// Espace de nom réservé aux fonctions et membres (privés et publics) de tenueAJourModal
var COMPTEUR_BATIMENTS = 0;
var COMPTEUR_EVENEMENT = 0;
var COMPTEUR_NATURE = 0;
var COMPTEUR_DETAILS_TRAVAUX = 0;


// Espace de nom réservé à l'utilisation des boutons et de leurs actions (global)
var tenueAJourModalBoutons = {

    initBoutonsTableEvenement: function (params) {
        var idRapport = $('[name=hid-id-rapport]').val();
        var idRapportGroupe = $('[name=hid-id-rapport-groupe]').val();
        var estquilibration = idRapportGroupe == 10 ? '-' + idRapport : '';
        $('#table-evenements' + estquilibration).on("click", 'td .check-valider-terrain', function (a) {
            var params = {
                id_evenement: $(a.target).closest('tr').data('id_evenement'),
                est_valide: $(a.target).is(':checked')
            };
            $.ajax({
                type: 'GET',
                async: false,
                url: '/gestion-roles/equilibration/valider-terrain/',
                data: params,
                dataType: 'json',
                success: function (response) {
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    retourErreur = 1;
                    infos.ajouterMessageToast({
                        message: 'Une erreur s\'est produite. Contactez un administrateur.',
                        messageDuree: 0
                    });
                    // TODO : logguer les erreurs
                }
            });
        });


        $('#table-evenements' + estquilibration).on("click", 'td .check-valider-immeuble', function (a) {
            var params = {};
            params.id_evenement = $(a.target).closest('tr').data('id_evenement');
            params.est_valide = $(a.target).is(':checked');

            $.ajax({
                type: 'GET',
                async: false,
                url: '/gestion-roles/equilibration/valider-immeuble/',
                data: params,
                dataType: 'json',
                success: function (response) {
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    retourErreur = 1;
                    infos.ajouterMessageToast({
                        message: 'Une erreur s\'est produite. Contactez un administrateur.',
                        messageDuree: 0
                    });
                    // TODO : logguer les erreurs
                }
            });
        });

        $(document).on('hide.bs.dropdown', '.btn-group-formulaire', function () {
            const $btnGroup = $(this);
            const $menu = $('body > .dropdown-menu-formulaire');

            $btnGroup.append($menu);
            $menu.hide().removeAttr('style');
        });


        $(document).on('show.bs.dropdown', '.btn-group-formulaire', function () {

            var $btnGroup = $(this);
            var $menu = $btnGroup.find('.dropdown-menu-formulaire');

            // save original parent
            $menu.data('parent', $btnGroup);

            // move menu to body
            $('body').append($menu);

            var offset = $btnGroup.offset();

            $menu.css({
                display: 'block',
                position: 'absolute',
                top: offset.top + $btnGroup.outerHeight(),
                left: offset.left,
                zIndex: 9999
            });

        });

        // Définition des évènements sur les boutons d'action de la table des évènements.
        $('#table-evenements' + estquilibration + ',.table-evenements').on("click", 'td a', function (e) { // Delegated Event
            var idEvenement = $(e.currentTarget).data('id_evenement');
            idEvenement = idEvenement ? idEvenement : $(e.target).closest('tr').data('id_evenement');
            var override_etapes = $(e.currentTarget).data('override_etapes');
            var btn = $(this).attr('class');
            var evenementTypeDisponible = $(e.target).closest('tr').data("bool_visible");
            var idUe = $(e.target).closest('tr').data('id_ue');
            var idMunicipalite = $(e.target).closest('tr').data('id_municipalite');
            var nomMunicipalite = $(this).attr('nom_municipalite');
            if ((idEvenement === $(this).data('id_evenement') && ((evenementTypeDisponible === 1) || (evenementTypeDisponible === true))) || ((evenementTypeDisponible === 1) || (evenementTypeDisponible === true))) {
                if (btn == 'editer-evenement') {
                    tenueAJourModal.ouvrirWizardEvenement(idEvenement, params, override_etapes);
                } else if (btn == 'voir-historique-evenement') {
                    tenueAJourModal.voirHistoriqueEvenement(idEvenement, params);
                }
                //ajout du bouton certificat
                else if (btn == 'btn-voir-certificat') {
                    tenueAJourModal.voirCertificat(idEvenement, params);
                } else if (btn == 'btn-voir-certificat-annexe') {
                    tenueAJourModal.voirCertificatAnnexe(idEvenement, params);
                } else if (btn == 'changer-ue-en-lot') {
                    if (params === undefined) {
                        params = {};
                    }
                    params.id_municipalite = idMunicipalite;
                    params.nom_municipalite = nomMunicipalite;
                    tenueAJourModal.ouvrirChangementUeEnLot(params);
                }

            } else {
                // ajout du bouton certificat lorsque les conditions des autres boutons ne sont pas true
                if (btn == 'btn-voir-certificat') {
                    tenueAJourModal.voirCertificat(idEvenement, params);
                } else {
                    throw new Error("L'évènement n'est pas disponible.");
                }

            }
        });
        $('#table-evenements' + '-' + RAPPORT.mise_a_jour_sig).on("click", 'td .check-sig-complete', function (a) {
            var params = {
                id_evenement: $(a.target).closest('tr').data('id_evenement'),
                est_complete: $(a.target).is(':checked')
            };
            $.ajax({
                type: 'GET',
                async: false,
                url: '/gestion-roles/gestion-mise-a-jour-sig/valider-maj-sig-complete/',
                data: params,
                dataType: 'json',
                success: function (response) {
                    // TODO : avoir le nom du champ sur la ligne pour changer la valeur
                    if (response) {
                        $(a.target).closest('tr').find('.user-maj-sig-complete').text(response.user_maj_sig_complete);
                        $(a.target).closest('tr').find('.date-actualisation-sig').text(response.date_actualisation_sig);
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    retourErreur = 1;
                    infos.ajouterMessageToast({
                        message: 'Une erreur s\'est produite. Contactez un administrateur.',
                        messageDuree: 0
                    });
                }
            });
        });
    }
};  // namespace tenueAJourModalBoutons


function updateEnteteWizard(){
    var idEvenement = $('#wizard').attr('id-evenement');
    if (idEvenement === ''){
        return;
    }
    $.ajax({
        type: "GET",
        url: '/gestion-roles/tenue-a-jour/wizard/evenement/'+idEvenement+'/entete/',
        dataType: 'html',
        success: function (response) {
            $('#wizard-entete').html(response);
        }
    });
}

function validerFermetureCycle(idMunicipalite, idTypeEvenement) {
            var params = {
                'id_municipalite': idMunicipalite,
                'id_type_evenement': idTypeEvenement
            };

            var jqxhr = $.ajax({
                type: "POST",
                url: "/gestion-roles/fermeture-cycle/validation-municipalite/",
                dataType: 'json',
                async: false,
                data: params
            });

            var estFermtureCycle = false;

            jqxhr.done(function (response) {
                if (response.reponse == 'error') {
                    estFermtureCycle = true;
                    fenetreModal.fermerModal('modal-wizard-evenement');

                    infos.ajouterMessageToast({
                        message: response.validation,
                        messageDuree: 0,
                        messageCouleur: 'red'
                    });
                }
            });
            return estFermtureCycle;
}
var tenueAJourModal = (function () {


        // variable utilisé pour générer la fenêtre modal et ses différentes options.
        // pour template: on ne place que le nom du fichier enregistré dans le dossier core/templates/wizards, sans l'extension.
        // voir modal.html pour les informations sur les variables.

        var m_modalEvenementCreer = {
            id: "tenue-a-jour-modal-creer-evenement",
            view: "/gestion-roles/tenue-a-jour/evenement/nouveau/",
            processus_id: "",
            processus_objet: "",
            titre: "Créer un évènement ",
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template: "",
            template_view: "",
            template_depart: "evenement_creer_type.html",
            template_depart_selectionne_view: "/gestion-roles/tenue-a-jour/evenement/nouveau/wizard/",
            template_depart_choix: "",
            taille: "grande",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            boutons: [
                {
                    type: "recharger",
                    label: "Recharger",
                    title: "",
                    id: "",
                    classSupp: "",
                    last: "",
                    afficher: true
                },
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    id: "",
                    classSupp: "",
                    last: "",
                    afficher: true
                },
                {
                    type: "previous",
                    label: "Précédent",
                    title: "",
                    id: "",
                    classSupp: "btn-prev",
                    last: "",
                    afficher: true
                },
                {
                    type: "next",
                    label: "Suivant",
                    title: "",
                    id: "",
                    classSupp: "btn-success btn-next",
                    last: "Terminer",
                    afficher: true
                }
                ,
                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "Sauvegarder l'état actuel de ce formulaire",
                    id: "",
                    classSupp: "btn-primary",
                    afficher: true,
                    disabled: true
                }
            ]
        };

        /**
         * Getter pour la variable privée m_modalEvenementCreer.
         * @return {object} m_modalEvenementCreer - l'objet pour la gestion de la liste évènements à créer.
         */
        function reqModalEvenementCreer() {
            return $.extend({}, m_modalEvenementCreer); // On retourne une copie de l'objet car sinon il est passé byRef
        }

        // a faire bt
        var estrepfiscale = 0;
        //    function reqreturnrepartitionfiscale() {
        //     var estrepfiscale = 0 ;
        //}

        /**
         * Getter pour la variable params qui récupère les infos du modal pour passer à une autre fonction.
         * @return {object} params
         */
        function reqVariablesWizard() {

            var params = {};
            if ($('#wizard').length > 0) {
                params.id_evenement = $('#wizard').attr('id-evenement');
                params.remarque = $('#wizard').attr('evenement-remarque');
                params.override_etapes = $('#wizard').attr('override-etapes');
                params.date_evenement = $('#wizard').attr('date-evenement');
                params.id_statut_evenement = $('#wizard').attr('id-statut-evenement');
                params.id_ue = $('#wizard').attr('id-ue');
                params.id_municipalite = $('#wizard').attr('id-municipalite');
                params.id_processus = $('#wizard').attr('id-processus'); // ex: permis, mutation, etc.
                params.id_user_assigne = $('#wizard').attr('id-user-assigne');
                params.id_type_evenement = $('#wizard').attr('id-type-evenement');
                params.attribut_generique = $('#wizard').attr('attribut-generique');
                params.etape_courante = $('#modal-step-contents > .active').attr('data-step');
                params.id_role_evaluation = $('#wizard').attr('id-role-evaluation');
                params.cycle_1 = $('#wizard').attr('cycle-1');
                params.cycle_2 = $('#wizard').attr('cycle-2');
                params.changer_ue_permis = $('#modal-step-contents > .active').attr('changer-ue-permis') === 'True';
            }

            params = nettoyerParams(params);
            return params;
        }

        /**
         * Voir le modal montrant l'historique du traitement d'un évènement.
         */
        function voirHistoriqueEvenement(evenement) {

            var variableModal = reqModalEvenementCreer();

            // Vider les options de sélection à l'intérieur de la variable : Réinitialisation
            variableModal.id = 'tenue-a-jour-modal-voir-historique-evenement';
            variableModal.titre = "Historique du traitement de l'évènement";

            // Requête conditionnelle à la présence d'un id_etape_processus
            // On récupère les étapes si nécessaire (dans le cas d'un wizard)
            //variableModal.url = '/gestion-roles/tenue-a-jour/evenement/' + evenement + '/nature/' + nature + '/etape/' + etape + '/';
            variableModal.template = '';
            variableModal.template_view = '/gestion-roles/tenue-a-jour/evenement/' + evenement + '/voir-historique/';
            variableModal.wizard = false;

            variableModal.municipalite = (typeof municipalite !== "undefined") ? municipalite : 0;

            variableModal.boutons = [
                {
                    type: "cancel",
                    label: "Ok",
                    title: "",
                    classSupp: "",
                    afficher: true,
                    callbacks: ''
                }
            ];


            fenetreModal.creerModal(variableModal, {});
        }

        function voirCertificat(evenement, params) {
            var url = "/gestion-roles/detail-certificat/evenement/" + evenement + '/';

            var variableModalCertificat = {
                id: "modal-certificat",
                view: "/core/modal/",
                id_processus: "",
                titre: "Certificat",
                titre_supp: "",
                module: "",
                contenuHTML: "",
                template: "",
                template_view: url,
                template_depart: "",
                template_depart_view: "",
                url: "",
                taille: "immense",
                resultat: "",
                resultat_depart: "",
                wizard: false,
                callback: function () {
                    $("#btn-certificat-imprimer").off('click').on("click", function () {
                        wait.start();
                        const url = `/gestion-roles/certificat/${evenement}/pdf/`;
                        const success_cb = function (resp) {
                            const modal = $('#modal-print-certificat');
                            $(modal).modal({
                                show: true,
                                backdrop: 'static'
                            });
                            $(modal).find('.modal-body').html(resp.template);
                            $(modal).find('#certificat-pdf-form').attr('action', url)

                        };
                        call_ajax(url, 'GET', null, success_cb);

                    });
                    tenueAJourModal.ajusterHauteurTdComparees(['identification'], ['avant', 'apres']); // On ajuste la hauteur des éléments comparés dans des TD différents
                },
                boutons: [

                    {
                        type: "print",
                        label: "Imprimer",
                        title: "Imprimer l'état actuel de ce formulaire",
                        id: "btn-certificat-imprimer",
                        classSupp: "btn-primary pull-left ",
                        afficher: true,
                        disabled: false
                    },


                    {
                        type: "cancel",
                        label: "Annuler",
                        title: "",
                        classSupp: "",
                        afficher: true
                    }


                ]
            };

            fenetreModal.creerModal(variableModalCertificat, {});

        }


        function voirCertificatAnnexe(evenement, params) {
            var url = "/gestion-roles/annexe-certificat/evenement/" + evenement + '/';
            var titre = "Certificat Annexe au rôle";

            var variableModalCertificat = {
                id: "modal-certificat-annexe",
                view: "/core/modal/",
                id_processus: "",
                titre: titre,
                titre_supp: "",
                module: "",
                contenuHTML: "",
                template: "",
                template_view: url,
                template_depart: "",
                template_depart_view: "",
                url: "",
                taille: "immense",
                resultat: "",
                resultat_depart: "",
                wizard: false,
                callback: function () {

                    $("#btn-certificat-annexe-imprimer").on("click", function () {

                        $('#export-pdf-certificat-annexe-id-evenement').val(evenement);
                        $('#export-pdf-certificat-annexe-id-municipalite').val(params.id_municipalite);
                        $("#frm-export-pdf-certificat-annexe").submit();

                    });
                    tenueAJourModal.ajusterHauteurTdComparees(['identification'], ['avant', 'apres']); // On ajuste la hauteur des éléments comparés dans des TD différents
                },
                boutons: [

                    {
                        type: "print",
                        label: "Imprimer",
                        title: "Imprimer l'état actuel de ce formulaire",
                        id: "btn-certificat-annexe-imprimer",
                        classSupp: "btn-primary pull-left ",
                        afficher: true,
                        disabled: false
                    },


                    {
                        type: "cancel",
                        label: "Annuler",
                        title: "",
                        classSupp: "",
                        afficher: true
                    }


                ]
            };

            fenetreModal.creerModal(variableModalCertificat, {});

        }

        /**
         *
         */
        function ouvrirWizardNouvelEvenement(idTypeEvenement, params) {
            $.ajax({
                type: "GET",
                url: '/gestion-roles/tenue-a-jour/wizard/type_evenement/' + idTypeEvenement + '/nouveau/',
                dataType: 'html',
                data: params,
                success: function (response) {

                    var m = $('#tenue-a-jour-modal-creer-evenement');
                    m.remove();
                    $(this).data('modal', null);
                    PostTraitementOuvrirWizardEvenement(response, params);

                }
            });
        }

        function ouvrirWizardEvenement(idEvenement, params, override_etapes) {
            var data = override_etapes ? {'override_etapes': override_etapes} : {};
            $.ajax({
                type: "GET",
                url: '/gestion-roles/tenue-a-jour/wizard/evenement/' + idEvenement + '/',
                data: data,
                dataType: 'html',
                success: function (response) {

                    if (params === undefined) {
                        params = {};
                    }

                    params.callback_fermeture_modal = function () {
                        // si le wizard est fermé, alors, vérifier les conditions de la fiche ouverte
                        // car ce code est appelé aussi à l'ouverture du wizard : bizarre
                        if (!$('#wizard').length) {
                            var ficheOuverte = $('#blocs-container').length > 0;
                            if (ficheOuverte) {
                                var dateEvenement = $('#date-evenement').val();
                                $('.container-reperes').each(function () {
                                    if ($(this).attr('date-evenement') != dateEvenement) {
                                        $(this).closest('[id="document-reperes"]').remove();
                                    }
                                });
                                resetModeLoad();

                                // Cacher les repères de fondation selon les types de fondation saisis dans le bloc 15
                                cacherRepereParTypeFondationQcb15($('.container-reperes'));

                                // Initialiser les actions sur les repères (clic sur les A,B,C...) et relance du calcul de la classe.
                                modalReperesLoaded();
                            } else {
                                if ($('#modal-reperes').length) {
                                    $('#modal-reperes').find('.modal-dialog').removeAttr('ne-pas-detruire');
                                    fenetreModal.fermerModal('modal-reperes');
                                }
                            }
                        }
                    };

                    PostTraitementOuvrirWizardEvenement(response, params);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (xhr.responseText) {
                        var erreur = $.parseJSON(xhr.responseText);
                        infos.ajouterMessageToast({
                            message: erreur,
                            messageDuree: 0
                        });
                    }
                    // TODO : logguer les erreurs
                }
            });
        }

        function ouvrirModalCreationActualisationInventaire(idEvenement, params, overide_etape) {
            var data = overide_etape ? {'override_etapes': overide_etape} : {};

            var url = '/gestion-roles/tenue-a-jour/actualisation-inventaire/' + idEvenement + '/creer/';

            let success_cb = function (response) {
                if (params === undefined) {
                    params = {};
                }

                fenetreModal.modalMessage({
                    titre: "Créer un nouvel évènement d'actualisation d'inventaire",
                    texteExplicatif: response,
                    conteneur: "#editeur-modal-container",
                    taille: "grande",
                    boutons: {
                        "Créer l'évènement": {
                            label: "Créer l'évènement",
                            class: "btn btn-success btn-sm",
                            action: function () {
                                creerActualisationInventaireAjax(idEvenement);
                            }
                        },
                        "Annuler": {
                            label: "Annuler",
                            class: "btn btn-sm",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    }
                });
            };

            let error_cb = function (xhr) {
                if (xhr.responseText) {
                    var erreur;
                    try {
                        erreur = $.parseJSON(xhr.responseText);
                    } catch (e) {
                        erreur = xhr.responseText;
                    }
                    infos.ajouterMessageToast({
                        message: erreur,
                        messageDuree: 0
                    });
                }
            };

            call_ajax(url, 'get', data, success_cb, error_cb, true, 'html');
        }

        function creerActualisationInventaireAjax(idEvenement) {
            var dateStr = $('#ai-event-date').val();
            var minDate = $('#ai-event-date').attr('min');

            if (!dateStr) {
                $('#ai-error').text("La date est obligatoire.").show();
                return;
            }
            if (minDate && dateStr < minDate) {
                $('#ai-error').text("La date doit être supérieure ou égale à " + minDate + ".").show();
                return;
            }
            $('#ai-error').hide();

            var url = '/gestion-roles/tenue-a-jour/actualisation-inventaire/' + idEvenement + '/creer/';

            var data = {
                event_date: dateStr,
                csrfmiddlewaretoken: $("input[name='csrfmiddlewaretoken']").val()
            };

            let success_cb = function (response) {
                fenetreModal.fermerModalAlerteDivs();
                infos.ajouterMessageToast({
                    message: "L'évènement est maintenant créé. Rechargez la page et sélectionnez sa date dans le menu supérieur pour y accéder.",
                    messageDuree: 0
                });
            };

            let error_cb = function (xhr) {
                var msg = "Erreur lors de la création.";
                try {
                    msg = $.parseJSON(xhr.responseText).error || msg;
                } catch (e) {
                }
                $('#ai-error').text(msg).show();
            };

            call_ajax(url, 'post', data, success_cb, error_cb, true, 'json');
        }


        function ouvrirChangementUeEnLot(params) {
            // #15823 : ligne suivante commentée ...
            // var donnees = (table.rows('.selected')[0].length > 1 ? ' ces ' + table.rows('.selected')[0].length + ' évènements ' : ' cet évènement ');
            var variableChangementUe = {
                id: "modal-changement-ue-en-lot",
                view: "/core/modal/",
                id_processus: "",
                titre: "Saisie des unités d'évaluation des mutations (en lot)",
                titre_supp: params.id_municipalite + " - " + params.nom_municipalite,
                titre_supp_break: true,
                module: "",
                contenuHTML: "",
                template: "",
                template_view: "/gestion-roles/tenue-a-jour/ouvrir-changement-ue-en-lot/",
                template_depart: "",
                template_depart_view: "",
                url: "",
                taille: "normale",
                resultat: "",
                resultat_depart: "",
                wizard: false,
                sans_x: true,
                callback: function () {

                    var containerModal = $('#modal-changement-ue-en-lot');
                    var optionsInit = {
                        blocsContainer: containerModal,
                        modeSave: ModeSave.MODAL
                    };
                    initWizardBlocs(optionsInit);
                    initLotSelect2(containerModal);
                    controlesFormulaires.detecterChangementsFormulaire();

                    containerModal.find('button[data-type="save"]').prop("disabled", true);
                    containerModal.find('.sous-bloc-form').attr('bloc-editable', 'True');

                    $('#sauvegarder-changement-ue').off('click').on('click', function () {
                        var callbackSaveWizardBlocs = function (response) {
                            if (response.reponse == 'ok') {
                                fenetreModal.fermerModal('modal-changement-ue-en-lot');
                                refreshDatatables();
                            }

                            if (typeof (callback) !== 'undefined') {
                                callback(response);
                            }
                        };

                        var optionsSave = {
                            paramsSupp: {sauvegarde_complet: true},
                            blocsContainer: $('#modal-changement-ue-en-lot'),
                            modeSave: ModeSave.MODAL,
                            idMunicipalite: params.id_municipalite,
                            idEvenement: null,
                            dateEvenement: null,
                        };
                        saveWizardBlocs(callbackSaveWizardBlocs, optionsSave);

                        if (typeof (callback) !== 'undefined') {
                            var response = {};
                            nbErreurs > 0 ? response.reponse = 'error' : response.reponse = 'ok';
                            callback(response);
                        }
                    });
                },
                boutons: [
                    {
                        type: "cancel",
                        label: "Annuler",
                        title: "",
                        classSupp: "",
                        afficher: true
                    },
                    {
                        type: "save",
                        label: "Sauvegarder",
                        title: "",
                        classSupp: "btn-primary",
                        afficher: true,
                        id: "sauvegarder-changement-ue",
                    },
                ]
            };

            fenetreModal.creerModal(variableChangementUe, params);
        }


        function PostTraitementOuvrirWizardEvenement(response, params){
            var idModal = 'modal-wizard-evenement';
            var $modal = $('#' + idModal);
            $('.modal-backdrop').remove();
            $modal.remove(); // On flush le modal pour être certain de ne pas le dupliquer

            // On recréer un nouveau div comme conteneur pour le modal
            $modal = $('<div id="' + idModal + '" class="modal"></div>');
            $('body').prepend($modal);

            // On ouvre le modal
            $modal.on('show.bs.modal', function (e) {
                setTimeout(function() {
                    // Juste un hack pour le double stack modal
                    if ($(e.relatedTarget).attr('oncourcircuite') !== undefined || ($("#modalLegend-metadata").length && !$("#modalLegend-metadata").is(":empty"))) {
                        e.preventDefault();
                        return false;
                    }

                    var idxModal = ($('.modal:visible').length) - 1; // raise backdrop after animation.
                    $('.modal-backdrop').not('.stacked').css('z-index', 9000 + (10 * idxModal) - 1);
                    $('.modal-backdrop').not('.stacked').addClass('stacked');
                    var divContenu = 'contenu';
                    var divContenuSelecteur = '#' + divContenu;
                    var etapeSelecteur = $('#modal-step-contents > .active').attr('id');
                    var etapeProcessusId = $('.steps').find('.active').attr('data-id_processus');
                    var etapeOrdre = $('.steps').find('.active').attr('data-step');
                    var tailleEtape = $('#' + etapeSelecteur).attr('taille');
                    var tailleModal = 'immense';

                    wait.start(divContenu, '255,255,255', 1);
                    if (etapeProcessusId == '37' && etapeOrdre == '1') {
                        $(divContenuSelecteur).prepend('<div id="pageSpinner"><div id="page-spinner-copy">Validation préliminaire des extrants en cours d\'exécution.</div></div>');
                    }

                    $('#modal-wizard-evenement').wizard(); //'selectedItem', {step: etape}

                    setTimeout(function () {
                        fenetreModal.redimentionnerModal(idModal, tailleModal, tailleEtape);
                        // On charge le contenu de l'étape active
                        chargerEtapeDynamique(etapeProcessusId, etapeOrdre, params); // Si nous avons une vue, et non un template, on charge ici.
                    }, 100); // ...avec animation.

                    actionsNavigationWizard();

                    if (params) {
                        if (params.hasOwnProperty('idCycle1')) {
                            if (params.idCycle1.length > 0) {
                                // $('#wizard').attr('attribut-generique', params.idCycle);
                                $('#wizard').attr('cycle-1', params.idCycle1);
                            }
                        }
                    }

                    if (params) {
                        if (params.hasOwnProperty('idCycle2')) {
                            if (params.idCycle2.length > 0) {
                                // $('#wizard').attr('attribut-generique', params.idCycle);
                                $('#wizard').attr('cycle-2', params.idCycle2);
                            }
                        }
                    }

                    // Initialisation du bouton save
                    $modal.find('button[data-type="save"]').off('click').on('click', function (e) {
                        e.preventDefault();
                        var etapeSauvegardeeSuivanteActive = $('#wizard').attr('etape-sauvegardee-suivante-active');
                        var idStatutEvenement = $('#wizard').attr('id-statut-evenement');
                        sauvegarderEtape(function (response) {
                            if (response.reponse == 'ok') {
                                postSauvegarderEtape(etapeSauvegardeeSuivanteActive, idStatutEvenement);

                                var rechargerPage = ($('#modal-step-contents > .active').attr('recharger') == 'oui');
                                if (rechargerPage) {
                                    $('#btn-wizard-recharger').trigger('click');
                                }
                            }
                        });
                        return false;
                    });

                    // Définition de l'évènement lors de la fermeture du wizard.
                    $modal.on('click', '[data-dismiss="modal-fermer"]', function () {
                        var recharger = $('#wizard').attr('recharger-editeur-fiche'); // On copie l'info avant qu'elle soit disparue avec callback_fermeture_modal()
                        checkSauvegarderEtapeEtPost(function (response) {
                            if (response.reponse == 'ok') {
                                fenetreModal.fermerModal(idModal);
                                if ($.fn.DataTable.isDataTable( '.reload-datatable')) {
                                    refreshDatatables();
                                }
                                if (typeof (params) !== "undefined") { // On peut définir des actions supplémentaires (fonctions) sur la fermeture du modal en les passant en paramètres à partir de l'appelant. Dans ce cas-ci, les paramètres sont connus. Pas nécessaire d'y aller par window[fonction],apply(window, [parametres])...
                                    if ('callback_fermeture_modal' in params) {
                                        params.callback_fermeture_modal();
                                    }
                                }
                            }
                        }, true);
                        if (typeof (recharger) !== 'undefined') {
                            if (recharger === 'True') {
                                rechargerFenetreEtDonnees();
                            }
                        }
                    });

                    $modal.find('button[data-type="recharger"]').on('click', function () {
                        var positions = positionCurseurWizard();
                        wait.start('contenu');
                        var etapeProcessusId = $('.steps').find('.active').attr('data-id_processus');
                        var etapeOrdre = $('.steps').find('.active').attr('data-step');
                        chargerEtapeDynamique(etapeProcessusId, etapeOrdre, params, '', positions); // Si nous avons une vue, et non un template, on charge ici.
                        return false;
                    });

                    initLienAutreEvenementOuvert();
                },300);

            });

            $modal.modal({ // Création du modal.
                backdrop: 'static',
                show: true,
                keyboard: false
            });
            var idxModal = $('.modal:visible').length;
            $modal.css('z-index', 9000 + (10 * idxModal));

            // On initialise les évènements sur le modal (ex: bouton X pour fermer en haut à droite)
            //fenetreModal.clique(idModal);

            // On insert la structure du wizard obtenue dans le modal
            $modal.html(response);

            if ($('#wizard').attr('id-type-evenement') == 67) {
                // dans ce type d'évènement, on ne veut pas voir les étapes dans le haut car il y a une seule étape
                $('.steps li').hide();
            }

            $modal.on('hide.bs.modal', function(){
                $('body').removeClass('modal-open');
            });
        }


        /**
         * Fonction de validation et de contrôle de la navigation dans le wizard
         * param {number} mode - Création (0) ou édition (1)
         * param {object} variableModal - Modal.
         * param {string} divContenu - Le contenu auquel affecter spin.
         */
        function actionsNavigationWizard() {
            var changingPage = false;

            $('#modal-wizard-evenement').on('changed.fu.wizard', function (evt, data) {
                destroyDataTableInContainer('#modal-wizard-evenement');

                if($("#carte-apres").length) $("#carte-apres").empty();
                if($("#som-cout-ajouter-carte").length) $("#som-cout-ajouter-carte").empty();
                if($("#map-terrain-agricole-boise-container").length) $("#map-terrain-agricole-boise-container").empty();
                if($(".modal-sig-legend-wizard").length) $(".modal-sig-legend-wizard").remove();

                // HACK car les spinners déclenchent cet évènement pour une raison inconnue
                if (!$(this).is(evt.target)) {
                    return;
                }

                var selecteur = '#modal-step' + data.step;
                wait.stop('contenu'); // Au cas une opération resterait en suspend pendant le changement d'étape : les speedy browsies.
                $('.overlay').remove();
                $('#erreurs-generiques').text(''); // On empêche de traîner une erreur pendant un wizard complet.

                wait.start('contenu', '255,255,255', 1);
                var btnSuivantTerminer = $('#btn-wizard-suivant-terminer');
                btnSuivantTerminer.prop("disabled", true);
                var etapeProcessusId = $('.steps').find('.active').attr('data-id_processus');
                var etapeOrdre = $('.steps').find('.active').attr('data-step');
                chargerEtapeDynamique(etapeProcessusId, etapeOrdre);
                //}
                var etapeSauvegardeeSuivante = $('#wizard').attr('etape-sauvegardee-suivante-active');
                activerNavigationEtapesSubsequentes(etapeSauvegardeeSuivante); // Dernière étape de l'évènement enregistrée dans la BD.

                //On cache le bouton save dans la dernière étape du wizard
                if (btnSuivantTerminer.length > 0) {
                    if ((btnSuivantTerminer.html()).indexOf('Terminer') != -1) {
                        $('#btn-wizard-save').hide();
                    } else if ($(selecteur).attr('data-bool-bouton-sauvegarder') != 'False') {
                        $('#btn-wizard-save').show();
                    }
                }
                // quand l'étape est chargée, faire un reset du flag pour permettre la sauvegarde des étapes
                changingPage = false;
            });

            $('#modal-wizard-evenement').off('actionclicked.fu.wizard').on('actionclicked.fu.wizard', function (evt, data) {
                // HACK car $('#wizard').wizard('next'); rappelle automatiquement cet évènement
                if (changingPage) {
                    return;
                }

                // Pour les étapes sans formulaire, on doit modifier le comportement du bouton suivant pour effectuer des validations minimales, sinon, le système autorise le passage à l'étape suivante. Dans le cas de l'étape 2 du permis, le wizard plante à l'étape 3 si aucune information sur l'unité d'évaluation n'est présente. Il ne s'agit pas d'un formulaire et doit donc être validé différemment.

                // On valide le formulaire lorsque nécessaire, comme dans le cas d'un formulaire sans formulaire...
                // Validation de l'étape courante.
                if (validerEtape() === true) { // On exécuter la validation et on affiche les messages d'erreurs si la validation est à false. On sait déjà ce qu'on retourne. On réutilise ici uniquement ce retour.
                    var callback = function (response) {
                        if (response.reponse == 'ok') {
                            changingPage = true;

                            if (data.direction == 'previous') {
                                $('#modal-wizard-evenement').wizard('previous');
                            }
                            if (data.direction == 'next') {
                                // #17206 : etape non applicable on skip des étapes!
                                var etape_sauvegardee_suivante_active = $('#wizard').attr('etape-sauvegardee-suivante-active');
                                var provenance_statut_x_evenement = $('#wizard').attr('provenance-statut-x-evenement');
                                var est_derniere_etape = $('#wizard li').last()[0] == $('#wizard li.active')[0];
                                // Dans tous les cas on enleve provenance-statut-x-evenement pour reset la mécanique
                                $('#wizard').removeAttr('provenance-statut-x-evenement');

                                if(!est_derniere_etape && etape_sauvegardee_suivante_active && provenance_statut_x_evenement){
                                    var prochaine_etape = $('.steps').find('[data-id_processus="'+etape_sauvegardee_suivante_active+'"]').attr('data-step');
                                    $('#modal-wizard-evenement').wizard('selectedItem', {step: prochaine_etape});

                                }else{
                                    $('#modal-wizard-evenement').wizard('next');
                                }
                            }

                            changingPage = false;
                        } else {
                            // On veut juste retourner à l'étape précédente. Il y a eu une erreur de sauvegarde sur la validation. On veut retourner en arrière. On ne peut pas sauvegarder de toute manière parce qu'on nous demande de retourner à l'étape 5, par exemple.
                            if (data.direction == 'previous') {
                                changingPage = true;
                                evt.preventDefault();
                                return;

                            }
                        }
                    };

                    var evenementMode = $('#wizard').attr('mode');
                    var etapeSuivante = isNaN(parseInt($('.steps').find('.active').attr('data-step')) + 1) ? $('.steps').find('.active').attr('data-step') : parseInt($('.steps').find('.active').attr('data-step')) + 1;
                    var etapeSuivanteComplete = $('[data-step="' + etapeSuivante + '"]').hasClass('complete');
                    var typeEvenement = $('#wizard').attr('id-type-evenement');
                    var response;
                    // On sauvegarde lors du clic sur bouton suivant uniquement si l'évènement est non disabled (status 99 et assignation).
                    if (evenementMode == 'w' && $('#wizard').attr('id-statut-evenement') !== 99 && (
                            $('#contenu').find('.step-pane.active').find('[id-model-instance="None"]').length >= 1
                            || $('#contenu').find('.step-pane.active').find('[modifie="True"]').length >= 1
                            || (data.direction == 'next' && !etapeSuivanteComplete && typeEvenement !== '50')
                        )
                    ) {
                        // timeout pour que le evt.preventDefault agisse avant de faire le save
                        setTimeout(function () {
                            sauvegarderEtapeEtPost(callback);
                        }, 100);
                    } else if ((evenementMode == 'w') && ($('#wizard').attr('id-statut-evenement') !== 99) && !etapeSuivanteComplete) { // On peut sauvegarder le numéro de l'étape actuelle même s'il n'y a pas de sauvegarde qui soit prévue.
                        response = {reponse: 'error'};
                        if ($('.contenu-principal.block-wizard').length <= 0) {
                            var etapeSauvegardeeSuivanteActive = $('#wizard').attr('etape-sauvegardee-suivante-active');
                            var idStatutEvenement = $('#wizard').attr('id-statut-evenement');
                            var resultPost = postSauvegarderEtape(etapeSauvegardeeSuivanteActive, idStatutEvenement);
                            response = {reponse: (resultPost ? 'ok' : 'error')};
                        }

                        callback(response);
                    } else if ($('#contenu').find('.step-pane.active').find('#travaux-batiment-aucune-sauvegarde').length >= 1) {
                        response = {reponse: 'error'};
                        callback(response);
                        focusControle('#btn-wizard-recharger', 5);
                    } else {
                        response = {reponse: 'ok'};
                        callback(response);
                    }
                }
                // pour pouvoir mettre un popup de confirmation
                evt.preventDefault();

            });
        }

        function postSauvegarderEtape(etapeSauvegardeeSuivanteActive, idStatutEvenement) {
            // DM: rester a la meme étape apres la sauvegarde, s'il reste des validations en haut en rouge
            if ($('.step-pane.active .wiz-validation-erreur').length > 0) {
                $('#modal-step-contents').slimScroll({scrollTo: 0}); // remonter le scroll en haut pour afficher les validations rouges
                nbErreurs += 1; // notifier qu'il y a encore des erreurs
                return false;
            }

            var retour = true;
            var idStatutEvenementApresSauvegarde = $('#wizard').attr('id-statut-evenement');
            // if (etapeSauvegardeeSuivanteActive == etapeSauvegardeeSuivanteActiveApresSauvegarde) {
            sauvegarderStatutEvenementEtapeProcessus(function (response) {
                if (response.reponse == 'error') {
                    retour = false;
                } else {
                    invaliderEtapeSubsequente(etapeSauvegardeeSuivanteActive);
                }
            });
            // }

            if (retour) {
                getAutresEvenementsOuverts(function (response) {
                    if (response.reponse == 'error') {
                        retour = false;
                    }
                });
            }

            if (idStatutEvenement != idStatutEvenementApresSauvegarde) {
                refreshDatatables();
            }
            return retour;
        }

        function sauvegarderEtapeEtPost(callback) {
            var etapeSauvegardeeSuivanteActive = $('#wizard').attr('etape-sauvegardee-suivante-active');
            var idStatutEvenement = $('#wizard').attr('id-statut-evenement');

            sauvegarderEtape(function (response) {
                if (response.reponse != 'ok') {
                    callback(response);
                    return;
                }

                if (!postSauvegarderEtape(etapeSauvegardeeSuivanteActive, idStatutEvenement)) {
                    response = {reponse: 'error'};
                }

                callback(response);
            });
        }


        function rechargerFenetreEtDonnees() {
            destroyDataTableInContainer('#modal-wizard-evenement');

            $('#container').hide();
            fenetreModal.modalMessage({
                titre: "Cette fiche a été modifiée et doit donc être rechargée",
                conteneur: "#editeur-modal-container",
                taille: "grande",
                texteExplicatif: "",
                boutons: {
                    "Recharger": {
                        label: " Recharger ",
                        id: "",
                        class: "btn btn-success",
                        action: function () {
                            // mettre un timeout au cas ou cette fonction ferait afficher un autre modal, car les modals sont automatiquement fermés sur clique d'un bouton
                            location.reload();
                        }
                    }
                }
            });
        }

        function checkSauvegarderEtapeEtPost(callback, confirmer) {
            var evenementMode = $('#wizard').attr('mode');
            var confirmCancel = $('#wizard').attr('confirm-cancel');
            var response = {};

            if (((!($('button[data-type="save"]').prop('disabled'))) && $("ul.steps").length >= 1 && evenementMode == 'w' && confirmCancel == 'True') || ($('#wizard').attr('id-evenement') === '' && evenementMode == 'w')) {
                if (!confirmer) {
                    sauvegarderEtapeEtPost(callback);
                    return;
                } else {
                    const id_type_evenement = $('#wizard').attr('id-type-evenement');
                    const est_operation_massive = (id_type_evenement >= '41' && id_type_evenement <= '48') || id_type_evenement === '55';
                    if (est_operation_massive) {
                        response.reponse = 'ok';
                        callback(response);
                    } else if ($('#wizard').attr('id-evenement') === '') {
                        fenetreModal.modalMessage({
                            titre: "L'évènement n'est pas encore créé. Voulez-vous vraiment fermer cette fenêtre ?",
                            sansX: true,
                            texteExplicatif: "",
                            boutons: {
                                "Oui": {
                                    label: " Oui ",
                                    id: "",
                                    class: "btn btn-success",
                                    action: function () {
                                        response.reponse = 'ok';
                                        callback(response);
                                    }
                                },
                                "Non": {
                                    label: " Non ",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                    }
                                }
                            }
                        });
                    } else if ($('#wizard').attr('id-evenement') !== '') {
                        fenetreModal.modalMessage({
                            titre: "Sauvegarder avant de fermer ?",
                            sansX: true,
                            texteExplicatif: "",
                            boutons: {
                                "Oui": {
                                    label: " Oui ",
                                    id: "",
                                    class: "btn btn-success",
                                    action: function () {
                                        // mettre un timeout au cas ou cette fonction ferait afficher un autre modal, car les modals sont automatiquement fermés sur clique d'un bouton
                                        setTimeout(function () {
                                            sauvegarderEtapeEtPost(callback);
                                        }, 100);
                                    }
                                },
                                "Non": {
                                    label: " Non ",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                        response.reponse = 'ok';
                                        callback(response);
                                    }
                                }
                            }
                        });
                    }
                }
            } else {
                response.reponse = 'ok';
                callback(response);
            }
        }

        /**
         * Fonction d'ouverture de la navigation des étapes subséquentes du wizard en fonction de la dernière étape complétée dans la BD.
         * Si la dernière étape sauvegardée est la 4, qu'on retourne à l'étape 1, on doit pouvoir être en mesure de renaviguer directement
         * à la 4 sans obligatoirement passer par la 2 et la 3.
         *
         * param {string} idModal - ID du du modal.
         * param {number} etapeSauvegardeeSuivante - Dernière étape de l'évènement stockée dans la bd : complétée.
         */
        function activerNavigationEtapesSubsequentes(etapeSauvegardeeSuivante) {

            var etapeCliquee = $('#modal-wizard-evenement').wizard('selectedItem').step;
            var etapeSauvegardeeSuivanteStep = $('[data-id_processus="' + etapeSauvegardeeSuivante + '"]').attr('data-step');
            if ($('#modal-wizard-evenement').wizard('selectedItem').step <= etapeSauvegardeeSuivanteStep) {
                for (let i = etapeCliquee + 1; i <= (etapeSauvegardeeSuivanteStep); i++) {
                    var etape = 'li[data-target="#modal-step' + i + '"]';
                    $(etape).addClass('complete'); // On indique, comme complétées, toutes les étapes précédentes à l'étape enregistrée (dernière complétée) pour cet évènement.
                }
            }
        }

        /**
         * Fonction pour charger une étape dynamique (REST viewSet ou une vue) à la sélection de l'étape dans le wizard.
         * @desc On charge la vue correspondante à l'étape dynamique ici. On prend en compte à la fois le cas du list (vide) pour un nouveau formulaire ou le cas d'un retreive s'il s'agit d'une récupération d'un objet (permis, mutation, etc).

         * @param {number} etapeProcessusId - ProcessusId - Numéro de l'étape à ajouter. Cet ajout décalera les étapes suivantes.
         * @param {number} etapeOrdre - ordre - Ordre dans lequel les étapes (etapeProcessusId) sont classées.
         * @param {string} noInit - 'noInit', si on souhaite empêcher, lors d'un rechargement de l'étape, la réinitialisation des events.
         * @param {object} positions - Contient une liste d'objects qui indique les différentes positions des éléments dans la page devant être restaurés suite au rechargement de l'étape suite à la sauvegarde (ouvrir fermer les accordéons, la position du slimscroll dans la page, etc).
         */


        function initChargerBoutonEtape(etapeProcessusId) {
            var id_municipalite = $('#wizard').attr('id-municipalite');
            var id_ue = $('#wizard').attr('id-ue');
            var date_url =  dateToStrYmd(new Date());
            var url = '/gestion-roles/explorateur/' + id_municipalite + '/' + id_ue + '/' + date_url + '/';
            var liste_evenements_permis = [1, 2, 3, 4, 6, 8 ,9, 14, 35, 36, 50, 69, 70];
            if (liste_evenements_permis.indexOf(parseInt($('#wizard').attr('id-type-evenement'))) !== -1) {
                $('#btn-supp').html('<a class="btn btn-sm btn-primary pull-left" href="' + url + '" target="_blank">Voir dans l\'explorateur</a>');
            }

            if (etapeProcessusId == 2) {

                // Permis carte
                $('#btn-visualiser-permis').off('click').on('click', function () {
                        var idUe = $('#wizard').attr('id-ue');
                        var id_evenement = $('#wizard').attr('id-evenement');
                        var iMunicipalite = $('#wizard').attr('id-municipalite');
                        var url = '/permis/sig-web/' + iMunicipalite + '/' + idUe + '/' + id_evenement + '/';
                        var win = window.open(url, '_blank');
                        win.focus();

                    }
                );
            }

            if (etapeProcessusId == 6) {
                // 14764: Ajout d'un bouton d'impression à côté du bouton excel.
                $('#btn-supp').html('' +
                    '<button id="btn-tj-imprimer" class="btn btn-sm pull-left" title="" data-placement="top" data-action="btn-tj-imprimer" data-toggle="tooltip" data-type="print">' +
                        '<i class="ace-icon fa fa-print"></i>Imprimer' +
                    '</button>' +
                    '<button id="btn-tj-imprimer-avec-indicateurs" class="btn btn-sm pull-left" data-action="btn-tj-imprimer-avec-indicateurs" data-type="print">' +
                        '<i class="ace-icon fa fa-print"></i>Imprimer avec indicateurs' +
                    '</button>'
                );
                $("#btn-tj-imprimer").prop('disabled', false);
                $("#btn-tj-imprimer").off('click').on("click", function () {
                    imprimer_sommaire_methode_cout(false);
                });
                $("#btn-tj-imprimer-avec-indicateurs").prop('disabled', false);
                $("#btn-tj-imprimer-avec-indicateurs").off('click').on("click", function () {
                    imprimer_sommaire_methode_cout(true);
                });
                function imprimer_sommaire_methode_cout(avec_indicateurs) {
                    var idUe = $('#wizard').attr('id-ue');
                    var currentDateEvenement = JSON.stringify($('#wizard').attr('date-evenement'));
                    var url = "/gestion-roles/methode-cout/export-pdf-sommaire/?export-pdf-sommaire-unites-evaluation=[\"" + idUe + "\"]&export-pdf-methode-cout-date-evenement=" + currentDateEvenement + "&export-pdf-sommaire-avec-indicateur=" + avec_indicateurs;
                    window.open(url, '_blank');
                }
                // DM: caché le bouton, voir issue #6991
                $('#btn-supp').append('<button id="btn-tj-exporter-excel" class="btn btn-sm pull-left" title="" data-placement="top" data-action="btn-tj-exporter-excel" data-toggle="tooltip"><i class="ace-icon evb-xls"></i>Excel</button>');
                var idUe = $('#wizard').attr('id-ue');
                var currentDateEvenement = $('#wizard').attr('date-evenement');
                $("#btn-tj-exporter-excel").prop('disabled', false);
                $("#btn-tj-exporter-excel").off('click').on("click", function () {
                    $("#btn-tj-exporter-excel").prop('disabled', true);
                    export_xls_Actualisation_invent(idUe, 0, currentDateEvenement, 0, 1);
                });

                $("#btn-sommaire-imprimer-wizard").off('click').on("click", function () {
                    $('#export-pdf-sommaire-unites-evaluation').val(JSON.stringify([$('#wizard').attr('id-ue')]));
                    $('#export-pdf-sommaire-date-evenement').val(JSON.stringify($('#wizard').attr('date-evenement')));
                    $('#export-pdf-sommaire-type-batiment').val(0);
                    $("#frm-export-pdf-sommaire").submit();
                });
            }
        }

        function chargerEtapeDynamique(etapeProcessusId, etapeOrdre, paramsSupp, noInit, positions, async=true) {

            $('#btn-supp').empty();

            initChargerBoutonEtape(etapeProcessusId);

            var selecteur = '#modal-step' + etapeOrdre;

            var btnSuivantTerminer = $('#btn-wizard-suivant-terminer');

            // On recharge l'étape uniquement si nécessaire (cache)
            if ($(selecteur).attr('recharger') === 'oui' || noInit === '') {
                // On obtient l'url de chargement de la page de l'étape depuis le champs vue de la bd
                var vue = $(selecteur).attr('vue');
                var params = {};

                // On passe en paramètre les paramètres importants pour le chargement d'une étape (seulement si le paramètre contient une valeur)
                params = reqVariablesWizard();
                params.id_etape_processus = etapeProcessusId;
                params.mode = $('wizard').attr('mode');

                if (paramsSupp) {
                    $.extend(params, paramsSupp);
                    // ET: 2019-02-07 On met a jour les parm supp si changement de id-ue dans l'entête
                    params.id_ue = $('#wizard').attr('id-ue');
                }

                if (vue != "None") {
                    let url = vue;
                    let success_cb = function(response) {
                        if($(selecteur).find('.min-today').data('daterangepicker')){
                            $(selecteur).find('.min-today').data('daterangepicker').remove();
                        }
                        $(selecteur).html(response);
                        controlesFormulaires.redimentionnerTextarea();
                        controlesFormulaires.retirerAccents();
                        if (params.id_statut_evenement === 99) { // TODO: Valider autorisations
                            $('.editer-cacher').hide();
                        }
                        // à cause d'un hack pour le permis qui recharge l'étape 1, on doit initialiser les date-picker de
                        // toutes les étapes, pas seulement pour l'étape active. Sinon, les date-picker ne fonctionnent plus
                        // après la sauvegarde de l'étape 1
                        init_date_picker($(selecteur));
                        formaterMonnaie($('#modal-wizard-evenement').find('input.money'), 0);
                        formaterSuperficie($('#modal-wizard-evenement').find('input.superficie'), 0);
                        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));

                        // initialiser le bouton Suivant/Terminer ici pour laisser l'étape le changer s'il y a lieu
                        btnSuivantTerminer.prop("disabled", false);
                        // ATTENTION : Les deux hacks qui suivent permettent, dans les étapes 1 (actualisation d'inventaire, permis, etc), de conserver les dates qui seront sauvegardées à l'étape 2 puisque l'évènement n'est pas encore créé. Si on les déplace, la date retenue par l'utilisateur et le commentaire, seront effacées dans le cas où l'usager fait un rafraîchissement de l'étape ou à la sauvegarde qui fait un reload des données provenant de la BD.

                        // HACK : Si on trouve un formulaire de date-evenement, on recopie la date sauvegardée dans l'entête avant le rechargement. Lorsqu'on se situe à la première étape de certains évènements, il est possible que la sauvegarde de la date ne survienne qu'à l'étape suivante (2).
                        var $dateEvenement = $('#frm-date-evenement').find('input[name="date_evenement"]');
                        var wizardDateEvenement = $('#wizard').attr('date-evenement');
                        if ($dateEvenement.length > 0 && (wizardDateEvenement !== '' && wizardDateEvenement !== undefined)) {
                            var dateTrim = $('#wizard').attr('date-evenement').split(" ");
                            $dateEvenement.val(dateTrim[0]);
                        }
                        // HACK : Si on trouve un formulaire de date-evenement, on recopie la remarque sauvegardée dans l'entête avant le rechargement. Lorsqu'on se situe à la première étape de certains évènements, il est possible que la sauvegarde de la remarque ne survienne qu'à l'étape suivante (2).
                        var $evenementRemarque = $('#evenement-remarque').find('textarea[name="remarque"]');
                        var wizardEvenementRemarque = $('#wizard').attr('evenement-remarque');
                        if ($evenementRemarque.length > 0 && (wizardEvenementRemarque !== '' && wizardEvenementRemarque !== undefined)) {
                            $evenementRemarque.val($('#wizard').attr('evenement-remarque'));
                        }
                        // On call la fonction d'initialisation de l'étape si définie dans la bd
                        executerFonctionDynamiqueInitialisationEtape(selecteur, noInit);
                        initAceThumbnails('colorboxPhotoPrincipale');
                        masquesSelection.init();

                        // Conserver la valeur originale des champs en mémoire. Ce sera utilisé pour revenir à la saisie précédente lorsque c'est nécessaire. On utilise .data de jquery pour ce faire.
                        var listeFormulaires = $('#modal-step-contents > .active div[type="formulaire"]');
                        listeFormulaires.each(function (idx) {
                            var currentForm = $(this);
                            var elements = currentForm.find(':input');
                            elements.each(function (idx) {
                                var element = $(this);
                                element.data('valeurPrecedente', element.val());
                            });
                        });
                        controlesFormulaires.detecterChangementsFormulaire();

                        // On replace le modal exactement dans le même état et au même endroit qu'avant la sauvegarde et le rafraîchissement de la page.
                        if (typeof (positions) !== 'undefined') {
                            var exec = [];
                            $.each(positions.accordions, function (index, value) {
                                var elemAccordion = $('.step-pane.active a[href="' + this.name + '"]');
                                if (elemAccordion.length > 0) {
                                    var oldCollapsed = (this.value.indexOf("collapse") > 0);
                                    var newCollapsed = (elemAccordion.attr('class').indexOf("collapse") > 0);

                                    if (oldCollapsed != newCollapsed) {
                                        exec.push(elemAccordion.trigger("click"));
                                    }
                                }
                            });
                            $.when(exec).then(function () {
                                $('#modal-step-contents').slimScroll({scrollTo: positions.position_dans_modal});
                            });
                        }
                        $('#modal-wizard-evenement').html().replace('Content-Type: text/html', ''); // Si jamais on reçevait un httpResponse au lieu du contenu (.content) d'un httpResponse dans une des méthodes côté serveur.

                        bootstrapOn.initTooltips();

                        if ($(selecteur).attr('data-bool-bouton-sauvegarder') == 'False') {
                            $('#btn-wizard-save').hide();
                        } else {
                            $('#btn-wizard-save').show();
                        }

                        // rafraichir les attributs du wizard selon le contenu de la page obtenue
                        var hidAttributs = $('#modal-step-contents > .active .charger-attribut');
                        hidAttributs.each(function () {
                            var nomAttribut = $(this).attr('name');
                            var valeurAttribut = $(this).attr('value');
                            $('#wizard').attr(nomAttribut, valeurAttribut);
                        });

                        var stepPaneActive = $('.step-pane.active .wiz-validation-erreur');
                        if (stepPaneActive.length > 0 && stepPaneActive.attr('relancer-propagation') == 'True') {
                            stepPaneActive.closest('.modal-body.step-content').find('.step-pane[data-id_processus="31"]').attr('recharger', 'oui')
                        }

                        if($('.steps .active').attr('data-id_processus') != '26'){
                            wait.stop('contenu', false);
                        }
                    };
                    let error_cb = function() {
                        btnSuivantTerminer.prop("disabled", true);
                        $(selecteur).empty();
                        $(selecteur).append('<div class="contenu-principal"><p class="align-center">Impossible de charger la page.</p></div>');
                        wait.stop('contenu');
                    }
                    call_ajax(url, "GET", params, success_cb, error_cb, true, 'html');
                } else {
                    // On call la fonction d'initialisation de l'étape si définie dans la bd
                    executerFonctionDynamiqueInitialisationEtape(selecteur, noInit);
                    wait.stop('contenu');
                    fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                    btnSuivantTerminer.prop("disabled", false);
                    if ($(selecteur).attr('data-bool-bouton-sauvegarder') == 'False') {
                        $('#btn-wizard-save').hide();
                    } else {
                        $('#btn-wizard-save').show();
                    }
                }
                // Options de gestion de l'étape dynamique
                $(selecteur).attr('recharger', 'non');
            } else {
                wait.stop('contenu');
                btnSuivantTerminer.prop("disabled", false);
                if ($(selecteur).attr('data-bool-bouton-sauvegarder') == 'False') {
                    $('#btn-wizard-save').hide();
                } else {
                    $('#btn-wizard-save').show();
                }
            }
            //var vue_variables = $.parseJSON($(selecteur).attr('vue-variables'));
            //if (vue_variables != "None") {
            // Exécution des fonctions déclarées dans la variable de la vue (tag "").
            //}
        }


        /**
         * Fonction de chargement des initialisations spécifiques à des étapes dynamiques dans le wizard. Ces initialisations
         * sont passées dans le tag "data-vue_variables" de l'étape courante au chargement des etapes_processus dans la BD.
         * Cette fonction est appelée automatiquement lors de l'utilisation du bouton suivant dans le wizard mais doit
         * être déclenchée explicitement au chargement d'une étape. La page doit exister avant de pouvoir interagir avec elle.
         * C'est ici, donc, qu'on choisit ce qui doit être initialisé après le chargement du modèle (template) dans la
         * balise #contenu de l'étape courante du wizard.
         *
         * param {string} selecteur - Sélecteur de l'étape courante.
         * param {string} noInit - Si définit comme "noInit" : pas d'initialisation. Dans le cas précis où l'on recharge l'étape mais sa redéclencher son initialisation.
         */
        function executerFonctionDynamiqueInitialisationEtape(selecteur, noInit) {

            // On obtient le nom de la fonction d'initialisation de l'étape provenant de la bd stockée en attribut dans un obj JSON
            var vueVariables = $(selecteur).attr('vue-variables');
            if (vueVariables != 'None' && vueVariables != '') {

                var selecteurVueVariables = $.parseJSON(vueVariables);
                if (selecteurVueVariables.init) {
                    var nomFonction = selecteurVueVariables.init.split('.');
                    if (nomFonction.length > 1) {
                        if (typeof noInit === 'undefined' || noInit === '') {
                            // On efface les focus, on efface les messages d'erreurs et le scroll du slimscroll dans le cas où on se situe sur une étape qui exige un rechargement dynamique.
                            erreursAjax.effacerErreurChamps($('#contenu'));
                            $('#modal-step-contents').slimScroll({scrollTo: '0px', animate: true});

                            window[nomFonction[0]][nomFonction[1]].apply(window);
                        }
                    } else {
                        try { // Dans le cas de l'étape 2 du permis le js qui contient la fonction init n'est pas incluse dans l'éditeur de fiche puisque non nécessaire car la sélection de l'ue aura toujours déjà été complétée. On catch donc l'erreur.
                            if (typeof noInit === 'undefined' || noInit === '') {
                                window[selecteurVueVariables.init].apply(window);
                            }
                        } catch (err) {
                        }
                    }
                }
            }
        }

        /*
     * Fonction utilisée pour la sauvegarde des étapes dans le wizard. On récupère les variables stockées pour chaque étape.
     * * @param {callback} object - Un objet qui contient notamment le statut du callback (error, ok, alted).
     */
        function sauvegarderEtape(callback) {
            messageToastCompteur = 0;
            nbErreurs = 0;

            // On call la fonction de sauvegarde spécifique à l'étape en cours si définie dans la bd
            var selecteurModal = $('.steps').find('.active').attr('data-target');
            // On obtient les paramètres propres à l'étape stockés dans la bd (table:etape_processus champs:vues_variables)
            var vueVariables = $(selecteurModal).attr('vue-variables');

            setTimeout(function () {
                if (vueVariables == 'None' || vueVariables == '') {
                    callback({reponse: 'ok'});
                    return;
                }
                var selecteurVueVariables = $.parseJSON(vueVariables);
                if (selecteurVueVariables.save !== undefined) {
                    var nomFonction = selecteurVueVariables.save.split('.');
                    wait.start('contenu', '255,255,255', 1);
                    var callbackBefore = function (response) {
                        if (response.reponse === 'ok' || response.reponse === 'pass') {

                            var callbackSave = function (response) {
                                wait.stop('contenu');
                                if (response.reponse === 'error') {
                                    infos.ajouterMessageToast({
                                        message: 'Erreur de sauvegarde',
                                        messageCouleur: 'red'
                                    });
                                }
                                callback(response);
                            };

                            if (nomFonction.length > 1) {
                                window[nomFonction[0]][nomFonction[1]].apply(window, [callbackSave]);
                            } else {
                                window[selecteurVueVariables.save].apply(window, [callbackSave]);
                            }
                        } else if (response.reponse === 'error') {
                            wait.stop('contenu');
                            infos.ajouterMessageToast({
                                message: 'Erreur de sauvegarde',
                                messageCouleur: 'red'
                            });
                            callback(response);
                        } else if (response.reponse === 'cancel') {
                            callback(response);
                        }
                    };

                    var assigne = securite.estMemeUsagerQueSession($('#wizard').attr('id-user-assigne'));
                    if (assigne.estAssigne === 'True') { // On permet le passage à l'étape suivante uniquement si l'usager de l'évènement est le même que celui de la session.

                        if (selecteurVueVariables.before_save !== undefined) {
                            var nomFonctionAvant = selecteurVueVariables.before_save.split('.');

                            if (nomFonctionAvant.length > 1) {
                                window[nomFonctionAvant[0]][nomFonctionAvant[1]].apply(window, [callbackBefore]);
                            } else {
                                window[selecteurVueVariables.before_save].apply(window, [callbackBefore]);
                            }
                        } else {
                            var response = {reponse: 'ok'};
                            callbackBefore(response);
                        }
                    } else {
                        wait.stop('contenu');
                        infos.ajouterMessageToast({
                            message: assigne.message,
                            messageCouleur: "red",
                            messageDuree: "0"

                        });
                    }

                } else {
                    // TODO : Vérifier si on implémente une sauvegarde par défaut si non définie dans la bd pour une étape
                    callback({reponse: 'ok'});
                }
            }, 0);
        }

        function invaliderEtapeSubsequente(etapeSauvegardeeSuivante) {
            var etapeCliquee = $('#modal-wizard-evenement').wizard('selectedItem').step;
            var etapeSauvegardeeSuivanteStep = $('[data-id_processus="' + etapeSauvegardeeSuivante + '"]').attr('data-step');
            var derniereEtapeStep = $('li[data-target^="#modal-step"]').last().attr('data-step');
            if (etapeCliquee <= etapeSauvegardeeSuivanteStep) {
                for (var i = etapeCliquee + 1; i <= (derniereEtapeStep); i++) {
                    var etape = 'li[data-target="#modal-step' + i + '"]';
                    $(etape).removeClass('complete'); // On indique, comme non complétées, toutes les étapes depuis l'étape enregistrée (dernière complétée) jusqu'à la fin des étapes pour cet évènement.
                    $('#modal-step' + i).attr('recharger', 'oui');
                }
            }
        }

        function sauvegarderStatutEvenementEtapeProcessus(callback, retourEtapePrecedente) {
            var retourErreur = 0;
            // Faire la mise à jour de l'évènement s'il existe (il n'existe pas encore dans un nouvel évènement)
            var idEvenement = $('#wizard').attr('id-evenement');
            if (idEvenement) {
                var idUserAssigne = $('#wizard').attr('id-user-assigne');
                var idStatutEvenement = $('#wizard').attr('id-statut-evenement');
                var etapeCourante = $('#modal-step-contents > .active').data('id_processus');
                var params = [
                    {name: 'evenement', value: idEvenement},
                    {name: 'statutEvenement', value: idStatutEvenement},
                    {name: 'etapeProcessus', value: etapeCourante},
                    {name: 'user', value: idUserAssigne}
                ];
                if (retourEtapePrecedente !== undefined) {
                    params.push({name: 'retour_etape_precedente', value: retourEtapePrecedente ? 'True' : 'False'});
                }
                if ($('#wizard').attr('override-etapes')) return;
                $.ajax({
                    type: 'POST',
                    async: false,
                    url: '/gestion-roles/statut-x-evenement/',
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        if (response.wizard && !($.isEmptyObject(response.wizard))) {
                            $.each(response.wizard, function (index, value) {
                                $('#wizard').attr(index, value);
                                if(index == "etape-sauvegardee-suivante-active" ){
                                    // sera utilisé dans la logique du bouton suivant du wizard
                                    // si on provient d'ici, alors une mécanique spécifique sera appliquée
                                    // sinon on utilisera le next normal.
                                   $('#wizard').attr('provenance-statut-x-evenement', true);
                                }
                            });
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        retourErreur = 1;
                        infos.ajouterMessageToast({
                            message: 'Une erreur s\'est produite. Contactez un administrateur.',
                            messageDuree: 0
                        });
                        // TODO : logguer les erreurs
                    }
                });
            }
            if (typeof (callback) !== 'undefined') {
                var response = {};
                response.reponse = retourErreur > 0 ? 'error' : 'ok';
                callback(response);
            }
        }


        function init_champ_conserver_ou_remplacer(modal, nom_champ, avec_radio_conserver=false){
            // Ces champs radios sont synthétiques et ne sont pas représentés dans les modèles.
            // Ils sont désormais invisible à l'interface et ne servent qu'à conserver l'état du champ.
            // Leurs valeurs sont définies en fonction des items sélectionnés dans les select ou les valeurs
            // des champs textes.
            var radios_conserver_ou_remplacer = $(modal).find('input[name="choix_'+nom_champ+'"]');
            var ligne_radios_conserver_ou_remplacer = $($(radios_conserver_ou_remplacer).parents('.form-group')[0]).parent();
            var champ_liste = $(modal).find('#form-'+nom_champ);
            var ligne_champ_liste = $($(champ_liste).parents('.form-group')[0]).parent();
            var radio_conserver = radios_conserver_ou_remplacer[0];
            var radio_remplacer = radios_conserver_ou_remplacer[1];
            // On manipule le dom pour remplacer les lignes du label/radio de remplacement avec le champ original
            ligne_champ_liste.find('label').remove();
            $(ligne_radios_conserver_ou_remplacer.find('.radio>.lbl')[1]).replaceWith(ligne_champ_liste);

            // Lorsque l'on rebascule sur "conserver", on vide la valeur du champ correspondant
            $(radio_conserver).on('click', function(e){
                ligne_champ_liste.find('.select2-container input').empty();
            });
            // pour cocher "remplacer" dès lors qu'on intéragit avec un select2
            $(ligne_champ_liste).find('select.geo-select').on('select2-opening', function(e) {
                $(radio_remplacer).click();
            });
            // pour cocher "remplacer" avec les autres input
            $(ligne_champ_liste).find('input, textarea').on('click', function(e){
                $(radio_remplacer).click();
            });
            // par défaut on initialise avec la checkbox de conservation des routes.
            $(radio_conserver).trigger('click');
            // on cache ou non la radio pour conserver
            if(!avec_radio_conserver){
                $(radio_conserver).parent().hide();
            }

            // Pour palier au 'x' de suppression de selection qui disparait
            let select2_data = $(modal).find('#s2id_form-'+nom_champ).data();
            if(select2_data){
                select2_data.select2.container.addClass("select2-allowclear");
            }
        }

        function modalAssignerEtEtatLoaded(variableModal) {
            if (typeof (table) !== 'undefined') { // non défini dans rapports génériques
                table.settings.sans_processing = true;
            }
            var modal = this._modal;
            $('#tenue-a-jour-modal-assigner-et-etat .modal-body').css('padding-top', '0px');
            initBlocsCharges(null, null, {blocsContainer: modal});
            initCascade(modal);

            // ############################## User
            var selectUser = modal.find('[name=user]');
            selectUser.on('change', function (e) {
                if ($(this).val() != '') {// gestion des cas est_inspecteur
                    $('#s2id_form-user').find('.select2-chosen').removeClass('est_inspecteur');
                    if(e.added && e.added.css=="est_inspecteur"){
                        // si la selection est est_inspecteur; on update le selected du select2 avec.
                        $('#s2id_form-user').find('.select2-chosen').addClass('est_inspecteur');
                    }
                }
            });
            // lors de l'init on gère aussi le est_inspecteur pour l'option sélectionnée
            if($('#form-user option:selected').hasClass('est_inspecteur')){
                $('#s2id_form-user').find('.select2-chosen').addClass('est_inspecteur');
            }

            // ############################## Route
            var selectRoute = modal.find('[name="routeInspection"]');
            // pour le cascade
            selectRoute.data('callback-params-supp', function(inputChild){
                var dateEvenement = moment().format('YYYY-MM-DD');
                return {
                    user: modal.find('[name=user]').val(),
                    date_evenement: dateEvenement
                };
            });

            // ############################## Etat
            var date_envoi = modal.find('[name="dates_formulaire"]');
            if (!date_envoi.val()){
                date_envoi.closest('.form-group').hide();
            }
            var date_rappel = modal.find('[name="date_rappel"]');
            if (!date_rappel.val()){
                date_rappel.closest('.form-group').hide();
            }
            function gerer_dates_formulaires_statut(){
                // On affiche/masque les champs dates en fonction du statut sélectionné
                if (['13', '14', '34', '35', '36'].includes(modal.find('[name="statutEvenement"]').val())) {
                    // hack bypass conflit styles select2, pour ajouter un espacement entre le champ État
                    // et les deux champs dates dessous
                    modal.find('#form-statutEvenement').prev('.select2-container').css('cssText', 'padding-bottom: 15px!important;');
                    // déplacer les champs dates au plus proche du dropdown d'état si ce n'est pas déja fait.
                    if(!modal.find('#form-statutEvenement').parent()[0].contains($(date_rappel)[0])){
                        modal.find('#form-statutEvenement').after($(date_rappel).parents('.form-group'));
                    }
                    if(!modal.find('#form-statutEvenement').parent()[0].contains($(date_envoi)[0])){
                        modal.find('#form-statutEvenement').after($(date_envoi).parents('.form-group'));
                    }
                    date_envoi.closest('.form-group').show();
                    date_rappel.closest('.form-group').show();

                    $(date_rappel).parents('.form-group').addClass('clearfix');
                    $(date_envoi).parents('.form-group').addClass('clearfix');

                } else {
                    // reset du hack d'espacement
                    modal.find('#form-statutEvenement').prev('.select2-container').css('cssText', ';');
                    date_envoi.closest('.form-group').hide();
                    date_rappel.closest('.form-group').hide();
                }
            }
            modal.find('[name="statutEvenement"]').on('change', function () {
                gerer_dates_formulaires_statut();
            });
            gerer_dates_formulaires_statut();

            // Gestion des boutons pour l'utilisateur
            var container_input_user = $('#form-user');
            $(container_input_user).after($('#assigner-etat-boutons-utilisateur-container'));
            $('#assigner-etat-boutons-utilisateur-container').show();
            // Et celui de la route:
            var container_input_route = $('#form-routeInspection');
            $(container_input_route).after($('#assigner-etat-boutons-route-container'));
            $('#assigner-etat-boutons-route-container').show();

            function selectionner_user_sans_assignation(multi=false){
                $('#form-user').select2('val', '1');
                if(multi){
                    $('[name="choix_user"]')[1].click();
                }
                $('#form-user').change();
                activer_bouton_save_asigner_etat();
            }

            // Gestion des radios boutons de choix conserver/remplacer
            if (this._modal.find('.conserver_ou_remplacer_champ').length>1 || (get_listeIdEvenement().length > 1)) {
                init_champ_conserver_ou_remplacer(modal, 'user');
                init_champ_conserver_ou_remplacer(modal, 'routeInspection');
                init_champ_conserver_ou_remplacer(modal, 'statutEvenement');
                init_champ_conserver_ou_remplacer(modal, 'commentaire', true);

                // clic du X pour vider l'utilisateur doit en fait sélectionner l'utilisateur sans assignation
                this._modal.find($('#form-user')).on("select2-clearing", function(e){
                    e.preventDefault();
                    selectionner_user_sans_assignation();
                });

                // callback click bouton auto assigner en multi evenement
                $('#assigner-etat-bouton-auto-assigner').on('click', function(e){
                    e.preventDefault();
                    $('#form-user').select2('val', $('#usager_public').val());
                    $('[name="choix_user"]')[1].click(); // cocher l'option cachée "champ remplacer"
                    $('#form-user').change();
                    activer_bouton_save_asigner_etat();
                });
                $('#assigner-etat-bouton-sans-assignation').on('click', function(e){
                    e.preventDefault();
                    selectionner_user_sans_assignation(true);
                });
                $('#assigner-etat-bouton-sans-route').on('click', function(e){
                    e.preventDefault();
                    $('#form-routeInspection').select2('val', '');
                    $('[name="choix_routeInspection"]')[1].click();
                    $('#form-routeInspection').change();
                    activer_bouton_save_asigner_etat();
                });

            }else{
                // Gestion du callback bouton d'auto assignation de l'utilisateur courant, dans le contexte d'1 seul évenement
                $('#assigner-etat-bouton-auto-assigner').on('click', function(e){
                    e.preventDefault();
                    $('#form-user').select2('val', $('#usager_public').val());
                    $('#form-user').change();
                    activer_bouton_save_asigner_etat();
                });
                $('#assigner-etat-bouton-sans-assignation').on('click', function(e){
                    e.preventDefault();
                    selectionner_user_sans_assignation();
                });
                $('#assigner-etat-bouton-sans-route').on('click', function(e){
                    e.preventDefault();
                    $('#form-routeInspection').select2('val', '');
                    $('#form-routeInspection').change();
                    activer_bouton_save_asigner_etat();
                });
            }

            // ############################## Bouton sauvegarder
            function activer_bouton_save_asigner_etat(){
                $('#btn-save-modal-assigner-et-etat').prop("disabled", false);
                $('#btn-save-modal-assigne-explorateur').prop("disabled", false);
            }
            // son activation
            modal.find('[name="user"], [name="routeInspection"], [name="statutEvenement"], [name="date_rappel"], [name="dates_formulaire"]').on('change', function () {
                activer_bouton_save_asigner_etat();
            });
            // pour les champs textarea
            $(modal).find('input, textarea').on('click', function(e){
                activer_bouton_save_asigner_etat();
            });

            // gestion d'exceptions, concernant le statut d'évènement en fonction du type d'évènements
            if(variableModal.customParams.boolDifferentTypeEvenement){
                if(variableModal.customParams.id_module=='59'){
                    // Cas spécial depuis les révisions administratives
                    $('#assigner-et-etat-avertissement-revisions-admins-via-ra').show();
                    $('#form-statutEvenement').prop('disabled', true);
                }else{
                    $('#assigner-et-etat-avertissement-revisions-admins').show();
                }
            }

            // son action
            $('#btn-save-modal-assigner-et-etat').off('click').on('click', function () {
                    modal.find('.form-control[name=commentaire]').addClass(CLASSE_VALEUR_MODIFIEE); // HACK pour être sûr que ça save !
                    tenueAJourModal.conserverSelection();

                    tenueAJourModal.modalAssignerEtatPreparerDonnees(modal);

                    var listeIdEvenement = get_listeIdEvenement();
                    var options = {
                        modeSave: ModeSave.MENU,
                        blocsContainer: modal,
                        paramsSupp: {
                            sauvegarde_complet: true,
                            liste_id_evenement: listeIdEvenement,
                            id_module: $(window.evb_last_module).attr('id_module'),
                        }
                    };
                    var callback = function (response) {
                        if (response.reponse == 'ok') {
                            if (response.avertissements == undefined) {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie',
                                    messageDuree: 500,
                                    icone: 'fa-check-circle-o',
                                    iconeCouleur: 'green'
                                });
                            } else {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie avec avertissement(s): ' + response.avertissements,
                                    messageDuree: 0,
                                    icone: 'fa-exclamation-triangle',
                                    iconeCouleur: 'orange'
                                });
                            }

                            modal.modal('hide');
                            refreshDatatables();
                        }
                    };
                    saveBlocs(false, callback, options);
                }
            );

            // Bouton sauvegarder, depuis explorateur
            $('#btn-save-modal-assigne-explorateur').off('click').on('click', function () {
                modal.find('.form-control[name=commentaire]').addClass(CLASSE_VALEUR_MODIFIEE); // HACK pour être sûr que ça save !

                tenueAJourModal.conserverSelection();
                var unitesEvaluation = $('#div-resultat-historique').find('.list-group-item');
                unitesEvaluation = unitesEvaluation.filter(":visible");
                var listeIdUe = [];
                $.each(unitesEvaluation, function (idx, value) {
                    var idUe = $(value).attr('id-ue');
                    if (idUe != '') listeIdUe.push(idUe);
                });
                var layerlistediv = $('#div-resultat-layer').find('[name="hid-filtres-layer"]');
                var layerliste = [];
                layerlistediv.each(function (){
                    var idMapLayer = $(this).val();
                    layerliste.push(idMapLayer);
                });
                var params = {};
                params['id_municipalite'] = $('#exp-ue-liste-ville').val();
                params['listeIdUe'] = JSON.stringify(listeIdUe);
                params['layer'] = JSON.stringify(layerliste);
                params['bool_explorateur_assigne_creer'] = (modal.find('[name="bool-explorateur-assigne-creer"]:checked').length > 0);
                // Callback d'initialisation datatable modale assigner etat dans l'explorateur
                function modalAssignerEtEtatLoadedCallbackSave(listeIdEvenementNew=[]){
                    var modal = $('#tenue-a-jour-modal-assigner-et-etat');

                    tenueAJourModal.modalAssignerEtatPreparerDonnees(modal);

                    var table = $('#adm-table-evenement-assigne').DataTable();
                    // Créer un tableau vide pour stocker les IDs
                    var listeIdEvenement = [];
                    // Sauvegarder la page actuelle
                    var currentPage = table.page();
                    // Parcourir toutes les pages
                    var pageCount = table.page.info().pages;
                    for (var i = 0; i < pageCount; i++) {
                        table.page(i).draw(false);
                        var checked = table.$('input[type="checkbox"]:checked');
                        checked.each(function () {
                            var row = $(this).closest('tr');
                            var idEvenement = Number(row.attr('data-id_evenement'));
                            // Vérifier si l'ID existe déjà dans la liste avant de l'ajouter
                            if (!listeIdEvenement.includes(idEvenement)) {
                                listeIdEvenement.push(idEvenement);
                            }
                        });
                    }
                    // Restaurer la page initiale
                    table.page(currentPage).draw(false);
                    for (var i = 0; i < listeIdEvenementNew.length; i++) {
                        var idEvenement = Number(listeIdEvenementNew[i]);
                        if (!listeIdEvenement.includes(idEvenement)) {
                            listeIdEvenement.push(idEvenement);
                        }
                    }
                    if (listeIdEvenement.length == 0) {
                        infos.ajouterMessageToast({
                            message: 'Vous devez sélectionner au moins un évènement pour pouvoir sauvegarder',
                            messageDuree: 5000,
                            icone: 'fa-exclamation-triangle',
                            iconeCouleur: 'orange'
                        });
                        return;
                    }else if (listeIdEvenement.length == 1) {
                        modal.find('[name=evenement]').val(listeIdEvenement[0]);
                    }

                    var options = {
                        modeSave: ModeSave.MENU,
                        blocsContainer: modal,
                        paramsSupp: {sauvegarde_complet: true, liste_id_evenement: listeIdEvenement}
                    };

                    var callback = function (response) {
                        if (response.reponse == 'ok') {
                            if (response.avertissements == undefined) {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie',
                                    messageDuree: 500,
                                    icone: 'fa-check-circle-o',
                                    iconeCouleur: 'green'
                                });
                            } else {
                                infos.ajouterMessageToast({
                                    message: 'Sauvegarde réussie avec avertissement(s): ' + response.avertissements,
                                    messageDuree: 0,
                                    icone: 'fa-exclamation-triangle',
                                    iconeCouleur: 'orange'
                                });
                            }
                            refreshDatatables();
                            modal.find('.sous-bloc-form').attr('bloc-editable', 'True');
                            modal.find('.sous-bloc-form').attr('id-model-instance', 'None');
                            modal.find('.sous-bloc-form').attr('modifie', 'False');
                        }
                    };
                    options.paramsSupp.estExplorateurmodule = true;
                    saveBlocs(false, callback, options);
                    wait.stop();
                }

                setTimeout(function () {
                    var jqxhr = $.ajax({
                        url: '/gestion-roles/exp-ue/insert-nouveau-actualisation-inventaire/',
                        async: false,
                        type: "POST",
                        dataType: 'json',
                        data: params
                    });
                    jqxhr.done(function (response) {
                        if (response.reponse == 'ok') {
                            var listeIdEvenementNew = response.listeIDevenement;
                            if(listeIdEvenementNew && listeIdEvenementNew.length){
                                // on doit reconstruire la liste des id evenements suite a la création des AI
                                var listeIdEvenementSelection = [];
                                var checked = $('#adm-table-evenement-assigne').find('input[type="checkbox"]:checked');
                                checked.each(function () {
                                var row = $(this).closest('tr');
                                var idEvenement = Number(row.attr('data-id_evenement'));
                                // Vérifier si l'ID existe déjà dans la liste avant de l'ajouter
                                if (!listeIdEvenementSelection.includes(idEvenement)) {
                                    listeIdEvenementSelection.push(idEvenement);
                                }});
                                listeIdEvenementSelection = listeIdEvenementSelection.concat(listeIdEvenementNew);
                                expAssignerEvenementInitTableEvenement(modalAssignerEtEtatLoadedCallbackSave, listeIdEvenementSelection);
                            }else{
                                console.log('cas sans listeIdEvenementNew');
                                modalAssignerEtEtatLoadedCallbackSave();
                            }
                        } else {
                                infos.ajouterMessageToast({
                                    message: "Erreur d'exécution sur les actualisations de l'inventaire",
                                    messageCouleur: 'red'
                                });
                                wait.stop();
                            }
                    });
                    jqxhr.fail(function (xhr, textStatus, errorThrown) {
                            infos.ajouterMessageToast({
                                message: "Erreur d'exécution sur les actualisations de l'inventaire",
                                messageCouleur: 'red'
                            });
                            wait.stop();
                        });
                }, 10);
            });
        }

        function conserverSelection() {
            if (typeof table !== 'undefined' && 'conserverSelection' in table.settings) {
                var nomTable = table.context[0].sTableId;
                var selection = $('#' + nomTable).find('input:checked').map(function () {
                    return $(this).attr("id");
                }).get();

                table.settings.selection = selection;
            }
        }

        function restaurerSelection() {
            if (typeof table !== 'undefined' && 'conserverSelection' in table.settings) {
                var nomTable = table.context[0].sTableId;
                var selection = table.settings.selection;
                var listeCasesACocher = $('#' + nomTable).find('input');
                // On boucle sur les éléments de la table et on utlise la liste de sélection pour recocher les cases décochées suite au rafraîchissement
                listeCasesACocher.each(function (index, value) {
                    if ($.inArray(value.id, selection) > -1) {
                        $(this).attr('checked', 'checked');
                        $(this).closest('tr').addClass('selected');
                    }
                });
                // On réactive les boutons du ruban
                tenueAJour.activerDesactiverBoutonsRuban($('#' + nomTable).closest('.table-template'), false);
                // On efface la sélection des éléments pour éviter qu'au prochain refresh de la table, qu'on resélectionne l'ancienne sélection.
                delete table.settings.selection;

            }
        }

        function modalSupprimerEvenementLoaded() {
            $('#proceder-supprimer-evenement').off('click').on('click', function () {
                if (typeof (table) != 'undefined') {
                    table.settings.sans_processing = true;
                }

                var listeEvenement = [];
                var listeFormulaires = $('#table-evenements,.table-evenements').find('tr:not(.entete-table-liee)').find('input[type="checkbox"]:checked');
                listeFormulaires.each(function () {
                    var row = $(this).closest('tr');
                    var idEvenement = row.attr('data-id_evenement');
                    listeEvenement.push(idEvenement);
                });

                  // 18489
                var rechargerOperationCadastrale = false;
                if($("#recharger_operation_cadastrale").length){
                    if ($('#recharger_operation_cadastrale').is(":checked")){
                        rechargerOperationCadastrale = true;
                    }
                }

                var params = {
                    liste_evenement: JSON.stringify(listeEvenement),
                    rechargerOperationCadastrale : rechargerOperationCadastrale
                };

                wait.start();

                var jqxhr = $.ajax({
                    type: "POST",
                    url: "/gestion-roles/evenement-supprimer/",
                    data: params,
                    dataType: 'html'
                });
                jqxhr
                    .done(function (response) {
                        var reponse = JSON.parse(response);
                        if (reponse.response == 'ok') {
                            refreshDatatables();

                            // rapports génériques
                            if ($('#table-evenements,.table-evenements').length) {
                                refreshDatatables(function () {
                                    wait.stop();
                                });
                            }

                            fenetreModal.fermerModal("tenue-a-jour-modal-supprimer-evenement");
                            messageToastCompteur = 0;
                            infos.ajouterMessageToast({
                                message: reponse.message,
                                messageDuree: 5000
                            });
                        } else {
                            erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', reponse.message);
                            messageToastCompteur = 0;
                            infos.ajouterMessageToast({
                                message: reponse.message,
                                messageCouleur: 'red',
                                messageDuree: 5000
                            });
                            wait.stop();
                        }
                    });
                jqxhr
                    .fail(function (jqxhr, textStatus, errorThrown) {
                        wait.stop();
                        erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', jqxhr, errorThrown);
                        messageToastCompteur = 0;
                        infos.ajouterMessageToast({
                            message: "Erreur de suppression d'évènement",
                            messageDuree: 5000,
                            messageCouleur: "red"
                        });
                        $('#proceder-supprimer-evenement').remove();
                        $('[data-dismiss="modal-fermer"]').prop('innerText', 'Fermer');
                        wait.stop();
                    });
            });
        }
        // #21261
        function modalAssignerEtEtat(){
            var variableAssignerEtEtat = {
                id: "tenue-a-jour-modal-assigner-et-etat",
                view: "/core/modal/",
                processus_id: "",
                titre: "Assigner / Modifier État",
                titre_supp: "",
                module: "",
                contenuHTML: "",
                contenuIcone: "fa fa-exclamation-triangle",
                texteExplicatif: "",
                template: "",
                template_view: "/gestion-roles/assigner-et-etat/",
                template_depart: "",
                sans_x: false,
                template_depart_view: "",
                url: "",
                taille: "grande",
                resultat: "",
                resultat_depart: "",
                wizard: false,
                callback: tenueAJourModal.modalAssignerEtEtatLoaded,
                fournir_variableModal_au_callback: true,
                boutons: [
                    {
                        type: "cancel",
                        label: "Annuler",
                        title: "",
                        classSupp: "",
                        afficher: true
                    },
                    {
                        type: "save",
                        label: "Sauvegarder",
                        title: "",
                        classSupp: "btn-primary",
                        afficher: true,
                        id: "btn-save-modal-assigner-et-etat",
                        disabled: true
                    }
                ]
            };
            setTimeout(function () {
                var callbacks = [function () {
                    controlesFormulaires.redimentionnerTextarea();
                }];
                var evenements = [];
                var boolDifferentTypeEvenement = false;
                var id_module = $(window.evb_last_module).attr('id_module');
                // pour gérer les cas des Révisions Administratives (RA)
                var liste_ra = [TYPE_EVENEMENT.demande_de_revision, TYPE_EVENEMENT.correction_d_office, TYPE_EVENEMENT.correction_erreur_ecriture, TYPE_EVENEMENT.recours_au_tribunal];
                var tout_type = [];
                $('#table-evenements, .table-evenements').find('tr:not(.entete-table-liee)').find('input[type="checkbox"]:checked').closest('tr').map(function(){
                    evenements.push($(this).attr('data-id_evenement'));
                    var id_type = parseInt($(this).attr('data-id_type_evenement'));
                    tout_type.push(id_type);
                });
                // garde le nb d'evenement par type
                var counts_types = {};
                for(const num of tout_type){
                    counts_types[num] = counts_types[num] ? counts_types[num] + 1 : 1;
                }
                // cas d'exceptions de mélange de types évènements, concernant les RA, dans le module RA
                if(id_module=='59'){

                    if(Object.keys(counts_types).length > 1){
                        boolDifferentTypeEvenement = true;
                    }
                }else{
                    // teste la présence d'au moins un évènement des RA, hors du module RA
                    for(let i in liste_ra){
                        if(liste_ra[i] in counts_types){
                            boolDifferentTypeEvenement = true;
                        }
                    }
                }
                var customParams = {
                    evenements: JSON.stringify(evenements),
                    id_module: id_module,
                    boolDifferentTypeEvenement: boolDifferentTypeEvenement
                };
                fenetreModal.creerModal(variableAssignerEtEtat, customParams, callbacks);
            }, 0);
        }

        function modalDateInspectionLoaded() {
            if (typeof (table) != 'undefined') {
                table.settings.sans_processing = true;
            }

            controlesFormulaires.detecterChangementsFormulaire();
            nbErreurs = 0;

            init_date_picker();

            $('#btn-save-modal-date-inspection').off('click').on('click', function () {

                tenueAJourModal.conserverSelection();
                var etapeProcessus = 0;
                var currentForm = $('#form-taj-date-inspection');
                var params = [];
                var date_prochaine_inspection = $('input[name="date_prochaine_inspection"]').val();
                if(date_prochaine_inspection){
                    date_prochaine_inspection = moment(date_prochaine_inspection).format('YYYY-MM-DD');
                }
                params.push({
                    name: 'date_prochaine_inspection',
                    value: date_prochaine_inspection
                });
                var async = false;
                var dataType = 'json';
                var messageToast = {
                    message: "Date de la prochaine inspection mise à jour",
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                };
                var callback;
                currentForm.attr('methode', 'PATCH');
                messageToastCompteur = 0;
                var listeFormulaires = $('#table-evenements,.table-evenements').find('tr').find('input[type="checkbox"]:checked');
                listeFormulaires.each(function () {
                    var paramsSupp = [];
                    var row = $(this).closest('tr');
                    params.push({name: 'id_evenement', value: row.attr('data-id_evenement')});
                    params.push({
                        name: 'date_evenement',
                        value: moment(row.attr('data-date_evenement')).format('YYYY-MM-DDTHH:mm:ss')
                    });
                    var idStatutEvenement = row.attr('data-id_statut_evenement');
                    var url = '/gestion-roles/evenement-date-inspection/' + row.attr('data-id_evenement') + '/';
                    paramsSupp.push({name: 'evenement', value: row.attr('data-id_evenement')});
                    paramsSupp.push({name: 'typeEvenement', value: row.attr('data-id_type_evenement')});
                    paramsSupp.push({name: 'statutEvenement', value: idStatutEvenement}); // On recopie le meme statut dans le cas ou il n'y a pas de changement. TODO: Intégrer au formulaire...
                    var paramsFormulaire = $.merge(paramsSupp, params);
                    var rechargerPage = false;
                    nbErreurs += sauvegarderDonnees(currentForm, url, async, dataType, paramsFormulaire, etapeProcessus, messageToast, listeFormulaires.length, rechargerPage, callback);
                });
                if (nbErreurs == 0) {
                    $('#tenue-a-jour-modal-date-inspection').find('[name=btn-tj-date-inspection]').prop('disabled', false);
                    $('#tenue-a-jour-modal-date-inspection').modal('hide');
                }

                refreshDatatables();

                // rapports génériques
                if ($('#table-evenements,.table-evenements').length) {
                    refreshDatatables();
                }

                if (typeof (callback) !== 'undefined') {
                    var response = {};
                    nbErreurs > 0 ? response.reponse = 'error' : response.reponse = 'ok';
                    callback(response);
                }
            });
        }

        function rechercherActiverSelection(id, no, type, typeNom) {
            var permisRechercheSelecteur = 'div[id-permis="' + id + '"]';
            $(permisRechercheSelecteur).addClass('actif');
            $(permisRechercheSelecteur).closest('div[type="formulaire"]').attr('methode', 'PATCH'); // rendre le permis editable (PATCH) lorsqu'on le charge pour éviter un POST
        }

        /**
         * Fonction de recherche des permis existants (pour utiliser un permis différent à la création d'un évènement.
         * @param {number} selecteur - Valeur du champ de recherche à utiliser.
         * @param {string} portee - 'unique' à une municipalité, 'tout', pour afficher les résultats de recherche de numéro de permis pour toutes les municipalités.
         * @param {number} id - Id de la ligne nécessaire à la sélection dans la BD.
         * @param {string} type - optionnel - utilisé pour le callback.
         * @param {string} typeNom - optionnel - utilisé pour le callback.
         * @param {string} callback - optionnel - fonction callback.
         * */
        function executerRecherchePermis(selecteur, portee, id, type, typeNom, callback) {
            wait.start();
            var $Municipalite = $('select[name="municipalite"]').val();
            var municipalite;
            if ($Municipalite !== 'undefined' && $Municipalite !== "" && portee != 'tout') {
                municipalite = "&id_municipalite=" + $Municipalite;
            } else {
                municipalite = '';
            }

            var jqxhr = $.ajax({
                url: "/gestion-roles/permis/?format=json&mode_recherche=contains&no_permis=" + selecteur + municipalite,
                async: false
            });
            jqxhr
                .done(function () {
                    var data = JSON.parse(jqxhr.responseText);
                    var html =
                        '<table id="permis-recherche-resultats" class="table table-striped table-bordered table-hover display dt-responsive no-wrap clearfix display datatable" cellspacing="0" width="100%">' +
                        '<thead>' +
                        '<tr>' +
                        '<th></th>' +
                        '<th></th>' +
                        '<th></th>' +
                        '<th></th>' +
                        '<th></th>' +
                        '<th></th>' +
                        '</tr>' +
                        '</thead>';
                    if (!$.fn.dataTable.isDataTable('#permis-recherche-resultats')) {
                        $('#recherche-contenu').append(html);
                    }
                    if ($.fn.dataTable.isDataTable('#permis-recherche-resultats')) {
                        tableModal.clear().rows.add(data).draw();
                    } else {
                        tableModal = $('#permis-recherche-resultats').DataTable({
                            retrieve: true,
                            data: data,
                            dom: 'trip',
                            order: [[1, 'asc']],
                            columnDefs: [
                                {
                                    orderable: false,
                                    targets: [0]
                                },
                                {
                                    title: "",
                                    data: "id_permis",
                                    targets: [0],
                                    width: '20px',
                                    render: function (data, type, row) {
                                        return '<div class="action-buttons-utiliser" id-permis="' + data + '" class="choisir-permis"><i class="ace-icon fa fa-check action-grille-icone fa-lg"></i></div>';
                                    }
                                },
                                {
                                    title: 'No Permis',
                                    data: 'no_permis',
                                    targets: 1
                                },
                                {
                                    title: 'Municipalité',
                                    data: 'municipalite',
                                    targets: 2,
                                    className: 'data-toggle="tooltip" data-placement="top"'
                                    //,
                                    //render: function (data, type, row) {
                                    //    return 'row.municipalite__nom' + '(' + municipalite + ')';
                                    //}
                                },
                                {
                                    title: 'Date d\'émission',
                                    data: 'date_emission',
                                    targets: 3
                                },
                                {
                                    title: 'Description des travaux',
                                    data: 'description_travaux',
                                    targets: 4,
                                    width: '400px'
                                },
                                {
                                    title: 'Valeur estimée',
                                    data: 'valeur_estimee_travaux',
                                    targets: 5,
                                    render: function (data, type, row) {
                                        return '<div class="text-right">' + data + ' $</div>';
                                    }
                                }
                            ],
                            "createdRow": function (row, data, dataIndex) {
                                var titre;
                                titre = "Utiliser ce permis";
                                $(row).addClass('choisir-permis align-left');
                                $(row).attr("id-permis", data.id_permis);
                                $(row).attr("data-modal-titre", titre);
                                $(row).attr("title", titre);
                            },
                            drawCallback: function (settings) {
                                if (callback) {
                                    var parametres = [id, selecteur, type, typeNom];
                                    window['tenueAJourModal'][callback].apply(window, parametres);
                                }

                                // Choisir le permis, recharger la recherche, s'assurer que permis existant est sélectionné, rendre le formulaire de permis editable (pour ne pas faire de post pour un permis existant...
                                $('tr.choisir-permis').off('click').on('click', function () { // Delegated Event
                                    var idPermis = $(this).attr('id-permis');
                                    var noPermis = $(this).find('td').eq(1).text();
                                    var municipalite = $(this).find('td').eq(2).text();
                                    var etape = $('ul.steps').find('li.active').attr('data-step');
                                    var selecteur = '#modal-step' + etape;
                                    $(selecteur).attr('recharger', 'oui');
                                    //$(selecteur).attr('data-processus_objet', permis_id);
                                    $(this).find().addClass("active");
                                    wait.start('contenu', '255,255,255', 1);

                                    // On remet à jour certaines variables globales du wizard suite au chargement d'un nouveau permis
                                    $('#wizard').attr('id-processus', idPermis);
                                    $('#wizard').attr('id-municipalite', municipalite);
                                    var etapeProcessusId = $('.steps').find('.active').attr('data-id_processus');
                                    var etapeOrdre = $('.steps').find('.active').attr('data-step');
                                    chargerEtapeDynamique(etapeProcessusId, etapeOrdre);
                                    fenetreModal.fermerModalAlerteDivs();
                                    wait.stop('contenu');
                                });

                            }
                        });
                    }
                    bootstrapOn.initTooltips();
                    var hauteurModal = $("#modal-message-alerte-contenu").innerHeight();
                    var hauteurNouvelleModal = $(window).height() * 0.9;
                    var hauteurScroll = hauteurNouvelleModal - hauteurModal;
                    scroll.ajouterSlimScroll('#evenement-recherche-permis-existant-toggle', {hauteur: hauteurScroll});
                    wait.stop();
                });
            jqxhr
                .fail(function (xhr, textStatus, errorThrown) {
                    $('#permis-recherche-resultats').empty();
                    $('#permis-recherche-resultats').append('<p>Impossible de charger les résultats de recherche.</p>');
                });
        }

        /**
         * Fonction d'initialisation de l'étape informations générales du processus de permis.
         * */
        function initInfoGeneralePermis() {
            var dateEvenementDatePicker = $('#frm-date-evenement').find('input[name="date_evenement"]');
            var evenementRemarque = $('#evenement-remarque').find('[name="remarque"]');

            updateDateEvenementWizard();
            updateRemarqueWizard();

            dateEvenementDatePicker.on('change', function () {
                updateDateEvenementWizard(true);
            });

            evenementRemarque.on('change', function () {
                updateRemarqueWizard(true);
            });

            var $modalWizard = $('#modal-wizard-evenement');
            // Sur l'utilisation de recherche pour un numéro de permis, on détecte l'utilisation du "ENTER" et on lance la recherche.
            $modalWizard.off('keydown.permis.recherche').on('keydown.permis.recherche', '#recherche-champ', function (e) {
                if (e.which == 13) {
                    $('#recherche').trigger('click');
                }
            });

            $modalWizard.off('click.recherche.permis').on('click.recherche.permis', 'button#recherche', function () { // Delegated event - Fenêtre de recherche d'un permis existant. click.recherche.permis est tout simplement le contexte d'un namespace.
                var $rechercheChamp = $('input#recherche-champ').val();
                tenueAJourModal.executerRecherchePermis($rechercheChamp, ($('select[name="municipalite"]').val() ? 'unique' : 'tout'));
            });

            // Initialisation des input file
            var organisation = securite.reqOrganisation();
            var documents = $('#document-permis').find('.section-document');
            $.each(documents.find('.ace-input-file'), function (idx, obj) {
                initAceInputFile($(obj), organisation, 'permis');
            });

            $modalWizard.off('click.permis.existant').on('click.permis.existant', '[data-action="rechercher-permis-existant"]', function () { // Delegated Event
                // Si la municipalité n'est pas remplie : forcer le choix.
                if ($('#municipalite').val() === '' || $('#municipalite').val() === 'Choisir Municipalité...') {
                    fenetreModal.modalMessage({
                        titre: "Veuillez d'abord sélectionner une municipalité.",
                        texteExplicatif: "",
                        boutons: [
                            {
                                label: " Fermer ",
                                title: "Fermer",
                                id: "",
                                class: "btn",
                                action: function () {
                                    fenetreModal.fermerModalAlerteDivs();
                                }
                            }
                        ]
                    });
                } else {
                    fenetreModal.modalMessage({
                        taille: 'immense',
                        enteteTitre: "Rechercher et sélectionner un numéro de permis existant pour cette municipalité (" + $('#municipalite').val() + ")",
                        texteExplicatif: "",
                        vueACharger: "/gestion-roles/tenue-a-jour/permis/information-generale/rechercher-permis-existant/",
                        boutons: {
                            "Fermer": {
                                label: " Fermer ",
                                id: "",
                                class: "btn",
                                action: function () {
                                    fenetreModal.fermerModalAlerteDivs();
                                }
                            }
                        }

                    });
                }
            });

            // Sur sélection de la municipalité : On relance la vérification si permis existe déjà dans cette municipalité.
            $('select[name="municipalite"]').off('change').on('change', function () {
                //$('#wizard').attr('data-id_municipalite', a.target.value);
                if ($('input[name="no_permis"]').val()) {
                    var $noPermis = $('input[name="no_permis"]');
                    $noPermis.trigger('change');
                }
            });

            // Évènement - Rechercher la présence d'un permis existant : doit être unique.
            $('input[name="no_permis"]').off('change').on('change', function (a) {
                var element = $(this);
                var idMunicipalite = $('select[name="municipalite"]').val(); //$('select[name="municipalite"]').select2('data').id;
                var jqxhr = $.ajax({
                    url: "/gestion-roles/permis/?format=json&no_permis=" + element.val() + "&id_municipalite=" + idMunicipalite,
                    async: true
                });
                jqxhr
                    .done(function (response) {
                        var resultat = response;
                        if ($('select[name="municipalite"]').select2('data') === null) {
                            var message = {
                                titre: "Choisissez une municipalité avant de saisir un numéro de permis."
                            };
                            fenetreModal.modalMessage(message);
                        } else if (resultat.length >= 1) {
                            if (resultat.length === 1 && $('#wizard').attr('id_evenement') !== undefined) {
                                fenetreModal.modalMessage({
                                    titre: "Puisque l'évènement existe déjà, vous ne pouvez que changer le numéro du permis actuel.",
                                    texteExplicatif: "",
                                    boutons: {
                                        "Annuler": {
                                            label: " Annuler ",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                                element.val(element.data.valeurPrecedente); // On remet le numéro de permis d'origine.
                                            }
                                        },
                                        "Ok": {
                                            label: " Ok ",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                            }
                                        }
                                    }
                                });
                            } else if (resultat.length === 1) {
                                fenetreModal.modalMessage({
                                    titre: "Il existe déjà un permis " + element.val() + " pour cette municipalité (" + idMunicipalite + "). Voulez-vous créer un nouvel évènement de tenue à jour lié à ce même permis ?",
                                    texteExplicatif: "",
                                    boutons: {
                                        "Oui": {
                                            label: " Oui ",
                                            id: "",
                                            class: "btn btn-success",
                                            objet: resultat[0].id_permis, // Si le résultat contient plusieurs permis avec le même no on prend le premier.
                                            municipalite: idMunicipalite,
                                            action: function () {
                                                // On charge le permis (chargerEtapeDynamique) avec le numéro existant (retrieve)
                                                // Barrer le numéro de permis si on conserver bool_permis_existant a 1
                                                // Effacer tout (vider) si on rechoisit nouveau et que bool_permis_existant était a 1
                                                wait.start('contenu');

                                                var idPermis = Number(this.objet);
                                                var municipalite = Number(this.municipalite);
                                                var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                                                var etapeOrdre = $('.steps').find('.active').attr('data-step');

                                                // On remet à jour certaines variables globales du wizard suite au chargement d'un nouveau permis
                                                $('#wizard').attr('id-processus', idPermis);
                                                $('#wizard').attr('id-municipalite', municipalite);
                                                $('#modal-step' + etapeOrdre).attr('recharger', 'oui');
                                                chargerEtapeDynamique(etapeProcessus, etapeOrdre);
                                            }
                                        },
                                        "Non": {
                                            label: " Non ",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                                $('#evenement-infos-generales').find('input[name="no_permis"]').val(''); // On efface la donnée pour ne pas créer un 2e pemis dans la même ville avec le même numéro de permis.
                                            }
                                        }
                                    }

                                }, function () {
                                    $(':focus').blur(); // On retire le focus
                                });
                            } else if (resultat.length > 1) {
                                fenetreModal.modalMessage({
                                    titre: "Il existe plusieurs permis de même numéro " + element.val() + " pour cette municipalité.",
                                    texteExplicatif: "Ce numéro n'est pas autorisé par le système. Contactez un administrateur.",
                                    boutons: [
                                        {
                                            label: " Ok ",
                                            title: "Ok",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                            }
                                        }
                                    ]
                                });
                                a.target.value = ''; // On vide le champs du no_permis pour ne pas permettre de garder ce no problématique.
                            }
                        } else { // Si on ne fait que modifier le no_permis pour un nouveau qui n'existe pas déjà alors indique que le formulaire a été modifié et on enable le bouton save.
                            // Ceci est normalement fait dans geocentralis.js/detecterChangementsFormulaire mais pour le no_permis on a overwrité l'event change par la méthode en cours.
                            $('button[data-type="save"]').prop("disabled", false);
                            $(this).closest('div[type="formulaire"]').attr('modifie', 'True');
                        }
                    });
                jqxhr
                    .fail(function (jqxhr, textStatus, errorThrown) {
                        alert('Erreur inconnue sur la recherche de municipalité et de no de permis!');
                    });
            });

            // On initialise seulement les select2 pour la section d'informations générales et non pour le sous-bloc des documents
            $('#evenement-infos-generales').find('select').select2();

            // mettre l'attribut 'bloc-editable' à 'True' pour chaque ligne de sous-bloc pour l'utiliser à la sauvegarde comme dans une fiche mais sans historicité
            $('.sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');

            init_change_event_sous_bloc();
        }

        function checkChangementDateEtSave(fonction, callback) {
            var fonction2 = function (callback2) {
                checkEvenementFermePosterieurCycleOuvertEtSave(fonction, callback2);
            };

            checkPropagationInutileEtSave(fonction2, callback);
        }

        function checkPropagationInutileEtSave(fonction, callback) {
            checkEvenementEtSave(fonction, callback, false, true);
        }

        function checkChangementDateDepasseEvenementOrigine(fonction, callback) {
            var fonction2 = function (callback2) {
                checkChangementDateEtSave(fonction, callback2);
            };

            checkDateDepasseEvenementOrigine(fonction2, callback);
        }

        function checkDateDeJour(fonction, callback) {
            var fonction2 = function (callback2) {
                checkChangementDateDepasseEvenementOrigine(fonction, callback2);
            };

            checkPasserDateJour(fonction2, callback);
        }

        function checkGetEvenements() {
            var evenements = {};
            var estEtapeRapportInspection = $('#wizard .active[data-id_processus=5]').length > 0;
            if (!estEtapeRapportInspection) {
                var idEvenement = $('#wizard').attr('id-evenement');

                if (idEvenement) {
                    var dateEvenement = $('#frm-date-evenement [name="date_evenement"]').val(); // TODO : S'assurer que l'utilisateur a saisi la date_effective.
                    if (dateEvenement.length == 10) { // Temporaire : utilisé pour mettre l'heure, les minutes et les secondes dans l'entête du wizard.
                        dateEvenement += ' 15:00:00';
                    }
                    evenements[idEvenement] = dateEvenement;
                }
            } else {
                var accordeons = $('[data-type="date_effective-evenement"]');
                $.each(accordeons, function (idx, accordeon) {
                    var idEvenement = $(accordeon).attr('id-model-instance');
                    var dateEvenement = $(accordeon).find('[name=date_evenement]').val();
                    if (dateEvenement.length == 10) { // Temporaire : utilisé pour mettre l'heure, les minutes et les secondes dans l'entête du wizard.
                        dateEvenement += ' 15:00:00';
                    }

                    if (!evenements[idEvenement] || dateEvenement > evenements[idEvenement]) {
                        evenements[idEvenement] = dateEvenement;
                    }

                    //evenements[idEvenement] = dateEvenement;
                });
            }

            return evenements;
        }

        function checkGetEvenementsOuverts() {
            var evenements = [];
            var estEtapeRapportInspection = $('#wizard .active[data-id_processus=5]').length > 0;
            var dateEvenementEncours = $('#wizard').attr('date-evenement');
            if (!estEtapeRapportInspection) {
                var idEvenement = $('#wizard').attr('id-evenement');

                var dateEvenement = $('.step-pane.active #frm-date-evenement [name="date_evenement"]').val();
                if (!dateEvenement) {
                    dateEvenement = $('#wizard').attr('date-evenement');
                }

                if (dateEvenement.length == 10) { // Temporaire : utilisé pour mettre l'heure, les minutes et les secondes dans l'entête du wizard.
                    dateEvenement += ' 15:00:00';
                }

                evenements.push({id_evenement: idEvenement, date_evenement: dateEvenement});
            } else {
                var accordeons = $('[data-type="date_effective-evenement"]');
                $.each(accordeons, function (idx, accordeon) {
                    var idEvenement = $(accordeon).attr('id-model-instance');
                    var dateEvenement = $(accordeon).find('[name=date_evenement]').val();
                    if (dateEvenement.length == 10) { // Temporaire : utilisé pour mettre l'heure, les minutes et les secondes dans l'entête du wizard.
                        dateEvenement += ' 15:00:00';
                    }

                    if (dateEvenementEncours <= dateEvenement) {
                        evenements.push({id_evenement: idEvenement, date_evenement: dateEvenement});
                    }
                });

            }

            return evenements;
        }

        function checkEvenementFermePosterieurCycleOuvertEtSave(fonction, callback, skip_modal=false) {
            //checkEvenementEtSave(fonction, callback, true, false);
            var idUe = $('#wizard').attr('id-ue');
            var idEvenementencours = $('#wizard').attr('id-evenement');
            var elements = $('.step-pane.active #div-resultat').find('input:checked').parents('a');
            var idMunicipalite = $('#wizard').attr('id-municipalite');

            if (elements.length > 0) {
                var element = elements[0];
                // Si l'UE n'est pas recherchée mais qu'une UE est entrée le champs Unité d'évaluation, on récupère non pas son attribut comme dans la liste de sélection des résultats de recherche mais sa valeur.
                idUe = typeof ($(element).attr('id-ue')) === 'undefined' ? $(element).val() : $(element).attr('id-ue');
            }

            var evenements = checkGetEvenementsOuverts();

            var params = {
                id_ue: idUe,
                evenements: JSON.stringify(evenements),
                idEvenementencours: idEvenementencours,
                id_municipalite: idMunicipalite,
            };

            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/evenement-verifier-changer-date/",
                data: params,
                dataType: 'json'
            });
            jqxhr
                .done(function (response) {
                    //var reponse = JSON.parse(response);

                    var annulation = false;
                    var texteAnnulation = "L'unité d'évaluation sera supprimée du rôle ainsi que les lots la conformant. Ceci est irréversible. Êtes-vous certain de vouloir continuer ?";
                    if ($("#annulation-matricule").prop("checked") && validateLocalisationTravauxPermis() === true) {
                        annulation = true;
                    }

                    var reponse = response;
                    if (reponse.reponse == 'ok' || skip_modal) {

                        if (annulation) {

                            fenetreModal.modalMessage({
                                titre: "Suppression d'une unité d'évaluation",
                                sansX: true,
                                texteExplicatif: texteAnnulation,
                                boutons: {
                                    "Oui": {
                                        label: " Oui ",
                                        id: "",
                                        class: "btn btn-success",
                                        action: function () {
                                            fenetreModal.fermerModalAlerteDivs();
                                            setTimeout(function () {
                                                fonction(callback);
                                            }, 0);
                                        }
                                    },
                                    "Non": {
                                        label: " Non ",
                                        id: "",
                                        class: "btn",
                                        action: function () {
                                            fenetreModal.fermerModalAlerteDivs();
                                            var reponse = {reponse: 'cancel'};
                                            callback(reponse);
                                        }
                                    }
                                }
                            });

                        } else {
                            fonction(callback);
                        }

                    } else {

                        var texteExplicatif = reponse.erreur.message;
                        if (annulation) {
                            texteExplicatif += '<br>' + texteAnnulation;
                        }

                        if (reponse.erreur.type == 'fermeture_cycle') {
                            fenetreModal.modalMessage({
                                titre: reponse.erreur.titre,
                                sansX: true,
                                texteExplicatif: texteExplicatif,
                                boutons: {
                                "Ok": {
                                    label: " Fermer ",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                            fenetreModal.fermerModalAlerteDivs();
                                            var reponse = {reponse: 'cancel'};
                                            callback(reponse);
                                    }
                                }
                            }
                            });
                        } else {
                            fenetreModal.modalMessage({
                            titre: reponse.erreur.titre,
                            sansX: true,
                            texteExplicatif: texteExplicatif,
                            boutons: {
                                "Oui": {
                                    label: " Oui ",
                                    id: "",
                                    class: "btn btn-success",
                                    action: function () {
                                        fenetreModal.fermerModalAlerteDivs();
                                        setTimeout(function () {
                                            fonction(callback);
                                        }, 0);

                                    }
                                },
                                "Non": {
                                    label: " Non ",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                        fenetreModal.fermerModalAlerteDivs();
                                        var reponse = {reponse: 'cancel'};
                                        callback(reponse);
                                    }
                                }
                            }
                        });
                        }
                    }
                });
            jqxhr
                .fail(function (jqxhr, textStatus, errorThrown) {
                    wait.stop();
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', jqxhr, errorThrown);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: "Erreur de validation",
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                    $('#proceder-supprimer-evenement').remove();
                    $('[data-dismiss="modal-fermer"]').prop('innerText', 'Fermer');
                    wait.stop();
                });
        }

        function checkPasserDateJour(fonction, callback) {
            //checkEvenementEtSave(fonction, callback, true, false);checkChangementDateEtSave
            var idUe = $('#wizard').attr('id-ue');
            var idMunicipalite = $('#wizard').attr('id-municipalite');
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');

            var elements = $('.step-pane.active #div-resultat').find('input:checked').parents('a');

            if (elements.length > 0) {
                var element = elements[0];
                // Si l'UE n'est pas recherchée mais qu'une UE est entrée le champs Unité d'évaluation, on récupère non pas son attribut comme dans la liste de sélection des résultats de recherche mais sa valeur.
                idUe = typeof ($(element).attr('id-ue')) === 'undefined' ? $(element).val() : $(element).attr('id-ue');
            }

            var evenements = checkGetEvenementsOuverts();
            var params = {
                id_ue: idUe,
                id_municipalite: idMunicipalite,
                evenements: JSON.stringify(evenements),
                id_type_evenement: idTypeEvenement
            };

            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/evenement-verifier-date-jour/",
                data: params,
                dataType: 'json'
            });
            jqxhr
                .done(function (response) {
                    //var reponse = JSON.parse(response);
                    var reponse = response;
                    if (reponse.reponse == 'ok') {
                        fonction(callback);
                    } else {

                        fenetreModal.modalMessage({
                            titre: reponse.erreur.titre,
                            sansX: true,
                            texteExplicatif: reponse.erreur.message,
                            boutons: {
                                "OK": {
                                    label: " OK ",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                        fenetreModal.fermerModalAlerteDivs();
                                        var reponse = {reponse: 'cancel'};
                                        callback(reponse);
                                    }
                                }
                            }
                        });

                    }
                });
            jqxhr
                .fail(function (jqxhr, textStatus, errorThrown) {
                    wait.stop();
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', jqxhr, errorThrown);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: "Erreur de validation",
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                    $('#proceder-supprimer-evenement').remove();
                    $('[data-dismiss="modal-fermer"]').prop('innerText', 'Fermer');
                    wait.stop();
                });
        }

        function checkDateDepasseEvenementOrigine(fonction, callback) {

            var evenements = checkGetEvenementsOuverts();
            var params = {
                evenements: JSON.stringify(evenements)
            };

            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/evenement-verifier-date-depasse-evenement-origine/",
                data: params,
                dataType: 'json'
            });
            jqxhr
                .done(function (response) {
                    //var reponse = JSON.parse(response);
                    var reponse = response;
                    if (reponse.reponse === 'ok') {
                        fonction(callback);
                    } else {

                        fenetreModal.modalMessage({
                            titre: reponse.erreur.titre,
                            sansX: true,
                            texteExplicatif: reponse.erreur.message,
                            boutons: {
                                "OK": {
                                    label: " OK ",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                        fenetreModal.fermerModalAlerteDivs();
                                        var reponse = {reponse: 'cancel'};
                                        callback(reponse);
                                    }
                                }
                            }
                        });

                    }
                });
            jqxhr
                .fail(function (jqxhr, textStatus, errorThrown) {
                    wait.stop();
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', jqxhr, errorThrown);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: "Erreur de validation",
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                    $('#proceder-supprimer-evenement').remove();
                    $('[data-dismiss="modal-fermer"]').prop('innerText', 'Fermer');
                    wait.stop();
                });
        }

        // DM: fonction commune entre checkOuvertPosterieurEtSave et checkPropagationInutileEtSave
        function checkEvenementEtSave(fonction, callback, checkOuvertPosterieur, checkPropagationInutile) {
            var evenements = checkGetEvenements();

            /*if (checkOuvertPosterieur) {
         var evenementChange = null;

         $.each(evenements, function (idEvenement, dateEvenement) {
         if (estEvenementOuvertPosterieur(idEvenement, dateEvenement)) {
         evenementChange = idEvenement;
         }
         });

         if (evenementChange) {
         fenetreModal.modalMessage({
         titre: "En changeant la date de l'évènement pour " + evenements[evenementChange] + ", les évènements fermés postérieurs de cette unité d'évaluation seront ouverts à nouveau. Voulez-vous continuer ?",
         sansX: true,
         texteExplicatif: "",
         boutons: {
         "Oui": {
         label: " Oui ",
         id: "",
         class: "btn btn-success",
         action: function () {
         fonction(callback);
         }
         },
         "Non": {
         label: " Non ",
         id: "",
         class: "btn",
         action: function () {
         fenetreModal.fermerModalAlerteDivs();
         var reponse = {reponse: 'cancel'};
         callback(reponse);
         }
         }
         }

         });
         }
         else {
         fonction(callback);
         }
         }*/

            if (checkPropagationInutile) {
                var propagationInutile = null;

                $.each(evenements, function (idEvenement, dateEvenement) {
                    if (estPropagationInutile(idEvenement, dateEvenement)) {
                        propagationInutile = idEvenement;
                    }
                });

                if (propagationInutile) {
                    fenetreModal.modalMessage({
                        titre: "En changeant la date de l'évènement pour " + evenements[propagationInutile] + ", la propagation qui avait été créée deviendra inutile donc sera supprimée. Voulez-vous continuer ?",
                        sansX: true,
                        texteExplicatif: "",
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function () {
                                    fonction(callback);
                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                    fenetreModal.fermerModalAlerteDivs();
                                    var reponse = {reponse: 'cancel'};
                                    callback(reponse);
                                }
                            }
                        }

                    });
                } else {
                    fonction(callback);
                }
            }
        }

        function verifierChangementStatutEvenement(fonction, callback) {
            var params = {
                id_type_evenement: $('#wizard').attr('id-type-evenement'),
                id_etape_processus: $('#modal-step-contents > .active').attr('data-id_processus'),
                id_evenement: $('#wizard').attr('id-evenement')
            };
            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/verifier-changement-statut-evenement/",
                data: params,
                dataType: 'json'
            });
            jqxhr
                .done(function (response) {
                    if (response.changement_statut) {
                        var ancienStatut = response.changement_statut.ancien_statut;
                        var nouveauStatut = response.changement_statut.nouveau_statut;
                        var messageStatut = "Souhaitez-vous conserver l'état actuel : <strong>" + ancienStatut.description +
                            "</strong><br/><br/>OU<br/><br/>Remplacer par le nouvel état : <strong>" + nouveauStatut.description + "</strong> ?";

                        fenetreModal.modalMessage({
                            titre: "Cette action provoque un changement d'état à l'évènement",
                            texteExplicatif: messageStatut,
                            sansX: true,
                            taille: "grande",
                            boutons: {
                                "1": {
                                    label: " Conserver l'état actuel ",
                                    id: "",
                                    class: "btn btn-primary",
                                    action: function () {
                                        setTimeout(function () {
                                            $('#wizard').attr('id-statut-evenement', ancienStatut.id);
                                            fenetreModal.fermerModalAlerteDivs();
                                            fonction(callback);
                                        }, 0);
                                    }
                                },
                                "2": {
                                    label: " Remplacer par le nouvel état ",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                        setTimeout(function () {
                                            $('#wizard').attr('id-statut-evenement', nouveauStatut.id);
                                            fenetreModal.fermerModalAlerteDivs();
                                            fonction(callback);
                                        }, 0);
                                    }
                                }
                            }
                        });
                    } else {
                        if (response.nouveau_statut) {
                            $('#wizard').attr('id-statut-evenement', response.nouveau_statut);
                        }
                        fonction(callback);
                    }
                    wait.stop();
                });
            jqxhr
                .fail(function (jqxhr, textStatus, errorThrown) {
                    wait.stop();
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', jqxhr, errorThrown);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: "Erreur de validation",
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                });
        }

        /**
         * Fonction de sauvegarde de l'étape informations générales du processus de permis.
         * */
        function saveInfoGeneralePermis(callback) {
            checkDateDeJour(saveInfoGeneralePermis2, callback);
        }

        function saveInfoGeneralePermis2(callback) {
            //  Si la date d'évènement a changé on tag pour l'étape 2. Faut que ça sauvegarde même si on ne change pas l'UE de l'étape 2.
            if ($('#wizard').attr('id-evenement') != '' &&
                ($('input[name="date_evenement"]').prop("defaultValue") !== $('input[name="date_evenement"]').val())) {

                verifierChangementStatutEvenement(saveInfoGeneralePermis3, callback);
            } else {
                saveInfoGeneralePermis3(callback);
            }
        }

        function saveInfoGeneralePermis3(callback) {
            messageToastCompteur = 0;
            nbErreurs = 0;
            // On sélectionne seulement les forms de la page devant être sauvegardés (ceux modifiés)
            var listeFormulaires = $('#modal-step-contents > .active div[type="formulaire"]').not($('[modifie="False"][methode="PATCH"]'));
            var nombreFormulaires = listeFormulaires.length;
            var sousBlocForms = $('#document-permis').find('.sous-bloc-form[modifie="True"]'); // La section documents a plutôt une classe au lieu du type formulaire pour l'identifier
            var idEvenement = $('#wizard').attr('id-evenement');

            // Pour les fins de création du permis et de la création de l'évènement, on doit swapper le formulaire de la date d'évènement et celui des infos générales pour que l'évènement puisse avoir un numéro de permis.
            if (listeFormulaires.length > 1) {
                var temp = listeFormulaires[0];
                listeFormulaires[0] = listeFormulaires[1];
                listeFormulaires[1] = temp;
            }
            if (listeFormulaires.length > 0) {
                var headers = {};
                listeFormulaires.each(function (idx) {
                    if (nbErreurs > 0) {
                        // DM: ca signifie que le permis n'a pas été sauvegardé. Alors on ne doit pas tenter de sauvegarder l'évènement (formulaire de date du haut)
                        // Sinon ca donnera un évènement avec aucun id_permis
                        return;
                    }

                    var currentForm = $(this);
                    var async = false;
                    var dataType = "json";
                    var typeRequete = currentForm.attr('methode');
                    var url = currentForm.attr('vue');
                    if (typeRequete !== "POST") { // On fait un update ou un delete
                        headers = {'X-HTTP-Method-Override': typeRequete};
                        url += currentForm.attr('id-model-instance') + '/';
                    } else {
                        headers = {};
                    }
                    var idCurrentForm = currentForm.attr('id');
                    var idMunicipalite = $('#municipalite').val();
                    var idUe = $('#wizard').attr('id-ue');

                    // On stocke les variables importantes pour les étapes suivantes.
                    $('#wizard').attr('id-municipalite', idMunicipalite);
                    if ($('#wizard').attr('id-statut-evenement') === '') {
                        $('#wizard').attr('id-statut-evenement', 1);
                    }

                    var idPermis = $('#evenement-infos-generales').attr('id-model-instance');
                    //var formulaire = $(this).attr('id');
                    var params = controlesFormulaires.serialiserFormulaire(currentForm);
                    if (idCurrentForm == 'frm-date-evenement') {
                        // prendre la date d'évènement dans l'entête du wizard : date qui peut avoir une heure différente de 15:00:00
                        // car si on modifie seulement la remarque, la date de l'évènement est changé pour 15:00:00 et comme le serveur
                        // vérifie si un autre évènement la même journée sans utiliser l'heure, l'heure est remis à 15:00:00 sur l'évènement
                        $.each(params, function (index, value) {
                            if (value.name === 'date_evenement') {
                                value.value = $('#wizard').attr('date-evenement');
                            }
                            if (value.name === 'remarque') {
                                var evenementRemarque = $('#wizard').attr('evenement-remarque');
                                value.value = evenementRemarque ? evenementRemarque : 'None';
                            }
                        });
                    }
                    // On strip les données mises en forme par des masques
                    params = masquesSelection.striper(currentForm, params);
                    var idStatutEvenement = $('#wizard').attr('id-statut-evenement');
                    var etapeProcessus = $('#modal-step-contents > .active').attr('data-id_processus');
                    var paramsSupplementaires = [
                        {name: 'id_municipalite', value: idMunicipalite},
                        {name: 'etapeProcessus', value: etapeProcessus},
                        {name: 'id_type_evenement', value: $('#wizard').attr('id-type-evenement')},
                        {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                        {name: 'id_statut_evenement', value: idStatutEvenement},
                        {name: 'remarque', value: $('#wizard').attr('evenement-remarque')},
                        {name: 'id_evenement', value: $('#wizard').attr('id-evenement')},
                    ];
                    if (idPermis != 'None') {
                        paramsSupplementaires.push({name: 'id_permis', value: idPermis});
                    }
                    if (idUe != '') {
                        paramsSupplementaires.push({name: 'id_ue', value: idUe});
                    }
                    paramsSupplementaires = nettoyerParams(paramsSupplementaires);
                    params = params.concat(paramsSupplementaires);
                    // indiquer qu'on vient du mode assistant pour effectuer la validation
                    params.push({name: 'wizard_mode', value: ''});
                    var callbackSauvegarde = function (response) {

                        if (idCurrentForm == 'evenement-infos-generales') {
                            traitementPostSauvegarde(currentForm);
                            var idPermis = response.id_permis;
                            currentForm.attr('id-model-instance', idPermis);
                            $('#wizard').attr('id-processus', idPermis); // On stocke aussi le id du permis au niveau du wizard pour être utilisé dans les étapes suivantes.
                            updateEnteteWizard();

                        } // Chaque forms de la page contient son id pour les prochains updates.

                        if (idCurrentForm == 'frm-date-evenement') { //($('#wizard').attr('id-ue') != '' && $('#wizard').attr('id-evenement') == '' &&  ...
                            idEvenement = response.id_evenement;
                            if (idEvenement !== undefined) { // Condition nécessaire car si le permis n'est pas créé à cause d'erreur de validation dans le form qui se save en premier alors il ne faut pas venir faire le traitementPostSauvegarde qui vient indiquer que modifie = false et alors l'évènement ne se crée plus car ce form de date evenement ne se save plus
                                traitementPostSauvegarde(currentForm);
                                $('#wizard').attr('id-evenement', idEvenement);
                                $('#wizard').attr('date-evenement', response.date_evenement); // GG: On vient remettre à jour la date d'évènement parce qu'elle peut être modifiée à tout moment et, dans des étapes subséquentes, on vient lire cette date dans l'entête du wizard.
                                $('#wizard').attr('evenement-remarque', $('#wizard').attr('evenement-remarque')); // On stocke dans le wizard la date_evenement pour les prochaines étapes.
                                currentForm.attr('id-model-instance', idEvenement);
                                updateEnteteWizard();
                                refreshDatatables();
                            }
                            $('button[data-type="save"]').attr("disabled", true);
                        }

                        // On devra recharger toutes les étapes pour prendre en compte les modifications (sauf celle en cours)...
                        //$('#modal-step-contents > div').not('.active').attr('recharger', 'oui');

                        // On execute le callback seulement si tous les forms ont été sauvegardés.
                        // Le callback est utilisé pour indiquer si la sauvegarde s'est effectuée sans erreur (utile pour le bouton x et potentiellement le bouton suivant).
                        var callback;
                        if (listeFormulaires.length - 1 == idx && typeof (callback) !== 'undefined') {
                            response.reponse = 'ok';
                            callback(response);
                        }

                        // TODO: Vérifier si le currentForm est dateEvenement et si oui on doit venir modifier l'historique dans chacun des blocs ayant été modifié et vérifier si propagation nécessaire.

                    };
                    var rechargerPage = false;
                    var callback2;
                    nbErreurs += sauvegarderDonnees(currentForm, url, async, dataType, params, etapeProcessus, {}, nombreFormulaires, rechargerPage, callback2, callbackSauvegarde);
                });
            }

            if (!nbErreurs && sousBlocForms.length > -1) {
                // Le id_permis est obligatoire pour le save des documents. Si le permis et le document sont savé en même temps celui du permis termine en premier à cause du async false.
                var sections = $('#document-permis');
                var idCurrentForm = 'document-permis';
                var currentForm = $('#' + idCurrentForm);
                var erreurFichier = $('#' + idCurrentForm).find('.ace-file-container.selected .ace-error').attr('erreur');
                if (!erreurFichier) {
                    erreurFichier = '';
                }

                var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                    var params = controlesFormulaires.serialiserFormulaire(currentForm);
                    var idPermis = $('#evenement-infos-generales').attr('id-model-instance');
                    var erreurFichier = currentForm.find('.ace-file-container.selected .ace-error').attr('erreur');
                    if (!erreurFichier) {
                        erreurFichier = '';
                    }
                    params.push(
                        {name: 'id_permis', value: idPermis},
                        {name: 'id_municipalite', value: $('#wizard').attr('id-municipalite')},
                        {name: 'erreur_fichier', value: erreurFichier},
                        {name: 'date_debut', value: $('#wizard').attr('date-evenement')} // prendre celui du wizard qui vient d'être ajouté par le 'frm-date-evenement'
                    );
                    return params;
                };

                var getChampUnique = function (currentForm, idCurrentForm) {
                    if (idCurrentForm == 'document-permis') {
                        return {
                            unique_nom_champ: 'index_ligne',
                            unique_id_champ: $('#' + idCurrentForm).find('.sous-bloc-form').index(currentForm)
                        };
                    }
                    return {};
                };

                var getChampTransfert = function (idCurrentForm) {
                    var retour = {};
                    if (idCurrentForm == 'document-permis') {
                        retour.transfert_champ_destination = 'id_permis';
                    }
                    return retour;
                };

                var messageToast = {};
                sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);
                wait.stop();
            }

            if (typeof (callback) !== 'undefined') {
                wait.stop('contenu');
                var response = {};
                if ($('#document-permis').find('.messages-erreurs').length > 0) {
                    nbErreurs = nbErreurs + 1;
                    var $cibleErreur = $('#modal-wizard-evenement').find('.messages-erreurs:first');
                    if ($cibleErreur.length > 0) {
                        var conteneurOffset = Math.abs($('#modal-step-contents > .active .contenu-principal').offset().top, 10);
                        var scrollToErreur = $cibleErreur.offset().top - WIZARD_ENTETE.taille + conteneurOffset;
                        $('#modal-step-contents').slimScroll({scrollTo: scrollToErreur, animate: true});
                    }
                }
            }
        }


        /**
         * Fonction d'initialisation de l'étape Saisie de la nature et description des travaux.
         * */
        function initNatureDescriptionTravaux() {

            $('#travaux-batiments-contenu').find('select').not('.well').select2();

            // On vient remplacer la listes de travaux si plus de 100 bâtiments par une liste avec des miniatures des photos principales

            function select_batiment_miniatures(batiment) {
                var originalOption = batiment.element;

                if (!batiment.id) return batiment.text;
                var ficher_chemin = $(originalOption).data('img_src');
                return '<img class="batiment-miniature" src=' + ficher_chemin.toLowerCase() + ' style="width: 30px;"/>' + '&nbsp;&nbsp;' + batiment.text;
            }

            if ($('#form-id_batiment-trop').length > 0) {
                $('#form-id_batiment-trop').select2({
                    cacheDataSource: [],

                    formatResult: select_batiment_miniatures,
                    formatSelection: select_batiment_miniatures,
                    escapeMarkup: function (batiment) {
                        return batiment;
                    }
                });
            }


            $('#form-id_batiment-trop').on("select2:selecting", function (e) {
                e.params.originalEvent.stopPropagation();
            });


            $('#travaux-batiments-contenu').off('click', '[data-action="travaux-batiment-trop-ajouter"]').on('click', '[data-action="travaux-batiment-trop-ajouter"]', function () {
                var batimentSelection = $('#travaux-batiments-contenu').find('select').not('.well').val();
                //    Ajouter le conteneur du bâtiment pour la sélection des travaux.
                ajouterFormulaireBatiment(batimentSelection);
            });


            $('#travaux-batiments-contenu').off('click', '[data-action="travaux-batiment-trop-enlever"]').on('click', '[data-action="travaux-batiment-trop-enlever"]', function () {
                var selection = $(this).closest('.flash-message').attr('id');
                supprimerFormulaireBatiment(selection);
            });


            $(document).on('mouseenter', 'img.batiment-miniature', function (e) {
                var $originalOption = $(e.currentTarget);
                var image_name = $originalOption.attr('src');
                if (image_name != "") {
                    var imageTag = '<div class="image" style="position:absolute; left: -180px">' + '<img class="ombre" src="' + image_name + '" alt="' + $originalOption.text + '" height="120"/>' + '</div>';
                    $('#select2-drop').prepend(imageTag);
                }
            });


            $(document).on('mouseleave', 'img.batiment-miniature', function (batiment) {
                $('#select2-drop').children('div.image').hide();
            });


            // Ajout de bâtiments pour l'étape "Saisie de la nature et de la description des travaux" du wizard de Tenue à jour.
            $("#modal-wizard-evenement").off('click', '[data-action="travaux-batiment-ajouter"]').on('click', '[data-action="travaux-batiment-ajouter"]', function () {
                var idUe = $('#wizard').attr('id-ue');
                var dateEvenement = $('#wizard').attr('date-evenement');
                var natureEvenement = $(this).attr('data-nature_evenement');
                creerBatiment(idUe, dateEvenement, natureEvenement);
            });


            // Ajout d'une nature des travaux pour un bâtiment à l'étape "Saisie de la nature et de la description des travaux" du wizard de Tenue à jour.
            $("#modal-wizard-evenement").off('click', '[data-action="travaux-batiment-nature-ajouter"]').on('click', '[data-action="travaux-batiment-nature-ajouter"]', function () {
                //var idBatiment = $(this).closest('[data-type=travaux-batiment]').attr('id').match(/\d*$/).pop();
                var idBatiment = $(this).closest('[data-type=travaux-batiment]').attr('id-model-instance');
                var dateEvenement = $('#wizard').attr('date-evenement');
                creerNatureTravaux(idBatiment, dateEvenement);
            });


            // Affichage du formulaire de détails des travaux (types de travaux) suite à la sélection d'une nature des travaux
            $('#modal-wizard-evenement').off('change', 'select[name="natureEvenement"]').on('change', 'select[name="natureEvenement"]', function (event) {

                var element = $(this);
                var donneeAvantChangement = element.data('valeurPrecedente');
                var idBatimentActuel = $(this).closest('[data-type=travaux-batiment]').attr('id-model-instance');

                var $listeIdAutres = $('#travaux-batiment-' + idBatimentActuel + ' select[name="natureEvenement"]').map(function () {
                    if (!(element.is($(this)))) {
                        return $(this);
                    }
                }).get(); // On accumule la liste des sélecteurs de nature afin mettre à jour toutes les listes en fonction de la sélection actuelle.

                var listeNaturesAutres = $('#travaux-batiment-' + idBatimentActuel + ' select[name="natureEvenement"]').map(function () {
                    if (!(element.is($(this)))) {
                        return this.value;
                    }
                }).get();

                var listeNatures = $('#travaux-batiment-' + idBatimentActuel + ' select[name="natureEvenement"]').map(function () {
                    return this.value;
                }).get(); // On passe la liste des natures de travaux existantes pour les retirer de la liste de sélection.

                var resultat = afficherCacherOptionsSelect2(this, $listeIdAutres, listeNatures, listeNaturesAutres);

                if (resultat === 'ok') {
                    if (donneeAvantChangement !== '' && typeof (donneeAvantChangement) !== 'undefined' && donneeAvantChangement.indexOf("nouveau") <= -1) {

                        // TODO: Mettre dans un buffer les opérations à effectuer : changements à la BD suite à la modification du formulaire en fonction du initial sur le chargement initial du formulaire.
                        fenetreModal.modalMessage({
                            titre: "Souhaitez-vous vraiment changer cette nature des travaux pour ce bâtiment ?",
                            boutons: {
                                'Oui': {
                                    label: " Oui ",
                                    id: "proceder-changement-nature",
                                    class: "btn btn-success",
                                    action: function () {
                                        changerNatureEvenementXEvenement(element);
                                    }
                                },
                                'Non': {
                                    label: " Non ",
                                    id: "annuler-changement-nature",
                                    class: "btn",
                                    action: function () {
                                        element.select2("val", donneeAvantChangement);
                                    }
                                }
                            }
                        });
                    } else {
                        changerNatureEvenementXEvenement(element); // Par défaut on charge la nature qui doit être chargée sans confirmation s'il sagit d'une sélection initiale.
                    }
                }
            });

            // Mise à jour du id-model-instance lorsqu'une sélection est effectuée et que editable=True.
            $('#modal-wizard-evenement').on('change', 'select[name="typeTravaux"]', function () {

                var element = $(this);

                var $listeIdAutres = $(this).closest('[data-type=travaux-batiment-nature]').find('select[name="typeTravaux"]').map(function () {
                    if (!(element.is($(this)))) {
                        return $(this);
                    }
                }).get(); // On accumule la liste des sélecteurs de nature afin mettre à jour toutes les listes en fonction de la sélection actuelle.

                var listeTypesTravauxAutres = $(this).closest('[data-type=travaux-batiment-nature]').find('select[name="typeTravaux"]').map(function () {
                    if (!(element.is($(this)))) {
                        return this.value;
                    }
                }).get();

                var listeTypesTravaux = $(this).closest('[data-type=travaux-batiment-nature]').find('select[name="typeTravaux"]').map(function () {
                    return this.value;
                }).get(); // On passe la liste des natures de travaux existantes pour les retirer de la liste de sélection.

                afficherCacherOptionsSelect2(this, $listeIdAutres, listeTypesTravaux, listeTypesTravauxAutres);
            });


            // Ajout d'une nature des travaux pour un bâtiment à l'étape "Saisie de la nature et de la description des travaux" du wizard de Tenue à jour.
            $("#modal-wizard-evenement").off('click', '[data-action="travaux-batiment-nature-type-ajouter"]').on('click', '[data-action="travaux-batiment-nature-type-ajouter"]', function () {
                var idBatiment = $(this).closest('[data-type=travaux-batiment]').attr('id-model-instance');
                var nouveauNature = $(this).closest('[data-type=travaux-batiment-nature]').attr('id').split('-')[4];
                var $Nature = $('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature);
                var idNature = $Nature.find('#natureEvenement').val();
                var dateEvenement = $('#wizard').attr('date-evenement');
                var typeAjout = 1; // On conserve de wrapper pour les types de travaux...
                creerTypeTravaux(idBatiment, idNature, nouveauNature, dateEvenement, typeAjout);
            });


            // Retirer le bâtiment, les natures et les travaux, s'il y en a.
            $("#modal-wizard-evenement").off('click', '[data-action="batiment-retirer"]').on('click', '[data-action="batiment-retirer"]', function (e) {
                var batimentSelection = $('#travaux-batiments-contenu').find('select').not('.well').val();
                supprimerFormulaireBatiment(e, batimentSelection);
            });

            // Suppression des éléments et sous-éléments d'un formulaire (nature et types, par exemple)
            $("#modal-wizard-evenement").off('click', '[data-action="travaux-supprimer"]').on('click', '[data-action="travaux-supprimer"]', function (e) {
                supprimeNaturesEtTravaux(e);
            });
        }


        /**
         * Fonction qui permet de cacher/afficher et d'activer/désactiver des options dans les listes select2 générées dynamiquement afin de prendre action. Utile dans le cas où nous avons plusieurs listes similaires, générées dynmaiquement et que nous changeons les options sélectionnées. Il peut arriver des cas où nous sélectionnons deux fois le même éléments dans deux listes différentes (par exemples 2 natures pareilles dans l'étape 3 du permis, ou deux travaux similaires : ce qu'on ne souhaite pas autoriser.
         * @param {object} elementCible - Le this du onChange.
         * @param {array} $listeIdAutres - Liste des sélecteurs des ID des listes communes (plusieurs natures, plusieurs travaux, etc).
         * @param {array} listeElements - Liste des éléments sélectionnés dans toutes les listes communes.
         * @param {array} listeElementsAutres - Liste des éléments des autres listes (n'inclut pas la valeu (option) sélectionnée dans la liste qui a déclenché ce on_change.
         * @return resultat : "ok" ou "erreur" afin de décider si on poursuit ou si l'on arrête l'exécution du script.
         */
        function afficherCacherOptionsSelect2(elementCible, $listeIdAutres, listeElements, listeElementsAutres) {
            // Suite à la sélection d'une nature on fait deux choses
            // - On vérifie que ce qui est sélectionné ne l'est pas pour aucun autre champ dans la page
            // - On l'enlève des listes des autres éléments dans la page.
            var valeurActuelle = $(elementCible).val();
            var donneeAvantChangement = $(elementCible).data('valeurPrecedente');

            var poursuivre;
            if ($.inArray($(elementCible).val().toString(), listeElementsAutres) > -1) {
                fenetreModal.modalMessage({
                    titre: "Cette nature a déjà été sélectionnée pour ce bâtiment",
                    boutons: {
                        'OK': {
                            label: " OK ",
                            class: "btn btn-success",
                            action: function () {
                                elementCible.select2('val', donneeAvantChangement);
                            }
                        }
                    }
                });
                poursuivre = 'error';
            } else {
                $.each($listeIdAutres, function (index, valeur) {
                    // on affiche tous les éléments de la liste d'origine
                    valeur.find('option').prop('disabled', false);
                    // on désactive celui qu'on vient de sélectionner.
                    valeur.find('option[value=' + valeurActuelle + ']').prop('disabled', true);
                    // on désactive aussi la liste des valeurs sélectionnées.
                    $.each(listeElements, function (index2, valeur2) {
                        if (valeur.select2('val') !== valeur2) {
                            valeur.find('option[value=' + valeur2 + ']').prop('disabled', true);
                        }
                    });
                });
                poursuivre = 'ok';
            }

            return poursuivre;
        }

        /**
         * Fonction exécutée pour le changement de nature des travaux x Evenement
         * @param {string} titre - Chaîne de caractères du titre à nettoyer.
         * */
        function changerNatureEvenementXEvenement(element) {
            var idBatiment = element.closest('[data-type=travaux-batiment]').attr('id-model-instance');
            var idNature = element.val();
            var nouveauNature = element.closest('[data-type="travaux-batiment-nature"]').attr('id').split('-')[4]; // Dans certains cas c'est nouveau_1, sinon, c'est parce qu'il y a des données sur les natures dans la BD.
            // On change le titre "Nature des travaux - Non sauvegardé" en "Agrandissement - Non sauvegardé"
            var selecteur = element.closest('[data-type="travaux-batiment-nature-contenu"]').find('a.accordion-toggle');
            var titreAccordeon = selecteur.text();
            var indiquerEtatSauvegarde = 1; // On indique si le titre de l'accordéon doit être mis à jour pour indiquer si l'élément doit être sauvegardé à nouveau.
            nettoyerTitreAccordeon(titreAccordeon, selecteur, element.closest('#natureEvenement').children(':selected').text(), indiquerEtatSauvegarde);
            // On récupère le compteur utilisé pour la création du div courant de la Nature actuelle. On a soit nouveau_1... (ordre création d'une nature non encore sauvegardée) ou 1 (nature sauvegardée)
            var typeAjout = 0; // On remplace le contenu du wrapper pour les types des types de travaux : changement de nature. 0 = remplacer le div du type de travaux (on change la nature), 1 = on ajoute un autre div manuellement (plusieurs types pour une nature).

            // Si les données proviennent dans la BD, on doit simuler un .trigger() pour effacer les types_travaux_x_evenement associés, s'ils existent.
            var formulaireCourant = element.closest('[data-type="travaux-batiment-nature"]').attr('id');
            var forcerSauvegardeNature;
            if ($('#' + formulaireCourant).find('[data-type="travaux-batiment-nature-type"]').length > 0) {
                // liste des formulaires
                var listeSuppressions = $('#' + formulaireCourant).find('[data-type="travaux-batiment-nature-type"]');
                $.each(listeSuppressions, function (i) {
                    $(this).find('a[data-action="travaux-supprimer"]').trigger("click");
                });
                // WORKAROUND : On doit forcer la sauvegarde de la nature si l'on a effectué le changement et que des travaux étaient présents parce qu'on fait un trigger click sur la suppression des travaux. Donc, on a changé les travaux, mais la nature, elle, n'est pas sauvegardée même si le formulaire nous indique que oui (bouton de sauvegarde désactivé).
                forcerSauvegardeNature = true;
            }
            var dateEvenement = $('#wizard').attr('date-evenement');
            creerTypeTravaux(idBatiment, idNature, nouveauNature, dateEvenement, typeAjout);
            element.data('valeurPrecedente', element.val()); // On n'utilise pas .prop('defaultValue'), au cas où l'on aurait besoin de retourner à la valeur initiale.
            if (forcerSauvegardeNature === true) {
                element.closest('[data-type="travaux-batiment-nature"]').attr('modifie', 'True');
                var nature_precedente = element.data('valeurPrecedente');
                $('#wizard').attr('nature_precedente', nature_precedente);
                $('#btn-wizard-save').trigger("click");
            }
        }


        /**
         * Fonction de nettoyage des caractères du titre des accordéons (espaces, etc.).
         * @param {string} titre - Chaîne de caractères du titre à nettoyer.
         * @oaram {object} selecteur - Sélecteur utilisé pour remplacer le titre du bon accordéon.
         * @oaram {number} indiquerEtatSauvegarde - Indique si l'on doit indiquer " - Non sauvegardé".
         * @return {string} le titre nettoyé et remplacé.
         * */
        function nettoyerTitreAccordeon(titre, selecteur, substitution, indiquerEtatSauvegarde) {
            var titreAccordeon = titre;
            var titreARemplacer = '';
            titreAccordeon = titreAccordeon.replace(/(\r\n|\n|\r)/gm, ""); // Retirer les retours de lignes
            titreAccordeon = titreAccordeon.replace(/\s+/g, " "); // Retirer les doubles espaces blancs
            if (titreAccordeon.indexOf("-") > -1) {
                titreARemplacer = titreAccordeon.match("(.*) -");
                titreAccordeon = titreARemplacer[1];
            }
            selecteur.html(selecteur.html().replace(titreAccordeon, " " + substitution)); // Ne fonctionne pas s'il y a un espace avant et après. On doit valider qu'il n'y a pas d'espace dans wiz_permis_travaux_batiment_nature.html.
            if (indiquerEtatSauvegarde === 1) {
                if (selecteur.html().indexOf(' - Non sauvegardé') <= -1) {
                    selecteur.append(' - Non sauvegardé');
                }
            }
        }

        /**
         * Fonction de sauvegarde et de suppression de l'étape Saisie de la nature et description des travaux.
         * */

        function saveNatureDescriptionTravaux(callback) {
            verifierChangementStatutEvenement(saveNatureDescriptionTravaux2, callback);
        }

        function saveNatureDescriptionTravaux2(callback, messageToastPerso, methode) {
            var nbErreurs = 0;
            messageToastCompteur = 0;

            var listeFormulaires = $('#modal-step-contents > .active div[type="formulaire"]'); // $('#modal-step-contents > .active div[type="formulaire"][modifie="True"]');
            // Itérer sur l'ensemble des formulaires
            var nombreFormulaires = listeFormulaires.length;
            var etapeProcessusId = $('#modal-step-contents > .active').attr('data-id_processus');
            var idStatutEvenement = $('#wizard').attr('id-statut-evenement');
            var dataType = 'json';
            var async = false;
            var formulairesTraites = {};
            listeFormulaires.each(function (index) {
                var $formulaireCourant = $(this);
                var params = controlesFormulaires.serialiserFormulaire($(this));
                var indexObjet = $(this).attr('id');
                var idSource = indexObjet.split('-');
                formulairesTraites[indexObjet] = {};
                var evenementNouveau = 'False';
                if (typeof (idSource[6]) !== "undefined") {
                    if (idSource[6].indexOf('nouveau') > -1) {
                        evenementNouveau = 'True';
                    }
                } else if (typeof (idSource[4]) !== "undefined") {
                    if (idSource[4].indexOf('nouveau') > -1) {
                        evenementNouveau = 'True';
                    }
                } else if (typeof (idSource[2]) !== "undefined") {
                    if ((idSource[2].indexOf('nouveau') > -1)) {
                        evenementNouveau = 'True';
                    }
                }
                if ((($formulaireCourant.find('[name="typeTravaux"]').prop("defaultValue") !== $formulaireCourant.find('[name="typeTravaux"]').val()) && ($formulaireCourant.find('[name="typeTravaux"]').prop("defaultValue") !== undefined)) || (evenementNouveau === 'True')) {
                    if ($formulaireCourant.attr('methode') !== 'DELETE') { // Si on a défini un DELETE déjà. On ne change pas.
                        $formulaireCourant.attr('methode', 'POST'); // Si on a changé le type de travaux, on doit faire un DELETE_POST. C'est en définissant mouvement à True qu'on le fait.
                    }
                    formulairesTraites[indexObjet].mouvement = 'True';
                } else if ($formulaireCourant.attr('methode') === 'DELETE') {
                    formulairesTraites[indexObjet].mouvement = 'True';
                } else {
                    formulairesTraites[indexObjet].mouvement = 'False';
                }
                formulairesTraites[indexObjet].id = $formulaireCourant.attr('id');
                formulairesTraites[indexObjet].vue = $formulaireCourant.attr('vue');
                formulairesTraites[indexObjet].methode = $formulaireCourant.attr('methode');
                formulairesTraites[indexObjet].bool_demande_originale = 'False'; // On hacke une valeur à false parce que pour l'étape 3, contrairement à l'étape 5, la décision d'exécuter un delete_create (delete, post) doit être positive, ici. À l'étape 5, on ne fait qu'un patch sur les formulaires bool_demande_originale.
                formulairesTraites[indexObjet].modifie = $formulaireCourant.attr('modifie');
                formulairesTraites[indexObjet].data_type = $formulaireCourant.attr('data-type');

                var instanceCalcul = (typeof ($(this).attr('id-model-instance')) === 'undefined' || $(this).attr('id-model-instance') === 'None' || $(this).attr('id-model-instance').indexOf('nouveau') > 0) ? 0 : $(this).attr('id-model-instance');
                formulairesTraites[indexObjet].id_instance = instanceCalcul;
                var paramsSupplementaires = [];
                var construction_ou_batiment = formulairesTraites[indexObjet].data_type === 'travaux-batiment-construction' ? 'travaux-batiment-construction' : 'travaux-batiment';
                var batimentParam = construction_ou_batiment == 'travaux-batiment-construction' ? idSource[3] : idSource[2];
                paramsSupplementaires.push(
                    {
                        name: 'etape_evenement_courant',
                        value: $('#modal-step-contents > .active').attr('data-id_processus')
                    },
                    {name: 'formulaire_id', value: $formulaireCourant.attr('id')},
                    {name: 'mouvement', value: formulairesTraites[indexObjet].mouvement},
                    {name: 'bool_demande_originale', value: 'True'},
                    {name: 'nature_precedente', value: $('#wizard').attr('nature_precedente')},
                    {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                    {name: 'uniteEvaluation', value: $('#wizard').attr('id-ue')},
                    {name: 'plus_de_100_batiments', value: $('input#plus-de-100-batiments').val()},
                    {name: 'municipalite', value: $('#wizard').attr('id-municipalite')},
                    {name: 'permis', value: $('#wizard').attr('id-processus')},
                    {name: 'id_evenement', value: $('#wizard').attr('id-evenement')},
                    {name: 'date_debut', value: $('#wizard').attr('date-evenement')},
                    {name: 'evenement', value: $('#wizard').attr('id-evenement')}, // Utilisé pour nature_x_evenement_evenement
                    {name: 'etapeProcessus', value: etapeProcessusId},
                    {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                    {name: 'id_statut_evenement', value: idStatutEvenement},
                    {name: 'type_evenement', value: $('#wizard').attr('id-type-evenement')},
                    {name: 'batiment', value: batimentParam},
                    {
                        name: 'id_type_batiment',
                        value: $formulaireCourant.closest('[data-type="' + construction_ou_batiment + '"]').attr('data-id_type_batiment')
                    },
                    {
                        name: 'idTypeBatiment',
                        value: $formulaireCourant.closest('[data-type="' + construction_ou_batiment + '"]').find('#typeBatiment').val()
                    },
                    {
                        name: 'natureEvenementXEvenement',
                        value: $formulaireCourant.closest('[data-type="' + construction_ou_batiment + '"]').attr('data-nature_evenement_x_evenement')
                    },
                    {
                        name: 'natureEvenement',
                        value: $formulaireCourant.closest('[data-type="' + construction_ou_batiment + '"]').attr('data-nature_evenement')
                    }, // nature des travaux (4) pour le formulaire de construction neuve...
                    {
                        name: 'id_nature_evenement',
                        value: $formulaireCourant.closest('[data-type="travaux-batiment-nature"]').find('#natureEvenement').val()
                    }, // nature de travaux
                    {
                        name: 'natureEvenementXBatiment',
                        value: $formulaireCourant.closest('[data-type="travaux-batiment-nature"]').attr('data-id_nature_evenement_x_batiment')
                    },
                    {
                        name: 'natureEvenement',
                        value: $formulaireCourant.closest('[data-type="travaux-batiment-nature"]').find('#natureEvenement').val()
                    }, // nature de travaux
                    {
                        name: 'id_type_travaux',
                        value: $formulaireCourant.closest('[data-type="travaux-batiment-nature-type"]').find('#typeTravaux').val()
                    } //type de travaux
                );
                paramsSupplementaires = nettoyerParams(paramsSupplementaires);
                params = params.concat(paramsSupplementaires);
                formulairesTraites[indexObjet].data_type = formulairesTraites[indexObjet].data_type.replace(/travaux/g, 'inspection');
                formulairesTraites[indexObjet].donnees = [];
                formulairesTraites[indexObjet].donnees = params;
            });
            if (typeof (formulairesTraites) !== "undefined") { // La sauvegarde n'est exécutée que lorsqu'une liste a été initialisée et qu'elle' contient "listeFormulairesATraiter" et "listeFormulairesNaturesATravauxSupprimer"
                nombreFormulaires = 1;
                var $formulaireCourantTemp = $('#saisie_et_validation_travaux-toggle');
                var url = '/gestion-roles/tenue-a-jour/wizard/evenement/sauvegarder-description-travaux/';
                async = true;
                dataType = "json";
                var params = {
                    'json': JSON.stringify(formulairesTraites),
                    'etapeProcessus': $('#modal-step-contents > .active').attr('data-step'),
                    'etapeOrdre': $('#modal-step-contents > .active').attr('data-id_processus'),
                    'evenement': $('#wizard').attr('id-evenement'),
                    'typeEvenement': $('#wizard').attr('id-type-evenement'),
                    'statutEvenement': idStatutEvenement,
                    'date_chargee': $('#wizard').attr('date-chargee')
                };
                etapeProcessusId = $('#modal-step-contents > .active').attr('data-id_processus');
                var callbackSauvegarde = function () {
                    if (typeof (response) != 'undefined') {
                        // Dans le cas des Types de travaux, on doit récupérer natureEvenementXBatiment pour s'y rattacher.
                        if (typeof (response.natureEvenementXEvenement) != 'undefined') {
                            $formulaireCourantTemp.attr('id-model-instance', response.natureEvenementXEvenement);
                            $formulaireCourantTemp.attr('data-id_nature_evenement_x_evenement', response.natureEvenementXEvenement);
                            $formulaireCourantTemp.attr('data-id_nature_evenement_x_batiment', response.natureEvenementXBatiment);
                            // HACK : Si on trouve un formulaire de date-evenement, on recopie la date sauvegardée dans l'entête avant le rechargement. Lorsqu'on se situe à la première étape de certains évènements, il est possible que la sauvegarde de la date ne survienne qu'à l'étape suivante (2).
                            var $dateEvenement = $('#frm-date-evenement').find('input[name="date_evenement"]');
                            if ($dateEvenement.length > 0 && $('#wizard').attr('date-evenement') !== undefined) {
                                $dateEvenement.val($('#wizard').attr('date-evenement'));
                            }
                        }
                    }
                    refreshDatatables();
                    if (listeFormulaires.length == 0) {
                        if (typeof (callback) !== 'undefined') {
                            var response = {};
                            response.reponse = 'ok';
                            callback(response);
                            wait.stop();
                        }
                    }
                };
                var messageToast = typeof (messageToastPerso) !== 'undefined' ? messageToastPerso : {};
                var rechargerPage = true;
                nbErreurs += sauvegarderDonnees($formulaireCourantTemp, url, async, dataType, params, etapeProcessusId, messageToast, nombreFormulaires, rechargerPage, callback, callbackSauvegarde);
            } else {
                if (typeof (callback) !== 'undefined') {
                    var response = {};
                    response.reponse = 'ok';
                    callback(response);
                    wait.stop();
                }
            }
            //}
        }


        /**
         * Fonction de sauvegarde des données d'un formulaire
         * @param {string} currentForm - Formulaire actuel.
         * @param {number} url - adresse utilisée pour le POST ou le PATCH.
         * @param {boolean} async - utilisé de manière synchrone (true) ou non (false).
         * @param {string} dataType - Json, html, etc.
         * @param {object} params - Une liste d'objets utilisé pour la sauvegarde des données.
         * @param {string} etapeProcessusId - Étape courante du wizard.
         * @param {object} messageToast - Objet qui contient les messages toast en cas de réussite ou d'échec.
         * @param {number} nombreFormulaires - Dans le contexte de plusieurs formulaires, on veut connaître sa position et le nombre total (provient de la fonction précédente.
         * @param {boolean} rechargerPage - Variable lancée par une fonction de sauvegarde d'étape afin de recharger une étape complète lorsque des formulaires doivent complètement être rechargés.
         * @param {string} callback - Erreur ou Réussite : Si on tente de fermer le modal, on retourne le résultat de l'exécution ('error', 'ok').
         * @param {object} callbackSauvegarde - Liste des fonctions à exécuter suite à la sauvegarde.
         * */
        function sauvegarderDonnees($formulaireCourant, url, async, dataType, params,
                                    etapeProcessusId, messageToast, nombreFormulaires,
                                    rechargerPage, callback, callbackSauvegarde) {
            // On sauvegarde la position et l'état des éléments dans la page du wizard (modal)
            var positions = positionCurseurWizard();

            var headersRequete = "";
            var typeRequete = 'POST';

            if ($formulaireCourant.attr('methode')) {
                typeRequete = $formulaireCourant.attr('methode');

                if ($formulaireCourant.attr('methode') != 'POST') {
                    headersRequete = {'X-HTTP-Method-Override': typeRequete};
                }
            }

            var jqxhr = $.ajax({
                headers: headersRequete,
                url: url,
                type: /*'POST'*/typeRequete,
                dataType: dataType,
                data: params,
                async: async
            });
            jqxhr
                .done(function (data, textStatus, jqxhr) {
                    var response = {};
                    if (typeof (data) != 'undefined') { // On a des données à ajouter au wizard, dans le cas du wizard.
                        if (data.wizard && !($.isEmptyObject(data.wizard))) { // On doit mettre à jour l'entête du wizard.
                            $.each(data.wizard, function (index, value) {
                                $('#wizard').attr(index, value);
                            });
                        }
                        if (typeof (data.attributs) != 'undefined') { // On a des données à ajouter au formulaire de l'étape courante.
                            $.each(data.attributs, function (index, value) {
                                $formulaireCourant.attr(index, value);
                            });
                        }
                    }
                    traitementPostSauvegarde($formulaireCourant);
                    erreursAjax.effacerErreurChamps($formulaireCourant);

                    // On recharge toutes les étapes subséquentes à l'étape sauvegardée pour réafficher les données mises à jour, dans le cas où l'étape 5, par exemple, a été chargée avant l'étape 3, qu'on vient tout juste de sauvegarder.
                    if ((data && data.methode !== 'undefined') && !(data && data.methode === 'DELETE')) { // Pour un delete, on efface son conteneur, et non recharge pas toute la page uniquement (trigger sur bouton supprimer)
                        var etapeActive = parseInt($('#modal-step-contents > .active').attr('data-step')); // Étape courante -1 (index)
                        var $etapesSubsequentes = $('#modal-step-contents [data-step]:gt(' + etapeActive + ')');
                        $etapesSubsequentes.attr('recharger', 'oui');
                    }

                    if (typeof (callbackSauvegarde) != 'undefined') {
                        callbackSauvegarde(data);
                    }
                    var noInit = rechargerPage || (data && typeof(data.methode) !== 'undefined' && data.methode !== 'DELETE') ? '' : 'noInit'; // On initialise le rechargement de l'étape uniquement sur la dernière opération de sauvegarde.

                    if (etapeProcessusId !== 0) {
                        if (messageToastCompteur === (nombreFormulaires - 1)) { // Comme on n'a pas encore incrémenté le compteur de messages, on enlève UN (1) pour la comparaison.
                            var etapeOrdre = $('#modal-step-contents > .active').attr('data-step');
                            setTimeout(function () {
                                // fenetreModal.redimentionnerModal(idModal, tailleModal, tailleEtape);
                                // On charge le contenu de l'étape active
                                if ($('#document-permis').find('.messages-erreurs').length === 0) {  // Hack poche parce que le formulaire des permis passe en double et que le chargement de l'étape efface les messages d'erreurs.
                                    chargerEtapeDynamique(etapeProcessusId, etapeOrdre, '', noInit, positions); // Si nous avons une vue, et non un template, on charge ici.
                                } else {
                                    var $cibleErreur = $('#modal-wizard-evenement').find('.messages-erreurs:first');
                                    if ($cibleErreur.length > 0) {
                                        var conteneurOffset = Math.abs($('#modal-step-contents > .active .contenu-principal').offset().top, 10);
                                        var scrollToErreur = $cibleErreur.offset().top - WIZARD_ENTETE.taille + conteneurOffset;
                                        $('#modal-step-contents').slimScroll({
                                            scrollTo: scrollToErreur,
                                            animate: true
                                        });
                                    }
                                    // }
                                    wait.stop();  // Nul besoin de se taper le spinner à l'écran.
                                }
                            }, 200); // ...avec animation.
                        }
                    }

                    if ($('.slimScrollDiv').length > 0) {
                        scroll.positionCurseurScroll($formulaireCourant, '#modal-step-contents');
                    }

                    if (typeof (callback) !== 'undefined') {
                        response.reponse = 'ok';
                        callback(response);
                    }
                    sauvegarderDonneesMessageToast(messageToast, nombreFormulaires, jqxhr, nbErreurs, callback);
                    messageToastCompteur += 1;
                    wait.stop();
                    // if(!async){
                    //     return nbErreurs;
                    // }
                });
            jqxhr
                .fail(function (jqxhr, textStatus, errorThrown) {
                    wait.stop();
                    wait.stop('contenu');
                    if (jqxhr.status >= 500) {
                        infos.ajouterMessageToast({
                            message: 'Une erreur s\'est produite. Contactez un administrateur.',
                            type: 'error',
                            messageDuree: 2000
                        });
                    } else {
                        erreursAjax.traiterErreurs($formulaireCourant, jqxhr, errorThrown);
                        $('.tooltip').remove();
                        nbErreurs += 1;

                        if (typeof (callback) !== 'undefined') {
                            var response = {};
                            response.reponse = 'error';
                            callback(response);
                        }
                        sauvegarderDonneesMessageToast(messageToast, nombreFormulaires, jqxhr, nbErreurs, callback);
                        messageToastCompteur += 1;
                    }
                });
            return nbErreurs;
        }


        /**
         * Fonction d'initialisation de l'étape de localisation des travaux du processus de permis.
         * */
        function initLocalisationTravauxPermis() {
            // On initialise l'outil de recherche récupéré de l'Explorateur uniquement si l'ue n'existe pas car sinon on montre l'info générale de l'ue sélectionnée
            var idEvenement = $('#wizard').attr('id-evenement');
            var ancienIdUe = $('#modal-step-contents > .active').attr('ancien-id-ue');
            if (idEvenement == '' || ancienIdUe != '') {
                $('#modal-recherche').attr('recharger', 'oui'); // En provenance de l'Explorateur d'UE, on doit recharger sinon les initialisations ne se font pas.
                init_explorateur_ue_partage();
            }

            $('#changer-ue-permis').on('click', function () {
                var etape = $('#modal-step-contents > .active');
                var etapeProcessus = etape.attr('data-id_processus');
                var etapeOrdre = etape.attr('data-step');
                etape.attr('recharger', 'oui');
                etape.attr('ancien-id-ue', $('#wizard').attr('id-ue')); // garder l'ancien id_ue pour effacer les étapes 3 et 5
                etape.attr('changer-ue-permis', 'True');
                $('button[data-type="save"]').prop("disabled", true); // On disable le bouton save

                wait.start('contenu', '255,255,255', 1);

                // On change certaines variables globales du wizard pour recharger l'étape en cours
                $('#wizard').attr('id-ue', '');

                chargerEtapeDynamique(etapeProcessus, etapeOrdre);
                wait.stop('contenu');
            });

        }

        /**
         * Fonction avant la sauvegarde de l'étape de localisation des travaux du processus de permis.
         * */
        function saveLocalisationTravauxPermisBefore(callback) {
            var changerUePermis = $('#modal-step-contents > .active').attr('changer-ue-permis') == 'True';
            if (changerUePermis) {
                if (validateLocalisationTravauxPermis() === true) {
                    let elementChecked = $('.step-pane.active #div-resultat').find('input:checked').parents('a');
                    let idx = 0;
                    let nouvelleUe = typeof ($(elementChecked[idx]).attr('id-ue')) === 'undefined' ? $(elementChecked[idx]).val() : $(elementChecked[idx]).attr('id-ue'); // Si l'UE n'est pas recherchée mais qu'une UE est entrée le champs Unité d'évaluation, on récupère non pas son attribut comme dans la liste de sélection des résultats de recherche mais sa valeur.
                    let vueParams = {
                        id_evenement: $('#wizard').attr('id-evenement'),
                        id_type_evenement: $('#wizard').attr('id-type-evenement'),
                        changer_ue_permis: true,
                        nouvelle_ue: nouvelleUe
                    };
                    fenetreModal.modalMessage({
                        enteteTitre: "Changer l'unité d'évaluation - UE " + nouvelleUe,
                        titre: "Confirmez-vous le changement d'unité d'évaluation ?",
                        texteExplicatif: "<strong>Attention!</strong> Cette action supprimera les informations déjà saisies aux étapes 3 et 5.",
                        vueACharger: '/gestion-roles/tenue-a-jour/permis/modale-changer-ue/',
                        vueAChargerParams: vueParams,
                        taille: 'immense',
                        sansX: true,
                        async: true,
                        init: function () {
                            let selecteurDate = $('#modal-message-alerte #frm-date-evenement').find('input[name="date_evenement"]');
                            let dateEvenementMinimum = $('#modal-message-alerte #frm-date-evenement').find('input[name="date_evenement_minimum"]')
                            selecteurDate.daterangepicker({
                                minDate: dateEvenementMinimum.val(),
                                autoUpdateInput: false,
                                parentEl: '.datepicker-container',
                                autoApply: true,
                                ranges: {
                                    "Aujourd'hui": [moment(), moment()]
                                },
                                showCustomRangeLabel: false
                            }).on('apply.daterangepicker', function (ev, picker) {
                                $(this).val(picker.startDate.format('YYYY-MM-DD'));
                                $(this).trigger('change');
                            }).next().on(ace.click_event, function () {
                                $(this).prev().focus();
                            });
                        },
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function () {
                                    wait.start('contenu');
                                    let selecteurDate = $('#modal-message-alerte #frm-date-evenement').find('input[name="date_evenement"]');
                                    $('#modal-step-contents > .active').attr('nouvelle-date-ue', selecteurDate.val());
                                    var params = [
                                        {name: 'id_evenement', value: $('#wizard').attr('id-evenement')},
                                        {name: 'ancien_id_ue', value: $('#modal-step-contents > .active').attr('ancien-id-ue')},
                                        {name: 'date_evenement', value: $('#wizard').attr('date-evenement')},
                                    ];
                                    $.ajax({
                                        type: "POST",
                                        url: '/gestion-roles/tenue-a-jour/effectuer-changement-ue/',
                                        data: params,
                                        dataType: 'json',
                                        async: false,
                                        success: function (response) {
                                            if (response.resultat) {
                                                $('#modal-step-contents > .active').removeAttr('ancien-id-ue');
                                            }
                                            var reponse = {};
                                            reponse.reponse = 'ok';
                                            callback(reponse);
                                        },
                                        error: function (jqxhr, textStatus, errorThrown) {
                                            nbErreurs += 1;
                                            wait.stop('contenu');
                                            var callback;
                                            sauvegarderDonneesMessageToast({}, 1, jqxhr, nbErreurs, callback);
                                            messageToastCompteur += 1;
                                        }
                                    });
                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                    wait.stop('contenu');
                                    var reponse = {};
                                    reponse.reponse = 'cancel';
                                    callback(reponse);
                                }
                            }
                        }
                    });
                } else {
                    var response = {reponse: 'error'};
                    callback(response);
                }
            } else {
                var reponse = {};
                reponse.reponse = 'pass';
                callback(reponse);
            }
        }

        /**
         * Fonction de sauvegarde de l'étape de localisation des travaux du processus de permis.
         * */
        function saveLocalisationTravauxPermis(callback) {
            checkEvenementFermePosterieurCycleOuvertEtSave(saveLocalisationTravauxPermis2, callback);
        }

        function saveLocalisationTravauxPermis2(callback) {

            // Si une ue a déjà été sauvegardée alors on ne permet plus la sauvegarde.
            // TODO: On devrait plutôt rafraichir la page lors de la sauvegarde pour afficher la page en mode read-only
            var idEvenement = $('#wizard').attr('id-evenement');
            var changerUePermis = $('#modal-step-contents > .active').attr('changer-ue-permis') == 'True';
            if (idEvenement === '') { // On permet la sauvegarde uniquement si aucune ue déjà sauvegardé
                if (validateLocalisationTravauxPermis() === true) {
                    saveEvenementParLocalisation(callback);
                } else {
                    var response = {reponse: 'error'};
                    callback(response);
                }
            } else if (idEvenement !== '' && changerUePermis) { // On permet la sauvegarde s'il y a déjà un évènement et qu'on a demandé de changer l'ue
                saveEvenementParLocalisation(callback, idEvenement);
           } else {
                if (typeof (callback) !== 'undefined') {
                    let response = {reponse: 'ok'};
                    callback(response);
                }
            }
        }

        /**
         * Fonction création des évènements suite à la validation de la localisation des travaux.
         * */
        function saveEvenementParLocalisation(callback, idEvenement) {
            var params = {};
            params.municipalite = $('#wizard').attr('id-municipalite');
            params.typeEvenement = $('#wizard').attr('id-type-evenement');
            if (params.typeEvenement == '1') {
                params.permis = $('#wizard').attr('id-processus');
            }
            if (params.typeEvenement == '2') {
                params.mutation = $('#wizard').attr('id-processus');
            }
            //Evenement de type Opération UE
            if (params.typeEvenement == '32') {
                params.operationUe = $('#wizard').attr('id-processus');
            }

            let dateEvenement;
            let nouvelleDateUe = $('#modal-step-contents > .active').attr('nouvelle-date-ue');
            if (nouvelleDateUe) {
                dateEvenement = nouvelleDateUe;
            } else {
                dateEvenement = $('#wizard').attr('date-evenement');
            }
            if (dateEvenement.length === 10) {
                dateEvenement += ' 15:00:00';
            }
            var evenementRemarque = $('#wizard').attr('evenement-remarque');
            params.date_evenement = dateEvenement;
            params.remarque = evenementRemarque;
            params.date_dernier_statut = moment().format('YYYY-MM-DD HH:mm:ss');
            params.etapeProcessus = $('#modal-step-contents > .active').attr('data-id_processus');
            params.statutEvenement = $('#wizard').attr('id-statut-evenement');
            params.changer_ue_permis = $('#modal-step-contents > .active').attr('changer-ue-permis') === 'True';

            // if ($("#creation-matricule").prop("checked")) {
            //
            // }

            erreursAjax.effacerErreurChamps($('#div-resultat'));
            messageToastCompteur = 0;

            var formPostMultiplesUes = $('#accordion-mutation-multiples-ues').find('[type="formulaire"][methode="POST"]');

            // Boucle de création des évènements en fonction des unités d'évaluation sélectionnées.
            var elementsChecked = $('.step-pane.active #div-resultat').find('input:checked').parents('a');
            var elements = elementsChecked.length > 0 ? elementsChecked : $('#exp-ue-id-ue').val != '' ? $('#exp-ue-id-ue') : [];
            $.each(elements, function (idx) {
                params.uniteEvaluation = typeof ($(elements[idx]).attr('id-ue')) === 'undefined' ? $(elements[idx]).val() : $(elements[idx]).attr('id-ue'); // Si l'UE n'est pas recherchée mais qu'une UE est entrée le champs Unité d'évaluation, on récupère non pas son attribut comme dans la liste de sélection des résultats de recherche mais sa valeur.

                // Sauvegarder les données de prix pour les multiples ues
                formPostMultiplesUes.find('[name="uniteEvaluation"]').filter(function () {
                    if ($(this).text() == params.uniteEvaluation) {
                        var form = $(this).closest('#mutation-multiples-ues-form');
                        params.prix_terrain = form.find('[name="prix_terrain"]').autoNumeric('get');
                        params.prix_batiment = form.find('[name="prix_batiment"]').autoNumeric('get');
                        params.prix_immeuble = form.find('[name="prix_immeuble"]').autoNumeric('get');
                        return false;
                    }
                });

                var url = '/gestion-roles/evenement/';
                var headers = {};
                var typeRequete = 'POST';

                if ((elements.length - 1 == idx && idEvenement)) {
                    typeRequete = 'PATCH';
                    params.id_evenement = $('#wizard').attr('id-evenement');
                    url += idEvenement + '/';
                    headers = {'X-HTTP-Method-Override': typeRequete};
                }

                $.ajax({
                    headers: headers,
                    type: typeRequete,
                    url: url,
                    async: false,
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        // On stocke le id_ue, id_evenement et autres paramètres du premier évènement créé pour la suite des étapes.
                        $('#wizard').attr('id-evenement', response.id_evenement);
                        if ($('#modal-wizard-evenement').find("#frm-date-evenement").length > 0) {
                            $('#modal-wizard-evenement').find("#frm-date-evenement").attr("id-model-instance", response.id_evenement);
                        }
                        if (response.wizard && !($.isEmptyObject(response.wizard))) {
                            $.each(response.wizard, function (index, value) {
                                $('#wizard').attr(index, value);
                            });
                        }
                        $('#wizard').attr('id-statut-evenement', response.statutEvenement);
                        $('#wizard').attr('id-ue', response.uniteEvaluation);
                        $('#wizard').attr('date-evenement', response.wizard['date-evenement']);
                        $('#wizard').removeAttr('remarque');

                        updateEnteteWizard();

                        // Seulement une fois insérée la dernière ue, on recharge l'étape pour montrer en mode read-only
                        if (elements.length - 1 === idx) {
                            // // commenter ce code pour le faire dans le save de l'appelant par l'attribut 'recharger' de l'étape
                            var etapeProcessus = $('ul.steps').find('li.active').attr('data-id_processus');
                            var etapeOrdre = $('ul.steps').find('li.active').attr('data-step');
                            var selecteur = '#modal-step' + etapeOrdre;
                            $(selecteur).attr('recharger', 'oui');
                            $('button[data-type="save"]').prop("disabled", true); // On disable le bouton save
                            chargerEtapeDynamique(etapeProcessus, etapeOrdre);
                            refreshDatatables();
                            $('#modal-step-contents > .active').removeAttr('changer-ue-permis');
                            $('#modal-step-contents > .active').removeAttr('nouvelle-date-ue');
                            var reponse = {reponse: 'ok'};
                            sauvegarderDonneesMessageToast({}, elements.length, reponse.reponse, 0);
                            if (typeof (callback) !== 'undefined') {
                                callback(reponse);
                            }
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        $('#div-resultat').parent().addClass('afficher-erreur');
                        var reponse = {reponse: 'error'};
                        try {
                            let erreurs = $.parseJSON(xhr.responseText);
                            $.each(erreurs, function (champ, valeur) {
                                erreursAjax.afficherErreurChamps($('#div-resultat').parent(), champ, valeur, xhr);
                            });
                            sauvegarderDonneesMessageToast({}, elements.length, reponse.reponse, 1);
                            messageToastCompteur += 1;
                        } catch {
                            infos.ajouterMessageToast({
                                message: "Une erreur s'est produite. Contactez un administrateur.",
                                messageDuree: 0
                            });
                        }
                        $('.tooltip').remove();
                        if (typeof (callback) !== 'undefined') {
                            callback(reponse);
                        }
                    }
                });
            });
        }

        /**
         * Fonction d'initialisation de l'étape planification d'inspection de permis.
         * */
        function initPlanificationInspectionPermis() {
            var $formulaire = $('#permis-ue-planification-planification');
            var $formTajDateInspection = $('#form-taj-date-inspection');
            var dateInspection = $formTajDateInspection.find('[name=date_prochaine_inspection]');
            var radios = $('[name="inspection-prevue"]');

            // disable this event since it's not expected to be fired
            dateInspection.on('keydown', function (e) {
                if (e.keyCode == 13) {
                    return false;
                }
            });

            $('input:radio').off('click').on('click', function () {
                clickRadio($(this), radios);
                enableDisableInspectionPrevue(this);
            });

            if ($('.steps').find('.active').attr('data-id_processus') === '4') {
                let radioOui = $('#radio_oui');
                if(!radioOui.hasAttr('disabled')){
                    // # #26285 Par défaut cocher oui.
                    radioOui.click();
                    let boolInspectionRequiseBd = $formTajDateInspection.find('[name=bool_inspection_requise_bd]').val();
                    if (boolInspectionRequiseBd === 'None') {
                        // forcer à cocher 'Oui' et forcer la sauvegarde de cette donnée
                        radioOui.closest('div[type="formulaire"]').attr('modifie', 'True');
                        $('#btn-wizard-save').prop('disabled', false);
                    }else if (boolInspectionRequiseBd === 'False') {
                        // sauf si explicitement présent en bd
                        $('#radio_non').click();
                    }
                }
            }

            // On initialise seulement les select2
            $('#permis-ue-planification-planification-toggle').find('select').select2();

            var options = {blocsContainer: $('#assigner-et-etat').closest('div')};
            initBlocsCharges(null, null, options);
        }

        function enableDisableInspectionPrevue(cible) {
            var enableDisable = (cible.id === 'radio_oui') ? '' : 'disabled';
            var $formTajDateInspection = $('#form-taj-date-inspection');
            var dateInspection = $formTajDateInspection.find('[name=date_prochaine_inspection]');
            if (enableDisable === 'disabled') {
                dateInspection.val('');
            }
            $('#form-taj-date-inspection').find('input').prop('disabled', enableDisable);
            $('#form-taj-assigne').find('input, textarea, select').prop('disabled', enableDisable);
            $('.wizard-id-ue').toggleClass('not-active', enableDisable === 'disabled');
        }


        /**
         * Détection des validations dynamique et arrimage aux champs.
         */
        function initDetectionValidationsDynamiquesFormulaires() {
            if ($('#modal-wizard-evenement').find('#validations_dynamiques').length === 1) {
                // pour chaque élément, on initialise l'action
                var currentModal = $('#modal-wizard-evenement');
                var validations = JSON.parse($('#validations_dynamiques').attr('value'));

                $.each(validations, function (champCle, champValeur) {
                    if ('champs_dependants_obligatoires' in champValeur) {
                        // Pour chaque dépendance (par exemple, si je modifie le champ X, on doit également modifier le champ Y immédiatement.
                        $.each(champValeur, function (dependanceCle, dependanceValeur) {
                            if (dependanceCle === 'champs_dependants_obligatoires') {
                                $.each(dependanceValeur, function (dependanceCleCle, dependanceCleValeur) {
                                    if (dependanceCleValeur.type_message === 'error') {
                                        $('#' + dependanceCleCle).parent('div').addClass('flash-message');
                                        $('#' + dependanceCleCle).addClass('champs_dependants_obligatoires');
                                        $('#modal-wizard-evenement').off('change', 'input[name=' + champCle + ']').on('change', 'input[name=' + champCle + ']', function () {
                                            if ($(this).hasClass('date-picker') && initializing_date_picker) {
                                                return;
                                            }

                                            $('#modal-wizard-evenement').find('.alert-danger').remove(); // On efface tous les messages.
                                            erreursAjax.afficherErreurChamps($('#accordion-saisie_et_validation_travaux'), dependanceCleCle, dependanceCleValeur.message, '');
                                            focusControle('#' + dependanceCleCle, 5);
                                            if ('action' in dependanceCleValeur) {
                                                var nomFonction = dependanceCleValeur.action.split('.');
                                                if (nomFonction.length > 1) {
                                                    window[nomFonction[0]][nomFonction[1]].apply(window);
                                                } else {
                                                    window[dependanceCleValeur.action].apply(window);
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }

        /**
         * Fonction d'initialisation de l'étape du rapport d'inspection.
         * */
        function initRapportInspection() {
            var nbDeplacementBloque = 0;

            $('#accordion-saisie_et_validation_travaux').find('select').select2();

            /**
             * Détection du clic sur le type d'évènement (bouton "Ajouter un type d'évènement") vers lequel déplacer les natures et/ou les types sélectionnés.
             * */
            $('#inspection-types-evenements-liste').on('click', '.btn-tj-ajouter-type-evenement', function () {
                var AjouterPLusieursEvenementsMemeTypeSauf = ['Permis'];
                var destination = $(this).text();
                var destinationTitre = nettoyerTitre(destination);
                var dataTitre = '[data-titre^="' + destinationTitre + '"]';
                var existePlusieursTypes = $('#inspection-rapport').find(dataTitre).length;
                if (existePlusieursTypes === 0 || (AjouterPLusieursEvenementsMemeTypeSauf.indexOf(destination) < 0)) {
                    // if (existePlusieursTypes === 0) {
                    var destinationTypeId = $(this).attr('value');
                    COMPTEUR_EVENEMENT += 1;
                    var inspection = 'inspection-type_evenement-';
                    var destinationNouveau = inspection + destinationTypeId + '-evenement-' + 'nouveau_' + COMPTEUR_EVENEMENT;
                    var selecteur = $('#inspection-type_evenement-vide');
                    var contenuFormulaire = selecteur.val();
                    // Définir ici toutes les options du formulaire
                    // contenuFormulaire = contenuFormulaire.replace(/%titre_evenement/g, (existePlusieursTypes !== 0 ? destination + ' (Nouveau ' + COMPTEUR_EVENEMENT + ')' : destination));
                    contenuFormulaire = contenuFormulaire.replace(/%titre_evenement/g, (destination + ' (Nouveau)'));
                    // contenuFormulaire = contenuFormulaire.replace(/template_nouveau_type_evenement/g, (existePlusieursTypes !== 0 ? destinationNouveau : destinationId));
                    contenuFormulaire = contenuFormulaire.replace(/template_nouveau_type_evenement/g, (destinationNouveau));
                    $('#inspection-types-evenement').find('.col-xs-12:first').append(contenuFormulaire);
                    fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                    chargerTypeEvenementListeDeplacer();
                    chargerTypeEvenementListeToutDeplacer();
                    $('[data-type="unite-details"]').find('input.checktaj:checked').closest('[data-type="unite-details"]').find('[data-action="btn-tj-inspection-deplacer"]').prop("disabled", false);
                    // on remet le champ date_evenement actif car il peut être désactivé dans le cas que l'évènement en cours est une enquête de vente
                    $('#' + destinationNouveau).find('[name="date_evenement"]').prop('disabled', false);
                    init_date_picker();
                    masquesSelection.init();

                    // Pour le rapport d'inspection, on doit détecter les évènements à "none", ie, les natures et les types de travaux qui ont été affiché par requête SQL
                    // en détection à modifications à des blocs dans la fiche non prévues au permis et qui nécessitent l'ajout d'un évènement (correction mineur, ajustement d'inventaire, etc).
                    // On tag ces nouveaux types et nature à modifier=true et on active le bouton "sauvegarder" de l'étape.
                    $('#inspection-types-evenement').find('[type="formulaire"]').find('[id-model-instance="None"]').attr('modifie', 'True');
                }
            });

            /**
             * Détection du clic sur le type d'évènement (bouton "Déplacer tout ... vers") vers lequel déplacer les natures et/ou les types sélectionnés. Simple boucle sur tous les bâtiments et travaux
             * */
            $('#inspection-rapport').on('click', '.btn-tj-inspection-tout_deplacer-action', function () {
                // Liste de tous les liens déplacer vers à déclencher
                var type_evenement = $(this).attr("id");
                var liste_liens_deplacer_vers = $(this).closest('div.panel-body').find('button[data-action="btn-tj-inspection-deplacer"]');
                // Activer les boutons Déplacer vers
                $(this).closest('div.panel-body').find('button[data-action="btn-tj-inspection-deplacer"]').prop("disabled", false);
                // Tout cocher.
                $(this).closest('div.panel-body').find('input.checktaj').prop("checked", true).change();
                // Boucler sur les éléments à déplacer.
                wait.start('contenu');
                $.each(liste_liens_deplacer_vers, function (index, value) {
                    var element = $(value).closest('div.btn-group').find('a.btn-tj-inspection-deplacer-action#' + type_evenement);
                    executerDeplacerTravaux(element);
                });
                wait.stop('contenu');
                afficherMessageDeplacementBloque();

            });

            function executerDeplacerTravaux(elementClique) {
                // Aussitot ce bouton utilisé, on ne fait plus de update dans les tables des natures et des types de travaux, parce qu'on ne track pas les changements :
                // on efface en bloc et et réinsère le contenu des formulaires dans la BD en une seule transaction.
                $('#inspection-types-evenement').attr('mouvement', 'True');
                // Comme on ne sait pas ce qui a été changé, on tag tous les formulaires Nature/Travaux.
                $('#inspection-types-evenement').find('[type="formulaire"][data-type^="inspection-batiment-nature"]').attr('modifie', 'True');
                var bufferSupprimer = []; // Utilisé si la cible contient déjà des éléments qu'on souhaite déplacer.
                var accordionDestinationId = 'accordion-' + elementClique.attr('id'); // On utilise l'accordéon comme point de départ de la recherche. Il ne devrait jamais y avoir deux accordéons pareils, deux types d'évènements pareils.
                var elementsChoisis = elementClique.closest('[data-type=unite-details]').find('input.checktaj:checked');

                // On itère sur chacun des éléments à déplacer
                $.each(elementsChoisis, function (index, value) {
                    var id = $(value).closest('[type=formulaire]').attr('id');
                    var indexNatureAvecIdentifiantDecalage = id.indexOf('identifiant_nature') > 0 ? 2 : 0; // Utilisé pour déplacer l'index lors de la construction des strings et de la récupération des valeurs
                    var indexTravauxAvecIdentifiantDecalage = id.indexOf('identifiant_travaux') > 0 ? 2 : 0;
                    var indexTypeEvenementsMultiplesDecalage = id.indexOf('identifiant_type_multiple') > 0 ? 1 : 0;
                    var nom = $(value).closest('[type=formulaire]').text();
                    nom = nettoyerTitre(nom);
                    var idDestination = id; // Utilisé pour vérifier l'existence ou la non existence de l'élément de la destination sélectionnée avec le bouton "Déplacer vers" (id_evenement, id_type_evenement différents).
                    var idPrecedent = $(value).parents('[type=formulaire]:last').find('.titre' + ':first');
                    var elementsChoisisOriginalId = $(value).attr('id');
                    var elementsChoisisOriginalCourant = id;
                    var elementsChoisisOriginalParent = $('#' + id).parents('[type=formulaire]').attr('id');
                    var formulaireTemp = idDestination.split('-');
                    var sousBlocsSourceTemp = formulaireTemp.slice(0);
                    var idEvenementDestination = accordionDestinationId.split('-')[5 + indexTypeEvenementsMultiplesDecalage];
                    formulaireTemp.splice(2, 1, accordionDestinationId.split('-')[3 + indexTypeEvenementsMultiplesDecalage]); // Remplacement du type d'évènement.
                    formulaireTemp.splice(4, 1, idEvenementDestination); // Remplacement du id_evenement.
                    // convertir en int pour vérifier le idEvenementDestination dans la liste des évènements bloqués de chaque nature ou travaux
                    idEvenementDestination = parseInt(idEvenementDestination) || 0;
                    idDestination = formulaireTemp.join('-');
                    var arrayIdEvenementBloque = JSON.parse($(value).closest('[type=formulaire]').attr('id-evenement-bloque'));
                    var estDeplacementAutorise = $.inArray(idEvenementDestination, arrayIdEvenementBloque) == -1;
                    if (!estDeplacementAutorise) {
                        nbDeplacementBloque += 1;
                    }

                    var elementNature = $(value).closest('[type=formulaire]').filter('[data-type="inspection-batiment-nature"]');
                    var estElementNature = elementNature.length > 0;
                    var peutCopierNature = false;
                    if (estElementNature) {
                        var travauxSurNature = elementNature.find('[data-type="inspection-batiment-nature-type"]');
                        if (travauxSurNature.length == 0) {
                            peutCopierNature = $.inArray(idEvenementDestination, JSON.parse(elementNature.attr('id-evenement-bloque'))) == -1;
                        } else {
                            peutCopierNature = travauxSurNature.filter(function () {
                                return $.inArray(idEvenementDestination, JSON.parse($(this).attr('id-evenement-bloque'))) == -1;
                            }).length > 0;
                        }
                    }

                    if ($(value).closest('[type=formulaire]').attr('bool_demande_originale') === 'True') {
                        var clone = $(value).closest('[type=formulaire]').first().clone(true, true).prop('id', idDestination).html(function (i, oldHTML) {
                            return oldHTML.replace(new RegExp(id, 'g'), idDestination);
                        });
                        if ($('#' + id).attr('effacer') !== 'true') {
                            var idInput = formulaireTemp.slice(0).splice(1).join('-');
                            // On remplace les ID pour les childs aussi si nécessaire
                            if ($('#' + idDestination).length === 0) {
                                clone.find('[data-name=description_a_revoir]').attr('id', idInput + '-' + clone.closest('[type=formulaire]').find('[data-name=description_a_revoir]').attr('data-name'));
                                var listeInput = clone.closest('[type=formulaire]').find('input, textarea').not('.checktaj');
                                clone.closest('[type=formulaire]').find('[data-name=description_a_revoir]').attr('id', idInput + '-' + clone.closest('[type=formulaire]').find('[data-name=description_a_revoir]').attr('data-name'));
                                $.each(listeInput, function (key, valeur) {
                                    $(valeur).attr('id', idInput + '-' + $(valeur).attr('name'));
                                });
                                clone.closest('[type=formulaire]').find('input.checktaj').attr('id', idInput + '-checktaj');
                            }
                        }
                    } else {
                        var $cibleCachee = $('#del-' + id);
                        if ($cibleCachee.length == 0 && estDeplacementAutorise) {
                            // On ne crée pas un élément qui existe déjà dans les formulaires cachés à supprimer
                            $('#inspection-types-evenement').append('<input type="hidden" index="' + index + '" id="del-' + id + '" class="inspection-nature-travaux-a-supprimer">');
                            $cibleCachee = $('#del-' + id);
                            var sourceAttributs = $(value).closest('[type=formulaire]').prop("attributes"); // Liste d'attibuts pour créer le input hidden
                            $.each(sourceAttributs, function () {
                                if (!(this.name == "class" || this.name == "type" || this.name == "id")) {
                                    $cibleCachee.attr(this.name, this.value);
                                }
                            });
                        }
                    }
                    if ($('#' + idDestination).length > 0 && ($('#' + id).attr('bool_demande_originale') !== 'True') && estDeplacementAutorise) {
                        $('#' + idDestination).attr('date_evenement_initiale', $('#' + id).attr('date_evenement_initiale'));
                        $('#' + id).attr('effacer', true); // On ne recopie pas un élément qui existe déjà dans la destination.
                        bufferSupprimer.push(id);
                    }
                    var cibleExisteElementOriginal = formulaireTemp.slice(0).splice(0, formulaireTemp.length - indexTravauxAvecIdentifiantDecalage).join('-'); // On peut avoir un type ou une nature existante et que l'identifiant les différencie dans la destination. Par exemple, fondation, et fondation - Rénovation 2006. Puisqu'on reconstruit sur le parent, on doit en tenir compte ici.
                    if (!(($('#' + idDestination).length > 0) && ($('#' + id).attr('bool_demande_originale') === 'True'))) {
                        var rechercherDestination = idDestination;
                        var rechercheArray = idDestination.split('-');
                        if (rechercherDestination === id ||
                            ((estElementNature && !peutCopierNature) || !estDeplacementAutorise)) {
                            $(value).prop('checked', false);
                            $(value).closest('[data-type=unite-details]').find('[data-action="btn-tj-inspection-deplacer"]').prop("disabled", true);
                            return;
                        } else {
                            for (var i = (rechercheArray.length); i >= 3; i -= 2) {
                                if (($('#' + accordionDestinationId).find('[id^=' + rechercherDestination + ']').length > 0) && ($('#' + accordionDestinationId).find('[id$=' + rechercherDestination + ']').length > 0)) { // On cherche une correspondance entre le début de la string de recherche et le début du ID. Si on a une correspondance sur la première recherche, c'est parce que l'élément existe déjà. Sinon, on réduit la chaîne de recherche et on recréera les types, batiments ou terrains, nature ou type nécessaires en fonction de la différence entre la recherche rechercherDestination et le iDDestination.
                                    // NOTE : id^=' + rechercherDestination peut nous retourner des résultats similaires pour ...nature=1 et nature=11, d'où la condition && étant donné qu'il s'agit d'une correspondance de début de string de recherche. On doit également s'assurer que ce qu'on recherche est aussi une fin de string.
                                    // On crée ce qui manque : différence entre rechercherDestination et idDestination.
                                    var constructionArray = rechercheArray;
                                    var constructionDestination = rechercherDestination;
                                    var selecteur = '';
                                    var cible = '';
                                    for (var j = rechercheArray.length; j <= formulaireTemp.length; j += 2) {
                                        if (((formulaireTemp.length - indexNatureAvecIdentifiantDecalage - indexTravauxAvecIdentifiantDecalage) - constructionArray.length) > 2) { // Si on a différence nulle c'est parce qu'on n'a pas besoin de refaire le niveau précédent.
                                            cible = constructionArray[(constructionArray.length - 2)];
                                            if (cible === 'type_evenement') {
                                                // ajouter un evenement
                                                selecteur = $('#inspection-type_evenement-vide');
                                            } else if (cible === 'evenement') {
                                                // ajouter bâtiment
                                                // Si on ajoute un bâtiment qui n'était pas présent, on affiche pour tous les autres cas et on l'ajoute aux autres formulaires.
                                                if ($('#' + constructionDestination + '-evenement-vide')) {
                                                    $('#' + constructionDestination + '-evenement-vide' + ':contains("Aucun élément pour cet évènement")');

                                                    // DM 2017-07-05
                                                    // $('#' + constructionDestination + '-batiment-None').empty();
                                                }
                                                selecteur = $('#inspection-type_evenement-batiment-vide');
                                                var id_type_batiment_deplace = $(this).closest('[data-type=unite-details]').attr('data-id_type_batiment');
                                            } else if (cible === 'batiment') {
                                                // ajouter un nature
                                                selecteur = $('#inspection-type_evenement-batiment-nature-vide');
                                            } else if (cible === 'nature') {
                                                // ajouter un type
                                                selecteur = $('#inspection-type_evenement-batiment-nature-type-vide');
                                            }
                                        }

                                        if (selecteur != '') { // On doit reconstruire un niveau précédent avant de faire un append : on a besoin d'une nature pour faire un append d'un type.
                                            if ($('#' + id).attr('effacer') !== 'true') {
                                                var contenuFormulaire = selecteur.val();
                                                var niveauActuel = constructionArray.length + 2;
                                                constructionArray = formulaireTemp.slice(0, niveauActuel /*+ indexNatureAvecIdentifiantDecalage*/);
                                                constructionDestination = constructionArray.join('-');
                                                // On utilise le dictionnaire d'exclusions afin de désactiver les inputs définis ainsi.
                                                let exclusions = $.parseJSON($('#inspection_bool_exclusions').val());
                                                $.each(exclusions, function (index, value) {
                                                    if ('disabled' in value) {
                                                        var ajouterNom = 'name="' + index + '"';
                                                        contenuFormulaire = contenuFormulaire.replace(ajouterNom, 'destinationId');
                                                    }
                                                });
                                                contenuFormulaire = contenuFormulaire.replace(/template_nouveau_type_evenement/g, accordionDestinationId);
                                                contenuFormulaire = contenuFormulaire.replace(/template_nouveau_batiment/g, rechercherDestination);
                                                contenuFormulaire = contenuFormulaire.replace(/template_id_type_evenement/g, constructionArray[2]);
                                                contenuFormulaire = contenuFormulaire.replace(/template_id_evenement/g, constructionArray[4]);
                                                contenuFormulaire = contenuFormulaire.replace(/template_id_batiment/g, constructionArray[6]);
                                                contenuFormulaire = contenuFormulaire.replace(/template_id_type_batiment/g, $(value).closest('[data-type=unite-details]').attr('data-id_type_batiment'));
                                                contenuFormulaire = contenuFormulaire.replace(/%hide_description_a_revoir/g, 'hidden');
                                                var contenuFormulaireAvecIdentifiantNature = (indexNatureAvecIdentifiantDecalage > 0 ? '-identifiant_nature-' + sousBlocsSourceTemp[3 + indexNatureAvecIdentifiantDecalage] : '');
                                                var contenuFormulaireAvecIdentifiantTravaux = (indexTravauxAvecIdentifiantDecalage > 0 ? '-identifiant_nature-' + sousBlocsSourceTemp[5 + indexNatureAvecIdentifiantDecalage] : '');
                                                contenuFormulaire = contenuFormulaire.replace(/template_id_nature/g, sousBlocsSourceTemp[3]);
                                                contenuFormulaire = contenuFormulaire.replace(/template_id_travaux/g, sousBlocsSourceTemp[5 + indexNatureAvecIdentifiantDecalage] + contenuFormulaireAvecIdentifiantTravaux);
                                                contenuFormulaire = contenuFormulaire.replace(/template_batiment_id/g, constructionDestination); // on remplace par le niveau actuel : constructionArray + 2
                                                contenuFormulaire = contenuFormulaire.replace(/template_nature_id/g, constructionDestination + contenuFormulaireAvecIdentifiantNature); // on remplace par le niveau actuel : constructionArray +
                                                var contructionInputsDestinationArray = constructionDestination.split('-');
                                                var contructionInputsDestination = contructionInputsDestinationArray.slice(1, contructionInputsDestinationArray.length).join('-');
                                                contenuFormulaire = contenuFormulaire.replace(/template_nature_inputs_id/g, contructionInputsDestination);
                                                var nomPrecedent;
                                                var constructionDestinationArrayTemp;
                                                var rechercheDestinationAjuste;
                                                if (cible === 'evenement') {
                                                    $('#accordion-' + rechercherDestination).find('.panel-body').append(contenuFormulaire);
                                                    // Pour le bénéfice de la fonction sp_calcul_batiment, on doit recopier data-id_type_batiment
                                                    if (typeof (id_type_batiment_deplace) !== undefined) {
                                                        $('#' + constructionDestination).attr('data-id_type_batiment', id_type_batiment_deplace);
                                                    }

                                                    var idBatiment = constructionArray[6];
                                                    $('#' + constructionDestination).find('.batiment-entete-bootstrap').text('Bâtiment ' + idBatiment);
                                                } else if (cible === 'batiment') {
                                                    nomPrecedent = nettoyerTitre(idPrecedent.text());
                                                    contenuFormulaire = contenuFormulaire.replace(/template_nature_nom/g, nomPrecedent);
                                                    if (rechercheArray[rechercheArray.length - 2] === 'evenement') { // On a ajouté un batîment, mais la référence pointe toujours sur l'évènement. Comme il n'y a pas de formulaire pour l'évènement, on utilise tout de suite le bâtiment. Donc, c'est ici qu'on ajuste temporairement la cible. Le tout rentre dans l'ordre aussitôt que la boucle revient sur cible batiment et que rechercheArray[rechercheArray.length -2] === 'batiment'.
                                                        constructionDestinationArrayTemp = formulaireTemp.slice(0, niveauActuel - 2);
                                                        rechercheDestinationAjuste = constructionDestinationArrayTemp.join('-');
                                                        var boolOriginalEvenementTemp = id.split('-')[4];
                                                        if ($('#' + elementsChoisisOriginalParent).attr('bool_demande_originale') === 'True') {
                                                            $('#' + constructionDestination).append('<input name="id_evenement_parent" type="hidden" value=" ' + boolOriginalEvenementTemp + '" >');
                                                        }
                                                        rechercherDestination = rechercheDestinationAjuste;
                                                        rechercheArray = constructionDestinationArrayTemp;
                                                        if (indexNatureAvecIdentifiantDecalage > 0) {
                                                            formulaireTemp.splice(7 + indexNatureAvecIdentifiantDecalage, indexNatureAvecIdentifiantDecalage); // On retire l'identifiant de la nature, du calcul, sinon la comparaison entre la recherche et la reconstruction d'un type d'évènement
                                                        }
                                                    }

                                                } else if (cible === 'nature') {
                                                    contenuFormulaire = contenuFormulaire.replace(/template_nature_type_id/g, constructionDestination); // on remplace par le niveau actuel : constructionArray +
                                                    nomPrecedent = nettoyerTitre(idPrecedent.text());
                                                    constructionDestinationArrayTemp = formulaireTemp.slice(0, niveauActuel - 2);
                                                    rechercheDestinationAjuste = constructionDestinationArrayTemp.join('-');
                                                    contenuFormulaire = contenuFormulaire.replace(/template_nature_nom/g, nomPrecedent);
                                                }

                                                if ($(value).closest('[type=formulaire]').attr('bool_demande_originale') === 'True') { // S'il s'agit de la demande originale enregistrée sur le permis, on conserve toujours les travaux originaux. On fait simplement une copie vide.
                                                    if (cible === 'batiment') {
                                                        collerContenuFormulaireTravaux(rechercherDestination, contenuFormulaire);
                                                        if ($('#' + constructionDestination).find('[type="formulaire"]').length > 0) { // dans le cas où la nature contient des types, on cache le champ «Coût réel»
                                                            $('#' + contructionInputsDestination + '-cout_reel').attr('type', 'hidden');
                                                        }
                                                    }
                                                } else {
                                                    if (!(indexNatureAvecIdentifiantDecalage === 0 && indexTravauxAvecIdentifiantDecalage === 0) && cible !== 'evenement') {
                                                        collerContenuFormulaireTravaux(rechercherDestination, contenuFormulaire);
                                                    } else { // Si l'identifiant est trouvé et qu'on se trouve au niveau du type, on faire un append sur la nature et non sur le type.
                                                        if (indexTravauxAvecIdentifiantDecalage > 0 && cible !== 'evenement') {
                                                            constructionArray.splice(-indexTravauxAvecIdentifiantDecalage, indexTravauxAvecIdentifiantDecalage);
                                                            constructionDestination = constructionArray.join('-');
                                                            collerContenuFormulaireTravaux(rechercherDestination, contenuFormulaire);
                                                        }
                                                        if (cible === 'nature') {
                                                            $('#' + idDestination).attr('data-id_nature_evenement_x_batiment', $('#' + rechercherDestination).attr('data-id_nature_evenement_x_batiment'));
                                                            collerContenuFormulaireTravaux(rechercherDestination, '#' + idDestination, constructionDestination + contenuFormulaireAvecIdentifiantNature);
                                                        } else {
                                                            if ($('#' + constructionDestination).length === 0) {
                                                                collerContenuFormulaireTravaux(rechercherDestination, contenuFormulaire);
                                                            }
                                                        }
                                                    }
                                                }

                                                selecteur = '';
                                            }
                                        } else if (formulaireTemp[formulaireTemp.length - 4 - ($('#' + cibleExisteElementOriginal).length > 0 ? 0 : indexTravauxAvecIdentifiantDecalage + (indexNatureAvecIdentifiantDecalage + indexNatureAvecIdentifiantDecalage))] === constructionArray[(constructionArray.length - 2 - indexNatureAvecIdentifiantDecalage)]) { // On utilise l'élément précédent pour faire un append.
                                            if ($('#' + id).attr('effacer') !== 'true') {
                                                $(this).closest('[data-type=unite-details]').find('[data-action="btn-tj-inspection-deplacer"]').prop("disabled", true);
                                                $('#' + elementsChoisisOriginalId).addBack().closest('[type="formulaire"]').find('input.checktaj:checked').prop('checked', false);
                                                if (($(this).closest('[type=formulaire]').attr('bool_demande_originale') === 'True') && ($('#' + idDestination).length === 0)) {
                                                    collerContenuFormulaireTravaux(rechercherDestination, clone, constructionDestination);
                                                    // Dans le cas précis d'un clone, on doit initialiser certains filtres et format
                                                    $('#' + idDestination).find('input.money').each(function () {
                                                        $(this).val($(this).val().replace(/\D/g, ''));
                                                    });
                                                    $('#' + id).find('.checktaj').prop('checked', false);
                                                    $('#' + idDestination).find('.checktaj').prop('checked', false);
                                                    $('#' + idDestination).find('[type="formulaire"]').attr('bool_demande_originale', 'False');
                                                    // Si le parent a un id_nature_evenement_x_batiment, on le copie.
                                                    var natureEvenementXBatiment = $('#' + rechercherDestination).attr('data-id_nature_evenement_x_batiment');
                                                    if (natureEvenementXBatiment !== '' && typeof (natureEvenementXBatiment) !== 'undefined') {
                                                        $('#' + idDestination).attr('data-id_nature_evenement_x_batiment', natureEvenementXBatiment);
                                                    }
                                                    nettoyerBoolDemandeOriginal($('#' + idDestination).find('input.checktaj').first()[0], boolOriginalEvenementTemp);
                                                } else {
                                                    if ($('#' + idDestination).length === 0) {
                                                        var memeTypeTravaux = $('#' + rechercherDestination).attr('data-type') == 'inspection-batiment-nature-type' &&
                                                            $('#' + id).attr('data-type') == 'inspection-batiment-nature-type';
                                                        if (memeTypeTravaux) {
                                                            // si le id source est un type de travaux et que la destination est aussi un type de travaux
                                                            // alors, reculer au niveau 'nature' pour ajouter le type de travaux
                                                            constructionArray.splice(-2, 2);
                                                            constructionDestination = constructionArray.join('-');
                                                        }
                                                        collerContenuFormulaireTravaux(rechercherDestination, '#' + id, constructionDestination);
                                                        constructionDestinationArrayTemp = formulaireTemp.slice(1, 5);
                                                        rechercheDestinationAjuste = constructionDestinationArrayTemp.join('-');
                                                        var constructionSourceArrayTemp = elementsChoisisOriginalCourant.split('-').slice(1, 5);
                                                        var constructionSourceTemp = constructionSourceArrayTemp.join('-');
                                                        var elementsChoisisOriginalEvenementRegex = new RegExp(constructionSourceTemp, "g");
                                                        $('#' + id).html($('#' + id).html().replace(elementsChoisisOriginalEvenementRegex, rechercheDestinationAjuste));
                                                        $('#' + id).attr('id', idDestination);
                                                        $('#' + idDestination).find('input.money').each(function () {
                                                            $(this).val($(this).val().replace(/\D/g, ''));
                                                            // formaterMonnaie($(this), 0);
                                                        });
                                                        // Si le parent a un id_nature_evenement_x_batiment, on le copie.
                                                        var natureEvenementXBatiment = $('#' + rechercherDestination).attr('data-id_nature_evenement_x_batiment');
                                                        if (natureEvenementXBatiment !== '' || typeof (natureEvenementXBatiment) !== 'undefined') {
                                                            $('#' + idDestination).attr('data-id_nature_evenement_x_batiment', natureEvenementXBatiment);
                                                        }
                                                        let exclusions = $.parseJSON($('#inspection_bool_exclusions').val());

                                                        if ($('#' + rechercherDestination).attr('bool_demande_originale') === 'True') {
                                                            // si la destination fait partie de la demande originale
                                                            // alors, ajouter les 2 étoiles sur le id copié, changer quelques attributs et supprimer le type de travaux originale
                                                            $('#' + idDestination).find('.type-travaux-description').parent().append('<span class="demande-originale">**</span>');
                                                            $('#' + idDestination).attr('bool_demande_originale', 'True');
                                                            if (memeTypeTravaux) {
                                                                $('#' + idDestination).attr('methode', 'PATCH');
                                                                $('#' + idDestination).attr('id-model-instance', $('#' + rechercherDestination).attr('id-model-instance'));
                                                                $('#' + rechercherDestination).remove();
                                                            }
                                                        }
                                                    }
                                                }
                                                $(value).prop("checked", false);
                                                j = 1000;
                                            }
                                        }
                                    }
                                    $(value).closest('[type=formulaire]').find('.checktaj').prop("checked", false);
                                    i = 2; // On doit forcer la sortie de la boucle sinon on dupliquerait le bâtiment.
                                } else {
                                    rechercheArray.splice(-2, 2);
                                    rechercherDestination = rechercheArray.join('-');
                                }
                            }
                            // On détruit les évènements existants pour le format monétaire et on les recrée.
                            //$('#modal-wizard-evenement').find('input.money').autoNumeric('destroy');
                            // inspection-type_evenement-1-evenement-112554-batiment-720214-nature-2-type-1 (source)
                            // inspection-type_evenement-3-evenement-112553-batiment-720214-nature-2-type-1 (destination)
                            // inspection-type_evenement-3-evenement-112553-batiment-720214
                            // formaterMonnaie($('#modal-wizard-evenement').find('input.money'), 0);
                        }
                    } else {
                        $('#' + elementsChoisisOriginalId).prop('checked', false); // On décoche l'élément de la demande originale, toujours coché suite à la duplication.
                        $(this).closest('[data-type=unite-details]').find('[data-action="btn-tj-inspection-deplacer"]').prop("disabled", true);
                    }
                });
                $.each(bufferSupprimer, function (key, value) {
                    $('#' + value).remove();
                });
                chargerTypeEvenementListeDeplacer();
                chargerTypeEvenementListeToutDeplacer();
                $('#modal-wizard-evenement').find('input.money').autoNumeric('destroy');
                formaterMonnaie($('#modal-wizard-evenement').find('input.money'), 0);
            }


            /**
             * Détection du clic sur le type d'évènement (bouton "Déplacer vers") vers lequel déplacer les natures et/ou les types sélectionnés.
             * */
            $('#inspection-rapport').on('click', '.btn-tj-inspection-deplacer-action', function () {
                executerDeplacerTravaux($(this));
            });

            function afficherMessageDeplacementBloque() {
                if (nbDeplacementBloque > 0) {
                    nbDeplacementBloque = 0;
                    infos.ajouterMessageToast({
                        message: "Certains déplacements n'ont pas été exécutés car l'élément existe déjà dans l'évènement de destination",
                        messageDuree: 0,
                        icone: 'fa-exclamation-triangle',
                        iconeCouleur: 'orange'
                    });
                }
            }

            /**
             * Fonction utilisée pour dupliquer un travaux et/ou son parent lorsque bool_demande_original est True
             * @param {string} value - id du checkbox courant
             * @param {number} idEvenement
             * */
            function nettoyerBoolDemandeOriginal(value, idEvenement) {
                var $selecteurOriginal = $(value).closest('[type=formulaire]');
                $selecteurOriginal.closest('[type=formulaire]').find('[type=formulaire][modifie="True"]').addBack('[type=formulaire]').attr('methode', 'POST');
                $selecteurOriginal.closest('[type=formulaire]').find('[type=formulaire][modifie="True"][bool_demande_originale="True"]').addBack('[type=formulaire]').attr('id-model-instance', 'None');
                if ($selecteurOriginal.attr('data-id_nature_evenement_x_batiment')) {
                    $selecteurOriginal.attr('data-id_nature_evenement_x_batiment', '');
                }
                if ($selecteurOriginal.attr('data-id_nature_evenement_x_evenement')) {
                    $selecteurOriginal.attr('data-id_nature_evenement_x_evenement', '');
                }
                $selecteurOriginal.closest('[type=formulaire]').find('[type=formulaire][modifie="True"]').addBack('[type=formulaire]').attr('bool_demande_originale', 'False');
                $selecteurOriginal.find('.demande-originale').remove();
                $selecteurOriginal.find('input.checktaj').attr('checked', false);
                $selecteurOriginal.append('<input name="id_evenement_parent" type="hidden" value="' + idEvenement + '" >');
            }


            function collerContenuFormulaireTravaux(rechercheDestinationAjuste, contenuFormulaire, constructionDestination) {
                var cible = constructionDestination ? constructionDestination : rechercheDestinationAjuste;
                if ($('#' + cible).find('.plusieurs-batiments').length > 0) {
                    if ($('#' + cible).find('.plusieurs-batiments').length > 0) {
                        $('#' + cible).find('.plusieurs-batiments').append($(contenuFormulaire));
                    } else {
                        $('#' + rechercheDestinationAjuste).find('.plusieurs-batiments').append($(contenuFormulaire));
                    }
                } else {
                    //$('#' + cible).append(contenuFormulaire);
                    $('#' + cible).append($(contenuFormulaire));
                }
                // On se déplacer dans le wizard pour afficher le résultat de la copie.
                // Presuppose que la copie est toujours dans le contexte d'un modal wizard : $('#modal-step-contents').
                var scrollTo_val = $('#' + cible).prop('scrollHeight') + 'px';
                $('#modal-step-contents').slimScroll({scrollTo: scrollTo_val, animate: true});

                /*var rechercheArray = rechercheDestinationAjuste.split('-');
             rechercheArray.splice(5);
             $('#'+rechercheArray.join('-')+'-evenement-vide').remove();*/
            }


            $('#inspection-rapport').on('change', '.checktaj', function () {
                selectCheckUncheck(this);
            });


            $('#inspection-rapport').on('change', '.bool_travaux_completes', function () {
                selectCheckUncheck(this);
            });


            $('#inspection-rapport').on('change', '.bool_travaux_a_revoir', function () {
                selectCheckUncheck(this);

                wait.start();
                var recherche = this.id;
                var rechercheTemp = recherche.split('-');
                var classe = rechercheTemp.splice(-1, 1)[0]; // Il ne reste qu'un identificateur qu'on récupère pour la classe également
                var coche = $(this).prop('checked');
                var exclureNature = $(this).closest('[type=formulaire]').find('.' + classe).not('.' + classe + ':first').length > 0 ? ':first' : '';
                var cacheCache = (coche === true) ? '' : 'hidden';
                if (coche) {

                    var params = {};
                    params = reqVariablesWizard();
                    // Si des travaux sont à revoir, on doit afficher une section "Travaux à revoir" de planification.
                    var jqxhr = $.ajax({
                        url: '/gestion-roles/tenue-a-jour/planification_inspection_planif/',
                        type: 'GET',
                        dataType: 'html',
                        data: params,
                        async: true
                    });
                    jqxhr
                        .done(function (response) {
                            var $element = $('#' + 'inspection-rapport');
                            if ($('#permis-ue-planification-planification-toggle').length = 0) { // si existe pas de append
                                $element.append(response);
                                $element.find('select').select2();
                                $element.find('[name="date_prochaine_inspection"]').daterangepicker({
                                    parentEl: '.modal',
                                });

                                $("div[id='accordion permis-ue-planification']").hide().fadeIn("slow");
                                initPlanificationInspectionPermis();
                            }
                            wait.stop();
                        });
                    jqxhr
                        .fail(function (jqxhr, textStatus, errorThrown) {
                            infos.ajouterMessageToast({
                                message: "Erreur de chargement du formulaire <br> « planification de l'inspection » : <br> " + erreursAjax.formaterMessageErreur('', jqxhr, '', errorThrown),
                                messageDuree: 5000,
                                messageCouleur: "red"
                            });
                            wait.stop();
                        });
                } else if ($('#inspection-types-evenement').find('input[name="bool_travaux_a_revoir"]:checked').length === 0) {
                    $("div[id='accordion permis-ue-planification']").fadeOut("slow", function () {
                        $("div[id='accordion permis-ue-planification']").remove();
                    });
                    wait.stop();
                } else {
                    wait.stop();
                }

                $(this).closest('[type="formulaire"]').find('[name="description_a_revoir"]:not(' + exclureNature + ')').fadeIn(500)[controlesFormulaires.toggleAddRemoveClass(cacheCache)]('hidden');

                var cacheCacheReste = 'oui';
                if (coche === false && $(this).parents('[data-type="unite-details"]').find('[name="bool_travaux_a_revoir"]:checked').length === 0) { // On ferme pas la colonne description tant et aussi longtemps que toutes les cases d'un type d'évènement ne sont pas toutes vides.
                    cacheCacheReste = 'non';
                }
                $(this).closest('[data-type="unite-details"]').find('[data-name="description_a_revoir"]').fadeIn(500)[controlesFormulaires.toggleAddRemoveClass(cacheCacheReste === 'oui' ? '' : cacheCache)]('hidden');

                if (coche === true) { // On focus sur les éléments visibles : peuvent être plusieurs dans le cas d'une nature lorsqu'on coche tout.

                    if ($(this).closest('[type=formulaire]').find('.' + classe).not('.' + classe + ':first').length > 0) {
                        focusControle('#' + $(this).closest('[data-type="inspection-batiment-nature"]').attr('id') + ' .description_a_revoir:not(' + exclureNature + ')', 5);
                    } else {
                        focusControle('#' + $(this).closest('[type="formulaire"]').find('[data-name="description_a_revoir"]').attr('id'), 5);
                    }
                }

                controlesFormulaires.redimentionnerTextarea();
            });

            $('#inspection-rapport').on('change', '.bool_travaux_abandonnes', function () {
                selectCheckUncheck(this);
            });

            function selectCheckUncheck(element) {
                var recherche = element.id;
                var rechercheTemp = recherche.split('-');
                var classe = rechercheTemp.splice(-1, 1)[0]; // Il ne reste qu'un identificateur qu'on récupère pour la classe également
                // Dans le cas de la saisie du rapport d'inspection, si plusieurs bâtiments sont présents, on doit descendre d'un niveau afin de ne pas bugger le sélecteur de premier niveau.

                var idCommun = rechercheTemp.join('-');
                var $selecteur = $(element);
                var parentsUntil = '[data-type="unite-details"]';
                var coche = $selecteur.prop('checked');
                var casesACocherEnfants = $selecteur.parents('[type=formulaire]').not('[data-type="unite-details"]').find('.' + classe);
                var elementFirst = '.' + classe + ':first';
                var exclusions = $.parseJSON($('#inspection_bool_exclusions').val());
                $selecteur.closest('[type=formulaire]').not('[data-type="unite-details"]').find($('#' + idCommun + '-' + classe)).prop("checked", coche);
                var nbrTypeEvenement = $('#inspection-types-evenement').find('[data-type="type_evenement"]').not('[data-type="unite-details"]').length;
                if ($selecteur.parents('[type=formulaire]').not('[data-type="unite-details"]').length === 1) { // Si un parent a plusieurs enfants, qu'on coche le parent, on coche tous ses enfants...
                    coche = $selecteur.prop('checked');
                    casesACocherEnfants.prop("checked", coche);
                    appliquerChangement(casesACocherEnfants);
                    casesACocherEnfants.closest('div[type="formulaire"]').attr('modifie', 'True');
                }

                if (casesACocherEnfants.not(elementFirst).length > 0) { // On vérifie qu'il y a au moins un enfant dans la liste de laquelle nous venons de cocher/décocher un élément.
                    var formulaireParent = $selecteur.parentsUntil(parentsUntil).parents('[type=formulaire]').not(parentsUntil);
                    formulaireParent.find('.' + classe).first().prop("checked", casesACocherEnfants.not(elementFirst).not(':checked').length === 0);
                    appliquerChangement(formulaireParent.find('.' + classe).first());
                    formulaireParent.attr('modifie', 'True');
                }
                var disableDeplacer = true;
                if ($selecteur.is(":checked")) {
                    disableDeplacer = false;
                }
                // pour vérifier les cases cochées, il faut tenir compte s'il y a plusieurs parents, pas juste le parent de la case cochée
                var casesACocherParentsEnfants = $selecteur.parents('[type=formulaire][data-type="unite-details"]').find('.' + classe);
                if (disableDeplacer === true && casesACocherParentsEnfants.filter(':checked').length > 0) {
                    disableDeplacer = false;
                }
                if (nbrTypeEvenement > 1 && classe === 'checktaj') { // Activer le bouton pour déplacer les travaux lorsqu'il y a plus d'un type d'évènement.
                    // $('#' + rechercheTemp[0] + '-' + rechercheTemp[1] + '-' + rechercheTemp[2] + '-' + rechercheTemp[3] + '-' + rechercheTemp[4] + '-' + rechercheTemp[5] + '-deplacer').prop("disabled", disableDeplacer);
                    $('#' + rechercheTemp[0] + '-' + rechercheTemp[1] + '-' + rechercheTemp[2] + '-' + rechercheTemp[3] + '-' + rechercheTemp[4] + '-' + rechercheTemp[5] + (rechercheTemp[2] !== 'evenement' ? rechercheTemp[6] : '') + '-deplacer').prop("disabled", disableDeplacer);
                }

                var $parent = $('#' + idCommun + '-' + classe).closest('[type="formulaire"]').not('[data-type="unite-details"]');
                //$parent.find('.' + classe).prop("checked", coche);
                $parent.find('.' + classe).prop('disabled', false);
                var verifExclusions = $.extend(true, [], classe in exclusions ? exclusions[classe]['exclusions'] : []);
                if (classe !== 'checktaj') {
                    verifExclusions.push(classe);
                }
                if (typeof (verifExclusions) !== 'undefined') {
                    var inputChecked = $parent.find("input:checked").not(element);
                    var inputCheckedAEnfants = $parent.find('input' + '.' + classe).not(':first').length > 0;
                    var inputCheckedExclu = {};
                    $.each(verifExclusions, function (indexVerifExclusions, valueVerifExclusions) { // on boucle sur les verifExclusions pour connaître toutes les autres cases cochées qui ont les mêmes exclusions.
                        inputCheckedExclu[valueVerifExclusions] = [];
                        $.each(inputChecked, function (indexChecked, valueChecked) { // On boucle sur chaque case à cocher qui est cochée et qui n'est pas l'élément actif.
                            var inputCheckedName = $(valueChecked).attr('name');
                            if (inputCheckedName in exclusions) {
                                $.each(exclusions[inputCheckedName]['exclusions'], function (index, value) { // On boucle dans ces éléments cochés afin de trouver si l'élément actif et cette case cochée (ou ces cases cochées) ont la même exclusion pour chacune des verifExclusions.
                                    if ((value === valueVerifExclusions) && (inputCheckedExclu[valueVerifExclusions].indexOf(inputCheckedName) < 0)) {
                                        inputCheckedExclu[valueVerifExclusions].push(inputCheckedName);
                                    }
                                });
                            }
                        });
                    });
                    $.each(verifExclusions, function (indexVerifExclusions, valueVerifExclusions) { // Lorsqu'on a toutes les contraintes d'exclusion, alors on peut activer désactiver des cases liées à l'élément sélectionné.
                        if (inputCheckedAEnfants) {
                            var disableExclusions = $parent.find('.' + valueVerifExclusions).prop('disabled') === true ? false : true;// A des enfants : on boucle sur les formulaires parent/enfants et on vérifie chaque ligne pour activer/desactiver ET décocher des cases lorsque nécessaire. Raison : checkUncheck ne peut pas tenir compte des exclusions. C'est ici qu'on le fait.
                            var inputColonneCourante = $parent.parents('[type="formulaire"]').find('input' + '.' + classe);
                            $.each(inputColonneCourante, function (indexAEnfant, valueAEnfant) {
                                var inputNom = $(valueAEnfant).attr('name');
                                $.each(inputCheckedExclu[inputNom], function (indexEstExcluDe, valueEstExcluDe) {
                                    var valueAEnfantRemplace = $(valueAEnfant).attr('id');
                                    var valueAEnfantRemplaceCopie = valueAEnfantRemplace.replace(inputNom, valueEstExcluDe);
                                    if ($('#' + valueAEnfantRemplaceCopie).prop('checked') === true) {
                                        $('#' + valueAEnfantRemplace).prop('disabled', disableExclusions);
                                        $('#' + valueAEnfantRemplace).prop('checked', false);
                                    }
                                    if (inputCheckedExclu[valueEstExcluDe] === inputNom) {
                                        disableExclusions = true;
                                    }
                                });
                                var $courant = $(valueAEnfant);
                                if ((valueVerifExclusions !== classe)) {
                                    if ($courant.prop('checked')) {
                                        $courant.closest('[type="formulaire"]').find('.' + valueVerifExclusions).prop('disabled', disableExclusions);
                                    } else {
                                        $courant.closest('[type="formulaire"]').find('.' + valueVerifExclusions).prop('disabled', false);
                                        // Si on indique disable=false sur un seul élément, on doit désactiver le parent "select all.
                                        $parent.parents('[type="formulaire"]').find('input' + '.' + valueVerifExclusions + ':first').prop('disabled', false);
                                    }
                                }
                            });
                            if ($parent.find('input' + '.' + classe).not('input:checked').length > 0) { // désactiver la case à cocher du parent, le cas échéant.
                                $parent.find('input' + '.' + classe + ':first').prop('checked', false);
                                disableExclusions = $parent.find('.' + valueVerifExclusions).prop('disabled') === true ? false : true;
                                if (inputCheckedExclu[valueVerifExclusions].length > 0) {
                                    disableExclusions = true;
                                } else {
                                    disableExclusions = false;
                                }
                                $parent.find('.' + valueVerifExclusions).prop('disabled', disableExclusions);
                                // $parent.parents('[type="formulaire"]').find('.' + valueVerifExclusions).prop('disabled', disableExclusions);// Décocher.
                            }
                        } else { // element sans enfants.
                            disableExclusions = $parent.find('.' + valueVerifExclusions).prop('disabled') === true ? false : true;
                            if (inputCheckedExclu[valueVerifExclusions].length > 0) {
                                disableExclusions = true;
                            }
                            if (element.name !== valueVerifExclusions) { // On ne désactive jamais une case qu'on coche
                                $parent.find('.' + valueVerifExclusions).prop('disabled', disableExclusions);
                                if (($parent.parents('[type="formulaire"]').find('.' + classe).not('input:checked').not(':first').length === 0)) { // Tous les enfants sont désactivés/activés.
                                    $parent.parents('[type="formulaire"]').find('.' + valueVerifExclusions).prop('disabled', disableExclusions);
                                } else if ($parent.parents('[type="formulaire"]').not(':first').find('.' + classe + ':checked').length === 0) { // Si on décoche, on active les exclusions. On vérifier celles qui demeureront désactivées : est l'exclusion d'une autre case.
                                    disableExclusions = $parent.find('.' + valueVerifExclusions).prop('disabled') === true ? false : true;
                                    if (inputCheckedExclu[valueVerifExclusions].length > 0) {
                                        disableExclusions = true;
                                    } else {
                                        disableExclusions = false;
                                    }
                                    $parent.find('.' + valueVerifExclusions).prop('disabled', disableExclusions);
                                    // $parent.parents('[type="formulaire"]').find('.' + valueVerifExclusions).prop('disabled', disableExclusions);
                                }
                            }
                        }
                    });
                }
            }

            chargerTypeEvenementListeDeplacer();
            chargerTypeEvenementListeToutDeplacer();

            initB79Attestation();

            $('#accordion-permis-inspection-remarques').find('.accordion-toggle').on('click', function () {
                // Si l'accordion est fermé et qu'il n'a pas encore été ouvert, on charge les remarques pour les afficher
                if ($(this).is('.collapsed') &&
                    $('#inspection-remarques').children().length == 0) {
                    // Créer le div pour les remarques
                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/editeur-fiche/remarque/ue/" + $('#wizard').attr('id-ue') + "/date/" + $('#wizard').attr('date-evenement') + "/",
                        dataType: 'html',
                        success: function (response) {
                            $('#inspection-remarques').append(response);
                            controlesFormulaires.redimentionnerTextarea();
                        }
                    });
                }
            });

            // On cherche des nouveaux travaux et natures dans l'interface. On active les formulaires en cascade et on active le bouton Sauvegarde
            var listeASauvegarder = $('#inspection-types-evenement').find('div[modifie="True"]').not('div[class*="visible"]').not('.hidden');
            var listeASauvegarderBootstrap = $('#inspection-types-evenement').find('div[modifie="True"][class*="visible-' + getBootstrapCurrentSize() + '"]').not('.hidden');
            var listeFormulairesATraiter = $.merge(listeASauvegarder, listeASauvegarderBootstrap);
            if (listeFormulairesATraiter.length > 0) {
                $('#btn-wizard-save').prop('disabled', false);
            }


            /**
             * On détecte un changement de date pour un évènement et on force modifie=True pour toutes les natures et les types de travaux de CET évènement qui ne sont pas modifie=True.
             */
            $('div[data-type="date_effective-evenement"]').on('change', 'input[name="date_evenement"]', function () {
                $(this).closest('[type="formulaire"]').attr('changement-date-initiale', 'True');
                $(this).closest('.panel-default').find('[type="formulaire"]').not('div[class*="visible"]').not('.hidden').not('[data-type="unite-details"]').not('[modifie="True"]').attr('modifie', 'True');
            });


            /** Chargement du check/uncheck sur la planification de l'inspection... **/
            initPlanificationInspectionPermis();

            /** Détection et préparation des messages de validation dynamique. **/
            initDetectionValidationsDynamiquesFormulaires();

            /** Si aucune sauvegarde d'un bâtiment n'est trouvée, on flash le bouton recharger */
            // if ($('#travaux-batiment-aucune-sauvegarde').length > 0) {
            //     focusBouton('#btn-wizard-recharger', 5);
            // }

            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
        }

        function initB79Attestation() {
            // $('#accordion-permis-lot-attestation').find('select').select2();
            $('#contenu-attestation-infos').find('select').select2();

            /** Détection du clic sur l'attestation (bouton "Ajouter cette attestation"). **/
            $('#contenu-attestation-infos').on('click', '.btn-tj-ajouter-attestation', function () {
                wait.start('contenu');
                setTimeout(function () {
                    if (validerInfosAttestation()) {
                        $('[name="checkbox-attestation-applique-a"]:checked')
                            .each(function () {
                                var checkbox = $(this);
                                var sousBloc = checkbox.closest('table').find('#b79-attestation-sous-bloc');
                                var nouvelleLigne = sousBloc.find('.sous-bloc-form.nouvelle-ligne');
                                if (nouvelleLigne.length == 1) {
                                    var nouvelleLigneClone = nouvelleLigne.clone(true);
                                    setInfosAttestation(nouvelleLigneClone);
                                    nouvelleLigneClone.css('display', '').removeClass('nouvelle-ligne');
                                    nouvelleLigne.before(nouvelleLigneClone);
                                    sousBloc.css('display', '');
                                }
                            })
                            .removeAttr('checked');

                        boutonAttestationEnabledDisabled();
                        checkboxTousCheckedNotChecked(true);

                        // avoir l'interaction avec les boutons de suppression des lignes d'attestation
                        init_change_event_sous_bloc();

                        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                    }
                    masquesSelection.init(); // On doit relancer l'initialisation des masques de saisie pour les lignes clonées.
                    masquesSelection.init(); // Le event reste accroché au premier élément du DOM. Si on ne relance pas, on peut saisir des lettres et chiffres. .clone() fonctionne donc mal avec jquery masked plugin.
                    wait.stop('contenu');
                }, 0);
            });

            // avoir l'interaction avec les boutons de suppression des lignes d'attestation
            init_change_event_sous_bloc();

            // avoir seulement les sous-blocs b79 du wizard car si l'évènement est ouvert à partir de la fiche, ça change l'aspect du bloc 79 de la fiche
            var sousBlocB79 = $('#accordion-permis-lot-attestation').find('[id=b79-attestation-sous-bloc]');
            // enlever la classe 'row' sur le sous-bloc b79 pour qu'il soit à l'intérieur de la cellule
            sousBlocB79.removeClass('row');
            // cacher la 'nouvelle ligne' des attestations
            sousBlocB79.find('.sous-bloc-form.nouvelle-ligne').css('display', 'none');
            // si la 'nouvelle-ligne' est seule dans le sous-bloc, cacher le sous-bloc au complet
            $.each(sousBlocB79, function () {
                if ($(this).find('.sous-bloc-form').not('.sous-bloc-form.nouvelle-ligne').length == 0) {
                    $(this).css('display', 'none');
                }
            });

            // déactiver les checkbox en mode read-only
            $('#checkbox-attestation-tous, [name="checkbox-attestation-applique-a"]').attr('disabled', $('#wizard').attr('mode') == 'r');

            $('#checkbox-attestation-tous').on('click', function () {
                wait.start('contenu');
                setTimeout(function() {
                    checkboxTousCheckedNotChecked(false);
                    wait.stop('contenu');
                }, 0);
            });

            boutonAttestationEnabledDisabled();

            $('[name="checkbox-attestation-applique-a"]').on('click', function () {
                boutonAttestationEnabledDisabled();
                checkboxTousCheckedNotChecked(true);
            });
        }

        /**
         * Fonction de chargement des types d'évènements dans la liste de choix du bouton "Déplacer tout vers".
         **/
        function chargerTypeEvenementListeToutDeplacer() {
            var $type = $('#inspection-rapport').find('[data-type=type_evenement]');
            var classe = '" class="btn-tj-inspection-tout_deplacer-action" href="#">';
            var listeTypes = getListeTypeEvenements($type, classe);
            var $boutonToutDeplacer = $('#inspection-rapport').find('[data-action=btn-tj-inspection-tout_deplacer]');

            peuplerDeplacerTravaux(listeTypes, $boutonToutDeplacer, $type);
        }


        /**
         * Fonction de chargement des types d'évènements dans la liste de choix du bouton "Déplacer vers". Ce sera toujours la liste moins le type actuel
         **/
        function chargerTypeEvenementListeDeplacer() {

            var $type = $('#inspection-rapport').find('[data-type=type_evenement]');
            var classe = '" class="btn-tj-inspection-deplacer-action" href="#">';
            var listeTypes = getListeTypeEvenements($type, classe);
            var $boutonDeplacer = $('#inspection-rapport').find('[data-action=btn-tj-inspection-deplacer]');

            peuplerDeplacerTravaux(listeTypes, $boutonDeplacer, $type);
        }


        function getListeTypeEvenements($type, classe) {
            var listeTypes = '';

            $.each($type, function (key, value) {
                var id = $(value).attr('id');
                listeTypes += '<li><a id="' + id + classe + $(value).attr('data-titre') + ' ' + $(value).attr('data-date_evenement') + '</a></li>';
            });

            return listeTypes;
        }


        function peuplerDeplacerTravaux(listeTypes, $boutonDeplacerToutDeplacer, $type) {
            $.each($boutonDeplacerToutDeplacer, function (key, value) {
                $(value).parent().find('ul[data-type=liste_types]').html(listeTypes);
                var id;
                if (listeTypes.indexOf('tout_deplacer') > 0) {
                    id = $(this).closest('div.panel-body').find('[data-type=unite-details]').attr('id');
                } else {
                    id = $(this).closest('[data-type=unite-details]').attr('id');
                }

                if(id != undefined) {
                    effacerAutoReferenceDeplacement(id, value);
                }
            });
        }


        function effacerAutoReferenceDeplacement(id, value) {
            var formulaireTemp = id.split('-');
            formulaireTemp.splice(-2, 2); // Dans le contexte d'un batiment ou d'un terrain, on doit remonter vers le niveau de l'évènement et du type d'évènement.
            id = formulaireTemp.join('-');
            var lienCourant = '[id=' + id + ']';
            $(value).parent().find(lienCourant).closest('li').remove();
        }


        /**
         * Fonction de sauvegarde et de suppression de l'étape de saisie du rapport d'inspection.
         * @param {function} callback
         * */
        function saveRapportInspection(callback) {
            checkChangementDateEtSave(saveRapportInspection2, callback);
        }

        function saveRapportInspection2(callback) {
            verifierChangementStatutEvenement(saveRapportInspection3, callback);
        }

        function saveRapportInspection3(callback) {
            var listeIdEvenementAIVide = [];
            var evActualisations = $('[id^=inspection-type_evenement-3-evenement-][data-type=date_effective-evenement]:not([id-model-instance^=evenement_nouveau])').filter(function() {
                return $(this).parent().find('[data-type=unite-details]').length > 0;
            });
            evActualisations.each(function () {
                var divNatures = $(this).parent().find('[data-type=unite-details] [data-type=inspection-batiment-nature]');
                var idModelInstance = $(this).attr('id').split('-').pop();
                if (divNatures.length == 0) {
                    listeIdEvenementAIVide.push(idModelInstance);
                }
                else {
                    var index = listeIdEvenementAIVide.indexOf(idModelInstance);
                    if (index > -1) {
                        listeIdEvenementAIVide.splice(index, 1);
                    }
                }
            });

            if (listeIdEvenementAIVide.length > 0) {
                fenetreModal.modalMessage({
                    titre: "Il ne reste aucune nature de travaux dans une ou plusieurs des actualisations " +
                        "d’inventaire. Voulez-vous supprimer ces évènements?",
                    sansX: true,
                    texteExplicatif: "",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                                saveRapportInspectionConfirmed(callback, listeIdEvenementAIVide);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                                saveRapportInspectionConfirmed(callback);
                            }
                        }
                    }
                });
            } else {
                saveRapportInspectionConfirmed(callback);
            }
        }

        function saveRapportInspectionConfirmed(callback, listeIdEvenementAIVide=[]) {
            modeSave = ModeSave.WIZARD; // DM: sinon date_debut n'apparaissait pas toujours dans le save de b79, voir getValidationSousBlocs(), getParamsSuppPourInsertion()

            nbErreurs = 0;
            var inputValeurReelleInfo = $('#frm_date_valeur_reelles').find('[name="valeur_reelle"]');
            var valeur_reelle_info = 0;
            if (inputValeurReelleInfo.length) {
                valeur_reelle_info = $('#frm_date_valeur_reelles').find('[name="valeur_reelle"]').autoNumeric('get');
            }
            var somme = 0;
            $('#inspection-types-evenement').find('input[name="cout_reel"]').each(function () {
                somme += Number($(this).autoNumeric('get'));
            });
            // Dans le cas où des montants ont été ajoutés aux natures ou aux travaux, on ajoute le formulaire frm_date_valeur_reelles afin de valider les sommes.
            if (somme > valeur_reelle_info) {
                $('#frm_date_valeur_reelles').attr('modifie', 'True');
            }
            var dateFinReelle = $('[name="date_fin_reelle"]');
            var idEvenement = $('#wizard').attr('id-evenement');
            var datePriseEffetRolePermis = $('#inspection-type_evenement-1-evenement-' + idEvenement).find('input[name="date_evenement"]');

            var dateEvenement = $('#wizard').attr('date-evenement');
            var forcerChangement = false;

            // On doit venir "artificiellement" indiquer que les lignes du bloc 79 sont modifiées afin quelles soient prises en compte dans la sauvegarde.
            // TODO: Avoir une fonction qui force ce changement basé sur des dépendances de modifications.
            if (dateFinReelle.val() !== "" && (dateFinReelle.val() !== dateFinReelle.attr('value'))) {
                dateEvenement = dateFinReelle.val();
                forcerChangement = true;
            } else if (datePriseEffetRolePermis.val() !== "" && datePriseEffetRolePermis.val() !== datePriseEffetRolePermis.attr('value')) {
                dateEvenement = datePriseEffetRolePermis.val();
                forcerChangement = true;
            }
            if (dateEvenement.length === 10) {
                dateEvenement += ' 15:00:00';
            }

            var containerErreurDate = datePriseEffetRolePermis.closest('[type="formulaire"]');
            erreursAjax.effacerErreurChamps(containerErreurDate);

            var anneeCourante = (new Date()).getFullYear();
            var dateMin = new Date(anneeCourante - 1, 0, 1);
            var dateCompare = new Date(dateEvenement);
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            if (idTypeEvenement === '1' && dateCompare < dateMin) {
                erreursAjax.afficherErreurChamps(containerErreurDate, 'date_evenement', "La date de prise d'effet ne peut pas être antérieure à " + dateToStrYmd(dateMin), '');

                infos.ajouterMessageToast({
                    message: "Erreur de validation",
                    messageDuree: 5000,
                    messageCouleur: "red"
                });

                var response = {reponse: 'error'};
                callback(response);
                return;
            }

            saveAttestationsB79(dateEvenement, forcerChangement);

            var mouvement = $('#inspection-types-evenement').attr('mouvement');
            // Les formulaires taggés par un changement de date initiale de l'évènement (maybe) sont ajoutés mais ne seront pas traités côté python puisqu'il n'y a eu aucune modification. Par contre, True ou Maybe doit permettre de changer les dates des blocs, sous-blocs, qualite complexité, des repères et du log pour la construction neuve...
            var listeFormulaires = $('#modal-step-contents > .active div[type="formulaire"]').not('div[class*="visible"]').not('[data-type="unite-details"]').not('.hidden'); // On ramasse les formulaire qui n'ont pas de classes bootstrap.
            var listeFormulairesSuppBootstrapTaille = $('#modal-step-contents > .active div[type="formulaire"][class*="visible-' + getBootstrapCurrentSize() + '"]').not('.hidden'); // On ramasse les formulaires qui ont des classes bootstrap particulières. Il peut y avoir des formulaires différents pour des mises en page différentes selon des medias et les breakpoints de Bootstrap.
            var listeFormulairesATraiter = $.merge(listeFormulaires, listeFormulairesSuppBootstrapTaille);
            var elementsARetirer = [];
            listeFormulairesATraiter.each(function (indexObjet) {
                var id = $(this).attr('id');
                if ($('#' + id + '-toggle').length === 1) {
                    if ($('#' + $(this).attr('id') + '-toggle').find('div[data-type="inspection-batiment-nature"]').length === 0) {
                        elementsARetirer.push(indexObjet);
                    }
                }
            });
            var listeFormulairesNaturesTravauxSupprimer = $('#inspection-types-evenement').find('.inspection-nature-travaux-a-supprimer'); // Dans le cas de déplacements de travaux, on supprime les nature et les travaux qui ont été déplacés. On supprime toutes les données et on réinsère dans la BD.
            var listeFormulairesNaturesTravauxASupprimer = {};
            for (let i = elementsARetirer.length - 1; i >= 0; i--) {
                listeFormulairesATraiter.splice(elementsARetirer[i], 1);
            }
            listeFormulairesNaturesTravauxSupprimer.each(function (indexObjet) {
                indexObjet = $(this).attr('id');
                listeFormulairesNaturesTravauxASupprimer[indexObjet] = {};
                var attributsSource = $(this).prop("attributes"); // Liste d'attibuts pour créer le input hidden $.each(attributsSource, function () {
                var params = [];
                $.each(attributsSource, function (indexAttribut, valueAttribut) {
                    params.push({name: this.name, value: this.value});
                });
                listeFormulairesNaturesTravauxASupprimer[indexObjet].id = $(this).attr('id');
                listeFormulairesNaturesTravauxASupprimer[indexObjet].methode = 'delete';
                listeFormulairesNaturesTravauxASupprimer[indexObjet].data_type = $(this).attr('data-type');
                listeFormulairesNaturesTravauxASupprimer[indexObjet].id_instance = $(this).attr('id-model-instance');
                listeFormulairesNaturesTravauxASupprimer[indexObjet].bool_demande_originale = $(this).attr('bool_demande_originale');
                listeFormulairesNaturesTravauxASupprimer[indexObjet].modifie = $(this).attr('modifie');

                var formulaireSplit = indexObjet.split('-');
                var dateEvenementFormDateEffective = indexObjet.split('-').splice(0, 5).join('-'); // On récupère la Date de prise d'effet au rôle qui sera utilisé pour mettre à jour les sous-formulaires du type de l'évènement (nature et types de travaux).

                var paramsSupplementaires = [];
                paramsSupplementaires.push(
                    // ces 4 éléments servent uniquement à appeler un calcul_cout_batiment ...
                    {name: 'id_municipalite', value: $('#wizard').attr('id-municipalite')},
                    {name: 'uniteEvaluation', value: $('#wizard').attr('id-ue')},
                    {name: 'evenement', value: formulaireSplit[5]},
                    {name: 'batiment', value: formulaireSplit[7]},

                    {name: 'mouvement', value: mouvement},
                    {name: 'bool_demande_originale', value: false} // Utilisé pour le perform_create des NatureEvenementXEvenement et TypeTravauxXEvenement. S'il est utilisé ici, pour la Sauvegarde du rapport, c'est qu'il ne s'agit pas d'une demande originale du permis. On force donc false.
                );

                listeFormulairesNaturesTravauxASupprimer[indexObjet].donnees = [];
                listeFormulairesNaturesTravauxASupprimer[indexObjet].donnees = paramsSupplementaires;
            });
            var async;
            if (listeFormulairesATraiter.length > 0) {
                var dataType = 'json';
                async = false;
                var formulairesTraites = {};
                var idStatutEvenement = $('#wizard').attr('id-statut-evenement');
                listeFormulairesATraiter.each(function (index) {
                        var indexObjet = $(this).attr('id');
                        var params = controlesFormulaires.serialiserFormulaire($(this));
                        var formulaireSplit = indexObjet.split('-');
                        var dateEvenementFormDateEffective = indexObjet.split('-').splice(0, 5).join('-'); // On récupère la Date de prise d'effet au rôle qui sera utilisé pour mettre à jour les sous-formulaires du type de l'évènement (nature et types de travaux).
                        formulairesTraites[indexObjet] = {};
                        formulairesTraites[indexObjet].id = $(this).attr('id');
                        // Afin de traiter une construction neuve et de traiter les différents blocs (notamment, un changement de date d'évènement), on doit ajouter tout ce qui est modifié mais non affiché dans l'interface de l'utilisateur.
                        if ($(this).attr('travaux-lies')) {
                            formulairesTraites[indexObjet].travaux_lies = $(this).attr('travaux-lies');
                        }
                        formulairesTraites[indexObjet].vue = $(this).attr('vue');
                        formulairesTraites[indexObjet].methode = $(this).attr('methode');
                        formulairesTraites[indexObjet].bool_demande_originale = $(this).attr('bool_demande_originale');
                        formulairesTraites[indexObjet].data_type = $(this).attr('data-type');
                        //formulaireTraites[indexObjet].id_instance = ($(this).attr('id-model-instance') !== 'None' || $(this).attr('id-model-instance').indexOf('nouveau') === 0 || typeof $(this).attr('id-model-instance') !== "undefined") ? 1 : $(this).attr('id-model-instance'); // On assigne la valeur
                        var instanceCalcul = (typeof ($(this).attr('id-model-instance')) === 'undefined' || $(this).attr('id-model-instance') === 'None' || $(this).attr('id-model-instance').indexOf('nouveau') > 0) ? 0 : $(this).attr('id-model-instance');
                        var statutEvenementCalcul = ($(this).attr('id-model-instance') === 'None' || $(this).attr('id-model-instance') === '' || $(this).attr('id-model-instance').indexOf('nouveau') > 0) ? 1 : idStatutEvenement;
                        formulairesTraites[indexObjet].id_instance = instanceCalcul;
                        var evenementParent = $(this).closest('[type="formulaire"]').find('input[name="id_evenement_parent"]').val();
                        var indexNatureAvecIdentifiantDecalage = formulairesTraites[indexObjet].id.indexOf('identifiant_nature') > 0 ? 2 : 0; // Utilisé pour déplacer l'index lors de la construction des strings et de la récupération des valeurs
                        var paramsSupplementaires = [];
                        if ((formulaireSplit[4] !== $('#wizard').attr('id-evenement') && statutEvenementCalcul === 1) && (formulairesTraites[indexObjet].data_type === 'date_effective-evenement')) { // Dans le cas d'une création d'un nouvel évènement, qui n'est pas prévu au permis, et uniquement dans le cas d'une création, on initialise son statut à 1 et son étape à 1. Pour toute mise à jour, on ne fait rien. L'Évènement courant est géré directement dans les paramètres qui sont passés avec la liste des formulaires.
                            paramsSupplementaires.push(
                                {name: 'statutEvenement', value: statutEvenementCalcul},
                                {name: 'id_statut_evenement', value: statutEvenementCalcul}
                            );
                            if (statutEvenementCalcul === 1) {
                                paramsSupplementaires.push(
                                    {name: 'etapeProcessus', value: 0}
                                );
                            }
                        }
                        paramsSupplementaires.push(
                            {
                                name: 'etape_evenement_courant',
                                value: $('#modal-step-contents > .active').attr('data-id_processus')
                            },
                            {name: 'formulaire_id', value: $(this).attr('id')}, // On le passe ici parce que parfois on peut vouloir retourner une liste de formulaire et valider individuellement un champ.
                            {name: 'mouvement', value: mouvement},
                            {name: 'evenement', value: formulaireSplit[4]},
                            {name: 'type_evenement', value: formulaireSplit[2]},
                            {name: 'typeEvenement', value: formulaireSplit[2]},
                            {name: 'id_municipalite', value: $('#wizard').attr('id-municipalite')},
                            {
                                name: 'id_type_batiment',
                                value: $(this).closest('[data-type=unite-details]').attr('data-id_type_batiment')
                            },
                            {name: 'id_evenement_parent', value: evenementParent !== undefined ? evenementParent : ''},
                            {name: 'uniteEvaluation', value: $('#wizard').attr('id-ue')},
                            {name: 'batiment', value: formulaireSplit[6]},
                            {name: 'nature_travaux', value: formulaireSplit[8]},
                            {name: 'type_travaux', value: formulaireSplit[10 + indexNatureAvecIdentifiantDecalage]},
                            {name: 'bool_demande_originale', value: $(this).attr('bool_demande_originale')} // Utilisé pour le perform_create des NatureEvenementXEvenement et TypeTravauxXEvenement. S'il est utilisé ici, pour la Sauvegarde du rapport, c'est qu'il ne s'agit pas d'une demande originale du permis. On force donc 0.
                        );

                        if (formulairesTraites[indexObjet].data_type === 'date-cout-reels-permis') {
                            formulairesTraites[indexObjet].modifie = $(this).closest('[type="formulaire"]').attr('modifie');
                            paramsSupplementaires.push(
                                {name: 'id_permis', value: $(this).attr('id_model_instance')},
                                {name: 'somme_couts_reels_nature_travaux', value: somme}
                            );
                        } else if (formulairesTraites[indexObjet].data_type === 'date_effective-evenement') {
                            formulairesTraites[indexObjet].modifie = $(this).closest('[type="formulaire"]').attr('modifie');
                            paramsSupplementaires.push(
                                {name: 'permis__id', value: $(this).attr('id_model_instance')},
                                {name: 'id_evenement', value: formulaireSplit[4]},
                                {name: 'date_dernier_statut', value: moment().format('YYYY-MM-DD HH:mm:ss')},
                                {
                                    name: 'date_evenement_initiale',
                                    value: $('#' + dateEvenementFormDateEffective + '[class*="visible-' + getBootstrapCurrentSize() + '"]').not('.hidden').find('input[name="date_evenement"]').prop('defaultValue')
                                });
                        } else if (formulairesTraites[indexObjet].data_type === 'inspection-batiment-nature') {
                            var maj_date_prise_effet_role = $('#' + dateEvenementFormDateEffective + '-actions').find('input[name="date_evenement"]').val() != $('#' + dateEvenementFormDateEffective).find('input[name="date_evenement"]').prop('defaultValue') ? 'true' : 'false';
                            formulairesTraites[indexObjet].modifie = $(this).closest('[type="formulaire"]').attr('modifie');
                            paramsSupplementaires.push(
                                {
                                    name: 'id_nature_evenement_x_batiment',
                                    value: $(this).attr('data-id_nature_evenement_x_batiment')
                                },
                                {name: 'natureEvenementXEvenement', value: $(this).attr('id-model-instance')},
                                {name: 'natureEvenement', value: formulaireSplit[8]}, // Nature de l'évènement pour nature_evenement_x_evenement
                                {name: 'date_dernier_statut', value: moment().format('YYYY-MM-DD HH:mm:ss')},
                                {
                                    name: 'date_evenement',
                                    value: $('#' + dateEvenementFormDateEffective + '[class*="visible-' + getBootstrapCurrentSize() + '"]').not('.hidden').find('input[name="date_evenement"]').val()
                                },
                                {
                                    name: 'date_evenement_initiale',
                                    value: $(this).attr('date_evenement_initiale')
                                    // value: $(this).parent('[type="formulaire"]').attr('date_evenement_initiale')
                                },
                                {name: 'identifiant', value: formulaireSplit[10]}, // Si la modif provient des modifications aux blocs, on récupère l'identifiant ici et on documente nature_evenement_x_batiment
                                {name: 'maj_date_prise_effet_role', value: maj_date_prise_effet_role}
                            );
                        } else if (formulairesTraites[indexObjet].data_type === 'inspection-batiment-nature-type') {
                            formulairesTraites[indexObjet].modifie = $(this).closest('[type="formulaire"]').attr('modifie');
                            var currentTypeTravaux = $(this);
                            var maj_date_prise_effet_role = $('#' + dateEvenementFormDateEffective + '-actions').find('input[name="date_evenement"]').val() != $('#' + dateEvenementFormDateEffective).find('input[name="date_evenement"]').prop('defaultValue') ? 'true' : 'false';
                            paramsSupplementaires.push(
                                {name: 'id_type_travaux_x_evenement', value: $(this).attr('id_model_instance')},
                                {
                                    name: 'natureEvenementXBatiment',
                                    value: $(this).parent().attr('data-id_nature_evenement_x_batiment')
                                },
                                {name: 'typeTravaux', value: $(this).attr('data-id_type_travaux')},
                                {name: 'date_dernier_statut', value: moment().format('YYYY-MM-DD HH:mm:ss')},
                                {name: 'id_nature_evenement', value: formulaireSplit[8]}, // Nature de l'évènement
                                {
                                    name: 'date_evenement',
                                    value: $('#' + dateEvenementFormDateEffective + '[class*="visible-' + getBootstrapCurrentSize() + '"]').not('.hidden').find('input[name="date_evenement"]').val()
                                },
                                //{name: 'date_evenement_initiale', value: $(this).parent().attr('date_evenement_initiale')},
                                {name: 'date_evenement_initiale', value: $(this).attr('date_evenement_initiale')},
                                {name: 'identifiant', value: formulaireSplit[12 + indexNatureAvecIdentifiantDecalage]},  // Si la modif provient des modifications aux blocs, on récupère l'identifiant ici et on documente type_travaux_x_evenement
                                {name: 'maj_date_prise_effet_role', value: maj_date_prise_effet_role}
                            );
                        }
                        paramsSupplementaires = nettoyerParams(paramsSupplementaires, ['date_evenement_initiale', 'bool_travaux_completes', 'bool_travaux_abandonnes', 'bool_travaux_a_revoir', 'valeur_reelle']); // La liste contient les cas d'exclusion à ne pas nettoyer (on nettoyage/elimine si vide)
                        params = params.concat(paramsSupplementaires);
                        formulairesTraites[indexObjet].donnees = [];
                        // On vérifie si bool_travaux_a_revoir est coché pour les travaux. Si c'est le cas, on doit, pour l'évènement courant, valider que l'inspection a bel et bien été planifiée. Sinon, on change le statut en "Inspection à planifier". Tout autre évènement créé à partir de l'étape 5 sera à complété à partir de l'étape 1 de toute manière.
                        formulairesTraites[indexObjet].donnees = params;
                    }
                );
            }
            $.extend(formulairesTraites, listeFormulairesNaturesTravauxASupprimer);
            if (typeof (formulairesTraites) !== "undefined" && nbErreurs == 0) { // La sauvegarde n'est exécutée que lorsqu'une liste a été initialisée et qui contient "listeFormulairesATraiter" et "listeFormulairesNaturesATravauxSupprimer"
                var etapeProcessus = $('#modal-step-contents > .active').attr('data-id_processus');
                var nombreFormulaires = 1;
                var currentForm = $('#saisie_et_validation_travaux-toggle');
                var url = '/gestion-roles/tenue-a-jour/wizard/evenement/sauvegarder-rapport-inspection/';
                async = false;
                dataType = "json";

                let params = {
                    'json': JSON.stringify(formulairesTraites),
                    'etapeProcessus': etapeProcessus,
                    'statutEvenement': idStatutEvenement,
                    'evenement': $('#wizard').attr('id-evenement'),
                    'typeEvenement': $('#wizard').attr('id-type-evenement'),
                    'bool-rapport-inspection': true,
                    'date_chargee': $('#wizard').attr('date-chargee'),
                    'liste_id_evenement_AI_vide': JSON.stringify(listeIdEvenementAIVide),
                };
                var callbackSauvegarde = function (response) {
                    updateEnteteWizard();
                    if (typeof (response) != 'undefined') {
                        // Dans le cas des Types de travaux, on doit récupérer natureEvenementXBatiment pour s'y rattacher.
                        if (typeof (response.natureEvenementXEvenement) != 'undefined') {
                            currentForm.attr('id-model-instance', response.natureEvenementXEvenement);
                            currentForm.attr('data-id_nature_evenement_x_evenement', response.natureEvenementXEvenement);
                            currentForm.attr('data-id_nature_evenement_x_batiment', response.natureEvenementXBatiment);
                        }
                    }
                    refreshDatatables();
                    $('#wizard').attr('id-statut-evenement', response.statutEvenement);
                    if ($('body').hasClass('editeur-fiche')) {
                        $('#wizard').attr('recharger-editeur-fiche', 'True');
                    }
                };
                // Si certains champs sont modifiés on peut laisser la page intacte sans devoir la recharger.

                var rechargerPage = true;
                let response = {};
                nbErreurs += sauvegarderDonnees(currentForm, url, async, dataType, params, etapeProcessus, {}, nombreFormulaires, rechargerPage, callback, callbackSauvegarde);
                nbErreurs > 0 ? response.reponse = 'error' : response.reponse = 'ok';

            } else {
                if (typeof (callback) !== 'undefined') {
                    let response = {};
                    nbErreurs > 0 ? response.reponse = 'error' : response.reponse = 'ok';
                    callback(response);
                }
            }

            if ($('#wizard').attr('id-ue').length > 0) {
                let params = [
                    {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                    {name: 'date_evenement', value: $('#wizard').attr('date-evenement')},
                ];
                $.ajax({
                    type: "GET",
                    url: '/gestion-roles/tenue-a-jour/verifier-permis-changer-ue/',
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        if (!response.resultat) {
                            // s'il y a des modifcations à la fiche, enlever le bouton qui permet de changer d'ue
                            $('#modal-step2').find('#changer-ue-permis').remove();
                        }
                    }
                });
            }
        }

        function saveAttestationsB79(dateEvenement, forcerChangement) {

            $.each($('tr#tr-attestation'), function (index, rowAttestation) {
                var row = $(rowAttestation);
                var sousBlocsValidation = row.find('.champs-multiple');

                if (forcerChangement) {
                    row.find('[id=b79-attestation-sous-bloc] .sous-bloc-form').not('.nouvelle-ligne').attr('modifie', "True");
                    row.find('[id=b79-attestation-sous-bloc] .sous-bloc-form[modifie="True"]').not('.nouvelle-ligne').find('[name="date_attestation"].form-control').not('.' + CLASSE_SUPPRESSION_LIGNE).addClass(CLASSE_VALEUR_MODIFIEE);
                }
                var validationSousBlocs = getValidationSousBlocs(sousBlocsValidation, dateEvenement, [], [], []);
                var paramsOptionnels = [
                    {name: 'validation', value: JSON.stringify(validationSousBlocs.main)},
                    {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                ];

                var sousBlocs = row.find('[id=b79-attestation-sous-bloc] .sous-bloc-form[modifie="True"]');
                $.each(sousBlocs, function (index, sousBloc) {
                    if (nbErreurs > 0) {
                        return; // DM: aussi bien arrêter tout le save si ça plante ici, juste pour éviter de corromptre un paquet de données plus loin ...
                    }

                    var $sousBloc = $(sousBloc);
                    var nomBloc = $sousBloc.attr('id');
                    var sousBlocAttestation = $(sousBloc).closest('#tr-attestation');
                    var idBatiment = sousBlocAttestation.attr('id-batiment');
                    var idFormulaire = sousBlocAttestation.attr('id-formulaire');
                    nbErreurs += wizardSauvegarderSousBloc($(sousBloc), idBatiment, idFormulaire, paramsOptionnels, dateEvenement);
                });
            });
        }

        function export_xls_Actualisation_invent(idUe, currentIdBatiment, currentDateEvenement, idTypeBatiment, impression) {

            var url = "/gestion-roles/methode-cout/export_xls_adi/" + idUe + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/id-type-batiment/" + idTypeBatiment + "/impression/" + impression + "/";
            wait.start();
            $.ajax({
                type: "POST",
                url: url,
                dataType: 'html',
                success: function (response) {
                    infos.ajouterMessageToast({
                        message: response,
                        messageDuree: 5000
                    });
                    wait.stop();
                    $("#btn-tj-exporter-excel").prop('disabled', false);
                } //end success
            }); //end ajax
        }

        /**
         * Fonction d'initialisation de l'étape de calcul de la méthode du coût.
         * */
        function initCalculMethodeCout() {
            $("#btn-tj-imprimer").prop('disabled', true);
            $("#btn-tj-exporter-excel").prop('disabled', true);

            if ($('#wizard').attr('mode') == 'w' && $('#wizard').attr('id-type-evenement') == '50') {
                $('#btn-wizard-save').attr("disabled", false);
                $('#btn-wizard-save').attr("data-original-title", "Sauvegarder et lancer le calcul du coût");

            }

            $(".step-pane.active").attr('recharger', 'oui');

            init_methode_cout();

            //get_totaux_sommaire(idUe,currentDateEvenement)
            //get_onglet_sommaire(idUe,0,currentDateEvenement,0);   //currentIdBatiment //idTypeBatiment
            $("#btn-tj-imprimer").prop('disabled', false);
            $("#btn-tj-exporter-excel").prop('disabled', false);
        }

        /**
         * Fonction de sauvegarde de l'étape de calcul de la méthode du coût.
         * */
        function saveCalculMethodeCout(callback) {
            $("#btn-tj-exporter-excel").prop('disabled', true);
            sauvegarder_sommaire(callback);
        }

        /**
         * Fonction de sauvegarde de l'étape de la valeur retenue.
         * */
        function initValeurRetenue() {

            var etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');

            var sectionAvant = $('#b94-section-avant');
            var sectionApres = $('#b94-section-apres');

            initWizardBlocs();

            initBlocRepartitionsFiscales();

            // sert pour la page 'Ne s'applique pas' et aussi quand on n'affiche pas l'accordéon 'Valeur retenue'
            if (sectionApres.length == 0) return;

            // enlever le portrait antérieur des contrôles
            // TODO : à vérifier quand on passe par l'étape Terrain juste avant
            sectionApres.find(':input').removeClass('portrait_anterieur');

            // ajouter le id_bloc pour mettre à jour les attribut du form
            sectionApres.find('.blocForm').attr('id_bloc', '94');

            //var id_type_evenement = $('#wizard').attr('id-type-evenement')
            // if (id_type_evenement == '60') {
            //	$('#id-modifier-montantb98').prop('checked', false);
            // }else{
            //	$('#id-modifier-montantb98').prop('checked', true);
            //}
            // on ne doit pas afficher le '0' pour les pourcentages de corrélation
            //par default on pour modifier les répartions fiscales au besoin
            $('#id-modifier-montantb98').prop('checked', true);

            $('[name^="pourcentage"][value="0"]').val('');

            sectionApres.find('[name^="valeur_manuelle_"], [name^="bool_changement_valeur_"]').on('change', function (event, estChargement) {
                updateValeurRetenueFinale($(this));

                // changer les montants de répartitions fiscales selon la valeur retenue
                if ($('#id-modifier-montantb98').is(':checked')) {
                    modifierB98MontantSelonValeurRetenue(estChargement);
                }
            });

            sectionApres.find('[name="valeur_manuelle_terrain"]').on('change', function () {
                updateValeurMethodeCalcul();
                updateValeurCalculeeSelonPourcentage();
            });

            sectionApres.find('[name^="pourcentage"]').on('change', function () {
                updateValeurCalculeeSelonPourcentage();
            });

            updateValeurCalculeeSelonPourcentage(sectionAvant);
            updateValeurCalculeeSelonPourcentage();

            // mettre a jour les calculs avant de mettre à jour les valeurs retenues
            updateValeurRetenueFinale(sectionApres.find('[name="valeur_manuelle_terrain"]'), true);
            updateValeurRetenueFinale(sectionApres.find('[name="valeur_manuelle_batiment"]'), true);

            // enlever la couleur 'verte' des contrôles arrive quand on passe par l'étape Terrain juste avant
            // explication: arrive à cause que l'étape Terrain fait appel au css de la fiche et le 'vert' s'affiche
            sectionApres.find(':input').removeClass('controle-modifie');
            sectionApres.find(':input:not([name^="bool_changement_valeur_"])').removeClass('valeur-modifiee');
            sectionApres.find('.for-ctrl-checkbox i').removeClass('controle-modifie');

            function updateValeurCalculeeSelonPourcentage(container) {
                var hasNoContainer = container == undefined;
                if (hasNoContainer) container = sectionApres;
                var valeurCalculeeCout = parseInt(container.find('[name="valeur_calculee_cout"]').autoNumeric('get'));
                var valeurCalculeeRevenu = container.find('[name="valeur_calculee_revenu"]').autoNumeric('get');
                var valeurCalculeeComparaison = container.find('[name="valeur_calculee_comparaison"]').autoNumeric('get');
                var pourcentageCout = container.find('[name="pourcentage_cout"]').val();
                var pourcentageRevenu = container.find('[name="pourcentage_revenu"]').val();
                var pourcentageComparaison = container.find('[name="pourcentage_comparaison"]').val();
                var inputvaleurCalculeeBatiment = container.find('[name="valeur_calculee_batiment"]');
                var valeurCalculeeBatiment = 0;

                if (pourcentageCout || pourcentageRevenu || pourcentageComparaison) {
                    if (pourcentageCout && valeurCalculeeCout) {
                        valeurCalculeeBatiment += parseInt(pourcentageCout) * parseInt(valeurCalculeeCout) / 100;
                    }
                    if (pourcentageRevenu && valeurCalculeeRevenu) {
                        valeurCalculeeBatiment += parseInt(pourcentageRevenu) * parseInt(valeurCalculeeRevenu) / 100;
                    }
                    if (pourcentageComparaison && valeurCalculeeComparaison) {
                        valeurCalculeeBatiment += parseInt(pourcentageComparaison) * parseInt(valeurCalculeeComparaison) / 100;
                    }
                    inputvaleurCalculeeBatiment.autoNumeric('set', valeurCalculeeBatiment);
                } else {
                    inputvaleurCalculeeBatiment.val('');
                }

                var inputvaleurCalculeeImmeuble = container.find('[name="valeur_calculee_immeuble"]');
                var valeurCalculeeImmeuble = 0;
                var valeurCalculeeTerrain = container.find('[name="valeur_calculee_terrain"]').autoNumeric('get');
                if (!valeurCalculeeTerrain) valeurCalculeeTerrain = 0;
                valeurCalculeeImmeuble = parseInt(valeurCalculeeTerrain) + valeurCalculeeBatiment;
                inputvaleurCalculeeImmeuble.autoNumeric('set', valeurCalculeeImmeuble);

                if (hasNoContainer) {
                    var inputvaleurBatiment = container.find('[name="valeur_batiment"]');
                    updateValeurRetenueFinale(inputvaleurBatiment);
                }
            }

            function updateValeurRetenueFinale(ctrl, estChargement) {
                var nomPartie = ctrl.attr('name').split('_').pop();
                var valeurRetenueAvant = sectionAvant.find('[name="valeur_' + nomPartie + '"]').autoNumeric('get');
                var valeurCalculeeApres = sectionApres.find('[name="valeur_calculee_' + nomPartie + '"]').autoNumeric('get');
                var facteurApres = sectionApres.find('[name="facteur_' + nomPartie + '"]').val();
                if (valeurCalculeeApres) {
                    valeurCalculeeApres = entierArrondirAu(valeurCalculeeApres, 100);
                }
                if (valeurCalculeeApres && typeof facteurApres !== 'undefined' && facteurApres !== '') {
                    valeurCalculeeApres = entierArrondirAu(parseFloat(facteurApres) * parseInt(valeurCalculeeApres), 100);
                }
                var inputValeurManuelleApres = sectionApres.find('[name="valeur_manuelle_' + nomPartie + '"]');
                var valeurManuelleApres = inputValeurManuelleApres.autoNumeric('get');
                var changementValeur = sectionApres.find('[name="bool_changement_valeur_' + nomPartie + '"]');
                var idModelInstanceAvant = sectionAvant.find('.blocForm').attr('id_model_instance');
                var idModelInstanceApres = sectionApres.find('.blocForm').attr('id_model_instance');

                if (inputValeurManuelleApres.is(':disabled')) {
                    updateEcartValeurRetenue(ctrl);
                    return;
                }

                var valeurRetenueApres = 0;
                if (valeurManuelleApres) {
                    valeurRetenueApres = entierArrondirAu(valeurManuelleApres, 100);
                    inputValeurManuelleApres.autoNumeric('set', valeurRetenueApres);
                }
                // si les 2 id_model_instance sont pareils, on coche automatiquement pour prendre la valeur calculée après
                else if (valeurCalculeeApres != valeurRetenueAvant && idModelInstanceAvant == idModelInstanceApres && estChargement) {
                    valeurRetenueApres = valeurCalculeeApres;
                } else if (valeurCalculeeApres != valeurRetenueAvant && valeurRetenueAvant == '' && idModelInstanceAvant == 'None') {
                    valeurRetenueApres = valeurCalculeeApres;
                } else if (changementValeur.is(':checked')) {
                    valeurRetenueApres = valeurCalculeeApres;
                } else {
                    valeurRetenueApres = valeurRetenueAvant;
                }

                if (!valeurRetenueApres) valeurRetenueApres = 0;
                var inputValeurApres = sectionApres.find('[name="valeur_' + nomPartie + '"]');
                inputValeurApres.autoNumeric('set', entierArrondirAu(valeurRetenueApres, 100));

                if (ctrl.attr('name').indexOf('valeur_manuelle') == 0) {
                    // cocher automatiquement la case s'il y a une différence entre la valeur retenue avant et après
                    if (!estChargement || valeurRetenueApres != valeurRetenueAvant) {
                        changementValeur.prop('checked', valeurRetenueApres != valeurRetenueAvant).trigger('change', estChargement !== undefined);
                    }
                    // désactiver la case à cocher quand il y a une valeur manuelle saisie
                    changementValeur.attr('disabled', valeurManuelleApres != '');
                    changementValeur.closest('.for-ctrl-checkbox').attr('disabled', valeurManuelleApres != '');
                }

                var valeurImmeuble = 0;
                var valeurTerrain = sectionApres.find('[name="valeur_terrain"]').autoNumeric('get');
                if (!valeurTerrain) valeurTerrain = 0;
                var valeurBatiment = sectionApres.find('[name="valeur_batiment"]').autoNumeric('get');
                if (!valeurBatiment) valeurBatiment = 0;
                valeurImmeuble = parseInt(valeurTerrain) + parseInt(valeurBatiment);

                var inputValeurImmeuble = sectionApres.find('[name="valeur_immeuble"]');
                inputValeurImmeuble.autoNumeric('set', valeurImmeuble);

                updateEcartValeurRetenue(ctrl);

                var containerB98RepartitionFiscaleApres = $('.apres-container [id="b98-repartition-fiscale"]');
                containerB98RepartitionFiscaleApres.find('[name="b94_valeur_terrain"]').autoNumeric('set', valeurTerrain);
                containerB98RepartitionFiscaleApres.find('[name="b94_valeur_batiment"]').autoNumeric('set', valeurBatiment);
                containerB98RepartitionFiscaleApres.find('[name="b94_valeur_immeuble"]').autoNumeric('set', valeurImmeuble);

                var avertissement = $('.wiz-validation-warning [data-avertissement="b94_batiment_0"]');
                if (avertissement.length) {
                    valeurBatiment == 0 ? avertissement.show() : avertissement.hide();
                }
            }

            function updateEcartValeurRetenue(ctrl) {
                // var nomPartie = ctrl.attr('name').split('_').pop();
                var listePartie = ['terrain', 'batiment', 'immeuble'];
                for (var i in listePartie) {
                    var nomPartie = listePartie[i];
                    var valeurRetenueAvant = sectionAvant.find('[name="valeur_' + nomPartie + '"]').autoNumeric('get');
                    if (!valeurRetenueAvant) valeurRetenueAvant = 0;
                    var valeurRetenueApres = sectionApres.find('[name="valeur_' + nomPartie + '"]').autoNumeric('get');
                    if (!valeurRetenueApres) valeurRetenueApres = 0;
                    var inputValeurEcart = sectionApres.find('[name="valeur_ecart_' + nomPartie + '"]');
                    var inputPourcentageEcart = sectionApres.find('[name="pourcentage_ecart_' + nomPartie + '"]');

                    var valeurEcart = parseInt(valeurRetenueApres) - parseInt(valeurRetenueAvant);
                    inputValeurEcart.autoNumeric('set', valeurEcart);

                    var pourcentageEcart = '';
                    if (valeurRetenueAvant != 0) {
                        pourcentageEcart = Math.round(((parseInt(valeurRetenueApres) - parseInt(valeurRetenueAvant)) / parseInt(valeurRetenueAvant)) * 100);
                    }
                    inputPourcentageEcart.val(pourcentageEcart);
                }
            }

            function updateValeurMethodeCalcul() {
                var container = sectionApres;
                var valeurCalculeeRevenuCtrl = container.find('[name="valeur_calculee_revenu"]');
                var valeurImmeubleRevenu = valeurCalculeeRevenuCtrl.closest('div').attr('valeur_immeuble_revenu');
                if (valeurImmeubleRevenu == 0) {
                    valeurCalculeeRevenuCtrl.val('');
                } else {
                    var valeurTerrain = container.find('[name="valeur_terrain"]').autoNumeric('get');
                    if (!valeurTerrain) valeurTerrain = 0;
                    valeurCalculeeRevenuCtrl.autoNumeric('set', valeurImmeubleRevenu - valeurTerrain);
                }
            }

            function modifierB98MontantSelonValeurRetenue(estChargement) {
                var containerB98DispositionAvant = $('.avant-container [id="b98-repartition-fiscale"]').find('#b98-repartition-fiscale-haut-sous-bloc .row.body');
                var containerB98DispositionApres = $('.apres-container [id="b98-repartition-fiscale"]').find('#b98-repartition-fiscale-haut-sous-bloc .row.body');

                var b98LignesAvant = containerB98DispositionAvant.find('.sous-bloc-form');
                var b98LignesApres = containerB98DispositionApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('.suppression-ligne').length == 0;
                });

                // mettre à jour les données :
                // - si ce n'est pas au chargement ou
                // - si c'est au chargement mais que les répartitions fiscales n'ont pas été sauvegardés pour cet évènement
                var update = !estChargement;

                if (estChargement) {
                    var listeIdAvant = b98LignesAvant.map(function () {
                        return $(this).attr("id-model-instance");
                    }).get();

                    var listeIdApres = b98LignesApres.map(function () {
                        return $(this).attr("id-model-instance");
                    }).get();

                    update = $(listeIdAvant).not(listeIdApres).length == 0 && $(listeIdApres).not(listeIdAvant).length == 0;
                }

                if (update) {
                    var containerB98RepartitionFiscaleApres = $('.apres-container [id="b98-repartition-fiscale"]');
                    var changementValeurTerrain = sectionApres.find('[name="bool_changement_valeur_terrain"]');
                    var changementValeurBatiment = sectionApres.find('[name="bool_changement_valeur_batiment"]');

                    var doitModifierB98TypeFiscal = false;

                    if (!changementValeurTerrain.is(':checked') && !changementValeurBatiment.is(':checked')) {
                        containerB98RepartitionFiscaleApres.find('[name="type_fiscal"]').trigger('change', true);
                        doitModifierB98TypeFiscal = true;
                    } else {
                        var listePartieImmeuble = [];
                        $.each(b98LignesApres, function () {
                            // garder les parties d'immeuble distinctes
                            var idPartieImmeuble = $(this).find('[name="id_partie_immeuble"]').val();
                            if ($.inArray(idPartieImmeuble, listePartieImmeuble) == -1) {
                                listePartieImmeuble.push(idPartieImmeuble);
                            }

                            // enlever le montant de toutes les lignes
                            $(this).find('[name="montant"]').val('').addClass('valeur-modifiee');
                        });

                        var valeurRetenue = getValeurRetenue();
                        for (var index in listePartieImmeuble) {

                            if (listePartieImmeuble.hasOwnProperty(index)) {
                                var idPartieImmeuble = listePartieImmeuble[index];
                                var sousBlocPartieImmeuble = b98LignesApres.filter(function () {
                                    return $(this).find('[name="id_partie_immeuble"]').val() == idPartieImmeuble;
                                });

                                if (sousBlocPartieImmeuble.length) {
                                    var nouveauMontant = 0;
                                    if (idPartieImmeuble == 'T') {
                                        nouveauMontant = valeurRetenue.valeurTerrain;
                                    }
                                    if (idPartieImmeuble == 'B') {
                                        nouveauMontant = valeurRetenue.valeurBatiment;
                                    }
                                    if (idPartieImmeuble == 'I') {
                                        nouveauMontant = valeurRetenue.valeurImmeuble;
                                    }
                                    $(sousBlocPartieImmeuble.get(0)).find('[name="montant"]').autoNumeric('set', nouveauMontant).addClass('valeur-modifiee');
                                    doitModifierB98TypeFiscal = true;
                                }
                            }
                        }
                    }
                    if (doitModifierB98TypeFiscal) {
                        // notifier que le b94_type_fiscal a changé pour provoquer la sauvegarde du bloc et ainsi modifier la nature en conséquence
                        containerB98RepartitionFiscaleApres.find('[name="b94_type_fiscal"]').addClass('valeur-modifiee');
                    }
                }
            }

            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            if (idTypeEvenement == TYPE_EVENEMENT.nouveau_role) {
                $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                    sauvegarderEtape(function (response) {
                        if (response.reponse == 'ok') {
                            fenetreModal.fermerModal('modal-wizard-evenement');
                            // ne pas rafraîchir dans l'Explorateur
                            if (!$('#collapse-evenement').not(':hidden').length && !$('#exp-ue-body-evenement').length) {
                                refreshDatatables();
                            }
                        } else {
                            infos.ajouterMessageToast({
                                message: 'Erreur de sauvegarde',
                                messageCouleur: 'red'
                            });
                            wait.stop();
                            erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', xhr, xhr.responseJSON['None']);
                        }
                    });
                });
            }

        }

        function initBlocRepartitionsFiscales() {
            var containerB98RepartitionFiscale = $('[id="b98-repartition-fiscale"]');
            var containerB98RepartitionFiscaleApres = $('.apres-container [id="b98-repartition-fiscale"]');
            var containerB98Disposition = containerB98RepartitionFiscale.find('#b98-repartition-fiscale-haut-sous-bloc .row.body');
            var containerB98DispositionApres = containerB98RepartitionFiscaleApres.find('#b98-repartition-fiscale-haut-sous-bloc .row.body');
            //pl48
            var bool_fin_scolaire = false;
            var containerB98DispositionScolaire = containerB98RepartitionFiscale.find('#b98-repartition-fiscale-bas-scolaire-sous-bloc .row.body');
            var containerB98DispositionScolaireApres = containerB98RepartitionFiscaleApres.find('#b98-repartition-fiscale-bas-scolaire-sous-bloc .row.body');

            // ajouter le id_bloc pour mettre à jour les attribut du form et afficher les erreurs dans les sous-blocs
            // (si on le met dans le viewset, ça force à vérifier si le bloc est vide par la bd)
            // ajouter une classe pour afficher les erreurs sous le bloc
            containerB98RepartitionFiscaleApres.attr('id_bloc', '98').addClass('afficher-erreur');

            var b98NouvelleLigne = containerB98Disposition.find('.sous-bloc-form.nouvelle-ligne');
            b98NouvelleLigne.hide();
            // pl48
            var b98NouvelleLigneScolaire = containerB98DispositionScolaire.find('.sous-bloc-form.nouvelle-ligne');
            b98NouvelleLigneScolaire.hide();

            // ne pas voir la ligne bool_dalete='True' dans le 'avant' et le 'après'
            // TODO : vérifier si on peut utiliser [value="True"] au lieu du filter()
            var b98LigneBoolDeleteTrue = containerB98Disposition.find('.sous-bloc-form [name="bool_delete"]').filter(function () {
                return $(this).val() == 'True';
            }).closest('.sous-bloc-form');
            b98LigneBoolDeleteTrue.hide();
            // pl48
            var b98LigneBoolDeleteTrueScolaire = containerB98DispositionScolaire.find('.sous-bloc-form [name="bool_delete"]').filter(function () {
                return $(this).val() == 'True';
            }).closest('.sous-bloc-form');
            b98LigneBoolDeleteTrueScolaire.hide();

            // seulement dans le 'après', vérifier s'il existe une ligne avec bool_delete=True, alors celle-ci devient la 'nouvelle ligne',
            // on n'a pas besoin de garder celle créée automatiquement par le système
            b98LigneBoolDeleteTrue = b98LigneBoolDeleteTrue.filter(function () {
                return $(this).closest('.apres-container').length > 0;
            }).closest('.sous-bloc-form');
            if (b98LigneBoolDeleteTrue.length) {
                b98NouvelleLigne.remove();
                b98LigneBoolDeleteTrue.addClass('nouvelle-ligne');
            } else {
                b98NouvelleLigne.find('[name="bool_delete"]').val('True');
            }

            b98LigneBoolDeleteTrueScolaire = b98LigneBoolDeleteTrueScolaire.filter(function () {
                return $(this).closest('.apres-container').length > 0;
            }).closest('.sous-bloc-form');
            if (b98LigneBoolDeleteTrueScolaire.length) {
                b98NouvelleLigneScolaire.remove();
                b98LigneBoolDeleteTrueScolaire.addClass('nouvelle-ligne');
            } else {
                b98NouvelleLigneScolaire.find('[name="bool_delete"]').val('True');
                b98NouvelleLigneScolaire.find('[name="bool_fin_scolaire"]').val('1');
                b98NouvelleLigneScolaire.find('[name="bool_fin_scolaire"]').prop('checked', true);
            }


            // faire ces initialisations après les changements pour la 'nouvelle ligne' et utiliser les variables déclarées ci-haut
            initB98RepartitionFiscale();
            initTypeFiscal();
            initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionApres);
            initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionScolaireApres, '_scolaire');
            initQuestionOmiseInscrite(containerB98RepartitionFiscaleApres, false);
            initQuestionOmiseInscrite(containerB98RepartitionFiscaleApres, false, '_b');
            //pl48
            //init_repartitions();

            var b98LignesAvant = $('.avant-container #b98-repartition-fiscale').find('.sous-bloc-form:not(.nouvelle-ligne)');
            var b98RepartitionFiscaleAvant = [];
            $.each(b98LignesAvant, function () {
                var ligne = $(this);
                var b98RepartitionFiscale = {};
                b98RepartitionFiscale.dispositionLegislative = ligne.find('[name="dispositionLegislative"]').val();
                b98RepartitionFiscale.montant = ligne.find('[name="montant"]').autoNumeric('get');
                b98RepartitionFiscale.id_imposabilite = ligne.find('[name="id_imposabilite"]').val();
                b98RepartitionFiscale.bool_delete = ligne.find('[name="bool_delete"]').val();
                b98RepartitionFiscale.id_type_fiscal = ligne.find('[name="id_type_fiscal"]').val();
                b98RepartitionFiscale.bool_fin_scolaire = ligne.find('[name="bool_fin_scolaire"]').val();
                b98RepartitionFiscaleAvant.push(b98RepartitionFiscale);
            });
            containerB98RepartitionFiscaleApres.find('[name="b98_repartition_fiscale_avant"]').val(JSON.stringify(b98RepartitionFiscaleAvant));

            containerB98RepartitionFiscaleApres.find('[name="type_fiscal"], [name="imposabilite"]').on('change', function (event, aucunChangement) {
                wait.start();
                var b98Lignes = []; // #16037 force init
                var selectChanged = $(this);
                var params = {
                    'id_ue': $('#wizard').attr('id-ue')
                };
                params['bool_fin_scolaire'] = containerB98RepartitionFiscaleApres.find('[name="bool_fin_scolaire"].valeur-modifiee').val() == '1';
                bool_fin_scolaire = containerB98RepartitionFiscaleApres.find('[name="bool_fin_scolaire"].valeur-modifiee').val() == '1';
                var b98Lignes;
                var b98lLgneScolaire;
                if (bool_fin_scolaire) {
                    b98Lignes = containerB98DispositionScolaireApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                        return $(this).find('.suppression-ligne').length == 0;
                    });
                    b98lLgneScolaire = b98Lignes;
                } else {
                    b98Lignes = containerB98DispositionApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                        return $(this).find('.suppression-ligne').length == 0;
                    });
                }


                var champNom = selectChanged.attr('name');
                var champValeur = selectChanged.val();
                var option = selectChanged.find('option:selected');
                var estTypeFiscal = champNom == 'type_fiscal';
                if (estTypeFiscal) {
                    var valeurRetenue = getValeurRetenue();
                    params.b94_valeur_terrain = valeurRetenue.valeurTerrain;
                    params.b94_valeur_batiment = valeurRetenue.valeurBatiment;
                    params.b94_valeur_immeuble = valeurRetenue.valeurImmeuble;
                    b98Lignes = nettoyyerLigneTypeFiscale(containerB98DispositionApres);
                    b98lLgneScolaire = nettoyyerLigneTypeFiscale(containerB98DispositionScolaireApres, '-scolaire');
                    // on peut choisir un seul type fiscal à la fois : supprimer toutes les lignes affichées

                } else {
                    champNom = 'disposition_legislative';
                    champValeur = option.attr('id_model');
                }

                params[champNom] = champValeur;
                params['liste_disposition_legislative'] =
                    JSON.stringify(b98Lignes.find('[name="dispositionLegislative"]').map(function () {
                        return $(this).val();
                    }).get());

                if (aucunChangement !== undefined) {
                    params.aucun_changement = aucunChangement;
                    params.statut_evenement = $('#wizard').attr('id-statut-evenement');
                    params.date_evenement = $('#wizard').attr('date-evenement');

                    var containerB98RepartitionFiscaleAvant = $('.avant-container [id="b98-repartition-fiscale"]');
                    var containerB98DispositionAvant = containerB98RepartitionFiscaleAvant.find('#b98-repartition-fiscale-haut-sous-bloc .row.body');
                    var containerB98DispositionScolaireAvant = containerB98RepartitionFiscaleAvant.find('#b98-repartition-fiscale-bas-scolaire-sous-bloc .row.body');

                    var b98LignesAvant = containerB98DispositionAvant.find('.sous-bloc-form:not(.nouvelle-ligne)');
                    var b98LignesAvantScolaire = containerB98DispositionScolaireAvant.find('.sous-bloc-form:not(.nouvelle-ligne)');

                    params.liste_id_b98_avant =
                        JSON.stringify(b98LignesAvant.map(function () {
                            return $(this).attr('id-model-instance');
                        }).get());

                    params.liste_id_b98_avant_scolaire =
                        JSON.stringify(b98LignesAvantScolaire.map(function () {
                            return $(this).attr('id-model-instance');
                        }).get());

                }

                $.ajax({
                    type: "GET",
                    url: '/gestion-roles/tenue-a-jour/valeur-retenue/ajouter-disposition-legislative/',
                    dataType: 'json',
                    data: params,
                    success: function (response) {
                        wait.stop();
                        if (response.b98_html) {
                            // ajouter la ligne de b98 au début du tableau pour laisser la 'nouvelle-ligne' cachée en dernier
                            var maDispositionApres = (bool_fin_scolaire) ? containerB98DispositionScolaireApres : containerB98DispositionApres;
                            if (estTypeFiscal) {
                                ajustertypefiscalsave(response, containerB98DispositionApres, containerB98DispositionScolaireApres);
                            } else {
                                maDispositionApres.prepend(response.b98_html);
                            }

                            init_change_event_sous_bloc();

                            formaterMonnaie(containerB98RepartitionFiscaleApres.find('input.money'), 0);

                            // si un montant est déjà indiqué, il faut forcer la valeur à 'modifiée' pour être prise en compte lors de la sauvegarde
                            containerB98RepartitionFiscaleApres.find('[name="montant"]').filter(function () {
                                if ($(this).autoNumeric('get')) {
                                    $(this).addClass('valeur-modifiee');
                                }
                            });

                            changerTypeFiscal(containerB98RepartitionFiscaleApres);
                            b98QuestionOmiseInscrite();
                        }

                        // on réordonne les lignes et autres initialisations pour b98
                        initB98RepartitionFiscale(selectChanged);

                        erreursAjax.effacerErreurChamps(containerB98RepartitionFiscale);
                        if (response.erreur) {
                            erreursAjax.afficherErreurChamps(containerB98RepartitionFiscale, 'none', response.erreur, '');
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        wait.stop();

                        if (typeof (callback) !== 'undefined') {
                            var response = {};
                            response.reponse = 'error';
                            callback(response);
                        }

                        // erreursAjax.traiterErreurs(currentForm, xhr, thrownError);
                    }
                });
            });

            function initTypeFiscal() {
                $.each(containerB98RepartitionFiscale, function () {
                    var b94TypeFiscal = $(this).find('[name="b94_type_fiscal"]').val();
                    var b98Lignes = $(this).find('.sous-bloc-form:not(.nouvelle-ligne)');
                    $.each(b98Lignes, function () {
                        var idTypeFiscal = '0';
                        var nbDispositionXTypeFiscal = '0';
                        if (b94TypeFiscal) {
                            idTypeFiscal = b94TypeFiscal;
                            nbDispositionXTypeFiscal = b98Lignes.length;
                        }
                        $(this).find('[name="id_type_fiscal"]').val(idTypeFiscal);
                        $(this).find('[name="nb_disposition_x_type_fiscal"]').val(nbDispositionXTypeFiscal);
                    });
                    changerTypeFiscal($(this), true);
                });
            }

            function changerTypeFiscal(containerB98, estChargement) {
                var nbLigneXTypeFiscal = {};
                var b98Lignes = containerB98.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('.suppression-ligne').length == 0;
                });
                $.each(b98Lignes, function () {
                    var idTypeFiscal = $(this).find('[name="id_type_fiscal"]').val();
                    if (!(idTypeFiscal in nbLigneXTypeFiscal)) {
                        nbLigneXTypeFiscal[idTypeFiscal] = 0;
                    }
                    nbLigneXTypeFiscal[idTypeFiscal] += 1;
                });

                var typeFiscal = '';
                var description = '';
                var descriptionManuel = '(manuel)';

                var nbKeys = Object.keys(nbLigneXTypeFiscal);
                if (nbKeys.length > 1) {
                    description = descriptionManuel;
                } else if (nbKeys.length == 1) {
                    var idTypeFiscal = nbKeys[0];
                    var nbLigneTypeFiscal = nbLigneXTypeFiscal[idTypeFiscal];
                    var nbDispositionXTypeFiscal =
                        b98Lignes.find('[name="id_type_fiscal"][value="' + idTypeFiscal + '"]')
                            .closest('.sous-bloc-form').find('[name="nb_disposition_x_type_fiscal"]').val();

                    if (nbLigneTypeFiscal == nbDispositionXTypeFiscal) {
                        typeFiscal = idTypeFiscal;
                        description = containerB98RepartitionFiscaleApres.find('[name="type_fiscal"] option[value="' + idTypeFiscal + '"]').text();
                    } else if (idTypeFiscal != '0') {
                        description = descriptionManuel;
                    }
                }

                var b94TypeFiscal = containerB98.find('[name="b94_type_fiscal"]');
                if (estChargement == undefined) {
                    if (b94TypeFiscal.val() != typeFiscal || (b94TypeFiscal.val() == '' && typeFiscal == '')) {
                        b94TypeFiscal.val(typeFiscal).addClass('valeur-modifiee');
                    }
                }
                var b94TypeFiscalDescription = containerB98.find('#description-type-fiscal');
                b94TypeFiscalDescription.text(description);
            }

            function ajustertypefiscalsave(response, containerB98DispositionApres, containerB98DispositionScolaireApres) {
                containerB98DispositionApres.prepend(response.b98_html);
                containerB98DispositionScolaireApres.prepend(response.b98_html1);
                var maDispositionApres = containerB98DispositionApres;
                formaterMonnaie(containerB98DispositionApres.find('input.money'), 0);
                formaterMonnaie(containerB98DispositionScolaireApres.find('input.money'), 0);
                initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionApres);
                initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionScolaireApres, '_scolaire');

            }

            function nettoyyerLigneTypeFiscale(containerB98DispositionApres, partie = '') {
                var b98Lignes = containerB98DispositionApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('.suppression-ligne').length == 0;
                });
                if (b98Lignes.length) {
                    var checkboxTous = containerB98RepartitionFiscaleApres.find('#ctrl-suppression-tous' + partie + '');
                    checkboxTous.click();
                    // décocher le checboxTous
                    var checkboxTousIcone = checkboxTous.parent().find('i');
                    checkboxTousIcone.removeClass('tout-active').addClass('tout-desactive');

                    // avoir toutes les lignes même celles qui sont supprimées
                    var b98LignesSuppression = containerB98DispositionApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                        return $(this).find('.suppression-ligne').length > 0;
                    });
                    // cacher les lignes supprimées
                    b98LignesSuppression.hide();

                    // enlever le 'change' sur le contrôle de suppression sur les lignes supprimées cachés pour ne pas
                    // faire le changement de type fiscal inutilement
                    b98LignesSuppression.find('.ctrl-suppression').off('change');

                    // refaire le filtre pour enlever les lignes supprimées
                    b98Lignes = containerB98DispositionApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                        return $(this).find('.suppression-ligne').length == 0;
                    });
                }
                return b98Lignes;
            }

            function initB98RepartitionFiscale(selectChanged) {
                var selectNom = '';
                if (selectChanged !== undefined) {
                    selectNom = selectChanged.attr('name');
                }
                if (selectNom == '' || selectNom == 'type_fiscal') {
                    // comme type_fiscal permet d'avoir toutes les données si typeRepartitionFiscale = '-', il faut d'abord vider
                    // le type_fiscal avant de vider son parent pour que sa valeur soit pris en compte dans l'event de initCascade
                    var typeFiscal = containerB98RepartitionFiscaleApres.find('[name="type_fiscal"]');
                    var selectionVideValue = typeFiscal.attr('selection-vide-value');
                    typeFiscal.val(selectionVideValue).select2('val', selectionVideValue);

                    // vider le sélecteur 'Type de répartition fiscale' pour effectuer la cascade du sélecteur type_fiscal
                    var typeRepartitionFiscale = containerB98RepartitionFiscaleApres.find('[name="typeRepartitionFiscale"]');
                    selectionVideValue = typeRepartitionFiscale.attr('selection-vide-value');
                    typeRepartitionFiscale.val(selectionVideValue).select2('val', selectionVideValue, true);
                }

                if (selectNom == '' || selectNom == 'imposabilite') {
                    // vider le sélecteur 'loi' pour effectuer la cascade des autres champs pour la disposition législative
                    containerB98RepartitionFiscaleApres.find('[name="loi"]').val('').select2('val', '', true);
                }

                // tous les contrôles de suppression des lignes excluant la 'nouvelle-ligne', les lignes supprimées 'cachées' et le checkboxTous de l'entête
                var b98Lignes = containerB98DispositionApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('.suppression-ligne').length == 0;
                });
                var ctrlSuppression = b98Lignes.find('.ctrl-suppression');
                var b98LignesScolaire = containerB98DispositionScolaireApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('.suppression-ligne').length == 0;
                });
                var ctrlSuppressionScolaire = b98LignesScolaire.find('.ctrl-suppression');

                // utiliser pour la liste des répartitions fiscales
                initCheckboxTous(containerB98RepartitionFiscaleApres.find('#ctrl-suppression-tous'), ctrlSuppression);
                initCheckboxTous(containerB98RepartitionFiscaleApres.find('#ctrl-suppression-tous-scolaire'), ctrlSuppressionScolaire);

                ctrlSuppression.on('change', function () {
                    initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionApres);
                    changerTypeFiscal(containerB98RepartitionFiscaleApres);
                    b98QuestionOmiseInscrite();

                });
                ctrlSuppressionScolaire.on('change', function () {
                    initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionScolaireApres, '_scolaire');
                });

                updatermontantb98(containerB98DispositionApres);
                updatermontantb98(containerB98DispositionScolaireApres, '_scolaire');

                ordonnerB98RepartitionFiscale(containerB98DispositionApres);
                ordonnerB98RepartitionFiscale(containerB98DispositionScolaireApres);

            }

            function updatermontantb98(containerB98DispositionApres, scolaire = '') {
                containerB98DispositionApres.find('[name="montant"]').on('change', function () {
                    var input = $(this);
                    var montant = input.autoNumeric('get');
                    if (montant != '' && scolaire == '') {
                        montant = entierArrondirAu(montant, 100);
                        input.autoNumeric('set', montant);
                    }
                    var sousBloc = input.closest('.sous-bloc-form');
                    var idPartieImmeuble = sousBloc.find('[name="id_partie_immeuble"]').val();
                    var sousBlocs = sousBloc.closest('.champs-multiple').find('.sous-bloc-form:not(.nouvelle-ligne, :hidden)').filter(function () {
                        return $(this).find('.suppression-ligne').length == 0;
                    });
                    var sousBlocPartieImmeuble = sousBlocs.filter(function () {
                        return $(this).find('[name="id_partie_immeuble"]').val() == idPartieImmeuble;
                    });
                    if (sousBlocPartieImmeuble.length > 1) {

                        // si le montant modifié est sur la 1ère ligne, on change le montant de la 2e ligne
                        // si le montant modifié est sur une autre ligne que la 1ère, on change le montant de la 1ère ligne
                        var indexSousBloc = sousBlocPartieImmeuble.index(sousBloc);
                        var indexNouveauMontant = indexSousBloc == 0 ? 1 : 0;

                        // faire la somme des montants de toutes les lignes sauf la ligne qui aura le calcul final
                        var somme = 0;
                        for (var i = 0; i < sousBlocPartieImmeuble.length; i++) {
                            if (i != indexNouveauMontant) {
                                var montant = $(sousBlocPartieImmeuble.get(i)).find('[name="montant"]').autoNumeric('get');
                                if (!montant) montant = 0;
                                somme += parseInt(montant);
                            }
                        }
                        var valeurRetenue = getValeurRetenue();
                        // soustraire le montant de la valeur retenue de la somme des lignes
                        var nouveauMontant = 0;
                        if (idPartieImmeuble == 'T') {
                            nouveauMontant = valeurRetenue.valeurTerrain - somme;
                        }
                        if (idPartieImmeuble == 'B') {
                            nouveauMontant = valeurRetenue.valeurBatiment - somme;
                        }
                        if (idPartieImmeuble == 'I') {
                            nouveauMontant = valeurRetenue.valeurImmeuble - somme;
                        }
                        $(sousBlocPartieImmeuble.get(indexNouveauMontant)).find('[name="montant"]').autoNumeric('set', nouveauMontant).addClass('valeur-modifiee');
                    }

                    // notifier que le b94_type_fiscal a changé pour provoquer la sauvegarde du bloc et ainsi modifier la nature en conséquence
                    containerB98RepartitionFiscaleApres.find('[name="b94_type_fiscal"]').addClass('valeur-modifiee');

                    b98QuestionOmiseInscrite();

                    // si un montant est modifié, forcer tous les autres montants à 'valeur-modifiee' afin d'être prise en compte lors de la sauvegarde
                    // (ceci va obliger à créer de nouvelles lignes en date de l'évènement pour qu'on voit toutes les données dans le certificat)
                    var blocpourmontant = containerB98RepartitionFiscaleApres.find('#b98-repartition-fiscale-haut-sous-bloc .row.body');
                    var blocpourmontantScolaire = containerB98RepartitionFiscaleApres.find('#b98-repartition-fiscale-bas-scolaire-sous-bloc .row.body');

                    blocpourmontant.find('[name="montant"]').filter(function () {
                        if ($(this).autoNumeric('get')) {
                            $(this).addClass('valeur-modifiee');
                        }
                    });

                    blocpourmontantScolaire.find('[name="montant"]').filter(function () {
                        if ($(this).autoNumeric('get')) {
                            $(this).addClass('valeur-modifiee');
                        }
                    });
                    initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionApres, scolaire);

                });

            }

            function ordonnerB98RepartitionFiscale(containerB98Disposition) {
                // ordonner avec le champ 'ordre_tri'
                $.each(containerB98Disposition, function () {
                    var b98Lignes = $(this).find('.sous-bloc-form').not('.nouvelle-ligne').filter(function () {
                        return $(this).find('.suppression-ligne').length == 0;
                    });
                    var b98Detach = b98Lignes.detach();
                    var b98Ordered = b98Detach.sort(function (a, b) {
                        var elementA = parseInt($(a).find('[name="ordre_tri"]').val());
                        var elementB = parseInt($(b).find('[name="ordre_tri"]').val());
                        return elementA > elementB ? 1 : elementA < elementB ? -1 : 0;
                    });
                    $(this).first().prepend(b98Ordered);
                });
            }

            function b98QuestionOmiseInscrite() {
                // afficher ou non la question pour indûment omise/inscrite
                var b98LignesApres = containerB98DispositionApres.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('.suppression-ligne').length == 0;
                });
                var typeFiscalEae = $.parseJSON(containerB98RepartitionFiscaleApres.find('[name="type_fiscal_eae"]').val());
                var dispositionLegislativeEae = $.parseJSON(containerB98RepartitionFiscaleApres.find('[name="disposition_legislative_eae"]').val());
                var dispositionLegislativeVfe = $.parseJSON(containerB98RepartitionFiscaleApres.find('[name="disposition_legislative_vfe"]').val());

                var nbEaeApres = 0;
                var nbVfeApres = 0;
                var nbNonImposableApres = 0;
                $.each(b98LignesApres, function () {
                    if ($.inArray($(this).find('[name="id_type_fiscal"]').val(), typeFiscalEae) != -1 ||
                        $.inArray($(this).find('[name="dispositionLegislative"]').val(), dispositionLegislativeEae) != -1) {
                        nbEaeApres += 1;
                    } else if ($(this).find('[name="id_imposabilite"]').val() == '2') { // non-imposable
                        nbNonImposableApres += 1;
                    }
                    if ($.inArray($(this).find('[name="dispositionLegislative"]').val(), dispositionLegislativeVfe) != -1) {
                        nbVfeApres += 1;
                    }

                });

                var nbEaeAvant = 0;
                var nbVfeAvant = 0;
                var nbNonImposableAvant = 0;
                $.each(b98LignesAvant, function () {
                    if ($.inArray($(this).find('[name="id_type_fiscal"]').val(), typeFiscalEae) != -1 ||
                        $.inArray($(this).find('[name="dispositionLegislative"]').val(), dispositionLegislativeEae) != -1) {
                        nbEaeAvant += 1;
                    } else if ($(this).find('[name="id_imposabilite"]').val() == '2') {
                        nbNonImposableAvant += 1;
                    }
                    if ($.inArray($(this).find('[name="dispositionLegislative"]').val(), dispositionLegislativeVfe) != -1) {
                        nbVfeAvant += 1;
                    }

                });

                // changer le texte de 'est_indument_omise_inscrite'
                var nomInput = '';
                if (nbEaeAvant || nbEaeApres) {
                    nomInput = 'texte_indument_omise_inscrite_eae';
                } else if (nbNonImposableAvant || nbNonImposableApres) {
                    nomInput = 'texte_indument_omise_inscrite_non_imposable';
                }
                if (nomInput) {
                    var texteQuestion = containerB98RepartitionFiscaleApres.find('[name="' + nomInput + '"]').val();
                    var labelQuestion = containerB98RepartitionFiscaleApres.find('label[for$="est_indument_omise_inscrite"]');
                    labelQuestion.text(texteQuestion);
                }
                var remplacerTexte = nbEaeAvant < nbEaeApres || nbNonImposableAvant < nbNonImposableApres;
                var estAffiche = (nbEaeAvant == 0 && nbEaeApres > 0) || (nbEaeAvant > 0 && nbEaeApres == 0) || nbNonImposableAvant != nbNonImposableApres;
                var vfe = '';
                initQuestionOmiseInscrite(containerB98RepartitionFiscaleApres, remplacerTexte, vfe);
                afficherQuestionOmiseInscrite(containerB98RepartitionFiscaleApres, estAffiche, '', vfe);
                // changer le texte de 'est_indument_omise_inscrite_b'
                var nomInputvfe = '';
                if (nbVfeAvant || nbVfeApres) {
                    nomInputvfe = 'texte_indument_omise_inscrite_vfe';
                }
                if (nomInputvfe) {
                    var texteQuestionvfe = containerB98RepartitionFiscaleApres.find('[name="' + nomInputvfe + '"]').val();
                    var labelQuestionvfe = containerB98RepartitionFiscaleApres.find('label[for$="est_indument_omise_inscrite_b"]');
                    labelQuestionvfe.text(texteQuestionvfe);
                }
                //pl48
                var remplacerTextevfe = nbVfeAvant < nbVfeApres;
                var estAffichevfe = (nbVfeAvant == 0 && nbVfeApres > 0) || (nbVfeAvant > 0 && nbVfeApres == 0);
                vfe = '_b';
                initQuestionOmiseInscrite(containerB98RepartitionFiscaleApres, remplacerTextevfe, vfe);
                afficherQuestionOmiseInscrite(containerB98RepartitionFiscaleApres, estAffichevfe, '', vfe);

            }


            function initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, monbloc, scolaire = '') {
                var sousBlocImmeuble = monbloc.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('[name="id_partie_immeuble"]').val() == "I" && $(this).find('.suppression-ligne').length == 0;
                });
                var sousBlocTerrain = monbloc.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('[name="id_partie_immeuble"]').val() == "T" && $(this).find('.suppression-ligne').length == 0;
                });
                var sousBlocBatiment = monbloc.find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function () {
                    return $(this).find('[name="id_partie_immeuble"]').val() == "B" && $(this).find('.suppression-ligne').length == 0;
                });

                var sommeT = 0;
                var sommeB = 0;
                var sommeI = 0;
                if (sousBlocTerrain.length > 0) {
                    for (var i = 0; i < sousBlocTerrain.length; i++) {
                        var montant = $(sousBlocTerrain.get(i)).find('[name="montant"]').autoNumeric('get');
                        if (!montant) montant = 0;
                        sommeT += parseInt(montant);
                    }
                }
                if (sousBlocBatiment.length > 0) {
                    for (var i = 0; i < sousBlocBatiment.length; i++) {
                        var montant = $(sousBlocBatiment.get(i)).find('[name="montant"]').autoNumeric('get');
                        if (!montant) montant = 0;
                        sommeB += parseInt(montant);
                    }
                }
                if (sousBlocImmeuble.length > 0) {
                    for (var i = 0; i < sousBlocImmeuble.length; i++) {
                        var montant = $(sousBlocImmeuble.get(i)).find('[name="montant"]').autoNumeric('get');
                        if (!montant) montant = 0;
                        sommeI += parseInt(montant);
                    }
                }

                containerB98RepartitionFiscaleApres.find('[name="b98_valeur_terrain' + scolaire + '"]').autoNumeric('set', sommeT);
                containerB98RepartitionFiscaleApres.find('[name="b98_valeur_batiment' + scolaire + '"]').autoNumeric('set', sommeB);
                containerB98RepartitionFiscaleApres.find('[name="b98_valeur_immeuble' + scolaire + '"]').autoNumeric('set', sommeI);


            }

            //générer repaattiotn fiscale
            function initgenerationdesrepartitionsfiscales() {
                var containerB98RepartitionFiscaleApres = $('.apres-container [id="b98-repartition-fiscale"]');
                var divPanelBody = $('#accordion-repartition-fiscale-section').find('.panel-body');
                $('#btn-generer-repartition-fiscale').on('click', function () {
                    var valeurRetenueb98 = getValeurRetenue();

                    var params = {
                        id_ue: $('#wizard').attr('id-ue'),
                        date_evenement: $('#wizard').attr('date-evenement'),
                        valeur_batiment: valeurRetenueb98.valeurBatiment,
                        valeur_terrain: valeurRetenueb98.valeurTerrain
                    };
                    var jq = $.ajax({
                        type: "POST",
                        url: "/gestion-roles/tenue-a-jour/valeur-retenue/generer-repartition-fiscale/",
                        data: params,
                        dataType: 'json',
                        async: false,
                    });

                    jq.done(function (reponse) {
                        if (reponse.reponse == 'ok') {
                            infos.ajouterMessageToast({
                                message: "La liste des répartitions fiscales a été générée. Rechargement en cours .....",
                                messageDuree: 3000
                            });
                            //hack pour sauvegarder et recharger les répartitions fiscales directement
                            var parametres = {
                                id_ue: $('#wizard').attr('id-ue'),
                                id_evenement: $('#wizard').attr('id-evenement'),
                                date_evenement: $('#wizard').attr('date-evenement'),
                                id_type_evenement: $('#wizard').attr('id_type_evenement')
                            };

                            $.ajax({
                                type: "GET",
                                url: "/gestion-roles/tenue-a-jour/repartition-fiscale-contenu/",
                                data: parametres,
                                dataType: 'html',
                                success: function (response) {
                                    divPanelBody.html(response);
                                    var options = {blocsContainer: divPanelBody};
                                    initBlocsCharges(null, '98', options);
                                    init_change_event_sous_bloc();
                                    formaterMonnaie(divPanelBody.find('input.money'), 0);
                                    initBlocRepartitionsFiscales();
                                    divPanelBody.find('.apres-container [name="b94_valeur_terrain"]').autoNumeric('set', valeurRetenueb98.valeurTerrain);
                                    divPanelBody.find('.apres-container [name="b94_valeur_batiment"]').autoNumeric('set', valeurRetenueb98.valeurBatiment);
                                    divPanelBody.find('.apres-container [name="b94_valeur_immeuble"]').autoNumeric('set', valeurRetenueb98.valeurImmeuble);

                                }
                            });
                            //$('#btn-wizard-recharger').trigger("click");
                            estrepfiscale = 1;
                        } else {
                            infos.ajouterMessageToast({
                                message: reponse.reponse,
                                messageDuree: 10000,
                                messageCouleur: "red"
                            });
                        }
                    });

                    jq
                        .fail(function (xhr, ajaxOptions, thrownError) {
                            erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', reponse.message);
                            messageToastCompteur = 0;
                            infos.ajouterMessageToast({
                                message: "Erreur lors de la génération des répartitions fiscales. svp contacter un administrateur",
                                messageDuree: 5000,
                                messageCouleur: "red"
                            });
                        });


                });
                if (estrepfiscale == 1) {
                    b98QuestionOmiseInscrite();
                    // si un montant est modifié, avec sp_generer_repartitions_fiscales forcer une 'valeur-modifiee' dans b98 afin d'être prise en compte lors de la sauvegarde
                    containerB98DispositionApres.find('[name="montant"]').filter(function () {
                        if ($(this).autoNumeric('get')) {
                            containerB98RepartitionFiscaleApres.find('[name="b94_type_fiscal"]').addClass('valeur-modifiee');
                        }
                    });
                    wait.stop();
                    initB98RepartitionFiscale(divPanelBody);
                    initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionApres);
                    initsommeTBIrepartitionsfiscales(containerB98RepartitionFiscaleApres, containerB98DispositionScolaireApres, '_scolaire');

                    estrepfiscale = 0;
                }
            }

            initgenerationdesrepartitionsfiscales();

        }


        /**
         * Déclenchement des filtres dépendants préenregistrés lorsque lechamp dépendant_de contient déjà des données (filtres enregistrés).
         * @param {string} conteneur - div auquel s'applique l'initialisation.
         * */
        function filtresDependantsDeclencher(value) {
            // Lancer l'appel Ajax pour récupérer les données...
            var champId = $(value).attr('id');
            var champDependantDeId = $(value).attr('data-dependant_de');
            // var selection = $('[name="' + champId + '"]').val(); // Selection active pour le select.
            // Dans le cas d'un select sur les filtres, on récupère le dernier élément de l'objet des filtres
            var champ_replace = champId.replace('id_', '');
            var champ_dependant_de = champDependantDeId.replace('id_', '');
            var longueurFiltres = filtresEvenements.reqListeFiltres().champs[champ_dependant_de].filtres;
            var selection = [];
            $.each(longueurFiltres, function (index, valeur) {
                selection.push(valeur.id);
            });
            var filtres = filtresEvenements.reqListeFiltres().champs[champ_replace];
            var champsDynamiques = [];
            champsDynamiques.push({
                "nom_filtre": champ_replace,
                "champ": filtres.parametres[0].champ,
                "taille": filtres.parametres[0].taille,
                "dependant_de": filtres.parametres[0].dependant_de,
                "dependant_de_valeur": JSON.stringify(selection)
            });
            filtresEvenements.chargerTagsFiltresRecherche(champsDynamiques);
            $('select.filtre-select').off('change').on('change', function (a) {
                tenueAJourBoutons.initialiserBoutonFiltre(a);
            });
        }

        /**
         * Fonction d'initialisation des dépendances de sélection sur des select.
         * @param {string} conteneur - div auquel s'applique l'initialisation.
         * */
        function initSelectDependant(conteneur) {
            var $cible = $(conteneur);
            var listeDependances = $cible.find('[data-dependant_de]'); // On liste les input et select qui présentent des dépendances de sélection ou d'activation.
            $.each(listeDependances, function (key, value) {
                // pour chaque dépendance, on crée l'event de gestion de la sélection.
                var parent = $(value).attr('data-dependant_de');
                $(document).on('change', '[name="' + parent + '"]', function () {
                    tenueAJourModal.filtresDependantsDeclencher(value);
                });
            });
        }

        /**
         * Fonction de déclaration des calculs automatiques entre champs (passé par le serializer).
         * */
        var hasSegmentationManuelleDeLaSuperficie = true;
        var valeur_calculee_totale_originale = 0;

        function initCalculValeurAjustementManuel() {

            $('#b93-tranche-terrain-0-sous-bloc').find("[name='superficie'],[name='taux'], [name='facteur_ajustement']").change(function () {
                var containerRow = $(this).closest('.sous-bloc-form');

                var superficieChamp = containerRow.find('[name="superficie"]');
                var frontChamp = containerRow.find('[name="front"]');

                var superficieOuFront = TryParseFloat(superficieChamp.val(), 0);
                if (superficieOuFront == 0) {
                    superficieOuFront = TryParseFloat(frontChamp.val(), 0);
                }

                var taux = containerRow.find('[name="taux"]');
                var valeurCalculeeChamp = containerRow.find('[name="valeur_calculee"]');

                var valeurCalculee = Math.round(superficieOuFront * TryParseFloat(taux.val(), 0));
                valeurCalculeeChamp.val(valeurCalculee).change();
                valeurCalculeeChamp.autoNumeric('set', valeurCalculee);

                // # TODO: OBSOLETE?
                // #15443 + #13688 : code inutile? venait remplacer la valeur totale par la valeur d'une seule ligne.
                // var valeur_retenue_finale = $('#b93-valeur-terrain').find("[name='valeur_retenue']");
                // var total = Math.round(valeurCalculee * TryParseFloat(facteur_ajustement.val(), 1));
                // valeur_retenue_finale.val(total).change();
                // valeur_retenue_finale.autoNumeric('set', total);
                // valeur_retenue_finale.attr('value', total);
            });

            var sousBlocsTranche = $('[id^=b93-tranche-terrain-][id$=-sous-bloc]');
            sousBlocsTranche.find("[name='valeur_calculee'],[name='facteur_ajustement']").change(function () {
                var containerRow = $(this).closest('.sous-bloc-form');

                var valeur_calculee = containerRow.find('[name="valeur_calculee"]');
                var facteur_ajustement = containerRow.find('[name="facteur_ajustement"]');
                var valeur_retenue = containerRow.find('[name="valeur_retenue"]');

                var total = Math.round(TryParseFloat(valeur_calculee.val(), 0) * TryParseFloat(facteur_ajustement.val(), 1));
                valeur_retenue.val(total).change();
                valeur_retenue.autoNumeric('set', TryParseFloat(total));
            });

            var blocResultat = $('#b93-valeur-terrain');
            sousBlocsTranche.find("[name='valeur_retenue']").change(function () {
                calculerValeurRetenue();

            });
            sousBlocsTranche.find(".ctrl-suppression").change(function () {
                setTimeout(calculerValeurRetenue, 200);
            });

            function calculerValeurRetenue() {
                var sousBlocsTranche = $('[id^=b93-tranche-terrain-][id$=-sous-bloc] .sous-bloc-form').not('.nouvelle-ligne').not(':has(.suppression-ligne)');
                var sousBlocsTrancheManuel = $('[id=b93-tranche-terrain-0-sous-bloc] .sous-bloc-form').filter(sousBlocsTranche);
                if (sousBlocsTrancheManuel.length > 0) {
                    sousBlocsTranche = sousBlocsTrancheManuel;
                    hasSegmentationManuelleDeLaSuperficie = true;
                } else {
                    hasSegmentationManuelleDeLaSuperficie = false;
                }

                var total = 0;
                sousBlocsTranche.find("[name='valeur_retenue']").each(function () {
                    var valeur_retenue = $(this);
                    total += TryParseFloat(valeur_retenue.val(), 0);
                });

                var valeur_total_tranches = blocResultat.find('[name="valeur_total_tranches"]');
                valeur_total_tranches.val(total).change();

                valeur_total_tranches.autoNumeric('set', total);
                cacheDoublonValeursRecap();

            }

            function calculerTauxEffectif() {
                var containerRow = $('#b93-valeur-terrain');
                var valeur_retenue = containerRow.find('[name="valeur_retenue"]');
                var taux_effectif = containerRow.find('[name="taux_effectif"]');

                var valeur_calculee = TryParseFloat(valeur_retenue.val(), 0);
                var sousBlocsTranche = $('[id^=b93-tranche-terrain-][id$=-sous-bloc] .sous-bloc-form').not('.nouvelle-ligne').not(':has(.suppression-ligne)');
                var sousBlocsTrancheManuel = $('[id=b93-tranche-terrain-0-sous-bloc] .sous-bloc-form').filter(sousBlocsTranche);
                if (sousBlocsTrancheManuel.length > 0) {
                    sousBlocsTranche = sousBlocsTrancheManuel;
                    hasSegmentationManuelleDeLaSuperficie = true;
                } else {
                    hasSegmentationManuelleDeLaSuperficie = false;
                }

                var total_superficie = 0;
                sousBlocsTranche.find("[name='superficie']").each(function () {
                    var superficie = $(this);
                    total_superficie += TryParseFloat(superficie.val(), 0);
                });

                var taux_calcul = valeur_calculee / total_superficie;

                if (isNaN(taux_calcul) || !isFinite(taux_calcul)) {
                    taux_effectif.val('').change();
                } else {
                    var rounded_value = taux_calcul.toFixed(2);
                    var formatted_value = rounded_value + ' $';
                    taux_effectif.val(formatted_value).change();
                }

            }

            // Effectue le total du b93
            function calculeTotalB93() {
                var containerRow = $('#b93-valeur-terrain');

                var valeur_total_tranches = containerRow.find('[name="valeur_total_tranches"]');
                var valeur_calculee = containerRow.find('[name="valeur_calculee"]');
                var facteur_ajustement = containerRow.find('[name="facteur_ajustement"]');
                var valeur_retenue = containerRow.find('[name="valeur_retenue"]');
                var facteur_ajustement_val = TryParseFloat(facteur_ajustement.val(), 1);
                if (hasSegmentationManuelleDeLaSuperficie) {
                    var total = Math.round(TryParseFloat(valeur_total_tranches.val(), 0) * facteur_ajustement_val);
                } else {
                    var total = Math.round(TryParseFloat(valeur_calculee.val(), 0) * facteur_ajustement_val);
                }

                var valeur_manuelle = containerRow.find('[name="valeur_manuelle"]');
                if (valeur_manuelle.val() != '') {
                    total = TryParseFloat(valeur_manuelle.val(), 0);
                }

                valeur_retenue.val(total).change();
                valeur_retenue.autoNumeric('set', TryParseFloat(total));
                cacheDoublonValeursRecap();
            }

            blocResultat.find("[name='valeur_calculee'],[name='facteur_ajustement'],[name='valeur_manuelle']").change(function () {
                calculeTotalB93();
            });
            calculerValeurRetenue();
            calculerTauxEffectif();
        }

        function cacheDoublonValeursRecap() {
            // Permets de masquer le champ valeur calculée totale si identique du champ valeur totale des tranches
            var selecteur_val_tranches = '[name="valeur_total_tranches"]';
            var selecteur_val_calc = '#b93-valeur-terrain [name="valeur_calculee"]';
            $(selecteur_val_calc).parents('.row').show();  // init

            if (($(selecteur_val_tranches).val() == $(selecteur_val_calc).val()) || hasSegmentationManuelleDeLaSuperficie) {
                $(selecteur_val_calc).parents('.row').hide();
            } else if (!hasSegmentationManuelleDeLaSuperficie) {
                $(selecteur_val_calc).parents('.row').show();
            }
        }

        function surlignevaleurcalculer() {
            var selectors = [
                '#b93-valeur-terrain [name="valeur_calculee"]',
                '#b93-valeur-terrain [name="valeur_retenue"]',
                '#b93-valeur-terrain [name="taux_effectif"]'
            ];

            selectors.forEach(function (selector) {
                var elements = $(selector);
                if (elements.length > 0) {
                    elements.parent().addClass('suppression-ligne-test');
                }
            });
        }


        function calculerValeurTotaleDesTranches() {
            // #13688 : nouveau champ de total des tranches automatiques
            function getSommeMultiInput(jq_selecteur) {
                var tot = 0;
                $(jq_selecteur).each(function (e) {
                    tot += (Number($(this).val().replace('$', '').replace(' ', '')));
                });
                return tot;
            }

            var total_valeur_retenue = 0;
            if (hasSegmentationManuelleDeLaSuperficie) {
                total_valeur_retenue = getSommeMultiInput('#b93-tranche-terrain-0 [name="valeur_retenue"]');
            } else {
                total_valeur_retenue = getSommeMultiInput('#accordion-section-methode-auto [name="valeur_retenue"]');
            }


            if (total_valeur_retenue) {
                $('[name="valeur_total_tranches"]').val(total_valeur_retenue);
                $('[name="valeur_total_tranches"]').autoNumeric('set', total_valeur_retenue);
            }
        }

        // DM: fonction générale d'initialisation d'une page du wizard (appliqué uniquement à l'étape Valeur Retenue pour l'instant)
        function initWizardBlocs(options) {
            initBlocsCharges(null, null, options);
        }

        /**
         * Fonction de sauvegarde de l'étape de la valeur retenue.
         * */
        function saveValeurRetenue(callback) {

            var formValeurRetenueApres = $('#b94-section-apres');
            var containerB98RepartitionFiscale = $('.apres-container #b98-repartition-fiscale');

            // sert pour la page 'Ne s'applique pas'
            if (formValeurRetenueApres.length == 0 && containerB98RepartitionFiscale.length == 0) {
                var response = {};
                response.reponse = 'ok';
                callback(response);
                return;
            }

            // enlever la classe 'blocForm' sur le 'avant' de la valeur retenue pour ne pas la sauvegarder
            var formValeurRetenueAvant = $('#b94-section-avant').find('.blocForm');
            formValeurRetenueAvant.removeClass('blocForm');

            // enlever la classe 'blocForm' sur le 'avant' de la répartition fiscale pour ne pas la sauvegarder
            var formRepartitionFiscaleAvant = $('.avant-container #b98-repartition-fiscale');
            formRepartitionFiscaleAvant.removeClass('blocForm');

            var containerB98Disposition = containerB98RepartitionFiscale.find('#b98-repartition-fiscale-haut-sous-bloc .row.body');
            var b98Lignes = containerB98Disposition.find('.sous-bloc-form[id-model-instance!="None"]').not('.nouvelle-ligne');
            var b98LignesSuppression = b98Lignes.filter(function () {
                return $(this).find('.suppression-ligne').length > 0;
            });
            var b98NouvelleLigne = containerB98Disposition.find('.sous-bloc-form.nouvelle-ligne');
            var estB98LigneBoolDeleteTrue = b98NouvelleLigne.attr('id-model-instance') != 'None';

            preSaveRepartitionsFiscales(b98Lignes, b98LignesSuppression, b98NouvelleLigne, estB98LigneBoolDeleteTrue);

            var containerB98DispositionScolaire = containerB98RepartitionFiscale.find('#b98-repartition-fiscale-bas-scolaire-sous-bloc .row.body');
            var b98LignesScolaire = containerB98DispositionScolaire.find('.sous-bloc-form[id-model-instance!="None"]').not('.nouvelle-ligne');
            var b98LignesSuppressionScolaire = b98LignesScolaire.filter(function () {
                return $(this).find('.suppression-ligne').length > 0;
            });
            var b98NouvelleLigneScolaire = containerB98DispositionScolaire.find('.sous-bloc-form.nouvelle-ligne');
            var estB98LigneBoolDeleteTrueScolaire = b98NouvelleLigneScolaire.attr('id-model-instance') != 'None';

            preSaveRepartitionsFiscales(b98LignesScolaire, b98LignesSuppressionScolaire, b98NouvelleLigneScolaire, estB98LigneBoolDeleteTrueScolaire);

            var callbackSaveWizardBlocs = function (response) {
                if (response.reponse == 'ok') {

                    // remettre la classe 'blocForm' sur la partie de gauche de la valeur retenue
                    formValeurRetenueAvant.addClass('blocForm');

                    // remettre la classe 'blocForm' sur la partie de gauche de la répartition fiscale
                    formRepartitionFiscaleAvant.addClass('blocForm');

                    postSaveRepartitionsFiscales(containerB98RepartitionFiscale, b98LignesSuppression, b98NouvelleLigne, estB98LigneBoolDeleteTrue);
                    postSaveRepartitionsFiscales(containerB98RepartitionFiscale, b98LignesSuppressionScolaire, b98NouvelleLigneScolaire, estB98LigneBoolDeleteTrueScolaire);

                } else if (response.reponse == 'error') {
                    resetB98NouvelleLigne(b98NouvelleLigne);
                    resetB98NouvelleLigne(b98NouvelleLigneScolaire);
                }

                callback(response);
            };

            var options = {conteneur: $('#table-choix-methode'), paramsSupp: {sauvegarde_complet: true}};
            saveWizardBlocs(callbackSaveWizardBlocs, options);
        }

        function resetB98NouvelleLigne(b98NouvelleLigne) {
            // remettre la 'nouvelle-ligne' comme avant la sauvegarde pour que ça fonctionne à la
            // prochaine sauvegarde
            b98NouvelleLigne
                .addClass('nouvelle-ligne')
                .attr('modifie', 'False')
                .find('[name="montant"]').removeClass('valeur-modifiee').end()
            ;
        }

        function getValeurRetenue() {

            var containerB98RepartitionFiscale = $('.apres-container #b98-repartition-fiscale');
            var valeurTerrain = containerB98RepartitionFiscale.find('[name="b94_valeur_terrain"]').autoNumeric('get');
            var valeurBatiment = containerB98RepartitionFiscale.find('[name="b94_valeur_batiment"]').autoNumeric('get');
            var valeurImmeuble = containerB98RepartitionFiscale.find('[name="b94_valeur_immeuble"]').autoNumeric('get');

            var valeurRetenue = {};
            valeurRetenue.valeurTerrain = entierArrondirAu(valeurTerrain, 100);
            valeurRetenue.valeurBatiment = entierArrondirAu(valeurBatiment, 100);
            valeurRetenue.valeurImmeuble = entierArrondirAu(valeurImmeuble, 100);

            return valeurRetenue;
        }

        function preSaveRepartitionsFiscales(b98Lignes, b98LignesSuppression, b98NouvelleLigne, estB98LigneBoolDeleteTrue) {
            if (b98Lignes.length) {
                // si toutes les lignes sont supprimées, on veut sauvegarder une ligne 'bool_delete=True'
                // ou s'il y a une ligne bool_delete=True au chargement, on veut la supprimer
                if (b98LignesSuppression.length == b98Lignes.length || estB98LigneBoolDeleteTrue) {
                    b98NouvelleLigne.removeClass('nouvelle-ligne');
                    // notifier qu'une donnée à changer pour faire la sauvegarde de cette ligne
                    b98NouvelleLigne.find('[name="montant"]').val(0).addClass('valeur-modifiee');
                }
                // s'il y avait une ligne avec bool_delete=True(bd) et qu'on a ajouté des lignes, on doit indiquer que la ligne 'bool_delete=True'
                // doit être supprimée
                if (estB98LigneBoolDeleteTrue) {
                    b98NouvelleLigne.find('[name="montant"]').parent().addClass('suppression-ligne');
                }
            }
        }

        function postSaveRepartitionsFiscales(containerB98RepartitionFiscale, b98LignesSuppression, b98NouvelleLigne, estB98LigneBoolDeleteTrue) {
            // reset la nouvelle ligne
            b98NouvelleLigne
                .addClass('nouvelle-ligne')
                .attr('modifie', 'False')
                .find('[name="montant"]').removeClass('valeur-modifiee').end()
            ;

            if (estB98LigneBoolDeleteTrue) {
                b98NouvelleLigne.find('[name="montant"]').parent().removeClass('suppression-ligne-sauvegardee');
            }

            // enlever les lignes en suppression de l'interface
            if (b98LignesSuppression.length) {
                b98LignesSuppression.remove();
                var checkboxTousIcone = containerB98RepartitionFiscale.find('#ctrl-suppression-tous').parent().find('i');
                checkboxTousIcone.removeClass('tout-active').addClass('tout-desactive');
            }

            // remettre le bloc en mode 'create' car il n'y aura jamais de update
            containerB98RepartitionFiscale.attr('id_model_instance', 'None');
            containerB98RepartitionFiscale.attr('bloc_editable', 'False');
        }

// DM: fonction générale de save d'une page du wizard (appliqué uniquement à l'étape Valeur Retenue pour l'instant)
        function saveWizardBlocs(callback, options) {
            var afficherReussi = (typeof (options) == 'undefined') || (typeof (options.afficherReussi) == 'undefined') || options.afficherReussi;

            var callbackSaveWizardBlocs = function (response) {
                if (typeof (callback) !== 'undefined' && response.reponse !== 'undefined') {
                    if (afficherReussi || response.reponse != 'ok') {
                        messageToastCompteur = 0;
                        sauvegarderDonneesMessageToast('', 1, response.reponse, nbErreurs);
                    }

                    if (response.reponse == 'ok') {
                        $('button[data-type="save"]').prop("disabled", true);
                    }
                    callback(response);
                }
            };
            saveBlocs(true, callbackSaveWizardBlocs, options, function () {});
        }

        function traiterErreursWizard(form, erreurs) {
            var xhr = '';
            if ('formulaires' in erreurs) {
                $.each(erreurs.formulaires, function (index, value) {
                    $.each(value, function (formulaire, champs) {
                        $.each(champs, function (champ, valeur) {
                            var visibleBootstrap = $('#' + formulaire + '[type="formulaire"].visible-' + getBootstrapCurrentSize()).length === 1 ? '[class*="visible-' + getBootstrapCurrentSize() + '"]' : '';
                            erreursAjax.afficherErreurChamps($('#' + formulaire + '[type="formulaire"]' + visibleBootstrap), champ, valeur, xhr);
                        });
                    });
                    $('.form.alert').fadeIn();
                });
            } else {
                $.each(erreurs, function (champ, valeur) {
                    var textes = valeur.texte || valeur;
                    if (valeur.sous_bloc !== undefined) {
                        $.each(valeur.sous_bloc, function (sousBlocKey, sousBlocValue) {
                            var formSousBloc = form;

                            if (!formSousBloc.is('.sous-bloc-form')) { // sinon ça foirait exemple pour b44-chauffage-renovation (erreur de combinaison) l'où on était déjà dans le sous-bloc et qu'on repointait vers le sous-bloc
                                formSousBloc = form.find('#' + sousBlocKey);
                            }

                            erreursAjax.afficherErreurChamps(formSousBloc, champ, sousBlocValue.texte[0], xhr);
                        });
                    } else {
                        $.each(textes, function (index) {
                            erreursAjax.afficherErreurChamps(form, champ, textes[index], xhr);
                        });
                    }

                    $('.form.alert').fadeIn();
                });
            }
            fenetreModal.calculerHauteurModal(form.closest('.modal'));
        }

        /**
         * Fonction d'initialisation de l'étape du certificat.
         * */
        function initCertificat() {
            // #18159: forcer le rechargement de l'étape Planification de l'inspection du permis.
            // une fois l'étape du certificat initialisée, un traitement spécifique est présent dans l'inspection.
            var etapeProcessus = 4; // ce id_etape_processus est seulement disponible dans le permis
            var etape = $('ul.steps').find('li[data-id_processus=' + etapeProcessus + ']').attr('data-step');
            $('#modal-step' + etape).attr('recharger', 'oui');

            init_certificat();

            $('#btn-supp').html('<button id="btn-certificat-imprimer" class="btn btn-sm btn-primary pull-left" title="" data-placement="top" data-type="print" data-toggle="tooltip"><i class="ace-icon fa fa-print"></i>Imprimer</button>');

            $("#btn-certificat-imprimer").on("click", function () {
                $('#export-pdf-certificat-unites-evaluation').val($('#wizard').attr('id-ue'));
                $('#export-pdf-certificat-date-evenement').val($('#wizard').attr('date-evenement'));
                $('#export-pdf-certificat-id-municipalite').val($('#wizard').attr('id-municipalite'));
                $('#export-pdf-certificat-id-evenement').val($('#wizard').attr('id-evenement'));
                $("#frm-export-pdf-certificat").submit();

            });
            $("#btn-pdf-certificat").off('click').on("click", function () {
                const url = '/gestion-roles/certificat/pdf/';
                const $form = $('#certificat-pdf-form');
                let data = $form.serialize();
                data += '&id_evenement=' + encodeURIComponent($('#wizard').attr('id-evenement'));
                const success_cb = function (resp) {
                    const modal = $('#modal-print-certificat');
                    $(modal).modal({
                        show: true,
                        backdrop: 'static'
                    });
                    $(modal).find('.modal-body').html(resp.template);

                };
                call_ajax(url, 'POST', data, success_cb);
            });


            etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');

        }

// On valide que chaque champ avant/après a le même scrollheight. On fait du cas par cas étant donné que le certificat a été créé en utilisant une table et non des divs. TODO: utiliser des divs pour la mise en page et non des tables...
        /**
         * Fonction de qui ajuste la hauteur de deux TD AVANT/APRÈS qui doivent avoir les mêmes hauteurs.
         * @param {array} sectionsAComparer - Sections qui contiennent des éléments à comparer. Permet d'utiliser des classes similaires dans des sections différentes.
         * @param {array} balisesAComparer - Avant, Après (.identification-avant, .identification-apres) ou tout autre concaténation définie dans le modèle.
         * */
        function ajusterHauteurTdComparees(sectionsAComparer, balisesAComparer) {
            var sections = sectionsAComparer;
            var aComparer = balisesAComparer;
            $.each(sections, function (index, section) {
                var cible = 'td#' + section + '-' + aComparer[0];
                var listeScrollHeight = $(cible).find('span[class*="scrollheight"]');
                $.each(listeScrollHeight, function (index, classe) {
                    var spanNom = '';
                    var spanClasse = $(this).attr('class').split(' ');
                    $.each(spanClasse, function (index, classe) {
                        if (classe.search("scrollheight") != -1) {
                            spanNom = classe;
                            return;
                        }
                    });
                    var listeComparatifs = $('#' + section).find('[class*="' + spanNom + '"]');

                    var maxSpanHauteur = 0;
                    $.each(listeComparatifs, function (index, element) {
                        if ($(element).prop('scrollHeight') > maxSpanHauteur) {
                            maxSpanHauteur = $(element).prop('scrollHeight');
                        }
                    });

                    $('#' + section).find('[class*="' + spanNom + '"]').height(maxSpanHauteur);
                });
            });
        }

        /**
         * Fonction de sauvegarde de l'étape du certificat.
         * */
        function saveCertificat(callback) {
            nbErreurs = 0;
            // cr�ation d'un json � partir d'un tableau
            var list_certificat = tableToJson('table-certificat-eec');
            var list_evenement = tableToJson('table-evenements-eec');

            var params = {
                list_certificat: list_certificat,
                list_evenement: list_evenement,
                nb_motif_certificat: $('#motif-certificat').find('ul li').length,
                certificat_sans_modification: $('#certificat-modification').attr('sans-modif'),
                propagation_sans_modification: $('#contenu .emettre-certificat:checkbox').attr('propagation-sans-modification')
            };
            var currentForm = $('#certificat-toggle');
            var idUe = $('#wizard').attr('id-ue');//$('#save-certificat').data('id_ue');

            $.ajax({
                type: "POST",
                url: '/gestion-roles/save-certificat/' + idUe + '/',
                dataType: 'json',
                data: params,
                success: function (response) {

                    traitementPostSauvegarde(currentForm);
                    erreursAjax.effacerErreurChamps(currentForm);
                    var certificat_json = response;

                    // on remet la valeur id_certificat à l'attribut dataValue afin de refléter la bd après la sauvegarde

                    let i = 0;
                    $('#table-certificat-eec tbody tr').each(function () {
                        $(this).find('.id-certificat').attr('dataValue', certificat_json[i]);
                        i++;
                    });

                    $('#table-evenements-eec tbody tr').each(function () {
                        $(this).find('.id-certificat').attr('dataValue', certificat_json[i]);
                        i++;
                    });

                    $('button[data-type="save"]').attr("disabled", true);
                    if (typeof (callback) !== 'undefined') {
                        callback({reponse: 'ok'});
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {

                    if (typeof (callback) !== 'undefined') {
                        var response = {};
                        response.reponse = 'error';
                        callback(response);
                    }

                    erreursAjax.traiterErreurs(currentForm, xhr, thrownError);
                    $('.tooltip').remove();

                    nbErreurs += 1;
                    messageToastCompteur = 0;
                    sauvegarderDonneesMessageToast('', 1, xhr, nbErreurs);
                }
            });
        }

        /**
         * Fonction de validation de la localisation des travaux. Il ne s'agit pas d'un formulaire. La gestion du bouton suivant ne pas pas uniquement par la fonction enregister.
         * */
        function validateLocalisationTravauxPermis() {
            var valide = false;
            var ues = $('form[data-type="travaux-localisation-ues"]').find('input').serializeArray();
            var selection = $('div[data-type="travaux-localisation-selection"]').find('input').serializeArray();
            var erreur;
            // On doit valider que pour un évènement d'opération UE, que la sélection de recherche UE ne comporte qu'un seul élément.
            if (selection.length > 1 && $('#wizard').attr('id-type-evenement') === '32') {
                erreur = "Pour un évènement d'opération UE, vous ne pouvez pas sélectionner plus d'une unité d'évaluation";
                erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', erreur);
                // Du fait que l'étape de la localisation des travaux ne contient pas de formulaire, on doit implanter un contrôle minimal de validation. Uniquement si l'étape affiche la boîte de recherche de l'explorateur d'UE. Dans le cas contraire, la sélection est déjà effectuée.
                ues = nettoyerParams(ues);
                selection = nettoyerParams(selection);
            } else if (selection.length > 1 && $('#modal-step-contents > .active').attr('changer-ue-permis') === 'True') {
                erreur = "Pour un changement d'unité d'évaluation, vous ne pouvez pas sélectionner plus d'une unité d'évaluation";
                erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', erreur);
            } else if (ues.length <= 0 || selection.length <= 0 && ($('#wizard').attr('id_ue') === undefined && $('ue-infos-toggle').length <= 0)) {
                erreur = "Vous devez saisir une unité d'évaluation ou un matricule ou encore sélectionner un résultat de recherche avant de poursuivre à l'étape suivante.";
                erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', erreur);
            } else if (ues.length > 0 || selection.length > 0) {
                var params = ues.concat(selection);
                params.push({"name": "id_municipalite", "value": $('#wizard').attr('id-municipalite')});
                params.push({"name": 'date_debut', "value": $('#wizard').attr('date-evenement')});
                var jqxhr = $.ajax({
                        url: '/gestion-roles/tenue-a-jour/valider-localisation_travaux/',
                        async: false,
                        data: params
                    }
                );
                jqxhr
                    .done(function (response) {
                        var reponse = JSON.parse(response);
                        valide = reponse.est_valide;

                        if (!(reponse.est_valide)) {
                            erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', reponse.message);
                        }
                    });
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', xhr, errorThrown);
                    });
            } else {
                valide = true;
            }
            return valide;
        }

        /**
         * Fonction de validation d'une étape qui permet de valider avant la sauvegarde. Utile dans le cas où une étape du wizard n'est pas un formulaire mais doit tout de même etre validée.
         * */
        function validerEtape() {
            // On call la fonction de validation spécifique à l'étape en cours si définie dans la bd
            var etape = $('.steps').find('.active').attr('data-step');
            var selecteurModal = '#modal-step' + etape;
            // On obtient les paramètres propres à l'étape stockés dans la bd (table:etape_processus champs:vues_variables)
            var selecteurVueVariables = $(selecteurModal).attr('vue-variables');

            if (selecteurVueVariables != 'None' && selecteurVueVariables != '') {
                selecteurVueVariables = $.parseJSON($(selecteurModal).attr('vue-variables'));
                if (selecteurVueVariables.validate) {
                    var nomFonction = selecteurVueVariables.validate.split('.');
                    if (nomFonction.length > 1) {
                        return window[nomFonction[0]][nomFonction[1]].apply(window);
                    } else {
                        return window[selecteurVueVariables.validate].apply(window);
                    }
                }
            }
            // TODO: Vérifier si on implémente une validation par défaut si non définie dans la bd pour une étape
            return true; // On indique que la validation est ok par défaut si une fonction de validation de l'étape n'est pas présente dans la BD.
        }


        /**
         * Fonction d'initialisation de l'étape 1 du processus d'actualisation de l'inventaire.
         * */
        function initActualisationInventaireEtape1() {

            $('#actualisation-inventaire-extraction-parametres').find('select').select2();
        }

        /**
         * Fonction de sauvegarde de l'étape 1 du processus d'actualisation de l'inventaire.
         * */
        function saveActualisationInventaireEtape1(callback) {
            var currentForm = $('#modal-step-contents > .active .form-horizontal');
            var params = currentForm.serialize();
            var response = {};

            var idMunicipalite = currentForm.find('#municipalite').val();
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');

            $.ajax({
                type: "POST",
                //url: '/gestion-roles/tenue-a-jour/actualisation-inventaire/etape1/',
                url: '/gestion-roles/actualisation-inventaire/',
                data: params,
                async: false, // Nécessaire pour s'assurer d'attendre le résultat de la sauvegarde/validation avant de passer à l'étape suivante
                dataType: 'json', // VIP sinon la sauvegarde passe par le HtmlFormRenderer et ca plante
                success: function (response) {

                    if (idMunicipalite && idTypeEvenement) {
                        validerFermetureCycle(idMunicipalite, idTypeEvenement);
                    }

                    erreursAjax.effacerErreurChamps(currentForm);
                    if (typeof (callback) !== 'undefined') {
                        response.reponse = 'ok';
                        callback(response);
                    }

                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (typeof (callback) !== 'undefined') {
                        response.reponse = 'error';
                        callback(response);
                    }

                    erreursAjax.traiterErreurs(currentForm, xhr, thrownError);
                    $('.tooltip').remove();
                }
            });

        }

        /**
         * Fonction d'initialisation de l'étape 2 du processus d'actualisation de l'inventaire.
         * */
        function initActualisationInventaireEtape2() {
            setTimeout(function () {
                var formEtape1 = $('#modal-step-contents > #modal-step1 .form-horizontal');
                var params = formEtape1.serialize();
                params.id_type_evenement = TYPE_EVENEMENT['actualisation_inventaire'];
                wait.start('contenu');
                $.ajax({
                    type: "GET",
                    url: '/gestion-roles/tenue-a-jour/actualisation-inventaire/etape2/',
                    data: params,
                    dataType: 'json',
                    success: function (response) {

                        var etape = $('#modal-step-contents > .active');
                        etape.html(response['html']);
                        etape.attr('recharger', 'oui');
                        if (response['nb_actualisation_a_faire'] == 0) {
                            $('#btn-wizard-suivant-terminer').prop('disabled', true);
                        }
                        wait.stop('contenu');
                    }
                });
                // Callback lorsqu'on clic sur le bouton terminer
                $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                    params.id_type_evenement = TYPE_EVENEMENT['actualisation_inventaire'];
                    wait.start();
                    setTimeout(function () {
                        var jqxhr = $.ajax({
                            url: '/gestion-roles/tenue-a-jour/actualisation-inventaire/insert-evenement/',
                            async: false,
                            type: "GET",
                            dataType: 'html',
                            data: params
                        });
                        jqxhr
                            .done(function (response) {
                                if (response == 'ok') {
                                    fenetreModal.fermerModal('modal-wizard-evenement');
                                    refreshDatatables();
                                    wait.stop();
                                } else {
                                    infos.ajouterMessageToast({
                                        message: "Erreur d'exécution de la commande d'actualisation de l'inventaire en lot",
                                        messageCouleur: 'red'
                                    });
                                    wait.stop();
                                }
                            });
                        jqxhr
                            .fail(function (xhr, textStatus, errorThrown) {
                                infos.ajouterMessageToast({
                                    message: "Erreur d'exécution de la commande d'actualisation de l'inventaire en lot",
                                    messageCouleur: 'red'
                                });
                                wait.stop();
                            });
                    }, 10);
                });
            }, 10);
        }


        /**
         * Fonction qui recopie la valeur de "date_fin_reelle" vers tous les inputs "date_evenement" POUR TOUS ET UNIQUEMENT tous les permis (Type d'évènement 1) à l'étape de la saisie du rapport d'inspection.
         * */
        function copierDateFinReelleTravauxDansPriseEffetRolePermis() {
            var donnee = $('#inspection-rapport').find('input[name="date_fin_reelle"]').val();
            var $idFormulairesCibles = $('*[id*=inspection-type_evenement-1][data-type="date_effective-evenement"]:visible');
            var $cibles = $idFormulairesCibles.find('input[name="date_evenement"]');
            $cibles.val(donnee).trigger("input").trigger('change');
        }


        function clickRadio(radioClique, radios) {
            var autresRadios = radios.not(radioClique);
            radioClique.attr('checked', 'checked');
            radioClique.parent().find('i').addClass('fa-check-square-o').removeClass('fa-square-o');
            autresRadios.removeAttr('checked');
            autresRadios.parent().find('i').addClass('fa-square-o').removeClass('fa-check-square-o');
        }


        /**
         * Fonction de fermeture de l'évènement suite à un message de confirmation de l'évènement.
         */
        function saveModalAlertConfirmationFermetureEvenement(callback) {
            var etape = $('#modal-step-contents > .active');
            var erreurs = etape.find('.wiz-validation .wiz-validation-erreur');
            if (erreurs.length > 0) {
                var idTypeEvenement = $('#wizard').attr('id-type-evenement');
                if (idTypeEvenement == TYPE_EVENEMENT.permis || idTypeEvenement == TYPE_EVENEMENT.actualisation_inventaire) {
                    $('#btn-wizard-suivant-terminer').prop('disabled', true);
                }
            }
            // code commenté temporairement #25148
            var params = {
                planification_inspection: false
            };
            // var params = {}
            // if (idTypeEvenement == TYPE_EVENEMENT.permis || idTypeEvenement == TYPE_EVENEMENT.actualisation_inventaire) {
            //     params = {
            //         planification_inspection: false
            //     };
            // }
            var id_evenement = $('#wizard').attr('id-evenement');
            $.ajax({
                type: "POST",
                url: '/gestion-roles/tenue-a-jour/fermeture-evenement/' + id_evenement + '/save/',
                data: params,
                dataType: 'json',
                success: function (response) {
                    var jqxhr = $.ajax({
                        type: "GET",
                        url: "/gestion-roles/" + id_evenement + "/valider-evenement-rouvert/",
                        data: params,
                        dataType: 'json'
                    });
                    jqxhr
                        .done(function (response1) {
                            var reponse1 = response1;
                            if (reponse1.reponse == 'ok') {
                                checkTraiterProchainEvenementLie(response.evenement_lie, callback);
                            } else {
                                fenetreModal.modalMessage({
                                    titre: reponse1.erreur.titre,
                                    sansX: true,
                                    taille: 'grande',
                                    texteExplicatif: reponse1.erreur.message,
                                    boutons: {
                                        "Fermer": {
                                            label: " Fermer ",
                                            id: "rouvrir",
                                            class: "btn",
                                            action: function () {
                                                setTimeout(function () {
                                                    fenetreModal.fermerModal('rouvrir');
                                                    wait.stop();
                                                    checkTraiterProchainEvenementLie(response.evenement_lie, callback);

                                                }, 10);
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    jqxhr
                        .fail(function (jqxhr, textStatus, errorThrown) {

                            fenetreModal.fermerModalAlerteDivs();
                            var reponse1 = {reponse1: 'cancel'};
                            callback(reponse1);
                        });
                }
            });

        }

        function checkTraiterProchainEvenementLie(evenement_lie, callback) {
            if (evenement_lie) {
                var idEvenement = evenement_lie.id_evenement;
                var descEvenement = evenement_lie.desc_evenement;
                var titre = "Il existe un autre évènement lié encore ouvert de type " + descEvenement + ". Voulez-vous traiter cet évènement maintenant ?";
                fenetreModal.modalMessage({
                    titre: titre,
                    //classe: 'modal-dialog',
                    sansX: true,
                    texteExplicatif: "",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function (response) {
                                fermerModaleEtRefreshTable();
                                tenueAJourModal.ouvrirWizardEvenement(idEvenement);
                                var reponse = {};
                                reponse.reponse = 'ok';
                                callback(reponse);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fermerModaleEtRefreshTable(wait.stop());
                                var reponse = {};
                                reponse.reponse = 'cancel';
                                callback(reponse);
                            }
                        }
                    }
                });
            } else {
                var reponse = {};
                reponse.reponse = 'ok';
                fermerModaleEtRefreshTable();
                callback(reponse);
            }
        }

        /**
         * Fonction confirmation de sauvegarde de l'étape de planification d'inspection de permis.
         * vient du etape_processus:
         *      {"init": "tenueAJourModal.initPlanificationInspectionPermis",
         *       "save": "tenueAJourModal.savePlanificationInspectionPermis",
         *       "before_save": "tenueAJourModal.savePlanificationInspectionPermisConfirmation"}
         */
        function savePlanificationInspectionPermisConfirmation(callback) {
            wait.start('contenu');
            // #18159 : validation que des données fiches ou certificat ne sont pas présente
            var etape_rapport_inspection_sans_modif = Boolean(Number($('#etape_rapport_inspection_sans_modif').val()));
            var avec_modif_ou_certificat_coche = !etape_rapport_inspection_sans_modif;
            if( $('#etape_rapport_evenement_bool_certificat').length) {
                var etape_rapport_evenement_bool_certificat = Boolean(Number($('#etape_rapport_evenement_bool_certificat').val()));
                avec_modif_ou_certificat_coche = avec_modif_ou_certificat_coche || etape_rapport_evenement_bool_certificat;
            }
            var reponse = {};
            if (avec_modif_ou_certificat_coche && $('#permis-ue-planification-planification').find('#radio_non').is(':checked')) {
                fenetreModal.modalMessage({
                    titre: "Attention",
                    sansX: true,
                    texteExplicatif: "Si une inspection n'est pas requise, vous devez tout d'abord vous assurer que la valeur retenue pour cette unité d'évaluation lors de cet évènement n'a pas été modifiée et que l'émission d'un certificat soit décochée. Vous pourrez ensuite revenir à cette étape pour fermer l'évènement.",

                    boutons: [
                        {
                            label: " Fermer ",
                            title: "Fermer",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                                wait.stop('contenu');

                            }
                        }
                    ]
                });

            }else if ($('#permis-ue-planification-planification').find('[name=form-field-radio]:checked').val() === "False") {
            // Valider que la fiche a déjà été sauvegardée avant de poursuivre.
            // Si a déjà été sauvegardée, autoriser la suite.
            // Sinon : afficher message d'erreur.
                reponse = {};
                fenetreModal.modalMessage({
                    classe: 'modal-dialog',
                    conteneur: '#wizard',
                    titre: "Sauvegarder ?",
                    ombre: true,
                    sansX: true,
                    texteExplicatif: "Vous avez indiqué qu'une inspection ne sera pas requise pour ce permis. Il n'y aura donc aucun changement au rôle ni aux fiches (bâtiments/terrain/renseignements administratifs) ni de certificat émis. L'évènement sera fermé automatiquement.<br><br>Voulez-vous continuer ?",


                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "btn_oui",
                            class: "btn btn-success",
                            action: function (response) {
                                reponse.reponse = 'ok';
                                wait.stop('contenu');
                                callback(reponse);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "btn_non",
                            class: "btn",
                            action: function () {
                                reponse.reponse = 'cancel';
                                wait.stop('contenu');
                                callback(reponse);
                            }
                        }
                    }
                });
            } else {
                reponse.reponse = 'pass'; // doit canceller l'appel. On redéclenche ici.
                callback(reponse);
            }

        }

        function validerDateEvenementPermisSansInspection(idEvenement, idTypeEvenement,etapeProcessus )
        /**
         * Fait les vérifications de dates avant de procéder à la fermeture de l'événement. Cette fonction est appelée
         * suite à l'étape 4 (Planification de l'inspection), lorsque aucune inspection n'est prévue, et donc lorsque
         * les autres étapes seront sautées.
        * */
        {
            let params = {'id_evenement': idEvenement, 'id_type_evenement': idTypeEvenement, 'id_etape_processus': etapeProcessus};
            let jqxhr = $.ajax({
                type: "POST",
                url: "/gestion-roles/fermeture-evenement/valider-date-permis/",
                dataType: 'json',
                async: false,
                data: params
            });
            let estValide = true
            jqxhr.fail(function (jqxhr) {
                if (jqxhr.responseJSON && jqxhr.responseJSON.reponse === 'error') {
                    fenetreModal.fermerModalAlerteDivs();
                    infos.ajouterMessageToast({
                        message: "Impossible de fermer l'événement: " + jqxhr.responseJSON.validation1,
                        messageDuree: 0,
                        messageCouleur: 'red'
                    });
                }
                else{
                    infos.ajouterMessageToast({
                    message: "Erreur de fermeture de l'événement",
                    messageDuree: 1500,
                    messageCouleur: 'red'
                });

                }

                estValide = false
            });
            wait.stop('contenu');
            return estValide
        }

        /**
         * Fonction de sauvegarde de l'étape de planification d'inspection de permis.
         */
        function savePlanificationInspectionPermis(callback) {
            if ($('#permis-ue-planification-planification').find('[name=form-field-radio]:checked').val() === "False") {
                savePlanificationInspectionPermis2(callback);
            }
            else {
                verifierChangementStatutEvenement(savePlanificationInspectionPermis2, callback);
            }
        }

        function savePlanificationInspectionPermis2(callback) {

            const idEvenement = $('#wizard').attr('id-evenement');
            const idTypeEvenement = $('#wizard').attr('id-type-evenement');
            const etapeProcessus = $('#modal-step-contents > .active').attr('data-id_processus');
            const dateInspection = $('#form-taj-date-inspection').find('[name=date_prochaine_inspection]');
            const dateInspectionDefaultValue = dateInspection.prop('defaultValue');

            let nbErreurs = 0;
            let rechargerPage;
            let idStatutEvenement = $('#wizard').attr('id-statut-evenement');
            let estmunicipaliteeditable = true;
            let currentForm = $('#' + 'permis-ue-planification-planification');
            let dateInspectionDepart = dateInspectionDefaultValue === 'None' ? '' : dateInspectionDefaultValue;
            let $formTajAssigne = $('#assigner-et-etat');
            let user = $formTajAssigne.find('[name=user]');
            let commentaire = $formTajAssigne.find('[name=commentaire]');
            let userEstChange = !user.prop('options')[user.prop('selectedIndex')].defaultSelected;
            let commentaireEstChange = commentaire.prop('defaultValue') !== commentaire.val();
            let routeInspection = $formTajAssigne.find('[name=routeInspection]');
            let routeInspectionEstChange = !routeInspection.prop('options')[routeInspection.prop('selectedIndex')].defaultSelected;
            let dateEstValide = true
            let reponse = {}

            if ($('#permis-ue-planification-planification').find('[name=form-field-radio]:checked').val() === "False")
            {
                dateEstValide = validerDateEvenementPermisSansInspection(idEvenement, idTypeEvenement, etapeProcessus);
                if (!dateEstValide){
                    // Si la date n'est pas valide, il ne sert à rien de continuer aux autres étapes
                    return
                }
            }

            // 1 - Sauvegarde de la planification d'inspection et des routes dans la table evenement
            let InspectionAPrevoir = $(currentForm).find('[name=form-field-radio]:checked').val();
            if (InspectionAPrevoir === 'False' && dateEstValide) {
                const idMunicipalite = $('#wizard').attr('id-municipalite');
                if (idMunicipalite !== '' && !!idMunicipalite) {
                    let params1 = {'id_municipalite': idMunicipalite, 'id_type_evenement': idTypeEvenement, 'id_etape_processus': etapeProcessus};
                    let jqxhr = $.ajax({
                        type: "POST",
                        url: "/gestion-roles/fermeture-cycle/validation-municipalite/",
                        dataType: 'json',
                        async: false,
                        data: params1
                    });

                    jqxhr.done(function (response) {
                        if (response.reponse === 'error') {
                            estmunicipaliteeditable = false;
                            fenetreModal.fermerModalAlerteDivs();
                            infos.ajouterMessageToast({
                                message: response.validation1,
                                messageDuree: 0,
                                messageCouleur: 'red'
                            });
                            fermerModaleEtRefreshTable(wait.stop());
                            reponse.reponse = 'error';
                            wait.stop('contenu');
                            callback(reponse);
                        }
                    });
                    jqxhr.fail(function (jqxhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur de fermeture de l'événement",
                            messageDuree: 1500,
                            messageCouleur: 'red'
                        });
                        reponse.reponse = 'error';
                        wait.stop('contenu');
                        callback(reponse);
                    });

                }
            }

            if (estmunicipaliteeditable) {
                // On s'assure de sauvegarder la date d'inspection uniquement si elle a été modifiée
                if ($('#permis-ue-planification-planification').attr('modifie') === 'True') {
                    if (dateInspectionDepart !== dateInspection.val() || routeInspectionEstChange) {
                        const InspectionAPrevoirDateEvenement = (InspectionAPrevoir === 'True') ? $('input[name="date_prochaine_inspection"]').val() === '' ? null : moment($('input[name="date_prochaine_inspection"]').val()).format('YYYY-MM-DD') : null;
                        const params_inspection = [];
                        params_inspection.push({name: 'evenement', value: idEvenement});
                        params_inspection.push({name: 'bool_inspection_requise', value: InspectionAPrevoir});
                        params_inspection.push({
                            name: 'date_prochaine_inspection',
                            value: InspectionAPrevoirDateEvenement
                        });
                        params_inspection.push({name: 'id_route_inspection', value: routeInspection.val()});
                        params_inspection.push({
                            name: 'date_evenement',
                            value: moment($('#wizard').attr('date-evenement')).format('YYYY-MM-DDTHH:mm:ss')
                        });
                        params_inspection.push({name: 'typeEvenement', value: idTypeEvenement});
                        let url = '/gestion-roles/evenement/' + idEvenement + '/';
                        let async = false;
                        let dataType = 'json';
                        currentForm.attr('methode', 'PATCH');
                        let messageToast = { // TODO: Cumuler les messages au lieu de les passer un par un.
                            message: "Planification de l'inspection mise à jour"
                        };
                        rechargerPage = false;
                        nbErreurs += sauvegarderDonnees(currentForm, url, async, dataType, params_inspection,
                                                        etapeProcessus, messageToast, 1, rechargerPage);
                    }
                }

                // 2 - Sauvegarde du changement de l'assignation. Il y a un trigger qui vient porter l'assignation
                //     (user et note de transmission) dans la table evenement à partir de statut_x_evenement

                const callback2 = function (reponse) {
                    if (reponse.reponse !== 'ok') {
                        callback(reponse);
                        return;
                    }

                    if ($('#permis-ue-planification-planification').find('[name=form-field-radio]:checked').val() === "False") {
                        saveModalAlertConfirmationFermetureEvenement(callback);
                        return;
                    }

                    reponse = {reponse: 'ok'};
                    callback(reponse);
                };

                if (userEstChange || commentaireEstChange) {
                    $formTajAssigne = $('#assigner-et-etat');
                    user = $formTajAssigne.find('[name=user]'); // L'usager qui a été assigné
                    commentaire = $formTajAssigne.find('[name=commentaire]'); // Note de transmission('id-model-instance');
                    currentForm = $formTajAssigne;
                    let url = '/gestion-roles/statut-x-evenement-a/';
                    let async = false;
                    let dataType = 'json';
                    let params_assigne = [];
                    params_assigne.push({name: 'evenement', value: idEvenement});
                    params_assigne.push({name: 'commentaire', value: commentaire.val()});
                    params_assigne.push({name: 'user_id', value: user.val()});
                    params_assigne.push({
                        name: 'date_evenement',
                        value: moment($('#wizard').attr('date-evenement')).format('YYYY-MM-DDTHH:mm:ss')
                    });

                    // On s'assure de prendre toujours le statut dans l'entête du wizard qui pourrait avoir été confirmé
                    // par l'usager avec le pop-up permettant de garder le statut actuel ou remplacer par le statut par
                    // défaut
                    params_assigne.push({name: 'statutEvenement', value: idStatutEvenement});
                    const messageToast = {
                        message: "Assignation réussie",
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green'
                    };

                    let callbackSauvegarde = function (data) {
                        // $('#wizard').attr('id-statut-evenement', idStatutEvenement);
                        $('#permis-ue-planification-planification').attr('id_statut_x_evenement', data.id_statut_x_evenement);
                        // remettre les valeurs par défaut au cas où l'utilisateur reste dans la page
                        commentaire.attr('defaultValue', commentaire.val());
                        user.attr('defaultValue', user.val());
                        routeInspection.attr('defaultValue', routeInspection.val());
                        refreshDatatables();
                    };
                    rechargerPage = false;
                    //var callback2;
                    nbErreurs += sauvegarderDonnees(currentForm, url, async, dataType, params_assigne, etapeProcessus, messageToast, 1, rechargerPage, callback2, callbackSauvegarde);
                } else {
                    nbErreurs > 0 ? reponse.reponse = 'error' : reponse.reponse = 'ok';
                    callback2(reponse);
                }
            }
        }

        function traitementPostSauvegarde(currentForm) {
            // var titre = currentForm.data('titre');
            // if (currentForm.hasClass('sous-bloc-form')) {
            //     var idCurrentForm = currentForm.closest('.champs-multiple').attr('id');
            //     if (idCurrentForm == 'document-permis') titre = 'Permis (documents)';
            //     if (idCurrentForm == 'b79-attestation-sous-bloc') titre = 'Permis (attestations)';
            //     if (idCurrentForm == 'bien-non-immobilier-mutation') titre = 'Mutation (biens non immobiliers)';
            //     if (idCurrentForm == 'document-mutation') titre = 'Mutation (documents)';
            // }

            if (currentForm.attr('methode')) {
                currentForm.attr('methode', 'PATCH'); // Indique qu'on devra faire un update au lieu d'un insert car l'objet existe dans la bd
            }
            if (currentForm.attr('modifie')) {
                currentForm.attr('modifie', 'False'); // Indique que le formulaire n'a pas été modifié puisqu'on vient d'effectuer la sauvegarde
            }

            $('.tooltip').remove();
            var idCurrentForm = currentForm.attr('id');
            // si c'est la fenêtre d'édition de l'adresse de propriétaire, on ne change pas l'état du bouton Sauvegarder du wizard
            if (!(idCurrentForm == 'creation-proprietaire' ||
                idCurrentForm == 'creation-adresse-proprietaire' ||
                idCurrentForm == 'edition-proprietaire-x-unite-evaluation'))
                $('button[data-type="save"]').attr("disabled", true);
        }


        /**
         * Suppression de formulaire de bâtiments pour l'étape "Saisie de la nature et de la description des travaux" du wizard de Tenue à jour lorsqu'il y a plus de 100  bâtiments.
         * @param {array} batimentSelection - Sélection jQuery du bâtiment à enlever de la liste des travaux de l'étape.
         */
        function supprimerFormulaireBatiment(batimentSelection) {
            supprimeNaturesEtTravaux(batimentSelection);
            //    Par la suite on retire simplement l'enveloppe du bâtiment de la page. Les données viennent d'être supprimées, si elles avaient été enregistrées.
            var formulaireBatimentARetirer = $(batimentSelection.target).closest('[type="formulaire"]').attr('id');
            $('#' + formulaireBatimentARetirer + '-focus').remove();
            wait.stop('contenu');
        }

        function supprimeNaturesEtTravaux(batimentSelection) {
            var lienSupprimerClic = batimentSelection.target;
            var $FormulaireCourant = $(lienSupprimerClic).closest('[type="formulaire"]');
            var formulaireType = $FormulaireCourant.attr('data-type');

            var estConstructionNeuve = (formulaireType == 'travaux-batiment-construction');
            if (estConstructionNeuve) {
                fenetreModal.modalMessage({
                    classe: 'modal-dialog',
                    conteneur: '#wizard',
                    titre: "Supprimer ?",
                    ombre: true,
                    sansX: true,
                    texteExplicatif: "Ceci supprimera le bâtiment et les informations saisies dans sa fiche de façon irréversible.<br><br>Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "btn_oui",
                            class: "btn btn-success",
                            action: function (response) {
                                supprimeNaturesEtTravaux2(lienSupprimerClic);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "btn_non",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });

            } else {
                supprimeNaturesEtTravaux2(lienSupprimerClic);
            }
        }

        function supprimeNaturesEtTravaux2(lienSupprimerClic) {

            //  S'il n'y a pas eu d'opération dans la BD (sauvegarde), les supprimer tout de suite
            wait.start('contenu');
            var $FormulaireCourant = $(lienSupprimerClic).closest('[type="formulaire"]');
            var formulaireBatimentCourant = $FormulaireCourant.closest('[data-type="travaux-batiment"]').attr('id');
            var formulaireType = $FormulaireCourant.attr('data-type');

            var formulaireAucun = '#' + (formulaireType === 'travaux-batiment-construction' ? 'travaux-batiment' : formulaireType) + '-aucun';
            var formulaireAucunRendu = $('#travaux-batiment-trop').length > 0 ? "" : $(formulaireAucun).val();
            var estDernier;
            if (formulaireType === 'travaux-batiment' && $('#travaux-batiment-trop').length > 0) {
                estDernier = false;
            } else {
                estDernier = ($('#' + formulaireBatimentCourant).find('[data-type="' + formulaireType + '"]').length <= 1) ? true : false;
            }

            var $Formulaire;
            if (estDernier) { // le formulaire courant est le dernier de son niveau et est sans enfants. On utilise son positionnement avant de l'effacer.
                // Si d'autres premiers niveaux existent, on ne doit pas les effacer. Il peut y avoir plusieurs bâtiments, surtout si un formulaire pour des travaux sur un bâtiment est présent, en plus d'un formulaire pour une construction neuve, par exemple.
                var params = [];
                var construction_ou_batiment = formulaireType === 'travaux-batiment-construction' ? 'travaux-batiment-construction' : 'travaux-batiment';
                var $Batiment = $FormulaireCourant.closest('[data-type="' + construction_ou_batiment + '"]').attr('id');
                $Batiment = $Batiment && $Batiment.length ? $Batiment.split('-')[2] : '';
                var $Nature = $FormulaireCourant.closest('[data-type="travaux-batiment-nature"]').attr('id'); // $FormulaireCourant.closest('[data-type="travaux-batiment-nature-types-contenu"]').attr('id');
                $Nature = $Nature && $Nature.length ? $Nature.split('-')[4] : '';
                var $Type = $FormulaireCourant.closest('[data-type="travaux-batiment-nature-type"]').attr('id');
                $Type = $Type && $Type.length ? $Type.split('-')[6] : '';
                params.push(
                    {name: 'batiment', value: $Batiment},
                    {name: 'nature', value: $Nature},
                    {name: 'type', value: $Type}
                );
                params = nettoyerParams(params);
                var formulaire = 'travaux';
                //
                $.each(params, function (index, value) {
                    var valeur = 'template_' + params[index].name + '_id';
                    formulaireAucunRendu = formulaireAucunRendu.replace(valeur, params[index].value);
                    formulaire += '-' + params[index].name + '-' + params[index].value;
                });
                var formulaireTemp = formulaire.split('-');
                formulaireTemp.splice(-1, 1); //TODO: valider celle-là.... Nécessaire
                var a = formulaireTemp.splice(-1, 1);
                a = String(a) + 's';
                formulaireTemp.push(a);
                formulaireTemp.push('contenu');
                formulaire = formulaireTemp.join('-');
                $Formulaire = $('#' + formulaire);
            } else { // On a plus d'un élément dans le contenu
                var formulaireCourantId = $FormulaireCourant.attr('id');
                $Formulaire = $('#' + formulaireCourantId + '-contenu');
            }

            var bool_batiment_a_retirer;
            var natures_batiment_a_retirer_sauvegardees;
            var natures_batiment_a_retirer_non_sauvegardees;
            if ($FormulaireCourant.attr('data-type') === 'travaux-batiment' || $FormulaireCourant.attr('data-type') === 'travaux-batiment-construction') {
                bool_batiment_a_retirer = true;
                natures_batiment_a_retirer_sauvegardees = $FormulaireCourant.find('[type="formulaire"][data-type="travaux-batiment-nature"]').not('[id-model-instance=""]');
                natures_batiment_a_retirer_non_sauvegardees = $FormulaireCourant.find('[type="formulaire"][data-type="travaux-batiment-nature"][id-model-instance=""]');
            } else {
                bool_batiment_a_retirer = false;
                natures_batiment_a_retirer_sauvegardees = $FormulaireCourant.find('[type="formulaire"][data-type="travaux-batiment-nature"]').not('[id-model-instance=""]');
            }
            var $FormulairesCourants;
            var cible;
            if ($FormulaireCourant.attr('id-model-instance') === '' || (bool_batiment_a_retirer === true && natures_batiment_a_retirer_non_sauvegardees.length >= 0 && natures_batiment_a_retirer_sauvegardees.length === 0 && construction_ou_batiment !== 'travaux-batiment-construction')) { // On ne touche qu'à l'interface.
                // Si on retire un bâtiment, on doit pointer sur la nature pour effacer le contenu des formulaires de nature et de travaux. Ensuite, il ne nous reste que le frame du bâtiment qu'on peut flusher.
                if (bool_batiment_a_retirer === true) {
                    cible = lienSupprimerClic;
                    $FormulairesCourants = $FormulaireCourant.find('[type="formulaire"][data-type="travaux-batiment-nature"][id-model-instance=""]');
                    if ($FormulairesCourants.length === 0) {
                        if (formulaireType === 'travaux-batiment-construction') {
                            $('#' + formulaireBatimentCourant + '-focus').remove();
                            wait.stop('contenu');
                        }
                        return; // Il n'y a rien à faire : L'usager retire un bâtiment auquel il n'a pas associé de nature.
                    }
                } else {
                    cible = lienSupprimerClic;
                }
                $(cible).closest('.flash-message').fadeOut("normal", function () {
                    if (estDernier) {
                        $Formulaire.empty();
                        $Formulaire.append(formulaireAucunRendu).hide();
                    }
                    if (estDernier) {
                        $('#' + formulaire).find('.action-buttons-text').not('.well .action-buttons-text').remove();
                        $('#' + formulaire).fadeIn('slow');
                    }
                }).remove();
            } else { // Il y a des données dans la base de données.
                if (natures_batiment_a_retirer_sauvegardees.length > 0 && bool_batiment_a_retirer === true) {
                    cible = lienSupprimerClic; // On pointe sur le bouton de la nature
                    $FormulairesCourants = $FormulaireCourant.find('[type="formulaire"][id-model-instance]');
                    if ($FormulairesCourants.length === 0) {
                        return; // Il n'y a rien à faire : L'usager retire un bâtiment auquel il n'a pas associé de nature.
                    }
                } else {
                    cible = lienSupprimerClic;
                    $FormulairesCourants = $FormulaireCourant;
                }

                $.each($FormulairesCourants, function (index, value) {
                    $(value).attr('methode', 'DELETE');
                    $(value).attr('modifie', 'True');
                });

                // Dans le cas d'une nature, trouver les sous-formulaires (types), s'il y en a, et les marquer comme étant également à supprimer.
                // $FormulaireCourant.find('[type="formulaire"]').attr('methode', 'DELETE');
                // $FormulaireCourant.find('[type="formulaire"]').attr('modifie', 'True');
                var messageToastPerso = {
                    message: 'Suppression réussie',
                    icone: 'fa-trash-o'
                };
                nbErreurs = 0;
                var callback;
                saveNatureDescriptionTravaux2(callback, messageToastPerso, $(cible).closest('[type="formulaire"]').attr('methode'));
                $(cible).closest('.flash-message').fadeOut("normal", function () {
                    if (estDernier) {
                        $Formulaire.empty();

                        $Formulaire.append(formulaireAucunRendu).hide();
                    }
                    if (estDernier) {
                        $('#' + formulaire).find('.action-buttons-text').not('.well .action-buttons-text').remove();
                        $('#' + formulaire).fadeIn('slow');
                    }
                }).remove();
            }
            wait.stop('contenu');

            // //    Si c'est la dernière nature, le dernier type d'une nature (S'il y en avait) ou le dernier bâtiment (construction neuve), on doit afficher un formulaire d'ajout correspondant.
            // if (estDernier) {
            //     var formulaireVide = formulaireType + '-aucun';
            //     $('#' + formulaire).append($('#' + formulaireVide).val());
            //     $('#' + formulaireVide).fadeIn('slow');
            //     //  Ajouter les actions sur les boutons
            //
            // }


        }

        /**
         * Ajout de bâtiments pour l'étape "Saisie de la nature et de la description des travaux" du wizard de Tenue à jour lorsqu'il y a plus de 100  bâtiments.
         * @param {array} batimentSelection - Sélection jQuery du bâtiment à ajouter à l'étape.
         * @return {string} batimentFormulaire - Rendu html du formulaire de bâtiment pour l'ajout de travaux.
         */
        function ajouterFormulaireBatiment(batimentSelection) {
            var batiment = /id_batiment-(\d+)/.exec(batimentSelection)[1];

            // On vérifie si le bâtiment à ajouter serait déjà présent dans le DOM.
            if ($('a[id-batiment=' + batiment + ']').length === 0) {
                var dernierAjoutBatiment = '#travaux-batiment-' + batiment;
                var divContenu = 'contenu';
                var url = '/gestion-roles/tenue-a-jour/permis/ajouter-formulaire-batiment-x-evenement/';
                var headers = {};
                var params = [];

                params.push(
                    {name: 'id_batiment', value: batiment},
                    {name: 'date_evenement', value: $('#wizard').attr('date-evenement')},
                    {name: 'id_evenement', value: $('#wizard').attr('id-evenement')},
                    {name: 'id_municipalite', value: $('#wizard').attr('id-municipalite')},
                    {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                    {name: 'id_type_evenement', value: $('#wizard').attr('id-type-evenement')},
                    {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                    {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                    {name: 'id_processus', value: $('#wizard').attr('id-processus')}
                );

                wait.start(divContenu);

                var jqxhr = $.ajax({
                        url: url,
                        headers: headers,
                        dataType: 'html',
                        data: params
                    }
                );

                jqxhr
                    .done(function (response) {
                        if ($('a[data-action="travaux-batiment-ajouter"]').length > 0) {
                            $('a[data-action="travaux-batiment-ajouter"]').before(response).hide().fadeIn("slow");
                        } else {
                            $('#travaux-batiments-contenu').append(response).hide().fadeIn("slow");
                        }
                        var dernierAjoutBatimentDetails = $(dernierAjoutBatiment).find('div[data-type="batiment-details"]');
                        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                        $(dernierAjoutBatimentDetails).hide().fadeIn();
                        scroll.positionCurseurScroll(dernierAjoutBatiment + 195, '#modal-step-contents');
                        focusControle(dernierAjoutBatiment + '-focus', 5); // Mettre en surbrillance l'ajout courant
                        controlesFormulaires.detecterChangementsFormulaire();
                        $(dernierAjoutBatimentDetails).find('select').select2();
                        $('#travaux-batiment-trop').find('select[name="id_batiment"]').select2('val', '');
                        formaterSuperficie($('#modal-wizard-evenement').find('input.superficie'), 0);
                        wait.stop(divContenu);
                    });
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur de chargement du formulaire <br> « Ajout d'un formulaire pour le bâtiment sélectionné » : <br> " + erreursAjax.formaterMessageErreur('', xhr, '', errorThrown),
                            messageDuree: 5000,
                            messageCouleur: "red"
                        });
                        wait.stop(divContenu);
                    });
            } else {
                // Le bâtiment est déjà présent dans le DOM. On avise l'utilisateur.
                fenetreModal.modalMessage({
                    titre: "Ce bâtiment a déjà été ajouté à la page",
                    sansX: true,
                    texteExplicatif: "",
                    boutons: [
                        {
                            label: " Fermer ",
                            title: "Fermer",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    ]
                });
            }
        }


        /**
         * Fonction de création de bâtiment pour l'unité d'évaluation ("Construction neuve/Ajout de batiment"). On prend le contenu d'un formulaire vide (caché dans un champs input) et on le recopie dans la page pour ajouter un bâtiment (avec ses sous-sections).
         * @param {number} idUe - id de l'unité d'évaluation.
         * @param {string} dateEvenement - Date de prise d'effet au rôle de l'évènement.
         * @param {number} natureEvenement - nature passée par paramètre avec le bouton d'ajout d'une construction neuve, par exemple. On force le passage d'une nature puisqu'on la connaît.
         * */
        function creerBatiment(idUe, dateEvenement, natureEvenement) {
            var selecteur = $('#travaux-batiment-formulaire-vide');
            var contenuFormulaire = selecteur.val();
            COMPTEUR_BATIMENTS += 1;
            var nouveauBatiment = 'nouveau_' + COMPTEUR_BATIMENTS;
            var nouveauBatimentTitre = 'Nouveau - Non sauvegardé';
            var dernierAjoutBatiment = '#travaux-batiment-' + nouveauBatiment;
            var contenuFormulaireCompteur = contenuFormulaire.replace(/template_batiment_id/g, nouveauBatiment);
            contenuFormulaireCompteur = contenuFormulaireCompteur.replace(/Bâtiment/g, 'Construction neuve');
            contenuFormulaireCompteur = contenuFormulaireCompteur.replace(/Nouveau/g, nouveauBatimentTitre);
            var aucun = $('#travaux-batiment-aucun');
            if (aucun.length > 1) {
                // Il n'y a aucun bâtiment pour cette UE. On effacera donc le well d'info (Unité qui ne possède pas de bâtiment) et on ajoutera un formulaire de bâtiment vide.
                aucun.hide();
                $('#travaux-batiments-contenu').append(contenuFormulaireCompteur).hide().fadeIn("slow");
                $('#travaux-batiments-contenu').append('<a href="#" data-action="travaux-batiment-ajouter" data-nature_evenement="4" class="action-buttons-text"><i class="fa fa-plus-circle fa-lg green"></i>Ajouter une construction neuve (bâtiment)</a>');
            } else {
                $('a[data-action="travaux-batiment-ajouter"]').before(contenuFormulaireCompteur);
            }
            var dernierAjoutBatimentDetails = $(dernierAjoutBatiment).find('div[data-type="batiment-details"]');
            dernierAjoutBatimentDetails.empty();

            dernierAjoutBatimentDetails.append(); // On ajoute le formulaire de sélection pour la nouvelle construction (Usage principal projeté (type de bâtiment), superficie projetée)

            var headers = {};
            var params = [];
            params.push(
                {name: 'batimentNouveau', value: nouveauBatiment},
                {name: 'evenement', value: $('#wizard').attr('id-evenement')},
                {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                {name: 'id_type_evenement', value: $('#wizard').attr('id-type-evenement')},
                {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                {name: 'natureEvenement', value: natureEvenement},
                {name: 'permis', value: $('#wizard').attr('id-processus')}
            );
            var url = '/gestion-roles/construction-neuve-x-evenement/';
            var divContenu = 'travaux-batiment-' + ' > div[data-type="batiment-details"]';

            wait.start(divContenu);

            var jqxhr = $.ajax({
                    url: url,
                    headers: headers,
                    dataType: 'html',
                    data: params
                }
            );
            jqxhr
                .done(function (response) {
                    wait.stop(divContenu);
                    dernierAjoutBatimentDetails.append(response);
                    fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                    $(dernierAjoutBatiment).hide().fadeIn();
                    scroll.positionCurseurScroll(dernierAjoutBatiment, '#modal-step-contents');
                    focusControle(dernierAjoutBatiment + '-focus', 5); // Mettre en surbrillance l'ajout courant
                    controlesFormulaires.detecterChangementsFormulaire();
                    $(dernierAjoutBatiment).find('select').select2();
                    formaterSuperficie($('#modal-wizard-evenement').find('input.superficie'), 0);
                });
            jqxhr
                .fail(function (xhr, textStatus, errorThrown) {
                    infos.ajouterMessageToast({
                        message: "Erreur de chargement du formulaire <br> « construction-neuve-x-permis » : <br> " + erreursAjax.formaterMessageErreur('', xhr, '', errorThrown),
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                });
        }

        /**
         * Fonction de nettoyage des paramètres utilisés pour les appels Ajax. On nettoie soit une liste, soit un objet selon le type. Si le paramètre est vide, on l'efface.
         * @param {object} params
         * @param {Array} exclusions : Liste des champs pour lesquels on souhaite conserver le nom du input et sa valeur None ou vide.
         * */
        function nettoyerParams(params, exclusions) {
            var parametres;
            if (params instanceof Array) {
                parametres = params;
                var exclusions_garder;
                typeof (exclusions) !== 'undefined' ? exclusions_garder = exclusions : exclusions_garder = [];
                for (var i in parametres) {
                    if ((parametres[i].value === '' || parametres[i].value === undefined) && ($.inArray(parametres[i].name, exclusions) === -1)) {
                        //alert("Erreur : valeur vide pour " + parametres[i].name);
                        delete parametres[i];
                    }
                }
                parametres = parametres.filter(function (n) {
                    return n != undefined;
                });
            } else if (params instanceof Object) {
                parametres = params;
                for (var i in parametres) {
                    if (parametres[i] === '' || parametres[i] === undefined && $.inArray(i, exclusions) === -1) {
                        delete parametres[i];
                    }
                }
            }

            return parametres;
        }

        /**
         * Fonction de création d'une nature des travaux pour le bâtiment listé. On prend le contenu d'un formulaire vide (caché dans un champs input) et on le recopie dans la page pour ajouter une nature des travaux (avec ses sous-sections).
         * @param {number} idBatiment - id du bâtiment
         * @param {string} dateEvenement - Date de prise d'effet au rôle de l'évènement.
         * */
        function creerNatureTravaux(idBatiment, dateEvenement) {
            var selecteur = $('#travaux-batiment-nature-formulaire-vide');
            var contenuFormulaire = selecteur.val();
            COMPTEUR_NATURE += 1;
            var nouveauNature = 'nouveau_' + COMPTEUR_NATURE;
            var nouveauNatureTitre = ' - Non sauvegardé';
            var dernierAjoutBatiment = '#travaux-batiment-' + idBatiment + '-natures-contenu';
            var dernierAjoutBatimentNatureContenu = '#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-contenu';
            var dernierAjoutBatimentNature = '#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature;
            var contenuFormulaireCompteur = contenuFormulaire.replace(/template_batiment_id/g, idBatiment);
            contenuFormulaireCompteur = contenuFormulaireCompteur.replace(/template_nature_id/g, nouveauNature);
            contenuFormulaireCompteur = contenuFormulaireCompteur.replace(/- Nouveau/g, nouveauNatureTitre);
            var $aucun = $('#travaux-batiment-' + idBatiment + '-nature-aucun');
            if ($aucun.length > 0) {
                // Il n'y a aucune nature des travaux pour ce bâtiment. On effacera donc le well d'info (Bâtiment qui ne possède pas de nature des travaux) et on ajoutera un formulaire de nature des travaux pour ce bâtiment.
                $aucun.remove();
                $(dernierAjoutBatiment).append(contenuFormulaireCompteur).hide().fadeIn("slow");
                $(dernierAjoutBatiment).append('<a href="#" data-action="travaux-batiment-nature-ajouter" class="action-buttons-text"><i class="fa fa-plus-circle fa-lg green"></i>Ajouter une nature des travaux</a>');
            } else {
                $(dernierAjoutBatiment).find('[data-action="travaux-batiment-nature-ajouter"]').before(contenuFormulaireCompteur).hide().fadeIn("slow");
                //$(dernierAjoutBatiment).append('<a href="#" data-action="travaux-batiment-nature-ajouter" class="action-buttons-text"><i class="fa fa-plus-circle fa-lg green"></i>Ajouter une nature des travaux</a>');
            }
            var $DernierAjoutBatimentNatureAjout = $(dernierAjoutBatimentNatureContenu).find('div[data-type=travaux-batiment-nature-wrapper]');//$(dernierAjoutBatimentNatureContenu).find('div[data-type=travaux-batiment-nature-types-contenu]');
            //dernierAjoutBatimentNatureAjout.empty();

            var headers = {};
            var params = [];
            params.push(
                {name: 'balise', value: '<!-- vide -->'},
                {name: 'batiment', value: idBatiment},
                {name: 'evenement', value: $('#wizard').attr('id-evenement')},
                {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                {name: 'recharger_nature', value: 0},
                {name: 'natureEvenementNouveau', value: nouveauNature},
                {name: 'permis', value: $('#wizard').attr('id-processus')},
                {name: 'typeEvenement', value: $('#wizard').attr('id-type-evenement')},
                {
                    name: 'listeNatures',
                    value: JSON.stringify($('#travaux-batiment-' + idBatiment + ' select[name="natureEvenement"]').map(function () {
                        return this.value;
                    }).get())
                } // On passe la liste des natures de travaux existantes pour les retirer de la liste de sélection
            );
            var url = '/gestion-roles/travaux-batiment-nature-creation/';
            var divContenu = 'permis-travaux-batiment-' + idBatiment + '-nature > div[data-type=permis-travaux-batiment-nature-contenu]';


            wait.start(divContenu);
            var jqxhr = $.ajax({
                    url: url,
                    headers: headers,
                    dataType: 'html',
                    data: params
                }
            );
            jqxhr
                .done(function (response) {
                    wait.stop(divContenu);
                    $DernierAjoutBatimentNatureAjout.append(response);
                    fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                    $(dernierAjoutBatimentNature + '-focus').hide().fadeIn();
                    // Modèle pour l'ajout des types de travaux.
                    var $Type = $('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature);
                    $Type.html($Type.html().replace(/template_batiment_id/g, String(idBatiment)));
                    $Type.html($Type.html().replace(/template_nature_id/g, nouveauNature));
                    scroll.positionCurseurScroll(dernierAjoutBatimentNatureContenu, '#modal-step-contents');
                    focusControle(dernierAjoutBatimentNature + '-focus', 5); // Mettre en surbrillance l'ajout courant
                    controlesFormulaires.detecterChangementsFormulaire();
                    controlesFormulaires.redimentionnerTextarea();
                    $(dernierAjoutBatimentNature).find('select').select2();
                });
            jqxhr
                .fail(function (xhr, textStatus, errorThrown) {
                    infos.ajouterMessageToast({
                        message: "Erreur de chargement du formulaire <br> « Nature des travaux » : <br> " + erreursAjax.formaterMessageErreur('', xhr, '', errorThrown),
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                });
        }


        /**
         * Fonction de création d'un détail des travaux pour la nature des travaux du bâtiment listé. On prend le contenu d'un formulaire vide (caché dans un champs input) et on le recopie dans la page pour ajouter le détail pour cette nature des travaux (avec ses sous-sections).
         * @param {number} idBatiment - id du bâtiment.
         * @param {number} idNature - id de la nature des travaux.
         * @param {number} nouveauNature - id de la nature des travaux ou compteur de la nouvelle nature à créer. Sert à savoir dans quel formulaire insérer ou modifier les données s'il s'agit d'une création.
         * @param {date} dateEvenement - Date de l'évènement.
         * @param {number} typeAjout - 0 = remplacer le div du type de travaux (on change la nature), 1 = on ajoute un autre div manuellement (plusieurs types pour une nature).
         * @param {string} dateEvenement - Date de prise d'effet au rôle de l'évènement.
         * */
        function creerTypeTravaux(idBatiment, idNature, nouveauNature, dateEvenement, typeAjout) {
            var dernierAjoutBatimentNature = '#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature;
            var dernierAjoutBatimentNatureContenu;
            if ($.inArray(idNature, ['5', '7']) > -1) { // Pour un agrandissement et un certificat d'autorisation
                let headers = {};
                let params = [];
                params.push(
                    {name: 'balise', value: '<!-- vide -->'},
                    {name: 'recharger_nature_avec_options', value: 1},
                    {name: 'batiment', value: idBatiment},
                    {name: 'evenement', value: $('#wizard').attr('id-evenement')},
                    {name: 'natureEvenementNouveau', value: nouveauNature},
                    {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                    {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                    {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                    {name: 'natureEvenement', value: idNature},
                    {name: 'recharger_nature', value: 1},  // On recharge la nature pour afficher la modification au formulaire (champs supplémentaires conditionnels, etc.). Pour tous les autre cas, on ne fait qu'afficher un selectbox normal, sans reload du formulaire de sélection de la nature avec des champs supplémentaires.
                    {name: 'permis', value: $('#wizard').attr('id-processus')},
                    {name: 'typeEvenement', value: $('#wizard').attr('id-type-evenement')},
                    {
                        name: 'listeNatures',
                        value: JSON.stringify($('#travaux-batiment-' + idBatiment + ' select[name="natureEvenement"]').map(function () {
                            return this.value;
                        }).get())
                    }
                );
                dernierAjoutBatimentNatureContenu = '#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-contenu';
                var $DernierAjoutBatimentNatureAjout = $(dernierAjoutBatimentNatureContenu).find('div[data-type=travaux-batiment-nature-wrapper]');
                var url = '/gestion-roles/travaux-batiment-nature-creation/';
                var idModelInstance = $(dernierAjoutBatimentNature).attr('id-model-instance') || '';
                var idNatureEvenementXEvenement = $(dernierAjoutBatimentNature).attr('data-id_nature_evenement_x_evenement') || '';
                var idNatureEvenementBatiment = $(dernierAjoutBatimentNature).attr('data-id_nature_evenement_x_batiment') || '';
                wait.start(divContenu);
                var jqxhr = $.ajax({
                        url: url,
                        headers: headers,
                        dataType: 'html',
                        data: params
                    }
                );
                jqxhr
                    .done(function (response) {
                        $DernierAjoutBatimentNatureAjout.empty();
                        $DernierAjoutBatimentNatureAjout.append(response);
                        formaterSuperficie($('#modal-wizard-evenement').find('input.superficie'), 0);
                        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                        controlesFormulaires.redimentionnerTextarea();
                        $(dernierAjoutBatimentNature + '-focus').hide().fadeIn();
                        // Modèle pour l'ajout des types de travaux.
                        scroll.positionCurseurScroll(dernierAjoutBatimentNatureContenu, '#modal-step-contents');
                        focusControle(dernierAjoutBatimentNature + '-focus', 5); // Mettre en surbrillance l'ajout courant
                        $(dernierAjoutBatimentNature).find('select').select2();
                        $(dernierAjoutBatimentNature).find('select').data('valeurPrecedente', $(dernierAjoutBatimentNature).find('select').val()); // Comme on a rechargé ce formulaire, on a perdu la dernière valeur stockée dans .data. // On n'utilise pas .prop('defaultValue'), au cas où l'on aurait besoin de retourner à la valeur initiale.
                        controlesFormulaires.detecterChangementsFormulaire();
                        $(dernierAjoutBatimentNature).attr('id-model-instance', idModelInstance);
                        $(dernierAjoutBatimentNature).attr('data-id_nature_evenement_x_evenement', idNatureEvenementXEvenement);
                        $(dernierAjoutBatimentNature).attr('data-id_nature_evenement_x_batiment', idNatureEvenementBatiment);
                        wait.stop(divContenu);
                        $(dernierAjoutBatimentNature).attr('modifie', 'True'); // Comme on recharge par javascript, on doit redétecter les changements de ce formulaire;
                    });
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur de chargement du formulaire <br> « Nature des travaux » : <br> " + erreursAjax.formaterMessageErreur('', xhr, '', errorThrown),
                            messageDuree: 5000,
                            messageCouleur: "red"
                        });
                    });
            } else {
                COMPTEUR_DETAILS_TRAVAUX += 1;
                var nouveauTypeTravaux = 'nouveau_' + COMPTEUR_DETAILS_TRAVAUX;
                dernierAjoutBatimentNatureContenu = '#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-contenu';
                var dernierAjoutBatimentNatureTypesContenu = '#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-types-contenu';
                // On doit générer le tableau de divs pour le tout premier rendu, pour une nature de travaux donnée pour un bâtiment donné.
                var dernierAjoutBatimentNatureTypeFocus = '#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-type-' + nouveauTypeTravaux + '-focus';
                if ($('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-type-contenu').length === 0) { // Le tableau n'existe pas encore (on n'a qu'une nature sans aucune sélection ou sans travaux)
                    var $TypeVide = $('#travaux-batiment-nature-type-formulaire-vide');
                    var nouveauNatureTitre = ' - Non sauvegardé';
                    var contenuFormulaireType = $TypeVide.val();
                    var contenuFormulaireTypeCompteur = contenuFormulaireType.replace(/template_batiment_id/g, String(idBatiment));
                    contenuFormulaireTypeCompteur = contenuFormulaireTypeCompteur.replace(/template_nature_id/g, nouveauNature);
                    contenuFormulaireTypeCompteur = contenuFormulaireTypeCompteur.replace(/Nouveau/g, nouveauNatureTitre);
                    contenuFormulaireTypeCompteur = contenuFormulaireTypeCompteur.replace(/template_type_id/g, nouveauTypeTravaux);
                    var aucun = $('#travaux-batiment-' + idBatiment + '-nature-' + (nouveauNature != '' ? nouveauNature : idNature) + '-aucun');
                    if (aucun.length > 0) { // Il n'y a aucun type de travaux pour cette nature. On effacera donc le well d'info avant d'ajouter un formulaire d'ajout de type pour cette nature pour ce bâtiment.
                        aucun.remove();
                        $(dernierAjoutBatimentNatureTypesContenu).append(contenuFormulaireTypeCompteur);
                    } else {
                        $(dernierAjoutBatimentNatureTypesContenu).append(contenuFormulaireTypeCompteur);
                    }
                } else if (typeAjout === 0) {
                    $('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-type-contenu').empty();
                }

                var selecteur = $(dernierAjoutBatimentNatureContenu).find('a.accordion-toggle');
                var titreAccordeon = selecteur.text();

                if (titreAccordeon.indexOf(" - Non sauvegardé") === -1) { // selecteur.html(nettoyerTitreAccordeon(titreAccordeon, /\-(.*)/i, ' - Non sauvegardé'));
                    selecteur.html(titreAccordeon + ' - Non sauvegardé');
                }

                let headers = {};
                let params = [];

                params.push(
                    {name: 'evenement', value: $('#wizard').attr('id-evenement')},
                    {name: 'permis', value: $('#wizard').attr('id-processus')},
                    {name: 'id_ue', value: $('#wizard').attr('id-ue')},
                    {name: 'typeTravauxNouveau', value: nouveauTypeTravaux},
                    {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                    {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                    {name: 'batiment', value: idBatiment},
                    {name: 'natureEvenement', value: idNature},
                    {name: 'natureEvenementNouveau', value: nouveauNature},
                    {
                        name: 'natureEvenementXBatiment',
                        value: $(dernierAjoutBatimentNature).attr('data-id_nature_evenement_x_batiment')
                    },
                    {
                        name: 'listeTypes',
                        value: JSON.stringify($('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-focus select[name="typeTravaux"]').map(function () {
                            return this.value;
                        }).get())
                    } // On passe la liste des types de travaux existants pour les retirer de la liste de sélection
                );
                var divContenu = 'travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-type-contenu';

                wait.start(divContenu);
                var jqxhr = $.ajax({
                        url: '/gestion-roles/travaux-batiment-nature-type/',
                        headers: headers,
                        dataType: 'html',
                        data: params
                    }
                );
                jqxhr
                    .done(function (response) {
                            wait.stop(divContenu);
                            $('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-wrapper').find('[data-type="travaux-batiment-nature-options"]').remove();
                            if (response.indexOf("aucun-type-travaux") > -1) { // balise html aucun-type-travaux correspond à la variable Javascript AucunTypeTravaux. On n'exécute donc rien d'autre.
                                $('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-type-wrapper').remove();
                            } else {
                                var divAjoutTravauxPourNature = $('#' + divContenu);
                                divAjoutTravauxPourNature.append(response);
                                if (typeAjout === 0 && $('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature).find($('#bool_plusieurs_types_x_nature')).val() === 'False') {
                                    // On ne détruit pas le conteneur puisqu'il s'agit simplement d'un changement de nature... On doit par contre contôler si l'entête doit être présente ou non : plusieurs types pour une nature. Cette information est retrouvée dans "wiz_permis_travaux_batiment_nature_type_ajout.html" sous : bool_plusieurs_types_x_nature. Si on a True, on affiche l'entête. Dans tous les autres cas, non. Dans ce cas, la modification s'effectue dans jqxhr.done parce qu'ici, on ne le sait pas encore.
                                    $('#travaux-batiment-' + idBatiment + '-nature-' + nouveauNature + '-type-wrapper').empty();
                                }
                                var erreur = divAjoutTravauxPourNature.find('.aucun-type-travaux');
                                (erreur.length) ? erreur.remove() : ''; // Si une erreur subsiste, on ne veut pas voir la balise utilisée par la vue...
                                fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                                $(dernierAjoutBatimentNatureTypeFocus).hide().fadeIn();
                                //scroll.positionCurseurScroll(dernierAjoutBatimentNatureTypeFocus, '#modal-step-contents');
                                var focusDiv = '#' + $(response).attr('id');
                                focusControle(focusDiv, 5); // Mettre en surbrillance l'ajout courant
                                controlesFormulaires.detecterChangementsFormulaire();
                                divAjoutTravauxPourNature.find('select').select2();

                                var selecteurAjouterType = $(dernierAjoutBatimentNatureTypesContenu).find('a[data-action="travaux-batiment-nature-type-ajouter"]');

                                if (selecteurAjouterType.length === 0) {
                                    $(dernierAjoutBatimentNatureTypesContenu).find('.div-table').append('<a href="#" data-action="travaux-batiment-nature-type-ajouter" class="action-buttons-text"><i class="fa fa-plus-circle fa-lg green"></i>Ajouter un type de travaux</a>');
                                }
                                if ($(divAjoutTravauxPourNature).find('#bool_plusieurs_types_x_nature').val() === 'False') {
                                    selecteurAjouterType.css("display", "none");
                                } else if ($(divAjoutTravauxPourNature).find('a[data-action=travaux-batiment-nature-type-ajouter]').css('display') === 'none') {
                                    selecteurAjouterType.css("display", "initial");
                                }
                            }
                        }
                    )
                ;
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur de chargement du formulaire <br> « Types de travaux » : <br> " + erreursAjax.formaterMessageErreur('', xhr, '', errorThrown),
                            messageDuree: 5000,
                            messageCouleur: "red"
                        });
                    });
            }
        }

        function ouvrirModalCreationEvenement(params) {
            var parametres = params !== undefined ? params : [];
            var titre = 'Créer un évènement';
            // Définition des paramètres pour créer la fenêtre modal
            var variableModal = {
                id: "tenue-a-jour-modal-creer-evenement",
                view: "/core/modal/",
                titre: titre,
                template: "wizards/evenement_creer_type.html",
                template_view: "", //"/gestion-roles/tenue-a-jour/evenement/nouveau/",
                template_depart: "", // Seulement pour wizard
                template_depart_selectionne_vue: "",
                taille: "grande",
                wizard: false,
                callback: function () {

                    // On initialise le click sur le choix du type d'évènement après l'ouverture du modal
                    $("#wizard-choisir").on("click", "button.modal-choisir", function (a) {
                        var idTypeEvenement = a.target.id;
                        parametres['id_type_evenement'] = idTypeEvenement;
                        var jqxhr = $.ajax({
                            type: "POST",
                            url: "/gestion-roles/fermeture-cycle/validation-municipalite/",
                            dataType: 'json',
                            async: false,
                            data: parametres
                        });

                        jqxhr.done(function (response) {
                            if (response.reponse == 'error') {
                                fenetreModal.fermerModal('tenue-a-jour-modal-creer-evenement');

                                infos.ajouterMessageToast({
                                    message: response.validation,
                                    messageDuree: 0,
                                    messageCouleur: 'red'
                                });

                            } else {
                                ouvrirWizardNouvelEvenement(idTypeEvenement, parametres);

                            }
                        });
                        jqxhr.fail(function (jqxhr, textStatus, errorThrown) {
                            infos.ajouterMessageToast({
                                message: "Erreur de création de l'événement",
                                messageDuree: 1500,
                                messageCouleur: 'red'
                            });
                        });

                    });
                },
                boutons: [
                    {
                        type: "cancel",
                        label: "Fermer",
                        title: "",
                        classSupp: "",
                        afficher: true
                    }
                ]
            };


            fenetreModal.creerModal(variableModal, {});


        }

        /**
         * Fonction de recherche des permis existants (pour utiliser un permis différent à la création d'un évènement.
         * @param {number} selecteur - Valeur du champ de recherche à utiliser.
         * @param {string} portee - 'unique' à une municipalité, 'tout', pour afficher les résultats de recherche de numéro de permis pour toutes les municipalités.
         * @param {number} id - Id de la ligne nécessaire à la sélection dans la BD.
         * @param {string} type - optionnel - utilisé pour le callback.
         * @param {string} typeNom - optionnel - utilisé pour le callback.
         * @param {string} callback - optionnel - fonction callback.
         * */
        function executerRechercheMutation(selecteur, callback) {
            wait.start();
            var tableId = 'mutation-recherche-resultats';

            var jqxhr = $.ajax({
                url: "/gestion-roles/mutation/?format=json",
                data: {'no_mutation': selecteur, 'mode_recherche': 'contains'},
                async: false
            });
            jqxhr
                .done(function () {
                    var data = JSON.parse(jqxhr.responseText);
                    var html =
                        '<table id="' + tableId + '" class="table table-striped table-bordered table-hover display dt-responsive no-wrap clearfix display datatable" cellspacing="0" width="100%">' +
                        '<thead>' +
                        '<tr>' +
                        '<th></th>' +
                        '<th></th>' +
                        '<th></th>' +
                        '<th></th>' +
                        '</tr>' +
                        '</thead>';
                    if (!$.fn.dataTable.isDataTable('#' + tableId)) {
                        $('#recherche-contenu').append(html);
                    }
                    if ($.fn.dataTable.isDataTable('#' + tableId)) {
                        tableModal.clear().rows.add(data).draw();
                    } else {
                        tableModal = $('#' + tableId).DataTable({
                            retrieve: true,
                            data: data,
                            dom: 't',
                            order: [[1, 'asc']],
                            columnDefs: [
                                {
                                    orderable: false,
                                    targets: [0]
                                },
                                {
                                    title: "",
                                    data: "id_mutation",
                                    targets: [0],
                                    width: '20px',
                                    render: function (data, type, row) {
                                        return '<div class="action-buttons-utiliser" id-mutation="' + data + '" class="choisir-mutation"><i class="ace-icon fa fa-check action-grille-icone fa-lg"></i></div>';
                                    }
                                },
                                {
                                    title: 'No de mutation',
                                    data: 'no_mutation',
                                    targets: 1
                                },
                                {
                                    title: 'Date de transaction',
                                    data: 'date_transaction',
                                    targets: 2
                                },
                                {
                                    title: 'Prix de vente déclaré',
                                    data: 'prix_declare_sans_taxes',
                                    targets: 3,
                                    render: function (data, type, row) {
                                        return data != null ? '<div class="text-right">' + data + ' $</div>' : '';
                                    }
                                }
                            ],
                            "createdRow": function (row, data, dataIndex) {
                                var titre = "Utiliser cette mutation";
                                $(row).addClass('choisir-mutation align-left');
                                $(row).attr("id-mutation", data.id_mutation);
                                $(row).attr("data-modal-titre", titre);
                                $(row).attr("title", titre);
                            },
                            drawCallback: function (settings) {
                                if (callback) {
                                    var parametres = [id, selecteur, type, typeNom];
                                    window['tenueAJourModal'][callback].apply(window, parametres);
                                }

                                // Choisir la mutation, recharger la recherche, s'assurer que la mutation existante est sélectionné, rendre le formulaire de mutation editable (pour ne pas faire de post pour une mutation existante...
                                $('tr.choisir-mutation').off('click').on('click', function () { // Delegated Event
                                    var idMutation = $(this).attr('id-mutation');
                                    var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                                    var etapeOrdre = $('.steps').find('.active').attr('data-step');
                                    var selecteur = '#modal-step' + etapeOrdre;
                                    $(selecteur).attr('recharger', 'oui');
                                    $(this).find().addClass("active");
                                    wait.start('contenu', '255,255,255', 1);

                                    // On remet à jour certaines variables globales du wizard suite au chargement d'une nouvelle mutation
                                    $('#wizard').attr('id-processus', idMutation);

                                    chargerEtapeDynamique(etapeProcessus, etapeOrdre);
                                    fenetreModal.fermerModalAlerteDivs();
                                    wait.stop('contenu');
                                });

                            }
                        });
                    }
                    bootstrapOn.initTooltips();
                    // var hauteurModal = $("#modal-message-alerte-contenu").innerHeight();
                    // var hauteurNouvelleModal = $(window).height() * 0.6;
                    // var hauteurScroll = hauteurNouvelleModal - hauteurModal;
                    // scroll.ajouterSlimScroll('#evenement-recherche-mutation-existante-toggle', {hauteur: hauteurScroll, largeur: 10});
                    wait.stop();
                });
            jqxhr
                .fail(function (xhr, textStatus, errorThrown) {
                    $('#' + tableId)
                        .empty()
                        .append('<p>Impossible de charger les résultats de recherche.</p>');
                });
        }

        /**
         * Fonction d'initialisation de l'étape informations générales du processus de mutation.
         * */
        function initInfoGeneraleMutation() {
            var identificationActeForm = $('#accordion-identification-acte');
            var dateTransaction = identificationActeForm.find('input[name="date_transaction"]');
            var dateEvenementDatePicker = $('#frm-date-evenement').find('input[name="date_evenement"]');
            var evenementRemarque = $('#evenement-remarque').find('[name="remarque"]');
            updateDateEvenementWizard();
            updateRemarqueWizard();
            dateTransaction.off('focusout').on('focusout', function() {
                var m = moment($(this).val());
                if (m.isValid()) {
                    $(this).data('daterangepicker').setStartDate($(this).val());
                    $(this).trigger('apply.daterangepicker');
                }
            });
            dateTransaction.off('apply.daterangepicker').on('apply.daterangepicker', function () {
                var dateSaisie = $(this).data('daterangepicker').startDate._d;
                var dateNow = new Date(Date.now());
                var anneeAnterieure = dateNow.getFullYear() - 1;
                var date_choisie;
                if (dateSaisie.getFullYear() < anneeAnterieure) {
                    date_choisie = moment(new Date(anneeAnterieure, 0, 1)).format('YYYY-MM-DD');
                } else {
                    date_choisie = moment(dateSaisie).format('YYYY-MM-DD');
                }
                dateEvenementDatePicker.val(date_choisie);
                dateEvenementDatePicker.trigger('change');
                $(this).val(date_choisie);
                updateDateEvenementWizard(true);
            });

            evenementRemarque.on('change', function () {
                updateRemarqueWizard(true);
            });

            // quand on charge une mutation existante, on assigne la date de transaction à la date d'évènement
            if (dateTransaction.val() && !dateEvenementDatePicker.val()) {
                dateTransaction.trigger('apply.daterangepicker');
            }

            var radios = identificationActeForm.find('input[name="bool_bureau_publicite_droit"]');
            radios.on('click', function () {
                clickRadio($(this), radios);

                //# 9411
                var no_mutation = identificationActeForm.find('input[name="no_mutation"]');
                var no_mutation_seing_prive = identificationActeForm.find('input[name="no_mutation_seing_prive"]');
                var id_processus = $('#wizard').attr('id-processus');
                var minute_notaire = identificationActeForm.find('input[name="minute_notaire"]')

                if ($(this).val() === '1') {
                    no_mutation_seing_prive.prop('disabled', true);
                    no_mutation.prop('disabled', false);
                    minute_notaire.prop('disabled', false);
                    no_mutation_seing_prive.val('');
                    no_mutation.val('');
                } else {
                    no_mutation_seing_prive.prop('disabled', false);
                    no_mutation.prop('disabled', true);
                    minute_notaire.prop('disabled', true);
                    minute_notaire.val(null)
                    if (id_processus) {
                        no_mutation.val(50000000 + Number(id_processus)); //50 000 0000 + id_mutation (chiffre à 8 digit unique)
                    }
                }

            });

            var $modalWizard = $('#modal-wizard-evenement');
            $modalWizard.off('click.recherche.mutation').on('click.recherche.mutation', 'button#recherche', function () { // Delegated event - Fenêtre de recherche d'un évènement existant...
                var $rechercheChamp = $('input#recherche-champ').val();
                tenueAJourModal.executerRechercheMutation($rechercheChamp);
            });

            $modalWizard.off('click.mutation.existante').on('click.mutation.existante', '[data-action="rechercher-mutation-existante"]', function (a) { // Delegated Event
                fenetreModal.modalMessage({
                    taille: 'immense',
                    enteteTitre: "Rechercher et sélectionner un numéro d'inscription d'une mutation existante",
                    texteExplicatif: "",
                    vueACharger: "/gestion-roles/tenue-a-jour/mutation/information-generale/rechercher-mutation-existante/",
                    boutons: {
                        "Fermer": {
                            label: " Fermer ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    }

                });
            });

            // Évènement - Rechercher la présence d'une mutation existante : doit être unique.
            $('input[name="no_mutation"]').off('change').on('change', function (a) {
                var element = $(this);
                var jqxhr = $.ajax({
                    url: "/gestion-roles/tenue-a-jour/mutation/information-generale/recherche-meme-no-mutation/",
                    data: {'no_mutation': element.val()},
                    async: false
                });
                jqxhr
                    .done(function (response) {
                        var resultat = JSON.parse(jqxhr.responseText);
                        if (resultat.length >= 1) {
                            if ($('#wizard').attr('id-evenement') != '') {
                                fenetreModal.modalMessage({
                                    titre: "Puisque l'évènement existe déjà, vous devez saisir un numéro d'inscription qui n'est pas utilisé dans le système pour une mutation.",
                                    texteExplicatif: "",
                                    boutons: {
                                        "Ok": {
                                            label: " Ok ",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                                element.val(element.prop('defaultValue')); // On remet le numéro de mutation d'origine.
                                            }
                                        },
                                    }
                                });
                            } else if (resultat.length === 1) {

                                fenetreModal.modalMessage({
                                    titre: "Il existe déjà une mutation ayant le même numéro d'inscription '" + element.val() + "'. ",
                                    texteExplicatif: "Voulez-vous créer un nouvel évènement lié à cette même mutation (ajout d'une ue) OU" +
                                        " créer un nouvel évènement avec ce numéro d'inscription (même numéro d'inscription mais plus d'une transaction) ?",
                                    boutons: {
                                        "Oui": {
                                            label: " Créer évènement lié ",
                                            id: "",
                                            class: "btn btn-info",
                                            objet: resultat[0].id_mutation, // Si le résultat contient plusieurs mutations avec le même no, on prend le premier.
                                            action: function () {
                                                wait.start('contenu');
                                                var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                                                var etapeOrdre = $('.steps').find('.active').attr('data-step');
                                                var idMutation = Number(this.objet);

                                                // On remet à jour certaines variables globales du wizard suite au chargement de la nouvelle mutation
                                                $('#wizard').attr('id-processus', idMutation);
                                                $('#modal-step1').attr('recharger', 'oui');

                                                chargerEtapeDynamique(etapeProcessus, etapeOrdre);
                                            }
                                        },
                                        "Non": {
                                            label: " Créer évènement avec même numéro ",
                                            id: "",
                                            class: "btn btn-info",
                                            objet: resultat[0].id_mutation, // Si le résultat contient plusieurs mutations avec le même no, on prend le premier.
                                            action: function () {
                                                wait.start('contenu');
                                                var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                                                var etapeOrdre = $('.steps').find('.active').attr('data-step');
                                                var idMutation = Number(this.objet);

                                                // On remet à jour certaines variables globales du wizard suite au chargement de la nouvelle mutation
                                                $('#wizard').attr('id-processus', idMutation);
                                                $('#modal-step1').attr('recharger', 'oui');

                                                var params = {id_meme_no_mutation: idMutation};
                                                chargerEtapeDynamique(etapeProcessus, etapeOrdre, params);
                                            }
                                        },
                                        "Annuler": {
                                            label: " Annuler ",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                                identificationActeForm.find('input[name="no_mutation"]').val(''); // On efface la donnée pour ne pas créer une 2e mutation avec le même numéro de mutation.
                                            }
                                        },
                                    }

                                }, function () {
                                    $(':focus').blur(); // On retire le focus
                                });
                            } else if (resultat.length > 1) {
                                wait.start();

                                fenetreModal.modalMessage({
                                    titre: "Il existe plusieurs mutations ayant le même numéro d'inscription '" + element.val() + "'. ",
                                    texteExplicatif: "Voulez-vous créer un nouvel évènement lié à cette même mutation (ajout d'une ue) OU" +
                                        " créer un nouvel évènement avec ce numéro d'inscription (même numéro d'inscription mais plus d'une transaction) ?" +
                                        "<br><br>Vous devez sélectionner une mutation et cliquer sur le bouton approprié.",
                                    vueACharger: "/gestion-roles/tenue-a-jour/mutation/information-generale/recherche-no-mutation-multiple/",
                                    sansX: true,
                                    async: true,
                                    init: function () {
                                        var tableId = 'recherche-no-mutation-mutiple-resultats';
                                        var data = resultat;
                                        if ($.fn.dataTable.isDataTable('#' + tableId)) {
                                            tableModal.clear().rows.add(data).draw();
                                        } else {
                                            tableModal = $('#' + tableId).DataTable({
                                                retrieve: true,
                                                data: data,
                                                dom: 't',
                                                order: [[1, 'asc']],
                                                columnDefs: [
                                                    {
                                                        orderable: false,
                                                        targets: [0]
                                                    },
                                                    {
                                                        title: "",
                                                        data: "id_mutation",
                                                        targets: [0],
                                                        width: '20px',
                                                        render: function (data, type, row) {
                                                            return '<div class="action-buttons-utiliser" id-mutation="' + data + '" class="choisir-mutation">' +
                                                                '<label class="position-relative">' +
                                                                '<input type="checkbox" class="ace check-taj" name="checkbox-mutation">' +
                                                                '<span class="lbl" title="Utiliser cette mutation"></span>' +
                                                                '</label>' +
                                                                '</div>';
                                                        }
                                                    },
                                                    {
                                                        title: 'No de mutation',
                                                        data: 'no_mutation',
                                                        targets: 1,
                                                        width: '110px'
                                                    },
                                                    {
                                                        title: 'Date de transaction',
                                                        data: 'date_transaction',
                                                        targets: 2
                                                    },
                                                    {
                                                        title: "Nature de l'acte",
                                                        data: 'nature_description',
                                                        targets: 3
                                                    },
                                                    {
                                                        title: 'Prix de vente déclaré (sans taxes)',
                                                        data: 'prix_declare_sans_taxes',
                                                        targets: 4,
                                                        render: function (data, type, row) {
                                                            return data != null ? '<div class="text-right">' + data + ' $</div>' : '';
                                                        }
                                                    }
                                                ],
                                                "createdRow": function (row, data, dataIndex) {
                                                    var titre = "Utiliser cette mutation";
                                                    $(row).addClass('choisir-mutation align-left');
                                                    $(row).attr("id-mutation", data.id_mutation);
                                                    $(row).attr("data-modal-titre", titre);
                                                    $(row).attr("title", titre);
                                                },
                                                drawCallback: function (settings) {
                                                    // désactiver les boutons
                                                    $('#creer-evenement-lie, #creer-evenement-meme-numero').prop('disabled', true);

                                                    // Choisir la mutation, recharger la recherche, s'assurer que la mutation existante est sélectionné, rendre le formulaire de mutation editable (pour ne pas faire de post pour une mutation existante...
                                                    $('tr.choisir-mutation').off('click').on('click', function (e) {
                                                        var checkboxMutation = $(this).find('input[name="checkbox-mutation"]');
                                                        var checkboxChecked = checkboxMutation.is(':checked');
                                                        checkboxMutation.prop('checked', !checkboxChecked);
                                                        $(this).css('color', !checkboxChecked ? '#5CB85C' : '#393939');

                                                        // décocher les autres lignes cochées
                                                        var autresLignes = $('tr.choisir-mutation').not($(this));
                                                        autresLignes.find('input[name="checkbox-mutation"]').prop('checked', false);
                                                        autresLignes.css('color', '#393939');

                                                        // activer / désactiver les boutons
                                                        var ligneCochee = $('tr.choisir-mutation').find('input[name="checkbox-mutation"]:checked');
                                                        $('#creer-evenement-lie, #creer-evenement-meme-numero').prop('disabled', ligneCochee.length == 0);
                                                    });

                                                }
                                            });
                                        }
                                        bootstrapOn.initTooltips();
                                        wait.stop();
                                    },
                                    boutons: {
                                        "Evennement_lié": {
                                            label: " Créer évènement lié ",
                                            id: "creer-evenement-lie",
                                            class: "btn btn-info",
                                            objet: resultat[0].id_mutation, // Si le résultat contient plusieurs mutations avec le même no, on prend le premier.
                                            action: function () {
                                                wait.start('contenu');
                                                var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                                                var etapeOrdre = $('.steps').find('.active').attr('data-step');
                                                var idMutation = $('tr.choisir-mutation').find('input[name="checkbox-mutation"]:checked').closest('.action-buttons-utiliser').attr('id-mutation');

                                                // On remet à jour certaines variables globales du wizard suite au chargement de la nouvelle mutation
                                                $('#wizard').attr('id-processus', idMutation);
                                                $('#modal-step1').attr('recharger', 'oui');

                                                chargerEtapeDynamique(etapeProcessus, etapeOrdre);
                                            }
                                        },
                                        "Evenement_meme_numéro": {
                                            label: " Créer évènement avec même numéro ",
                                            id: "creer-evenement-meme-numero",
                                            class: "btn btn-info",
                                            objet: resultat[0].id_mutation, // Si le résultat contient plusieurs mutations avec le même no, on prend le premier.
                                            action: function () {
                                                wait.start('contenu');
                                                var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                                                var etapeOrdre = $('.steps').find('.active').attr('data-step');
                                                var idMutation = $('tr.choisir-mutation').find('input[name="checkbox-mutation"]:checked').closest('.action-buttons-utiliser').attr('id-mutation');

                                                // On remet à jour certaines variables globales du wizard suite au chargement de la nouvelle mutation
                                                $('#wizard').attr('id-processus', idMutation);
                                                $('#modal-step1').attr('recharger', 'oui');

                                                var params = {id_meme_no_mutation: idMutation};
                                                chargerEtapeDynamique(etapeProcessus, etapeOrdre, params);
                                            }
                                        },
                                        "Annuler": {
                                            label: " Annuler ",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                                identificationActeForm.find('input[name="no_mutation"]').val(''); // On efface la donnée pour ne pas créer une 2e mutation avec le même numéro de mutation.
                                            }
                                        },
                                    }

                                }, function () {
                                    $(':focus').blur(); // On retire le focus
                                });
                            }
                        } else { // Si on ne fait que modifier le no_mutation pour un nouveau qui n'existe pas déjà alors indique que le formulaire a été modifié et on enable le bouton save.
                            // Ceci est normalement fait dans geocentralis.js/detecterChangementsFormulaire mais pour le no_mutation on a overwrité l'event change par la méthode en cours.
                            $('button[data-type="save"]').prop("disabled", false);
                            $(this).closest('div[type="formulaire"]').attr('modifie', 'True');
                        }
                    });
                jqxhr
                    .fail(function (jqxhr, textStatus, errorThrown) {
                        fenetreModal.modalMessage({
                            titre: "Erreur inconnue sur la recherche du numéro d'inscription de mutation " + element.val() + ".",
                            texteExplicatif: "Contactez un administrateur.",
                            boutons: [
                                {
                                    label: " Ok ",
                                    title: "Ok",
                                    id: "",
                                    class: "btn",
                                    action: function () {
                                    }
                                }
                            ]
                        });
                    });
            });

            var restrictionForm = $('#accordion-restriction');
            var selectRestriction = restrictionForm.find('select[name="restriction"]');
            autreRestrictionDisplayed(selectRestriction);

            selectRestriction.on('change', function () {
                autreRestrictionDisplayed($(this));
            });

            function autreRestrictionDisplayed(select) {
                var descriptionRow = $('#description_autre_restriction.row');
                var selected = select.find('option[value="7"]').is(':selected');
                descriptionRow.css('display', selected ? '' : 'none');
                if (!selected) {
                    descriptionRow.find('input[name="description_autre_restriction"]').val('');
                }
            }

            // ajuster les inputs money de la section 'Prix de vente' pour avoir 2 décimales, vu que chargerEtapeDynamique à mis 0 décimale par défaut
            var inputMoneySectionPrixVente = $('#accordion-prix-vente').find('input.money');
            inputMoneySectionPrixVente.autoNumeric('update', {mDec: 2});
            inputMoneySectionPrixVente.each(function () {
                // remettre la valeur originale pour la faire formatter avec 2 décimales
                var $this = $(this);
                if ($this.attr('value')) {
                    $this.autoNumeric('set', $this.attr('value'));
                }
            });

            calculerPrixVenteRajuste(true);

            // exception pour les 2 sous-blocs se rattachant à la mutation, si une valeur change, le prix rajusté sera recalculé, donc la mutation doit être sauvegardée
            $('#bien-non-immobilier-mutation input:text, #rajustement-mutation input:text').on('change', function () {
                calculerPrixVenteRajuste();
                $('#mutation-infos-generales').attr('modifie', 'True');
            });

            $('#mutation-infos-generales').on('change', '[name="prix_declare_sans_taxes"], [name="tvq"], [name="tps"], [name="ristourne_tvq"], [name="ristourne_tps"]', function () {
                calculerPrixVenteRajuste();
            });

            // On initialise seulement les select2 pour la section d'informations générales et non pour le sous-bloc des documents
            $('#modal-step-contents .form-horizontal').find('select').select2({allowClear: true});

            // mettre l'attribut 'bloc-editable' à 'True' pour chaque ligne de sous-bloc pour l'utiliser à la sauvegarde comme dans une fiche mais sans historicité
            $('.sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');

            // initialisation des sous-blocs
            init_change_event_sous_bloc();

            // initialisation des input file
            var organisation = securite.reqOrganisation();
            var documents = $('#document-mutation').find('.section-document');
            $.each(documents.find('.ace-input-file'), function (idx, obj) {
                initAceInputFile($(obj), organisation, 'mutation');
            });

            if ($('#mutation-infos-generales').attr('est-meme-no-mutation') !== undefined) {
                documents.find('.ace-file-input').find('[name="nom"]').addClass('controle-modifie').addClass('valeur-modifiee');
                documents.find('.sous-bloc-form').not('.nouvelle-ligne').attr('modifie', 'True');
            }
            // initialiser le bouton 'Éditer l'adresse du propriétaire' dans la partie du cessionnaire affiché en lecture seule
            var contenuCessionnaire = $('#section-cessionnaire');
            initCreationEditionAdresseProprietaire(contenuCessionnaire);
        }

        /**
         * Fonction de sauvegarde de l'étape 1 d'informations générales du processus de mutation.
         * */
        function saveInfoGeneraleMutation(callback) {
            checkChangementDateEtSave(saveInfoGeneraleMutation2, callback);
        }

        function saveInfoGeneraleMutation2(callback) {
            // si la mutation a été reçu par courriel et qu'elle est complètement saisi pour une ue,
            // en ajoutant une autre ue sur cette mutation, on veut obliger la sauvegarde pour que
            // nature_evenement_x_evenement soit sauvegardé
            if ($('#wizard').attr('etape-sauvegardee-suivante-active') == '14' &&
                $('#wizard').attr('id-evenement') != '' &&
                $('#mutation-infos-generales').attr('modifie') == 'False') {
                $('#mutation-infos-generales').attr('modifie', 'True');
            }
            // ajouter evenement remarque
            var pageCourante = $('.step-pane.active');
            var sections = pageCourante.find($('#mutation-infos-generales, #evenement-remarque, ' +
                '#frm-date-evenement, #bien-non-immobilier-mutation, #rajustement-mutation, ' +
                '#document-mutation,#evenement-remarque, #document-enquete-vente-sous-bloc, ' +
                '#mutation-resultat-analyse-vente'));

            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var params = controlesFormulaires.serialiserFormulaire(currentForm);
                var idMutation = $('#mutation-infos-generales').attr('id-model-instance');
                // var dateEvenementForm = currentForm.find('[name="date_evenement"]').val();
                //params.push({name: 'remarque', value: $('#wizard').attr('evenement-remarque')});
                if (idCurrentForm == 'frm-date-evenement') {
                    //var evenementRemarque = currentForm.find('[name="remarque"]').val();
                    //if (evenementRemarque !== '' && evenementRemarque !== undefined) {
                    //  $('#wizard').attr('evenement-remarque', evenementRemarque);
                    //}
                    params.push({name: 'date_evenement', value: $('#wizard').attr('date-evenement')});
                    //params.push({name: 'remarque', value: evenementRemarque});
                    var paramsOptionnels = [
                        {name: 'id_municipalite', value: $('#wizard').attr('id-municipalite')},
                        {name: 'id_type_evenement', value: $('#wizard').attr('id-type-evenement')},
                        {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                        {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                        {name: 'etapeProcessus', value: $('#modal-step-contents > .active').attr('data-id_processus')},
                        {name: 'remarque', value: $('#wizard').attr('evenement-remarque')},
                    ];

                    var idUe = $('#wizard').attr('id-ue');
                    if (idUe != '') {
                        paramsOptionnels.push({name: 'id_ue', value: idUe});
                    }

                    paramsOptionnels = nettoyerParams(paramsOptionnels);
                    $.each(paramsOptionnels, function (idx, item) {
                        params.push(item);
                    });
                } else if (idCurrentForm == 'document-mutation' || idCurrentForm == 'document-enquete-vente-sous-bloc') {
                    var erreurFichier = currentForm.find('.ace-file-container.selected .ace-error').attr('erreur');
                    if (!erreurFichier) erreurFichier = '';
                    params.push(
                        {name: 'id_municipalite', value: $('#wizard').attr('id-municipalite')},
                        {name: 'erreur_fichier', value: erreurFichier},
                        {name: 'date_debut', value: $('#wizard').attr('date-evenement')} // prendre celui du wizard qui vient d'être ajouté par le 'frm-date-evenement'
                    );
                    if (idCurrentForm == 'document-mutation') {
                        params.push({name: 'id_mutation', value: idMutation});
                    } else if (idCurrentForm == 'document-enquete-vente-sous-bloc') {
                        params.push({name: 'id_enquete_vente', value: $('#wizard').attr('id-processus')});
                    }
                }

                if (idCurrentForm == 'frm-date-evenement' || idCurrentForm == 'bien-non-immobilier-mutation' ||
                    idCurrentForm == 'rajustement-mutation' || idCurrentForm == 'document-mutation') {
                    if (idMutation != 'None') {
                        // passer le champ si le formulaire est en édition
                        params.push({name: 'id_mutation', value: idMutation});
                    }
                }

                return params;
            };
            var getChampUnique = function (currentForm, idCurrentForm) {
                if (idCurrentForm == 'bien-non-immobilier-mutation' || idCurrentForm == 'rajustement-mutation' || idCurrentForm == 'document-mutation') {
                    return {
                        unique_nom_champ: 'index_ligne',
                        unique_id_champ: $('#' + idCurrentForm).find('.sous-bloc-form').index(currentForm)
                    };
                }
                return {};
            };
            var getChampTransfert = function (idCurrentForm) {
                var retour = {};
                if (idCurrentForm == 'mutation-infos-generales') {
                    retour.transfert_champ_source = 'id_mutation';
                } else if (idCurrentForm == 'frm-date-evenement' || idCurrentForm == 'bien-non-immobilier-mutation' ||
                    idCurrentForm == 'rajustement-mutation' || idCurrentForm == 'document-mutation') {
                    retour.transfert_champ_destination = 'id_mutation';
                }
                return retour;
            };

            var callback2 = function (response) {
                if (response.reponse == 'ok') {
                    updateEnteteWizard();
                }
                callback(response);
            };

            var messageToast = {};
            var statut = $('#wizard').attr('id-statut-evenement') || 1;
            sauvegarderFormulairesCoteServeur(callback2, sections, getParams, getChampUnique, getChampTransfert, messageToast, statut);
        }

        function wizardSauvegarderSousBloc(sousBloc, idBatiment, idFormulaire, paramsOptionnels, dateEvenement, messageSucces, messageSuppression) {
            var nbErreurs = 0;
            var champsMultiple = sousBloc.closest('.champs-multiple');
            var nomBloc = champsMultiple.attr('id');
            var index = champsMultiple.find('.sous-bloc-form').index(sousBloc);

            // On vérifie d'abord si la ligne a été éditée afin de ne pas la sauvegarder inutilement
            if (sousBlocEstModifie(sousBloc)) {
                var params = [];
                var ligneStatut = LIGNE_STATUT.none;
                var idModelInstance = sousBloc.attr('id-model-instance');

                // Cas d'une suppression de ligne
                if (sousBloc.find('.' + CLASSE_SUPPRESSION_LIGNE).length > 0) {
                    ligneStatut = LIGNE_STATUT.delete;
                }
                // Cas d'une modification ou insertion
                else {
                    ligneStatut = idModelInstance != 'None' ? LIGNE_STATUT.update : LIGNE_STATUT.insert;
                    params = controlesFormulaires.serialiserFormulaire(sousBloc);
                }
                params.push({name: 'wizard_mode', value: true});
                params.push({name: 'id_etape_processus', value: $('.step-pane.active').attr('data-id_processus')});

                $.each(paramsOptionnels, function (idx, item) {
                    params.push(item);
                });
                params = nettoyerParams(params, ['validation']);

                // On strip les données mises en forme par des masques
                params = masquesSelection.striper(sousBloc, params);

                if (ligneStatut != LIGNE_STATUT.none) {
                    ajaxSauvegarderSousBloc(sousBloc, params, false, ligneStatut, nomBloc, idBatiment, dateEvenement, idFormulaire, index, paramsOptionnels,
                        function () {
                            //Callback en cas de succès;
                            traitementPostSauvegarde(sousBloc);
                            erreursAjax.effacerErreurChamps(sousBloc);
                            if (ligneStatut == LIGNE_STATUT.delete) {
                                sousBloc.remove();
                                if (messageSuppression !== undefined) {
                                    infos.ajouterMessageToast({
                                        message: messageSuppression
                                    });
                                }
                            } else {
                                if (messageSucces !== undefined) {
                                    infos.ajouterMessageToast({
                                        message: messageSucces
                                    });
                                }
                            }
                        },
                        function (jqXHR, textStatus, errorThrown) {
                            // Callback en cas d'erreurs;
                            if (jqXHR.status >= 500) {
                                infos.ajouterMessageToast({
                                    message: "Une erreur s'est produite. Contactez un administrateur.",
                                    type: 'error',
                                    messageDuree: 2000
                                });
                            }
                            else {
                                erreursAjax.traiterErreurs(sousBloc, jqXHR, errorThrown);
                            }
                            nbErreurs += 1;
                        });
                }
            }
            return nbErreurs;
        }

        /**
         * Fonction d'initialisation de l'étape de localisation de l'ue du processus de mutation.
         * */
        function initLocalisationUeMutation() {
            // On initialise l'outil de recherche récupéré de l'Explorateur uniquement si l'ue n'existe pas car sinon on montre l'info générale de l'ue sélectionnée
            var idEvenement = $('#wizard').attr('id-evenement');
            var idUe = $('#wizard').attr('id-ue');
            var receptionMutationParCourriel = idUe.substr(0, 1) == '-' && $('#municipalite').val() != '';

            if (idEvenement == '' || receptionMutationParCourriel) {
                $('#modal-recherche').attr('recharger', 'oui'); // En provenance de l'Explorateur d'UE, on doit recharger sinon les initialisation ne se font pas.
                init_explorateur_ue_partage();
            }

            $('#municipalite').on('change', function () {
                $('#wizard').attr('id-municipalite', $(this).val());

                // Ceci permet entre autre de charger le listbox de voies publiques selon la municipalité
                var selecteur = $('#wizard').attr('id-municipalite');
                if (selecteur != '' && !!selecteur) {
                    var idMunicipalite = selecteur;
                    ouvrirRechercheExpUe(idMunicipalite);
                }
            });

            if (receptionMutationParCourriel) {
                $('#municipalite').trigger('change');
            }

            // On initialise les select2
            $('#modal-step-contents .form-horizontal').find('select').select2();

            // utiliser pour la liste des lots de ue
            initCheckboxTous($('#checkbox-ue-lot-tous'), $('[name="bool_lot_inclus"]'));

            $('[name="bool_lot_inclus"], #checkbox-ue-lot-tous').on('change', function () {
                $(this).closest('[id="mutation-ue-lots"]').attr('modifie', 'True');
                $('#localisation-ue-infos-mutation').attr('modifie', 'True');
            });

            initMultiplesUesMutation();

            // s'il y a des lots et au moins un lot est coché ou s'il n'y a pas de lots dans le tableau,
            // remettre 'modifie' à False pour ne pas obliger à sauvegarder
            if ($('[id="mutation-ue-lots"]').find('[name="bool_lot_inclus"]:checked').length ||
                $('[id="mutation-ue-lots"]').length == 0) {
                $('#localisation-ue-infos-mutation').attr('modifie', 'False');
            }
        }

//#7103, mutations sur opérations cadastrales non terminées
        function checkkLotMutationDansOperationCadastraleOuvert() {

            var params = {};
            // params.idUe = $('#wizard').attr('id-ue');
            var isOk = false;


            var list_id_ue = [];

            var sections = $('#exp-ue-lots').find('[data-type="ue-lots"]');

            $.each(sections, function () {
                var section = $(this);
                list_id_ue.push(section.find('[name="lot_id_ue"]').text());
            });

            params.idUe = list_id_ue;


            $.ajax({
                type: "GET",
                url: '/gestion-roles/tenue-a-jour/lot-mutation-dans-operation-cadastrale-ouvert/',
                data: params,
                dataType: 'json',
                async: false,
                success: function (response) {

                    var reponse = response[0];
                    if (reponse.reponse == 'ok') {
                        isOk = true;
                    } else {
                        isOk = false;
                    }
                },
                error: function (jqxhr, textStatus, errorThrown) {
                    isOk = false;
                }
            });
            return isOk;
        }


        /**
         * Fonction de sauvegarde de l'étape de localisation de l'ue du processus de mutation.
         * */
        function saveLocalisationUeMutation(callback) {


            //#7103, mutations sur opérations cadastrales non terminées

            checkEvenementFermePosterieurCycleOuvertEtSave(saveLocalisationUeMutation2, callback);
        }

        function saveLocalisationUeMutation2(callback) {

            if ($('#mutation-ue-lots[modifie=True]').length) {

                var params = {
                    'id_processus': $('#wizard').attr('id-processus'),
                    'bool_mutation_simple': get_bool_mutation_simple(),
                };
                var estValide = false;
                $.ajax({
                    type: "GET",
                    url: "/gestion-roles/tenue-a-jour/mutation/valide-localisation-ue-mutation-save/",
                    data: params,
                    async: false,
                    dataType: 'json',
                    success: function (response) {
                        if (response) {
                            estValide = response.est_valide;
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        messageToastCompteur = 0;
                        infos.ajouterMessageToast({
                            message: 'Une erreur s\'est produite. Contactez un administrateur.',
                            messageDuree: 0
                        });

                        var response = {reponse: 'error'};
                        callback(response);
                    }
                });
                wait.stop('contenu');

                if (estValide) {
                    fenetreModal.modalMessage({
                        titre: "Voulez-vous vraiment continuer ?",
                        texteExplicatif: "Le système a détecté qu'il existe une 'Opération UE' lié à cette mutation. Donc, " +
                            "ceci aura pour effet d'effacer les données saisies dans toutes les étapes suivantes.",
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function () {
                                    sauvegarderEtape2Mutation(callback);

                                    refreshDatatables();
                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                    fenetreModal.fermerModalAlerteDivs();
                                }
                            }
                        }

                    });
                } else {
                    sauvegarderEtape2Mutation(callback);
                }
            } else {
                sauvegarderEtape2Mutation(callback);
            }

            //
            function sauvegarderEtape2Mutation(callback) {
                var idUe = $('#wizard').attr('id-ue');
                var idEvenement = $('#wizard').attr('id-evenement');
                // si l'ue commence par le signe négatif, on arrive de la réception par courriel d'une mutation
                var receptionMutationParCourriel = idUe.substr(0, 1) == '-';

                sauvegarderInfosMutation(function (reponse) {
                    if (reponse.reponse == 'ok') {
                        if (idEvenement === '') { // On permet la sauvegarde uniquement si aucune ue déjà sauvegardé
                            saveEvenementParLocalisation(callback);
                        } else if (idEvenement != '' && receptionMutationParCourriel) { // On permet la sauvegarde s'il y a déjà un évènement et qu'on arrive de la réception de mutation par courriel
                            saveEvenementParLocalisation(function (reponse) {
                                callback(reponse);
                            }, idEvenement);
                        } else {
                            callback(reponse);
                        }
                    } else {
                        callback(reponse);
                    }
                });
            }
        }

        /**
         * Fonction de sauvegarde de l'étape de la méthode de comparaison
         * */
        function saveMethodeComparaison(callback) {
            var a = 1;
        }

        function get_bool_mutation_simple() {
            var nbUeLotsForm = $('[id="mutation-ue-lots"]').length;
            var nbUeLotsChecked = $('[name="bool_lot_inclus"]:checked').length;
            return nbUeLotsForm == nbUeLotsChecked;
        }

         function get_bool_mutation_simple_ajax(idEvenement, idProcessus) {
            var estSimple = false;
            var params = {
                'id_evenement': idEvenement,
                'id_mutation': idProcessus
            };
            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/mutation/is-mutation-complexe-ajax/",
                data: params,
                async: false,
                dataType: 'json',
                success: function (response) {
                    if (response) {
                        estSimple = !response.est_simple;
                    }
                }
            });
            return estSimple;
        }

        function sauvegarderInfosMutation(callback) {
            var pageCourante = $('.step-pane.active');
            var sections = pageCourante.find('#accordion-mutation-lots-ue-impliques, #localisation-ue-infos-mutation, #accordion-mutation-multiples-ues');
            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var params = [];
                if (idCurrentForm === 'mutation-multiples-ues-form') {
                    params = controlesFormulaires.serialiserFormulaire(currentForm); // utiliser pour les checkbox
                    params.push({name: 'uniteEvaluation', value: currentForm.find('[name="uniteEvaluation"]').text()});
                    params.push({name: 'id_mutation', value: currentForm.attr('id-mutation')});
                } else if (idCurrentForm === 'localisation-ue-infos-mutation') {
                    params.push({
                        name: 'bool_mutation_multiple_ventilee',
                        value: $('[id="mutation-multiples-ues-form"]').length > 1
                    });
                    params.push({name: 'bool_mutation_simple', value: get_bool_mutation_simple()});
                    params.push({name: 'bool_premier_chargement', value: false});
                    params.push({name: 'bool_meme_cessionnaire', value: false});
                    params.push({name: 'est_exp_ue_recherche', value: $('#div-resultat').length > 0});
                } else {
                    params = controlesFormulaires.serialiserFormulaire(currentForm); // utiliser pour les checkbox
                    params.push({name: 'b00Cadastre', value: currentForm.find('[name="id_b00_cadastre"]').text()});
                    params.push({name: 'uniteEvaluation', value: currentForm.find('[name="lot_id_ue"]').text()});
                    params.push({name: 'mutation', value: $('#wizard').attr('id-processus')});
                }
                return params;
            };
            var getChampUnique = function (currentForm, idCurrentForm) {
                if (idCurrentForm == 'mutation-ue-lots') {
                    return {
                        unique_nom_champ: 'id_b00_cadastre',
                        unique_id_champ: currentForm.find('[name="id_b00_cadastre"]').text()
                    };
                }
                if (idCurrentForm == 'mutation-multiples-ues-form') {
                    return {
                        unique_nom_champ: 'index_ligne',
                        unique_id_champ: currentForm.closest('.div-table-contenu').find('[id="mutation-multiples-ues-form"]').index(currentForm)
                    };
                }
                return {};
            };
            var getChampTransfert;
            var messageToast = {};
            sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);
        }

        function initScenarioMutation() {
        }


        function saveScenarioMutation(callback) {
            var nbErreurs = 0;
            var listeFormulaires = [];
            var formMutation = $('#mutation-scenario');
            listeFormulaires = formMutation;

            var idEvenement = $('#wizard').attr('id-evenement');
            var idMutation = $('#mutation-scenario').attr('id-model-instance');

            var bool_ue_complete = $('#mutation-scenario').find("input[name=bool_ue_complete]:checked").val();
            var bool_fusion_lot_adjacent = $('#mutation-scenario').find("input[name=bool_fusion_lot_adjacent]:checked").val();

            $.each(listeFormulaires, function () {
                var currentForm = $(this);
                var params = controlesFormulaires.serialiserFormulaire(currentForm);

                params.push({name: 'id_evenement', value: idEvenement});
                params.push({name: 'id_mutation', value: idMutation});

                if (typeof (bool_ue_complete) != 'undefined') {
                    params.push({name: 'bool_ue_complete', value: bool_ue_complete});
                }

                if (typeof (bool_fusion_lot_adjacent) != 'undefined') {
                    params.push({name: 'bool_fusion_lot_adjacent', value: bool_fusion_lot_adjacent});
                }

                // indiquer qu'on vient de l'assistant pour effectuer la validation
                params.push({name: 'wizard_mode', value: true});

                var url = currentForm.attr('vue');
                if (currentForm.attr('methode') != 'POST') {
                    url += currentForm.attr('id-model-instance') + '/';
                }
                var etapeProcessus = $('#modal-step-contents > .active').attr('data-id_processus');
                var messageToast = {
                    message: "Informations mises à jour"
                };
                var rechargerPage = false;
                nbErreurs += sauvegarderDonnees(currentForm, url, false, 'json', params, etapeProcessus, messageToast, listeFormulaires.length, rechargerPage, callback);
            });
        }

        function initRechercheProprietaire(selectedCallback) {
            var id_ue = $('#wizard').attr('id-ue');
            var contenuRechercheProprio = $('#contenu-proprietaire-recherche');
            var inputsSelect2Ajax = contenuRechercheProprio.find('input[name$="nom_legal"], input[name$="prenom"]');

            var statutProprietaire = contenuRechercheProprio.find('[name="statutProprietaire"]');
            disableNomPrenomProprio(statutProprietaire, contenuRechercheProprio);

            statutProprietaire.on('change', function () {
                disableNomPrenomProprio($(this), contenuRechercheProprio);
            });

            disableBoutonAjouterProprio(contenuRechercheProprio);

            contenuRechercheProprio.find(':input.form-control').on('change', function () {
                var name = $(this).attr('name');
                var container = $('#contenu-proprietaire-recherche');
                disableBoutonAjouterProprio(container);
            });


            var contenuCessionnaire = $('#section-cessionnaire');
            if (!contenuCessionnaire.length) {
                contenuCessionnaire = $('#adresse-proprietaire-apres-container');
                if (contenuCessionnaire.length) {
                    // changer le title sur le bouton Ajouter quand on est dans 'Renseignements administratifs'
                    contenuRechercheProprio.find('button[data-action="ajouter-au-cessionnaire"]').attr('title', 'Ajouter ce propriétaire');
                }
            }

            contenuRechercheProprio.off('click.mutation.ajouter.proprio_existant').on('click.mutation.ajouter.proprio_existant', '[data-action="ajouter-au-cessionnaire"]', function (a) {
                var inputs = $(this).closest('.form-horizontal').find(':input.form-control').not('[name="adresse_complete"], [name="id_proprietaire_x_unite_evaluation"]');
                var inputsDisabled = inputs.filter(':disabled').attr('disabled', false);
                var params = inputs.serializeArray();
                inputsDisabled.attr('disabled', true);

                // pour l'adresse complète, prendre l'attribut plutôt que val() car on ne veut pas prendre l'adresse affichée avec le complément
                params.push({
                    name: 'adresse_complete',
                    value: $(this).closest('.form-horizontal').find('[name="adresse_complete"]').attr('adresse-complete')
                });

                if (ajouterEditerProprietaire(params, contenuCessionnaire)) {

                    //vider tous les champs une fois que c'est ajouté au cessionnaire
                    contenuRechercheProprio.find(':input.form-control').val('');
                    contenuRechercheProprio.find(':input.form-control').select2('val', '');
                    disableNomPrenomProprio(statutProprietaire, contenuRechercheProprio);
                    disableBoutonAjouterProprio(contenuRechercheProprio);
                }
            });

            // var initialValues = selectNomLegal.attr('initial-choices');
            // // var initialValues = [{'test': 'premier_test'}];
            // var data = [];
            // if (initialValues) {
            //     var jsonObj = $.parseJSON(initialValues);
            //     for (var i = 0; i < jsonObj.length; i++) {
            //         data.push({id: jsonObj[i][0], text: jsonObj[i][1]});
            //     }
            // }

            var url = "/gestion-roles/tenue-a-jour/mutation/identification-partie/get-choix-adresse-proprietaire/";

            var estCorrectionMineure = (typeof (selectedCallback) != 'undefined');
            if (estCorrectionMineure) {
                id_ue = ''; // hack pour éviter d'exclure l'UE en cours dans correction mineure
            }

            var nbParPage = 100;
            inputsSelect2Ajax.select2({
                ajax: {
                    url: url,
                    dataType: 'json',
                    quietMillis: 500,
                    data: function (searchTerm, pageNumber) {
                        var dateEvenement = $('#wizard').attr('date-evenement');
                        var municipalite = $('#wizard').attr('id-municipalite');
                        var elementName = $(this).attr('name');
                        var nomLegal = contenuRechercheProprio.find('[name$="nom_legal"]');
                        var prenom = contenuRechercheProprio.find('[name$="prenom"]');

                        return {
                            page: pageNumber,
                            nb_x_page: nbParPage,
                            filtre_nom_legal: elementName == 'nom_legal' ? searchTerm : nomLegal.val(),
                            filtre_prenom: elementName == 'prenom' ? searchTerm : prenom.val(),
                            date_evenement: dateEvenement,
                            id_ue: id_ue,
                            filtre_statut_proprietaire: $(this).closest('.form-horizontal').find('[name="statutProprietaire"]').val(),
                            id_municipalite: municipalite,
                            id_mutation: $('#wizard').attr('id-processus'),
                            id_type_evenement: $('#wizard').attr('id-type-evenement'),
                        };
                    },
                    results: function (remoteData, pageNumber, query) {
                        // garder le texte recherché pour l'afficher si on ferme le dropdown sans sélection
                        query.element.attr('texte-recherche', query.term.toUpperCase());

                        var more = (pageNumber * nbParPage) < remoteData.total_count;
                        var elementName = query.element.attr('name');
                        $.each(remoteData.adresses_proprio, function (index, data) {
                            var texte = data.nom_legal;
                            if (data.prenom) texte += ', ' + data.prenom;
                            if (data.adresse_complete) texte += ', ' + data.adresse_complete;
                            if (data.complement) texte += ', ' + data.complement;
                            data.id = elementName == 'nom_legal' ? data.nom_legal : data.prenom ? data.prenom : '';
                            data.text = texte;
                        });
                        return {
                            results: remoteData.adresses_proprio,
                            more: more
                        };
                    },
                    cache: true
                },
                placeholder: "Rechercher...",
                minimumInputLength: 2,
                allowClear: true,
                dropdownAutoWidth: true,
                escapeMarkup: function (markup) {
                    return markup;
                },
                // nextSearchTerm: function(selectedObject, currentSearchTerm) {
                //     // ceci affiche la dernière recherche dans le sélecteur et ça charge la liste de sélection automatiquement
                //     return currentSearchTerm.toUpperCase();
                // },
                initSelection: function (element, callback) {
                    // si on met à jour l'élément avec select2('val', ...) depuis formatSelection, alors, il passe ici pour retourner l'information
                    var data = {id: element.val(), text: element.val()};
                    callback(data);
                },
                formatResult: function (result, container, query, escapeMarkup) {
                    // on a une donnée à souligner en plus du terme qui est souligné par défaut
                    var ret = $.fn.select2.defaults.formatResult(result, container, query, escapeMarkup);
                    var queryTerm = query.term;
                    var resultText = result.text;
                    // souligner le terme et la valeur de l'autre input s'il est saisi
                    var nomLegalVal = contenuRechercheProprio.find('[name$="nom_legal"]').val();
                    var prenomVal = contenuRechercheProprio.find('[name$="prenom"]').val();
                    if (nomLegalVal || prenomVal) {
                        var element = this.element;
                        var elementName = element.attr('name');
                        if (elementName == 'nom_legal' && prenomVal) {
                            query.term = prenomVal;
                        }
                        if (elementName == 'prenom' && nomLegalVal) {
                            query.term = nomLegalVal;
                        }
                        result.text = ret;
                        ret = $.fn.select2.defaults.formatResult(result, container, query, escapeMarkup);
                        query.term = queryTerm;
                        result.text = resultText;
                        return ret;
                    }
                    return ret;
                },
                formatSelection: function (data, container, escapeMarkup) {
                    var element = this.element;
                    var elementName = element.attr('name');
                    var nomLegal = contenuRechercheProprio.find('[name$="nom_legal"]');
                    var prenom = contenuRechercheProprio.find('[name$="prenom"]');
                    var proprietaire = contenuRechercheProprio.find('[name$="proprietaire"]');
                    var adresse = contenuRechercheProprio.find('[name$="adresse_complete"]');
                    var complement = contenuRechercheProprio.find('[name$="complement"]');
                    var idUeProprioExistant = contenuRechercheProprio.find('[name="id_ue_proprio_existant"]');
                    var idB02AdresseProprietaire = contenuRechercheProprio.find('[name="id_b02_adresse_proprietaire"]');
                    var idProprietaireXUniteEvaluation = contenuRechercheProprio.find('[name="id_proprietaire_x_unite_evaluation"]');

                    // effacer le texte recherché, qui est gardé comme attribut dans le input, car une sélection est faite ou il est affiché dans le sélecteur
                    $(element).removeAttr('texte-recherche');

                    if (data.proprietaire) {
                        if (elementName == 'nom_legal') {
                            // remplacer le texte de la sélection par le nom légal pour l'afficher dans le sélecteur
                            data.text = data.nom_legal;
                            // mettre à jour le prénom pour l'afficher dans le sélecteur
                            prenom.select2('val', data.prenom);
                        }
                        if (elementName == 'prenom') {
                            // remplacer le texte de la sélection par le prénom pour l'afficher dans le sélecteur
                            data.text = data.prenom;
                            // mettre à jour le nom légal pour l'afficher dans le sélecteur
                            nomLegal.select2('val', data.nom_legal);
                        }
                        proprietaire.val(data.proprietaire);
                        proprietaire.trigger('change');

                        var adresseAffichee = data.adresse_complete;
                        if (data.complement) {
                            adresseAffichee += ', ' + data.complement;
                        }
                        adresse.val(adresseAffichee);
                        // garder l'adresse sans le complément pour l'afficher dans 'adresse postale' du cessionnaire
                        adresse.attr('adresse-complete', data.adresse_complete);

                        complement.val(data.complement);
                        idUeProprioExistant.val(data.id_ue_proprio_existant);
                        idB02AdresseProprietaire.val(data.id_b02_adresse_proprietaire);
                        idProprietaireXUniteEvaluation.val(data.id_proprietaire_x_unite_evaluation);
                    } else {
                        proprietaire.val('');
                        proprietaire.trigger('change');
                        adresse.val('');
                        adresse.attr('adresse-complete', '');
                        complement.val('');
                        idUeProprioExistant.val();
                        idB02AdresseProprietaire.val();
                        idProprietaireXUniteEvaluation.val();
                    }

                    if (typeof (selectedCallback) != 'undefined') {
                        selectedCallback();
                    }

                    return $.fn.select2.defaults.formatSelection(data, container, escapeMarkup);
                },
            });

            // mettre le texte à rechercher en majuscules
            inputsSelect2Ajax.each(function () {
                $(this).select2('container').find(".select2-search input.select2-input").css('text-transform', 'uppercase');
            });

            // sur la fermeture du sélecteur, vérifier si on doit afficher le texte recherché
            inputsSelect2Ajax.on('select2-close', function (e) {
                var texteRecherche = $(this).attr('texte-recherche');
                if (texteRecherche) {
                    $(this).select2('val', texteRecherche, true);
                }
            });
            // sur la suppression de la sélection, effacer le propriétaire et l'adresse
            inputsSelect2Ajax.on('select2-clearing', function (e) {
                var container = $('#contenu-proprietaire-recherche');
                container.find('[name="proprietaire"]').val('');
                container.find('[name="adresse_complete"]').val('');
            });

        }

        function disableNomPrenomProprio(statutProprietaire, container) {
            container.find('[name="nom_legal"]').attr('disabled', statutProprietaire.val() == '');
            // le prénom doit être disabled si autre que 'Personne physique' est choisi
            container.find('[name="prenom"]').attr('disabled', statutProprietaire.val() != '1');
        }

        function initCreationEditionAdresseProprietaire(contenuCessionnaire, contenuRechercheProprio) {
            var dateEvenement = $('#wizard').attr('date-evenement');
            var idUe = $('#wizard').attr('id-ue');

            $('#modal-wizard-evenement').off('click.mutation.creer.proprio').on('click.mutation.creer.proprio', '[data-action="editer-adresse-proprietaire"], [data-action="creer-proprietaire"]', function (a) {
                wait.start();
                var modeEdition = $(this).attr('data-action') == 'editer-adresse-proprietaire';
                // var idTypeEvenement = $('#wizard').attr('id-type-evenement');
                var vueParams = [];
                var titre = '';
                var vue = '';
                var currentForm = $(this).closest('[type="formulaire"]');
                var boolMemeAdresseUe = currentForm.find('[name="bool_meme_adresse_ue"]');

                if (modeEdition && currentForm.attr('id-model-instance') === '') {
                    wait.stop();
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: "Vous devez sauvegarder le cessionnaire avant d'éditer l'adresse.",
                        messageCouleur: "red",
                        messageDuree: 0
                    });
                    return;
                }

                if (modeEdition) {
                    titre = "Édition de l'adresse du propriétaire";
                    vue = "/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/editer-adresse-proprietaire/";
                    vueParams = {
                        id_proprietaire_x_unite_evaluation: currentForm.attr('id-model-instance'),
                        bool_meme_adresse_ue: boolMemeAdresseUe.attr('value'), // prendre value qui est un attribut ajouté sur le div
                        id_proprietaire: currentForm.find('[name="proprietaire"]').text(),
                        id_b02_adresse_proprietaire: currentForm.find('[name="id_b02_adresse_proprietaire"]').text(),
                        id_ue_proprio_existant: currentForm.find('[name="id_ue_proprio_existant"]').text(),
                        adresse_complete: currentForm.find('[name="adresse_complete"]').text(),
                        complement: currentForm.find('[name="complement"]').text(),
                        date_initiale_inscription: currentForm.find('[name="date_initiale_inscription"]').val(),
                        pourcentage: currentForm.find('[name="pourcentage"]').val(),
                        bool_proprietaire_principal: currentForm.find('[name="bool_proprietaire_principal"]').is(':checked') ? 1 : 0,
                        cessionnaire_est_cedant: currentForm.attr('cessionnaire-est-cedant'),
                        id_ue: currentForm.find('[name="id_ue"]').text() ? currentForm.find('[name="id_ue"]').text() : idUe,
                        date_evenement: dateEvenement,
                        id_evenement: $('#wizard').attr('id-evenement'),
                        id_type_evenement: $('#wizard').attr('id-type-evenement')
                    };
                } else {
                    var sis = contenuRechercheProprio.find('[name="statutProprietaire"]');
                    var nomLegal = contenuRechercheProprio.find('[name$="nom_legal"]');
                    var prenom = contenuRechercheProprio.find('[name$="prenom"]');
                    titre = "Création d'un nouveau propriétaire";
                    vue = "/gestion-roles/tenue-a-jour/mutation/identification-partie/creer-adresse-proprietaire/";
                    vueParams = {
                        statutProprietaire: sis.val(),
                        nom_legal: nomLegal.val(),
                        prenom: prenom.val(),
                        id_ue: idUe,
                        date_evenement: dateEvenement,
                        id_type_evenement: $('#wizard').attr('id-type-evenement'),
                        est_creation_proprietaire: true
                    };
                }

                vueParams.liste_id_b02_pour_copie = JSON.stringify($.unique($.makeArray(contenuCessionnaire.find('[name="id_b02_adresse_proprietaire"]').map(function () {
                    return parseInt($(this).text());
                }))));

                fenetreModal.modalMessage({
                    taille: 'immense',
                    enteteTitre: titre,
                    texteExplicatif: "",
                    vueACharger: vue,
                    vueAChargerParams: vueParams,
                    boutons: {
                        "Annuler": {
                            label: " Annuler ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        },
                        "Sauvegarder": {
                            label: " Sauvegarder ",
                            id: "sauvegarder-adresse-proprietaire",
                            type: 'save',
                            class: "btn btn-primary",
                            action: function (e) {
                                let containerProprietaire = $('#creation-proprietaire');
                                let modifierProprietaire = containerProprietaire.attr('modifier-proprietaire') === 'True';
                                if (modifierProprietaire) {
                                    let proprietaireModifie = false;
                                    $.each(containerProprietaire.find('[name="nom_legal"], [name="prenom"], [name="statutProprietaire"]'), function () {
                                        // si on permet de modifier le propriétaire, on remet à None le id-model-instance pour créer un nouveau id_proprietaire
                                        if (controleEstModifie($(this))) {
                                            proprietaireModifie = true;
                                            containerProprietaire.attr('proprietaire-avant-creation', containerProprietaire.attr('id-model-instance'));
                                            containerProprietaire.attr('id-model-instance', 'None');
                                            containerProprietaire.attr('methode', 'POST');
                                            let containerAdresseProprietaire = $('#creation-adresse-proprietaire');
                                            if (containerAdresseProprietaire.attr('id-model-instance') !== '') {
                                                // indiquer que l'adresse est modifiée pour lui assigner le nouveau propriétaire
                                                containerAdresseProprietaire.attr('modifie', 'True');
                                            }
                                            return false;
                                        }
                                    });
                                    // si aucun des champs du propriétaire n'a changé et que le sélecteur API n'est pas changé, alors on indique que le form n'a pas changé
                                    let boolMemeAdresseUe = containerProprietaire.find('[name="bool_meme_adresse_ue"]');
                                    if (!proprietaireModifie && !controleEstModifie(boolMemeAdresseUe)) {
                                        containerProprietaire.attr('modifie', 'False');
                                    }
                                }

                                sauvegarderAdresseProprietaire(modeEdition, false, function (response) {
                                    if (response.reponse == 'error') {
                                        // on veut rester sur la page vu qu'il y a des erreurs
                                        e.preventDefault();
                                    } else {
                                        var sectionProprio = $('#accordion-creation-proprietaire');
                                        var inputDisabled = sectionProprio.find(':input:disabled').attr('disabled', false);
                                        var params = sectionProprio.find(':input.form-control').serializeArray();
                                        inputDisabled.attr('disabled', true);
                                        params.push({
                                            name: 'proprietaire',
                                            value: sectionProprio.find('[type="formulaire"]').attr('id-model-instance')
                                        });
                                        params.push({
                                            name: 'proprietaire-avant-creation',
                                            value: sectionProprio.find('[type="formulaire"]').attr('proprietaire-avant-creation')
                                        });

                                        var sectionAdresse = $('#accordion-creation-adresse-proprietaire');
                                        var b02Instance = sectionAdresse.find('[type="formulaire"]').attr('id-model-instance');
                                        params.push({
                                            name: 'id_b02_adresse_proprietaire',
                                            value: b02Instance
                                        });
                                        params.push({
                                            name: 'adresse_complete',
                                            value: sectionProprio.find('[name="bool_meme_adresse_ue"]').val() == '1' && !b02Instance ?
                                                $('#edition-adresse-ue').attr('adresse-complete') :
                                                sectionAdresse.find('[name="adresse_complete"]').val()
                                        });
                                        params.push({
                                            name: 'complement',
                                            value: sectionAdresse.find('[name="complement"]').val()
                                        });

                                        if (modeEdition) {
                                            // prendre le id-model-instance de pxue dans le popup car il peut y avoir été créé
                                            var sectionPxue = $('#edition-proprietaire-x-unite-evaluation');
                                            params.push({
                                                name: 'id_proprietaire_x_unite_evaluation',
                                                value: sectionPxue.attr('id-model-instance')
                                            });
                                            // - si on est en édition, on change le 'proprietaire' pour celui du modale de la section pxue car
                                            //   on peut avoir créer un nouveau propriétaire dans l'ajout de l'adresse b02
                                            // - si on modifie le propriétaire, ne pas remettre l'ancien 'proprietaire', on veut garder le nouveau 'proprietaire'
                                            if (!modifierProprietaire) {
                                                params.push({
                                                    name: 'proprietaire',
                                                    value: sectionPxue.attr('id_proprietaire')
                                                });
                                            }
                                            params.push({
                                                name: 'pourcentage',
                                                value: currentForm.find('[name="pourcentage"]').val()
                                            });
                                            params.push({
                                                name: 'bool_proprietaire_principal',
                                                value: currentForm.find('[name="bool_proprietaire_principal"]').val()
                                            });
                                            var dateInitialeInscription = currentForm.find('[name="date_initiale_inscription"]');
                                            params.push({
                                                name: 'date_initiale_inscription',
                                                value: dateInitialeInscription.is('input') ?
                                                    dateInitialeInscription.val() :
                                                    dateInitialeInscription.text()
                                            });
                                            params.push({name: 'uniteEvaluation', value: sectionPxue.attr('id_ue')});
                                        }

                                        ajouterEditerProprietaire(params, contenuCessionnaire, currentForm.attr('modifie'), modeEdition);

                                        fenetreModal.fermerModalAlerteDivs();
                                    }
                                });
                            }
                        }
                    },
                    callback_on_escape: function () {
                        // s'il y a eu des changements dans la page, on propose la sauvegarde
                    }
                });

                initChangementAdressePostale(modeEdition);

                wait.stop();
            });
        }

        function initSuppressionProprietaire() {

            function supprimerProprietaire(currentForm, idCurrentForm) {
                if (currentForm.attr('id-model-instance') == '') {
                    currentForm.remove();
                    appliquerCedantModifie(currentForm);
                } else {
                    currentForm.attr('methode', 'DELETE');
                    currentForm.attr('modifie', 'True');

                    var callbackSave = function (response) {
                        if (response.reponse == 'ok') {
                            // mettre modifie=True aux autres lignes de propriétaires pour effectuer la sauvegarde de l'étape
                            $('[id="' + idCurrentForm + '"]').attr('modifie', 'True');
                            $('button[data-type="save"]').attr("disabled", false);
                            appliquerCedantModifie(currentForm);

                            // remettre l'étape précédente et invalider les étapes subséquentes
                            var etapeSauvegardeeSuivanteActive = $('#wizard').attr('etape-sauvegardee-suivante-active');
                            sauvegarderStatutEvenementEtapeProcessus(function (response) {
                                if (response.reponse == 'error') {
                                    retour = false;
                                } else {
                                    invaliderEtapeSubsequente(etapeSauvegardeeSuivanteActive);
                                }
                            }, true);
                        }
                    };
                    sauvegarderSuppressionProprietaire(callbackSave);
                }
            }

            $('#modal-wizard-evenement').off('click.mutation.supprimer.tous.proprietaires').on('click.mutation.supprimer.tous.proprietaires', '[data-action="supprimer-tous-proprietaires"]', function (a) { // Delegated Event
                wait.start('contenu');
                fenetreModal.modalMessage({
                    titre: "Voulez-vous vraiment supprimer tous les cessionnaires?",
                    texteExplicatif: "Cela aura pour effet de supprimer tous les cessionnaires de l'évènement en cours.",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                var sectionCessionnaire = $('#section-cessionnaire');
                                $.each(sectionCessionnaire.find('[data-action="supprimer-proprietaire"]'), function (){
                                    var currentForm = $(this).closest('[type="formulaire"]');
                                    var idCurrentForm = currentForm.attr('id');
                                    supprimerProprietaire(currentForm, idCurrentForm);
                                });
                                // cacher le bouton qui supprime tous les propriétaires
                                sectionCessionnaire.find('[data-action="supprimer-tous-proprietaires"]').hide();
                                wait.stop('contenu');
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                                wait.stop('contenu');
                            }
                        }
                    }

                });
            });

            $('#modal-wizard-evenement').off('click.mutation.supprimer.proprietaire').on('click.mutation.supprimer.proprietaire', '[data-action="supprimer-proprietaire"]', function (a) { // Delegated Event
                wait.start('contenu');

                var currentForm = $(this).closest('[type="formulaire"]');
                var idCurrentForm = currentForm.attr('id');
                var texteProprietaire = 'cessionnaire';
                if (idCurrentForm == 'correction-mineure-changement-adresse-proprietaire') {
                    texteProprietaire = 'propriétaire';
                }
                fenetreModal.modalMessage({
                    titre: "Voulez-vous vraiment supprimer ce " + texteProprietaire + " ?",
                    texteExplicatif: "Cela aura pour effet de supprimer ce " + texteProprietaire + " de l'évènement en cours.",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                supprimerProprietaire(currentForm, idCurrentForm);
                                var sectionCessionnaire = $('#section-cessionnaire');
                                if (sectionCessionnaire.find('[type="formulaire"]').length == 0) {
                                    // cacher le bouton qui supprime tous les propriétaires si aucun propriétaire
                                    sectionCessionnaire.find('[data-action="supprimer-tous-proprietaires"]').hide();
                                }
                                wait.stop('contenu');
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                                wait.stop('contenu');
                            }
                        }
                    }
                });
            });
        }

        function initChangementAdressePostale(modeEdition) {
            var dateEvenement = $('#wizard').attr('date-evenement');
            controlesFormulaires.retirerAccents();
            var secteurChargement = $('#creation-adresse-proprietaire').find('[name="secteur"]').val();

            initProprietaire();
            initProprietaireInteractionAdresse();
            initAdresseProprietaire();

            var boolMemeAdresseUe = $('#creation-proprietaire').find('[name="bool_meme_adresse_ue"]');
            if (boolMemeAdresseUe.val() == '1') {
                boolMemeAdresseUe.trigger('change', true);
            }
            // faire un reset sur la notification du changement
            $('#creation-proprietaire, #creation-adresse-proprietaire').attr('modifie', 'False');
            // si on trouve une classe 'activer-sauvegarder' sur un champ, on laisse le bouton 'Sauvegarder' actif
            if (!$('.activer-sauvegarder').length) {
                $('#modal-message-alerte').find('button[data-type="save"]').attr("disabled", true);
            }
            $('#creation-proprietaire').find(':input').removeClass('controle-modifie').removeClass('valeur-modifiee');

            // si le secteur est déjà rempli mais on n'affiche pas le sélecteur selon la municipalite(bool_secteur=False),
            // il faut notifier la sauvegarde du secteur qui est vidé
            var containerAdresseProprietaire = $('#creation-adresse-proprietaire');
            var secteur = containerAdresseProprietaire.find('[name="secteur"]');
            var municipalite = containerAdresseProprietaire.find('[name="municipalite_liste"]');
            if (municipalite.length) {
                var optionSelected = $(municipalite[0].options[municipalite[0].selectedIndex]);
                var munBoolSecteur = optionSelected.attr('bool_secteur') == 'true';
                if (!munBoolSecteur && secteurChargement) {
                    secteur.trigger('change');
                }
            }

            var modeReadOnly = $('#wizard').attr('mode') == 'r';
            if (modeReadOnly) {
                $('#creation-proprietaire, #creation-adresse-proprietaire').find(':input').prop('disabled', true);
                $('#creation-adresse-proprietaire').find('.bouton-copie-adresse').remove();
            }

            scroll.ajouterSlimScroll('#modal-message-alerte-contenu', {hauteur: 700});

            function initProprietaire() {
                let containerProprietaire = $('#creation-proprietaire');
                let statutProprietaire = containerProprietaire.find('[name="statutProprietaire"]');
                let modeEdition = containerProprietaire.attr('mode-edition') === 'True';
                let modifierProprietaire = containerProprietaire.attr('modifier-proprietaire') === 'True';

                disableNomPrenomProprio(statutProprietaire, containerProprietaire);

                statutProprietaire.on('change', function () {
                    disableNomPrenomProprio($(this), containerProprietaire);
                });

                if (modeEdition && !modifierProprietaire) {
                    containerProprietaire.find(':input').not('[name="bool_meme_adresse_ue"]').attr('disabled', true);
                }

                // mettre cette détection à la fin pour ne pas attraper les events lors du chargement
                detecterChangementCreationEditionAdresseProprietaire(containerProprietaire);
            }

            function initProprietaireInteractionAdresse() {
                var containerProprietaire = $('#creation-proprietaire');
                var containerAdresseProprietaire = $('#creation-adresse-proprietaire');
                var sectionAdresseInfos = containerAdresseProprietaire.find('#adresse-infos');
                var codePostal = containerAdresseProprietaire.find('[name="code_postal"]');
                var pays = containerAdresseProprietaire.find('[name="pays"]');
                var provinceEtat = containerAdresseProprietaire.find('[name="province_etat_liste"]');
                var municipalite = containerAdresseProprietaire.find('[name="municipalite_liste"]');
                var secteur = containerAdresseProprietaire.find('[name="secteur"]');
                var listeAdresseUe = containerAdresseProprietaire.find('[name="liste_adresse_ue"]');
                var noCivique = containerAdresseProprietaire.find('[name="no_civique"]');
                var complementNoCivique = containerAdresseProprietaire.find('[name="complement_no_civique"]');
                var noAppartementLocal = containerAdresseProprietaire.find('[name="no_appartement_local"]');
                var complementNoAppartementLocal = containerAdresseProprietaire.find('[name="complement_no_appartement_local"]');
                var casierPostal = containerAdresseProprietaire.find('[name="casier_postal"]');
                var succursalePostale = containerAdresseProprietaire.find('[name="succursale_postale"]');
                var modeEdition = containerAdresseProprietaire.attr('mode-edition') === 'True';
                var noCiviqueOriginal = containerAdresseProprietaire.find('[name="no_civique_original"]');
                var noCiviqueSuperieur = containerAdresseProprietaire.find('[name="no_civique_superieur"]');
                var adresseComplete = containerAdresseProprietaire.find('[name="adresse_complete"]');
                var adresseCourte = containerAdresseProprietaire.find('[name="adresse_courte"]');
                var containerAdresseUe = $('#edition-adresse-ue');
                var b02Instance = containerAdresseProprietaire.attr('id-model-instance');

                if (!modeEdition) {
                    sectionAdresseInfos.find(':input').attr('disabled', true);
                }

                initAPICreationProprio();

                function initAPICreationProprio() {

                    if (containerProprietaire.find('[name="bool_meme_adresse_ue"]').val() === '1') {
                        // au chargement, s'il existe un b02 pour cette ue, on garde les infos dans le div 'edition-adresse-ue'
                        if (b02Instance) {
                            containerAdresseUe.attr('no_civique', noCivique.val());
                            containerAdresseUe.attr('complement_no_civique', complementNoCivique.val());
                            containerAdresseUe.attr('no_appartement_local', noAppartementLocal.val());
                            containerAdresseUe.attr('complement_no_appartement_local', complementNoAppartementLocal.val());
                            containerAdresseUe.attr('casier_postal', casierPostal.val());
                            containerAdresseUe.attr('succursale_postale', succursalePostale.val());
                            if (secteur.val() !== '') {
                                containerAdresseUe.attr('secteur', secteur.val());
                            }
                        }
                    }

                    containerProprietaire.off('change.creer.proprio.modifier.API').on('change.creer.proprio.modifier.API', '[name="bool_meme_adresse_ue"]', function (event, estChargement) {
                        var boolMemeAdresseUe = $(this).val();

                        if (boolMemeAdresseUe === '1') {
                            let valeurAdresseComplete = adresseComplete.val();
                            let valeurAdresseCourte = adresseCourte.val();

                            resetSectionsAdressePostales(1, true);
                            sectionAdresseInfos.find(':input').attr('disabled', true);

                            var inputs = containerAdresseProprietaire.find('#adresse-infos, #adresse-postale-structuree').find(':input.form-control');
                            $.each(inputs, function () {
                                var input = $(this);
                                var inputName = input.attr('name');
                                if (input.hasClass('select2')) {
                                    input.select2('val', containerAdresseUe.attr(inputName));
                                } else {
                                    input.val(containerAdresseUe.attr(inputName));
                                }
                            });

                            // utiliser pour mettre les ajax en cascade avec async=false pour charger les données de l'adresse ue
                            // autant en édition qu'en création
                            let modeEditionAvant = $('#creation-adresse-proprietaire').attr('mode-edition');
                            if (estChargement === undefined) {
                                $('#creation-adresse-proprietaire').attr('mode-edition', 'True');
                            }

                            codePostal.val(containerAdresseUe.attr('code-postal'));
                            codePostal.prop('disabled', containerAdresseUe.attr('code-postal'));
                            pays.select2('val', containerAdresseUe.attr('id-pays'), true);
                            provinceEtat.select2('val', containerAdresseUe.attr('id-province-etat'), true);
                            municipalite.select2('val', containerAdresseUe.attr('id-municipalite'), true);
                            secteur.select2('val', containerAdresseUe.attr('secteur'), true);
                            noCiviqueOriginal.val(containerAdresseUe.attr('no_civique_original'));
                            noCiviqueSuperieur.val(containerAdresseUe.attr('no_civique_superieur'));
                            adresseComplete.val(b02Instance ? valeurAdresseComplete : containerAdresseUe.attr('adresse_complete'));
                            adresseCourte.val(b02Instance ? valeurAdresseCourte : containerAdresseUe.attr('adresse_courte'));
                            listeAdresseUe.select2('val', containerAdresseUe.attr('adresse-courte'));
                            listeAdresseUe.attr('disabled', true);

                            if (estChargement === undefined) {
                                $('#creation-adresse-proprietaire').attr('mode-edition', modeEditionAvant);
                            }
                        } else {
                            sectionAdresseInfos.find(':input').attr('disabled', boolMemeAdresseUe === '');
                            resetSectionAdresseInfos();
                            resetSectionsAdressePostales(-1);
                        }
                    });
                }
            }

            function initAdresseProprietaire() {
                // #13143 utilisé pour bypass certains event (on change, reset de champs) lors de l'init
                var initAdresseProprietaireDone = false;

                var containerAdresseProprietaire = $('#creation-adresse-proprietaire');
                var codePostal = containerAdresseProprietaire.find('[name="code_postal"]');
                var pays = containerAdresseProprietaire.find('[name="pays"]');
                var provinceEtat = containerAdresseProprietaire.find('[name="province_etat_liste"]');
                var provinceEtatInputHidden = containerAdresseProprietaire.find('[name="provinceEtat"]');
                var municipalite = containerAdresseProprietaire.find('[name="municipalite_liste"]');
                var municipaliteInputHidden = containerAdresseProprietaire.find('[name="municipalite"]');
                var secteur = containerAdresseProprietaire.find('[name="secteur"]');
                var nomPays = containerAdresseProprietaire.find('[name="nom_pays"]');
                var nomProvinceEtat = containerAdresseProprietaire.find('[name="nom_province_etat"]');
                var nomMunicipalite = containerAdresseProprietaire.find('[name="nom_municipalite"]');
                var listeAdresseUe = containerAdresseProprietaire.find('[name="liste_adresse_ue"]');
                var generiqueAdresse = containerAdresseProprietaire.find('[name="generiqueAdresse"]');
                var lienAdresse = containerAdresseProprietaire.find('[name="lienAdresse"]');
                var orientationAdresse = containerAdresseProprietaire.find('[name="orientationAdresse"]');
                var boolMemeAdresseUe = $('#creation-proprietaire').find('[name="bool_meme_adresse_ue"]');
                var containerAdresseUe = $('#edition-adresse-ue');

                // initialiser le masque pour le code postal
                masquesSelection.init();

                pays.select2({dropdownAutoWidth: true, allowClear: true});
                provinceEtat.select2({dropdownAutoWidth: true, allowClear: true});
                municipalite.select2({dropdownAutoWidth: true, allowClear: true});
                secteur.select2({dropdownAutoWidth: true, allowClear: true});
                generiqueAdresse.select2({allowClear: true});
                lienAdresse.select2({allowClear: true});
                orientationAdresse.select2({allowClear: true});
                // mettre le texte à rechercher en majuscules
                containerAdresseProprietaire.find('.select2-search input.select2-input').css('text-transform', 'uppercase');

                disableSectionsAdressesPostales(-1);

                containerAdresseProprietaire.off('click.adresse_proprio.copier').on('click.adresse_proprio.copier', '[data-action="btn-copier-adresse-proprietaire"]', function (e) {
                    wait.start('contenu');
                    var modeEdition = containerAdresseProprietaire.attr('mode-edition') === 'True';
                    var containerProprietaire = $('#creation-proprietaire');
                    var liensCopieAdresses = $(this).closest('ul').find('li a');
                    var listeIdUe = JSON.stringify($.unique($.makeArray(liensCopieAdresses.map(function () {
                        if ($(this).attr('id-ue') !== '') {
                            return parseInt($(this).attr('id-ue'));
                        }
                    }))));
                    var listeIdB02 = JSON.stringify($.unique($.makeArray(liensCopieAdresses.map(function () {
                        if ($(this).attr('id-b02') !== '') {
                            return parseInt($(this).attr('id-b02'));
                        }
                    }))));
                    var idB02 = $(this).attr('id-b02');
                    var params = {
                        id_b02_adresse_proprietaire: idB02,
                        id_ue: $(this).attr('id-ue'),
                        est_copie_adresse: true,
                        liste_id_ue_pour_copie: listeIdUe,
                        liste_id_b02_pour_copie: listeIdB02,
                        date_evenement: $('#wizard').attr('date-evenement'),
                        id_type_evenement: $('#wizard').attr('id-type-evenement')
                    };
                    const success_cb = function(response) {
                        setTimeout(function () {
                            if (response) {
                                $('#accordion-creation-adresse-proprietaire').html(response);
                                // reprendre le container vu qu'il a été refait
                                containerAdresseProprietaire = $('#creation-adresse-proprietaire');
                                containerProprietaire.find('[name="bool_meme_adresse_ue"]').val(idB02 != ''? '0' : '1');
                                initChangementAdressePostale(modeEdition);
                                // remettre le mode_edition comme avant l'ajout de l'adresse
                                containerAdresseProprietaire.attr('mode-edition', modeEdition ? 'True' : 'False');
                                // remettre les valeurs pour créer une nouvelle adresse
                                containerAdresseProprietaire.attr('id-model-instance', '');
                                containerAdresseProprietaire.attr('methode', 'POST');
                                // notifier que le form d'adresse et de propriétaire ont changés, s'il y a lieu
                                containerAdresseProprietaire.attr('modifie', 'True');
                                containerProprietaire.attr('modifie', !modeEdition ? 'True' : 'False');
                                // changer API selon le choix del'adresse b02 ou ue
                                // activer le bouton de sauvegarde
                                $('#modal-message-alerte').find('button[data-type="save"]').prop("disabled", false);
                                $('#modal-message-alerte #btn-wizard-suivant-terminer').prop('disabled', false);
                            }
                            wait.stop('contenu');
                        }, 0);
                    };
                    const error_cb = function (xhr, ajaxOptions, thrownError) {
                        wait.stop('contenu');
                        infos.ajouterMessageToast({
                            message: "Une erreur s'est produite. Contactez un administrateur.",
                            messageDuree: 0
                        });
                    };
                    call_ajax(
                        '/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/editer-adresse-proprietaire/',
                        'GET', params, success_cb, error_cb, false, 'html');
                });
                containerAdresseProprietaire.off('keyup.adresse_proprio.code_postal').on('keyup.adresse_proprio.code_postal', '[name="code_postal"]', function (e) {
                    var $codePostal = $(this);
                    // #13143 : code postal devient optionnel pour les autres pays que Canada
                    var is_pays_canada = true;
                    if ($('#pays').select2('val') != '124') {
                        is_pays_canada = false;
                    } else {
                        $codePostal.val($codePostal.val().replace(/_/g, ''));
                    }
                    if (boolMemeAdresseUe.val() == '1') {
                        containerAdresseUe.attr('code-postal', $codePostal.val());
                        containerAdresseUe.attr('modifie', 'True');
                    } else {
                        if ($codePostal.val()) {
                            if ($codePostal.val().length == 6 && is_pays_canada) {
                                wait.start();
                                var modeEdition = containerAdresseProprietaire.attr('mode-edition') === 'True';
                                $.ajax({
                                    type: "GET",
                                    url: "/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/get-pays/",
                                    data: {'code_postal': $codePostal.val()},
                                    dataType: 'json',
                                    async: !modeEdition,
                                    success: function (response) {
                                        if (response) {
                                            pays.select2('val', response.pays, true);
                                        }
                                        wait.stop();
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        wait.stop();
                                    }
                                });
                            } else {
                                e.preventDefault();
                            }
                        } else {
                            resetSectionAdresseInfos();
                            resetSectionsAdressePostales(-1);
                        }
                    }
                });

                containerAdresseProprietaire.off('change.adresse_proprio.pays').on('change.adresse_proprio.pays', '[name="pays"]', function (e) {
                    var $pays = $(this);

                    // vider le code postal si le pays n'est pas Canada
                    if ($pays.select2('val') != '124') {
                        if (initAdresseProprietaireDone) {
                            codePostal.val('');
                        }
                        // #13143 : code postal devient optionnel pour les autres pays
                        $('.masque-code-postal').unmask();
                    } else {
                        $('.masque-code-postal').mask('a9a9a9');
                    }

                    var paysText = $pays.prop('options')[$pays.prop('selectedIndex')].text;
                    var paysSplit = paysText.split(' - ');
                    nomPays.val(paysSplit.length > 1 ? paysSplit[1] : paysText);
                    $pays.select2('container').attr('title', paysText);
                    var modeEdition = containerAdresseProprietaire.attr('mode-edition') === 'True';

                    wait.start();
                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/get-province-etat/",
                        data: {'id_pays': $pays.val(), 'code_postal': codePostal.val()},
                        dataType: 'json',
                        async: !modeEdition,
                        success: function (response) {
                            if (response) {
                                var parentProvinceEtat = provinceEtat.closest('.form-group').parent();
                                var parentNomProvinceEtat = nomProvinceEtat.closest('.form-group').parent();

                                if (response.province_etat.length == 0) {
                                    parentNomProvinceEtat.show();
                                    parentProvinceEtat.hide();
                                    if (!modeEdition) {
                                        resetToSelect2(provinceEtat, nomProvinceEtat, false);
                                        nomProvinceEtat.val('');
                                    }
                                } else {
                                    resetToSelect2(provinceEtat, nomProvinceEtat);

                                    var premiereValeur = '';
                                    $.each(response.province_etat, function (i, prov_etat) {
                                        if (i == 0) {
                                            premiereValeur = prov_etat[0];
                                        }
                                        provinceEtat.append($('<option>', {
                                            value: prov_etat[0],
                                            text: prov_etat[1] + ' - ' + prov_etat[2],
                                            nom: prov_etat[1]
                                        }));
                                    });

                                    if (response.province_etat.length == 1) {
                                        provinceEtat.select2('val', premiereValeur);
                                    } else if (modeEdition && provinceEtatInputHidden.val()) {
                                        provinceEtat.select2('val', provinceEtatInputHidden.val());
                                    } else if (modeEdition && nomProvinceEtat.val()) {
                                        // chercher le nom de la provinceEtat dans la liste
                                        // enlever les accents du nom, enlever les espaces et le mettre en majuscules
                                        var option = provinceEtat.find('option').filter(function () {
                                            return $(this).attr('nom') !== undefined &&
                                                Select2.util.stripDiacritics($(this).attr('nom')) == $.trim(Select2.util.stripDiacritics(nomProvinceEtat.val())).toUpperCase();
                                        });
                                        if (option.length == 1) {
                                            provinceEtat.select2('val', option.val());
                                        }
                                    }
                                }
                                getMunicipalite(provinceEtat, codePostal.val());
                            }
                            wait.stop();
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            wait.stop();
                        }
                    });
                });

                containerAdresseProprietaire.off('change.adresse_proprio.provinceEtat').on('change.adresse_proprio.provinceEtat', '[name="province_etat_liste"]', function (e) {
                    getMunicipalite($(this), codePostal.val());
                });

                function getMunicipalite($provinceEtat, valCodePostal) {
                    var valProvinceEtat = $provinceEtat.select2('val');
                    // assigner selon la valeur sélectionnée ou assigner ''(vide) s'il n'y a aucun choix fait
                    // vérifier si la liste est vide et si oui, on ne fait pas l'assignation à vide car ça enlève la valeur de nomProvinceEtat (en édition en autre)
                    if ($provinceEtat[0].options.length - 1 > 0) {
                        var optionSelected = $($provinceEtat[0].options[$provinceEtat[0].selectedIndex]);
                        nomProvinceEtat.val(optionSelected.attr('nom'));
                        provinceEtatInputHidden.val(optionSelected.val());
                        $provinceEtat.select2('container').attr('title', optionSelected.text());
                    }
                    var modeEdition = containerAdresseProprietaire.attr('mode-edition') === 'True';

                    wait.start();
                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/get-municipalite/",
                        data: {
                            'id_province_etat': valProvinceEtat,
                            'code_postal': valCodePostal,
                            'date_evenement': dateEvenement
                        },
                        dataType: 'json',
                        async: !modeEdition,
                        success: function (response) {
                            if (response) {
                                if (!modeEdition) {
                                    resetSectionsAdressePostales(-1);
                                }

                                var parentMunicipalite = municipalite.closest('.form-group').parent();
                                var parentNomMunicipalite = nomMunicipalite.closest('.form-group').parent();

                                if (response.municipalite.length == 0) {
                                    parentNomMunicipalite.show();
                                    parentMunicipalite.hide();
                                    if (modeEdition) {
                                        disableSectionsAdressesPostales(response.municipalite.length);
                                    } else {
                                        resetSectionsAdressePostales(response.municipalite.length);
                                    }
                                    wait.stop();

                                    // TODO : trouver une meilleur solution pour vider le sélecteur car on aimerait que ce ajax soit async = false pour mettre 'Sauvegarder' disabled et gérer l'entrée en édition
                                    // vu que de vider le sélecteur de municipalité est trop lent, on le fait après avoir arrêté le spinner.
                                    // en plus que c'est un input qui remplace le sélecteur, l'usager ne voit pas la lenteur
                                    // et seulement en mode création car en mode édition, on n'a pas changé la liste des municipalités
                                    if (!modeEdition) {
                                        resetToSelect2(municipalite, nomMunicipalite, false);
                                        nomMunicipalite.val('');
                                    }
                                } else {
                                    // parentMunicipalite.css('display', '');
                                    // parentNomMunicipalite.css('display', 'none');

                                    resetToSelect2(municipalite, nomMunicipalite);

                                    var premiereValeur = '';
                                    $.each(response.municipalite, function (i, mun) {
                                        if (i == 0) {
                                            premiereValeur = mun.id_municipalite;
                                        }
                                        municipalite.append($('<option>', {
                                            value: mun.id_municipalite,
                                            text: mun.nom_municipalite + ' (' + mun.id_municipalite + ')',
                                            nom: mun.nom_municipalite,
                                            est_evimbec: mun.est_evimbec,
                                            bool_secteur: mun.bool_secteur,
                                            bool_arrondissement: mun.bool_arrondissement,
                                        }));
                                    });

                                    if (response.municipalite.length == 1) {
                                        municipalite.select2('val', premiereValeur);
                                    } else if (modeEdition && municipaliteInputHidden.val()) {
                                        municipalite.select2('val', municipaliteInputHidden.val());
                                    } else if (modeEdition && nomMunicipalite.val()) {
                                        // chercher le nom de la municipalité dans la liste
                                        // enlever les accents du nom, enlever les espaces et le mettre en majuscules
                                        var option = municipalite.find('option').filter(function () {
                                            return $(this).attr('nom') !== undefined &&
                                                $.trim(Select2.util.stripDiacritics(nomMunicipalite.val())).toUpperCase().indexOf(Select2.util.stripDiacritics($(this).attr('nom'))) != -1;
                                        });
                                        if (option.length == 1) {
                                            municipalite.select2('val', option.val());
                                        }
                                    }
                                    // notifier le changement pour continuer la cascade
                                    municipalite.trigger('change');
                                }
                            }
                            wait.stop();
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            wait.stop();
                        }
                    });
                }

                containerAdresseProprietaire.off('change.adresse_proprio.municipalite').on('change.adresse_proprio.municipalite', '[name="municipalite_liste"]', function (e) {
                    // assigner selon la valeur sélectionnée ou assigner ''(vide) s'il n'y a aucun choix fait
                    var optionSelected = $($(this)[0].options[$(this)[0].selectedIndex]);
                    nomMunicipalite.val(optionSelected.attr('nom'));
                    municipaliteInputHidden.val(optionSelected.val());
                    municipalite.select2('container').attr('title', optionSelected.text());

                    var modeEdition = containerAdresseProprietaire.attr('mode-edition') === 'True';
                    var valMunicipalite = municipalite.select2('val');

                    if (valMunicipalite) {
                        var estMunicipaliteEvimbec = optionSelected.attr('est_evimbec') == 'true' || boolMemeAdresseUe.val() == '1';
                        var munBoolSecteur = optionSelected.attr('bool_secteur') == 'true';
                        var munBoolArrondissement = optionSelected.attr('bool_arrondissement') == 'true';
                        erreursAjax.effacerErreurChamps($('#adresse-infos').find('[name="secteur"]').closest('div'));
                        if (munBoolSecteur) {
                            wait.start();
                            secteur.closest('.form-group').parent().show();
                            secteur.attr('disabled', boolMemeAdresseUe.val() == '1');
                            getSecteur(valMunicipalite, secteur, boolMemeAdresseUe, modeEdition);
                        } else if (munBoolArrondissement) {
                            wait.start();
                            secteur.closest('.form-group').parent().show();
                            secteur.attr('disabled', false);
                            getArrondissement(valMunicipalite, secteur, boolMemeAdresseUe, modeEdition);
                        } else {
                            resetToSelect2(secteur, '');
                            secteur.closest('.form-group').parent().hide();
                        }

                        var nbMunicipalite = municipalite.find('option').length - 1; // -1 => c'est pour ne pas compter l'option vide
                        if (modeEdition) {
                            disableSectionsAdressesPostales(nbMunicipalite, estMunicipaliteEvimbec);
                        } else {
                            resetSectionsAdressePostales(nbMunicipalite, estMunicipaliteEvimbec);
                        }

                        if (estMunicipaliteEvimbec) {
                            var nbParPage = 100;
                            listeAdresseUe.select2({
                                ajax: {
                                    url: "/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/get-choix-adresse-ue/municipalite/" + valMunicipalite + '/',
                                    dataType: 'json',
                                    delay: 100,
                                    data: function (searchTerm, pageNumber) {
                                        return {
                                            page: pageNumber,
                                            nb_x_page: nbParPage,
                                            filtre: searchTerm,
                                            date_evenement: dateEvenement
                                        };
                                    },
                                    results: function (remoteData, pageNumber, query) {
                                        var more = (pageNumber * nbParPage) < remoteData.total_count;
                                        $.each(remoteData.adresses_ue, function (index, data) {
                                            data.id = index + 1;
                                            data.text = data.adresse_courte;
                                        });
                                        return {
                                            results: remoteData.adresses_ue,
                                            more: more
                                        };
                                    },
                                    cache: true
                                },
                                placeholder: "Rechercher...",
                                minimumInputLength: 2,
                                allowClear: true,
                                dropdownAutoWidth: true,
                                escapeMarkup: function (markup) {
                                    return markup;
                                },
                                // nextSearchTerm: function(selectedObject, currentSearchTerm) {
                                //     // ceci affiche la dernière recherche dans le sélecteur et ça charge la liste de sélection automatiquement
                                //     return currentSearchTerm.toUpperCase();
                                // },
                                initSelection: function (element, callback) {
                                    // si on met à jour l'élément avec select2('val', ...) depuis formatSelection, alors, il passe ici pour retourner l'information
                                    var data = {id: element.val(), text: element.val()};
                                    callback(data);
                                },
                                formatSelection: function (data, container, escapeMarkup) {
                                    var element = this.element;

                                    // effacer les anciennes données avant d'afficher celles-ci
                                    var modeEdition = containerAdresseProprietaire.attr('mode-edition') === 'True';
                                    if (!modeEdition) {
                                        var inputs = containerAdresseProprietaire.find('#adresse-postale-structuree').find(':input.form-control');
                                        inputs.val('');
                                        inputs.filter('.select2').select2('val', '');
                                    }

                                    erreursAjax.effacerErreurChamps($('#adresse-infos').find('[name="secteur"]').closest('div'));
                                    if (munBoolSecteur && data['secteur']) {
                                        // rafraîchir la liste de secteur pour avoir tous les choix de cette municipalité
                                        secteur.select2('val', '');
                                        getSecteur(valMunicipalite, secteur, boolMemeAdresseUe, modeEdition);
                                    }

                                    if (munBoolArrondissement && data['secteur']) {
                                        // rafraîchir la liste d'arrondissement pour avoir tous les choix de cette municipalité
                                        secteur.select2('val', '');
                                        getArrondissement(valMunicipalite, secteur, boolMemeAdresseUe, modeEdition);
                                    }

                                    var noCiviqueSuperieur = undefined;
                                    for (var field in data) {
                                        if (field == 'no_civique_superieur') {
                                            noCiviqueSuperieur = data[field];
                                        }
                                        var input = containerAdresseProprietaire.find('[name="' + field + '"]');
                                        if (input.hasClass('select2')) {
                                            input.select2('val', data[field]);
                                        } else {
                                            input.val(data[field]);
                                        }
                                    }
                                    if (noCiviqueSuperieur == undefined) {
                                        noCiviqueSuperieur = containerAdresseProprietaire.find('[name="no_civique_superieur"]').val();
                                    }
                                    activerChampsAdresseStructuree(containerAdresseProprietaire, noCiviqueSuperieur);

                                    if (munBoolSecteur) {
                                        // rafraîchir la liste de secteur avec le secteur sélectionné et ainsi, enlever les choix inutiles
                                        getSecteur(valMunicipalite, secteur, boolMemeAdresseUe, modeEdition);
                                    }

                                    if (munBoolArrondissement) {
                                        // rafraîchir la liste d'arrondissement' avec le secteur sélectionné et ainsi, enlever les choix inutiles
                                        getArrondissement(valMunicipalite, secteur, boolMemeAdresseUe, modeEdition);
                                    }

                                    return $.fn.select2.defaults.formatSelection(data, container, escapeMarkup);
                                },
                                formatInputTooShort: function (input, min) {
                                    var n = min - input.length;
                                    return "Saisissez " + n + " caractères ou plus";
                                },
                                formatSearching: function () {
                                    return "Recherche en cours...";
                                },
                                formatLoadMore: function (pageNumber) {
                                    return "Chargement de résultats supplémentaires...";
                                }
                            });

                            // mettre le texte à rechercher en majuscules
                            listeAdresseUe.select2('container').find(".select2-search input.select2-input").css('text-transform', 'uppercase');
                        }
                        // sur la suppression de la sélection, effacer les données de l'adresse
                        listeAdresseUe.on('select2-clearing', function (e) {
                            var inputs = containerAdresseProprietaire.find('#adresse-postale-structuree').find(':input.form-control');
                            inputs.val('');
                            inputs.filter('.select2').select2('val', '');
                        });


                        // il faudrait savoir si c'est vraiment l'adresse d'une ue pour l'afficher dans listeAdresseUe
                        // attendons que quelqu'un le demande pour aller plus loin
                        // (correction faite avec l'issue #12146)
                        // if (modeEdition) {
                        //     // si on a une adresse ue plutôt qu'une adresse b02 qui existe déjà, on doit afficher les infos de l'adresse ue
                        //     var adresse = containerAdresseProprietaire.find('[name="adresse_courte"]').val().toUpperCase();
                        //     var adresseNonStructuree = containerAdresseProprietaire.find('[name="adresse_non_structuree"]').val();
                        //     if (!adresseNonStructuree) {
                        //         if (!adresse) {
                        //             var adresseComplete = containerAdresseProprietaire.find('[name="adresse_complete"]').val().toUpperCase();
                        //             var adresseCompleteSansAccent = Select2.util.stripDiacritics(adresseComplete);
                        //             var index = adresseCompleteSansAccent.indexOf(' ' + Select2.util.stripDiacritics(nomMunicipalite.val()));
                        //             if (index != -1) {
                        //                 adresse = adresseComplete.substring(0, index);
                        //             } else {
                        //                 index = adresseCompleteSansAccent.indexOf(' ' + Select2.util.stripDiacritics(nomProvinceEtat.val()));
                        //                 if (index != -1) {
                        //                     adresse = adresseComplete.substring(0, index);
                        //                 }
                        //             }
                        //         }
                        //         listeAdresseUe.select2('val', adresse);
                        //     }
                        // }
                    } else {
                        resetToSelect2(secteur, '');
                        secteur.closest('.form-group').parent().hide();
                    }
                });

                containerAdresseProprietaire.off('change.adresse_proprio.secteur').on('change.adresse_proprio.secteur', '[name="secteur"]', function (e) {
                    var optionSelected = $($(this)[0].options[$(this)[0].selectedIndex]);
                    secteur.select2('container').attr('title', optionSelected.text());
                    if (boolMemeAdresseUe.val() == '1' && secteur.select2('val')) {
                        containerAdresseUe.attr('secteur', secteur.select2('val'));
                    }
                });

                // si on est en édition, on force la cascade pour peupler les listes de province et municipalité
                if (containerAdresseProprietaire.attr('mode-edition') === 'True') {
                    if (pays.val()) {
                        pays.trigger('change');
                    } else if (nomPays.val()) {
                        // si le id_pays n'existe pas, chercher le nom de pays comme option dans le sélecteur de pays
                        // enlever les accents du nom, enlever les espaces et le mettre en majuscules
                        var option = pays.find('option').filter(function () {
                            return $(this).text() == $.trim(Select2.util.stripDiacritics(nomPays.val())).toUpperCase();
                        });
                        if (option.length) {
                            pays.select2('val', option.val(), true);
                        }
                    } else if (codePostal.val()) {
                        codePostal.trigger('change');
                    }
                }

                // utiliser pour la liste de propriétaires liés
                initCheckboxTous($('#checkbox-proprio-tous'), $('[name="checkbox-proprio"]'));

                // mettre cette détection à la fin pour ne pas attraper les events lors du chargement
                detecterChangementCreationEditionAdresseProprietaire(containerAdresseProprietaire, boolMemeAdresseUe);
                var containerPropriosLies = $('#accordion-creation-adresse-proprietaire-proprietaires-lies');
                detecterChangementCreationEditionAdresseProprietaire(containerPropriosLies);
                initAdresseProprietaireDone = true;
            }

            function resetToSelect2(champSelect, champNom, afficheChampSelect) {
                if (typeof afficheChampSelect === 'undefined') afficheChampSelect = true;

                // FB : tests pour effacer tous les 'option' du sélecteur sans que ce soit trop lent
                // $.each(champSelect.prop('options'), function(index, option) {
                //     $(option).remove().end();
                // }); // fail, n'efface rien
                // champSelect.select2('data', null); // fail, n'efface rien
                // champSelect.remove('option'); // fail, n'efface rien
                // champSelect.empty(); // ok mais trop lent
                // champSelect.html('').select2('data', [{id: '', text: ''}]); // ok mais trop lent car il fait un remove() dans html()

                // TODO : trouver une meilleur solution pour vider le sélecteur car il est lent à se vider quand il y a beaucoup de données

                champSelect.find('option').remove(); // trop lent si beaucoup d'options
                champSelect.append('<option value=""></option>');
                champSelect.select2('val', '');
                champSelect.select2('container').attr('title', '');

                // champNom.val('');

                // afficher le sélecteur au lieu du input lorsque le select2 est nettoyé
                if (afficheChampSelect && champNom) {
                    champSelect.closest('.form-group').parent().show();
                    champNom.closest('.form-group').parent().hide();
                }
            }

            function resetSectionAdresseInfos() {
                var sectionAdresseInfos = $('#creation-adresse-proprietaire').find('#adresse-infos');
                var codePostal = sectionAdresseInfos.find('[name="code_postal"]');
                var pays = sectionAdresseInfos.find('[name="pays"]');
                var provinceEtat = sectionAdresseInfos.find('[name="province_etat_liste"]');
                var provinceEtatInputHidden = sectionAdresseInfos.find('[name="provinceEtat"]');
                var municipalite = sectionAdresseInfos.find('[name="municipalite_liste"]');
                var municipaliteInputHidden = sectionAdresseInfos.find('[name="municipalite"]');
                var nomPays = sectionAdresseInfos.find('[name="nom_pays"]');
                var nomProvinceEtat = sectionAdresseInfos.find('[name="nom_province_etat"]');
                var nomMunicipalite = sectionAdresseInfos.find('[name="nom_municipalite"]');
                var secteur = sectionAdresseInfos.find('[name="secteur"]');

                // #13787
                codePostal.val('');
                pays.select2('val', $('#pays').val() || '124');  // #13143 : pays par défaut
                pays.select2('container').attr('title', '');
                nomPays.val('');

                var is_pays_canada = $('#pays').select2('val') == '124';
                if(is_pays_canada){
                    resetToSelect2(provinceEtat, nomProvinceEtat);
                    provinceEtatInputHidden.val('');
                    nomProvinceEtat.val('');
                    resetToSelect2(municipalite, nomMunicipalite);
                    resetToSelect2(secteur, '');
                    municipaliteInputHidden.val('');
                    nomMunicipalite.val('');
                }
                secteur.closest('.form-group').parent().hide();
            }

            function resetSectionsAdressePostales(nbResulat, estEvimbec) {
                if (typeof estEvimbec === 'undefined') estEvimbec = false;

                disableSectionsAdressesPostales(nbResulat, estEvimbec);

                var containerAdresseProprietaire = $('#creation-adresse-proprietaire');
                var inputs = containerAdresseProprietaire.find('#adresse-postale-ue, #adresse-postale-structuree, #adresse-postale-non-structuree').find(':input.form-control');
                inputs.val('');
                inputs.filter('.select2').select2('val', '');
                // on ne veut pas recréer le contrôle de la liste d'adresse d'ue, on le crée au besoin lors du choix de la municipalité
                inputs.filter('[name="liste_adresse_ue"]').select2('destroy');
            }

            function disableSectionsAdressesPostales(nbResultat, estEvimbec) {
                if (typeof estEvimbec === 'undefined') estEvimbec = false;

                var containerAdresseProprietaire = $('#creation-adresse-proprietaire');
                var sectionAdresse = containerAdresseProprietaire.find('[id^="adresse-postale-"]');
                sectionAdresse.removeClass('active');
                sectionAdresse.find(':input').attr('disabled', true);

                var boolMemeAdresseUe = $('#accordion-creation-proprietaire').find('[name="bool_meme_adresse_ue"]').val();

                var sectionAdresseUe;
                var sectionAdresseStructuree;
                var sectionAdresseNonStructuree;
                if (nbResultat != -1) {
                    // si aucune municipalité n'est disponible, alors, on active la section "Adresse non structurée"
                    if (nbResultat == 0) {
                        sectionAdresseNonStructuree = containerAdresseProprietaire.find('#adresse-postale-non-structuree');
                        sectionAdresseNonStructuree.find(':input').attr('disabled', false);
                        sectionAdresseNonStructuree.addClass('active');
                    }
                    // si une seule municipalité est disponible ou ce sont des municipalités Évimbec, alors, on active la section "Adresse de l'unité d'évaluation"
                    else if (estEvimbec) {
                        if (boolMemeAdresseUe == '1') {
                            sectionAdresseUe = containerAdresseProprietaire.find('#adresse-postale-ue');
                            sectionAdresseUe.find(':input').attr('disabled', false);
                            sectionAdresseUe.addClass('active');

                            sectionAdresseStructuree = containerAdresseProprietaire.find('#adresse-postale-structuree');
                            sectionAdresseStructuree.find('[name="casier_postal"], [name="succursale_postale"]').attr('disabled', false);
                        }
                        // si c'est une municipalité Évimbec, il arrive qu'on ne trouve pas l'adresse de l'ue alors on ouvre tous les champs pour la saisie
                        else {
                            // adresse non structurée
                            sectionAdresseNonStructuree = containerAdresseProprietaire.find('#adresse-postale-non-structuree');
                            sectionAdresseNonStructuree.find(':input').attr('disabled', false);

                            // adresse structurée
                            sectionAdresseStructuree = containerAdresseProprietaire.find('#adresse-postale-structuree');
                            sectionAdresseStructuree.find(':input').attr('disabled', false);

                            // adresse postale des ues de cette municipalité
                            sectionAdresseUe = containerAdresseProprietaire.find('#adresse-postale-ue');
                            sectionAdresseUe.find(':input').attr('disabled', false);
                            sectionAdresseUe.addClass('active');
                        }
                    }
                    // si plusieurs municipalités sont disponibles mais ce ne sont pas des municipalités Évimbec, alors, on active la section "Adresse structurée"
                    else {
                        sectionAdresseStructuree = containerAdresseProprietaire.find('#adresse-postale-structuree');
                        sectionAdresseStructuree.find(':input').attr('disabled', false);
                        sectionAdresseStructuree.addClass('active');
                    }
                }
            }

            function activerChampsAdresseStructuree(containerAdresseProprietaire, noCiviqueSuperieur) {
                // ouvrir les champs pour la saisie
                containerAdresseProprietaire.find('[name="no_civique"], [name="complement_no_civique"], [name="no_appartement_local"], ' +
                    '[name="complement_no_appartement_local"], [name="casier_postal"], [name="succursale_postale"]').attr('disabled', false);

                var boolMemeAdresseUe = $('#accordion-creation-proprietaire').find('[name="bool_meme_adresse_ue"]').val();
                var noCivique = containerAdresseProprietaire.find('[name="no_civique"]');

                if (boolMemeAdresseUe == '1') {
                    if (noCiviqueSuperieur == '' && noCivique.val() && $.isNumeric(noCivique.val())) {
                        noCivique.attr('disabled', true);
                    }
                }

                // s'il y a un no civique mais qu'il n'est pas numérique, il faut laisser le bouton 'Sauvegarder' actif
                if (noCivique.val()) {
                    noCivique.toggleClass('activer-sauvegarder', !$.isNumeric(noCivique.val()));
                }
            }

            function getSecteur(municipalite, secteur, boolMemeAdresseUe, modeEdition) {
                $.ajax({
                    type: "GET",
                    url: "/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/get-secteur/",
                    data: {
                        'id_municipalite': municipalite
                    },
                    dataType: 'json',
                    async: false,
                    success: function (response) {
                        if (response) {
                            var valSecteur = secteur.select2('val');
                            var texteSecteur = secteur.select2().find(":selected").text();
                            if (!valSecteur && boolMemeAdresseUe.val() == '1') {
                                valSecteur = $('#edition-adresse-ue').attr('secteur');
                            }
                            resetToSelect2(secteur, '');

                            $.each(response.secteurs, function (i, valeur) {
                                var texte = valeur.no_secteur + ' - ' + valeur.nom;

                                if ((valSecteur &&
                                    (boolMemeAdresseUe.val() != '1' && valeur.est_secteur_postes_canada == true && texte != texteSecteur) ||
                                    valeur.id_secteur == valSecteur) ||
                                    !valSecteur) {
                                    secteur.append($('<option>', {
                                        value: valeur.id_secteur,
                                        text: texte,
                                        est_secteur_postes_canada: valeur.est_secteur_postes_canada
                                    }));
                                }
                            });
                            secteur.select2('val', valSecteur, true);
                        }
                        wait.stop();
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        wait.stop();
                    }
                });

            }

            function getArrondissement(municipalite, secteur, boolMemeAdresseUe, modeEdition) {
                $.ajax({
                    type: "GET",
                    url: "/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/get-arrondissement/",
                    data: {
                        'id_municipalite': municipalite
                    },
                    dataType: 'json',
                    async: false,
                    success: function (response) {
                        if (response) {
                            var valSecteur = secteur.select2('val');
                            if (!valSecteur && boolMemeAdresseUe.val() == '1') {
                                valSecteur = $('#edition-adresse-ue').attr('secteur');
                            }
                            resetToSelect2(secteur, '');

                            $.each(response.arrondissements, function (i, valeur) {
                                secteur.append($('<option>', {
                                    value: valeur.id_arrondissement,
                                    text: valeur.no_arrondissement + ' - ' + valeur.nom
                                }));
                            });
                            secteur.select2('val', valSecteur, true);
                        }
                        wait.stop();
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        wait.stop();
                    }
                });

            }
        }

        function chercherProprietaire(idProprietaire, container) {
            var proprioTrouves = [];
            if (container != undefined) {
                var proprioContainer = container.find('[id="mutation-cessionnaire"]:visible [name="proprietaire"]');
                // si pas trouvé, on vérifie si on les trouve dans la portion des 'Renseignements administratifs'
                if (!proprioContainer.length) {
                    proprioContainer = container.find('[id="correction-mineure-changement-adresse-proprietaire"] [name="proprietaire"]');
                }
                proprioTrouves = proprioContainer.filter(function () {
                    return idProprietaire == $(this).text();
                });
            }
            return proprioTrouves;
        }

        function disableBoutonAjouterProprio(container) {
            var disableBouton = true;
            var proprietaire = container.find('[name="proprietaire"]');
            var sis = container.find('[name="statutProprietaire"]');
            if (proprietaire.val() != '' && sis.val() != '') {
                disableBouton = false;
            }
            container.find('button').attr('disabled', disableBouton);
        }

        function appliquerCedantModifie(cessionnaireForm) {
            let estCedantModifie = $('[id="mutation-cessionnaire"]').length >= 1;
            if (cessionnaireForm !== undefined &&
                cessionnaireForm.find('[name="id_ue"]').text() !== $('#wizard').attr('id-ue')) {
                // si le id_ue du cessionnaire est différent du id_ue du wizard que l'on veut ajouter, les cédants n'ont
                // pas à être modifiés car ils ont déjà reçus leur date_fin lors de l'opération ue
                estCedantModifie = false;
            }
            $('[id="mutation-cedant"]').attr('modifie', estCedantModifie ? 'True' : 'False');
        }

        function ajouterEditerProprietaire(params, contenuCessionnaire, estModifieParWizard, modeEdition) {
            if (contenuCessionnaire === undefined) contenuCessionnaire = $('#section-cessionnaire');
            if (estModifieParWizard === undefined) estModifieParWizard = 'False';
            if (modeEdition === undefined) modeEdition = false;

            var retour = true;
            var paramProprietaire = '';
            $.each(params, function (index, param) {
                if (param.name == 'proprietaire') {
                    paramProprietaire = param.value;
                    return false;
                }
            });

            // si uniteEvaluation n'est pas dans params, alors il faut l'ajouter par défaut
            var uniteEvaluationTrouve = false;
            $.each(params, function (index, param) {
                if (param.name == 'uniteEvaluation') {
                    uniteEvaluationTrouve = true;
                    return false;
                }
            });
            if (!uniteEvaluationTrouve) {
                params.push({name: 'uniteEvaluation', value: $('#wizard').attr('id-ue')});
            }
            params.push({name: 'date_evenement', value: $('#wizard').attr('date-evenement')});

            // si ça vient de 'Renseigenements administratifs', il faut changer le id_type_evenement pour charger le template côté serveur
            var estChangementAdministratif = false;
            if (contenuCessionnaire.is('#adresse-proprietaire-apres-container')) {
                estChangementAdministratif = true;
                params.push({name: 'id_type_evenement', value: TYPE_EVENEMENT.correction_mineure});
                if ($('#wizard').attr('id-type-evenement') == TYPE_EVENEMENT.operation_ue && $('#wizard').attr('attribut-generique') == 'True') {
                    params.push({name: 'est_creation_proprio', value: 'True'});
                }
            } else {
                params.push({name: 'id_mutation', value: $('#wizard').attr('id-processus')});
            }
            params.push({name: 'est_creation_proprio', value: $('#adresse-proprietaire-apres-container').attr('creation-proprio')});

            // vérifier que le propriétaire ne soit pas ajouté 2 fois si on est en création
            var proprioTrouves = chercherProprietaire(paramProprietaire, contenuCessionnaire);
            // s'il y a une création de propriétaire lors d'un changement d'adresse, on cherche le propriétaire d'avant cette création
            if (modeEdition && proprioTrouves.length == 0) {
                $.each(params, function (index, param) {
                    if (param.name == 'proprietaire-avant-creation') {
                        paramProprietaire = param.value;
                        return false;
                    }
                });
                proprioTrouves = chercherProprietaire(paramProprietaire, contenuCessionnaire);
            }
            if (!modeEdition && proprioTrouves.length == 1) {
                fenetreModal.modalMessage({
                    titre: "Vous ne pouvez pas ajouter 2 fois le même cessionnaire.",
                    texteExplicatif: "",
                    boutons: {
                        "Fermer": {
                            label: " Fermer ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    }
                });
                retour = false;
            } else {
                $.ajax({
                    type: "GET",
                    url: '/gestion-roles/tenue-a-jour/mutation/identification-partie/ajouter-editer-proprietaire/?id_type_evenement=' + $('#wizard').attr('id-type-evenement'),
                    dataType: 'html',
                    data: params,
                    async: false,
                    success: function (response) {
                        var contenuCessionnaireDivTable = contenuCessionnaire.find('.div-table-contenu');
                        var cessionnaireForm = [];

                        if (modeEdition) {
                            var proprioForm = proprioTrouves.closest('[type="formulaire"]');
                            proprioForm.after(response);
                            cessionnaireForm = proprioForm.next();
                            if (estChangementAdministratif) {
                                // mettre 'modifie' à true si on vient de Renseignements administratifs pour sauvegarder la nature
                                cessionnaireForm.attr('modifie', 'True');
                            } else {
                                // remettre le statut 'modifie' comme il était avant l'édition
                                cessionnaireForm.attr('modifie', estModifieParWizard);
                            }
                            proprioForm.remove();
                        } else {
                            // effacer le message d'erreur, s'il y a lieu
                            contenuCessionnaireDivTable.find('.messages-erreurs').remove();
                            contenuCessionnaireDivTable.append(response);
                            cessionnaireForm = contenuCessionnaireDivTable.find('[type="formulaire"]').last();
                            // notifier que c'est modifié pour qu'on ne rafraichisse pas les propriétaires à la sauvegarde
                            cessionnaireForm.find('[name="pourcentage"]').addClass('valeur-modifiee');
                            // activer le bouton 'Sauvegarder'
                            $('button[data-type="save"]').attr("disabled", false);
                        }

                        init_date_picker(contenuCessionnaire);
                        initCheckBoxWithAceIcon(contenuCessionnaireDivTable, true);
                        controlesFormulaires.detecterChangementsFormulaire();
                        appliquerCedantModifie(cessionnaireForm);

                        // montrer le bouton qui supprime tous les propriétaires
                        contenuCessionnaire.find('[data-action="supprimer-tous-proprietaires"]').show();
                    }
                });
            }
            return retour;
        }

        function detecterChangementCreationEditionAdresseProprietaire(container, boolMemeAdresseUe, formulaireModifie) {

            container.find(':text, textarea').on("keyup", function (e) {
                if (e.keyCode == 8 || e.keyCode == 46) { // Utilisation de "Backspace" et "Delete".
                    changerEtatSauvegarde(container);
                } else { // On ne fait rien pour les autres touches utilisées.
                    e.preventDefault();
                }
            });

            container.on('change keypress', ':input, :checkbox', function () {
                var nomChamp = $(this).attr('name');
                var containerEstModifie = true;
                if (boolMemeAdresseUe !== undefined && boolMemeAdresseUe.val() == '1' && nomChamp == 'code_postal') {
                    containerEstModifie = false;
                }
                changerEtatSauvegarde(container, containerEstModifie);
            });

            function changerEtatSauvegarde(container, containerEstModifie) {
                if (containerEstModifie === undefined) containerEstModifie = true;
                if (containerEstModifie) {
                    container.attr('modifie', 'True');
                    if (formulaireModifie !== undefined) {
                        formulaireModifie.attr('modifie', 'True');
                    }
                }
                $('#modal-message-alerte').find('button[data-type="save"]').attr("disabled", false);
            }
        }

        function initSortableProprietaires(container) {
            container.sortable({
                opacity: 0.5,
                tolerance: "pointer",
                update: function (event, ui) {
                    var divEnfants = $(this).children();
                    var checkbox = divEnfants.first().find('.ctrl-checkbox');
                    if (!checkbox.is(':checked')) {
                        checkbox.trigger('click');
                    }

                    divEnfants.attr('modifie', 'True');
                    $('#btn-wizard-save').prop('disabled', false);
                }
            });
        }

        /**
         * Fonction d'initialisation de l'étape de l'identification des parties du processus de mutation.
         * */
        function initIdentificationPartieMutation() {

            var dateEvenement = $('#wizard').attr('date-evenement');
            var municipalite = $('#wizard').attr('id-municipalite');
            var contenuRechercheProprio = $('#contenu-proprietaire-recherche');
            var contenuCessionnaire = $('#section-cessionnaire');

            initRechercheProprietaire();

            initCreationEditionAdresseProprietaire(contenuCessionnaire, contenuRechercheProprio);

            var contenuCedant = $('#accordion-cedant');
            contenuCedant.off('click.mutation.ajouter.cedant').on('click.mutation.ajouter.cedant', '[data-action="ajouter-au-cessionnaire"]', function (a) { // Delegated Event
                var colonnes = $(this).closest('#mutation-cedant').find('div').not(':last-child');
                var params = [];
                colonnes.each(function () {
                    var colonne = $(this);
                    var valeur = colonne.attr('value') !== undefined ? colonne.attr('value') : colonne.text();
                    params.push({name: colonne.attr('name'), value: valeur});
                });
                params.push({name: 'cessionnaire_est_cedant', value: 'True'});

                ajouterEditerProprietaire(params);
            });

            initSuppressionProprietaire();
            initCheckBoxWithAceIcon(contenuCedant);
            initCheckBoxWithAceIcon(contenuCessionnaire, true);
            initSortableProprietaires(contenuCessionnaire.find('.div-table-contenu'));

            var checkboxMemeCessionnaire = $('#identification-parties-infos-mutation').find('[name="bool_meme_cessionnaire"]');

            checkboxMemeCessionnaire.on('change', function (event, estChargement) {
                $('[id="mutation-cessionnaire"]').attr('modifie', 'True');
                $(this).closest('label').css('color', $(this).is(':checked') ? 'red' : '#393939');
                if (!estChargement) {
                    // forcer de refaire l'étape Opération UE car les propriétaires pourraient avoir changés sur cette case
                    $('#identification-parties-infos-mutation').attr('bool_premier_chargement', '');
                }
            });
            checkboxMemeCessionnaire.trigger('change', true);

            $('#accordion-cessionnaire').on('change', ':input', function () {
                $('#identification-parties-infos-mutation').attr('modifie', 'True');
            });

            if ($('[id="mutation-cessionnaire"]').length) {
                // s'il y a des cessionnaires, remettre 'modifie' à False pour ne pas obliger à sauvegarder
                $('#identification-parties-infos-mutation').attr('modifie', 'False');
                // si c'est un cadastre vertical et qu'il y a un cessionnaire, alors on ne veut pas sauvegarder le cédant
                if ($('#identification-parties-infos-mutation').attr('est-cadastre-vertical') == 'True') {
                    $('[id="mutation-cedant"]').attr('modifie', 'False');
                }
            } else {
                // s'il n'y a pas de cessionnaire, mettre 'modifie' à True pour obliger à sauvegarder les cédants :
                // arrive quand on a plusieurs ues sur une mutation et que bool_premier_chargement = True. Alors,
                // la date_fin sur les cédants des ues liées n'est pas sauvegardée.
                if ($('[id="mutation-cedant"]').attr('est-copropriete') === 'True')
                    $('[id="mutation-cedant"]').attr('modifie', 'False');
                else
                    $('[id="mutation-cedant"]').attr('modifie', 'True');
            }
        }


        function chargerIconeFichierInput($input, paramNomFichier, contenant) {

            const nomFichier = paramNomFichier;

            var extensionsAutoriseesRegEx = /(\.|\/)(xls|xlsx|csv)$/i;

            if (nomFichier != undefined) {
                var nomFichierArr = (nomFichier.split('\\'));
                var nomFichierTexte = nomFichierArr[0];
                if (nomFichierArr.length > 1) nomFichierTexte = nomFichierArr[nomFichierArr.length - 1];
            }

            var file_settings = {
                filename: nomFichierTexte,
                no_icon: 'fa fa-upload'
            };

            var icone = retournerIconeUpload(extensionsAutoriseesRegEx, file_settings);
            var $conteneur;
            if (contenant !== undefined) {
                $conteneur = $(contenant).find("span[data-title='" + nomFichierTexte + "']");
            } else {
                $conteneur = $("span[data-title='" + nomFichierTexte + "']");
            }

            $conteneur.find('i.ace-icon').removeClass().addClass('ace-icon-evb').addClass(icone).addClass('ace-icon');
        }

        /**
         * START Fonction d'initialisation de la validation des fichiers pour l'importation de données en lots dans les évènements
         */

        function initValiderImporterDonneesEvenement() {
            var fichiers_a_ajouter = $('#id_fichier_importer');
            var formulaire = fichiers_a_ajouter.closest('form')[0];
                 $('#modal-wizard-evenement').find('[name="user"]').on('change', function () {
                $('#wizard').attr('user', $(this).val());

                var selecteur = $(this).val();
                if (selecteur != '' && !!selecteur) {
                    var user_id = selecteur;
                    chargerrouteinspectionGestionRoute(user_id);

                }
            });

            $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').css("display", "none");
            $('#modal-wizard-evenement #zone-telechargement-fichiers-permis-existant').css("display", "none");
            var typeEvenementDescACreer = $('#modal-wizard-evenement').find('[name="type_evenement_desc_a_creer"]').val() || '';

            var titre = 'Déposez un fichier ici ou cliquez pour en sélectionner un';
            if (typeEvenementDescACreer === 'mutation') {
                titre = 'Déposez des fichiers ici ou cliquez pour en sélectionner';
            }
            fichiers_a_ajouter.ace_file_input({
                style: 'well',
                btn_choose: titre,
                btn_change: null,
                no_icon: 'ace-icon fa fa-cloud-upload',
                droppable: true,
                thumbnail: 'large'
            });

            // On doit forcer la hauteur pour qu'elle reprenne une hauteur auto.
            fichiers_a_ajouter.closest('div').find('.ace-file-container').css("cssText", "height: auto !important;");

            fichiers_a_ajouter.on('change', function (e) {
                var municipalite = $('#modal-wizard-evenement #municipalite');
                if (municipalite.length && !municipalite.val()) {
                    $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur .message').html('Vous devez choisir une Municipalité');
                    $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').css("display", "inline");
                    setTimeout(function () {
                        fichiers_a_ajouter.ace_file_input('reset_input');
                        fichiers_a_ajouter.ace_file_input('reset_input_ui');
                    }, 250);
                    return;
                }

                erreursAjax.effacerErreurChamps($(formulaire));

                // TODO : il faut gérer plusieurs fichiers ici, pas juste le premier, dans le cas des mutations par exemple
                var nomFichier = $(this).val().split('\\').pop();

                if ($('#accordion-fichier-a-importer').find('.fichier').text(nomFichier).length > 0) {
                    infos.ajouterMessageToast({
                        message: "Ce fichier est déjà présent dans l'accordéon : " + nomFichier,
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                    wait.stop();
                    e.stopPropagation();
                } else {
                    // TODO : il faut gérer plusieurs fichiers ici, pas juste le premier, dans le cas des mutations par exemple
                    // chargerIconeFichierInput($(this), fichier);

                    wait.start();

                    //    On déclenche l'ajout du fichier. On laisse le choix à l'utilisateur de déclencher lui-même la validation. À revoir ?
                    init_save_input_file(formulaire.id, '/gestion-roles/tenue-a-jour/ajouter-fichier-liste-fichiers-a-valider/' + typeEvenementDescACreer+ '/', function (response) {

                        var responseObject = JSON.parse(response);

                        //  On pousse le ID de l'importation dans le formulaire.
                        $('#modal-wizard-evenement').find('#id_import_donnees_evenement').val(responseObject.id_import_donnees_evenement);
                        $('#modal-wizard-evenement').attr('id-processus', responseObject.id_import_donnees_evenement);
                        //  On cache le champs qui permet d'ajouter un fichier lorque l'importation est complétée et/ou lorsque le fichier ajouté apparaît dans l'accordéon des fichiers.
                        $('#modal-wizard-evenement').find('div.importer_fichier').hide();
                        //  On ne pourra pas le supprimer si l'importation a été réussie (bool_importation_reussie à true) et que les permis se retrouvent dans la liste des évènements.
                        $('#accordion-fichier-a-importer').find('.panel-body').empty().html(responseObject.liste_fichiers);
                        // Relancer l'initialisation des events pour la liste des fichiers recharger.
                        var $fichiers = $('#accordion-fichier-a-importer').find('.fichier');
                        afficherIconeFichiers($fichiers, '#accordion-fichier-a-importer');
                        //  On change le bouton pour pouvoir passer à l'étape suivante.
                        $('#modal-wizard-evenement #btn-wizard-suivant-terminer').prop('disabled', false);

                        // afficher le message d'erreur s'il y a lieu
                        if (responseObject.message) {
                            $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur .message').html(responseObject.message);
                            $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').show();
                            // ne pas voir le message indiquant de choisir des fichiers
                            $('#modal-wizard-evenement #zone-telechargement-fichiers').hide();

                            // TODO : vérifier si tous les fichiers sont en erreur, alors ne pas passer à l'étape suivante
                            //  sino, laissons passer avec les erreurs mais rien ne sera fait jusqu'à la fin
                            // // on ne change pas le bouton pour pouvoir passer à l'étape suivante.
                            // $('#modal-wizard-evenement #btn-wizard-suivant-terminer').prop('disabled', true);
                        }
                        else {
                            $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').hide();
                        }

                        // afficher le message quand il y a des permis existants et que les données seront changées
                        if (responseObject.message_permis_existant_donnees_changees) {
                            $('#modal-wizard-evenement #zone-telechargement-fichiers-permis-existant .message').html(responseObject.message_permis_existant_donnees_changees);
                            $('#modal-wizard-evenement #zone-telechargement-fichiers-permis-existant').show();
                            // ne pas voir le message indiquant de choisir des fichiers
                            $('#modal-wizard-evenement #zone-telechargement-fichiers').hide();
                        }
                        else {
                            $('#modal-wizard-evenement #zone-telechargement-fichiers-permis-existant').hide();
                        }
                        $('#modal-wizard-evenement .btn-next').prop('disabled', false);

                        wait.stop();

                    }, function (response) {
                        //CALLBACK LORS D'UNE ERREUR;
                        wait.stop();
                        var responseObject = JSON.parse(response);

                        $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur .message').html(responseObject.message);
                        $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').css("display", "inline");
                        $('#modal-wizard-evenement #btn-wizard-suivant-terminer').prop('disabled', true);

                    }, false);
                }
            });

            $('#modal-wizard-evenement').on('click', '#btn-creer-csv-mutation', function (e) {
                var jqxhr = $.ajax({
                    url: '/gestion-roles/tenue-a-jour/creer-csv-mutation/' + typeEvenementDescACreer + '/',
                    async: false,
                    type: "GET",
                    dataType: 'html',
                });
                jqxhr
                    .done(function (response) {
                        $('#modal-wizard-evenement #zone-creer-csv-mutation-erreur').show();
                        $('#modal-wizard-evenement #zone-creer-csv-mutation-erreur .message').html(response);
                    });
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        $('#modal-wizard-evenement #zone-creer-csv-mutation-erreur').show();
                        $('#modal-wizard-evenement #zone-creer-csv-mutation-erreur .message').html(xhr.responseText);
                    });
            });

            $('#modal-wizard-evenement').find('div.importer_fichier a.remove').on('click', function() {
                $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur .message').html('');
                $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').hide();
                $('#modal-wizard-evenement #zone-telechargement-fichiers-permis-existant .message').html('');
                $('#modal-wizard-evenement #zone-telechargement-fichiers-permis-existant').hide();
            });

            initialisationBoutonsImporterEvenement();

            $(formulaire).find('select').select2();
            // On désactive le bouton sauvegarder
            setTimeout(function () {
                $('#modal-wizard-evenement .btn-next').prop('disabled', true);
                $('#btn-wizard-save').hide();
            }, 250);
        }

        function initImporterDonneesPermisApi() {
            const modal_wizard = $('#modal-wizard-evenement');
            modal_wizard.find('select.select2').select2();
            init_date_picker(modal_wizard);
            $(modal_wizard).off('finished.fu.wizard').on('finished.fu.wizard', function () {
                fenetreModal.fermerModal('modal-wizard-evenement');
            });
        }

        function saveImporterDonneesPermisApi(callback) {
            const form = $('#import-donnees-lot-permis-api-form');
            const url = form.attr('action');
            const data = form.serialize();

            const success_cb = function(resp) {
                var idMunicipalite = form.find('#municipalite').val();
                var idTypeEvenement = $('#wizard').attr('id-type-evenement');
                if (idMunicipalite && idTypeEvenement) {
                    validerFermetureCycle(idMunicipalite, idTypeEvenement);
                }
                callback(resp);
                const step_container = $('#modal-step2');
                step_container.empty();
                step_container.html(resp.template);
            };
            const error_cb = function (xhr) {
                const step_container = $('#modal-step1');
                step_container.empty();
                step_container.html(xhr.responseText);
                wait.stop('contenu');
                initImporterDonneesPermisApi();
            };
            call_ajax(url, 'POST', data, success_cb, error_cb);
        }
        function saveConfirmImportDonneesPermisApi(callback) {
            const form = $('#import-donnees-lot-permis-api-form');
            const url = '/gestion-roles/tenue-a-jour/lancer-import-permis-api/';
            const data = form.serialize();

            const success_cb = function(resp) {
                const step_container = $('#modal-step3');
                step_container.empty();
                step_container.html(resp.template);
                callback(resp);
            };
            const error_cb = function (xhr) {
            };
            call_ajax(url, 'POST', data, success_cb, error_cb);
        }


        function validerImporterDonneesEvenement(callback) {
            let response = {reponse: 'ok'};
            var currentForm = $('#modal-step-contents > .active .form-horizontal');
            var idMunicipalite = currentForm.find('#municipalite').val();
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');

            if (idMunicipalite && idTypeEvenement) {
                validerFermetureCycle(idMunicipalite, idTypeEvenement);
            }
            callback(response);
        }

        function initImporterDonneesEvenement() {
            var trFichier = $('#modal-step-contents > #modal-step1 #table-evenements > tbody > tr');
            var idFichier = $.makeArray(trFichier.map(function() {
                return this.id;
            }));
            var typeEvenementDescACreer = $('#modal-wizard-evenement').find('[name="type_evenement_desc_a_creer"]').val() || '';

            var params = {
                'id_fichier': idFichier
            };

            setTimeout(function () {
                $.ajax({
                    type: "GET",
                    url: '/gestion-roles/tenue-a-jour/ouvrir-etape-importer-donnees-evenement/' + typeEvenementDescACreer + '/',
                    data: params,
                    success: function (response) {
                        var etape = $('#modal-step-contents > .active');
                        etape.html(response);
                        etape.attr('recharger', 'oui');
                        wait.stop('contenu');
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        $('#modal-wizard-evenement #modal-step2').append('<div class="alert alert-danger">' + xhr.responseText + '</div>');
                    }
                });

            }, 10);

            // On désactive le bouton sauvegarder
            setTimeout(function () {
                $('#btn-wizard-save').hide();
            }, 250);
        }

        function importerDonneesEvenement(callback) {
            var trFichier = $('#modal-step-contents > #modal-step1 #table-evenements > tbody > tr');
            var idFichier = $.makeArray(trFichier.map(function() {
                return this.id;
            }));
            var idMun = $('#modal-step-contents > #modal-step1 #municipalite').val();
            var typeEvenementDescACreer = $('#modal-wizard-evenement').find('[name="type_evenement_desc_a_creer"]').val() || '';

            var params = {
                'id_fichier': idFichier,
                'municipalite': idMun
            };
            wait.start();
            setTimeout(function () {
                var jqxhr = $.ajax({
                    url: '/gestion-roles/tenue-a-jour/importer-donnees-evenement/' + typeEvenementDescACreer + '/executer/',
                    async: false,
                    type: "POST",
                    dataType: 'html',
                    data: params
                });
                jqxhr
                    .done(function (response) {

                        if (response == 'ok') {
                            callback({reponse: 'ok'});
                        } else {
                            infos.ajouterMessageToast({
                                message: "Erreur d'exécution de la commande d'importation de " + typeEvenementDescACreer + " en lot",
                                messageCouleur: 'red'
                            });
                            wait.stop();
                        }
                    });
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur d'exécution de la commande d'importation de " + typeEvenementDescACreer + " en lot",
                            messageCouleur: 'red'
                        });
                        wait.stop();
                    });
            }, 10);
        }

        function initBilanDonneesEvenement() {
            var trFichier = $('#modal-step-contents > #modal-step1 #table-evenements > tbody > tr');
            var idFichier = $.makeArray(trFichier.map(function() {
                return this.id;
            }));
            var typeEvenementDescACreer = $('#modal-wizard-evenement').find('[name="type_evenement_desc_a_creer"]').val() || '';
            var params = {
                'id_fichier': idFichier
            };

            wait.start();
            setTimeout(function () {
                var jqxhr = $.ajax({
                    url: '/gestion-roles/tenue-a-jour/ouvrir-etape-bilan-import-evenement/' + typeEvenementDescACreer + '/',
                    async: false,
                    type: "GET",
                    dataType: 'html',
                    data: params,
                });
                jqxhr
                    .done(function (response) {
                        $('#modal-wizard-evenement .modal-body .active').html(response);
                        wait.stop();

                        $('#modal-wizard-evenement').on('click', '#btn-telecharger-echecs', function (e) {
                            var idImportDonneesEvenementFichier = $(this).attr('import-donnees-evenement');
                            telechargerFichierImporterEvenement(idImportDonneesEvenementFichier);
                        });

                    });
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur d'exécution de la commande d'importation de " + typeEvenementDescACreer + " en lot",
                            messageCouleur: 'red'
                        });
                        wait.stop();
                    });
            }, 10);

            // On désactive le bouton sauvegarder
            setTimeout(function () {
                $('#btn-wizard-save').hide();
            }, 250);

            $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                fenetreModal.fermerModal('modal-wizard-evenement');
            });

        }

        function bilanDonneesEvenement(callback) {
            var response = {reponse: 'ok'};
            refreshDatatables();
            callback(response);
        }

        function initChargerDocumentPermis(callback) {
            var zone_erreurs = $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur');
            var fichiers_a_ajouter = $('#id_fichier_importer');
            var formulaire = fichiers_a_ajouter.closest('form')[0];
            var typeEvenementDescACreer = $('#modal-wizard-evenement').find('[name="type_evenement_desc_a_creer"]').val() || '';

            fichiers_a_ajouter.ace_file_input({
                style: 'well',
                btn_choose: 'Déposez des fichiers ici ou cliquez pour en sélectionner',
                btn_change: null,
                no_icon: 'ace-icon fa fa-cloud-upload',
                droppable: true,
                thumbnail: 'large',
                whitelist: 'gif|png|jpg|jpeg|zip|pdf'
            });

            zone_erreurs.css('display', 'none');

            // On doit forcer la hauteur pour qu'elle reprenne une hauteur auto.
            fichiers_a_ajouter.closest('div').find('.ace-file-container').css("cssText", "height: auto !important;");

            fichiers_a_ajouter.on('change', function (e) {
                var municipalite = $('#modal-wizard-evenement #municipalite');
                if (municipalite.length && !municipalite.val()) {
                    $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur .message').html('Vous devez choisir une Municipalité');
                    $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').css("display", "inline");
                    setTimeout(function () {
                        fichiers_a_ajouter.ace_file_input('reset_input');
                        fichiers_a_ajouter.ace_file_input('reset_input_ui');
                    }, 250);
                    return;
                }

                zone_erreurs.html('');

                $('#btn-wizard-suivant-terminer').prop('disabled', false);

                erreursAjax.effacerErreurChamps($(formulaire));

                var fichier = $(this).val();
                var nomFichier = $(this).val().split('\\').pop();

                if ($('#accordion-fichier-a-importer').find('.fichier').text(nomFichier).length > 0) {
                    infos.ajouterMessageToast({
                        message: "Ce fichier est déjà présent dans l'accordéon : " + nomFichier,
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                    wait.stop();
                    e.stopPropagation();
                } else {
                    chargerIconeFichierInput($(this), fichier);

                    wait.start();

                    //    On déclenche l'ajout du fichier. On laisse le choix à l'utilisateur de déclencher lui-même la validation. À revoir ?
                    init_save_input_file(formulaire.id, '/gestion-roles/tenue-a-jour/valider-charger-documents/' + typeEvenementDescACreer + '/', function (response) {

                    wait.stop();

                    }, function (response) {
                        //CALLBACK LORS D'UNE ERREUR;
                        wait.stop();

                        var reponseObjet = JSON.parse(response);
                        var keys = Object.keys(reponseObjet.erreur);

                        if (keys.length > 0) {
                            $('#zone-telechargement-fichiers-erreur').css("display", "inline");
                            for (var key in keys) {
                                zone_erreurs.append("<div class=\"alert alert-danger\">"
                                    + "<p> Fichier " + keys[key] + "<\/p>"
                                    + reponseObjet.erreur[keys[key]]
                                    + "<br><\/div>");
                            }
                        }
                    }, true);
                }
            });

            $('#modal-wizard-evenement').find('div.importer_fichier a.remove').on('click', function() {
                $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur .alert').html('');
                $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').hide();
            });

            $(formulaire).find('select').select2();
            // On désactive le bouton sauvegarder
            setTimeout(function () {
                $('#btn-wizard-save').hide();
            }, 250);
        }

        function saveChargerDocumentPermis(callback) {
            const $form = $('#formulaire-valider-importer-donnees-evenement-en-lot');
            const url = $($form).attr('vue');
            let form_data = new FormData();
            const data = $($form).serializeArray();
            for (const idx in data) {
                form_data.append(data[idx].name, data[idx].value);
            }
            const file_input = $form.find('input[type=file]');
            const aceFiles = file_input.data('ace_input_files'); // always filled for both choose + drop
            if (aceFiles && aceFiles.length > 0) {
                for (var i = 0; i < aceFiles.length; i++) {
                    form_data.append(file_input.attr('name'), aceFiles[i]);
                }
            }
            const success_cb = function(resp) {
                var idMunicipalite = data.find(champ => champ.name === 'municipalite')?.value;
                var idTypeEvenement = $('#wizard').attr('id-type-evenement');
                if (idMunicipalite && idTypeEvenement) {
                    validerFermetureCycle(idMunicipalite, idTypeEvenement);
                }
                if (resp.sauvegarde === 'ok'){
                    const response = {reponse: 'ok'};
                    callback(response);
                } else {
                    if (resp.erreur.message) {
                        infos.ajouterMessageToast({
                            message: resp.erreur.message,
                            type: 'error',
                            messageDuree: 2000
                        });
                    }
                    callback(resp);
                }

            };
            call_ajax_with_file(url, 'POST', form_data, success_cb);

        }

        function initImporterDocumentsPermis(callback) {
            $('#modal-step-contents > #modal-step2 #info_nb_lignes_valides').html("Les fichiers valides de l'étape précédente seront importés. " +
                "Veuillez cliquer sur le bouton Terminer pour confirmer l'importation.");

            $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                importerDocumentsPermis(callback);
            });

            // On désactive le bouton sauvegarder
            setTimeout(function () {
                $('#btn-wizard-save').hide();
            }, 250);
        }

        function importerDocumentsPermis(callback) {
            var fichiers_a_ajouter = $('#id_fichier_importer');
            var formulaire = fichiers_a_ajouter.closest('form')[0];
            var typeEvenementDescACreer = $('#modal-wizard-evenement').find('[name="type_evenement_desc_a_creer"]').val() || '';

            wait.start();
            const url = `/gestion-roles/tenue-a-jour/importer-documents/${typeEvenementDescACreer}/`
            const success_cb = function (response) {
                wait.stop();
                var responseJson = JSON.parse(response);
                infos.ajouterMessageToast({
                    message: responseJson.message,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green',
                    messageDuree: 2000
                });
                fenetreModal.fermerModal('modal-wizard-evenement');

            };
            const error_cb = function (response) {
                wait.stop();
                const message = response.message || "'Une erreur s'est produite. Contactez un administrateur."
                infos.ajouterMessageToast({
                    message: message,
                    type: 'error',
                    messageDuree: 2000
                });
            };
            //    On déclenche l'ajout du fichier. On laisse le choix à l'utilisateur de déclencher lui-même la validation. À revoir ?
            init_save_input_file(formulaire.id, url, success_cb, error_cb, true, null, 'json');
        }

        /**
         * END Fonction d'initialisation de la validation des fichiers pour l'importation de données en lots dans les évènements
         */


        function afficherIconeFichiers($fichiers, contenant) {
            $.each($fichiers, function (index, value) {
                var nom_fichier = value.textContent.split('\\').pop();
                chargerIconeFichierInput($fichiers, nom_fichier, contenant);
            });
        }

        function effacerFichierImporterEvenement(id_import_donnees_evenement_fichier) {
            var reponse = {};
            var data = {'id_import_donnees_evenement_fichier': id_import_donnees_evenement_fichier};
            var url = '/gestion-roles/tenue-a-jour/effacer-fichier-importer-evenement/';

            var jqxhr = $.ajax({
                    url: url,
                    type: 'GET',
                    data: data,
                    async: false
                }
            );

            jqxhr
                .done(function (response) {
                    // On affiche la bonne extension pour le bon fichier
                    $('#accordion-fichier-a-importer').find('.panel-body').empty().html(response.liste_fichiers);
                    var $fichiers = $('#accordion-fichier-a-importer').find('.fichier');
                    // On fait réapparaître le input de sélection des fichiers
                    $('#modal-wizard-evenement').find('div.importer_fichier').show();
                    setTimeout(function () {
                        $('#modal-wizard-evenement').find('div.importer_fichier').find('a.remove').trigger('click');
                    }, 100); // ...avec animation.
                    afficherIconeFichiers($fichiers, '#accordion-fichier-a-importer');
                    if ($fichiers.length == 0) {
                        // s'il ne reste pas de fichiers, on efface le message d'erreur
                        $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur .message').html('');
                        $('#modal-wizard-evenement #zone-telechargement-fichiers-erreur').hide();
                        // remettre le message pour ajouter des fichiers
                        $('#modal-wizard-evenement #zone-telechargement-fichiers').show();
                    }
                });
            jqxhr
                .fail(function (xhr, textStatus, errorThrown) {
                    infos.ajouterMessageToast({
                        message: "Erreur de suppression du fichier",
                        messageCouleur: "red"
                    });
                });
            return reponse;
        }

        function initialisationBoutonsImporterEvenement() {

            $('#modal-wizard-evenement').on('click', '.telecharger-rapport', function () {
                var idImportDonneesEvenementFichier = $(this).closest('tr').attr('id');
                telechargerFichierImporterEvenement(idImportDonneesEvenementFichier);
            });

            $('#modal-wizard-evenement').on('click', '.supprimer-fichier', function () {
                wait.start();
                //    On vérifie que l'importation n'a pas été complétée

                //    On supprimer les fichiers de la BD et on regénère l'accordéon à partir de la BD.
                var id_import_donnees_evenement_fichier = $(this).closest('tr').attr('id');
                effacerFichierImporterEvenement(id_import_donnees_evenement_fichier);
                wait.stop();
            });
        }

        function telechargerFichierImporterEvenement(idImportDonneesEvenementFichier) {
            var url = '/gestion-roles/tenue-a-jour/telecharger-fichier-importer-evenement/1/' + idImportDonneesEvenementFichier;
            var xhttp = new XMLHttpRequest();
            wait.start();
            xhttp.onreadystatechange = function () {
                var a, today;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    a = document.createElement('a');
                    a.href = window.URL.createObjectURL(xhttp.response);
                    today = new Date();
                    a.download = "RapportImportation_" + today.toDateString().split(" ").join("_") + ".xlsx";
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    wait.stop();
                    return a.click();
                }
            };
            xhttp.open("GET", url, true);
            xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhttp.setRequestHeader("Content-Type", "application/json");
            xhttp.responseType = 'blob';
            xhttp.send();
        }

        /**
         * Fonction de sauvegarde de l'étape de l'identification des parties du processus de mutation.
         * */
        function saveIdentificationPartieMutation(callback) {

            var sections = $('#accordion-cedant, #section-cessionnaire, #identification-parties-infos-mutation, #accordion-copropriete');
            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var params = [];

                if (idCurrentForm === 'mutation-cedant') {
                    params.push({
                        name: 'id_proprietaire_x_unite_evaluation',
                        value: currentForm.attr('id-model-instance')
                    });
                    params.push({name: 'date_fin', value: dateEvenement});
                    params.push({name: 'maj_cedant', value: true}); // indiquer qu'on veut mettre à jour le cédant
                    params.push({
                        name: 'bool_meme_cessionnaire',
                        value: $('#identification-parties-infos-mutation').find('[name="bool_meme_cessionnaire"]').is(':checked')
                    });
                } else if (idCurrentForm === 'mutation-cessionnaire') {
                    params = controlesFormulaires.serialiserFormulaire(currentForm);
                    params.push({
                        name: 'bool_meme_adresse_ue',
                        value: currentForm.find('[name="bool_meme_adresse_ue"]').attr('value')
                    });
                    params.push({
                        name: 'complement',
                        value: currentForm.find('[name="complement"]').text() ? currentForm.find('[name="complement"]').text() : null
                    });
                    params.push({name: 'proprietaire', value: currentForm.find('[name="proprietaire"]').text()});
                    params.push({
                        name: 'id_ue_proprio_existant',
                        value: currentForm.find('[name="id_ue_proprio_existant"]').text()
                    });
                    params.push({
                        name: 'id_b02_adresse_proprietaire',
                        value: currentForm.find('[name="id_b02_adresse_proprietaire"]').text()
                    });
                    params.push({
                        name: 'adresse_complete',
                        value: currentForm.find('[name="adresse_complete"]').text()
                    });
                    params.push({
                        name: 'date_initiale_inscription',
                        value: currentForm.find('[name="date_initiale_inscription"]').val()
                    });
                    params.push({name: 'uniteEvaluation', value: currentForm.find('[name="id_ue"]').text()});
                    params.push({name: 'date_debut', value: dateEvenement});
                    params.push({
                        name: 'bool_meme_cessionnaire',
                        value: $('#identification-parties-infos-mutation').find('[name="bool_meme_cessionnaire"]').is(':checked')
                    });
                    params.push({name: 'ordre_tri', value: currentForm.index() + 1});
                } else if (idCurrentForm === 'identification-parties-infos-mutation') {
                    params = controlesFormulaires.serialiserFormulaire(currentForm);
                    let boolPremierChargement = $('#identification-parties-infos-mutation').attr('bool_premier_chargement');
                    if (boolPremierChargement !== undefined) {
                        params.push({name: 'bool_premier_chargement', value: false});
                    }
                } else if (idCurrentForm === 'mutation-copropriete') {
                    params = controlesFormulaires.serialiserFormulaire(currentForm);
                }
                return params;
            };
            var getChampUnique = function (currentForm, idCurrentForm) {
                return {
                    unique_nom_champ: idCurrentForm == 'mutation-cessionnaire' ? 'proprietaire' : '',
                    unique_id_champ: idCurrentForm == 'mutation-cessionnaire' ? currentForm.find('[name="proprietaire"]').text() : ''
                };
            };
            var getChampTransfert;
            var messageToast = {};
            // TODO: si la réponse est 'Mutation simple', alors, on met le statut à 5: 'Mise à jour terminée'. Sinon, on laisse à 1 : 'Nouveau'
            sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, 5);
        }


        /**
         * Fonction de sauvegarde de l'étape de création/édition de l'adresse du propriétaire.
         * */
        function sauvegarderAdresseProprietaire(modeEdition, validerSeulement, callback) {

            var sections = $('#creation-proprietaire, #creation-adresse-proprietaire, #edition-proprietaire-x-unite-evaluation, #edition-adresse-ue, #accordion-proprietaire-recherche-cm:visible');
            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var boolMemeAdresseUe = $('#creation-proprietaire, #creation-proprietaire-sans-sauvegarde').filter(
                    function () {
                        return this.parentElement && $(this.parentElement).is(':visible');
                    }).first().find('[name="bool_meme_adresse_ue"]').val();
                var containerAdresseProprietaire = $('#creation-adresse-proprietaire');
                var complement = containerAdresseProprietaire.find('[name="complement"]').val();
                var params = [];

                var propriosLies = $('#accordion-creation-adresse-proprietaire-proprietaires-lies').find('[name="checkbox-proprio"]');
                var listePropriosLies = [];
                $.each(propriosLies, function () {
                    var ligne = $(this).closest('.div-table-ligne');
                    var idUe = ligne.find('[name="id_ue"]').text();
                    if (idUe == '') {
                        idUe = ligne.attr('id_ue');
                    }
                    listePropriosLies.push({
                        id_proprietaire: ligne.attr('id_proprietaire'),
                        id_ue: idUe,
                        est_coche: $(this).is(':checked') ? 1 : 0,
                        bool_meme_adresse_ue: ligne.find('[name="checkbox-api-apres"]').is(':checked') ? 1 : 0,
                        complement: ligne.find('[name="complement_apres"]').val() ? ligne.find('[name="complement_apres"]').val().toUpperCase() : '',
                    });
                });

                if (idCurrentForm == 'creation-adresse-proprietaire' && boolMemeAdresseUe == '') {
                    // ne pas valider le formulaire d'adresse puisque l'API n'est pas saisi
                    return params;
                }

                if (idCurrentForm == 'edition-adresse-ue' && boolMemeAdresseUe != '1') {
                    // ne pas valider le formulaire d'adresse de l'ue puisque l'API n'est pas saisi ou API est à Non
                    return params;
                }

                if (idCurrentForm == 'creation-proprietaire') {
                    params = currentForm.find(':input.form-control').serializeArray();
                } else if (idCurrentForm == 'creation-adresse-proprietaire') {
                    var inputs = currentForm.find(':input.form-control:not(:disabled)');
                    var currentFormActive = currentForm.find('.active');
                    var listeAdresseUe = currentFormActive.find('[name="liste_adresse_ue"]');
                    var listeAdresseUeEstSaisi = listeAdresseUe.length > 0;
                    // si c'est API=Non et listeAdresseUe est saisie, on vide la sélection avant de l'envoyer au
                    // serveur car on doit valider les champs d'adresse et non pas la sélection
                    if (boolMemeAdresseUe == '0') {
                        listeAdresseUe.val('');
                    }

                    serializeArrayCustom(inputs, params);
                    params.push({
                        name: 'section_active',
                        value: currentFormActive.attr('id') ? currentFormActive.attr('id') : ''
                    });

                    if (listeAdresseUeEstSaisi) {
                        var inputsDisabled = containerAdresseProprietaire.find('#adresse-infos, #adresse-postale-ue, #adresse-postale-structuree').find(':input.form-control:disabled');
                        serializeArrayCustom(inputsDisabled, params);
                    }
                    var secteur = containerAdresseProprietaire.find('[name="secteur"]');
                    params.push({
                        name: 'est_secteur_postes_canada',
                        value: $(secteur[0].options[secteur[0].selectedIndex]).attr('est_secteur_postes_canada') == 'true'
                    });
                    var municipaliteListe = containerAdresseProprietaire.find('[name="municipalite_liste"]');
                    var munSelected = $(municipaliteListe[0].options[municipaliteListe[0].selectedIndex]);
                    params.push({
                        name: 'bool_secteur',
                        value: municipaliteListe.length ? munSelected.attr('bool_secteur') == 'true' : false
                    });
                    params.push({
                        name: 'bool_arrondissement',
                        value: municipaliteListe.length ? munSelected.attr('bool_arrondissement') == 'true' : false
                    });
                    params.push({
                        name: 'est_evimbec',
                        value: municipaliteListe.length ? munSelected.attr('est_evimbec') == 'true' : false
                    });

                    var provinceEtatListeCount = containerAdresseProprietaire.find('[name="province_etat_liste"] option').length - 1; // -1 => c'est pour ne pas compter l'option vide
                    params.push({name: 'province_etat_liste_count', value: provinceEtatListeCount});
                    if (boolMemeAdresseUe !== undefined) {
                        params.push({name: 'bool_meme_adresse_ue', value: boolMemeAdresseUe});
                    }
                    var idProprietaire = $('#accordion-creation-proprietaire').find('[type="formulaire"]').attr('id-model-instance');
                    if (idProprietaire !== undefined) {
                        params.push({name: 'id_proprietaire', value: idProprietaire});
                    }
                    params.push({name: 'id_evenement', value: $('#wizard').attr('id-evenement')});
                    params.push(
                        {name: 'nb_proprios_lies', value: propriosLies.length},
                        {name: 'proprios_lies', value: listePropriosLies},
                        {
                            name: 'section_proprios_lies',
                            value: 'accordion-creation-adresse-proprietaire-proprietaires-lies'
                        }
                    );
                    var proprietaireNomComplet = $('#accordion-proprietaire-recherche-cm').find('[name="proprietaire_nom_complet"]');
                    if (proprietaireNomComplet.length) {
                        params.push({name: 'proprietaire_nom_complet', value: proprietaireNomComplet.select2('val')});
                    }

                    params.push({name: 'cessionnaire_est_cedant', value: currentForm.attr('cessionnaire-est-cedant')});

                    params.push({'validerSeulement': validerSeulement});
                } else if (idCurrentForm == 'edition-proprietaire-x-unite-evaluation') {
                    params.push({name: 'uniteEvaluation', value: currentForm.attr('id_ue')});
                    params.push({name: 'proprietaire', value: currentForm.attr('id_proprietaire')});
                    params.push({
                        name: 'date_initiale_inscription',
                        value: currentForm.attr('date_initiale_inscription')
                    });
                    params.push({
                        name: 'pourcentage',
                        value: currentForm.attr('pourcentage') ? currentForm.attr('pourcentage') : null
                    });
                    params.push({
                        name: 'bool_proprietaire_principal',
                        value: currentForm.attr('bool_proprietaire_principal')
                    });
                    params.push({name: 'bool_meme_adresse_ue', value: boolMemeAdresseUe});
                    params.push({name: 'complement', value: complement ? complement : null});
                    params.push({name: 'mode_edition_adresse', value: modeEdition});
                    params.push(
                        {name: 'nb_proprios_lies', value: propriosLies.length},
                        {name: 'proprios_lies', value: listePropriosLies}
                    );
                    params.push({name: 'date_debut', value: dateEvenement});
                } else if (idCurrentForm == 'edition-adresse-ue') {
                    params.push({name: 'code_postal', value: currentForm.attr('code-postal')});
                    params.push({name: 'id_b00_adresse_ue', value: currentForm.attr('id-b00-adresse-ue')});
                    params.push({name: 'id_municipalite', value: currentForm.attr('id-municipalite')});
                } else if (idCurrentForm == 'proprietaire-recherche-cm') {
                    // reset attribut 'modifie' pour ne pas sauvegarder
                    $('#proprietaire-recherche-cm').attr('modifie', 'False');
                    params = controlesFormulaires.serialiserFormulaire(currentForm);
                }
                return params;
            };

            function serializeArrayCustom(container, params) {
                // sert pour mettre null au lieu de ''(vide) car ça met '' dans la bd au lieu de null et l'adresse complète modifiée par le trigger a des caractères ou des espace en trop
                $.each(container, function () {
                    var input = $(this);
                    params.push({
                        name: input.attr('name'),
                        value: input.val() ? input.val() : null
                    });
                });
            }

            var getChampTransfert = function (idCurrentForm) {
                var retour = {};
                if (idCurrentForm == 'creation-proprietaire' || idCurrentForm == 'creation-adresse-proprietaire') {
                    retour.transfert_champ_source = 'id_proprietaire';
                }
                if (idCurrentForm == 'creation-adresse-proprietaire' || idCurrentForm == 'edition-proprietaire-x-unite-evaluation') {
                    retour.transfert_champ_destination = 'id_proprietaire';
                }
                return retour;
            };

            var getChampUnique;
            var messageToast = {
                message: modeEdition ? "Mise à jour des données du propriétaire réussi" : "Ajout des données du propriétaire réussi"
            };
            sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);
        }

        function sauvegarderSuppressionProprietaire(callback) {

            // on veut seulement la ligne avec methode=DELETE. C'est pour ça qu'on met le formulaire précis au lieu de la section.
            var sections = $('#mutation-cessionnaire[methode="DELETE"], #correction-mineure-changement-adresse-proprietaire[methode="DELETE"]');
            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var params = [
                    {name: 'id_proprietaire_x_unite_evaluation', value: currentForm.attr('id-model-instance')},
                ];
                params.push({
                    name: 'bool_meme_cessionnaire',
                    value: $('#identification-parties-infos-mutation').find('[name="bool_meme_cessionnaire"]').is(':checked')
                });
                return params;
            };
            var getChampUnique = function (currentForm, idCurrentForm) {
                return {
                    unique_nom_champ: 'proprietaire',
                    unique_id_champ: currentForm.find('[name="proprietaire"]').text()
                };
            };
            var getChampTransfert;
            var messageToast = {};

            sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);
        }

        /**
         * Fonction d'initialisation de l'étape de résultat d'analyse de vente du processus de mutation.
         * */
        function initResultatAnalyseVenteMutation() {

            var containerResultatAnalyseVente = $('#mutation-resultat-analyse-vente');
            var natureBoolNonVente = containerResultatAnalyseVente.find('[name="nature_bool_non_vente"]');
            var natureMotifExclusion = containerResultatAnalyseVente.find('[name="nature_motif_exclusion"]');
            var motifExclusion = containerResultatAnalyseVente.find('[name="motifExclusion"]');
            var decisionAdmission = containerResultatAnalyseVente.find('[name="decisionAdmission"]');
            var justificationExclusion = containerResultatAnalyseVente.find('[name="justification_exclusion"]');

            // code commenté temporairement #25148
            // // #25148
            // var boolCertificat = containerResultatAnalyseVente.find('[name="bool_certificat"]');
            // if ($(boolCertificat).val()=='True'){
            //     containerResultatAnalyseVente.find('#radio_oui').prop('checked', 'checked');
            // }else{
            //     containerResultatAnalyseVente.find('#radio_non').prop('checked', 'checked');
            // }

            decisionAdmission.on('change', function () {
                var decision = $(this);
                // si la décision est vide ou 'Admise', les champs 'motif d'exclusion' et 'Justification de l'exclusion' sont vidés
                if (decision.val() != '0') {
                    motifExclusion.val('').trigger('change');
                    justificationExclusion.val('');
                }

                // si la décision est vide ou 'Exclue' et le motif est vide, prendre celui de la nature s'il y a lieu
                if (decision.val() != '1' && !motifExclusion.val() && natureMotifExclusion.val()) {
                    motifExclusion.val(natureMotifExclusion.val());
                    decision.val('0'); // 'Exclue'
                    if (natureBoolNonVente.val() == 'True') {
                        justificationExclusion.val('Non vente');
                    }
                }

                motifExclusion.attr('disabled', decision.val() != '0');
                justificationExclusion.attr('disabled', decision.val() != '0');
            });

            decisionAdmission.trigger('change');

            fenetreModal.calculerHauteurModal($('#mutation-resultat-analyse-vente'));
        }

        /**
         * Fonction de sauvegarde de l'étape de résultat d'analyse de vente du processus de mutation.
         * */
        function saveResultatAnalyseVenteMutation(callback) {

            var sections = $('#accordion-resultat-analyse-vente');
            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var containerResultatAnalyseVente = $('#mutation-resultat-analyse-vente');
                var inputsDisabled = containerResultatAnalyseVente.find('[name="ratio"], [name="motifExclusion"], [name="justification_exclusion"]').filter(':disabled');
                inputsDisabled.attr('disabled', false);
                var params = currentForm.find(':input.form-control').not('[name="boolEnqueteVente"]').serializeArray();
                inputsDisabled.attr('disabled', true);
                // si 'Enquête de vente' n'est pas saisi, il faut le passer 'vide' dans les params pour qu'il soit valider
                var boolEnqueteVente = containerResultatAnalyseVente.find('[name="bool_enquete_vente"]:checked');
                params.push({
                    name: 'bool_enquete_vente',
                    value: boolEnqueteVente.length ? boolEnqueteVente.val() : ''
                });
                params.push({name: 'date_debut', value: dateEvenement});

                if (currentForm.attr('est-enquete-vente') !== undefined) {
                    params.push({name: 'est_enquete_vente', value: true});
                }

                return params;
            };
            var getChampUnique;
            var getChampTransfert;
            var messageToast = {};
            sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);
        }

        /**
         * Fonction pour sauvegarder des formulaires côté serveur en un seul envoi
         * @param {function} callback - fonction utilisée par la sauvegarde générique
         * @param {Array} sections - sections qui serviront à rechercher les formulaires ou la section est un formulaire en soit
         * @param {function} callbackGetParams - fonction retournant les inputs du formulaire
         * @param {function} callbackGetChampUnique - champs qui permettrent de retrouver le formulaire s'il en a plusieurs dans la même section
         * @param {function} callbackGetChampTransfert - champ de l'instance que l'on doit passer au prochain formulaire qui l'utilisera dans sa sauvegarde
         * @param {object} messageToast - message qui s'affiche quand il y a succès de la sauvegarde
         * @param {number} statutEvenement - statut de l'évènement s'il change pour cette étape
         */
        function sauvegarderFormulairesCoteServeur(callback, sections, callbackGetParams, callbackGetChampUnique, callbackGetChampTransfert, messageToast, statutEvenement) {
            messageToastCompteur = 0;
            var nbErreurs = 0;
            // on fait un seul ajax, donc, on met le nombre de formulaires à 1 pour faire afficher les messages toast
            var nombreFormulaires = 1;
            // On sauvegarde la position des éléments dans la page du wizard (modal)
            var positions = {};
            positions.position_dans_modal = $('.slimScrollBar').length > 1 ? $('.slimScrollBar').css('top') : '';
            positions.accordions = [];
            var listeAccordions = $('.modal-content .step-pane.active .accordion-toggle');
            $.each(listeAccordions, function (index, value) {
                positions.accordions.push({name: $(value).attr('href'), value: $(value).attr('class')});
            });
            var dateEvenement = $('#wizard').attr('date-evenement');
            var validerSeulement = false;

            var validation = {};
            $.each(sections, function () {
                var section = $(this);
                var idSection = section.attr('id');
                var ordreSauvegarde = section.attr('ordre-sauvegarde') ? section.attr('ordre-sauvegarde') + '-' : '';
                idSection = ordreSauvegarde + idSection;
                validation[idSection] = [];
                var formulaires = section.attr('type') == 'formulaire' ? section : section.find('[type="formulaire"], .sous-bloc-form:not(.nouvelle-ligne)');
                // var formulaires = section.attr('type') == 'formulaire' ? section : section.find('[type="formulaire"]:visible, .sous-bloc-form:not(.nouvelle-ligne)');
                $.each(formulaires, function () {
                    var currentForm = $(this);
                    var estSousBloc = currentForm.hasClass('sous-bloc-form');
                    var champsMultiple = currentForm.closest('.champs-multiple');
                    var idCurrentForm = estSousBloc ? champsMultiple.attr('id') : currentForm.attr('id');

                    var params = callbackGetParams(currentForm, idCurrentForm, dateEvenement);

                    // enlever la paramètre 'validerSeulement' s'il existe
                    for (var index in params) {
                        if ('validerSeulement' in params[index]) {
                            validerSeulement = params[index]['validerSeulement'];
                            params.splice(index, 1);
                            break;
                        }
                    }

                    if (params.length) {
                        // indiquer qu'on vient de l'assistant pour effectuer la validation
                        params.push({name: 'wizard_mode', value: true});
                        params.push({name: 'wizard_no_raise_error', value: true});

                        var methode = currentForm.attr('methode');
                        var dict_validation = {
                            url: estSousBloc ? '/gestion-roles/' + idCurrentForm + '/' : currentForm.attr('vue'),
                            params: params,
                            action: methode == 'DELETE' ? 'delete' : methode == 'PATCH' ? 'update' : 'create',
                            id_model_instance: currentForm.attr('id-model-instance'),
                            // le formulaire qui a un fichier, on fait seulement le valider et
                            // on va le sauvegarder avec un ajax personnalisé s'il n'y a pas d'erreur sur l'ensemble des formulaires
                            // pour les multiples ues, on doit sauvegarder seulement le formulaire qui est un PATCH, le POST sera sauvegardé par l'évènement qui sera créé
                            // mais on veut le valider
                            modifie: currentForm.has('.ace-file-input').length ? false :
                                idCurrentForm == 'mutation-multiples-ues-form' && methode == 'POST' ? false :
                                    currentForm.attr('modifie') == 'True',
                            current_form: idCurrentForm
                        };

                        if (callbackGetChampUnique) {
                            $.extend(dict_validation, callbackGetChampUnique(currentForm, idCurrentForm));
                        }
                        if (callbackGetChampTransfert) {
                            $.extend(dict_validation, callbackGetChampTransfert(idCurrentForm));
                        }

                        validation[idSection].push(dict_validation);
                    }
                });
            });

            var idEvenement = $('#wizard').attr('id-evenement');
            var etapeCourante = $('#modal-step-contents > .active').data('id_processus');
            var idUe = $('#wizard').attr('id-ue');
            var idProcessus = $('#wizard').attr('id-processus');
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            var attributGenerique = $('#wizard').attr('attribut-generique');
            var dateChargee = $('#wizard').attr('date-chargee');
            var modeWizard = ($('#wizard').length > 0);

            if (validation) {
                wait.start();
                var params = {
                    'validation': JSON.stringify(validation),
                    'valider_seulement': validerSeulement,
                    'mode_wizard': modeWizard
                };
                var jqxhr = $.ajax({
                    headers: {},
                    type: 'POST',
                    url: '/gestion-roles/tenue-a-jour/formulaire-save/?date_evenement=' + encodeURI(dateEvenement) + '&id_evenement=' +
                        idEvenement + '&id_ue=' + idUe + '&id_processus=' + idProcessus + '&id_type_evenement=' + idTypeEvenement +
                        '&attribut_generique=' + attributGenerique + '&date_chargee=' + dateChargee,
                    data: params,
                    dataType: 'json',
                    async: false
                });

                jqxhr.done(function (response) {
                    erreursAjax.effacerErreurChamps(sections);
                    $.each(response, function (idSection, forms) {
                        $.each(forms, function (index, form) {
                            var currentForm = $('[id=' + form.current_form).eq(index);

                            var nomChampUnique = form.unique_nom_champ;
                            var idChampUnique = form.unique_id_champ;
                            // si on a nomChampUnique et idChampUnique, on cherche le formulaire associé
                            if (nomChampUnique && idChampUnique != undefined && (idChampUnique != '' || idChampUnique >= 0)) {
                                if (nomChampUnique == 'index_ligne') {
                                    var currentFormSousBloc = currentForm.find('.sous-bloc-form').eq(idChampUnique);
                                    if (!currentFormSousBloc.length) {
                                        currentForm = currentForm.closest('.div-table-contenu').find('[id="' + form.current_form + '"]').eq(idChampUnique);
                                    } else {
                                        currentForm = currentFormSousBloc;
                                    }
                                } else {
                                    var section = $('#' + idSection);
                                    var champSection = section.find('[name="' + nomChampUnique + '"][value="' + idChampUnique + '"]');
                                    if (!champSection.length) {
                                        champSection = section.find('[name="' + nomChampUnique + '"]').filter(function () {
                                            return $(this).text() == idChampUnique;
                                        });
                                    }
                                    if (!champSection.length) {
                                        section = $('[id="' + form.current_form + '"]');
                                        champSection = section.find('[name="' + nomChampUnique + '"][value="' + idChampUnique + '"]');
                                        if (!champSection.length) {
                                            champSection = section.find('[name="' + nomChampUnique + '"]').filter(function () {
                                                return $(this).text() == idChampUnique;
                                            });
                                        }
                                    }
                                    currentForm = champSection.closest('[type="formulaire"]');
                                }
                            }
                            erreursAjax.effacerErreurChamps(currentForm);

                            // il y a des erreurs ou warnings
                            if ('erreur' in form || 'warning' in form) {
                                afficherErreurWizard(form, currentForm, idSection);
                                nbErreurs += 1;
                            }
                            // il y a une sauvegarde
                            else if ('action' in form) {
                                var action = form.action;
                                if (action == 'delete') {
                                    currentForm.remove();
                                }
                                var idModelInstance = form.id_model_instance;
                                if (idModelInstance != 'None') {
                                    currentForm.attr('id-model-instance', idModelInstance);

                                    // On stocke le id au niveau du wizard pour être utilisé dans les étapes suivantes
                                    if (idSection == 'mutation-infos-generales' || idSection == 'operation-ue-infos-generales') {
                                        if ($('#mutation-infos-generales').attr('est-enquete-vente') == undefined) {
                                            $('#wizard').attr('id-processus', idModelInstance);
                                        }

                                    } else if (idSection == 'frm-date-evenement') {
                                        $('#wizard').attr('id-evenement', idModelInstance);
                                        $('#wizard').attr('date-evenement', form.data.date_evenement);
                                    }


                                }
                                var formData = form.data;
                                if (formData) {
                                    // récupérer seulement les données que l'on veut râfraichir dans le formulaire
                                    var fieldData = [];
                                    if (idSection == 'creation-proprietaire') {
                                        fieldData = ['nom_legal', 'prenom'];
                                    } else if (idSection == 'creation-adresse-proprietaire') {
                                        fieldData = ['adresse_complete', 'id_proprietaire', 'id_proprietaire_avant_creation', 'complement', 'evenement_lie'];
                                    } else if (idSection == 'section-cessionnaire' || idSection == 'adresse-proprietaire-apres-container') {
                                        fieldData = ['proprietaire', 'id_b02_adresse_proprietaire', 'id_ue_proprio_existant'];
                                    } else if (idSection == 'edition-proprietaire-x-unite-evaluation') {
                                        fieldData = ['complement'];
                                    } else if (idSection == 'edition-adresse-ue') {
                                        fieldData = ['adresse_complete'];
                                    }
                                    $.each(fieldData, function (index) {
                                        if (idSection == 'creation-adresse-proprietaire' && fieldData[index] == 'id_proprietaire') {
                                            $('#creation-proprietaire').attr('id-model-instance', formData[fieldData[index]]);
                                            $('#edition-proprietaire-x-unite-evaluation').attr('id_proprietaire', formData[fieldData[index]]);
                                        } else if (fieldData[index] == 'id_proprietaire_avant_creation') {
                                            $('#creation-proprietaire').attr('proprietaire-avant-creation', formData[fieldData[index]]);
                                        } else if (idSection == 'creation-adresse-proprietaire' && fieldData[index] == 'evenement_lie') {
                                            $('#wizard').data('evenement-lie', formData[fieldData[index]]);
                                        } else if (idSection == 'section-cessionnaire' || idSection == 'adresse-proprietaire-apres-container') {
                                            currentForm.find('[name="' + fieldData[index] + '"]').text(formData[fieldData[index]]);
                                        } else if (idSection == 'edition-proprietaire-x-unite-evaluation' && fieldData[index] == 'complement') {
                                            $('#creation-adresse-proprietaire').find('[name="' + fieldData[index] + '"]').val(formData[fieldData[index]]);
                                        } else if (idSection == 'edition-adresse-ue' && fieldData[index] == 'adresse_complete') {
                                            $('#edition-adresse-ue').attr('adresse-complete', formData[fieldData[index]]);
                                        } else {
                                            currentForm.find('[name="' + fieldData[index] + '"]').val(formData[fieldData[index]]);
                                        }
                                    });
                                }
                                if (!validerSeulement) {
                                    traitementPostSauvegarde(currentForm);
                                }
                                if ($('.slimScrollDiv').length > 0) {
                                    scroll.positionCurseurScroll(currentForm, '#modal-step-contents');
                                }
                            }
                            if (idSection === 'champ_modifie_auto') {
                                $('#wizard').attr('date-chargee', form.date_chargee);
                            }
                        });
                    });

                    // sauvegarder les documents avec un ajax personnalisé
                    if (!nbErreurs) {
                        var sousBlocsDocument = sections.find('.sous-bloc-form[modifie="True"]').has('.ace-file-input');
                        var idUe = $('#wizard').attr('id-ue');
                        var idMunicipalite = $('#municipalite').val();
                        var idMutation = $('#mutation-infos-generales').attr('id-model-instance');
                        var idPermis = $('#evenement-infos-generales').attr('id-model-instance');
                        var idOperationUe = $('#operation-ue-infos-generales').attr('id-model-instance');
                        var idOperationCadastrale = $('#operation-cadastrale-infos-generales').attr('id-model-instance');
                        var idProcessus = $('#wizard').attr('id-processus');
                        $.each(sousBlocsDocument, function (index, sousBloc) {
                            var paramsOptionnels = [];
                            if (idMunicipalite) {
                                paramsOptionnels.push({name: 'id_municipalite', value: idMunicipalite});
                            }
                            if (idMutation) {
                                paramsOptionnels.push({name: 'id_mutation', value: idMutation});
                            }
                            if (idPermis) {
                                paramsOptionnels.push({name: 'id_permis', value: idPermis});
                            }
                            if (idOperationUe) {
                                paramsOptionnels.push({name: 'id_operation_ue', value: idOperationUe}); //et
                            }
                            if (idOperationCadastrale) {
                                paramsOptionnels.push({
                                    name: 'id_operation_cadastrale',
                                    value: idOperationCadastrale
                                }); //et
                            }
                            if ($('#mutation-infos-generales').attr('est-enquete-vente') !== undefined && idProcessus) {
                                paramsOptionnels.push({name: 'id_enquete_vente', value: idProcessus});
                            }
                            if ($('#ddr-reponse-evaluateur-form').length) {
                                paramsOptionnels.push({name: 'id_demande_de_revision', value: idProcessus});
                            }else if($('#cdo-reponse-evaluateur-form').length) {
                                // TODO: test conserver ou spprimer
                                paramsOptionnels.push({name: 'id_correction_d_office', value: idProcessus});
                            }
                            nbErreurs = wizardSauvegarderSousBloc($(sousBloc), idUe, -1, paramsOptionnels, dateEvenement);
                        });
                    }

                    if (etapeCourante !== 0) {
                        if (messageToastCompteur === (nombreFormulaires - 1)) { // Comme on n'a pas encore incrémenté le compteur de messages, on enlève UN (1) pour la comparaison.
                            var etapeOrdre = $('#modal-step-contents > .active').attr('data-step');
                            var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                            // Dans le cas de l'étape 1 des permis, on a deux méthodes de sauvegarde. On ne recharge pas l'étape sinon les messages ne s'affichent pas.
                            // 75 reponse de l'évaluateur pour les ddr
                            if (![1,75].includes(Number(etapeProcessus,10))) {
                                chargerEtapeDynamique(etapeCourante, etapeOrdre, '', 'noInit', positions);
                            }
                        }
                    }
                    if ($.inArray(idTypeEvenement, ['36', '67']) == -1 || nbErreurs) {
                        sauvegarderDonneesMessageToast(messageToast, nombreFormulaires, jqxhr, nbErreurs, callback);
                        messageToastCompteur += 1;
                    }
                    wait.stop();
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    wait.stop();
                    infos.ajouterMessageToast({
                        message: 'Une erreur s\'est produite. Contactez un administrateur.',
                        type: 'error',
                        messageDuree: 0
                    });
                    //TODO : logguer les erreurs

                    nbErreurs = 1;
                });
            }
            if (typeof (callback) !== 'undefined') {
                var response = {};
                if (nbErreurs) {
                    response.reponse = 'error';
                } else {
                    if (statutEvenement != -1 && idTypeEvenement != 6) {
                        $('#wizard').attr('id-statut-evenement', statutEvenement);
                    }

                    response.reponse = 'ok';
                }

                if (typeof (callback) == 'object') {
                    callback = response;
                } else {
                    callback(response);
                }
            }

            function afficherErreurWizard(form, currentForm, idSection) {
                afficherErreurParType('erreur', form, currentForm, idSection);
                afficherErreurParType('warning', form, currentForm, idSection);
            }

            function afficherErreurParType(typeErreur, form, currentForm, idSection) {
                if (typeErreur in form) {
                    $.each(form[typeErreur], function (champ, erreur) {
                        // on pourrait avoir une 2e section dans laquelle on veut afficher l'erreur, donc, on l'a concaténé dans le nom de champ
                        var champSplit = champ.split('^^^');
                        if (champSplit.length == 2) {
                            // on prend la 1ère partie pour vérifier avec la section
                            champ = champSplit[0];
                        }
                        if (champ == idSection) {
                            if (champSplit.length == 2) {
                                // on prend la 2e partie pour trouver la section correspondante
                                champ = champSplit[1];
                            }
                            currentForm = $('#' + champ);
                            var currentFormTable = currentForm.find('.div-table-contenu');
                            if (currentFormTable.length) {
                                currentForm = currentFormTable;
                            }
                            champ = 'none';
                        }
                        // montrer l'erreur sur le champ affiché dans l'interface
                        if (champ == 'provinceEtat') {
                            champ = 'province_etat_liste';
                        }
                        if (champ == 'municipalite') {
                            champ = 'municipalite_liste';
                        }
                        if (champ == 'code_postal' && idSection == 'edition-adresse-ue') {
                            currentForm = $('#creation-adresse-proprietaire');
                        }
                        erreursAjax.afficherErreurChamps(currentForm, champ, erreur, '');
                    });
                }
            }
        }


        function initFermetureEvenement() {
            var etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');

            var erreurs = etape.find('.wiz-validation .wiz-validation-erreur');
            if (erreurs.length > 0) {
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
            }
            if ($('#evenement-facturation').attr('data-est_facturation') === 'True') {
                $('[name="baremes"]').select2();
                $('[name="baremes"]').off('change').on('change', function (e) {
                    $('#btn-wizard-save').prop('disabled', true);
                    if ((e.added) || (e.removed)) {
                        $('#btn-wizard-save').hide();
                    }
                });
            }

            // Callback lorsqu'on clic sur le bouton terminer
            $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                let titre = "";
                let texteExplicatif = "";
                var dateNouveauRoleOuvert = $('#evenement-detection-nouveau-role-ouvert').attr('date-nouveau-role-ouvert');
                if (dateNouveauRoleOuvert) {
                    titre = "En terminant cet évènement, toutes les modifications apportées à une fiche de bâtiment résidentiel de cet évènement seront automatiquement reportées au nouveau rôle.<br><br>Voulez-vous fermer l'évènement?"
                    texteExplicatif = "<strong>Attention, cette action pourrait écraser des modifications déjà apportées " +
                        "à une fiche de bâtiment résidentiel de l'évènement du nouveau rôle et nécessiter la relance de certains calculs afin de " +
                        "refléter les changements appliqués.</strong>";
                }
                else {
                    titre = "Voulez-vous fermer l'évènement ?";
                    if (erreurs.length !== 0) {
                        titre = "Au moins une des fiches de l'unité d'évaluation contient encore des erreurs à compléter (voir validations). Voulez-vous tout de même fermer l'évènement ?";
                    }
                }

                fenetreModal.modalMessage({
                    titre: titre,
                    sansX: true,
                    texteExplicatif: texteExplicatif,
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function (response) {
                                if (dateNouveauRoleOuvert) {
                                    var params = {
                                        id_evenement: $('#wizard').attr('id-evenement'),
                                        date_nouveau_role_ouvert: dateNouveauRoleOuvert
                                    };
                                    var jqxhr = $.ajax({
                                        type: 'POST',
                                        url: '/gestion-roles/tenue-a-jour/nettoyer-changement-nouveau-role-ouvert/',
                                        data: params,
                                        dataType: 'json',
                                        async: false
                                    });
                                    jqxhr
                                        .done(function (response) {
                                            fenetreModal.fermerModalAlerteDivs();
                                        });
                                    jqxhr
                                        .fail(function (jqxhr, textStatus, errorThrown) {
                                            fenetreModal.fermerModalAlerteDivs();
                                            infos.ajouterMessageToast({
                                                message: "Erreur lors de l'application des modifications au nouveau rôle. Contactez un administrateur.",
                                                messageDuree: 0,
                                            });
                                        });
                                }

                                saveFermetureEvenement();

                                var id_evenement = $('#wizard').attr('id-evenement');
                                $.ajax({
                                    type: "POST",
                                    url: '/gestion-roles/tenue-a-jour/fermeture-evenement/' + id_evenement + '/save/',
                                    dataType: 'json',
                                    success: function (response) {
                                        var callback = function (reponse) {};
                                        var jqxhr = $.ajax({
                                            type: "GET",
                                            url: "/gestion-roles/" + id_evenement + "/valider-evenement-rouvert/",
                                            dataType: 'json'
                                        });
                                        jqxhr
                                            .done(function (response1) {
                                                var reponse1 = response1;
                                                if (reponse1.reponse == 'ok') {
                                                    checkTraiterProchainEvenementLie(response.evenement_lie, callback);
                                                } else {

                                                    fenetreModal.modalMessage({
                                                        titre: reponse1.erreur.titre,
                                                        sansX: true,
                                                        taille: 'grande',
                                                        texteExplicatif: reponse1.erreur.message,
                                                        boutons: {
                                                            "Fermer": {
                                                                label: " Fermer ",
                                                                id: "rouvrir",
                                                                class: "btn",
                                                                action: function () {
                                                                    setTimeout(function () {
                                                                        fenetreModal.fermerModal('rouvrir');
                                                                        wait.stop();
                                                                        checkTraiterProchainEvenementLie(response.evenement_lie, callback);

                                                                    }, 10);
                                                                }
                                                            }
                                                        }

                                                    });

                                                }
                                            });

                                        jqxhr
                                            .fail(function (jqxhr, textStatus, errorThrown) {

                                                fenetreModal.fermerModalAlerteDivs();
                                                var reponse1 = {reponse1: 'cancel'};
                                                callback(reponse1);
                                            });
                                        // #15873: Exception pour l'explorateur, le datatable n'est pas initialisé via ajax.
                                        var estExplorateur = ($('#collapse-evenement-et-valeurs-accordeon').length > 0);
                                        if (estExplorateur) {
                                            ExplorateurUEchargeTableauEvenement();
                                        } else {
                                            refreshDatatables();
                                        }
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        infos.ajouterMessageToast({
                                            message: 'Erreur de sauvegarde',
                                            messageCouleur: 'red'
                                        });
                                        wait.stop();
                                        erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', xhr, xhr.responseJSON['None']);
                                    }
                                });
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }
                });
            });
        }

        function saveFermetureEvenement() {
            // $('#btn-wizard-save').prop('disabled', true);
            var est_Facturation = $('#evenement-facturation').attr('data-est_facturation');
            if (est_Facturation === 'True') {
                var table = 'table-evenement-facturation';

                var tableObject = $('#' + table + ' tbody tr').map(function (i) {
                    var row = {};
                    var idevenement = $(this).attr("data-id_evenement");
                    var variation_imposable_immeuble = $(this).attr("data-variation");
                    var id_cyle = $(this).attr("data-cycle");

                    $(this).find('td').each(function (i) {


                        //select2 multiple
                        if ($(this).attr('dataValue') == 'select') {

                            var list_baremes = $(this).find('[name="baremes"]').select2('data');

                            var listeBareme = [];
                            $.each(list_baremes, function (index, value) {
                                listeBareme.push(value.id);
                            });
                            row['id_bareme_liste'] = listeBareme;
                            row['id_evenement'] = idevenement;
                            row['id_cycle'] = id_cyle;
                            row['variation_imposable_immeuble'] = variation_imposable_immeuble;

                        }

                    });
                    return row;
                }).get();

                var params = [{name: 'donnees', value: JSON.stringify(tableObject)}];
                wait.start();
                $.ajax({
                    type: "POST",
                    url: '/gestion-roles/tenue-a-jour/fermeture-evenement-facturation/',
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        wait.stop();
                        infos.ajouterMessageToast({
                            message: 'Sauvegarde item facturation réussie',
                            messageDuree: 500,
                            icone: 'fa-check-circle-o',
                            iconeCouleur: 'green'
                        });
                    }
                });

            }

            var paramsattestation = {
                "id_ue": $('#wizard').attr('id-ue'),
            };
            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/mutation/date-attestation/",
                data: paramsattestation,
                dataType: 'json',
                success: function (response) {
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: 'Une erreur s\'est produite. Contactez un administrateur.',
                        messageDuree: 0
                    });

                }
            });



        }

        // c'est l'étape Terrain au chargement
        function initTraitementMutation() {
            // à cause que l'étape est longue à charger, mettre le bouton Suivant inactif
            $('#btn-wizard-suivant-terminer').prop("disabled", true);

            // il faut recharger l'étape Terrain car la valeur manuelle ou la remarque peuvent
            // avoir changés dans l'étape de Valeur retenue
            var idEtapeProcessus = 18;
            var pageCourante = $($('.steps li[data-id_processus=' + idEtapeProcessus + ']').data('target'));
            pageCourante.attr('recharger', 'oui');

            // ajouter le id_bloc pour mettre à jour les attribut du form et afficher les erreurs dans les sous-blocs
            // ajouter une classe pour afficher les erreurs sous le bloc
            var containerB93ValeurTerrain = pageCourante.find('#b93-valeur-terrain');
            containerB93ValeurTerrain.attr('id_bloc', '93').addClass('afficher-erreur');

            initWizardBlocs();
            initCalculValeurAjustementManuel();
            calculerValeurTotaleDesTranches();
            cacheDoublonValeursRecap();
            var mode_afficher_erreurs_wizard = ['#b93-valeur-terrain'];
            for (let i in mode_afficher_erreurs_wizard) {
                $(mode_afficher_erreurs_wizard[i]).attr('mode_afficher_erreurs_wizard', 'oui');
            }
            if ($("#afficher-emplacement-b93").css('display') == 'none') {

                containerB93ValeurTerrain.find("[name='facteur_ajustement']").on('change', function () {
                    var containerTypeutilisation = pageCourante.find('[name="div-dest"] #b04-terrain-agricole-boise [name="typeUtilisationSol"]').parent();
                    var typeUtilisation = $.makeArray(
                        containerTypeutilisation.find('[name="typeUtilisationSol"] option:checked').map(function () {
                            return ($(this).text()).indexOf("Emplacement") > -1;
                        }));
                    for (let i = 0; i < typeUtilisation.length; i++) {
                        if (typeUtilisation[i] === true) {
                            $("#afficher-emplacement-b93").removeAttr('style');
                            $("#afficher-emplacement-b93").css("display", "block");
                        }
                    }
                    //  var bool_emplacement = containerRow.find('[name="bool_applique_facteur_emplacement"]');
                    //   bool_emplacement.show();
                });
            }

            // afficher les avertissements de validation en-dessous du sélecteur
            var containerTypeServiceTg = pageCourante.find('[name="div-dest"] #b04-terrain-general [name="type_service_tg_liste"]').parent();

            // #17610: systématiquement force enlève les services 01 à 07 SI 08 est inclu
            let typeServiceTGListe = containerTypeServiceTg.find('[name="type_service_tg_liste"]');
            let options;
            if (containerTypeServiceTg.is('ul')) {
                options = typeServiceTGListe.find('li.option.bg-grey');
            }
            else {
                options = typeServiceTGListe.find('option:checked');
            }
            var typeServiceTG = $.makeArray(options.map(function () {
                return $(this).val();
            }));
            if (typeServiceTG.includes('08')) {
                for (let i=1;i<=7;i++) {
                    if (typeServiceTG.includes('0'+i)) {
                        let option;
                        let disabled;
                        if (containerTypeServiceTg.is('ul')) {
                           option = $(containerTypeServiceTg).find('li.option[value="0' + i + '"]');
                           disabled = $(option).attr('disabled');
                        }
                        else {
                            option = $(containerTypeServiceTg).find('option[value="0' + i + '"]');
                            disabled = $(option)[0].hasAttribute('disabled');
                        }
                        // pour désactiver temporairement l'attr disabled afin de simuler un clic sur l'element
                        if(disabled){
                            $(option).removeAttr('disabled');
                        }
                        // creation d'un fake event pour les fins de callBackSelectMultiplePointerup
                        var event = {'currentTarget': {'index': i-1}};  // -1 pour l'index (position) de l'option dans le select
                        callBackSelectMultiplePointerup(option, event);
                        // on remets le disabled
                        if(disabled){
                            $(option).attr('disabled', true);
                        }
                    }
                }
            }

            containerTypeServiceTg.addClass('type-warning').addClass('garder-warning');

            validerTypeServiceTG(containerTypeServiceTg);

            pageCourante.find('.btn-group label[name=label-src]').on('click', function () {
                pageCourante.find('[name=div-src]').hide();

                var idx = $(this).attr('index-div');
                pageCourante.find('[name=div-src][index-div=' + idx + ']').show();
            });

            pageCourante.find('.btn-group label[name=label-dest]').on('click', function () {
                var curIdxActive = ($(this).attr('index-div') == 1 ? 2 : 1);
                var idx = $(this).attr('index-div');

                fenetreModal.modalMessage({
                    titre: "Voulez-vous vraiment continuer ?",
                    texteExplicatif: "Ceci aura pour effet d'effacer le terrain déjà nouvellement créé.",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                var idFormulaire = (idx == 1 ? ID_FORMULAIRE.terrainGeneral : ID_FORMULAIRE.terrainAgricoleBoise);

                                var params = {
                                    id_evenement: $('#wizard').attr('id-evenement'),
                                    id_formulaire: idFormulaire
                                };

                                $.ajax({
                                    type: "GET",
                                    url: '/gestion-roles/tenue-a-jour/mutation/terrain-save-valeur-defaut/',
                                    data: params,
                                    dataType: 'json',
                                    success: function (response) {

                                        var dateEvenement = $('#wizard').attr('date-evenement');
                                        var idEvenement = $('#wizard').attr('id-evenement');
                                        var idBatiment = $('#wizard').attr('id-ue');
                                        var idTypeBatiment = $('#wizard').attr('id-type-batiment');
                                        var idBloc = (idFormulaire == ID_FORMULAIRE.terrainGeneral ? '04TG' : '04TAB');

                                        var callback = function () {
                                            if (idFormulaire == ID_FORMULAIRE.terrainAgricoleBoise) {
                                                var bloc = pageCourante.find('[name=div-dest] > .blocForm');
                                                if (response.typeFormeTab) {
                                                    var champFormeTab = bloc.find('[name="typeFormeTab"]');
                                                    champFormeTab.val(response.typeFormeTab);
                                                }

                                            }

                                            pageCourante.find('[name=div-src] > form').removeClass('blocForm').addClass('blocForm');
                                            pageCourante.find('[name=div-dest] > form').removeClass('blocForm').addClass('blocForm');

                                            pageCourante.find('[name=div-dest]').hide();
                                            var divDest = pageCourante.find('[name=div-dest][index-div=' + idx + ']');
                                            divDest.show();

                                            if (response.id_model_instance) {
                                                var divDestForm = divDest.find('.blocForm');
                                                divDestForm.attr('id_model_instance', response.id_model_instance);
                                                divDestForm.attr('bloc_editable', 'True');
                                            }
                                        };

                                        // pour ne pas charger dans ces blocs
                                        pageCourante.find('[name=div-src] > form').removeClass('blocForm');
                                        pageCourante.find('[name=div-dest] > form').removeClass('blocForm');

                                        // charger uniquement le bloc affiché (soit TG ou TAB)
                                        //var idx = $('.active[name=label-dest]').attr('index-div');
                                        pageCourante.find('[name=div-dest][index-div=' + idx + '] > form').addClass('blocForm');

                                        ouvrirFicheTaj(idBatiment, idTypeBatiment, idEvenement, dateEvenement, idFormulaire, idBloc, callback);
                                    }
                                });
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                pageCourante.find('.btn-group label[name=label-dest][index-div=' + curIdxActive + ']').addClass('active');
                                pageCourante.find('.btn-group label[name=label-dest][index-div!=' + curIdxActive + ']').removeClass('active');
                            }
                        }
                    }

                });
            });

            // Si on a chargé des valeurs par défaut (donc pas de ligne b04 à date_debut = date_evenement), on marque tout comme étant modifié pour pouvoir tout sauvegarder
            //vérifier si le terrain actif a un id_modal_instance
            var idx = $('.active[name=label-dest]').attr('index-div');
            var mapageactif = pageCourante.find('[name=div-dest][index-div=' + idx + ']');
            if (mapageactif.find('form[code=04][id_model_instance=None]').length > 0) {
                blocsMarquerModifie(pageCourante);

                // ne pas mettre 'modifie' sur les champs de segmentation manuelles, on doit attendre que les données
                // changent pour faire la validation côté serveur
                $('#b93-tranche-terrain-0-sous-bloc').find('.sous-bloc-form .form-control').removeClass(CLASSE_VALEUR_MODIFIEE);

                $('#btn-wizard-save').prop('disabled', false);
            }

            mapageactif.find('.champs-multiple .sous-bloc-form [name=superficie]').change(function(element){
                var needUpdateSuperficieEaeViseeImpositionMax = true;
                var elementChanged = element.currentTarget;
                while (elementChanged) {
                    elementChanged = elementChanged.parentNode;
                    if (elementChanged) {
                        if (elementChanged.id === "b04-paturage" || elementChanged.id === "b04-droit-acquis" || elementChanged.id === "b04-cultivable" || elementChanged.id === "b04-produits-forestiers-non-ligneux") {
                            needUpdateSuperficieEaeViseeImpositionMax = false;
                            break;
                        }
                    }
                }
                if (needUpdateSuperficieEaeViseeImpositionMax) {
                    var elements = document.getElementsByName('superficie_eae_visee_imposition_max');
                    elements.forEach(element => element.classList.add(CLASSE_VALEUR_MODIFIEE));
                }
            });

            $('#btn-calculer-terrain').on('click', function () {
                var positions = positionCurseurWizard();
                var callbackCalculTerrain = function () {
                    var params = {
                        id_ue: $('#wizard').attr('id-ue'),
                        date_evenement: $('#wizard').attr('date-evenement')
                    };
                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/methode-cout/calculer-terrain/",
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            $('#btn-wizard-recharger').trigger('click');
                        }
                    });
                };

                fenetreModal.modalMessage({
                    titre: "Lancer le calcul du terrain ?",
                    sansX: true,
                    texteExplicatif: "Les données entrées manuellement dans les tranches terrains (accordéon « Segmentation de la superficie »)<br> seront effacées et recalculées selon les paramètres de la Municipalité.",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                // mettre un timeout au cas ou cette fonction ferait afficher un autre modal, car les modals sont automatiquement fermés sur clique d'un bouton
                                setTimeout(function () {
                                    // 1- On doit lancer la sauvegarde de l'étape
                                    saveTraitementMutation({}, callbackCalculTerrain, function () {
                                    }); // 2- Ensuite, si la réponse de la sauvegarde est OK, on procède au calcul du terrain.
                                }, 100);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }
                });
            });

            // #5653, On désactive le bouton si read-only
            var evenementMode = $('#wizard').attr('mode');
            if (evenementMode == 'r') {
                pageCourante.find('.btn-terrain').attr('disabled', true);
                pageCourante.find('.btn-group label[name=label-dest]').off("click");

            }
            $('#btn-editer-fiche-terrain').on('click', function () {
                wait.start('contenu');
                var etapeProcessusId = pageCourante.attr('data-id_processus');
                var etapeOrdre = pageCourante.attr('data-step');
                var paramsSupp = {'editer_fiche_terrain': 1};
                chargerEtapeDynamique(etapeProcessusId, etapeOrdre, paramsSupp);
                return false;
            });

            // à cause que l'étape est longue à charger, remettre le bouton Suivant actif selon les conditions
            var estB93ValeurTerrainNonPresent = (containerB93ValeurTerrain.length == 0 &&
                pageCourante.find('form[code=04]').length > 0) || (pageCourante.find('#adm-erreur-calcul-terrain').length > 0);
            // bloquer le suivant selon la variable, car on veut d'abord qu'il save b04, puis ça autogénérera des b93
            $('#btn-wizard-suivant-terminer').prop("disabled", estB93ValeurTerrainNonPresent);
            if (pageCourante.find('#adm-erreur-calcul-terrain').length > 0) {
                infos.ajouterMessageToast({
                    message: 'Erreur sur le calcul terrain',
                    messageDuree: 0,
                    messageCouleur: 'red'
                });
            }

            // 13923 Juste dans le après
            var touchbloc = 0;
            chargerinformationecoforestiere([]);
            valeur_calculee_totale_originale = $('[name="valeur_total_tranches"]').val();
            pageCourante.find('.form-control').change(function () {
                touchbloc = $(this).parent().find("#form-facteur_ajustement").length + $(this).parent().find("#form-valeur_retenue").length
                    + $(this).parent().find("#form-valeur_manuelle").length + $(this).parent().find("#form-description_ajustement").length
                    + $(this).parent().find("#form-remarque").length;
                if (touchbloc <= 0) {
                    surlignevaleurcalculer();
                }
            });

            var containerTAB = pageCourante.find('[name="div-dest"] #b04-terrain-agricole-boise');
            containerTAB.find('[name="bool_vfe"]').change(function() {
                var estEnregistreeCochee = $(this).is(':checked');
                var champsSuperficieVfeSaisi = containerTAB.find('[name^="superficie_vfe"]').filter(function() {
                    return $(this).val() != '';
                });
                champsSuperficieVfeSaisi.parent().toggleClass(CLASSE_SUPPRESSION_LIGNE, !estEnregistreeCochee);
                champsSuperficieVfeSaisi.prop('disabled', !estEnregistreeCochee);
            });

            // #24928: gestion des champs superficie imask : séparateur de miliers
            window.b04terraiagricoleboise_superficies_imask = []
            let noms_champs_b04_principal_superficie = ['front', 'profondeur', 'superficie', 'superficie_eae_totale', 'superficie_eae_zonee', 'superficie_eae_visee_imposition_max', 'superficie_vfe_totale', 'superficie_vfe_zonee'];
            let nom_sous_blocs_b04_superficie = ['b04-droit-acquis', 'b04-produits-forestiers-non-ligneux', 'b04-cultivable', 'b04-friche', 'b04-paturage', 'b04-boise', 'b04-erabliere', 'b04-arbre-fruitier', 'b04-inutilisable'];

            function init_champ_superficie_imask(champ_superficie){
                champ_superficie.imask = IMask(
                    champ_superficie,
                    {
                        mask: Number,
                        min: 0,
                        max: 1000000000000,
                        thousandsSeparator: ' ',
                        radix: '.',
                        scale: 2,
                        padFractionalZeros: true,
                    }
                );
                window.b04terraiagricoleboise_superficies_imask.push(champ_superficie);
            }

            function init_b04_champs_superficies(){
                // les champs superficie du b04 qui ont tous des noms différents (et uniques)
                $(noms_champs_b04_principal_superficie).each(function () {
                    let champs_superficie_jq = $('#b04-terrain-agricole-boise [name="' + this + '"]:not(.sous-bloc-form *)');
                    $.each(champs_superficie_jq, function(idx, champ_superficie) {
                        init_champ_superficie_imask(champ_superficie);
                    });
                });
                // les champs superficie des sous-blocs identifiés
                $(nom_sous_blocs_b04_superficie).each(function () {
                    let champs_superficie_jq = $('#' + this + ' [name="superficie"]');
                    $.each(champs_superficie_jq, function(idx, champ_superficie) {
                        init_champ_superficie_imask(champ_superficie);
                    });
                });
                // observer des ajouts de nouvelles lignes de sous-blocs contenant un champ superficie
                function init_b04_champs_superficies_nouvelles_lignes(){
                    var nouvelle_ligne_observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(mutation) {
                            // Pour le cas d'une ligne ajoutée d'un des sous-blocs (Contient un champ superficie)
                            for (var i = 0; i < mutation.addedNodes.length; i++){
                                let champ_superficie_jq = $(mutation.addedNodes[i]).find('[name="superficie"]');
                                let has_champ_superficie = champ_superficie_jq.length > 0;
                                let is_nouvelle_ligne = champ_superficie_jq.parents('.nouvelle-ligne');
                                if(has_champ_superficie && is_nouvelle_ligne){
                                    init_champ_superficie_imask(champ_superficie_jq[0]);
                                }
                            }
                        });
                    });
                    // selecteur des formulaires parent de nos b04 contenant les champs en question
                    let containers_main_b04_jq = $('form#b04-terrain-agricole-boise');
                    $(containers_main_b04_jq).each(function(){
                            nouvelle_ligne_observer.observe(this, { childList: true, subtree: true});
                    });
                }
                init_b04_champs_superficies_nouvelles_lignes();
            }
            init_b04_champs_superficies();

        } // initTraitementMutation

        function blocsMarquerModifie(blocsContainer) {
            if (blocsContainer === undefined) blocsContainer = $('.step-pane.active');

            // On enlève les éléments qui seraient dans un sous-bloc
            var elementsException = blocsContainer.find('.champs-multiple .form-control');
            blocsContainer.find('.form-control').not(elementsException).addClass(CLASSE_VALEUR_MODIFIEE);

            blocsContainer.find('.sous-bloc-form').not('.sous-bloc-form.nouvelle-ligne').find('.form-control').addClass(CLASSE_VALEUR_MODIFIEE);
        }

        function positionCurseurWizard() {
            // On sauvegarde la position et l'état des éléments dans la page du wizard (modal)
            var positions = {};
            var cadre = $('#modal-step-contents').length > 0 ? '#modal-step-contents' : '';
            var offset = $(cadre + ' > .active .contenu-principal').offset();
            var contenuPrincipalOffset = 0;
            if(offset){
                contenuPrincipalOffset = $(cadre).length > 0 ? Math.abs(offset.top, 10) : 0;
            }

            positions.position_dans_modal = $('.slimScrollBar').length > 0 ? parseInt($('.slimScrollBar').css('top'), 10) : '';
            positions.position_dans_modal = positions.position_dans_modal + contenuPrincipalOffset + "px";
            positions.accordions = [];
            var listeAccordions = $('.modal-content .step-pane.active .accordion-toggle');
            $.each(listeAccordions, function (index, value) {
                positions.accordions.push({name: $(value).attr('href'), value: $(value).attr('class')});
            });

            return positions;
        }

// c'est l'étape Terrain à la sauvegarde
        function saveTraitementMutation(callback, callbackCalculTerrain, validation_repartitions_ok=false) {
            var $etapeCourante = $('#modal-step-contents > .active');
            $etapeCourante.attr('recharger', 'oui');
            // vu que l'étape doit être rechargé et que l'étape est longue à charger, mettre le bouton Suivant inactif
            $('#btn-wizard-suivant-terminer').prop("disabled", true);

            // si 'Ne s'applique pas' ou si l'étape est read-only, alors ne pas sauvegarder
            var doitSauvegarder = true;
            if ($('[name=div-dest] > form').length == 0) {
                if ($('[name="valeur_manuelle"]').length == 0 ||
                    ($('#wizard').attr('id-type-evenement') == '20' && !$('[name="valeur_retenue"]').val())) {
                    doitSauvegarder = false;
                }
            }

            if (!doitSauvegarder) {
                if (typeof (callback) !== 'undefined') {
                    var response = {};
                    response.reponse = 'ok';
                    callback(response);
                }
                return;
            }
            // #25182: avertir utilisateur champs répartitions vides
            if(!validation_repartitions_ok){
                let champs_a_valider = ['b04-droit-acquis', 'b04-produits-forestiers-non-ligneux', 'b04-cultivable', 'b04-friche', 'b04-paturage', 'b04-boise', 'b04-erabliere', 'b04-arbre-fruitier', 'b04-inutilisable'];
                let avertir_utilisateur_repartitions_vides = false;
                // seulement si l'onglet "terrain agricole ou boisé" (et non "terrain général")
                if($('.btn-terrain.active input').val() == '2'){
                    avertir_utilisateur_repartitions_vides = true;
                    $(champs_a_valider).each(function () {
                        if($('#' + this + ' [name="superficie"]').val()!=''){
                            avertir_utilisateur_repartitions_vides=false;
                            return false;
                        }
                    });
                }
                if(avertir_utilisateur_repartitions_vides){
                    fenetreModal.modalMessage({
                        enteteTitre:'Attention',
                        taille:'petite',
                        titre: 'Champs de répartitions de superficies vides',
                        sansX: true,
                        texteExplicatif: "Aucune valeur de répartition n\'a été remplie. Souhaitez-vous" +
                            " sauvegarder quand-même?",
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function (response) {
                                    saveTraitementMutation(callback, callbackCalculTerrain, true);
                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                    if (callback) {
                                        const response = {reponse: 'error'};
                                        callback(response);
                                    }
                                    return;
                                }
                            }
                        }
                    });
                    if (callback) {
                        const response = {reponse: 'error'};
                        callback(response);
                    }
                    return;
                }
            }


            // pour ne pas le sauvegarder
            $('[name=div-src] > form').removeClass('blocForm');
            $('[name=div-dest] > form').removeClass('blocForm');

            // sauvegarder uniquement le bloc affiché (soit TG ou TAB)
            var idx = $('.active[name=label-dest]').attr('index-div');
            $('[name=div-dest][index-div=' + idx + '] > form').addClass('blocForm');

            var callbackSaveWizardBlocs = function (response) {

                if (response.reponse === 'ok') {
                    if (typeof (callbackCalculTerrain) != "undefined") {
                        callbackCalculTerrain();
                    }
                } else if (response.reponse === 'error' || response.reponse === 'cancel') {
                    callback(response);
                }

                $('[name=div-src] > form').addClass('blocForm');
                $('[name=div-dest] > form').addClass('blocForm');

                // recharger les champs superficies imask (Après avoir update leur valeurs pour le save)
                $(window.b04terraiagricoleboise_superficies_imask).each(function(){
                    $(this).each(function(){
                       this.imask.updateControl();
                    })
                });

                callback(response);
            };

            /// DM: recharger l'interface avec la sauvegarde, mais uniquement si on a cliqué Sauvegarder et non Suivant
            $('#modal-step-contents > .active').attr('recharger', 'oui');
            //verifier la date attestation
            var paramsattestation = {
                "id_ue": $('#wizard').attr('id-ue'),
            };
            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/mutation/date-attestation/",
                data: paramsattestation,
                dataType: 'json',
                success: function (response) {
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: 'Une erreur s\'est produite. Contactez un administrateur.',
                        messageDuree: 0
                    });

                }
            });

            // Préparer les données des champs superficie
            $(window.b04terraiagricoleboise_superficies_imask).each(function(){
                // itérer dans plus qu'un input dans la pluspart des cas
                // this est le selecteur jq
                $(this).each(function(){
                    // this est l'objet dom (notre input de superficie)
                    $(this).val(this.imask.unmaskedValue);
                });
            });

            var options = {/*modeErreur: ModeSave.FICHE,*/ paramsSupp: {sauvegarde_complet: true}};
            saveWizardBlocs(callbackSaveWizardBlocs, options);
        }


        function initAdminMutation() {
            initWizardBlocs();

            // pour ne pas le sauvegarder
            //$('[name=div-src] > form').removeClass('blocForm');

            var bloc = $('[name=div-dest] > .blocForm');

            var idUe = $('#wizard').attr('id-ue');
            bloc.find('[name="no_dossier"]').prop('disabled', true).val(idUe);

            bloc.find('[name="nb_batiment"],[name="nb_etage"],[name="nb_logement"],[name="nb_chambre_locative"],[name="nb_local"],[name="aire_etage"]' +
                ',[name="lienPhysique"],[name="genreConstruction"],[name="annee_construction"],[name="mentionReelleEstimee"],[name="typeZonageAgricole"]').prop('disabled', true);

            if ($('form[code=00][id_model_instance=None]').length > 0) {
                blocsMarquerModifie();
            }

            $('.step-pane.active .btn-group label[name=label-src]').on('click', function () {
                $('[name=div-src]').hide();

                var idx = $(this).attr('index-div');
                $('[name=div-src][index-div=' + idx + ']').show();
            });

        }

        function saveAdminMutation(callback) {
            $('[name=div-src] > form').removeClass('blocForm');

            saveWizardBlocs(callback);

            $('[name=div-src] > form').removeClass('blocForm').addClass('blocForm');
        }


//---------------------------------------------------------------------
        /**
         * Fonction d'initialisation de l'étape de l'opération cadastrale
         * */
        function initInfoGeneraleOperationCadastrale() {

            var dateEvenementDatePicker = $('#frm-date-evenement').find('input[name="date_evenement"]');
            updateDateEvenementWizard();

            dateEvenementDatePicker.on('change', function () {
                updateDateEvenementWizard(true);
            });

            var evenementRemarque = $('#evenement-remarque').find('[name="remarque"]');
            evenementRemarque.on('change', function () {
                updateRemarqueWizard(true);
            });
            // mettre l'attribut 'bloc-editable' à 'True' pour chaque ligne de sous-bloc pour l'utiliser à la sauvegarde comme dans une fiche mais sans historicité
            $('.sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');

            // initialisation des sous-blocs
            init_change_event_sous_bloc();

            // initialisation des input file
            var organisation = securite.reqOrganisation();
            var documents = $('#document-operation-cadastrale').find('.section-document');
            $.each(documents.find('.ace-input-file'), function (idx, obj) {
                initAceInputFile($(obj), organisation, 'operation-cadastrale');
            });

            // $('#id-input-file-3').ace_file_input({
            //     style: 'well',
            //     btn_choose: 'Déposer ou sélectionner un fichier GeoJson',
            //     btn_change: null,
            //     no_icon: 'ace-icon fa fa-cloud-upload',
            //     droppable: true,
            //     thumbnail: 'small',
            //     preview_error: function (filename, error_code) {
            //
            //     }
            // }).on('change', function () {
            //
            // });
            //
            InitTable('table-operation-cadastrale', 7, [[1, 'desc']]);

        }

        /**
         * Fonction de sauvegarde de l'étape de l'opération cadastr.
         * */
        function saveInfoGeneraleOperationCadastrale(callback) {
            checkChangementDateEtSave(saveInfoGeneraleOperationCadastrale2, callback);
        }

        function saveInfoGeneraleOperationCadastrale2(callback) {
            var sections = $('#operation-cadastrale-infos-generales, #frm-date-evenement, #document-operation-cadastrale,#evenement-remarque');
            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var params = controlesFormulaires.serialiserFormulaire(currentForm);
                var idOperationCadastrale = $('#operation-cadastrale-infos-generales').attr('id-model-instance');
                var dateEvenementForm = currentForm.find('[name="date_evenement"]').val();

                //params.push({name: 'remarque', value: $('#wizard').attr('evenement-remarque')});
                if (idCurrentForm == 'frm-date-evenement') {
                    var idMunicipalite = $('#municipalite').val();

                    // On stocke les variables importantes pour les étapes suivantes.
                    if (dateEvenementForm.length == 10) { // Temporaire : utilisé pour mettre l'heure, les minutes et les secondes dans l'entête du wizard.
                        // dateEvenementForm += ' 15:00:00';
                        dateEvenementForm = dateEvenement;
                        $('#wizard').attr('date-evenement', dateEvenementForm);
                    }
                    params.push({
                        name: 'date_evenement', value: dateEvenementForm
                    });
                    $('#wizard').attr('id-municipalite', idMunicipalite);
                    var etapeProcessus = $('#modal-step-contents > .active').attr('data-id_processus');

                    var paramsOptionnels = [
                        {name: 'id_municipalite', value: idMunicipalite},
                        {name: 'id_type_evenement', value: $('#wizard').attr('id-type-evenement')},
                        {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                        {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                        {name: 'etapeProcessus', value: etapeProcessus},
                        {name: 'remarque', value: $('#wizard').attr('evenement-remarque')},
                    ];

                    var idUe = $('#wizard').attr('id-ue');
                    if (idUe != '') {
                        paramsOptionnels.push({name: 'id_ue', value: idUe});
                    }
                    var idNatureEvenement = $('#operation-cadastrale-infos-generales').find('[name="natureEvenement"]').val();
                    if (idNatureEvenement != '') {
                        paramsOptionnels.push({name: 'id_nature_evenement', value: idNatureEvenement});
                    }

                    paramsOptionnels = nettoyerParams(paramsOptionnels);
                    $.each(paramsOptionnels, function (idx, item) {
                        params.push(item);
                    });
                } else if (idCurrentForm == 'document-operation-cadastrale') {
                    var idMunicipalite = $('#municipalite').val() ? $('#municipalite').val() : '';
                    var idUe = $('#wizard').attr('id-ue') ? $('#wizard').attr('id-ue') : '';
                    var erreurFichier = currentForm.find('.ace-file-container.selected .ace-error').attr('erreur');
                    if (!erreurFichier) erreurFichier = '';
                    params.push(
                        {name: 'id_municipalite', value: idMunicipalite},
                        {name: 'erreur_fichier', value: erreurFichier},
                        {name: 'date_debut', value: $('#wizard').attr('date-evenement')} // prendre celui du wizard qui vient d'être ajouté par le 'frm-date-evenement'
                    );
                }

                if (idCurrentForm == 'frm-date-evenement' || idCurrentForm == 'document-operation-cadastrale') {
                    if (idOperationCadastrale != 'None') {
                        // passer le champ si le formulaire est en édition
                        params.push({name: 'id_operation_cadastrale', value: idOperationCadastrale});
                    }
                }

                return params;
            };
            var getChampUnique = function (currentForm, idCurrentForm) {
                if (idCurrentForm == 'document-operation-cadastrale') {
                    return {
                        unique_nom_champ: 'index_ligne',
                        unique_id_champ: $('#' + idCurrentForm).find('.sous-bloc-form').index(currentForm)
                    };
                }
                return {};
            };
            var getChampTransfert = function (idCurrentForm) {
                var retour = {};
                if (idCurrentForm == 'operation-cadastrale-infos-generales') {
                    retour.transfert_champ_source = 'id_operation_cadastrale';
                } else if (idCurrentForm == 'frm-date-evenement' || idCurrentForm == 'document-operation-cadastrale') {
                    retour.transfert_champ_destination = 'id_operation_cadastrale';
                }
                return retour;
            };
            var messageToast = {};
            sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, 1);

        }

        function initLocalisationUeOperationCadastrale() {


            // On initialise l'outil de recherche récupéré de l'Explorateur uniquement si l'ue n'existe pas car sinon on montre l'info générale de l'ue sélectionnée
            var idEvenement = $('#wizard').attr('id-evenement');
            if (idEvenement == '') {
                $('#modal-recherche').attr('recharger', 'oui'); // En provenance de l'Explorateur d'UE, on doit recharger sinon les initialisation ne se font pas.
                init_explorateur_ue_partage();
            }


            $('#municipalite').on('change', function () {
                $('#wizard').attr('id-municipalite', $(this).val());

                // Ceci permet entre autre de charger le listbox de voies publiques selon la municipalité
                var selecteur = $('#wizard').attr('id-municipalite');
                if (selecteur != '' && !!selecteur) {
                    var idMunicipalite = selecteur;
                    ouvrirRechercheExpUe(idMunicipalite);
                }
            });


            // On initialise les select2
            $('#modal-step-contents .form-horizontal').find('select').select2();

        }

        /**
         * Fonction de sauvegarde de l'étape de localisation des travaux du processus de permis.
         * */
        function saveLocalisationUeOperationCadastrale(callback) {
            checkEvenementFermePosterieurCycleOuvertEtSave(saveLocalisationUeOperationCadastrale2, callback, true);
        }

        function saveLocalisationUeOperationCadastrale2(callback) {

            if (typeof (callback) !== 'undefined') {
                var response = {};
                response.reponse = 'ok';
                callback(response);
            }
        }

        function initLocalisationUeOperationUe() {


            // On initialise l'outil de recherche récupéré de l'Explorateur uniquement si l'ue n'existe pas car sinon on montre l'info générale de l'ue sélectionnée
            var idEvenement = $('#wizard').attr('id-evenement');
            var idUe = $('#wizard').attr('id-ue');
            var dateEvenement = $('#wizard').attr('date-evenement');
            // $('#wizard').attr('attribut-generique', false);

            if (idEvenement == '') {
                $('#modal-recherche').attr('recharger', 'oui'); // En provenance de l'Explorateur d'UE, on doit recharger sinon les initialisation ne se font pas.
                init_explorateur_ue_partage();


            }

            $('#municipalite').on('change', function () {
                $('#wizard').attr('id-municipalite', $(this).val());

                // Ceci permet entre autre de charger le listbox de voies publiques selon la municipalité
                var selecteur = $('#wizard').attr('id-municipalite');
                if (selecteur != '' && !!selecteur) {
                    var idMunicipalite = selecteur;
                    ouvrirRechercheExpUe(idMunicipalite);
                }
            });

            // On initialise les select2
            $('#modal-step-contents .form-horizontal').find('select').select2();


            $('#creation-matricule').on('change', function () {
                if ($(this).prop("checked")) {
                    $("#wizard #critere-recherche *").prop('disabled', true);
                    $("#wizard #resultat-recherche *").prop('disabled', true);
                    $('#wizard').attr('attribut-generique', 'True');

                } else {
                    $("#wizard #critere-recherche *").prop('disabled', false);
                    $("#wizard #resultat-recherche *").prop('disabled', false);
                    $('#wizard').attr('attribut-generique', 'False');

                }

            });

            //********************************************************************************************
            // #6190, ajout des 2 boutons Création d'une unité d'évaluation Création d'une unité d'évaluation - bâtiment et Création d'une unité d'évaluation -local
            $('[name="creation_matricule_batiment"], #creation-matricule-batiment').on('change', function () {
                if ($(this).prop("checked")) {
                    // On obtiens le template des input batiment, local et de lots
                    OperationUeGetBatLocLot(idEvenement, idUe, dateEvenement, 'batiment', $('#wizard').attr('id-municipalite'));
                    $('#wizard').attr('attribut-generique', 'True');
                    $('#btn-wizard-suivant-terminer').prop('disabled', true);


                } else {
                    $("#operation-ue-batiment-local").empty();
                    $('#wizard').attr('attribut-generique', 'False');
                    $('#btn-wizard-suivant-terminer').prop('disabled', false);

                }
            });
        }

        function OperationUeGetBatLocLot(idEvenement, idUe, dateEvenement, typeCreation, idMunicipalite) {

            var params = {
                'idEvenement': idEvenement,
                'dateEvenement': dateEvenement,
                'idUe': idUe,
                'typeCreation': typeCreation,
                'idMunicipalite': idMunicipalite
            };

            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/operation-ue/creation-matricule-batiment-lot/",
                data: params,
                dataType: 'html',
                async: false,
                success: function (response) {

                    $("#operation-ue-batiment-local").html(response);
                }

            });
        }


        function saveLocalisationUeOperationUe(callback) {

            checkEvenementFermePosterieurCycleOuvertEtSave(saveLocalisationUeOperationUe2, callback);

        }


        function saveLocalisationUeOperationUe2(callback) {

            // Si une ue a déjà été sauvegardée alors on ne permet plus la sauvegarde.
            // TODO: On devrait plutôt rafraichir la page lors de la sauvegarde pour afficher la page en mode read-only

            var idEvenement = $('#wizard').attr('id-evenement');
            var idUe = $('#wizard').attr('id-ue');
            var dateEvenement = $('#wizard').attr('date-evenement');
            var idMunicipalite = $('#wizard').attr('id-municipalite');

            if (idEvenement === '') { // On permet la sauvegarde uniquement si aucune ue déjà sauvegardé

                if ($("#creation-matricule").prop("checked") && $("#annulation-matricule").prop("checked")) {
                    var erreur = "Vous devez saisir soit une création ou un annulation d'unité d'évaluation.";
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', erreur);
                    var response = {};
                    response.reponse = 'error';
                    callback(response);

                } else {

                    // Si création de matricule, on ne fait rien. On n'a pas encore de UE. Celui-ci sera déterminé a l'étape suivante
                    if ($("#creation-matricule").prop("checked")) {

                        // il faut s'assurer d'avoir un ville de sélectionner
                        var selecteur = $('#wizard').attr('id-municipalite');
                        if (selecteur == '') {

                            var erreur = "Vous devez saisir une municipalité avant de poursuivre à l'étape suivante.";
                            erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', erreur);
                            var response = {};
                            response.reponse = 'error';
                            callback(response);

                        } else {
                            if (typeof (callback) !== 'undefined') {
                                var response = {};
                                response.reponse = 'ok';
                                callback(response);
                            }
                        }

                    } else {

                        if ($("#annulation-matricule").prop("checked")) {

                            if (validateLocalisationTravauxPermis() === true) {

                                var callbackEvenement = function (response) {
                                    if (response.reponse != 'ok') {
                                        callback(response);
                                        return;
                                    }
                                    creerEvenementAnnulationParLocalisation(callback);
                                };
                                saveEvenementParLocalisation(callbackEvenement);


                                /*fenetreModal.modalMessage({
                                    titre: "L'unité d'évaluation sera supprimée du rôle ainsi que les lots la conformant. Ceci est irréversible. Êtes-vous certain de vouloir continuer ?",
                                    sansX: true,
                                    texteExplicatif: "",
                                    boutons: {
                                        "Oui": {
                                            label: " Oui ",
                                            id: "",
                                            class: "btn btn-success",
                                            action: function () {
                                                var callbackEvenement = function (response) {
                                                    if (response.reponse != 'ok') {
                                                        callback(response);
                                                        return;
                                                    }
                                                    creerEvenementAnnulationParLocalisation(callback);
                                                };
                                                saveEvenementParLocalisation(callbackEvenement);
                                            }
                                        },
                                        "Non": {
                                            label: " Non ",
                                            id: "",
                                            class: "btn",
                                            action: function () {
                                                var response = {};
                                                response.reponse = 'error';
                                                callback(response);

                                            }
                                        }
                                    }
                                });*/

                            } else {
                                if (typeof (callback) !== 'undefined') {
                                    var response = {};
                                    response.reponse = 'error';
                                    callback(response);
                                }
                            }

                        } else {

                            if (validateLocalisationTravauxPermis() === true) {
                                saveEvenementParLocalisation(callback);
                            } else {
                                if (typeof (callback) !== 'undefined') {
                                    var response = {};
                                    response.reponse = 'error';
                                    callback(response);
                                }
                            }
                        }
                    }
                }

            } else {

                //********************************************************************************************
                // #6190, Sauvegarde de la création

                if ($("#creation-matricule-batiment").prop("checked") && $("#creation-matricule-local").prop("checked")) {
                    var erreur = "Vous devez saisir soit une création de batiment ou une création de local.";
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', erreur);
                    var response = {};
                    response.reponse = 'error';
                    callback(response);

                } else {

                    if ($("#creation-matricule-batiment").prop("checked") || $("#creation-matricule-local").prop("checked")) {
                        // On sauvegarde la nouvelle unité d'évaluation

                        var tableau_lot = $('#exp-ue-lots').find('[id="operation-ue-lots"]');
                        var liste_lot = [];

                        $.each(tableau_lot, function () {
                            var arrayTableauLot = {};
                            arrayTableauLot["bool_lot_inclus"] = $(this).find('input').prop('checked');
                            arrayTableauLot["lot_no_lot"] = $(this).find('[name="lot_no_lot"]').text();
                            liste_lot.push(arrayTableauLot);
                        });

                        var params = {
                            'idEvenement': idEvenement,
                            'dateEvenement': dateEvenement,
                            'idUe': idUe,
                            'idMunicipalite': idMunicipalite,
                            'noBatiment': $("#operation-ue-no-batiment").val(),
                            'noLocal': $("#operation-ue-no-local").val(),
                            'listeLot': JSON.stringify(liste_lot)
                        };

                        $.ajax({
                            type: "GET",
                            url: "/gestion-roles/tenue-a-jour/operation-ue/sauvegarde-matricule-batiment-lot/",
                            data: params,
                            dataType: 'json',
                            async: false,
                            success: function (response) {

                                if (response.response == 'ok') {

                                    // On change le id-ue dans les paramètres du wizard
                                    $('#wizard').attr('id-ue', response.id_ue);
                                    $('#creation-matricule-batiment').prop("checked", false);
                                    $('#creation-matricule-local').prop("checked", false);
                                    $("#operation-ue-batiment-local").empty();
                                    updateEnteteWizard();

                                    $('#modal-step2').attr('recharger', 'oui');
                                    var etapeProcessus = $('.steps').find('.active').attr('data-id_processus');
                                    var etapeOrdre = $('.steps').find('.active').attr('data-step');
                                    chargerEtapeDynamique(etapeProcessus, etapeOrdre);

                                    if (typeof (callback) !== 'undefined') {

                                        infos.ajouterMessageToast({
                                            message: response.message,
                                            messageDuree: 1500,
                                            icone: 'fa-check-circle-o',
                                            iconeCouleur: 'green'
                                        });
                                        callback({reponse: 'ok'});
                                    }
                                } else {

                                    infos.ajouterMessageToast({
                                        message: response.message,
                                        messageDuree: 3000,
                                        messageCouleur: "red",
                                        icone: 'fa-check-circle-o',
                                        iconeCouleur: 'red'
                                    });
                                    callback({reponse: 'error'});
                                }

                            }
                        });

                        if (typeof (callback) !== 'undefined') {
                            callback({reponse: 'ok'});
                        }
                    } else {
                        if (typeof (callback) !== 'undefined') {
                            callback({reponse: 'ok'});
                        }
                    }
                }
            }
        }


        function validateLotSDC() {

            var cadastreValide = false;

            var dateEvenement = $('#wizard').attr('date-evenement');
            //var idUe = $('#wizard').attr('id-ue');

            var elements = $('.step-pane.active #div-resultat').find('input:checked').parents('a');

            if (elements.length > 0) {
                var element = elements[0];
                var idUe = typeof ($(element).attr('id-ue')) === 'undefined' ? $(element).val() : $(element).attr('id-ue');
            }

            var params = {
                'dateEvenement': dateEvenement,
                'idUe': idUe
            };


            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/annulation-ue/validate-lot-sdc/",
                data: params,
                dataType: 'html',
                async: false,
                success: function (response) {

                    if (response == 'ok') {
                        cadastreValide = true;
                    }
                }
            });

            return cadastreValide;

        }


        function creerEvenementAnnulationParLocalisation(callback) {

            var idMunicipalite = $('#municipalite').val();
            var dateEvenement = $('#wizard').attr('date-evenement');
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            var idUe = $('#wizard').attr('id-ue');
            var idProcessus = $('#wizard').attr('id-processus');

            var params = {
                'idMunicipalite': idMunicipalite,
                'dateEvenement': dateEvenement,
                'idTypeEvenement': idTypeEvenement,
                'idUe': idUe,
                'idProcessus': idProcessus
            };

            var response = {};
            response.reponse = 'ok';
            var cadastreInvalide = false;

            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/annulation-ue/supprimer/",
                data: params,
                dataType: 'html',
                async: false,
            });
            jqxhr
                .done(function (reponse) {
                    if (reponse == 'ok') {
                        infos.ajouterMessageToast({
                            message: "L'unité d'évaluation a été supprimée avec succès",
                            messageDuree: 0,
                            icone: 'fa-check-circle-o',
                            iconeCouleur: 'green'
                        });
                    } else {
                        infos.ajouterMessageToast({
                            message: "Erreur de suppression de l'unité d'évaluation",
                            messageDuree: 5000,
                            messageCouleur: "red"
                        });
                    }

                });
            jqxhr
                .fail(function (xhr, textStatus, errorThrown) {
                    infos.ajouterMessageToast({
                        message: "Erreur de suppression de l'unité d'évaluation",
                        messageDuree: 5000,
                        messageCouleur: "red"
                    });
                });

            if (typeof (callback) !== 'undefined') {
                callback(response);
            }

            return cadastreInvalide;
        }

        function initRenovationCadastrale() {

            $('#id-input-file-3').ace_file_input({
                style: 'well',
                btn_choose: 'Déposer ou sélectionner un fichier GeoJson',
                btn_change: null,
                no_icon: 'ace-icon fa fa-cloud-upload',
                droppable: true,
                thumbnail: 'small',
                preview_error: function (filename, error_code) {

                }
            }).on('change', function () {

            });
        }

        // # TODO: OBSOLETE? (les 3 suivantes + leurs appels)
        function initOperationUeTraitement() {
            //console.log('initOperationUeTraitement');

        }

        function saveOperationUeTraitement() {
            //console.log('saveOperationUeTraitement');
        }


        function saveRenovationCadastrale() {
            //console.log('saveRenovationCadastrale');
        }


        function initInfoGeneraleOperationUe() {

            var dateEvenementDatePicker = $('#frm-date-evenement').find('input[name="date_evenement"]');
            updateDateEvenementWizard();

            dateEvenementDatePicker.on('change', function () {
                updateDateEvenementWizard(true);
            });

            var evenementRemarque = $('#evenement-remarque').find('[name="remarque"]');
            evenementRemarque.on('change', function () {
                updateRemarqueWizard(true);
            });
            // mettre l'attribut 'bloc-editable' à 'True' pour chaque ligne de sous-bloc pour l'utiliser à la sauvegarde comme dans une fiche mais sans historicité
            $('.sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');

            // initialisation des sous-blocs
            init_change_event_sous_bloc();

            // initialisation des input file
            var organisation = securite.reqOrganisation();
            var documents = $('#document-operation-ue').find('.section-document');
            $.each(documents.find('.ace-input-file'), function (idx, obj) {
                initAceInputFile($(obj), organisation, 'operation-ue');
            });

        }


        function saveInfoGeneraleOperationUe(callback) {
            checkDateDeJour(saveInfoGeneraleOperationUe2, callback);
        }

        function saveInfoGeneraleOperationUe2(callback) {
            var sections = $('#operation-ue-infos-generales, #frm-date-evenement, #document-operation-ue, #evenement-remarque');
            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                var params = controlesFormulaires.serialiserFormulaire(currentForm);
                var idOperationUe = $('#operation-ue-infos-generales').attr('id-model-instance');
                var dateEvenementForm = currentForm.find('[name="date_evenement"]').val();
                //params.push({name: 'remarque', value: $('#wizard').attr('evenement-remarque')});
                if (idCurrentForm == 'frm-date-evenement') {

                    var idMunicipalite = $('#municipalite').val();

                    // On stocke les variables importantes pour les étapes suivantes.

                    if ($('#wizard').attr('id-evenement') == '') {
                        if (dateEvenementForm.length == 10) { // Temporaire : utilisé pour mettre l'heure, les minutes et les secondes dans l'entête du wizard.
                            dateEvenementForm += ' 15:00:00';
                            $('#wizard').attr('date-evenement', dateEvenementForm);
                        }
                    } else {
                        dateEvenementForm = $('#wizard').attr('date-evenement');
                    }

                    params.push({
                        name: 'date_evenement', value: dateEvenementForm
                    });
                    /*params.push({
                 name: 'remarque', value: remarque
                 });*/
                    $('#wizard').attr('id-municipalite', idMunicipalite);
                    var etapeProcessus = $('#modal-step-contents > .active').attr('data-id_processus');

                    var paramsOptionnels = [
                        {name: 'id_municipalite', value: idMunicipalite},
                        {name: 'id_type_evenement', value: $('#wizard').attr('id-type-evenement')},
                        {name: 'id_user_assigne', value: $('#wizard').attr('id-user-assigne')},
                        {name: 'id_statut_evenement', value: $('#wizard').attr('id-statut-evenement')},
                        {name: 'etapeProcessus', value: etapeProcessus},
                        {name: 'remarque', value: $('#wizard').attr('evenement-remarque')},
                    ];

                    var idUe = $('#wizard').attr('id-ue');
                    if (idUe != '') {
                        paramsOptionnels.push({name: 'id_ue', value: idUe});
                    }
                    var idNatureEvenement = $('#operation-ue-infos-generales').find('[name="natureEvenement"]').val();
                    if (idNatureEvenement != '') {
                        paramsOptionnels.push({name: 'id_nature_evenement', value: idNatureEvenement});
                    }

                    paramsOptionnels = nettoyerParams(paramsOptionnels);
                    $.each(paramsOptionnels, function (idx, item) {
                        params.push(item);
                    });
                } else if (idCurrentForm == 'document-operation-ue') {
                    var idMunicipalite = $('#municipalite').val() ? $('#municipalite').val() : '';
                    var idUe = $('#wizard').attr('id-ue') ? $('#wizard').attr('id-ue') : '';
                    var erreurFichier = currentForm.find('.ace-file-container.selected .ace-error').attr('erreur');
                    if (!erreurFichier) erreurFichier = '';
                    params.push(
                        {name: 'id_municipalite', value: idMunicipalite},
                        {name: 'erreur_fichier', value: erreurFichier},
                        {name: 'date_debut', value: $('#wizard').attr('date-evenement')} // prendre celui du wizard qui vient d'être ajouté par le 'frm-date-evenement'
                    );
                }

                if (idCurrentForm == 'frm-date-evenement' || idCurrentForm == 'document-operation-ue') {
                    if (idOperationUe != 'None') {
                        // passer le champ si le formulaire est en édition
                        params.push({name: 'id_operation_ue', value: idOperationUe});
                    }
                }

                return params;
            };
            var getChampUnique = function (currentForm, idCurrentForm) {
                if (idCurrentForm == 'document-operation-ue') {
                    return {
                        unique_nom_champ: 'index_ligne',
                        unique_id_champ: $('#' + idCurrentForm).find('.sous-bloc-form').index(currentForm)
                    };
                }
                return {};
            };
            var getChampTransfert = function (idCurrentForm) {
                var retour = {};
                if (idCurrentForm == 'operation-ue-infos-generales') {
                    retour.transfert_champ_source = 'id_operation_ue';
                } else if (idCurrentForm == 'frm-date-evenement' || idCurrentForm == 'document-operation-ue') {
                    retour.transfert_champ_destination = 'id_operation_ue';
                }
                return retour;
            };

            var callback2 = function (response) {
                if (response.reponse == 'ok') {
                    updateEnteteWizard();
                }
                callback(response);
            };

            var messageToast = {};
            sauvegarderFormulairesCoteServeur(callback2, sections, getParams, getChampUnique, getChampTransfert, messageToast, 1);

        }

        function initOperationUeOperationUe() {
            var pageCourante = $('.step-pane.active');
            if (pageCourante.find('[name=ue-identification-form-set]').length) {
                initFormCondo(pageCourante);
                wait.stop('contenu', false);
                return;
            }

            // #16195 : désactiver le bouton suivant quand l'étape est bloquée.
            if (pageCourante.find('#wizard-ne-s-applique-pas-bloquant').length) {
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
            }

            var idMunicipalite = $('#wizard').attr('id-municipalite');
            var dateEvenement = $('#wizard').attr('date-evenement');
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            var idProcessus = $('#wizard').attr('id-processus');
            var idEvenement = $('#wizard').attr('id-evenement');
            var creationMatricule = $('#wizard').attr('attribut-generique');

            // FB : Je commente ce code : Mais à quoi ça sert à part de recharger le tableau de tenue à jour s'il est
            // affiché? Peut-être c'est pour le tableau de l'Opération UE...
            // refreshDatatables();

            // 15697
            var deplacementBail = $("#deplacement-bail").val();

            if (deplacementBail == 'True') {
                // Vérifie si une map existe
                if ($("#carte-apres").length != 0) {
                    operationUeChargementCarte(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, idProcessus, isModeReadOnly, creationMatricule, deplacementBail);
                }
                return;
            }

            var isModeReadOnly = false;
            // si creation de matricule, on affiche juste la carte après en pleine grandeur avec 2 boutons pour positionner un matricule
            if (creationMatricule == 'True') {

                if (idEvenement != '') {
                    isModeReadOnly = true;
                }
                // Vérifie si une map existe
                if ($("#carte-apres").length != 0) {
                    operationUeChargementCarte(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, idProcessus, isModeReadOnly, creationMatricule, 'False');
                }

            } else {

                isModeReadOnly = $('#wizard').attr('mode') == 'r';

                if (!isModeReadOnly) {
                    isModeReadOnly = valideEvenementLieFerme(idEvenement);
                }

                // Vérifie si une map existe
                if ($("#carte-apres").length != 0) {
                    creationMatricule = false;

                    // ET Chargement opération cadastrale à l'ouverture de l'étape 3 2019-01-15
                    if (idTypeEvenement == '5') {
                        isModeReadOnly = chargement_operation_cadastrale(idProcessus, idMunicipalite, idEvenement, dateEvenement);
                    }
                    if (idTypeEvenement == '32') {
                        isModeReadOnly = validerOperationUePartieLot(idEvenement)
                    }
                    operationUeChargementCarte(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, idProcessus, isModeReadOnly, creationMatricule, 'False');

                }

                if ($('#operation-ue-operation').attr('recharger_mutation') == 'True') {
                    // forcer l'étape 3 de la mutation à se recharger
                    $('#modal-step3').attr('recharger', 'oui');
                }

                // cas d'un cadastre vertical
                if ($('#exp-ue-lots-cadastre-vertical-apres').length != 0) {
                    // forcer l'étape 4 de la mutation à se recharger
                    $('#modal-step4').attr('recharger', 'oui');

                    $('[name="lot_id_ue_destination"]').select2({
                        dropdownAutoWidth: 'true',
                        allowClear: true,
                        placeholder: '',
                    });

                    // si recharger_mutation = True, alors ça veut dire qu'une sauvegarde sera obligé à cette étape
                    // ça arrive quand on modifie les lots à l'étape 2 ou quand on passe la 1ère fois à l'étape 4
                    if ($('#operation-ue-operation').attr('recharger_mutation') == 'True') {
                        $('#exp-ue-lots-cadastre-vertical-apres').find('[id="mutation-ue-lots-cadastre-vertical"]').attr('modifie', 'True');
                        $('#btn-wizard-save').prop('disabled', false);
                    }

                    var tableauLotsAvant = $('#exp-ue-lots-cadastre-vertical').find('[id="mutation-ue-lots-cadastre-vertical"]');
                    var tableauLotsApres = $('#exp-ue-lots-cadastre-vertical-apres').find('[id="mutation-ue-lots-cadastre-vertical"]');

                    $('[name="lot_id_ue_destination"]').off('change').on('change', function () {
                        var idUeSelected = $(this).select2('val');

                        var matriculeTrouve = '';
                        // on veut afficher le matricule de l'ue sélectionnée au changement de sélection
                        $.each(idUeSelected, function (index, valeur) {
                            var ueLotAvant = tableauLotsAvant.find('[name="lot_id_ue"]').filter(function () {
                                return $(this).text() == valeur;
                            }).first().closest('[id="mutation-ue-lots-cadastre-vertical"]');

                            matriculeTrouve += ueLotAvant.find('[name="lot_matricule"]').text();
                            if (index < idUeSelected.length - 1) matriculeTrouve += '<br>';
                        });

                        var lotMatriculeApres = $(this).closest('[id="mutation-ue-lots-cadastre-vertical"]').find('[name="lot_matricule"]');
                        lotMatriculeApres.html(matriculeTrouve);

                        // remettre les sélections saisies, vu qu'ils arrivent ici ordonnés. Alors les matricules
                        // seront dans le même ordre que les ues
                        $(this).select2('val', idUeSelected);
                    });

                    // regrouper les ues des lots ayant le même matricule_source_lot
                    $.each(tableauLotsApres, function () {
                        var matriculeSourceLot = $(this).find('[name="lot_matricule_source_lot"]').text();
                        var idUeDestinationSelect = $(this).find('[name="lot_id_ue_destination"]');
                        var ligneAVerifier = $(this);

                        tableauLotsApres.not($(this)).not('[supprimer-ligne=""]').not('[garder-ligne]').filter(function () {
                            if ($(this).find('[name="lot_matricule_source_lot"]').text() == matriculeSourceLot) {
                                var idUeDestinationLigne = $(this).find('[name="lot_id_ue_destination"]').select2('val');
                                var valeur = idUeDestinationSelect.select2('val').concat(idUeDestinationLigne);
                                idUeDestinationSelect.select2('val', valeur, true);
                                // indiquer que la ligne en double doit être supprimée
                                $(this).attr('supprimer-ligne', '');
                                // indiquer que la ligne sur laquelle on commence la vérification des doublons doit être gardée
                                ligneAVerifier.attr('garder-ligne', '');
                                return true;
                            }
                        });
                    });
                    tableauLotsApres.filter('[supprimer-ligne=""]').remove();
                    tableauLotsApres.filter('[garder-ligne=""]').removeAttr('garder-ligne');
                }
            }

            pageCourante = $('.step-pane.active');
            var checkTous = pageCourante.find('[name=checkbox-ue-tous]');
            var checkUEs = pageCourante.find('[name=bool_ue_inclus]');

            initCheckboxTous(checkTous, checkUEs);
            wait.stop('contenu', false);
        }

        function validerOperationUePartieLot(idEvenement) {
            var isModeReadOnly = false;
            var params = {
                'idEvenement': idEvenement,
            };

            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/operation-ue/valider-partie-lot/",
                data: params,
                async: false,
                dataType: 'json',
                success: function (response) {
                    isModeReadOnly = response.est_partie_lot;
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (!(xhr.status >= 200 && xhr.status < 300)) {
                        infos.ajouterMessageToast({
                            message: 'Une erreur s\'est produite. Contactez un administrateur.',
                            messageDuree: 0
                        });
                        // TODO : logguer les erreurs
                    }
                }
            });
            return isModeReadOnly
        }

        function chargement_operation_cadastrale(idProcessus, idMunicipalite, idEvenement, dateEvenement) {

            var isModeReadOnly = false;
            var params = {
                'idProcessus': idProcessus,
                'idMunicipalite': idMunicipalite,
                'idEvenement': idEvenement,
                'dateEvenement': dateEvenement
            };

            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/operation-cadastrale/chargement-commande-2/",
                data: params,
                async: false,
                dataType: 'json',
                success: function (response) {
                    if (response == true) {
                        isModeReadOnly = true;
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (!(xhr.status >= 200 && xhr.status < 300)) {
                        infos.ajouterMessageToast({
                            message: 'Une erreur s\'est produite. Contactez un administrateur.',
                            messageDuree: 0
                        });
                        // TODO : logguer les erreurs
                    }
                }
            });

            return isModeReadOnly;

        }

        function valideEvenementLieFerme(idEvenement) {

            var isModeReadOnly = false;
            var params = {
                'idEvenement': idEvenement
            };

            $.ajax({
                type: "GET",
                url: "/gestion-roles/tenue-a-jour/operation-ue/valide-evenement-lie-ferme/",
                data: params,
                async: false,
                dataType: 'html',
                success: function (response) {

                    if (response == 'true') {
                        isModeReadOnly = true;
                    }
                }
            });
            return isModeReadOnly;
        }


        function saveOperationUeOperationUe(callback) {
            var pageCourante = $('.step-pane.active');
            if (pageCourante.find('[name=ue-identification-form-set]').length) {
                saveCondos(pageCourante, callback);
                return;
            }


            var idMunicipalite = $('#wizard').attr('id-municipalite');
            var idEvenement = $('#wizard').attr('id-evenement');
            var idUe = $('#wizard').attr('id-ue');
            var dateEvenement = $('#wizard').attr('date-evenement');
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            var creationMatricule = $('#wizard').attr('attribut-generique');

            // 15697
            var deplacementBail = $("#deplacement-bail").val();
            if (deplacementBail == 'True' && $('#table-apres-operation-cadastrale').attr('modifie') == 'True') {
                saveDeplacementBail(idMunicipalite, dateEvenement, idTypeEvenement, idEvenement, idUe, callback);
                return;
            }


            if (creationMatricule == 'True') {

                if (['32'].indexOf(idTypeEvenement) > -1 && $('#table-apres-operation-cadastrale').attr('modifie') == 'True') {
                    // Il ne faut pas que le bail tombe dans une zone urbanisé (doit pas intersecté de lot cadastre)
                    creationMatriculeUeLot(idMunicipalite, dateEvenement, idTypeEvenement, callback);
                    // à la fin de la sauvegarde, $('#table-apres-operation-cadastrale').attr('modifie') == 'False)
                } else {
                    // si sauvegarder et $('#table-apres-operation-cadastrale').attr('modifie') == 'True')
                    // on veux savoir s'il y'a une UE qui a été créé
                    if ($('#id-ue-creation').text() == '' && $('#id-ue').text() == '') {

                        infos.ajouterMessageToast({
                            message: "Vous devez créer une unité d\'évaluation",
                            messageDuree: 2500,
                            messageCouleur: 'red'
                        }); //1500 = 1,5 secondes
                        callback({reponse: 'pas_ok'});
                    } else {
                        callback({reponse: 'ok'});
                    }
                }
            } else {

                var estCadastreVertical = $('#exp-ue-lots-cadastre-vertical-apres').length != 0;
                var estVentePartieLot = ($('.step-pane.active [name=checkbox-ue-tous]').length > 0);

                var response;
                //Si pas de carte, cela veut-dire que l'on ne retrouve pas le matricule sur la matrice
                if ($("#carte-apres").length != 0 || estCadastreVertical || estVentePartieLot) {

                    // si aucune
                    if (!estCadastreVertical && !estVentePartieLot && !isOperationUE()) {

                        if (['5'].indexOf(idTypeEvenement) > -1 && $('#table-apres-operation-cadastrale').attr('modifie') == 'True') {
                            //var response = {reponse: 'ok'};
                            //callback(response);
                            valideOperationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback);
                        } else {
                            infos.ajouterMessageToast({
                                message: "Vous devez scinder ou regrouper une unité d\'évaluation",
                                messageDuree: 2500,
                                messageCouleur: 'red'
                            }); //1500 = 1,5 secondes
                            response = {reponse: 'pas_ok'};
                            callback(response);
                        }

                    } else {
                        var ueLotsModifie;
                        var estModifie = $('#table-apres-operation-cadastrale').attr('modifie') == 'True';
                        if (estCadastreVertical) {
                            ueLotsModifie = $('#exp-ue-lots-cadastre-vertical-apres').find('#mutation-ue-lots-cadastre-vertical[modifie=True]');
                            estModifie = ueLotsModifie.length > 0;
                        }
                        if (estVentePartieLot) {
                            var ueLotsModifie = $('.step-pane.active #mutation-ue-partie-lot[modifie=True]');
                            estModifie = ueLotsModifie.length > 0;
                        }
                        //ET 2019-01-22, ajout de l'opération cadastrale
                        if (['2', '5', '32'].indexOf(idTypeEvenement) > -1 && estModifie) {
                            valideOperationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback, estCadastreVertical);
                        } else {
                            response = {reponse: 'ok'};
                            callback(response);
                        }
                    }


                    if (idTypeEvenement == '2') {
                        // forcer des étapes de la mutation à se recharger
                        var etapes = [2, 3];
                        for (var i = 0; i < etapes.length; i++) {
                            $('#modal-step' + etapes[i]).attr('recharger', 'oui');
                        }
                    }

                } else {
                    response = {reponse: 'ok'};
                    callback(response);
                }
            }
        }

//---------------------------------------------------------------------


        function initInfoGeneraleCorrectionMineure() {
            updateDateEvenementWizard();

            // On initialise seulement les select2 pour la section d'informations générales et non pour le sous-bloc des documents
            $('#accordion-infos-generales').find('select').select2();

            var blocsContainer = $('.step-pane.active');

            var idEvenement = $('#wizard').attr('id-evenement');
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');

            $('#municipalite').on('change', function () {
                $('#wizard').attr('id-municipalite', $(this).val());

                // Ceci permet entre autre de charger le listbox de voies publiques selon la municipalité
                var selecteur = $('#wizard').attr('id-municipalite');
                if (selecteur != '' && !!selecteur) {
                    var idMunicipalite = selecteur;
                    var params1 = {'id_municipalite': idMunicipalite, 'id_type_evenement': idTypeEvenement};
                    //gérer les evenements en lots dans le cas ou on est en cours de fermeture de cycle
                    var jqxhr = $.ajax({
                        type: "POST",
                        url: "/gestion-roles/fermeture-cycle/validation-municipalite/",
                        dataType: 'json',
                        async: false,
                        data: params1
                    });

                    jqxhr.done(function (response) {
                        if (response.reponse == 'error') {
                            fenetreModal.fermerModal('modal-wizard-evenement');

                            infos.ajouterMessageToast({
                                message: response.validation,
                                messageDuree: 0,
                                messageCouleur: 'red'
                            });

                        } else {


                            // charge les voie publique à l'ouverture de la fenêtre recherche, s'il ya déjà eu une ville de sélectionné
                            if (idMunicipalite != null && idMunicipalite != '') {
                                if (idTypeEvenement == 9) {
                                    rafraichirCorrectionMineureUe();
                                }

                                if (idTypeEvenement == 33) {
                                    //chargerVoiePubliqueExpUe(idMunicipalite, $('#voiePublique'));
                                    rafraichirComboVoiePublique();
                                    $('#accordion-nature-173').show();
                                }
                                if (idTypeEvenement == 34) {
                                    $('#accordion-nature-123').show();
                                }
                                if ($.inArray(idTypeEvenement, ['36', '67']) != -1) {
                                    $('#accordion-proprietaire-recherche-cm').show();
                                }

                                fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));

                            }
                        }
                    });
                    jqxhr.fail(function (jqxhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur de création de l'événement",
                            messageDuree: 1500,
                            messageCouleur: 'red'
                        });
                    });


                }

            });

            var idUe = $('#wizard').attr('id-ue');
            if (idTypeEvenement == 9) {
                if (idUe) {
                    $('#municipalite').prop('disabled', 'true');
                }
            }


            $('[name=date_evenement]').off('change').on('change', function (e) {

                var dateSaisie = $(this).val();
                // si la date est saisie manuellement, il arrive qu'on ait des 'souligné venant du masque. Alors, il ne faut pas utiliser la date.
                // on a mit une protection au serveur mais ça fait des trucs bizarres à l'interface. On va le trapper ici à la place.
                if (dateSaisie.indexOf('_') == -1) {
                    updateDateEvenementWizard(true);

                    if (idTypeEvenement == 33) {
                        rafraichirComboVoiePublique();
                    }

                    rafraichirCorrectionMineureUe();
                }
            });

            $('#voiePublique').on('change', function () {
                rafraichirCorrectionMineureUe();
            });

            // mettre l'attribut 'bloc-editable' à 'True' pour chaque ligne de sous-bloc pour l'utiliser à la sauvegarde comme dans une fiche mais sans historicité
            $('#accordion-infos-generales .sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');

            function proprietaireChanged() {

                var proprioParUeCoche = [];
                var containerProprios;
                if (idTypeEvenement == 36) {
                    // garder les cases cochées des propriétaires
                    containerProprios = $('#accordion-creation-adresse-proprietaire-proprietaires-lies');
                    var propriosLiesChecked = containerProprios.find('[name="checkbox-proprio"]:checked');
                    $.each(propriosLiesChecked, function (idx, valeur) {
                        proprioParUeCoche.push({
                            id_ue: $(this).closest('.div-table-ligne').attr('id_ue'),
                            id_proprietaire: $(this).closest('.div-table-ligne').attr('id_proprietaire'),
                            bool_meme_adresse_ue: $(this).closest('.div-table-ligne').find('[name="checkbox-api-apres"]').is(':checked')
                        });
                    });
                }

                rafraichirCorrectionMineureUe();

                if (idTypeEvenement == 36) {
                    // remettre les cases cochées des propriétaires
                    containerProprios = $('#accordion-creation-adresse-proprietaire-proprietaires-lies');
                    $.each(proprioParUeCoche, function (idx, valeur) {
                        var ligne = containerProprios.find('.div-table-ligne' +
                            '[id_proprietaire="' + valeur.id_proprietaire + '"][id_ue="' + valeur.id_ue + '"]');
                        ligne.find('[name="checkbox-proprio"]').click();
                        ligne.find('[name="checkbox-api-apres"]').prop('checked', valeur.bool_meme_adresse_ue);
                    });
                }

                if (idTypeEvenement == 67) {
                    if ($('[name="checkbox-proprio"]:enabled').length == 0) {
                        $('#checkbox-proprio-tous').prop('disabled', true);
                        $('#accordion-nature-122').hide();
                        $('#btn-wizard-suivant-terminer').prop('disabled', true);
                    }
                }

                if (['36', '67'].includes(idTypeEvenement)) {
                    // ne pas voir la section du nom de propriétaire dans une correction d'adresse de propriétaire
                    $('#accordion-creation-proprietaire').parent().hide();
                }
            }

            if (idTypeEvenement == 34) {
                var comboAdresse = $('#contenu-proprietaire-recherche [name=adresse_complete]');
                var adresse_complete = comboAdresse.val();
                var adresseAffichee = adresse_complete;
                var complement = $('#contenu-proprietaire-recherche [name=complement]').val();
                if (complement) {
                    adresseAffichee += ', ' + complement;
                }
                var hidProprietaire = $('#contenu-proprietaire-recherche [name=proprietaire]');
                var idProprietaire = hidProprietaire.val();

                initRechercheProprietaire(function () {
                    //rafraichirCorrectionMineureUe();
                });

                var contenuRechercheProprio = $('.avant-container #contenu-proprietaire-recherche');
                var statutProprietaire = contenuRechercheProprio.find('[name="statutProprietaire"]');
                disableNomPrenomProprio(statutProprietaire, contenuRechercheProprio);

                statutProprietaire.on('change', function () {
                    disableNomPrenomProprio($(this), contenuRechercheProprio);
                });

                comboAdresse.val(adresseAffichee);
                // garder l'adresse sans le complément pour l'afficher dans 'adresse postale' du cessionnaire
                comboAdresse.attr('adresse-complete', adresse_complete);
                hidProprietaire.val(idProprietaire);

                if (!idEvenement && idUe) {
                    proprietaireChanged(); // comboNom.trigger('change'); // raffraichir le champ adresse
                }
            }

            if (idTypeEvenement == 36) {
                var containerRechercheProprio = $('#proprietaire-recherche-cm');
                initProprietaireRechercheSelect2(containerRechercheProprio);
            }

            if (idTypeEvenement == 67) {
                $('#frm-date-evenement').hide();
                $('#accordion-infos-generales').hide();
                $('#wizard').attr('id-ue', '');

                var champ = $('[name="proprietaire_nom_complet"]');
                var paramsSupp = {};
                var callbackParamsSupp = function () {
                    return {
                        id_municipalite: $('#municipalite').val(),
                        remplacer_id_par_texte: true
                    };
                };
                initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-proprietaire", true, true, false, paramsSupp, callbackParamsSupp);

                if (idUe) {
                    initCorrectionMineureAdressePostale();
                    initComplement();
                    rafraichirCorrectionMineureUe();
                }
                // ne pas voir la section du nom de propriétaire dans une correction d'adresse de propriétaire
                $('#accordion-creation-proprietaire').parent().hide();
            }

            $('#nature_123 .avant-container').find('[name="nom_legal"], [name="prenom"]').on('change', function () {
                proprietaireChanged();
            });

            $('[name="proprietaire_nom_complet"]').on('change', function () {
                proprietaireChanged();
            });

            if (idTypeEvenement == 36 && idEvenement) {
                initCorrectionMineureAdressePostale();
                initComplement();

                var modeReadOnly = $('#wizard').attr('mode') == 'r';
                var containerProprios = $('#accordion-creation-adresse-proprietaire-proprietaires-lies');
                containerProprios.find('[name="checkbox-utiliser-adresse"]').prop('disabled', modeReadOnly);
                containerProprios.find('[name="checkbox-utiliser-adresse"]').parent().find('.checkmark_square_down').attr('disabled', modeReadOnly);
                $('[name="no_correction_mineure"]').prop('disabled', modeReadOnly);
            }

            initWizardBlocs();

            $('#voiePublique').select2();

            if ($('#municipalite').val() != '' && !idEvenement) {
                $('#municipalite').trigger('change');
            }
        }

        function getDateEvenementEtape1() {
            var dateEvenement = $('#frm-date-evenement [name="date_evenement"]').val();
            //var dateEvenement = $('#wizard').attr('date-evenement');
            if (dateEvenement.length == 10) {
                dateEvenement += ' 15:00:00';
                $('#wizard').attr('date-evenement', dateEvenement);
            }

            return dateEvenement;
        }

        function rafraichirComboVoiePublique() {
            var idMunicipalite = $('#wizard').attr('id-municipalite'); // Number(selecteur);

            if (idMunicipalite != null && idMunicipalite != '') {
                var dateEvenement = getDateEvenementEtape1();

                var idEvenement = $('#wizard').attr('id-evenement');
                if (idEvenement != '' && idEvenement != '0') {
                    dateEvenement = null;
                }

                var contientUe = null;
                if (!idEvenement) {
                    contientUe = $('#wizard').attr('id-ue') || null;
                }

                var combo = $('#voiePublique');
                var val = combo.val();

                var callback = function () {
                    if (combo.find("option[value='" + val + "']").val() !== undefined) {
                        combo.val(val);
                    }

                    if (contientUe) {
                        var options = combo.find("option[contientUe='1']");
                        if (options.length == 1) {
                            var val = options.attr('value');
                            combo.val(val).trigger("change");
                        } else {
                            $('#wizard').attr('id-ue', ''); // ne pas envoyer ce UE au serveur quand on va saver
                        }
                    }
                };
                chargerVoiePubliqueExpUe(idMunicipalite, combo, dateEvenement, contientUe, callback);
            }
        }

        function rafraichirCorrectionMineureUe() {
            var params = {};
            params.id_municipalite = $('#wizard').attr('id-municipalite');
            params.id_type_evenement = $('#wizard').attr('id-type-evenement');
            params.id_user_assigne = $('#wizard').attr('id-user-assigne');
            params.id_evenement = $('#wizard').attr('id-evenement');
            params.id_processus = $('#wizard').attr('id-processus');
            params.id_ue = $('#wizard').attr('id-ue');

            params.date_evenement = $('#wizard').attr('date-evenement');
            params.date_dernier_statut = moment().format('YYYY-MM-DD HH:mm:ss');
            params.etapeProcessus = parseInt($('#modal-step-contents > .active').attr('data-id_processus')); // On save l'étape suivante puisque celle en cours est complétée
            params.statutEvenement = $('#wizard').attr('id-statut-evenement');
            params.id_voie_publique = $('#voiePublique').val();
            params.id_proprietaire = $('[name=proprietaire]').val();
            var proprietaireNomComplet = $('[name="proprietaire_nom_complet"]').select2('val');
            if (proprietaireNomComplet.length && typeof(proprietaireNomComplet) == 'string') {
                // quand le sélecteur n'est pas à multiples choix, alors convertir en array pour la suite du code
                proprietaireNomComplet = proprietaireNomComplet.split();
            }
            params.proprietaire_nom_complet = proprietaireNomComplet.length ? JSON.stringify(proprietaireNomComplet) : undefined;
            params.id_b02_adresse_proprietaire = $('[name=id_b02_adresse_proprietaire]').val();
            params.id_proprietaire_x_unite_evaluation = $('[name=id_proprietaire_x_unite_evaluation]').val();

            // vérifier s'il manque la date ou le nom de propriétaire/voie publique AVANT.
            var manqueChamps = (params.date_evenement == '' || params.id_municipalite == '');
            if (!manqueChamps) {
                if (params.id_type_evenement == 33) {
                    manqueChamps = (params.id_voie_publique == '' || params.id_voie_publique == 0);
                }
                if (params.id_type_evenement == 34) {
                    manqueChamps = (params.id_proprietaire == '');
                }
                if ($.inArray(params.id_type_evenement, ['36', '67']) != -1) {
                // if (params.id_type_evenement == 36) {
                    manqueChamps = (params.proprietaire_nom_complet == '');
                }
            }

            if (manqueChamps) {
                $('#info-ue').html('');
                return;
            }

            var erreur = false;

            $.ajax({
                type: "GET",
                url: "/gestion-roles/exp-ue/localisation_ue_correction_mineure/",
                data: params,
                async: false,
                dataType: 'json',
                success: function (response) {

                    $('#info-ue').html(response.contenu);
                    $('#vp-apres-container').html(response.voie_bloc);
                    $('#proprietaire-apres-container').html(response.proprietaire_bloc);
                    if (response.date_evenement) {
                        $('#wizard').attr('date-evenement', response.date_evenement);
                        if (params.id_type_evenement==69) {
                            $('#frm-date-evenement [name="date_evenement"]').val(response.date_evenement.substring(0, 10));
                        }
                    }

                    if (response.erreur_proprio_date) {
                        var datepickerEvenement = $('#frm-date-evenement [name="date_evenement"]');

                        if (params.id_type_evenement == 67) {
                            fenetreModal.modalMessage({
                                titre: response.erreur_proprio_date,
                                texteExplicatif: "",
                                sansX: true,
                                taille: 'normale',
                                boutons: {
                                    "Annuler": {
                                        label: " Annuler ",
                                        id: "",
                                        class: "btn",
                                        action: function () {
                                            fenetreModal.fermerModalAlerteDivs();
                                        }
                                    },
                                }
                            });
                        }
                        else {
                            fenetreModal.modalMessage({
                                titre: response.erreur_proprio_date + " Voulez-vous continuer avec cette date ?",
                                texteExplicatif: "Si « Oui », la date sera gardée et le propriétaire saisi sera vidé.<br/><br/>Si « Non », les données seront rechargées avec la date du jour.",
                                sansX: true,
                                taille: 'grande',
                                boutons: {
                                    "Oui": {
                                        label: " Oui ",
                                        id: "",
                                        class: "btn btn-success",
                                        action: function () {
                                            if (params.id_type_evenement == 34) {
                                                // vider tous les champs
                                                var contenuRechercheProprio = $('.avant-container #contenu-proprietaire-recherche');
                                                contenuRechercheProprio.find(':input.form-control').val('');
                                                contenuRechercheProprio.find(':input.form-control').select2('val', '');
                                                var statutProprietaire = contenuRechercheProprio.find('[name="statutProprietaire"]');
                                                disableNomPrenomProprio(statutProprietaire, contenuRechercheProprio);
                                            }
                                            if (params.id_type_evenement == 36) {
                                                // vider la recherche de propriétaire
                                                $('[name="proprietaire_nom_complet"]').select2('val', '');
                                            }
                                        }
                                    },
                                    "Non": {
                                        label: " Non ",
                                        id: "",
                                        class: "btn",
                                        action: function () {
                                            // remettre la date du jour
                                            datepickerEvenement.data('daterangepicker').setStartDate(new Date());
                                        }
                                    }
                                }
                            });
                        }
                        erreur = true;
                    } else {
                        initCheckboxTous($('#checkbox-ue-tous'), $('[name="checkbox-ue"]'));

                        init_change_event_sous_bloc($('#vp-apres-container, #proprietaire-apres-container'));

                        if ($.inArray(params.id_type_evenement, ["33", "34"]) == -1) {
                            $('#modal-recherche').attr('recharger', 'oui');
                            init_explorateur_ue_partage();
                        }

                        if ($.inArray(params.id_type_evenement, ["33", "34"]) != -1) {
                            $('#table-evenements tbody tr').off('click');
                            $('#table-evenements [name=checkbox-ue]').on('change', function () {
                                var row = $(this).closest('tr');
                                var textbox = row.find("[name=text-numero-civique-apres]");
                                textbox.prop('disabled', !$(this).is(':checked'));
                            });

                            var idEvenement = $('#wizard').attr('id-evenement');

                            var contientUe = null;
                            if (!idEvenement) {
                                contientUe = $('#wizard').attr('id-ue') || null;
                            }

                            if (contientUe) {
                                $('#wizard').attr('id-ue', ''); // ne pas envoyer ce UE au serveur quand on va saver
                                $('#table-evenements #checkbox-ue-tous').click();
                                $('#table-evenements tr[id_ue=' + contientUe + '] [name=checkbox-ue]').click();
                            }
                        }

                        if (params.id_type_evenement == 34) {
                            $('#proprietaire-apres-container').find('[name="statutProprietaire"]').on('change', function () {
                                $('#proprietaire-apres-container').find('[name="prenom"]').attr('disabled', $(this).val() == '2');
                            });
                        }

                        if ($.inArray(params.id_type_evenement, ['36', '67']) != -1) {
                        // if (params.id_type_evenement == 36) {
                            initCorrectionMineureAdressePostale();

                            var containerProprios = $('#accordion-creation-adresse-proprietaire-proprietaires-lies');

                            containerProprios.find('[name="checkbox-proprio"]').on('change', function () {
                                var ligne = $(this).closest('.div-table-ligne');
                                var proprioCoche = $(this).is(':checked');
                                var complementApres = ligne.find('[name="complement_apres"]');

                                // ne pas activer l'api 'après' : il est seulement activé si on clique sur 'Utiliser comme adresse postale'
                                // ligne.find('[name="checkbox-api-apres"]').prop('disabled', !$(this).is(':checked'));
                                complementApres.prop('disabled', !proprioCoche);

                                // mettre le complément commun, s'il y a lieu
                                var complementCommun = $('#creation-adresse-proprietaire').find('[name="complement"]').val();
                                if (proprioCoche) {
                                    if (complementCommun) {
                                        complementApres.val(complementCommun);
                                    }
                                } else {
                                    complementApres.val(complementApres.attr('complement'));
                                }
                            });

                            containerProprios.find('[name="checkbox-api-apres"]').on('change', function () {
                                $(this).parent().find('span').attr('title', $(this).is(':checked') ? 'Oui' : 'Non');

                                var checkboxApi = containerProprios.find('[name="checkbox-api-apres"]:checked');
                                var apiCochee = checkboxApi.length > 0;
                                var idUeApiCochee = $(this).closest('.div-table-ligne').attr('id_ue');
                                if (apiCochee) {
                                    // décocher les api de l'autre ue
                                    checkboxApi.closest('.div-table-ligne').filter(function () {
                                        if ($(this).attr('id_ue') != idUeApiCochee) {
                                            var checkbox = $(this).find('[name="checkbox-api-apres"]');
                                            checkbox.prop('checked', false);
                                            checkbox.parent().find('span').attr('title', 'Non');
                                        }
                                    });
                                }
                            });

                            // mettre inactif le bouton 'Utiliser comme adresse postale' si pas d'adresse
                            containerProprios.find('[name="adresse_complete"]').each(function () {
                                if ($(this).text() == '') {
                                    var checkboxUtiliser = $(this).closest('.div-table-ligne').find('[name="checkbox-utiliser-adresse"]');
                                    checkboxUtiliser.prop('disabled', true);
                                    checkboxUtiliser.parent().find('.checkmark_square_down').attr('disabled', true);
                                }
                            });

                            containerProprios.find('[name="checkbox-utiliser-adresse"]').on('change', function () {
                                wait.start('contenu');
                                var params = {};
                                params.date_evenement = $('#wizard').attr('date-evenement');
                                params.id_type_evenement = $('#wizard').attr('id-type-evenement');

                                // décocher la case déjà coché, s'il y a lieu : une seule case peut être coché à la fois
                                var checkboxUtiliserAutres = containerProprios.find('[name="checkbox-utiliser-adresse"]:checked').not($(this));
                                checkboxUtiliserAutres.prop('checked', false);

                                var ligne = $(this).closest('.div-table-ligne');
                                var checkboxUtiliser = $(this);
                                var checkboxUtiliserCocher = checkboxUtiliser.is(':checked');

                                // décocher api 'après' par défaut
                                var apiApres = containerProprios.find('[name="checkbox-api-apres"]');
                                apiApres.prop('checked', false);
                                apiApres.parent().find('span').attr('title', 'Non');
                                apiApres.prop('disabled', true);

                                var cocheSelonUe = false;
                                if (checkboxUtiliserCocher) {
                                    var idB02 = ligne.attr('id_b02_adresse_proprietaire');
                                    var idUe = ligne.attr('id_ue');

                                    params.id_proprietaire_x_unite_evaluation = ligne.attr('id_proprietaire_x_unite_evaluation');

                                    if (idB02) {
                                        params.id_b02_adresse_proprietaire = idB02;
                                    } else {
                                        params.id_ue = idUe;
                                        cocheSelonUe = true;
                                    }

                                    // cocher api 'après' selon l'adresse cochée
                                    containerProprios.find('.div-table-ligne').each(function () {
                                        var idB02AutreLigne = $(this).attr('id_b02_adresse_proprietaire');
                                        var idUeAutreLigne = $(this).attr('id_ue');
                                        var checkboxApiApres = $(this).find('[name="checkbox-api-apres"]');
                                        var api = $(this).find('[name="checkbox-api-avant"]').is(':checked');
                                        if (api) {
                                            if ((idB02 != '' && idB02AutreLigne == idB02) || (idUeAutreLigne == idUe)) {
                                                checkboxApiApres.prop('checked', true);
                                                checkboxApiApres.parent().find('span').attr('title', 'Oui');
                                                checkboxApiApres.prop('disabled', false);
                                            }
                                        }
                                    });
                                }
                                $.ajax({
                                    type: "GET",
                                    url: '/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/editer-adresse-proprietaire/',
                                    dataType: 'html',
                                    data: params,
                                    async: false,
                                    success: function (response) {
                                        // mettre un timeout pour voir le spinner
                                        setTimeout(function () {
                                            var containerAccordionAdresse = $('#accordion-nature-122 .apres-container');
                                            containerAccordionAdresse.empty();
                                            containerAccordionAdresse.append(response);

                                            if (['36', '67'].includes(params.id_type_evenement)) {
                                                // ne pas voir la section du nom de propriétaire dans une correction d'adresse de propriétaire
                                                $('#accordion-creation-proprietaire').parent().hide();
                                            }

                                            var containerAdresse = $('#creation-adresse-proprietaire');
                                            if (cocheSelonUe) {
                                                var containerProprietaire = $('#accordion-creation-proprietaire');
                                                containerProprietaire.find('[name="bool_meme_adresse_ue"]').val('1');

                                                $('#edition-adresse-ue').attr('modifie', 'True');
                                            } else {
                                                containerAdresse.attr('id-model-instance', '');
                                                containerAdresse.attr('methode', 'POST');
                                            }
                                            initCorrectionMineureAdressePostale();
                                            initComplement();
                                            // forcer le changement du complément
                                            containerAdresse.find('[name="complement"]').trigger('change');
                                            // après l'initialisation des forms,  notifier que le form d'adresse a changé, s'il y a lieu
                                            containerAdresse.attr('modifie', checkboxUtiliserCocher ? 'True' : 'False');
                                            // décocher le checkbox pour une prochaine utilisation
                                            checkboxUtiliser.prop('checked', false);
                                            wait.stop('contenu');
                                        }, 0);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        wait.stop('contenu');
                                        // décocher le checkbox pour une prochaine utilisation
                                        checkboxUtiliser.prop('checked', false);
                                        infos.ajouterMessageToast({
                                            message: 'Une erreur s\'est produite. Contactez un administrateur.',
                                            messageDuree: 0
                                        });
                                        // TODO : logguer les erreurs
                                    }
                                });
                            });

                            initComplement();

                            // reset attribut 'modifie' pour ne pas sauvegarder
                            $('#proprietaire-recherche-cm').attr('modifie', 'False');
                        }

                        $('#voie-publique-sous-bloc [name=nom]').on('change', function () {
                            // enlever les accents
                            var val = $(this).val();
                            val = Select2.util.stripDiacritics(val);
                            $(this).val(val);
                        });

                        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                    }
                }
            });
            return erreur;
        }

        function initCorrectionMineureAdressePostale() {

            initChangementAdressePostale(true);

            // sert pour afficher les erreurs à la fin de l'accordéon
            $('#creation-adresse-proprietaire').addClass('afficher-erreur');
        }

        function initComplement() {
            var containerProprios = $('#accordion-creation-adresse-proprietaire-proprietaires-lies');

            $('#creation-adresse-proprietaire').find('[name="complement"]').on('change', function () {
                var complement = $(this).val();
                var ligneProprioCoches = containerProprios.find('[name="checkbox-proprio"]:checked').closest('.div-table-ligne');

                if (complement) {
                    ligneProprioCoches.find('[name="complement_apres"]').val(complement);
                } else {
                    $.each(ligneProprioCoches.find('[name="complement_apres"]'), function () {
                        $(this).val($(this).attr('complement'));
                    });
                }
            });
        }


        /**
         * Fonction qui permet de décider si on ferme ou non le wizard à la sauvegarde spécifique à certaines corrections.
         */
        function saveInfoGeneraleCorrectionMineureBefore(callback, sauvegarde) {
            var typeEvenement = $('#wizard').attr('id-type-evenement');
            if ($('#wizard').attr('id-evenement') == '' && $.inArray(typeEvenement, ['33', '34', '36', '67']) != -1) {
                var titre = "Sauvegarder et fermer ?";
                var texteExplicatif = '';
                var texteExplicatif2 = " Ceci aura pour effet de sauvegarder, de créer un évènement pour chaque" +
                    " UE impliquée, d'émettre un certificat pour chacun et de fermer cet assistant.";

                if (typeEvenement == 33) {
                    wait.start();

                    var vp_sous_bloc = $('#voie-publique-sous-bloc');
                    var municipalite = $('#wizard').attr('id-municipalite');
                    var nom = vp_sous_bloc.find('[name=nom]').val();
                    var id_generique_adresse = vp_sous_bloc.find('[name=generiqueAdresse]').val();
                    var id_lien_adresse = vp_sous_bloc.find('[name=lienAdresse]').val();
                    var id_orientation_adresse = vp_sous_bloc.find('[name=orientationAdresse]').val();

                    var params = {
                        municipalite: municipalite,
                        nom: nom,
                        id_generique_adresse: id_generique_adresse,
                        id_lien_adresse: id_lien_adresse,
                        id_orientation_adresse: id_orientation_adresse
                    };

                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/exp-ue/voie-publique-match/",
                        data: params,
                        async: false,
                        dataType: 'json',
                        success: function (response) {
                            wait.stop();

                            var id_voie_publique = response.id_voie_publique;
                            var row = vp_sous_bloc.find('.sous-bloc-form');

                            if (id_voie_publique == 0) {
                                row.attr('id-model-instance', 'None');
                                texteExplicatif = 'Une nouvelle voie publique sera créée. Veuillez svp confirmer que les unités d\'évaluation sélectionnées seront associées avec cette nouvelle voie publique.';
                            } else {
                                row.attr('id-model-instance', id_voie_publique);
                                texteExplicatif = 'La voie publique saisie dans la section Après existe déjà pour cette municipalité. Veuillez svp confirmer que les unités d\'évaluation sélectionnées seront associées avec cette voie publique existante.';
                            }

                            //$('#vp-apres-container').html(response.voie_bloc);
                        }
                    });
                }

                if (typeEvenement == 67) {
                    titre = "Désirez-vous transmettre les modifications et fermer l\'assistant ?";
                    texteExplicatif2 = "Ceci aura pour effet de sauvegarder les modifications de l'adresse " +
                        "postale et de soumettre ces modifications au service d'évaluation aux fins d'émission du " +
                        "certificat de modification au rôle d'évaluation.";
                }
                fenetreModal.modalMessage({
                    titre: titre,
                    sansX: true,
                    texteExplicatif: texteExplicatif + texteExplicatif2,
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function (response) {
                                var reponse = {};
                                wait.stop('contenu');
                                reponse.reponse = 'ok';
                                callback(reponse);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                var reponse = {};
                                reponse.reponse = 'cancel';
                                wait.stop('contenu');
                                callback(reponse);
                            }
                        }
                    }
                });
            } else {
                var reponse = {};
                reponse.reponse = 'pass';
                wait.stop('contenu');
                callback(reponse);
            }
        }

        /**
         * Fonction de sauvegarde de l'étape informations générales du processus de permis.
         * */

        function saveInfoGeneraleCorrectionMineure(callback) {
            checkDateDeJour(saveInfoGeneraleCorrectionMineure2, callback);
        }

        function saveInfoGeneraleCorrectionMineure2(callback) {
            var blocsContainer = $('.step-pane.active');

            var dateEvenement = $('#wizard').attr('date-evenement');

            var champDateBloc = blocsContainer.find('.blocForm [name="date_evenement"]');
            if (champDateBloc.val() != dateEvenement) {
                champDateBloc.removeClass(CLASSE_VALEUR_MODIFIEE).addClass(CLASSE_VALEUR_MODIFIEE);
            }

            blocsContainer.find('[name="date_evenement"]').val(dateEvenement);

            var typeEvenement = $('#wizard').attr('id-type-evenement');
            blocsContainer.find('[name="typeEvenement"]').val(typeEvenement);

            var voiePublique = $('#voiePublique').val();
            blocsContainer.find('[name="voiePublique"]').val(voiePublique);

            var proprietaire = $('[name=proprietaire]').val();
            blocsContainer.find('[name="cm_proprietaire"]').val(proprietaire);

            if ($.inArray(typeEvenement, ['36', '67']) != -1) {
                proprietaire = $('[name=proprietaire_nom_complet]').select2('val');
                blocsContainer.find('[name="cm_proprietaire"]').val(JSON.stringify(proprietaire));
            }

            /*if (!$('#municipalite').val()) {
         $('#municipalite').val(0); // pour éviter un FILE NOT FOUND quand on va sauvegarder
         }*/
            if (!$('#wizard').attr('id-municipalite')) {
                $('#wizard').attr('id-municipalite', 0);
            }

            if (typeEvenement == 9) {
                //var elements = ($('#exp-ue-id-ue').val() != '') ? $('#exp-ue-id-ue') : $('#modal-step2 #div-resultat').find('input:checked').parents('a');
                var elements = $('.step-pane.active #div-resultat').find('input:checked').parents('a');

                if (elements.length > 0) {
                    var element = elements[0];
                    // Si l'UE n'est pas recherchée mais qu'une UE est entrée le champs Unité d'évaluation, on récupère non pas son attribut comme dans la liste de sélection des résultats de recherche mais sa valeur.
                    var idUe = typeof ($(element).attr('id-ue')) === 'undefined' ? $(element).val() : $(element).attr('id-ue');
                    //blocsContainer.find('[name="uniteEvaluation"]').val(idUe);
                    $('#wizard').attr('id-ue', idUe);
                }
            }

            if ($.inArray(typeEvenement, ['33', '34', '36', '67']) != -1) {
                var listeUe;
                if (typeEvenement == 33) {
                    listeUe = $.makeArray($("[name=checkbox-ue]:checked").map(function () {
                        return $(this).closest('tr').attr("id_ue");
                    })).join(',');

                    var listeNoCivique = {};
                    $("[name=checkbox-ue]:checked").each(function () {
                        var row = $(this).closest('tr');
                        var nom = row.attr("id_b00_adresse_ue");
                        var valeur = row.find("[name=text-numero-civique-apres]").val();
                        listeNoCivique[nom] = valeur;
                    });

                    var listeNoCiviqueJson = JSON.stringify(listeNoCivique);
                    blocsContainer.find('[name="liste_no_civique"]').val(listeNoCiviqueJson);
                }
                if (typeEvenement == 34) {
                    listeUe = $.makeArray($("[name=checkbox-ue]:checked").map(function () {
                        return $(this).closest('tr').attr("id_ue");
                    })).join(',');
                }
                if ($.inArray(typeEvenement, ['36', '67']) != -1) {
                    var propriosLiesChecked = $('#accordion-creation-adresse-proprietaire-proprietaires-lies').find('[name="checkbox-proprio"]:checked');
                    listeUe = $.unique($.makeArray(propriosLiesChecked.map(function () {
                        return $(this).closest('.div-table-ligne').attr('id_ue');
                    }))).join(',');
                }

                blocsContainer.find('[name="liste_ue"]').val(listeUe);

                var params = {
                    date_evenement: dateEvenement,
                    liste_ue: listeUe
                };

                if (typeEvenement != 67) {
                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/tenue-a-jour/changement-administratif/verifier-propagation/",
                        data: params,
                        async: true,
                        dataType: 'json',
                        success: function (response) {
                            wait.stop();

                            if (!response.nb_propagation) {
                                saveInfoGeneraleCorrectionMineure3(callback);
                                return;
                            }

                            fenetreModal.modalMessage({
                                titre: "Propagation(s) détectée(s)",
                                sansX: true,
                                texteExplicatif: "Nous avons détecté qu'il nous faudra créer " + response.nb_propagation +
                                    " évènement(s) de propagation pour " + response.nb_ue + " UE(s), car il y a un ou" +
                                    " des évènements postérieurs fermés dans un cycle fermé. Voulez-vous continuer ?",
                                boutons: {
                                    "Oui": {
                                        label: " Oui ",
                                        id: "",
                                        class: "btn btn-success",
                                        action: function (response) {
                                            saveInfoGeneraleCorrectionMineure3(callback);
                                        }
                                    },
                                    "Non": {
                                        label: " Non ",
                                        id: "",
                                        class: "btn",
                                        action: function () {
                                            var reponse = {};
                                            reponse.reponse = 'cancel';
                                            wait.stop('contenu');
                                            callback(reponse);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
                else {
                    saveInfoGeneraleCorrectionMineure3(callback);
                }
            } else {
                saveInfoGeneraleCorrectionMineure3(callback);
            }
        }

        function saveInfoGeneraleCorrectionMineure3(callback) {
            var blocsContainer = $('.step-pane.active');
            var typeEvenement = $('#wizard').attr('id-type-evenement');

            // mettre l'attribut 'bloc-editable' à 'True' pour chaque ligne de sous-bloc pour l'utiliser à la sauvegarde comme dans une fiche mais sans historicité
            $('#vp-apres-container,#proprietaire-apres-container').find('.sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');

            // changer le nom de la section 'creation-proprietaire' pour ne pas la sauvegarder
            $('#creation-proprietaire').attr('id', 'creation-proprietaire-sans-sauvegarde');

            var callbackSaveWizardBlocs = function (response) {
                if (response.reponse != 'ok') {
                    callback(response);
                    return;
                }

                var nouvelEvenement = ($('#wizard').attr('id-evenement') == '');

                var idEvenement = $('#evenement-wizard').attr('id_model_instance');
                if (idEvenement != 'None') {
                    $('#wizard').attr('id-evenement', idEvenement);
                }
                updateEnteteWizard();

                // remettre la date sans l'heure dans le date picker
                var datePicker = blocsContainer.find('.date-picker[name="date_evenement"]');
                datePicker.val(datePicker.val().substring(0, 10));

                var remarque = blocsContainer.find('[name="evenement-remarque"]').val();
                if (remarque != 'None') {
                    $('#wizard').attr('evenement-remarque', remarque);
                }
                var statutEvenement = blocsContainer.find('[name="statutEvenement"]').val();
                $('#wizard').attr('id-statut-evenement', statutEvenement);

                if (nouvelEvenement && $.inArray(typeEvenement, ['33', '34', '36', '67']) != -1) {
                    var evenement_lie = $('#wizard').data('evenement-lie');

                    if ($.inArray(typeEvenement, ['36', '67']) != -1) {
                        // on termine avec la sauvegarde de l'adresse postale pour avoir l'évènement
                        sauvegarderAdresseProprietaire(true, false, function (response) {
                            if (response.reponse != 'ok') {
                                var params = {id_processus: $('#wizard').attr('id-processus')};
                                $.ajax({
                                    type: "GET",
                                    url: '/gestion-roles/supprimer-evenement-erreur-save-adresse-proprietaire/',
                                    dataType: 'json',
                                    data: params,
                                    async: false,
                                    success: function (reponseSauvegarde) {
                                        if (reponseSauvegarde.reponse == 'ok') {
                                            $('#wizard').attr('id-evenement', '');
                                            $('#wizard').attr('date-evenement', '');

                                            // remettre le nom de la section 'creation-proprietaire' comme avant la sauvegarde
                                            $('#creation-proprietaire-sans-sauvegarde').attr('id', 'creation-proprietaire');
                                        }
                                        // retourner la réponse en erreur pour que ça arrête le wizard
                                        callback(response);
                                    },
                                    error: function (xhr, textStatus, error) {
                                        infos.ajouterMessageToast({
                                            message: "Une erreur s'est produite. Contactez un administrateur.",
                                            messageDuree: 0
                                        });
                                        callback(response);
                                    }
                                });
                            }
                            else {
                                evenement_lie = $('#wizard').data('evenement-lie');
                                checkTraiterProchainEvenementLie(evenement_lie, callback);
                            }
                        });
                    } else {
                        //fermerModaleEtRefreshTable();
                        checkTraiterProchainEvenementLie(evenement_lie, callback);
                    }
                } else {
                    callback(response);
                }
            };

            var options = {
                paramsSupp: {
                    sauvegarde_complet: true,
                    id_type_evenement: typeEvenement
                }
            };

            // effacer les messages d'erreurs avant de commencer vu que la sauvegarde se fait en 2 parties
            erreursAjax.effacerErreurChamps($('#contenu'));

            $('#wizard').data('evenement-lie', null);

            if ($.inArray(typeEvenement, ['36', '67']) != -1) {
                // on commence par valider l'adresse postale
                sauvegarderAdresseProprietaire(true, true, function (response) {
                    if (response.reponse != 'ok') {
                        // remettre le nom de la section 'creation-proprietaire' comme avant la sauvegarde
                        $('#creation-proprietaire-sans-sauvegarde').attr('id', 'creation-proprietaire');

                        callback(response);
                        return;
                    }

                    saveWizardBlocs(callbackSaveWizardBlocs, options);
                });
            } else {
                saveWizardBlocs(callbackSaveWizardBlocs, options);
            }
        }

        function fermerModalWizard() {
            // fenetreModal.fermerModal('modal-wizard-evenement');
            var $modal = $('#modal-wizard-evenement');
            $modal.find('[data-dismiss="modal-fermer"]').click();
            //$modal.on('click', '[data-dismiss="modal-fermer"]'
        }

        function fermerModaleEtRefreshTable() {
            fenetreModal.fermerModal('modal-wizard-evenement');
            refreshDatatables();
        }

        // DM: c'est l'étape Renseignements administratifs et de Traitement dans un Changement de rens. adm.
        function initTraitementCorrectionMineure() {
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            var idEtapeProcessus = 30; // étape Traitement de Changement de rens. adm.
            if (idTypeEvenement != TYPE_EVENEMENT.correction_mineure) {
                // étape Renseignements administratifs de plusieurs évènements
                idEtapeProcessus = 28;
            }

            var pageCourante = $($('.steps li[data-id_processus=' + idEtapeProcessus + ']').data('target'));
            var selectNature = pageCourante.find('[name="natureEvenementXEvenement"]');

            var options = {blocsContainer: pageCourante};
            initWizardBlocs(options);

            selectNature.on('change', function () {
                var selectedValues = selectNature.select2('val');
                updateDisplayAccordeonNatures(selectedValues);

                fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
            });

            function updateDisplayAccordeonNatures(selectedValues) {
                var accordeons = pageCourante.find('[id^=accordion-nature-]').not('#accordion-nature-evenement');
                accordeons.each(function () {
                    var noNature = $(this).attr('id').substring(17);
                    var thisSelected = ($.inArray(noNature, selectedValues) > -1);
                    $(this).toggle(thisSelected);
                });

                // afficher l'accordéon de la recheche et création de propriétaire s'il existe et si l'accordion d'adresse propriétaire est affiché
                var accordeonRechercheCreationProprio = pageCourante.find('[id$="recherche-creation-proprio"]');
                var accordeonAdresseProprio = pageCourante.find('#accordion-nature-122');
                accordeonRechercheCreationProprio.toggle(accordeonAdresseProprio.is(":visible"));
            }

            var contenuAdresses = pageCourante.find('#adresse-proprietaire-apres-container');
            var contenuRechercheProprio = pageCourante.find('#contenu-proprietaire-recherche');
            initRechercheProprietaire();
            initCreationEditionAdresseProprietaire(contenuAdresses, contenuRechercheProprio);
            initCheckBoxWithAceIcon(contenuAdresses, true);
            initSuppressionProprietaire();
            initSortableProprietaires(contenuAdresses.find(".div-table-contenu"));

            if ($('#wizard').attr('mode') != 'r') {
                initCodeUtilisationSelect2(pageCourante.find('#nature_9 .apres-container'), true, true);

                // afficher le code d'utilisation et la description
                function initCodeUtilisationDescription(input) {
                    input.parent().find('.select2-container .select2-chosen').text(input.attr('title'));
                }

                var codeUtilisationApres = pageCourante.find('.apres-container [name="codeUtilisation"]');
                initCodeUtilisationDescription(codeUtilisationApres);

                codeUtilisationApres.on('change', function () {
                    initCodeUtilisationDescription($(this));
                });

            } else {
                // afficher le code d'utilisation et la description
                $.each(pageCourante.find('.apres-container [name="codeUtilisation"]'), function () {
                    $(this).val($(this).attr('title'));
                });
            }

            // afficher le code d'utilisation et la description
            $.each(pageCourante.find('.avant-container [name="codeUtilisation"]'), function () {
                $(this).val($(this).attr('title'));
            });

            // on garde les natures déjà sauvegardées
            selectNature.attr('valeur-precedente', selectNature.select2('val'));

            // DM: dans le cas de Révision/recours, on a un autre sélecteur de nature dans l'étape 1 donc ici dans l'étape 2 faut pas se mêler, d'où le .step-pane.active
            var selectNatureWizard = pageCourante.find('#select-nature-wizard');
            if (selectNatureWizard.attr('forcer-nature') != '' && selectNatureWizard.attr('forcer-nature') != null) {
                // on affiche toutes les natures que l'on peut modifier, ce qui affichera les blocs que l'on veut saisir
                var naturesAfficher = selectNatureWizard.attr('forcer-nature').split(',');
                if (selectNature.is('textarea')) {
                    updateDisplayAccordeonNatures(naturesAfficher);
                } else {
                    selectNature.select2('val', naturesAfficher, true);
                }

                // on n'affiche pas l'accordéon du sélecteur de natures d'évènement
                pageCourante.find('[id=accordion-nature-evenement]').hide();
            }

            // Charger le tableau de bâtiments au chargement
            if (pageCourante.find('#table-changement-batiment-principal').length) {
                var idUe = $('#wizard').attr('id-ue');
                tableChangementBatimentPrincipal(idUe);
            }

            // initialisation du input caché 'classe_avant'
            $.each(pageCourante.find('.apres-container input:hidden[name="classe_avant"]'), function () {
                // pour tous les input hidden 'classe_avant', on veut y mettre la valeur du 'avant'
                var inputClasse = $(this).closest('.blocForm').find('select[name^="classeImmeuble"], ' +
                    'input:radio[name="bool_terrain_vague_desservi"], select[name="secteurTaxation"]');
                var nomClasse = inputClasse.attr('name');
                var inputClasseAvant = pageCourante.find('.avant-container [name="' + nomClasse + '"]');
                // #24559 : EXCEPTION classe_avant pour les sous-catégories ir et inr.
                //      Création de la valeur avec une combinaison de trois doubles champs (select id-sous-cat/input pourcentage-sous-cat)
                let container_form = $(this).parents('form');
                let containers_sous_categories = ['correction-mineure-sous-categories-ir', 'correction-mineure-sous-categories-inr']
                if(containers_sous_categories.includes(container_form.attr('id'))){
                    // Venir chercher la valeur "classe_avant" dans le bloc de gauche  pour la mettre dans le "classe_avant" du apres(droite)
                    let container_avant = $('#'+$(container_form).attr('id')); // via le premier element dom trouvé.
                    let valeur_classe_avantr = $(container_avant).find('[name="classe_avant"]').val();
                    $(this).val(valeur_classe_avantr);
                }
                else if (inputClasse.is(':radio')) {
                    $(this).val(inputClasseAvant.filter(':checked').val());
                }
                else {
                    $(this).val(inputClasseAvant.val());
                }

                initQuestionOmiseInscrite($(this).closest('.blocForm'), $(this).val() == '' || $(this).val() == '0');
            });

            $.each(pageCourante.find('.apres-container [name^="classeImmeuble"], .apres-container [name="bool_terrain_vague_desservi"]'), function () {
                rensAdmAfficherQuestionOmiseInscrite($(this));
            });

            function rensAdmAfficherQuestionOmiseInscrite(element) {
                // pour vérifier que ce soit "indûment" omise ou inscrite, il faut savoir s'il y a une valeur vide avant
                // ou après, sauf pour un radio bouton car c'est 'Non'('0') par défaut quand il n'y a pas de valeur
                // - quand la classe est un sélecteur : On vérifie s'il y a une modification entre avant et après ET
                //   on vérifie que la valeur soit vide avant ou après
                // - quand la classe est un radio bouton : On vérifie s'il y a une modification entre avant et
                //   après sans vérifier s'il y a une valeur vide avant ou après
                var containerElement = element.closest('.blocForm');
                var classeAvant = containerElement.find('[name="classe_avant"]').val();
                var classeApres = element.val();

                // exception classeApres pour Sous-catégories (champs multiples des id sous-catégories et pourcentages),
                // on vient combiner les valeurs de tous nos champs dans classeApres
                // le but est d'obtenir une string vide quand tous nos champs sont vidés
                if($(containerElement).attr('id').includes('correction-mineure-sous-categories-')){
                    let nos_champs = $(containerElement).find('[name^="sous"], [name^="pour"]');
                    classeApres = ''
                    $(nos_champs).each(function(){
                        classeApres += $(this).val();
                    })
                }

                var estAffiche = classeApres !== classeAvant;
                if (estAffiche && element.is(':not(:radio)')) {
                    estAffiche = classeApres === '' || classeAvant === '';
                }

                var estNatureIndumentOmiseInscrite = containerElement.find('input[name="est_nature_indument_omise_inscrite"]').val() || '';
                if (!estAffiche && estNatureIndumentOmiseInscrite !== '') {
                    // s'il y a une nature en lien avec la question "indûment omise/inscrite" alors forcer à afficher
                    // la question
                    estAffiche = true;
                }

                afficherQuestionOmiseInscrite(containerElement, estAffiche, estNatureIndumentOmiseInscrite);
            }

            // Changement de classe
            pageCourante.find('.apres-container [name^="classeImmeuble"], .apres-container [name="bool_terrain_vague_desservi"]').on('change', function () {
                rensAdmAfficherQuestionOmiseInscrite($(this));
            });

            pageCourante.find('.apres-container [name="est_indument_omise_inscrite"]').on('change', function () {
                // changer la valeur de est_nature_indument_omise_inscrite selon la valeur du radio bouton
                $(this).closest('.blocForm').find('input[name="est_nature_indument_omise_inscrite"]').val($(this).val());
            });

            initBlocRepartitionsFiscales();

            var containerAdresseUe = pageCourante.find('.apres-container #correction-mineure-adresse-civique');
            // si le code postal change, notifier que l'adresse ue a changé pour que adresse_complete de b00_adresse_ue soit mis à jour
            var codePostal = containerAdresseUe.find('[name="code_postal"]');
            codePostal.on('change', function () {
                containerAdresseUe.find('[name="no_civique"]').addClass('valeur-modifiee');
            });

            // si l'adresse ue change, notifier que le code postal a changé pour que adresse_complete de b00_adresse_ue soit mis à jour avec b00_identification
            //var adresseUe = containerAdresseUe.find(':input');
          //  adresseUe.on('change', function () {
          //      containerAdresseUe.find('[name="code_postal"]').addClass('valeur-modifiee');
         //   });

            // afficher les erreurs de validation en-dessous du form 'après'
            pageCourante.find('.apres-container .blocForm, .sous-bloc-form').addClass('afficher-erreur');

            // ajouter le id_bloc pour mettre à jour les attribut du form et dans les sous-blocs,
            // afficher les erreurs et mettre à jour les données après sauvegarde
            pageCourante.find('.apres-container #correction-mineure-adresse-civique').attr('id_bloc', '00-adr-ue');
            pageCourante.find('.apres-container #correction-mineure-b00-cadastre').attr('id_bloc', '00-cadastre');
            pageCourante.find('#batiment-x-unite-evaluation-bloc-wizard').attr('id_bloc', 'bxue-principale');
            var containerWizValidation = pageCourante.find('.wiz-validation-warning');

            // afficher l'avertissement de la classe INR et de la classe industielle sous le select
            var containerClasseInr = pageCourante.find('.apres-container #correction-mineure-classe-inr [name="classeImmeubleNonResidentiel"]').parent();
            containerClasseInr.addClass('type-warning').addClass('garder-warning');

            var containerClasseIndustrielle = pageCourante.find('.apres-container #correction-mineure-classe-industrielle [name="classeImmeubleIndustriel"]').parent();
            containerClasseIndustrielle.addClass('type-warning').addClass('garder-warning');

            // Afficher l'avertissement du code d'utilisation sous le select
            var containerCodeUtilisation = pageCourante.find('.apres-container #correction-mineure-usage [name="codeUtilisation"]').parent();
            containerCodeUtilisation.addClass('type-warning').addClass('garder-warning');

            validerCodeUtilisation();

            function validerCodeUtilisation() {
                var codeUtilisation = 'codeUtilisation';
                erreursAjax.effacerErreurChamps(containerCodeUtilisation, codeUtilisation);
                var params = {
                    id_ue: $('#wizard').attr('id-ue'),
                    date_evenement: $('#wizard').attr('date-evenement'),
                    id_type_evenement: $('#wizard').attr('id-type-evenement'),
                    classe_industrielle: containerCodeUtilisation.find('[name="codeUtilisation"]').val(),
                    code_utilisation: pageCourante.find('.apres-container #correction-mineure-usage [name="codeUtilisation"]').val(),
                };

                $.ajax({
                    url: '/gestion-roles/tenue-a-jour/correction-mineure/valider-presence-batiment-et-code-utilisation',
                    async: false,
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        if (response.erreur_code_utilisation.length) {
                            $.each(response.erreur_code_utilisation, function (index, erreur) {
                                erreursAjax.afficherErreurChamps(containerCodeUtilisation, codeUtilisation, erreur, '');
                                erreursAjax.afficherErreurChamps(containerWizValidation, 'none', erreur, '', codeUtilisation);
                            });
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        erreursAjax.traiterErreurs(pageCourante, xhr, thrownError);
                        $('.tooltip').remove();
                    }
                });

            }

            pageCourante.find('[name="codeUtilisation"]').on('change', function () {
                validerCodeUtilisation();
            });

            validerB81LocalNr();

            function validerB81LocalNr() {
                // Changement de classe INR et industrielle : si est saisi, valider les conditions

                var classeInr = 'classeImmeubleNonResidentiel';
                var classeIndust = 'classeImmeubleIndustriel';
                erreursAjax.effacerErreurChamps(containerClasseInr, classeInr);
                erreursAjax.effacerErreurChamps(containerClasseIndustrielle, classeIndust);
                var params = {
                    id_ue: $('#wizard').attr('id-ue'),
                    date_evenement: $('#wizard').attr('date-evenement'),
                    id_type_evenement: $('#wizard').attr('id-type-evenement'),
                    classe_inr: containerClasseInr.find('[name="classeImmeubleNonResidentiel"]').val(),
                    classe_industrielle: containerClasseIndustrielle.find('[name="classeImmeubleIndustriel"]').val(),
                    code_utilisation: pageCourante.find('.apres-container #correction-mineure-usage [name="codeUtilisation"]').attr('value'),
                };

                $.ajax({
                    url: '/gestion-roles/tenue-a-jour/correction-mineure/valider-b81-local-nr',
                    async: false,
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        if (response.erreur_classe_inr.length) {
                            $.each(response.erreur_classe_inr, function (index, erreur) {
                                erreursAjax.afficherErreurChamps(containerClasseInr, classeInr, erreur, '');
                                erreursAjax.afficherErreurChamps(containerWizValidation, 'none', erreur, '', classeInr);
                            });
                        }
                        if (response.erreur_classe_industrielle.length) {
                            $.each(response.erreur_classe_industrielle, function (index, erreur) {
                                erreursAjax.afficherErreurChamps(containerClasseIndustrielle, classeIndust, erreur, '');
                                erreursAjax.afficherErreurChamps(containerWizValidation, 'none', erreur, '', classeIndust);
                            });
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        erreursAjax.traiterErreurs(pageCourante, xhr, thrownError);
                        $('.tooltip').remove();
                    }
                });
            }

            pageCourante.find('[name="classeImmeubleNonResidentiel"], [name="classeImmeubleIndustriel"]').on('change', function () {
                validerB81LocalNr();
            });

            // via pl39 #24559: trois accordeons: déclancher la gestion du champ valeur indûment omise.
            pageCourante.find('.apres-container [name="secteurTaxation"], .apres-container [name^="sousCategorieIR"], .apres-container [name^="sousCategorieINR"], .apres-container [name^="pourcentage_sous_categorie"]').each(function (){
                $(this).on('change', function(){
                    rensAdmAfficherQuestionOmiseInscrite($(this));
                });
                rensAdmAfficherQuestionOmiseInscrite($(this));
            });


            // afficher l'avertissement de la classe TVD seulement sous le contrôle radio
            var containerClasseTvd = pageCourante.find('.apres-container #correction-mineure-classe-tvd [name="bool_terrain_vague_desservi"][value="1"]').parent().parent();
            containerClasseTvd.addClass('type-warning').addClass('garder-warning');

            validerClasseTvd();

            function validerClasseTvd() {
                // Changement de classe tvd : si devient Non, valider les conditions
                var classeTvd = 'bool_terrain_vague_desservi';
                erreursAjax.effacerErreurChamps(containerClasseTvd, classeTvd);
                if (containerClasseTvd.find('[name="bool_terrain_vague_desservi"]:checked').val() == '0') {
                    var params = {
                        id_ue: $('#wizard').attr('id-ue'),
                        date_evenement: $('#wizard').attr('date-evenement'),
                        id_processus: $('#wizard').attr('id-processus'),
                        id_type_evenement: $('#wizard').attr('id-type-evenement')
                    };

                    $.ajax({
                        url: '/gestion-roles/tenue-a-jour/correction-mineure/valider-classe-tvd',
                        async: false,
                        data: params,
                        dataType: 'json',
                        success: function (response) {

                            if (response.erreur) {
                                erreursAjax.afficherErreurChamps(containerClasseTvd, classeTvd, response.erreur, '');
                                erreursAjax.afficherErreurChamps(containerWizValidation, 'none', response.erreur, '', classeTvd);
                            }
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            erreursAjax.traiterErreurs(pageCourante, xhr, thrownError);
                            $('.tooltip').remove();
                        }
                    });
                }
            }

            pageCourante.find('[name="bool_terrain_vague_desservi"]').on('change', function () {
                validerClasseTvd();
            });

            initB79Attestation();

            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
        }

        function initQuestionOmiseInscrite(containerLabelQuestion, remplacerTexte, vfe = '') {
            // ne pas voir la question 'est indûment omise/inscrite' avant de faire une sélection
            var labelQuestion = containerLabelQuestion.find('label[for$="est_indument_omise_inscrite' + vfe + '"]');
            labelQuestion.parent().hide();
            // remplacer le texte selon les données
            if (remplacerTexte) {
                labelQuestion.text(labelQuestion.text().replace('inscrite', 'omise'));
            } else {
                labelQuestion.text(labelQuestion.text().replace('omise', 'inscrite'));
            }
        }

        function afficherQuestionOmiseInscrite(containerLabelQuestion, estAffiche, estNatureIndumentOmiseInscrite = '', vfe = '') {
            var labelQuestion = containerLabelQuestion.find('label[for$="est_indument_omise_inscrite' + vfe + '"]');
            if (estAffiche) {
                labelQuestion.parent().show();
                if (estNatureIndumentOmiseInscrite !== '') {
                    // on coche la réponse Oui('1')/Non('0') selon la valeur de la nature omise/inscrite
                    containerLabelQuestion.find('input[name="est_indument_omise_inscrite' + vfe + '"][value="' + estNatureIndumentOmiseInscrite + '"]').prop('checked', true);
                }
            } else {
                labelQuestion.parent().hide();
                containerLabelQuestion.find('input[name="est_indument_omise_inscrite' + vfe + '"]').prop('checked', '');
            }
        }

        function saveTraitementCorrectionMineure(callback) {

            // on veut sauvegarder seulement les natures qui ont été modifiées selon le type d'évènement
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            var pageCourante = $('.step-pane.active');
            var selectNature = pageCourante.find('[name="natureEvenementXEvenement"]');
            if (selectNature.length) {
                var selectedValues = [];

                if (idTypeEvenement != TYPE_EVENEMENT.correction_mineure) {
                    var valeurPrecedente = selectNature.attr('valeur-precedente');
                    if (valeurPrecedente) {
                        selectedValues = valeurPrecedente.split(',');
                    }
                    var accordeons = pageCourante.find('[id^=accordion-nature-] .apres-container').find('.blocForm[modifie="True"], ' +
                        '.form-horizontal[type="formulaire"][modifie="True"]').not('#accordion-nature-evenement');
                    accordeons.each(function () {
                        var noNature = $(this).closest('[id^="accordion-nature-"]').attr('id').substring(17);
                        if ($.inArray(noNature, selectedValues) == -1) {
                            selectedValues.push(noNature);
                        }
                    });
                    selectNature.select2('val', selectedValues);
                }

                // on garde les nouvelles natures qui seront sauvegardées
                selectNature.attr('valeur-precedente', selectNature.select2('val'));
                // On force la sauvegarde des natures
                selectNature.addClass('valeur-modifiee').removeClass('sauvegarde');
            }

            var containerAdresseUe = pageCourante.find('.apres-container #correction-mineure-adresse-civique');
            var adresseUeModifiee = containerAdresseUe.find('.valeur-modifiee');
            var containerProprietaire = pageCourante.find('#adresse-proprietaire-apres-container');
            var proprietaireModifie = containerProprietaire.find('.valeur-modifiee');

            // pour ne pas le sauvegarder
            pageCourante.find('.avant-container > form').removeClass('blocForm');
            var blocsCaches = pageCourante.find('.apres-container > form:hidden');
            blocsCaches.removeClass('blocForm');
            var batimentBlocForm = $('#batiment-x-unite-evaluation-bloc-wizard');
            if (batimentBlocForm.find('.sous-bloc-form').length == 0) {
                batimentBlocForm.removeClass('blocForm');
            }

            var containerB98RepartitionFiscale = pageCourante.find('.apres-container #b98-repartition-fiscale');
            var containerB98Disposition = containerB98RepartitionFiscale.find('#b98-repartition-fiscale-haut-sous-bloc .row.body');
            var b98Lignes = containerB98Disposition.find('.sous-bloc-form[id-model-instance!="None"]').not('.nouvelle-ligne');
            var b98LignesSuppression = b98Lignes.filter(function () {
                return $(this).find('.suppression-ligne').length > 0;
            });
            var b98NouvelleLigne = containerB98Disposition.find('.sous-bloc-form.nouvelle-ligne');
            var estB98LigneBoolDeleteTrue = b98NouvelleLigne.attr('id-model-instance') != 'None';

            preSaveRepartitionsFiscales(b98Lignes, b98LignesSuppression, b98NouvelleLigne, estB98LigneBoolDeleteTrue);

            var containerB98DispositionScolaire = containerB98RepartitionFiscale.find('#b98-repartition-fiscale-bas-scolaire-sous-bloc .row.body');
            var b98LignesScolaire = containerB98DispositionScolaire.find('.sous-bloc-form[id-model-instance!="None"]').not('.nouvelle-ligne');
            var b98LignesSuppressionScolaire = b98LignesScolaire.filter(function () {
                return $(this).find('.suppression-ligne').length > 0;
            });
            var b98NouvelleLigneScolaire = containerB98DispositionScolaire.find('.sous-bloc-form.nouvelle-ligne');
            var estB98LigneBoolDeleteTrueScolaire = b98NouvelleLigneScolaire.attr('id-model-instance') != 'None';

            preSaveRepartitionsFiscales(b98LignesScolaire, b98LignesSuppressionScolaire, b98NouvelleLigneScolaire, estB98LigneBoolDeleteTrueScolaire);

            var callbackSaveWizardBlocs = function (response) {
                pageCourante.find('.avant-container > form').removeClass('blocForm').addClass('blocForm');
                blocsCaches.removeClass('blocForm').addClass('blocForm');
                batimentBlocForm.addClass('blocForm');

                if (response.reponse != 'ok') {
                    resetB98NouvelleLigne(b98NouvelleLigne);
                    resetB98NouvelleLigne(b98NouvelleLigneScolaire);

                    callback(response);
                    return;
                }

                postSaveRepartitionsFiscales(containerB98RepartitionFiscale, b98LignesSuppression, b98NouvelleLigne, estB98LigneBoolDeleteTrue);
                postSaveRepartitionsFiscales(containerB98RepartitionFiscale, b98LignesSuppressionScolaire, b98NouvelleLigneScolaire, estB98LigneBoolDeleteTrueScolaire);

                // sauvegarder le changement d'adresse du propriétaire
                var sections = $('#adresse-proprietaire-apres-container:visible');
                var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                    var params = [];

                    if (idCurrentForm == 'correction-mineure-changement-adresse-proprietaire') {
                        params = controlesFormulaires.serialiserFormulaire(currentForm);
                        params.push({
                            name: 'bool_meme_adresse_ue',
                            value: currentForm.find('[name="bool_meme_adresse_ue"]').attr('value')
                        });
                        params.push({
                            name: 'complement',
                            value: currentForm.find('[name="complement"]').text() ? currentForm.find('[name="complement"]').text() : null
                        });
                        //11663 et 12019
                        if (params.some(params => params.name === "date_initiale_inscription") === false) {
                            params.push({
                                name: 'date_initiale_inscription',
                                value: currentForm.find('[name="date_initiale_inscription"]').text()
                            });
                        }
                        params.push({name: 'proprietaire', value: currentForm.find('[name="proprietaire"]').text()});
                        params.push({
                            name: 'id_ue_proprio_existant',
                            value: currentForm.find('[name="id_ue_proprio_existant"]').text()
                        });
                        params.push({
                            name: 'id_b02_adresse_proprietaire',
                            value: currentForm.find('[name="id_b02_adresse_proprietaire"]').text()
                        });
                        params.push({
                            name: 'adresse_complete',
                            value: currentForm.find('[name="adresse_complete"]').text()
                        });
                        params.push({name: 'uniteEvaluation', value: $('#wizard').attr('id-ue')});
                        params.push({name: 'date_debut', value: dateEvenement});
                        params.push({name: 'ordre_tri', value: currentForm.index() + 1});
                    }
                    return params;
                };
                var getChampUnique = function (currentForm, idCurrentForm) {
                    return {
                        unique_nom_champ: idCurrentForm == 'correction-mineure-changement-adresse-proprietaire' ? 'proprietaire' : '',
                        unique_id_champ: idCurrentForm == 'correction-mineure-changement-adresse-proprietaire' ? currentForm.find('[name="proprietaire"]').text() : ''
                    };
                };
                var getChampTransfert;
                var messageToast = {};

                var callbackFormulaires = function (response) {
                    if (response.reponse != 'ok') {
                        callback(response);
                        return;
                    }

                    // si l'adresse ue change incluant le code postal et que les propriétaires n'ont pas changés,
                    // rafraîchir les propriétaires pour voir les changements
                    if (adresseUeModifiee.length && !proprietaireModifie.length) {
                        var params = {};
                        params.date_evenement = $('#wizard').attr('date-evenement');
                        params.id_ue = $('#wizard').attr('id-ue');
                        params.creation_proprio = $('#adresse-proprietaire-apres-container').attr('creation-proprio');

                        $.ajax({
                            type: "GET",
                            url: '/gestion-roles/tenue-a-jour/correction-mineure/modification-adresse/get-adresse-proprietaire',
                            dataType: 'html',
                            data: params,
                            async: false,
                            success: function (response) {
                                var contenuAdresses = pageCourante.find('#accordion-nature-122 .panel-body');
                                contenuAdresses.empty();
                                contenuAdresses.append(response);

                                var contenuAdressesApres = pageCourante.find('#adresse-proprietaire-apres-container');
                                var contenuRechercheProprio = pageCourante.find('#contenu-proprietaire-recherche');
                                initRechercheProprietaire();
                                initCreationEditionAdresseProprietaire(contenuAdressesApres, contenuRechercheProprio);
                                initCheckBoxWithAceIcon(contenuAdressesApres, true);
                                initSuppressionProprietaire();
                                initSortableProprietaires(contenuAdressesApres.find(".div-table-contenu"));
                                controlesFormulaires.detecterChangementsFormulaire();
                            }
                        });
                    }

                    callback(response);
                };

                sauvegarderFormulairesCoteServeur(callbackFormulaires, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);

                fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
            };

            var options = {
                afficherReussi: false,
                paramsSupp: {sauvegarde_complet: true, id_type_evenement: idTypeEvenement}
            };
            saveWizardBlocs(callbackSaveWizardBlocs, options);


            //-------------------------------------------------------------------------------------------
            //# 9249
            //-------------------------------------------------------------------------------------------

            nbErreurs = 0;
            var dateFinReelle = $('[name="date_fin_reelle"]');
            var idEvenement = $('#wizard').attr('id-evenement');
            var datePriseEffetRolePermis = $('#inspection-type_evenement-1-evenement-' + idEvenement).find('input[name="date_evenement"]');

            var dateEvenement = $('#wizard').attr('date-evenement');
            var forcerChangement = false;


            // On doit venir "artificiellement" indiquer que les lignes du bloc 79 sont modifiées afin quelles soient prises en compte dans la sauvegarde.
            // TODO: Avoir une fonction qui force ce changement basé sur des dépendances de modifications.
            if (dateFinReelle.val() !== "" && (dateFinReelle.val() !== dateFinReelle.attr('value'))) {
                dateEvenement = dateFinReelle.val();
                forcerChangement = true;
            } else if (datePriseEffetRolePermis.val() !== "" && datePriseEffetRolePermis.val() !== datePriseEffetRolePermis.attr('value')) {
                dateEvenement = datePriseEffetRolePermis.val();
                forcerChangement = true;
            }
            if (dateEvenement.length === 10) {
                dateEvenement += ' 15:00:00';
            }

            saveAttestationsB79(dateEvenement, forcerChangement);
        }

        function tableChangementBatimentPrincipal(idUe) {

            var idEvenement = $('#wizard').attr('id-evenement');

            var table = $('#table-changement-batiment-principal');
            if (!$.fn.dataTable.isDataTable(table)) {
                table.find('tbody').remove();

                table.dataTable({
                    'serverSide': true,
                    "searching": true,
                    "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
                    "bFilter": false,
                    "bInfo": false,
                    "language": {
                        "url": datatable_locale_url
                    },

                    "ajax": {
                        "url": "/gestion-roles/exp-ue/json-batiment/unite-evaluation/" + idUe + "/origine/3/id-evenement/" + idEvenement,
                        "data": function (d) {
                            d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                            d.rechercher_historique = false;
                        }
                    }
                    ,
                    "columnDefs": [/*SETTINGS THAT APPLY ON ALL COLUMNS AT ONCE*/

                        {"title": "Photo", "targets": 0, "bSortable": false},
                        {"title": "No bâtiment", "targets": 1},
                        {"title": "ID bâtiment", "targets": 2},
                        {"title": "Principal", "targets": 3},
                        {"title": "Type", "targets": 4},
                        {"title": "Court descriptif", "targets": 5},
                    ],

                    "preDrawCallback": function () {
                        wait.start();
                        return true;
                    },

                    "drawCallback": function () {
                        wait.stop();

                        ajusterTailleImage(table.find('img'), '100px', '80px');
                        // initAceThumbnails('colorbox-photo-principale');
                        initCheckBoxWithAceIcon($('#table-changement-batiment-principal'), true);
                        controlesFormulaires.detecterChangementsFormulaire();
                        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));

                        // rendre cachée la ligne du tableau qui a un sous-bloc caché du bâtiment principal
                        $('#batiment-x-unite-evaluation-sous-bloc-wizard .sous-bloc-form.sous-bloc-cache').closest('tr').hide();

                        // afficher les erreurs de validation en-dessous du tableau
                        $('#batiment-x-unite-evaluation-bloc-wizard').addClass('afficher-erreur');

                        $('#table-changement-batiment-principal_paginate .paginate_button a').on('click', function () {
                            if ($('#batiment-x-unite-evaluation-sous-bloc-wizard .sous-bloc-form[modifie="True"]').length) {

                                // pour ne pas sauvegarder les autres form
                                var blocFormAutres = $('.avant-container > form, .apres-container > form');
                                blocFormAutres.removeClass('blocForm');

                                var callbackSaveWizardBlocs = function (response) {
                                    blocFormAutres.addClass('blocForm');
                                };

                                var options = {afficherReussi: false, async: false};
                                saveWizardBlocs(callbackSaveWizardBlocs, options);
                            }
                        });

                    }
                });
            }
        }

        function initPropagation() {
            var pageCourante = $('.step-pane.active');

            $('[name=select-propagation]').on('change', function () {
                var selectedValue = $(this).val();
                var accordeons = $('.step-pane.active [id^=accordion-propagation-]').not('#accordion-nature-evenement');
                accordeons.each(function () {
                    var noAccordeon = $(this).attr('id').substring(22);
                    var thisSelected = (noAccordeon == selectedValue);
                    $(this).toggle(thisSelected);
                });
                fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
            });

            var callback = function (reponse) {
                // simuler bouton "Remplacer" sur les blocs touchés à gauche mais pas à droite
                var blocsContainer = $('.step-pane.active');
                blocsContainer.find('.bloc-copier[propager-auto=true]').click();
            };
            var options = {callback: callback};
            initWizardBlocs(options);

            $('.step-pane.active .panel-collapse').on('show.bs.collapse', function () {
                var divPanelBody = $(this).find('.panel-body');
                if ($.trim(divPanelBody.html()) === '') {
                    chargerContenuBlocPropagation($(this));
                }
            });

            var btnCreerPropagation = $('#btn-creer-propagation');
            if (btnCreerPropagation.length > 0) {
                var boutonBlocToutCopier = pageCourante.find('button.bloc-tout-copier').length > 0;
                if (boutonBlocToutCopier) {
                    $('#btn-wizard-suivant-terminer').prop('disabled', false);
                    pageCourante.find('[name="bool-propager-auto"]:checked').prop('checked', false);
                }
                else {
                    $('#btn-wizard-suivant-terminer').prop('disabled', true);
                }

                $('#btn-creer-propagation').on('click', function () {
                    var positions = positionCurseurWizard();
                    wait.start('contenu');
                    var etapeProcessusId = $('.steps').find('.active').attr('data-id_processus');
                    var etapeOrdre = $('.steps').find('.active').attr('data-step');
                    var bool_propagation_automatique = (pageCourante.find('[name="bool-propager-auto"]:checked').length > 0);
                    var bool_charger_propagation = (pageCourante.find('[name="bool-charger-propagation"]:checked').length > 0);
                    var paramsSupp = {'creer_propagation': true, 'charger_propagation': bool_charger_propagation ,'bool_propagation_automatique':bool_propagation_automatique};
                    chargerEtapeDynamique(etapeProcessusId, etapeOrdre, paramsSupp, '', positions); // Si nous avons une vue, et non un template, on charge ici.
                    validerropagationCelery($('#wizard').attr('id-evenement'));
                    return false;
                });
                if (btnCreerPropagation.closest('.step-pane').find('.wiz-validation .alert-danger').length > 0) {
                    btnCreerPropagation.prop('disabled', true);
                }
                pageCourante.find('[name="bool-charger-propagation"]').prop('checked', false);
                if($('#est-executer-propagation').val() == 'True') {
                    pageCourante.find('[name="bool-propager-auto"]').prop('checked', false);
                    $('#btn-creer-propagation').prop('disabled', true);
                }
                var bool_simili_propagation = pageCourante.find('[name="bool-simili-propagation"]');
                if (bool_simili_propagation.val() == 'True') {
                    pageCourante.find('[name="bool-propager-auto"]').prop('checked', false);
                    pageCourante.find('[name="bool-charger-propagation"]').prop('checked', true);
                    $('#btn-creer-propagation').prop('disabled', true);
                    $('#btn-wizard-suivant-terminer').prop('disabled', false);
                }
                verifierPropagationfait(pageCourante);
            }

            pageCourante.find('.apres-container [name=codeUtilisation]').on('change', function () {
                if ($(this).val() == '5099') {
                    var accordionBatiment = $(this).closest('[id^=accordion-batiment-]');
                    var accordionBlocs = accordionBatiment.find('[id^=accordion-propagation-]');
                    accordionBlocs.each(function () {
                        var idAccordion = $(this).attr('id');
                        var idAccordionSplit = idAccordion.split('-');

                        var blocInt = TryParseInt(idAccordionSplit[4].substring(0, 2), 0);
                        if (blocInt >= 50 && blocInt <= 59) {
                            $(this).find('h4 > a').filter(".collapsed").click();
                        }
                    });
                }
            });
            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
            if (pageCourante.find('.apres-container').length > 0 ) {
                initvalidationdialogpropagation(pageCourante);
                effacerValidation();
            }

            if(pageCourante.find('[name="hid-bool-propagation-en-traitement"]').val() !== undefined) {
                $('#btn-wizard-suivant-terminer').prop("disabled", true);
            }
           pageCourante.find('[name="bool-propager-auto"], [name="bool-charger-propagation"]').on('change', function () {
               var liensprop = '<span id="bool-propager-automatiquement" class="wizard-executer-propagation" >Attention dans ce cas vous serez responsable de gérer la propagation</span>';
               var bool_prop_checked = pageCourante.find('[name="bool-propager-auto"]:checked').length > 0 ;
               var bool_prop_unchecked = pageCourante.find('[name="bool-propager-auto"]:checked').length <= 0 ;
               var bool_charger_checked = pageCourante.find('[name="bool-charger-propagation"]:checked').length > 0 ;
               var bool_charger_unchecked = pageCourante.find('[name="bool-charger-propagation"]:checked').length <= 0 ;

               if(bool_prop_checked || (bool_prop_unchecked && bool_charger_unchecked)) {
                    $('#bandeaupropagation').html('');
               }
               else {
                   if (bool_prop_unchecked && bool_charger_checked ) {
                       $('#bandeaupropagation').html(liensprop);
                   }
               }
               setTimeout(function () {
                    $('#btn-wizard-save').prop("disabled", true);
                    verifierPropagationfait(pageCourante);
                   if($('#est-executer-propagation').val() == undefined) {
                       var propage_auto = (pageCourante.find('[name="bool-propager-auto"]:checked').length > 0);
                       var charge_prop = (pageCourante.find('[name="bool-charger-propagation"]:checked').length > 0);
                       if (propage_auto || charge_prop) {
                           $('#btn-creer-propagation').prop('disabled', false);
                       }
                       else {
                           $('#btn-creer-propagation').prop('disabled', true);
                       }
                   }
                }, 0);
            });
        }

        function validerropagationCelery(idEvenement) {
            var params1 = {'id_evenement': idEvenement};
            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/propagation/valider-propagation/",
                dataType: 'json',
                async: false,
                data: params1
            });

            jqxhr.done(function (response) {
                if (response.reponse == 'ok') {
                    infos.ajouterMessageToast({
                        message: response.validation1,
                        messageDuree: 1500,
                    });
                }
            });
            jqxhr.fail(function (jqxhr, textStatus, errorThrown) {
                infos.ajouterMessageToast({
                    message: "'Une erreur s'est produite. Contactez un administrateur.",
                    messageDuree: 1500,
                    messageCouleur: 'red'
                });
            });
        }


        function verifierPropagationfait(pageCourante) {
            if($('#est-executer-propagation').val() == 'True') {
                $('#btn-wizard-suivant-terminer').prop('disabled', false);
                var propage_auto = (pageCourante.find('[name="bool-propager-auto"]:checked').length > 0);
                var charge_prop = (pageCourante.find('[name="bool-charger-propagation"]:checked').length > 0);
                if (propage_auto || charge_prop) {
                    $('#btn-creer-propagation').prop('disabled', false);
                } else {
                    $('#btn-creer-propagation').prop('disabled', true);
                }
            }
        }

        function sauvegarderStatutPropagation(pageCourante, idEvenementAnt) {
            var params1 = {'id_evenement': idEvenementAnt};
            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/propagation/sauvegarder-statut-propagation/",
                dataType: 'json',
                async: false,
                data: params1
            });

            jqxhr.done(function (response) {
                if (response.reponse == 'ok') {
                    verifierPropagationfait(pageCourante, $('#id-evenement-propagation').val());
                    $('#btn-wizard-suivant-terminer').prop("disabled", false);
                    $('#accordion-historique-traitement-evenement').html(response.html);
                }
            });
            jqxhr.fail(function (jqxhr, textStatus, errorThrown) {
                var reponse = {};
                reponse.reponse = 'ok';
                wait.stop('contenu');
                callback(reponse);
            });
        }

        function savePropagation(callback) {
            var pageCourante = $('.step-pane.active');

            // pour ne pas le sauvegarder
            pageCourante.find('.avant-container > form').removeClass('blocForm');
            //var blocsCaches = pageCourante.find('.apres-container > form:hidden'); // DM: commenté car on veut tout de même sauvegarder les accordéons mauves qui sont collapsés
            //blocsCaches.removeClass('blocForm');

            var idEvenementAnt = $('#id-evenement-ant').val();
            var idEvenementPost = $('#id-evenement-post').val();
            var idEvenementPropagation = $('#id-evenement-propagation').val();
            var dateEvenementPropagation = $('#date-evenement-propagation').val();
            var options = {
                idEvenementAnt: idEvenementAnt,
                idEvenementPost: idEvenementPost,
                idEvenement: idEvenementPropagation,
                dateEvenement: dateEvenementPropagation,
                paramsSupp: {sauvegarde_complet: '1'}
            };

            var callback2 = function (result) {
                pageCourante.find('.avant-container > form').removeClass('blocForm').addClass('blocForm');
                //blocsCaches.removeClass('blocForm').addClass('blocForm');

                // ouvrir l'accordéon du bloc en erreur et ouvrir celui du bâtiment s'il est fermé
                pageCourante.find('.form.alert').closest('[id^="accordion-batiment-"]').find('[data-parent^="#accordion-batiment-"].accordion-toggle').filter('.collapsed').click();
                pageCourante.find('.form.alert').closest('[id^="accordion-propagation-"]').find('[data-parent^="#accordion-propagation-"].accordion-toggle').filter('.collapsed').click();

                callback(result);
            };

            // ne pas appeler le save s'il n'y a rien à sauvegarder...
            var a_sauvegarder = false;
            var apresContainerForms = pageCourante.find('.apres-container > form');
            if (apresContainerForms.length > 0) {
                a_sauvegarder = true;
            }

            // #15689 : désactiver la sauvegarde du bouton suivant, lorsque la sauvegarde s'est déja effectuée
            // (depuis le bouton suivant par exemple)
            // la logique est que si un changement a été effectué dans le formulaire, le bouton d'enregistrement
            // n'est pas désactivé et qu'une sauvegarde devra être effectuée.
            // Donc: si le bouton sauvegarder est désactivé: ne pas enregistrer.
            if ($('button[data-type="save"]').prop('disabled') === true) {
                a_sauvegarder = false;
            }

            if (a_sauvegarder) {
                saveWizardBlocs(callback2, options);
                sauvegarderStatutPropagation(pageCourante, idEvenementAnt);

            } else {
                // s'il n'y avait rien à propager, signaler que le save de cette étape est ok
                var response = {reponse: 'ok'};
                callback2(response);
            }
        }

        function initInfoGeneraleAnnulationUe() {
            initInfoGeneraleCommun();
        }

        function initInfoGeneraleCommun() {
            // On initialise seulement les select2 pour la section d'informations générales et non pour le sous-bloc des documents
            $('#accordion-infos-generales').find('select').select2();

            var idTypeEvenement = $('#wizard').attr('id-type-evenement');

            $('#municipalite').on('change', function () {
                $('#wizard').attr('id-municipalite', $(this).val());
                // Ceci permet entre autre de charger le listbox de voies publiques selon la municipalité
                var selecteur = $('#wizard').attr('id-municipalite');
                if (selecteur != '' && !!selecteur) {
                    var idMunicipalite = selecteur;

                    // charge les voie publique à l'ouverture de la fenêtre recherche, s'il ya déjà eu une ville de sélectionné
                    if (idMunicipalite != null && idMunicipalite != '') {
                        rafraichirCorrectionMineureUe();
                        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
                    }

                }

            });

            var idUe = $('#wizard').attr('id-ue');
            if (idUe) {
                $('#municipalite').prop('disabled', 'true');
            }

            updateDateEvenementWizard();
            var timerRafraichir = null;
            $('[name=date_evenement]').on('change', function () {
                if (timerRafraichir) {
                    clearTimeout(timerRafraichir);
                    timerRafraichir = null;
                }

                var id_type_evenement = $('#wizard').attr('id-type-evenement');
                // #18746 : exception demande de révisions
                // #16404 : + correction d'office
                if([61, 63].includes(id_type_evenement)){
                    // timer car sinon dans certain cas, quand il y a une heure dans le contrôle, ça fait deux changements de contrôle en ligne quand on clique une date du calendrier
                    timerRafraichir = setTimeout(rafraichirCorrectionMineureUe, 500);
                }
                updateDateEvenementWizard(true);

            });
            var idEvenement = $('#wizard').attr('id-evenement');

            if ($('#municipalite').val() != '' && !idEvenement) {
                $('#municipalite').trigger('change');
            }

            initWizardBlocs();
            if (!idEvenement) {
                blocsMarquerModifie();
            }
        }

        function saveInfoGeneraleAnnulationUe(callback) {
            //On s'assure que l'usager veut bien supprimer

            var idMunicipalite = $('#municipalite').val();
            var dateEvenement = $('#wizard').attr('date-evenement');
            var idTypeEvenement = $('#wizard').attr('id-type-evenement');


            fenetreModal.modalMessage({
                titre: "Voulez-vous vraiment supprimer cette unité d'évaluation ?",
                sansX: true,
                texteExplicatif: "",
                boutons: {
                    "Oui": {
                        label: " Oui ",
                        id: "",
                        class: "btn btn-success",
                        action: function () {
                            // mettre un timeout au cas ou cette fonction ferait afficher un autre modal, car les modals sont automatiquement fermés sur clique d'un bouton
                            setTimeout(function () {
                                saveInfoGeneraleCommun(callback);

                                var params = {
                                    'idMunicipalite': idMunicipalite,
                                    'dateEvenement': dateEvenement,
                                    'idTypeEvenement': idTypeEvenement
                                };

                                $.ajax({
                                    type: "GET",
                                    url: "/gestion-roles/annulation-ue/supprimer/",
                                    data: params,
                                    dataType: 'html',
                                    success: function (response) {

                                        infos.ajouterMessageToast({
                                            message: "Unité d'évaluation supprimée",
                                            messageDuree: 2500,
                                            messageCouleur: 'green'
                                        });

                                    }
                                });


                            }, 100);
                        }
                    },
                    "Non": {
                        label: " Non ",
                        id: "",
                        class: "btn",
                        action: function () {
                            wait.stop();
                        }
                    }
                }

            });


        }

        function saveInfoGeneraleCommun(callback) {
            checkDateDeJour(saveInfoGeneraleCommun2, callback);
        }

        function saveInfoGeneraleCommun2(callback) {
            console.log('saveInfoGeneraleCommun2');
            var blocsContainer = $('.step-pane.active');

            var dateEvenement = $('#wizard').attr('date-evenement');

            var champDateBloc = blocsContainer.find('.blocForm [name="date_evenement"]');
            if (champDateBloc.val() != dateEvenement) {
                champDateBloc.removeClass(CLASSE_VALEUR_MODIFIEE).addClass(CLASSE_VALEUR_MODIFIEE);
            }

            champDateBloc.val(dateEvenement);

            var typeEvenement = $('#wizard').attr('id-type-evenement');
            blocsContainer.find('[name="typeEvenement"]').val(typeEvenement);

            if (!$('#wizard').attr('id-municipalite')) {
                $('#wizard').attr('id-municipalite', 0);
            }

            var elements = $('.step-pane.active #div-resultat').find('input:checked').parents('a');

            if (elements.length > 0) {
                var element = elements[0];
                // Si l'UE n'est pas recherchée mais qu'une UE est entrée le champs Unité d'évaluation, on récupère non pas son attribut comme dans la liste de sélection des résultats de recherche mais sa valeur.
                var idUe = typeof ($(element).attr('id-ue')) === 'undefined' ? $(element).val() : $(element).attr('id-ue');
                $('#wizard').attr('id-ue', idUe);
            }

            saveWizardBlocs(function (response) {
                if (response.reponse == 'ok') {
                    // var nouvelEvenement = ($('#wizard').attr('id-evenement') == '');

                    var idEvenement = $('#evenement-wizard').attr('id_model_instance');
                    if (idEvenement != 'None') {
                        $('#wizard').attr('id-evenement', idEvenement);

                        if (typeEvenement == TYPE_EVENEMENT.revision_recours) {
                            $('#correction-mineure-nature').attr('id_model_instance', idEvenement);
                        }
                        else if(typeEvenement == TYPE_EVENEMENT.correction_d_office) {
                            // forcer le rechargement de l'étape lorsqu'on y reviendra
                            if(response.orginal_response.main['correction-d-office']){
                                $('#modal-step-contents > .active').attr('recharger', 'oui');
                            }
                        }
                    }
                    var statutEvenement = blocsContainer.find('[name="statutEvenement"]').val();
                    $('#wizard').attr('id-statut-evenement', statutEvenement);

                    // remettre la date sans l'heure dans le date picker
                    var datePicker = blocsContainer.find('.date-picker[name="date_evenement"]');
                    datePicker.val(datePicker.val().substring(0, 10));
                    //ajouter la remarque pour les evens communs
                    var remarque = blocsContainer.find('[name="remarque"]');
                    $('#wizard').attr('evenement-remarque', remarque.val());
                    updateEnteteWizard();
                }
                callback(response);
            });
        }


        function initInfoGeneraleChangementTerrain() {
            initInfoGeneraleCommun();
        }

        function saveInfoGeneraleChangementTerrain(callback) {
            saveInfoGeneraleCommun(callback);
        }

        function initInfoGeneraleActualisationInventaire() {
            initInfoGeneraleCommun();
        }

        function saveInfoGeneraleActualisationInventaire(callback) {
            saveInfoGeneraleCommun(callback);
        }

        function initInfoGeneraleEnqueteRevenu() {
            initInfoGeneraleCommun();
        }

        function saveInfoGeneraleEnqueteRevenu(callback) {
            saveInfoGeneraleCommun(callback);
        }

        function initInfoGeneraleEnqueteVente() { //# 5874
            initInfoGeneraleMutation();

            initMultiplesUesMutation();

            initResultatAnalyseVenteMutation();

            // Initialisation des input file de sous-blocs
            var organisation = securite.reqOrganisation();
            var documents = $('#document-enquete-vente').find('.ace-input-file');
            $.each(documents, function (idx, obj) {
                initAceInputFile($(obj), organisation);
            });
        }

        function saveInfoGeneraleEnqueteVente(callback) { //# 5874
            // var idEvenementEnqueteVente = $('#wizard').attr('id-evenement');
            // var dateEvenementEnqueteVente = $('#wizard').attr('date-evenement');
            // var idEnqueteVente =  $('#wizard').attr('id-processus');

            // // changer les données du wizard pour celles de la mutation temporairement
            // $('#wizard').attr('id-evenement', $('#mutation-infos-generales').attr('id-evenement-mutation'));
            // $('#wizard').attr('date-evenement', $('#mutation-infos-generales').attr('date-evenement-mutation'));
            // $('#wizard').attr('id-processus', $('#mutation-infos-generales').attr('id-model-instance'));
            // $('#wizard').attr('id-type-evenement', TYPE_EVENEMENT.mutation); // Mutation
            var acteInputsDisabled = $('#accordion-identification-acte').find(':disabled');

            var callback1 = function (response) {
                if (response.reponse === 'ok') {
                    sauvegarderInfosMutation(callback2);
                } else if (response.reponse === 'error' || response.reponse === 'cancel') {
                    callback(response);
                }
                acteInputsDisabled.attr('disabled', true);
            };

            var callback2 = function (response) {
                if (response.reponse === 'ok') {
                    saveResultatAnalyseVenteMutation(callback3);
                } else if (response.reponse === 'error' || response.reponse === 'cancel') {
                    callback(response);
                }
            };

            var callback3 = function (response) {
                // code commenté temporairement #25148
                callback(response);
                // // #25148
                // if($('#mutation-resultat-analyse-vente').find('[name=form-field-radio]:checked').val() === "False") {
                //     reponse = {};
                //     fenetreModal.modalMessage({
                //         classe: 'modal-dialog',
                //         conteneur: '#wizard',
                //         titre: "Sauvegarder ?",
                //         ombre: true,
                //         sansX: true,
                //         texteExplicatif: "Vous avez indiqué que l'évènement ne necessite pas de Certificat. Il n'y aura donc aucun changement au rôle ni aux fiches (bâtiments/terrain/renseignements administratifs) ni de certificat émis. L'évènement sera fermé automatiquement.<br><br>Voulez-vous continuer ?",
                //
                //
                //         boutons: {
                //             "Oui": {
                //                 label: " Oui ",
                //                 id: "btn_oui",
                //                 class: "btn btn-success",
                //                 action: function (response) {
                //                     saveModalAlertConfirmationFermetureEvenement(callback);
                //                     return
                //                 }
                //             },
                //             "Non": {
                //                 label: " Non ",
                //                 id: "btn_non",
                //                 class: "btn",
                //                 action: function () {
                //                     reponse.reponse = 'cancel';
                //                     wait.stop('contenu');
                //                     callback(reponse);
                //                 }
                //             }
                //         }
                //     });
                // } else {
                //     reponse.reponse = 'ok';
                //     callback(reponse);
                // }

            };

            acteInputsDisabled.attr('disabled', false);
            saveInfoGeneraleMutation(callback1);
        }

        function initInfoGeneraleRevisionRecours() {
            initInfoGeneraleCommun();
        }

        function saveInfoGeneraleRevisionRecours(callback) {
            saveInfoGeneraleCommun(callback);
        }

        function initInfoGeneraleChangementLegislatif() {
            initInfoGeneraleCommun();
        }

        function saveInfoGeneraleChangementLegislatif(callback) {
            saveInfoGeneraleCommun2(callback);
        }

        function initValiderXml() {

            // si 2 triennals, on set l'attribut cycle-2 pour l'avoir en tout temps dans les autres étapes
            if ($('#modal-document-cycle-2').val()) {
                $('#wizard').attr('cycle-2', $('#modal-document-cycle-2').val());
            }

            // Cas de validation des XML sur 2 rôles triennals
            var idCycle1 = $('#wizard').attr('cycle-1');
            var idCycle2 = $('#wizard').attr('cycle-2');
            var allCycle = [];

            if (idCycle2) {
                tableFichierCycleXml('adm-table-fichier-cycle-xml-1', 'cycle', idCycle1, 1);
                tableFichierCycleXml('adm-table-fichier-cycle-xml-2', 'cycle', idCycle2, 1);
                allCycle.push(idCycle1);
                allCycle.push(idCycle2);
            } else {
                tableFichierCycleXml('adm-table-fichier-cycle-xml-1', 'cycle', idCycle1, 1);
                allCycle.push(idCycle1);
            }

            // disabler le Suivant si on est rendu à cette étape
            var pageCourante = $('.step-pane.active');

            var btnGenererValider = pageCourante.find('[name=btn-generer-valider]');
            btnGenererValider.off('click').on('click', function () {
                if ($('#error-evenement-lie-non-ferme').length) {
                    infos.ajouterMessageToast({
                        message: "Il y a des évènements liés encore ouverts avec des évènements fermés.",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });

                    return;
                }

                if ($('#error-evenement-donnees').length) {
                    infos.ajouterMessageToast({
                        message: "Il y a des UEs comportant des erreurs.",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });

                    return;
                }

                fenetreModal.modalMessage({
                    enteteTitre: "Générer les extrants à valider",
                    sansX: true,
                    texteExplicatif: "Ceci générera les extrants à valider. De plus, la municipalité deviendra en lecture seule jusqu'à ce que le cycle soit fermé. Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                wait.start('contenu');
                                btnGenererValider.prop('disabled', true);

                                setTimeout(function () {
                                    $('#btn-wizard-suivant-terminer').prop('disabled', true);

                                    var params = {
                                        "liste_id_cycle": JSON.stringify(allCycle),
                                        "is_individuel": false
                                    };
                                    //on genere xml et affiche si erreur
                                    $.ajax({
                                        type: "GET",
                                        url: "/gestion-roles/administration-evaluation/generer-document-valider/",
                                        async: false,
                                        data: params,
                                        dataType: 'json',
                                        success: function (response) {
                                            wait.stop('contenu');
                                        }
                                    });

                                    infos.ajouterMessageToast({
                                        message: "La génération des extrants à valider a débuté. Vous recevrez un courriel pour vous aviser dès que les extrants à valider auront été générés. Veuillez cliquer sur le bouton Recharger ensuite svp.",
                                        messageDuree: 0
                                    });

                                }, 0);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });
            });

            var btnSupprimerValider = pageCourante.find('[name=btn-supprimer-valider]');
            btnSupprimerValider.off('click').on('click', function () {
                fenetreModal.modalMessage({
                    enteteTitre: "Supprimer les extrants / Rendre éditable la municipalité",
                    sansX: true,
                    texteExplicatif: "Ceci supprimera les extrants à valider. De plus, la municipalité redeviendra éditable. Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                wait.start('contenu');
                                btnSupprimerValider.prop('disabled', true);

                                setTimeout(function () {
                                    $('#btn-wizard-suivant-terminer').prop('disabled', true);

                                    var params = {
                                        "liste_id_cycle": JSON.stringify(allCycle),
                                        "is_individuel": false
                                    };
                                    //on genere xml et affiche si erreur
                                    $.ajax({
                                        type: "GET",
                                        url: "/gestion-roles/administration-evaluation/supprimer-document-valider/",
                                        async: false,
                                        data: params,
                                        dataType: 'json',
                                        success: function (response) {
                                            infos.ajouterMessageToast({
                                                message: "Les extrants à valider ont été supprimés et la municipalité est maintenant éditable.",
                                                messageDuree: 0
                                            });

                                            wait.stop('contenu');
                                        }
                                    });

                                }, 0);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });
            });

        }

        function initProduireExtrants() {
            // forcer le chargement de l'étape, pour une bonne gestion du bouton suivant
            var i = '2';
            $('#modal-step' + i).attr('recharger', 'oui');

            if ($('#modal-document-cycle-2').val()) {
                $('#wizard').attr('cycle-2', $('#modal-document-cycle-2').val());
            }

            var idCycle1 = $('#wizard').attr('cycle-1');

            // pour le depot du role, l'id du processus est l'id du cycle
            if (!idCycle1) {
                idCycle1 = $('#wizard').attr('id-processus');
            }

            var idCycle2 = $('#wizard').attr('cycle-2');

            var allCycle = [];

            tableFichierCycleXml('adm-table-fichier-cycle-xml-1', 'cycle', idCycle1, 2);
            allCycle.push(idCycle1);

            if (idCycle2) {
                tableFichierCycleXml('adm-table-fichier-cycle-xml-2', 'cycle', idCycle2, 2);
                allCycle.push(idCycle2);
            }

            $('#modal-document-select-all-1').change(function () {
                if ($(this).is(":checked")) {
                    $('.input-lg-1:not(.disabled)').prop('checked', true);
                } else {
                    $('.input-lg-1:not(.disabled)').prop('checked', false);
                }
            });

            $('#modal-document-select-all-2').change(function () {
                if ($(this).is(":checked")) {
                    $('.input-lg-2:not(.disabled)').prop('checked', true);
                } else {
                    $('.input-lg-2:not(.disabled)').prop('checked', false);
                }
            });

            var suivantEnabled = ($('#modal-step-contents > .active [name="suivant-enabled"]').val() == '1');
            if (!suivantEnabled) {
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
                $('[name=btn-wizard-precedant]').prop('disabled', true);
            }

            //var etapeSauvegardeeSuivante = $('#modal-step-contents > .active .charger-attribut[name=etape-sauvegardee-suivante-active]').attr('value');

            /*if (pageCourante.attr('data-id_processus') == etapeSauvegardeeSuivante) {
         $('#btn-wizard-suivant-terminer').prop('disabled', true);
         }*/

            var pageCourante = $('.step-pane.active');
            var btnGenererExtrants = pageCourante.find('[name=btn-generer-extrants]');

            btnGenererExtrants.off('click').on('click', function () {
                if ($('#error-evenement-lie-non-ferme').length) {
                    infos.ajouterMessageToast({
                        message: "Il y a des évènements liés encore ouverts avec des évènements fermés.",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });
                }
                else if ($('#error-evenement-donnees').length) {
                    infos.ajouterMessageToast({
                        message: "Il y'a des unités d'évaluation en erreurs.",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });
                }
                else if ($('#cycle-date-limite').val() == '' && $('#cycle-date-expedition').val() == '') {
                    infos.ajouterMessageToast({
                        message: "Veuillez saisir les dates d'expédition et de limite.",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });
                }
                else if ($('#cycle-date-limite').val() == '') {
                    infos.ajouterMessageToast({
                        message: "Veuillez saisir une date de limite.",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });
                }
                else if ($('#cycle-date-expedition').val() == '') {
                    infos.ajouterMessageToast({
                        message: "Veuillez saisir une date d'expédition",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });
                }
                else {
                    var idTypeEvenement = $('#wizard').attr('id-type-evenement');

                    var enteteTitre = "Générer les extrants et fermer le cycle";
                    var texteExplicatif = "Ceci générera les extrants qui seront fournis au client et aura pour effet de fermer le cycle en cours et de rendre la municipalité éditable à nouveau. Voulez-vous continuer ?";

                    // Depot de role
                    if (idTypeEvenement == 53) {
                        enteteTitre = "Générer les extrants et déposer le rôle";
                        texteExplicatif = "Ceci générera les extrants qui seront fournis au client et aura pour effet de déposer le rôle. Voulez-vous continuer?";
                    }

                    fenetreModal.modalMessage({
                        enteteTitre: enteteTitre,
                        sansX: true,
                        texteExplicatif: texteExplicatif,
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function () {

                                    wait.start('contenu');
                                    btnGenererExtrants.prop('disabled', true);

                                    setTimeout(function () {
                                        $('#btn-wizard-suivant-terminer').prop('disabled', true);

                                        var idCycle1 = $('#wizard').attr('cycle-1');
                                        var idCycle2 = $('#wizard').attr('cycle-2');
                                        var listeContainer = [];

                                        if (idCycle2) {
                                            listeContainer.push({
                                                element: $("#adm-body-produire-extrants-1"),
                                                idCycle: idCycle1
                                            });
                                            listeContainer.push({
                                                element: $("#adm-body-produire-extrants-2"),
                                                idCycle: idCycle2
                                            });
                                        } else {
                                            listeContainer.push({
                                                element: $("#adm-body-produire-extrants-1"),
                                                idCycle: idCycle1
                                            });

                                        }

                                        var params = admGetGenererDocumentParams(listeContainer, false);

                                        var idMunicipalite = $('#wizard').attr('id-municipalite');
                                        params.push({name: 'id_municipalite', value: idMunicipalite});
                                        // 8716 ET
                                        params.push({name: 'date_limite', value: $('#cycle-date-limite').val()});
                                        params.push({name: 'date_expedition', value:$('#cycle-date-expedition').val()})
                                        params.push({name: 'id_type_evenement', value: idTypeEvenement});
                                        params.push({name: 'id_cycle', value: idCycle1});


                                        //on genere xml et affiche si erreur
                                        $.ajax({
                                            type: "GET",
                                            url: "/gestion-roles/administration-evaluation/generer-document/",
                                            async: false,
                                            data: params,
                                            dataType: 'json',
                                            success: function (response) {
                                                infos.ajouterMessageToast({
                                                    message: "Vous recevrez une notification par courriel lorsque les documents seront générés. Veuillez cliquer le bouton Recharger ensuite svp.",
                                                    messageDuree: 0
                                                });

                                                wait.stop('contenu');
                                            }
                                        });

                                    }, 0);
                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                }
                            }
                        }

                    });
                }
            });
        }

        function initEcrireCourriel() {


        }

        function initSignerDocuments() {

            if ($('#modal-document-cycle-2').val()) {
                $('#wizard').attr('cycle-2', $('#modal-document-cycle-2').val());
            }

            var idCycle1 = $('#wizard').attr('cycle-1');
            var idCycle2 = $('#wizard').attr('cycle-2');

            var allCycle = [];

            if (idCycle2) {
                admGetFichierCycle(idCycle1, 'adm-table-fichier-cycle-1', 3);
                admGetFichierCycle(idCycle2, 'adm-table-fichier-cycle-2', 3);
                allCycle.push(idCycle1);
                allCycle.push(idCycle2);
            } else {
                admGetFichierCycle(idCycle1, 'adm-table-fichier-cycle-1', 3);
                allCycle.push(idCycle1);
            }


            $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                wait.start();
                setTimeout(function () {
                    var value = saveSignerDocuments();
                    if (value) {
                        return;
                    }
                    refreshDatatables();

                    //fermerModalWizard();
                    fenetreModal.fermerModal('modal-wizard-evenement');

                }, 0);
            });

        }


        function saveValiderXml(callback) {

            //todo:réactiver
            //on valide, on s'assure de ne plus avoir d'icon alert
            if ($('.step-pane.active [name=adm-table-fichier-cycle-xml-1]').find('i.red-alert').length) {

                wait.stop();
                infos.ajouterMessageToast({
                    message: "Veuillez produire les extrants à valider et les vérifier.",
                    messageDuree: 2500,
                    messageCouleur: 'red'
                });

                //temporaire
                var response = {reponse: 'error'};
                // var response = {reponse: 'ok'};
                callback(response);

            } else {

                if ($('.step-pane.active [name=adm-table-fichier-cycle-xml-2]').find('i.red-alert').length) {

                    wait.stop();
                    infos.ajouterMessageToast({
                        message: "Veuillez produire les extrants à valider et les vérifier.",
                        messageDuree: 2500,
                        messageCouleur: 'red'
                    });

                    //temporaire
                    var response = {reponse: 'error'};
                    // var response = {reponse: 'ok'};
                    callback(response);

                } else {


                    if ($('#error-evenement-lie-non-ferme').length) {
                        wait.stop();
                        infos.ajouterMessageToast({
                            message: "Il y a des évènements liés encore ouverts avec des évènements fermés.",
                            messageDuree: 2500,
                            messageCouleur: 'red'
                        });

                        var response = {reponse: 'error'};
                        callback(response);
                        return;
                    }

                    if ($('#error-evenement-donnees').length) {
                        wait.stop();
                        infos.ajouterMessageToast({
                            message: "Il y a des UEs comportant des erreurs.",
                            messageDuree: 2500,
                            messageCouleur: 'red'
                        });

                        var response = {reponse: 'error'};
                        callback(response);
                        return;
                    }

                    var response = {reponse: 'ok'};
                    callback(response);
                }

            }
        }


        function saveProduireExtrants(callback) {
            if ($('.step-pane.active [name=adm-table-fichier-cycle-xml-1]').find('i.red-alert').length || $('.step-pane.active [name=adm-table-fichier-cycle-xml-2]').find('i.red-alert').length) {
                infos.ajouterMessageToast({
                    message: "Veuillez valider ou corriger le(s) XML(s)",
                    messageDuree: 2500,
                    messageCouleur: 'red'
                });

                //temporaire
                var response = {reponse: 'error'};
                callback(response);

            } else {
                wait.start();

                var params = {
                    id_cycle_1: $('#wizard').attr('cycle-1'),
                    id_type_evenement: $('#wizard').attr('id-type-evenement')
                };

                $.ajax({
                    type: "POST",
                    url: "/gestion-roles/administration-evaluation/sauvegarder-produire-extrant/",
                    async: true,
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        wait.stop();

                        if (response.reponse == 'error') {
                            infos.ajouterMessageToast({
                                message: response.message,
                                messageDuree: 0
                            });
                        }

                        callback(response);
                    }
                });
            }
        }


        function saveEcrireCourriel(callback) {

            wait.start();

            var idTypeEvenement = $('#wizard').attr('id-type-evenement');
            var idCycle1 = $('#wizard').attr('cycle-1');

            var params = {};

            if (idTypeEvenement == 53) {
                params = {"id_cycle_1": idCycle1};
            } else {
                //Sauvegarder commentaires dans la table cycle
                var commentaires = $('#adm-ecrire-courriel-commentaire').val();
                var commentaires_municipalite = $('#adm-ecrire-courriel-commentaire-municipalite').val();
                var commentaires_cs = $('#adm-ecrire-courriel-commentaire-cs').val();
                var commentaires_facturation = $('#adm-ecrire-courriel-commentaire-facturation').val();

                params = {
                    "id_cycle_1": idCycle1,
                    "commentaires": commentaires,
                    "commentaires_municipalite": commentaires_municipalite,
                    "commentaires_cs": commentaires_cs,
                    "commentaires_facturation": commentaires_facturation
                };
            }


            $.ajax({
                type: "GET",
                url: "/gestion-roles/administration-evaluation/sauvegarder-commentaires/",
                data: params,
                async: true,
                dataType: 'json',
                success: function (response) {
                    wait.stop();

                    refreshDatatables();

                    if (idTypeEvenement == 53) {
                        var response = {reponse: 'ok'};
                        callback(response);
                    } else {
                        if (response.bool_omettre_signature_extrants == true) {
                            var response = {reponse: 'ok'};
                            callback(response);
                        } else if (response.bool_close_modal === false) {
                            var response = {reponse: 'ok'};
                            callback(response);
                        }else {
                            infos.ajouterMessageToast({
                                message: 'Le cycle a été assigné au responsable de la signature du cycle.',
                                messageDuree: 5000,
                                messageCouleur: 'green'
                            });
                            var response = {reponse: 'ok'};
                            callback(response);
                            fenetreModal.fermerModal('modal-wizard-evenement');
                        }
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var response = {reponse: 'error'};
                    callback(response);
                }
            });
        }

        function validateCertificats(idsCycle) {
            var html = '';
            for (let idCycle of idsCycle) {
                if (idCycle) {
                    var docs = document.getElementsByClassName('certificat-unifies-' + idCycle);
                    for (let doc of docs) {
                        if (doc.value === 'True') {
                            return html;
                        }
                    }
                }}
            for (let idCycle of idsCycle) {
                if (idCycle) {
                    var cetificatHasSign = false;
                    for (var cetificatHasSignInput of document.getElementsByClassName('certificat-' + idCycle)) {
                        if (cetificatHasSignInput.value === 'True') {
                            cetificatHasSign = true;
                            break;
                        }
                    }
                    if (!cetificatHasSign) {
                        var cycleName = cetificatHasSignInput.getAttribute('data-cycle');
                        var deuxiemeTriennal = cetificatHasSignInput.getAttribute('data-deuxieme-triennal');
                        if (deuxiemeTriennal === 'False') {
                            html += '<li>Le certificat XML ou le certificat XML unifié du cycle ' + cycleName + ' ou un certificat XML unifiés (2 rôles).</li>';
                        }
                        else {
                            html += '<li>Le certificat XML ou le certificat XML unifié du cycle ' + cycleName + '.</li>';
                        }
                    }
                }
            }
            return html;
        }

        function saveSignerDocuments(callback) {
            var idCycle1 = $('#wizard').attr('cycle-1');
            var idCycle2 = $('#wizard').attr('cycle-2');
            var docsASigner = document.getElementsByClassName('doc-a-signer');
            var certificatsASigner = document.getElementsByClassName('certificat-a-signer');
            var erreurCertificatHtml = '';
            if (certificatsASigner.length > 0) {
                erreurCertificatHtml = validateCertificats([idCycle1, idCycle2]);
            }
            if (docsASigner.length > 0 || erreurCertificatHtml !== '') {
                var errorDiv = document.getElementById('erreurs-doc');
                var html =  "<p>Veuillez signer les fichiers suivants : </p> <ul>";
                html += erreurCertificatHtml;
                for (let doc of docsASigner) {
                    var docName = doc.value.replace('/media/', '');
                    html += '<li>' + docName + '</li>';
                }
                html += '</ul>';
                errorDiv.innerHTML = html;
                errorDiv.classList.add('alert');
                errorDiv.classList.add('alert-danger');
                wait.stop();
                return 'error';
            }
            else {
                //Sauvegarder commentaires dans la table cycle
                var idTypeEvenement = $('#wizard').attr('id-type-evenement');

                var params = {
                    "id_cycle": idCycle1,
                    "id_cycle_2": idCycle2,
                    "id_type_evenement": idTypeEvenement
                };

                $.ajax({
                    type: "GET",
                    url: "/gestion-roles/administration-evaluation/terminer-cycle/",
                    data: params,
                    async: false,
                    dataType: 'json',
                    success: function (response) {
                        if (response.reponse == 'ok') {
                            var message = 'Le cycle a été fermé avec succès.';

                            if (idTypeEvenement == 53) {
                                message = "Le rôle a été déposé avec succès. Veuillez envoyer un courriel avec l'attestation de dépôt et le sommaire à la municipalité.";
                            }

                            infos.ajouterMessageToast({
                                message: message,
                                messageDuree: 2500,
                                messageCouleur: 'green'
                            });

                            callback(response);
                        } else {

                            infos.ajouterMessageToast({
                                message: "Une erreur est survenue lors de la fermeture du rôle.",
                                messageDuree: 2500,
                                messageCouleur: 'red'
                            });

                            callback(response);

                        }
                        wait.stop();
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        //
                        infos.ajouterMessageToast({
                            message: "Une erreur est survenue lors de la fermeture de cycle",
                            messageDuree: 2500,
                            messageCouleur: 'red'
                        });
                        wait.stop();
                    }
                });
            }

        }
        function getAutresEvenementsOuverts(callback) {
            var retourErreur = 0;
            var idEvenement = $('#wizard').attr('id-evenement');
            var wizardAutresEvenementsOuverts = $('#wizard').find('.wizard-autre-evenement');
            // afficher les autres évènements ouverts seulement si on a le id_evenement et si le div n'est pas affiché
            if (idEvenement && !wizardAutresEvenementsOuverts.length) {
                var params = [];
                params.push({name: 'id_evenement', value: idEvenement});
                params.push({name: 'id_ue', value: $('#wizard').attr('id-ue')});
                params.push({name: 'id_type_evenement', value: $('#wizard').attr('id-type-evenement')});

                $.ajax({
                    type: 'GET',
                    async: false,
                    url: '/gestion-roles/tenue-a-jour/wizard/autres-evenements-ouverts/',
                    data: params,
                    dataType: 'html',
                    success: function (response) {
                        if (response) {
                            if ($('div.wizard-autre-evenement').length > 0) {
                                $('div.wizard-autre-evenement').remove('');
                            }
                            $('#contenu').prepend(response);
                            initLienAutreEvenementOuvert();
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        retourErreur = 1;
                        infos.ajouterMessageToast({
                            message: 'Une erreur s\'est produite. Contactez un administrateur.',
                            messageDuree: 0
                        });
                        // TODO : logguer les erreurs
                    }
                });
            }
            if (typeof (callback) !== 'undefined') {
                var response = {};
                retourErreur > 0 ? response.reponse = 'error' : response.reponse = 'ok';
                callback(response);
            }
        }

        function initLienAutreEvenementOuvert() {
            $('#modal-wizard-evenement').find('.lien-evenement').on('click', function (e) {
                checkSauvegarderEtapeEtPost(function (response) {
                    if (response.reponse == 'ok') {
                        fenetreModal.fermerModal('modal-wizard-evenement');
                        var idEvenement = $(e.target).data('id_evenement');
                        var params = {};
                        tenueAJourModal.ouvrirWizardEvenement(idEvenement, params);
                    }
                }, true);
            });
        }

        function initMedianeListeBase() {
            var pageCourante = $('.step-pane.active');

            var suivantEnabled = ($('#modal-step-contents > .active [name="suivant-enabled"]').val() == 'True');
            if (!suivantEnabled) {
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
            }

            var btnGenererExtrants = pageCourante.find('[name=btn-generer-liste-base]');

            btnGenererExtrants.off('click').on('click', function () {
                fenetreModal.modalMessage({
                    enteteTitre: "Générer la liste de base",
                    sansX: true,
                    texteExplicatif: "Ceci écrasera la liste de base actuelle. Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {

                                wait.start('contenu');
                                btnGenererExtrants.prop('disabled', true);

                                setTimeout(function () {
                                    // $('#btn-wizard-suivant-terminer').prop('disabled', true);

                                    var params = [];

                                    var idMunicipalite = $('#wizard').attr('id-municipalite');
                                    var idMediane = $('#wizard').attr('id-mediane');
                                    var idEvenement = $('#wizard').attr('id-evenement');
                                    var bool_appliquer_prix_rajuste = (pageCourante.find('[name="bool_calculer_prix_actualise_annee_reference"]:checked').length > 0);

                                    params.push({name: 'bool_calculer_prix_actualise_annee_reference', value: bool_appliquer_prix_rajuste});
                                    params.push({name: 'id_municipalite', value: idMunicipalite});
                                    params.push({name: 'id_mediane', value: idMediane});
                                    params.push({name: 'id_evenement', value: idEvenement});

                                    //on genere xml et affiche si erreur
                                    $.ajax({
                                        type: "GET",
                                        url: "/gestion-roles/administration-evaluation/proportion-mediane-generer-liste-base/",
                                        async: false,
                                        data: params,
                                        dataType: 'json',
                                        success: function (response) {
                                            wait.stop('contenu');

                                            if (response.erreur) {
                                                btnGenererExtrants.prop('disabled', false);

                                                infos.ajouterMessageToast({
                                                    message: "Erreur: " + response.erreur,
                                                    messageDuree: 0
                                                });
                                            } else {
                                                // positionner à l'étape courante dans la BD et dans le JS
                                                sauvegarderStatutEvenementEtapeProcessus(function (response) {
                                                    if (response.reponse == 'error') {
                                                        // pas vraiment censé arriver mais rester sur la page quand même ...
                                                        e.preventDefault();
                                                        //retour = false;
                                                    } else {
                                                        // l'étape courante devrait avoir été rafraichie par sauvegarderStatutEvenementEtapeProcessus
                                                        var etapeCourante = $('#modal-step-contents > .active').data('id_processus');
                                                        invaliderEtapeSubsequente(etapeCourante);

                                                        infos.ajouterMessageToast({
                                                            message: "La liste de base a été regénérée. Rechargement de la page en cours...",
                                                            messageDuree: 3000
                                                        });

                                                        $('#btn-wizard-recharger').trigger('click');
                                                    }
                                                });
                                            }
                                        }
                                    });

                                }, 0);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });

            });

            var btnExporterExcel = pageCourante.find('[name=btn-exporter-excel-liste-base]');
            btnExporterExcel.off('click').on('click', function () {
                wait.start('contenu');
                btnExporterExcel.prop('disabled', true);

                setTimeout(function () {
                    // $('#btn-wizard-suivant-terminer').prop('disabled', true);

                    var params = [];

                    /*var idMunicipalite = $('#wizard').attr('id-municipalite');
                    var idMediane = $('#wizard').attr('id-mediane');
                    params.push({name: 'id_municipalite', value: idMunicipalite});
                    params.push({name: 'id_mediane', value: idMediane});*/
                    var idEvenement = $('#wizard').attr('id-evenement');
                    params.push({name: 'id_evenement', value: idEvenement});

                    //on genere xml et affiche si erreur
                    $.ajax({
                        type: "GET",
                        url: "/gestion-roles/administration-evaluation/proportion-mediane-exporter-excel-liste-base/",
                        async: false,
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            wait.stop('contenu');
                            btnExporterExcel.prop('disabled', false);

                            if (response.erreur) {
                                infos.ajouterMessageToast({
                                    message: "Erreur: " + response.erreur,
                                    messageDuree: 0
                                });
                            } else {
                                infos.ajouterMessageToast({
                                    message: "Vous recevrez la liste de base sous forme Excel par courriel sous peu...",
                                    messageDuree: 0
                                });
                            }
                        }
                    });

                }, 0);

            });
            $('.btn-editer-mutation').off('click').on('click', function(){
                $('#modal-editer-mutation .contenu-titre').html('');
                $('#modal-editer-mutation .modal-body').html('');
                wait.start();
                $.ajax({
                    type: "GET",
                    url: $(this).data('url'),
                    success: function (response) {
                        var $modal = $('#modal-editer-mutation');
                        $('#modal-editer-mutation .contenu-titre').html(response.titre);
                        $('#modal-editer-mutation .modal-body').html(response.content);
                        wait.stop();
                        $modal.modal('show');
                        $modal.css('z-index', 9011);
                        $('.modal-backdrop').not('.stacked').css('z-index', 9010);
                        var hidReadOnly = $modal.find('[name=read_only]');
                        $modal.find('#btn-save').prop('disabled', hidReadOnly.val() == '1');
                        $modal.find('[type="formulaire"]').attr('modifie', 'True');

                        // Si on a déjà du contenu, on ajuste la hauteur du textarea pour ne pas voir les contrôles de défilement.
                        var textarea_memo = $modal.find('textarea[name="memo"]')[0];
                        if(textarea_memo) {
                            var offset = textarea_memo.offsetHeight - textarea_memo.clientHeight;
                            var scrollHeight = textarea_memo.scrollHeight;

                            if (scrollHeight) {
                                $(textarea_memo).css('height', `${scrollHeight + offset}px`);
                            }
                        }

                        formaterMonnaie($modal.find('input.money'), 0);

                        // ajuster les inputs money de la section 'Prix de vente' pour avoir 2 décimales, vu que chargerEtapeDynamique à mis 0 décimale par défaut
                        var inputMoneySectionPrixVente = $('#accordion-prix-vente').find('input.money');
                        inputMoneySectionPrixVente.autoNumeric('update', {mDec: 2});
                        inputMoneySectionPrixVente.each(function () {
                            // remettre la valeur originale pour la faire formatter avec 2 décimales
                            var $this = $(this);
                            if ($this.attr('value')) {
                                $this.autoNumeric('set', $this.attr('value'));
                            }
                        });

                        calculerPrixVenteRajuste(true);

                        // exception pour les 2 sous-blocs se rattachant à la mutation, si une valeur change, le prix rajusté sera recalculé, donc la mutation doit être sauvegardée
                        $('#bien-non-immobilier-mutation input:text, #rajustement-mutation input:text').on('change', function () {
                            calculerPrixVenteRajuste();
                            $('#mutation-infos-generales').attr('modifie', 'True');
                        });

                        $('#mutation-infos-generales').on('change', '[name="prix_declare_sans_taxes"], [name="tvq"], [name="tps"], [name="ristourne_tvq"], [name="ristourne_tps"]', function () {
                            calculerPrixVenteRajuste();
                        });

                        // On initialise seulement les select2 pour la section d'informations générales et non pour le sous-bloc des documents
                        $('#modal-step-contents .form-horizontal').find('select').select2({allowClear: true});

                        // mettre l'attribut 'bloc-editable' à 'True' pour chaque ligne de sous-bloc pour l'utiliser à la sauvegarde comme dans une fiche mais sans historicité
                        $('.sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');

                        init_change_event_sous_bloc($modal);

                        $modal.find('[id=rajustement-mutation],[id=bien-non-immobilier-mutation]').find('.form-control').on("change", function (e) {
                            $(this).closest('.sous-bloc-form').attr('modifie', 'True');
                        });

                        $('#modal-editer-mutation #btn-save').off('click').on('click', function() {
                            var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                                var params;
                                if (idCurrentForm == 'mutation-resultat-analyse-vente') {
                                    var containerResultatAnalyseVente = $('#mutation-resultat-analyse-vente');
                                    var inputsDisabled = containerResultatAnalyseVente.find('[name="ratio"], [name="motifExclusion"], [name="justification_exclusion"]').filter(':disabled');
                                    inputsDisabled.attr('disabled', false);
                                    params = currentForm.find(':input.form-control').not('[name="boolEnqueteVente"]').serializeArray();
                                    inputsDisabled.attr('disabled', true);
                                    // si 'Enquête de vente' n'est pas saisi, il faut le passer 'vide' dans les params pour qu'il soit valider
                                    var boolEnqueteVente = containerResultatAnalyseVente.find('[name="bool_enquete_vente"]:checked');
                                    params.push({
                                        name: 'bool_enquete_vente',
                                        value: boolEnqueteVente.length ? boolEnqueteVente.val() : ''
                                    });
                                    params.push({name: 'date_debut', value: dateEvenement});
                                } else {
                                    params = controlesFormulaires.serialiserFormulaire(currentForm);
                                    var idMutation = $('#mutation-infos-generales').attr('id-model-instance');
                                    if (['frm-date-evenement', 'bien-non-immobilier-mutation', 'rajustement-mutation',
                                        'document-mutation'].includes(idCurrentForm) && idMutation != 'None') {
                                        // passer le champ si le formulaire est en édition
                                        params.push({name: 'id_mutation', value: idMutation});
                                    }
                                }
                                return params;
                            };

                            var callback = function (response) {
                                if (response.reponse == 'error') {
                                    // on veut rester sur la page vu qu'il y a des erreurs
                                    e.preventDefault();
                                } else {
                                    // positionner à l'étape courante dans la BD et dans le JS
                                    sauvegarderStatutEvenementEtapeProcessus(function (response) {
                                        if (response.reponse == 'error') {
                                            // pas vraiment censé arriver mais rester sur la page quand même ...
                                            e.preventDefault();
                                            //retour = false;
                                        } else {
                                            // l'étape courante devrait avoir été rafraichie par sauvegarderStatutEvenementEtapeProcessus
                                            var etapeCourante = $('#modal-step-contents > .active').data('id_processus');
                                            invaliderEtapeSubsequente(etapeCourante);

                                            $('#btn-wizard-recharger').trigger('click');
                                            $modal.modal('hide');
                                        }
                                    });
                                }
                            };
                            sauvegarderFormulairesCoteServeur(callback, $modal, getParams, null, null, {}, -1);
                        });
                    }
                });
            });
            var table = pageCourante.find('[name=table-mediane-liste-base]');

            table.dataTable({
                'processing': false,
                "scrollX": true,
                "searching": true,
                "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
                "bFilter": false,
                "bInfo": false,
                "bLengthChange": false,
                "paging": false,
                "language": {
                    "url": datatable_locale_url
                },
                "columnDefs": [
                    {
                        targets: 6,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                    {
                        targets: 7,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                    {
                        targets: 10,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                    {
                        targets: 11,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                    {
                        targets: 12,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                ],
                "fixedHeader": false,
            });

            table.on('processing.dt', function (e, settings, processing) {
                if (processing) {
                    wait.start();
                } else {
                    wait.stop();
                }
            });
        }

        function saveMedianeListeBase(callback) {
            var pageCourante = $('.step-pane.active');
            var idEvenement = $('#wizard').attr('id-evenement');

            var params = {
                'bool_calculer_prix_actualise_annee_reference': $('#bool_calculer_prix_actualise_annee_reference').is(':checked')
            };
            erreursAjax.effacerErreurChamps(pageCourante);
            wait.start();

            //on genere xml et affiche si erreur
            $.ajax({
                type: "POST",
                url: "/gestion-roles/administration-evaluation/proportion-mediane/sauvegarder-composition-liste-base/" + idEvenement,
                async: true,
                data: params,
                dataType: 'json',
                success: function (response) {
                    wait.stop();
                    var reponse;
                    if (response.length == 0) {
                        reponse = {reponse: 'ok'};
                    } else {
                        reponse = {reponse: 'error'};

                        $.each(response, function (index, value) {
                            erreursAjax.afficherErreurChamps(pageCourante, value.champ, value.texte, '');
                        });
                    }
                    callback(reponse);
                }
            });
        }

        function initMedianeEpurationStatistique() {

        }

        function saveMedianeEpurationStatistique(callback) {
            var response = {reponse: 'ok'};
            callback(response);
        }

        function initMedianeResultat() {
            var pageCourante = $('.step-pane.active');

            // initWizardBlocs();
            init_change_event_sous_bloc(pageCourante);
        }

        function saveMedianeResultat(callback) {
            var pageCourante = $('.step-pane.active');
            var params = [];

            var idMunicipalite = $('#wizard').attr('id-municipalite');
            var idEvenement = $('#wizard').attr('id-evenement');
            var motifsFiabilite = pageCourante.find('[name=motifs_fiabilite]').val();

            params.push({name: 'id_municipalite', value: idMunicipalite});
            params.push({name: 'id_evenement', value: idEvenement});
            params.push({name: 'motifs_fiabilite', value: motifsFiabilite});

            erreursAjax.effacerErreurChamps(pageCourante);

            wait.start();

            //on genere xml et affiche si erreur
            $.ajax({
                type: "GET",
                url: "/gestion-roles/administration-evaluation/proportion-mediane/sauvegarder-etablissement-resultat/",
                async: true,
                data: params,
                dataType: 'json',
                success: function (response) {
                    wait.stop();

                    if (response.length == 0) {
                        var reponse = {reponse: 'ok'};
                    } else {
                        var reponse = {reponse: 'error'};

                        $.each(response, function (index, value) {
                            erreursAjax.afficherErreurChamps(pageCourante, value.champ, value.texte, '');
                        });
                    }
                    callback(reponse);
                }
            });
        }

        function initMedianePonderation() {

        }

        function saveMedianePonderation(callback) {
            var response = {reponse: 'ok'};
            callback(response);
        }

        function initMedianeProduireExtrants() {
            var pageCourante = $('.step-pane.active');
            var idMediane = pageCourante.find('.charger-attribut[name=id-mediane]').val();

            // var idMediane = $('#wizard').attr('id-mediane');

            tableFichierMedianeXml('adm-table-fichier-mediane-xml', idMediane);

            var suivantEnabled = ($('#modal-step-contents > .active [name="suivant-enabled"]').val() == '1');
            if (!suivantEnabled) {
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
            }

            var btnGenererExtrants = pageCourante.find('[name=btn-generer-extrants]');

            btnGenererExtrants.off('click').on('click', function () {
                fenetreModal.modalMessage({
                    enteteTitre: "Générer les extrants",
                    sansX: true,
                    texteExplicatif: "Ceci générera les extrants. Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {

                                wait.start('contenu');
                                btnGenererExtrants.prop('disabled', true);

                                setTimeout(function () {
                                    $('#btn-wizard-suivant-terminer').prop('disabled', true);

                                    var params = [];

                                    var idMunicipalite = $('#wizard').attr('id-municipalite');
                                    params.push({name: 'id_municipalite', value: idMunicipalite});
                                    params.push({name: 'id_mediane', value: idMediane});

                                    //on genere xml et affiche si erreur
                                    $.ajax({
                                        type: "GET",
                                        url: "/gestion-roles/administration-evaluation/proportion-mediane-generer-document/",
                                        async: false,
                                        data: params,
                                        dataType: 'json',
                                        success: function (response) {
                                            infos.ajouterMessageToast({
                                                message: "Vous recevrez une notification par courriel lorsque les documents seront générés. Veuillez cliquer le bouton Recharger ensuite svp.",
                                                messageDuree: 0
                                            });

                                            wait.stop('contenu');
                                        }
                                    });

                                }, 0);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });

            });
        }

        function saveMedianeProduireExtrants(callback) {
            var response = {reponse: 'ok'};
            callback(response);
        }

        function initMedianeApprobation() {
            initWizardBlocs();

            var pageCourante = $('.step-pane.active');
            var txtCommentaire = pageCourante.find('[name=commentaire]');

            // Callback lorsqu'on clic sur le bouton terminer
            $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {

                var titre = "Voulez-vous fermer l'évènement ? La médiane sera alors considérée comme étant approuvée et deviendra lecture seule.";

                fenetreModal.modalMessage({
                    titre: titre,
                    sansX: true,
                    texteExplicatif: "",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function (response) {
                                var callbackSaveWizardBlocs = function (response) {
                                    if (response.reponse == 'ok') {
                                        var params = [];

                                        var idMunicipalite = $('#wizard').attr('id-municipalite');
                                        var idEvenement = $('#wizard').attr('id-evenement');
                                        var commentaire = txtCommentaire.val();
                                        params.push({name: 'id_municipalite', value: idMunicipalite});
                                        params.push({name: 'id_evenement', value: idEvenement});
                                        params.push({name: 'commentaire', value: commentaire});

                                        //on genere xml et affiche si erreur
                                        $.ajax({
                                            type: "GET",
                                            url: "/gestion-roles/administration-evaluation/proportion-mediane-terminer/",
                                            async: false,
                                            data: params,
                                            dataType: 'json',
                                            success: function (response) {
                                                var callback = function (reponse) {
                                                };
                                                checkTraiterProchainEvenementLie(response.evenement_lie, callback);
                                            }
                                        });
                                    }
                                };

                                var options = {};
                                saveWizardBlocs(callbackSaveWizardBlocs, options);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }
                });
            });
        }

        function saveMedianeApprobation(callback) {
            // var callbackSaveWizardBlocs = function (response) {
            //     // if (response.reponse == 'ok') {
            //     //
            //     //     // remettre la classe 'blocForm' sur la partie de gauche de la valeur retenue
            //     //     formValeurRetenueAvant.addClass('blocForm');
            //     //
            //     //     // remettre la classe 'blocForm' sur la partie de gauche de la répartition fiscale
            //     //     formRepartitionFiscaleAvant.addClass('blocForm');
            //     //
            //     //     postSaveRepartitionsFiscales(containerB98RepartitionFiscale, b98LignesSuppression, b98NouvelleLigne, estB98LigneBoolDeleteTrue);
            //     // }
            //
            //     callback(response);
            // };
            //
            // var options = {};
            // saveWizardBlocs(callbackSaveWizardBlocs, options);

            var response = {reponse: 'ok'};
            callback(response);
        }

        /**
         *  Depot du role
         *
         */
        function initValiderRole() {
            var pageCourante = $('.step-pane.active');

            var idEvenement = $('#wizard').attr('id-evenement');
            tableFichierCycleXml('adm-table-depot-role-validations', 'evenement', idEvenement, 1);

            var btnGenererValider = pageCourante.find('[name=btn-generer-valider]');

            btnGenererValider.off('click').on('click', function () {
                fenetreModal.modalMessage({
                    enteteTitre: "Validations",
                    sansX: true,
                    texteExplicatif: `
                        Voulez-vous lancer les validations?
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="checkbox-inclure-role-preliminaire">
                            <label class="form-check-label" for="checkbox-inclure-role-preliminaire">
                                Inclure le rôle préliminaire au format PDF
                            </label>
                        </div>
                    `,
                    // "De plus, la municipalité deviendra en lecture seule jusqu'à ce que le cycle soit fermé. Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                var inclureRolePreliminaire = $('#checkbox-inclure-role-preliminaire').is(':checked');
                                wait.start('contenu');
                                btnGenererValider.prop('disabled', true);

                                setTimeout(function () {


                                    var params = {
                                        "inclureRolePreliminaire": inclureRolePreliminaire,
                                        "id_evenement": $('#wizard').attr('id-evenement'),
                                        "id_municipalite": $('#wizard').attr('id-municipalite'),
                                        "attestation_terrain": ($('#contenu').find('[name="attestation-terrain"]:checked').length > 0)
                                    };

                                    if ($('#formulaire-depot-role').length > 0) {
                                        $('#formulaire-depot-role').serializeArray().forEach(function (obj, idx) {
                                            params[obj.name] = obj.value;
                                        });
                                    }

                                    //on genere xml et affiche si erreur
                                    $.ajax({
                                        type: "POST",
                                        url: "/gestion-roles/administration-evaluation/generer-document-valider-role/",
                                        async: false,
                                        data: params,
                                        dataType: 'json',
                                        success: function (response) {
                                            if (response.erreur) {
                                                btnGenererValider.prop('disabled', false);
                                                infos.ajouterMessageToast({
                                                    message: response.erreur,
                                                    messageDuree: 12000,
                                                    messageCouleur: "red"
                                                });
                                            } else {
                                                btnGenererValider.prop('disabled', true);
                                                infos.ajouterMessageToast({
                                                    message: "La génération des extrants à valider a débuté. Vous recevrez un courriel pour vous aviser dès que les extrants à valider auront été générés. Veuillez cliquer sur le bouton Recharger ensuite svp.",
                                                    messageDuree: 0
                                                });
                                            }
                                            wait.stop('contenu');
                                        }
                                    });
                                }, 0);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });
            });

        }

        function saveValiderRole(callback) {
            // if($('.validations-en-traitement').size > 0) {
            //
            // }
            var params = [];
            var idEvenement = $('#wizard').attr('id-evenement');
            params.push({name: 'id_evenement', value: idEvenement});

            $.ajax({
                type: "POST",
                url: "/gestion-roles/administration-evaluation/depot-role-save/",
                async: false,
                data: params,
                // dataType: 'json',
                success: function (response) {
                    wait.stop('contenu');

                    if (response.erreur) {
                        infos.ajouterMessageToast({
                            message: "Erreur: " + response.erreur,
                            messageDuree: 5000,
                        });
                    } else {
                        callback({reponse: 'ok'});
                    }
                }
            });
        }

        /**
         * Fin depot du role
         *
         */

        function wizResetMapAfterReload(maxAttempts, delayMs) {
            var attempts = 0;
            var maxA = typeof maxAttempts === 'number' ? maxAttempts : 50; // ~6s par défaut
            var delay = typeof delayMs === 'number' ? delayMs : 120;

            (function check() {
                var $map = $('#map');
                if ($map.length) {
                    // Dit à wiz_comparaison.html de (ré)initialiser la carte
                    document.dispatchEvent(new CustomEvent('wiz:comparaison:reset-map'));
                } else if (attempts < maxA) {
                    attempts++;
                    setTimeout(check, delay);
                }
            })();
        }

        function initTvmListeBase() {
            var pageCourante = $('.step-pane.active');

            var suivantEnabled = ($('#modal-step-contents > .active [name="suivant-enabled"]').val() == '1');
            if (!suivantEnabled) {
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
            }

            var btnGenererExtrants = pageCourante.find('[name=btn-generer-liste-base]');

            btnGenererExtrants.off('click').on('click', function () {
                fenetreModal.modalMessage({
                    enteteTitre: "Générer la liste de base",
                    sansX: true,
                    texteExplicatif: "Ceci écrasera la liste de base actuelle. Voulez-vous continuer ?",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {

                                wait.start('contenu');
                                btnGenererExtrants.prop('disabled', true);

                                setTimeout(function () {
                                    // $('#btn-wizard-suivant-terminer').prop('disabled', true);

                                    var params = [];

                                    var idMunicipalite = $('#wizard').attr('id-municipalite');
                                    var idTvm = $('#wizard').attr('id-tvm');
                                    params.push({name: 'id_municipalite', value: idMunicipalite});
                                    params.push({name: 'id_tvm', value: idTvm});

                                    //on genere xml et affiche si erreur
                                    $.ajax({
                                        type: "GET",
                                        url: "/gestion-roles/administration-evaluation/depot-role/tvm/generer-liste-base/",
                                        async: false,
                                        data: params,
                                        dataType: 'json',
                                        success: function (response) {
                                            wait.stop('contenu');

                                            if (response.erreur) {
                                                btnGenererExtrants.prop('disabled', false);

                                                infos.ajouterMessageToast({
                                                    message: "Erreur: " + response.erreur,
                                                    messageDuree: 0
                                                });
                                            } else {
                                                infos.ajouterMessageToast({
                                                    message: "La liste de base a été regénérée. Rechargement de la page en cours...",
                                                    messageDuree: 3000
                                                });

                                                $('#btn-wizard-recharger').trigger('click');
                                            }
                                        }
                                    });

                                }, 0);
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }

                });

            });

            pageCourante.off('click', '[data-action="editer-mutation"]').on('click', '[data-action="editer-mutation"]', function (a) {
                wait.start();
                var vueParams = [];
                var titre = '';
                var vue = '';
                var currentForm = $(this).closest('tr'); // $(this).closest('[type="formulaire"]');

                titre = $(this).attr('titre'); // "Édition de la mutation";
                vue = "/gestion-roles/administration-evaluation/proportion-mediane-editer-mutation/";
                vueParams = {
                    id_mediane_liste_base: currentForm.attr('id-mediane-liste-base')/*,
                id_proprietaire: currentForm.find('[name="proprietaire"]').text(),
                id_b02_adresse_proprietaire: currentForm.find('[name="id_b02_adresse_proprietaire"]').text(),
                id_ue_proprio_existant: currentForm.find('[name="id_ue_proprio_existant"]').text(),
                adresse_complete: currentForm.find('[name="adresse_complete"]').text(),
                complement: currentForm.find('[name="complement"]').text(),
                date_initiale_inscription: currentForm.find('[name="date_initiale_inscription"]').val(),
                pourcentage: currentForm.find('[name="pourcentage"]').val(),
                bool_proprietaire_principal: currentForm.find('[name="bool_proprietaire_principal"]').is(':checked') ? 1 : 0,
                cessionnaire_est_cedant: currentForm.attr('cessionnaire-est-cedant'),
                id_ue: currentForm.find('[name="id_ue"]').text() ? currentForm.find('[name="id_ue"]').text() : idUe,
                date_evenement: dateEvenement*/
                };

                fenetreModal.modalMessage({
                    taille: 'immense',
                    enteteTitre: titre,
                    texteExplicatif: "",
                    vueACharger: vue,
                    vueAChargerParams: vueParams,
                    boutons: {
                        "Annuler": {
                            label: " Annuler ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        },
                        "Sauvegarder": {
                            label: " Sauvegarder ",
                            id: "sauvegarder-adresse-proprietaire",
                            type: 'save',
                            class: "btn btn-primary",
                            action: function (e) {
                                var sections = $('#modal-message-alerte');
                                var getParams = function (currentForm, idCurrentForm, dateEvenement) {
                                    var containerResultatAnalyseVente = $('#mutation-resultat-analyse-vente');
                                    var inputsDisabled = containerResultatAnalyseVente.find('[name="ratio"], [name="motifExclusion"], [name="justification_exclusion"]').filter(':disabled');
                                    inputsDisabled.attr('disabled', false);
                                    var params = currentForm.find(':input.form-control').not('[name="boolEnqueteVente"]').serializeArray();
                                    inputsDisabled.attr('disabled', true);
                                    // si 'Enquête de vente' n'est pas saisi, il faut le passer 'vide' dans les params pour qu'il soit valider
                                    var boolEnqueteVente = containerResultatAnalyseVente.find('[name="bool_enquete_vente"]:checked');
                                    params.push({
                                        name: 'bool_enquete_vente',
                                        value: boolEnqueteVente.length ? boolEnqueteVente.val() : ''
                                    });
                                    params.push({name: 'date_debut', value: dateEvenement});

                                    if (idCurrentForm == 'rajustement-mutation') {
                                        var idMutation = $('#mutation-resultat-analyse-vente').attr('id-model-instance');
                                        if (idMutation != 'None') {
                                            // passer le champ si le formulaire est en édition
                                            params.push({name: 'id_mutation', value: idMutation});
                                        }
                                    }

                                    return params;
                                };
                                var getChampUnique;
                                var getChampTransfert;
                                var messageToast = {};

                                var callback = function (response) {
                                    if (response.reponse == 'error') {
                                        // on veut rester sur la page vu qu'il y a des erreurs
                                        e.preventDefault();
                                    } else {
                                        $('#btn-wizard-recharger').trigger('click');
                                    }
                                };
                                sauvegarderFormulairesCoteServeur(callback, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);
                            }
                        }
                    },
                    callback_on_escape: function () {
                        // s'il y a eu des changements dans la page, on propose la sauvegarde
                    }
                });

                //initChangementAdressePostale(modeEdition);

                var popupPageCourante = $('#modal-message-alerte');
                popupPageCourante.find('[type="formulaire"]').attr('modifie', 'True');

                // initialisation des sous-blocs
                init_change_event_sous_bloc();

                popupPageCourante.find('[id=rajustement-mutation] .form-control').on("change", function (e) {
                    $(this).closest('.sous-bloc-form').attr('modifie', 'True');
                });

                scroll.ajouterSlimScroll('#modal-message-alerte-contenu', {hauteur: 700});

                wait.stop();
            });

            var table = pageCourante.find('[name=table-tvm-liste-base]');

            table.dataTable({
                'processing': false,
                "scrollX": true,
                "searching": false,
                "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
                "bFilter": false,
                "bInfo": false,
                "bLengthChange": false,
                "paging": false,
                "language": {
                    "url": datatable_locale_url
                },

                "columnDefs": [
                    {
                        targets: 6,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                    {
                        targets: 7,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                    {
                        targets: 9,
                        render: $.fn.dataTable.render.number(' ', '.', 0)
                    },
                ]
            });

            table.on('processing.dt', function (e, settings, processing) {
                if (processing) {
                    wait.start();
                } else {
                    wait.stop();
                }
            });
        }

        function saveTvmListeBase(callback) {
            var response = {reponse: 'ok'};
            callback(response);
        }

        function initExamenRoleDonneesGeneralesEquilibration() {
            var pageCourante = $('.step-pane.active');
            init_change_event_sous_bloc(pageCourante);
        }

        function saveExamenRoleDonneesGeneralesEquilibration(callback) {
            var pageCourante = $('.step-pane.active');
            var params = [];

            var idMunicipalite = $('#wizard').attr('id-municipalite');
            var idEvenement = $('#wizard').attr('id-evenement');

            params.push({name: 'id_municipalite', value: idMunicipalite});
            params.push({name: 'id_evenement', value: idEvenement});

            var controles = pageCourante.find('[name^=bool_acceptable_]:checked');
            controles.each(function () {
                params.push({name: $(this).attr('name'), value: $(this).val()});
            });

            erreursAjax.effacerErreurChamps(pageCourante);

            //on genere xml et affiche si erreur
            $.ajax({
                type: "GET",
                url: "/gestion-roles/administration-evaluation/depot-role/examen-role/sauvegarder-donnees-generales-equilibration/",
                async: true,
                data: params,
                dataType: 'json',
                success: function (response) {
                    var reponse;
                    if (Object.keys(response).length == 0) {
                        reponse = {reponse: 'ok'};
                    } else {
                        reponse = {reponse: 'error'};

                        for (var key in response) {
                            // check if the property/key is defined in the object itself, not in parent
                            if (response.hasOwnProperty(key)) {
                                erreursAjax.afficherErreurChamps(pageCourante, key, response[key].texte, '');
                            }
                        }
                    }
                    callback(reponse);
                }
            });


        }

        // # TODO: OBSOLETE?
        function initExamenRoleStatistiqueAutre() {

        }

        function saveExamenRoleStatistiqueAutre(callback) {
            var response = {reponse: 'ok'};
            callback(response);
        }


        function initComparaison() {
            var readOnly = $('#mode-read-only').val();
            var pageCourante = $('.step-pane.active');
            var btnGenererComparaisons = pageCourante.find('[name=btn-generer-comparaison]');
            var btnComparables = pageCourante.find('[name=btn-modifier-comparables]');
            var champsManuels = pageCourante.find('#manual_value_comparaison, #manual_remarque_comparaison');
            var champValeurManuelle = pageCourante.find('#manual_value_comparaison');
            var champRemarqueManuelle = pageCourante.find('#manual_remarque_comparaison');

            champsManuels.each(function () {
                $(this).attr('data-valeur-initiale', $(this).val());
                $(this).removeAttr('modifie');
            });

            if (readOnly != 'True') {
                // 'modifie' est l'attribut que le wizard inspecte pour décider de sauvegarder l'étape
                champsManuels.off('change.comparaison input.comparaison')
                    .on('change.comparaison input.comparaison', function () {
                        var initiale = $(this).attr('data-valeur-initiale') || '';
                        if ($(this).val() !== initiale) {
                            $(this).attr('modifie', 'True');
                        } else {
                            $(this).removeAttr('modifie');
                        }
                        $('#btn-wizard-save').prop('disabled', !comparaisonValeursManuellesModifiees());
                        pageCourante.find('.erreur-valeur-manuelle').remove();
                    });

                champValeurManuelle.on('change.comparaison', function () {
                    if (!$(this).val()) {
                        champRemarqueManuelle.val('');
                        var initialeRemarque = champRemarqueManuelle.attr('data-valeur-initiale') || '';
                        if (initialeRemarque !== '') {
                            champRemarqueManuelle.attr('modifie', 'True');
                        }
                    }
                    champRemarqueManuelle.prop('disabled', !$(this).val());
                });
                champRemarqueManuelle.prop('disabled', !champValeurManuelle.val());
                $('#btn-wizard-save').prop('disabled', true);
            }
            var texte_explicatif = "Ceci écrasera la comparaison actuelle. Voulez-vous continuer ?";
            if (readOnly == 'True') {
                controlesFormulaires.readOnlyFormulaire();
                texte_explicatif = "Ceci va permettre de lancer la génération du rapport uniquement s'il existe déjà des comparables";
            }
                btnGenererComparaisons.off('click').on('click', function () {
                    fenetreModal.modalMessage({
                        enteteTitre: "Générer la comparaison",
                        sansX: true,
                        texteExplicatif: texte_explicatif,
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function () {
                                    wait.start('contenu');
                                    btnGenererComparaisons.prop('disabled', true);
                                    setTimeout(function () {
                                        var params = [];
                                        params.push({
                                            name: 'id_municipalite',
                                            value: $('#wizard').attr('id-municipalite')
                                        });
                                        params.push({name: 'id_evenement', value: $('#wizard').attr('id-evenement')});
                                        params.push({name: 'id_ue', value: $('#wizard').attr('id-ue')});
                                        params.push({
                                            name: 'date_evenement',
                                            value: $('#wizard').attr('date-evenement')
                                        });
                                        params.push({name: 'date_role', value: $('#wizard').attr('date-role')});
                                        params.push({
                                            name: 'conserver_comparables',
                                            value: $('input[name="conserver-comparables"]')[0].checked
                                        });
                                        params.push({
                                            name: 'generer_rapport_evaluateur',
                                            value: $('input[name="generer-rapport-evaluateur"]')[0].checked
                                        });
                                        params.push({
                                            name: 'generer_rapport_contribuable',
                                            value: $('input[name="generer-rapport-contribuable"]')[0].checked
                                        });
                                         params.push({
                                            name: 'generer_methode_geo',
                                            value:true
                                        });


                                        params.push({
                                            name: 'rapport_seulement',
                                            value: $('input[name="generer-rapport-seulement"]')[0].checked
                                        });
                                        params.push({
                                            name: 'inclure_sujet',
                                            value: $('input[name="inclure-sujet-comparable"]')[0].checked
                                        });
                                        params.push({
                                            name: 'id_type_methode_calcul',
                                            value: $('#methode-calcul').val()
                                        });


                                        //on genere xml et affiche si erreur
                                        $.ajax({
                                            type: "GET",
                                            url: "/gestion-roles/methode-comparaison/calcul-comparaison/",
                                            async: false,
                                            data: params,
                                            dataType: 'json',
                                            success: function (response) {
                                                wait.stop('contenu');
                                                if (response.erreur) {
                                                    btnGenererComparaisons.prop('disabled', false);

                                                    infos.ajouterMessageToast({
                                                        message: "Erreur: " + response.erreur,
                                                        messageDuree: 0
                                                    });
                                                } else {
                                                    infos.ajouterMessageToast({
                                                        message: "La comparaison a été regénérée. Rechargement de la page en cours...",
                                                        messageDuree: 3000
                                                    });
                                                    $('#btn-wizard-recharger').trigger('click');
                                                }
                                            }
                                        });
                                    }, 0);
                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                }
                            }
                        }
                    });
                });


            btnComparables.off('click').on('click', function (e) {
                wait.start();

                var variablesModaleComparable = {
                    id: "rapport-comparable-modal",
                    view: "/core/modal/",
                    processus_id: "",
                    estExplorateurmodule : true,
                    titre: "Liste des meilleurs comparables identifiés",
                    titre_supp_break: true,
                    titre_supp: "Vous pouvez modifier les comparables qui seront utilisés pour le calcul en cochant ceux désirés dans la liste suivante",
                    module: "",
                    contenuHTML: "",
                    template_view: "/gestion-roles/methode-comparaison/charger-modal-comparable/",
                    template: "",
                    template_depart: "",
                    sans_x: false,
                    template_depart_view: "",
                    url: "",
                    taille: "tres-grande",
                    resultat: "",
                    resultat_depart: "",
                    wizard: false,
                    nePasCacherBackdrop: true,

                    //allback: tenueAJourModal.modalAssigneLoaded,
                    boutons: [{
                        type: "cancel",
                        label: "Fermer",
                        title: "",
                        classSupp: "",
                        afficher: true
                    }, {
                        type: "save",
                        label: "Regénérer le rapport",
                        title: "",
                        classSupp: "btn-primary",
                        afficher: true,
                        id: "btn-generer-rapport-comparaison",
                        disabled: false
                    }]
                };
                setTimeout(function () {
                    var callbacks = [function () {
                        controlesFormulaires.redimentionnerTextarea();
                        wait.start();

                        tablecomparable();
                        var btnGenererComparaisonsportrait = $('#btn-generer-rapport-comparaison');
                        btnGenererComparaisonsportrait.off('click').on('click', function (e) {
                            rapportComparaisonPagesize('portrait');
                            wizResetMapAfterReload(60, 150);
                        });
                        $('#rapport-comparable-modal').on('hidden.bs.modal', function (e) {
                            $('body').addClass('modal-open');
                        });

                        $('#btn-tj-exporter-excel-comparable').off('click').on('click', function (e) {
                            var params = [];
                            params.push({
                                name: 'id_municipalite',
                                value: $('#wizard').attr('id-municipalite')
                            });
                            params.push({name: 'id_evenement', value: $('#wizard').attr('id-evenement')});
                            params.push({name: 'id_ue', value: $('#wizard').attr('id-ue')});
                            params.push({
                                name: 'date_evenement',
                                value: $('#wizard').attr('date-evenement')
                            });

                            exportMeilleurComparable(params);
                        });
                    }];
                    var params = {};
                    fenetreModal.creerModal(variablesModaleComparable, params, callbacks);
                }, 0);
            });

            $('#collapsible').on('shown.bs.collapse hidden.bs.collapse',
                function () {
                    fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'), '#contenu');
                }
            );

            setTimeout(function () {
                    $('.slimScrollDiv').css('height', 'auto');
                    $('#modal-step-contents').css('height', 'auto');
                    fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'), '#contenu');
                }
                , 0);

        }

        function rapportComparaisonPagesize(page_size) {
            fenetreModal.modalMessage({
                enteteTitre: "Générer la comparaison",
                sansX: true,
                conteneur: "#editeur-modal-container",
                texteExplicatif: "Ceci écrasera la comparaison actuelle. Voulez-vous continuer ?",
                boutons: {
                    "Oui": {
                        label: " Oui ",
                        id: "",
                        class: "btn btn-success",
                        action: function () {
                            var params = [];
                            params.push({
                                name: 'id_municipalite',
                                value: $('#wizard').attr('id-municipalite')
                            });
                            params.push({name: 'id_evenement', value: $('#wizard').attr('id-evenement')});
                            params.push({name: 'id_ue', value: $('#wizard').attr('id-ue')});
                            params.push({
                                name: 'date_evenement',
                                value: $('#wizard').attr('date-evenement')
                            });
                            params.push({name: 'date_role', value: $('#wizard').attr('date-role')});
                            params.push({
                                name: 'generer_methode_geo',
                                value: true
                            });
                            params.push({
                                name: 'conserver_comparables',
                                value: false
                            });
                            params.push({
                                name: 'generer_rapport_evaluateur',
                                value: true
                            });
                            params.push({
                                name: 'type_page_size',
                                value: page_size
                            });
                            params.push({
                                name: 'generer_rapport_contribuable',
                                value: false
                            });
                            params.push({
                                name: 'rapport_seulement',
                                value: false
                            });
                            params.push({
                                name: 'inclure_sujet',
                                value: false
                            });
                            params.push({
                                name: 'id_type_methode_calcul',
                                value: $('#methode-calcul').val()
                            });

                            var checked = $('#data-table-comparable').find('tr').find('input[type="checkbox"]:checked:not(:disabled)');
                            var listeIdentifiant = [];
                            checked.each(function () {
                                var row = $(this).closest('tr');
                                var identifiant = row.attr('data-identifiant');
                                if (identifiant && identifiant !== '&nbsp;') {
                                    listeIdentifiant.push(identifiant);
                                }
                            });
                            params.push({
                                name: 'comparable_manuelle',
                                value: listeIdentifiant.join(',')
                            });

                            wait.start();
                            $.ajax({
                                type: "GET",
                                url: "/gestion-roles/methode-comparaison/calcul-comparaison/",
                                data: params,
                                dataType: 'json',
                                success: function (response) {
                                    wait.stop();
                                    if (response.erreur) {
                                        infos.ajouterMessageToast({
                                            message: "Erreur: " + response.erreur,
                                            messageDuree: 0
                                        });
                                    } else {
                                        infos.ajouterMessageToast({
                                            message: "La comparaison a été regénérée avec les choix manuels. Rechargement de la page en cours...",
                                            messageDuree: 3000
                                        });
                                        fenetreModal.fermerModal("rapport-comparable-modal");
                                        $('#btn-wizard-recharger').trigger('click');
                                    }
                                }
                            });
                        }
                    },
                    "Non": {
                        label: " Non ",
                        id: "",
                        class: "btn",
                        action: function () {
                        }
                    }
                }
            });
        }

        function tablecomparable() {
            var params = [];
            params.push({
            name: 'id_municipalite',
            value: $('#wizard').attr('id-municipalite')
            });
            params.push({name: 'id_evenement', value: $('#wizard').attr('id-evenement')});
            params.push({name: 'id_ue', value: $('#wizard').attr('id-ue')});
            params.push({
            name: 'date_evenement',
            value: $('#wizard').attr('date-evenement')
            });
            params.push({name: 'date_role', value: $('#wizard').attr('date-role')});

            $.ajax({
                type: "GET",
                url: "/gestion-roles/methode-comparaison/modal-comparable/",
                data: params,
                dataType: 'json',
                success: function (response) {
                    var columnsDef = [];
                    var data = response['data'];
                        columnsDef.push({ defaultContent: '', className: 'select-checkbox', orderable: false,
                                data: "index",
                                width: '20px',
                                render: function (data, type, row) {
                                    let checked_html = row.comparable_sauvegarde?'checked="checked"':'';
                                    return '<div class="action-buttons-utiliser" data="' + data + '" class="choisir-mutation">' +
                                        '<label class="position-relative">' +
                                        '<input type="checkbox" '+checked_html+' class="ace check-taj-assigne" name="checkbox-assignation">' +
                                        '<span class="lbl" title="Utiliser ce comparable"></span>' +
                                        '</label>' +
                                        '</div>';
                                }

                        });
                        for (var key in data[0])
                        {
                          if (key !== 'index')
                          {
                            columnsDef.push({ data: key, title: key.charAt(0).toUpperCase() + key.slice(1)
                            });

                          }
                        }
                        var table = $('#data-table-comparable');

                   initTableDatatable(table, {
                        'processing': false,
                        "scrollX": true,
                        scrollY: "500px",
                        "searching": true,
                        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
                        "bFilter": false,
                        "bInfo": false,
                        "bLengthChange": false,
                        "language": {
                            "url": datatable_locale_url
                        },
                        pageLength: 25,
                        paging : false,
                        columns: columnsDef,
                        data: data,
                        createdRow: function (row, data) {
                            $(row).attr("data-identifiant", data.ID);
                        },
                        drawCallback: function () {
                                initAceThumbnails('colorbox-photo-rapport');
                                var listeImg = table.find('img');
                                listeImg.attr('height', '40px');
                        },
                        initComplete: function(settings, json) {
                            wait.stop();

                            var api = this.api();
                                api.columns().every(function() {
                                  var column = this;
                                  var header = $(column.header());
                                  if (header.text() === "ID") {
                                    column.visible(false);
                                  }
                                });

                                $('#btn-generer-rapport-comparaison').prop('disabled', true);
                                table.find('tbody tr:first-child').find('.check-taj-assigne').attr('disabled',true);
                                table.find('tbody').on('click', '.check-taj-assigne', function () {
                                    var nombreComparable = table.find('tbody .check-taj-assigne:checked:not(:disabled)').length;
                                    if (nombreComparable >= 3 && nombreComparable <= 5) {
                                        $('#btn-generer-rapport-comparaison').prop('disabled', false);
                                    } else {
                                        $('#btn-generer-rapport-comparaison').prop('disabled', true);
                                    }
                                });



                      var modal = document.getElementById("imageComparable");

                  // Get the image
                  var img = document.getElementById("modalImage");

                  // When a thumbnail image is clicked, open the modal
                                        table.find('tbody').on('click', '.thumbnail', function () {
                                            modal.style.display = "block";
                    img.src = this.src;
                  });

                  // When the close button is clicked, close the modal
                  modal.getElementsByClassName("close-comparable-image")[0].onclick = function() {
                    modal.style.display = "none";
                  };

                  // When the user clicks anywhere outside of the modal, close it
                  window.onclick = function(event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };


                }
            });
              }

               });

        }


   // });
     //   }

        function exportMeilleurComparable(params) {

    wait.start();

    $.ajax({
        type: "POST",
        url: "/gestion-roles/methode-comparaison/export-modal-comparable/",
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: 'text',
        success: function (response) {
            infos.ajouterMessageToast({
                message: response,
                messageDuree: 5000
            });

            wait.stop();
        } //end success
    }); //end ajax

}

        function sauvegarderValeurManuelleComparaison(callback) {
            var params = [];
            params.push({name: 'id_municipalite', value: $('#wizard').attr('id-municipalite')});
            params.push({name: 'id_evenement', value: $('#wizard').attr('id-evenement')});
            params.push({name: 'id_ue', value: $('#wizard').attr('id-ue')});
            params.push({
                name: 'manuel_value_comparaison',
                value: $('#manual_value_comparaison').val()
            });
            params.push({
                name: 'manuel_remarque_comparaison',
                value: $('#manual_remarque_comparaison').val()
            });

            var $etape = $('.step-pane.active');
            var jqxhr = $.ajax({
                type: "GET",
                url: "/gestion-roles/methode-comparaison/sauvegarder-valeur-manuelle-comparaison/",
                dataType: 'json',
                async: false,
                data: params
            });

            jqxhr.done(function (reponse) {
                if (reponse.erreur) {
                    infos.ajouterMessageToast({
                        message: "Erreur: " + reponse.erreur,
                        messageDuree: 0
                    });
                    if (callback) callback({reponse: 'error'});
                    return;
                }

                // resynchronise l'état pour ne pas resauvegarder au prochain Suivant
                $etape.find('#manual_value_comparaison, #manual_remarque_comparaison').each(function () {
                    $(this).attr('data-valeur-initiale', $(this).val());
                    $(this).removeAttr('modifie');
                });
                $('#btn-wizard-save').prop('disabled', true);

                // rafraîchit la date de dernière modification sans recharger l'étape
                if (reponse.derniere_modification) {
                    var $cellule = $etape.find('#derniere-modification-comparaison');
                    if (!$cellule.length) {
                        // repli : on repère la ligne par son libellé si l'id est absent
                        $cellule = $etape.find('td').filter(function () {
                            return $.trim($(this).text()) === 'Dernière modification';
                        }).next('td');
                    }
                    $cellule.text(reponse.derniere_modification);
                }
                $etape.find('.erreur-valeur-manuelle').remove();

                if (callback) callback({reponse: 'ok'});
            });

            jqxhr.fail(function () {
                if (callback) callback({reponse: 'error'});
            });
        }

        function comparaisonChampsManuels() {
            return $('.step-pane.active')
                .find('#manual_value_comparaison, #manual_remarque_comparaison');
        }

        function comparaisonValeursManuellesModifiees() {
            return comparaisonChampsManuels().filter('[modifie="True"]').length > 0;
        }

        function comparaisonValiderValeursManuelles() {
            var valeur = $.trim($('#manual_value_comparaison').val());
            var remarque = $.trim($('#manual_remarque_comparaison').val());

            if (valeur && isNaN(parseInt(valeur.replace(/[\s,]/g, ''), 10))) {
                return "La valeur manuelle doit être un nombre entier.";
            }
            if (valeur && !remarque) {
                return "Une remarque est obligatoire lorsqu'une valeur manuelle est saisie.";
            }
            if (!valeur && remarque) {
                return "Une remarque ne peut pas être saisie sans valeur manuelle.";
            }
            if (remarque.length > 100) {
                return "La remarque ne peut pas dépasser 100 caractères.";
            }
            return null;
        }

        function saveComparaison(callback) {
            if ($('#mode-read-only').val() === 'True') {
                callback({reponse: 'ok'});
                return;
            }
            if (!comparaisonValeursManuellesModifiees()) {
                callback({reponse: 'ok'});
                return;
            }
            var erreur = comparaisonValiderValeursManuelles();
            if (erreur) {
                var $etape = $('.step-pane.active');
                var $champ = erreur.indexOf('remarque est obligatoire') !== -1
                    ? $etape.find('#manual_remarque_comparaison')
                    : $etape.find('#manual_value_comparaison');

                $etape.find('.erreur-valeur-manuelle').remove();
                $champ.closest('td')
                      .append('<div class="erreur-valeur-manuelle" style="color:red;font-size:12px;padding-top:4px;">'
                              + erreur + '</div>');
                focusControle('#' + $champ.attr('id'), 5);

                callback({reponse: 'error'});
                return;
            }
            sauvegarderValeurManuelleComparaison(callback);
        }

        function initCalculMassifEtape1() {
        }

        function saveCalculMassifEtape1(callback) {
            var currentForm = $('#modal-step-contents > .active .form-horizontal');
            var params = currentForm.serialize();
            var response = {};
            $.ajax({
                type: "POST",
                url: '/gestion-roles/calcul-massif-cout/',
                data: params,
                async: false, // Nécessaire pour s'assurer d'attendre le résultat de la sauvegarde/validation avant de passer à l'étape suivante
                dataType: 'json', // VIP sinon la sauvegarde passe par le HtmlFormRenderer et ca plante
                success: function (response) {
                    erreursAjax.effacerErreurChamps(currentForm);
                    if (typeof (callback) !== 'undefined') {
                        response.reponse = 'ok';
                        callback(response);
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (typeof (callback) !== 'undefined') {
                        response.reponse = 'error';
                        callback(response);
                    }
                    erreursAjax.traiterErreurs(currentForm, xhr, thrownError);
                    $('.tooltip').remove();
                }
            });
        }

        function getParamsFromUrl(params) {
            params = decodeURI(params);
            if (typeof params === 'string') {
                var eachParamsArr = params.split('&');
                var obj = {};
                if (eachParamsArr && eachParamsArr.length) {
                    eachParamsArr.map(param => {
                        var keyValuePair = param.split('=');
                        var key = keyValuePair[0];
                        var value = keyValuePair[1];
                        obj[key] = value;
                    });
                }
                return obj;
            }
        }

        function initCalculMassifEtape2() {
            setTimeout(function () {
                var formEtape1 = $('#modal-step-contents > #modal-step1 .form-horizontal');
                var params = formEtape1.serialize();
                wait.start('contenu');
                $.ajax({
                    type: "POST",
                    url: '/gestion-roles/calcul-massif/etape2/',
                    data: params,
                    dataType: 'json',
                    success: function (response) {
                        var etape = $('#modal-step-contents > .active');
                        etape.html(response['html']);
                        etape.attr('recharger', 'oui');
                        if (response['nb_ue_a_calculer'] == 0) {
                            $('#btn-wizard-suivant-terminer').prop('disabled', true);
                        }
                        wait.stop('contenu');
                    }
                });
                // Callback lorsqu'on clic sur le bouton terminer
                $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                    var url = '';
                    if (getParamsFromUrl(params).id_type_evenement === '41')
                        url = '/gestion-roles/calcul-massif/calcul-cout-role/';
                    else if (getParamsFromUrl(params).id_type_evenement === '42')
                        url = '/gestion-roles/calcul-massif/calcul-terrain-role/';
                    else if (getParamsFromUrl(params).id_type_evenement === '43')
                        url = '/gestion-roles/calcul-massif/calcul-valeur-retenue-role/';
                    else if (getParamsFromUrl(params).id_type_evenement === '44')
                        url = '/gestion-roles/calcul-massif/calcul-repartition-fiscale-role/';
                    else if (getParamsFromUrl(params).id_type_evenement === '45')
                        url = '/gestion-roles/calcul-massif/calcul-comparaison-role/';
                    else if (getParamsFromUrl(params).id_type_evenement === '46')
                        url = '/gestion-roles/calcul-massif/calcul-equilibration-facteur/';
                    else if (getParamsFromUrl(params).id_type_evenement === '47')
                        url = '/gestion-roles/calcul-massif/calcul-cout-vente/';
                    else if (getParamsFromUrl(params).id_type_evenement === '48')
                        url = '/gestion-roles/calcul-massif/calcul-revenu/';
                    wait.start();
                    setTimeout(function () {
                        var jqxhr = $.ajax({
                            url: url,
                            async: false,
                            type: "POST",
                            dataType: 'html',
                            data: params
                        });
                        jqxhr
                            .done(function (response) {
                                if (response == 'ok') {
                                    fenetreModal.fermerModal('modal-wizard-evenement');
                                    infos.ajouterMessageToast({
                                        message: 'Un courriel vous sera envoyé lorsque le calcul sera complété.',
                                        messageDuree: 3000
                                    });
                                    wait.stop();
                                } else {
                                    infos.ajouterMessageToast({
                                        message: "Erreur d'exécution de la commande de calcul massif\r\n" + response,
                                        messageDuree: 5000,
                                        messageCouleur: 'red'
                                    });
                                    wait.stop();
                                }
                            });
                        jqxhr
                            .fail(function (xhr, textStatus, errorThrown) {
                                infos.ajouterMessageToast({
                                    message: "Erreur d'exécution de la commande de calcul massif",
                                    messageCouleur: 'red'
                                });
                                wait.stop();
                            });
                    }, 10);
                });
            }, 10);
        }

        function initValeurMethodeRevenu() {
            var etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');

            initWizardBlocs();

            var b92BlocForm = $('#b92-valeur-methode-revenu.blocForm');
            var valeurImmeuble = b92BlocForm.find('[name="valeur_immeuble"]');
            var remarqueValeurImmeuble = b92BlocForm.find('[name="remarque"]');
            valeurImmeuble.on('change', function () {
                if (!$(this).val()) {
                    remarqueValeurImmeuble.val('');
                }
                remarqueValeurImmeuble.prop('disabled', !$(this).val());
            });

            var type_vue = $("#contenu-principale-methode-revenu").attr('data-type-vue');
            if(type_vue == 'complete' || type_vue == 'simplifiee') {
                var id_evenement = $('#wizard').attr('id-evenement');
                var url_btn_print = '/methode_revenu/generer-pdf-sommaire/' + id_evenement + '/' + type_vue;
                var bouton_impression = '<a class="btn btn-sm pull-left" title="Imprimer" href="' + url_btn_print + '" target="_blank"><i class="ace-icon fa fa-print"></i>Imprimer</a>';

                $('#btn-supp').html(bouton_impression);
            }

            remarqueValeurImmeuble.prop('disabled', !valeurImmeuble.val());
        }

        function saveValeurMethodeRevenu(callback) {
            var valeurs_modifiees = [];
            $.each($('.step-pane.active').find('.form-methode-revenu'), function (idx, row) {
                if ($(row).find('.' + CLASSE_VALEUR_MODIFIEE).length === 0) return true;
                valeurs_modifiees.push(idx);
            });
            if(valeurs_modifiees.length>0){
                save_methode_revenu(callback);
            }else{
                callback({'reponse':'ok'});
            }
        }

        function initLocalAnnexe() {
            var etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');

            initWizardBlocs();

            var checkboxAnnexe = $('#table-certificat-annexe input[type="checkbox"].redressement-donnees');

            if (checkboxAnnexe.length > 0 && checkboxAnnexe.is(':checked')) {
                // Si la checkbox est cochée lors de l'init, activer le bouton save et marquer comme modifié
                $('#btn-wizard-save').prop('disabled', false);
                $('#table-certificat-annexe').attr('modifie', 'True');
            }
        }

        function saveLocalAnnexe(callback) {
            var nbErreurs = 0;
            var pageCourante = $('.step-pane.active');
            var etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');
            pageCourante.attr('recharger', 'oui');
            var batimentBlocForm = $('#motif-x-certificat-annexe-role-x-evenement');
            var dateEvenement = $('#wizard').attr('date-evenement');
            var localBlocForm = $('#motif-x-certificat-annexe-role-x-evenement');
                localBlocForm.removeClass('blocForm').addClass('blocForm');
            var doitSauvegarder = true;
                if ($('#accordion-div-dest').length == 0) {
                         doitSauvegarder = false;
                }

            if (!doitSauvegarder) {
                if (typeof (callback) !== 'undefined') {
                    var response = {};
                    response.reponse = 'ok';
                    callback(response);
                }
                return;
            }
            var callbackSaveWizardBlocs = function (response) {

                localBlocForm.removeClass('blocForm').addClass('blocForm');
                if (response.reponse == 'ok') {
                    saveCertificatAnnexe();
                }
                callback(response);
            };

            var options = {paramsSupp: {sauvegarde_complet: true}};
            saveWizardBlocs(callbackSaveWizardBlocs, options);
        }

        function saveCertificatAnnexe() {
            $('#btn-wizard-save').prop('disabled', true);
            var list_certificat = tableToJson('table-certificat-annexe');
            var params = {
                'list_certificat': list_certificat,
            };
            var idUe = $('#wizard').attr('id-ue');
            $.ajax({
                type: "POST",
                url: '/gestion-roles/save-certificat-annexe/' + idUe + '/',
                dataType: 'json',
                data: params,
                success: function (response) {
                    $('#btn-wizard-recharger').trigger('click');
                },
                error: function (xhr, ajaxOptions, thrownError) {

                }
            });
        }

        function initAttributionLot() {
            var etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');

            var pageCourante = $('.step-pane.active');

            pageCourante.find('[name="lot_id_ue_destination"]').select2({
                dropdownAutoWidth: 'true',
                allowClear: true,
                placeholder: '',
            });

            //initWizardBlocs();
        }

        function saveAttributionLot(callback) {
            var pageCourante = $('.step-pane.active');
            var etape = $('#modal-step-contents > .active');
            etape.attr('recharger', 'oui');
            pageCourante.attr('recharger', 'oui');

            var dataSave = {};

            pageCourante.find('[name=table-operation-cadastrale] tbody tr').each(function () {
                var ligne = $(this);
                var lot = ligne.attr('lot');
                var ues = ligne.find('[name="lot_id_ue_destination"]').select2('val');
                var superficie = ligne.find('[name=superficie]').val();
                var bool_possede_geometrie = (ligne.find('[name=bool_possede_geometrie]:checked').length ? 1 : 0);

                dataSave[lot] = {ues: ues, superficie: superficie, bool_possede_geometrie: bool_possede_geometrie};
            });

            erreursAjax.effacerErreurChamps(pageCourante);

            var params = {
                'data_save': JSON.stringify(dataSave),
                'id_evenement': $('#wizard').attr('id-evenement')
            };

            $.ajax({
                type: "POST",
                url: '/gestion-roles/tenue-a-jour/operation-cadastrale/save-attribution-lot/',
                dataType: 'json',
                data: params,
                success: function (response) {
                    var reponse = {};

                    if (response.erreurs.length) {
                        reponse.reponse = 'error';

                        $.each(response.erreurs, function (index, erreur) {
                            var form;
                            if (erreur.lot) {
                                form = pageCourante.find('[name=table-operation-cadastrale] tr[lot="' + erreur.lot + '"]');
                            } else {
                                form = pageCourante;
                            }

                            erreursAjax.afficherErreurChamps(form, erreur.champ, erreur.erreur, '');
                        });
                    } else {
                        reponse.reponse = 'ok';

                    }

                    callback(reponse);
                },
                error: function (xhr, ajaxOptions, thrownError) {

                }
            });
        }

        function initCreationEvenementOperationCadastrale() {

            // Callback lorsqu'on clic sur le bouton terminer
            $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
                var params = {
                    'id_evenement': $('#wizard').attr('id-evenement')
                };
                // var idUe = $('#wizard').attr('id-ue');
                $.ajax({
                    type: "POST",
                    url: '/gestion-roles/tenue-a-jour/operation-cadastrale/save-creation-evenement/',
                    dataType: 'json',
                    data: params,
                    success: function (response) {
                        var callback = function (reponse) {
                        };
                        checkTraiterProchainEvenementLie(response.evenement_lie, callback);
                    },
                    error: function (xhr, ajaxOptions, thrownError) {

                    }
                });

            });

        }

        function saveCreationEvenementOperationCadastrale(callback) {

        }
        function modalAssignerEtatPreparerDonnees(modal){
            // préparer données pour post en mode multi pour les conserver/remplacer
            $.each(['user', 'routeInspection', 'statutEvenement'], function(e, nom_champ){
                let champ_source =  $(modal).find('#form-'+nom_champ);
                if(champ_source.select2('data')){
                    if(champ_source.select2('data').id == 'conserver'){
                        // on selectionne la radio conserver et enlève la valeur "conserver" du champ
                        champ_source.val('');
                        $(modal).find('[name="choix_'+nom_champ+'"]')[0].click();
                    }
                }
            });
        }


// public API : On ne met ici que les fonctions qui doivent être appelées de l'extérieur. Pas de fonctions privées ici.
        return {

            filtresDependantsDeclencher: filtresDependantsDeclencher,
            reqModalEvenementCreer: reqModalEvenementCreer,
            nettoyerParams: nettoyerParams,
            ouvrirModalCreationEvenement: ouvrirModalCreationEvenement,
            ouvrirWizardNouvelEvenement: ouvrirWizardNouvelEvenement,
            ouvrirWizardEvenement: ouvrirWizardEvenement,
            ouvrirModalCreationActualisationInventaire: ouvrirModalCreationActualisationInventaire,
            voirHistoriqueEvenement: voirHistoriqueEvenement,
            voirCertificat: voirCertificat,
            voirCertificatAnnexe: voirCertificatAnnexe,

            PostTraitementOuvrirWizardEvenement: PostTraitementOuvrirWizardEvenement,
            checkDateDeJour:checkDateDeJour,
            sauvegarderDonnees:sauvegarderDonnees,
            sauvegarderFormulairesCoteServeur: sauvegarderFormulairesCoteServeur,
            traitementPostSauvegarde:traitementPostSauvegarde,
            initInfoGeneraleCommun:initInfoGeneraleCommun,
            saveInfoGeneraleCommun2:saveInfoGeneraleCommun2,

            ouvrirChangementUeEnLot: ouvrirChangementUeEnLot,
            modalAssignerEtEtat: modalAssignerEtEtat,
            modalDateInspectionLoaded: modalDateInspectionLoaded,
            modalAssignerEtEtatLoaded: modalAssignerEtEtatLoaded,
            modalAssignerEtatPreparerDonnees: modalAssignerEtatPreparerDonnees,
            modalSupprimerEvenementLoaded: modalSupprimerEvenementLoaded,
            executerRecherchePermis: executerRecherchePermis,
            conserverSelection: conserverSelection,
            restaurerSelection: restaurerSelection,
            rechercherActiverSelection: rechercherActiverSelection,
            initInfoGeneralePermis: initInfoGeneralePermis,
            saveInfoGeneralePermis: saveInfoGeneralePermis,
            initLocalisationTravauxPermis: initLocalisationTravauxPermis,
            saveLocalisationTravauxPermis: saveLocalisationTravauxPermis,
            saveLocalisationTravauxPermisBefore: saveLocalisationTravauxPermisBefore,
            validateLocalisationTravauxPermis: validateLocalisationTravauxPermis,
            initNatureDescriptionTravaux: initNatureDescriptionTravaux,
            saveNatureDescriptionTravaux: saveNatureDescriptionTravaux,
            savePlanificationInspectionPermisConfirmation: savePlanificationInspectionPermisConfirmation,
            initPlanificationInspectionPermis: initPlanificationInspectionPermis,
            savePlanificationInspectionPermis: savePlanificationInspectionPermis,
            initRapportInspection: initRapportInspection,
            initEclaterVoiePublique: initEclaterVoiePublique,
            saveInfoGeneraleCorrectionMineureBefore: saveInfoGeneraleCorrectionMineureBefore,
            saveRapportInspection: saveRapportInspection,
            copierDateFinReelleTravauxDansPriseEffetRolePermis: copierDateFinReelleTravauxDansPriseEffetRolePermis,

            executerRechercheMutation: executerRechercheMutation,
            initInfoGeneraleMutation: initInfoGeneraleMutation,
            saveInfoGeneraleMutation: saveInfoGeneraleMutation,
            initLocalisationUeMutation: initLocalisationUeMutation,
            saveLocalisationUeMutation: saveLocalisationUeMutation,
            initIdentificationPartieMutation: initIdentificationPartieMutation,
            saveIdentificationPartieMutation: saveIdentificationPartieMutation,
            initScenarioMutation: initScenarioMutation,
            saveScenarioMutation: saveScenarioMutation,
            initTraitementMutation: initTraitementMutation,
            saveTraitementMutation: saveTraitementMutation,
            initAdminMutation: initAdminMutation,
            saveAdminMutation: saveAdminMutation,
            initResultatAnalyseVenteMutation: initResultatAnalyseVenteMutation,
            saveResultatAnalyseVenteMutation: saveResultatAnalyseVenteMutation,

            initCalculMethodeCout: initCalculMethodeCout,
            saveCalculMethodeCout: saveCalculMethodeCout,

            initValeurRetenue: initValeurRetenue,
            saveValeurRetenue: saveValeurRetenue,

            initCertificat: initCertificat,
            saveCertificat: saveCertificat,

            // type evenement = chargement de permis en lot

            initImporterDocumentsPermis: initImporterDocumentsPermis,
            importerDocumentsPermis: importerDocumentsPermis,

            initChargerDocumentPermis: initChargerDocumentPermis,
            saveChargerDocumentPermis: saveChargerDocumentPermis,

            initBilanDonneesEvenement: initBilanDonneesEvenement,
            bilanDonneesEvenement: bilanDonneesEvenement,

            initValiderImporterDonneesEvenement: initValiderImporterDonneesEvenement,
            validerImporterDonneesEvenement: validerImporterDonneesEvenement,

            initImporterDonneesPermisApi: initImporterDonneesPermisApi,
            saveImporterDonneesPermisApi: saveImporterDonneesPermisApi,
            saveConfirmImportDonneesPermisApi: saveConfirmImportDonneesPermisApi,

            initImporterDonneesEvenement: initImporterDonneesEvenement,
            importerDonneesEvenement: importerDonneesEvenement,

            initInfoGeneraleOperationCadastrale: initInfoGeneraleOperationCadastrale,
            saveInfoGeneraleOperationCadastrale: saveInfoGeneraleOperationCadastrale,

            initLocalisationUeOperationCadastrale: initLocalisationUeOperationCadastrale,
            saveLocalisationUeOperationCadastrale: saveLocalisationUeOperationCadastrale,

            initInfoGeneraleOperationUe: initInfoGeneraleOperationUe,
            saveInfoGeneraleOperationUe: saveInfoGeneraleOperationUe,

            initLocalisationUeOperationUe: initLocalisationUeOperationUe,
            saveLocalisationUeOperationUe: saveLocalisationUeOperationUe,

            //Opération ue (type evenement 2,5,32)

            initOperationUeOperationUe: initOperationUeOperationUe,
            saveOperationUeOperationUe: saveOperationUeOperationUe,


            initOperationUeTraitement: initOperationUeTraitement,
            saveOperationUeTraitement: saveOperationUeTraitement,

            initRenovationCadastrale: initRenovationCadastrale,
            saveRenovationCadastrale: saveRenovationCadastrale,


            chargerEtapeDynamique: chargerEtapeDynamique,
            initActualisationInventaireEtape1: initActualisationInventaireEtape1,
            saveActualisationInventaireEtape1: saveActualisationInventaireEtape1,
            initActualisationInventaireEtape2: initActualisationInventaireEtape2,

            initEnqueteRevenuLotEtape1: initEnqueteRevenuLotEtape1,
            saveEnqueteRevenuLotEtape1: saveEnqueteRevenuLotEtape1,
            initEnqueteRevenuLotEtape2: initEnqueteRevenuLotEtape2,

            initFermetureEvenement: initFermetureEvenement,
            //saveFermetureEvenement: saveFermetureEvenement,

            traiterErreursWizard: traiterErreursWizard,
            wizardSauvegarderSousBloc: wizardSauvegarderSousBloc,

            initInfoGeneraleCorrectionMineure: initInfoGeneraleCorrectionMineure,
            saveInfoGeneraleCorrectionMineure: saveInfoGeneraleCorrectionMineure,
            initTraitementCorrectionMineure: initTraitementCorrectionMineure,
            saveTraitementCorrectionMineure: saveTraitementCorrectionMineure,

            initPropagation: initPropagation,
            savePropagation: savePropagation,

            initInfoGeneraleAnnulationUe: initInfoGeneraleAnnulationUe,
            saveInfoGeneraleAnnulationUe: saveInfoGeneraleAnnulationUe,

            initInfoGeneraleChangementTerrain: initInfoGeneraleChangementTerrain,
            saveInfoGeneraleChangementTerrain: saveInfoGeneraleChangementTerrain,

            initInfoGeneraleActualisationInventaire: initInfoGeneraleActualisationInventaire,
            saveInfoGeneraleActualisationInventaire: saveInfoGeneraleActualisationInventaire,

            initInfoGeneraleEnqueteRevenu: initInfoGeneraleEnqueteRevenu,
            saveInfoGeneraleEnqueteRevenu: saveInfoGeneraleEnqueteRevenu,

            initInfoGeneraleEnqueteVente: initInfoGeneraleEnqueteVente, //# 5874
            saveInfoGeneraleEnqueteVente: saveInfoGeneraleEnqueteVente, //# 5874

            initInfoGeneraleRevisionRecours: initInfoGeneraleRevisionRecours,
            saveInfoGeneraleRevisionRecours: saveInfoGeneraleRevisionRecours,

            initSelectDependant: initSelectDependant,

            // Fermeture de cycle

            initValiderXml: initValiderXml,
            saveValiderXml: saveValiderXml,
            initProduireExtrants: initProduireExtrants,
            saveProduireExtrants: saveProduireExtrants,
            initEcrireCourriel: initEcrireCourriel,
            saveEcrireCourriel: saveEcrireCourriel,
            initSignerDocuments: initSignerDocuments,
            //pas necessaire suite au fix changement etape
            //saveSignerDocuments: saveSignerDocuments,

            // Depot du role

            initValiderRole: initValiderRole,
            saveValiderRole: saveValiderRole,

            // Proportion médiane
            initMedianeListeBase: initMedianeListeBase,
            saveMedianeListeBase: saveMedianeListeBase,
            initMedianeEpurationStatistique: initMedianeEpurationStatistique,
            saveMedianeEpurationStatistique: saveMedianeEpurationStatistique,
            initMedianeResultat: initMedianeResultat,
            saveMedianeResultat: saveMedianeResultat,
            initMedianePonderation: initMedianePonderation,
            saveMedianePonderation: saveMedianePonderation,
            initMedianeProduireExtrants: initMedianeProduireExtrants,
            saveMedianeProduireExtrants: saveMedianeProduireExtrants,
            initMedianeApprobation: initMedianeApprobation,
            saveMedianeApprobation: saveMedianeApprobation,

            initExamenRoleDonneesGeneralesEquilibration: initExamenRoleDonneesGeneralesEquilibration,
            saveExamenRoleDonneesGeneralesEquilibration: saveExamenRoleDonneesGeneralesEquilibration,
            initExamenRoleStatistiqueAutre: initExamenRoleStatistiqueAutre,
            saveExamenRoleStatistiqueAutre: saveExamenRoleStatistiqueAutre,

            initTvmListeBase: initTvmListeBase,
            saveTvmListeBase: saveTvmListeBase,

            initComparaison: initComparaison,
            saveComparaison: saveComparaison,

            initCalculMassifEtape1: initCalculMassifEtape1,
            saveCalculMassifEtape1: saveCalculMassifEtape1,
            initCalculMassifEtape2: initCalculMassifEtape2,
            //pl48
            initInfoGeneraleChangementLegislatif: initInfoGeneraleChangementLegislatif,
            saveInfoGeneraleChangementLegislatif: saveInfoGeneraleChangementLegislatif,

            ajusterHauteurTdComparees: ajusterHauteurTdComparees,
            saveEvenementParLocalisation: saveEvenementParLocalisation,

            initValeurMethodeRevenu: initValeurMethodeRevenu,
            saveValeurMethodeRevenu: saveValeurMethodeRevenu,

            initLocalAnnexe: initLocalAnnexe,
            saveLocalAnnexe: saveLocalAnnexe,

            initAttributionLot: initAttributionLot,
            saveAttributionLot: saveAttributionLot,
            initCreationEvenementOperationCadastrale: initCreationEvenementOperationCadastrale,
            saveCreationEvenementOperationCadastrale: saveCreationEvenementOperationCadastrale,

            //question omise/inscrite
            afficherQuestionOmiseInscrite: afficherQuestionOmiseInscrite,
            initQuestionOmiseInscrite: initQuestionOmiseInscrite

        };
    }
)
(); // namespace tenueAJourModal


function estPropagationInutile(idEvenement, dateEvenement) {
    var retour = false;

    var propagationEnfantsJson = $('[name=propagation-enfants]').val();
    var propagationEnfants = JSON.parse(propagationEnfantsJson);

    if (propagationEnfants[idEvenement]) {
        $.each(propagationEnfants[idEvenement], function (idx, valeur) {
            var dateEvenementFerme = valeur;
            if (dateEvenement > dateEvenementFerme) {
                retour = true;
            }
        });
    }

    return retour;
}

function estEvenementOuvertPosterieur(idEvenement, dateEvenement) {
    var retour = false;

    var evenementsOuvertsJson = $('[name=evenements-ouverts]').val();
    var evenementsOuverts = JSON.parse(evenementsOuvertsJson);

    if (evenementsOuverts[idEvenement]) {
        $.each(evenementsOuverts[idEvenement], function (idx, valeur) {
            var dateEvenementOuvert = valeur;
            if (dateEvenement < dateEvenementOuvert) {
                retour = true;
            }
        });
    }

    return retour;
}

function updateDateEvenementWizard(forcerChangement) {
    if (forcerChangement === undefined) forcerChangement = false;
    if ($('#wizard').attr('id-evenement') == '' || forcerChangement) {
        var dateEvenementDatePicker = $('#frm-date-evenement').find('input[name="date_evenement"]');
        var dateEvenementWizard = dateEvenementDatePicker.val();
        if (dateEvenementWizard.length == 10) { // Temporaire : utilisé pour mettre l'heure, les minutes et les secondes dans l'entête du wizard.
            dateEvenementWizard += ' 15:00:00';
            $('#wizard').attr('date-evenement', dateEvenementWizard);
        }
        if (dateEvenementWizard != '' && !moment(dateEvenementWizard).isValid()) {
            fenetreModal.modalMessage({
                titre: "Il y a une erreur avec la date choisie. SVP resélectionnez la date de l'évènement",
                sansX: true,
                texteExplicatif: "",
                boutons: [
                    {
                        label: " Fermer ",
                        title: "Fermer",
                        id: "",
                        class: "btn",
                        action: function () {
                            fenetreModal.fermerModalAlerteDivs();
                        }
                    }
                ]
            });
        }

        // 9733
        // Pour un changement de date. on doit rediriger l'usager vers l'événement d'origine
        changementDateEvenementOrigine();
    }
}


function updateRemarqueWizard(forcerChangement) {
    if (forcerChangement === undefined) forcerChangement = false;
    var evenementRemarque = $('.step-pane.active').find('[name="remarque"]').val();
    $('#wizard').attr('evenement-remarque', evenementRemarque);
}


function setInfosAttestation(nouvelleLigne) {
    // mettre les infos d'attestation dans les champs appropriés de la nouvelle ligne d'attestation à ajouter
    var containerInfosAttestation = $('#contenu-attestation-infos');
    containerInfosAttestation.find(':input').not('button').each(function () {
        var nomChamp = $(this).attr('name');
        var valeur = containerInfosAttestation.find('[name="' + nomChamp + '"]').val();
        nouvelleLigne.find('[name="' + nomChamp + '"]').val(valeur);
    });

    nouvelleLigne.find('[name="date_attestation"]').daterangepicker({
        parentEl: '.modal'
    });
    init_date_picker(nouvelleLigne);

    // marquer les changements de chaque contrôle
    nouvelleLigne.find(':input').each(function () {
        appliquerChangement($(this));
    });
    nouvelleLigne.attr('modifie', 'True');
}

function validerInfosAttestation() {
    var containerInfosAttestation = $('#contenu-attestation-infos');

    erreursAjax.effacerErreurChamps(containerInfosAttestation);

    var viewset = 'B79AttestationInspectionInfosViewSet';
    var headers = {};
    var params = containerInfosAttestation.find(':input').not('[id^="s2id"], button').serializeArray();
    var dateEvenement = $('#wizard').attr('date-evenement');
    var idUe = $('#wizard').attr('id-ue');
    params.push({"name": 'date_debut', "value": dateEvenement});
    var valide = false;
    $.ajax({
        headers: headers,
        type: 'POST',
        url: '/gestion-roles/tenue-a-jour/permis/rapport-inspection/valider-infos-attestation/' + '?viewset=' + viewset + '&date_evenement=' + encodeURI(dateEvenement) + '&id_ue=' + idUe,
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            valide = response.est_valide;
            if (!valide) {
                $.each(response.erreurs, function (champ, valeur) {
                    erreursAjax.afficherErreurChamps(containerInfosAttestation, champ, valeur, '');
                    $('.form.alert').fadeIn();
                });
            }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            erreursAjax.traiterErreurs(containerInfosAttestation, xhr, thrownError);
        }
    });

    return valide;
}



//9733. GG: Faudrait savoir c'est dans quel contexte...
function changementDateEvenementOrigine() {

    var idEvenement = $('#wizard').attr('id-evenement');
    if(!idEvenement){
        return;
    }
    var params = {
        'idEvenement': idEvenement
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/changement-date-evenement-origine/",
        async: false,
        data: params,
        dataType: 'json',
        success: function (response) {

            if (response.id_evenement != null) {

                fenetreModal.modalMessage({
                    titre: "Vous devez changer la date de l'événement sur l'événement d'origine, voulez-vous poursuivre ?",
                    sansX: true,
                    texteExplicatif: "",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {

                                if (response.id_evenement) {
                                    tenueAJourModal.ouvrirWizardEvenement(response.id_evenement, params);
                                }

                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                            }
                        }
                    }
                });
            }
        }
    });

}

function init_repartitions() {
    var containerB98RepartitionFiscaleApres = $('.apres-container [id="b98-repartition-fiscale"]');
    var valeurTerrain = containerB98RepartitionFiscaleApres.find('[name="b94_valeur_terrain"]').autoNumeric('get');
    var valeurBatiment = containerB98RepartitionFiscaleApres.find('[name="b94_valeur_batiment"]').autoNumeric('get');
    var params = {
        id_ue: $('#wizard').attr('id-ue'),
        date_evenement: $('#wizard').attr('date-evenement'),
        valeur_batiment: valeurBatiment,
        valeur_terrain: valeurTerrain
    };
    var jq = $.ajax({
        type: "POST",
        url: "/gestion-roles/tenue-a-jour/valeur-retenue/generer-repartition-fiscale/",
        data: params,
        dataType: 'json',
        async: false,
    });

    jq.done(function (reponse) {
        if (reponse.reponse == 'ok') {
            infos.ajouterMessageToast({
                message: "La liste des répartitions fiscales a été générée. Rechargement de la page en cours...",
                messageDuree: 3000
            });
            //hack pour sauvegarder et recharger les répartitions fiscales directement
            //$('#btn-wizard-save').trigger("click");
            $('#btn-wizard-recharger').trigger("click");
        } else {
            infos.ajouterMessageToast({
                message: "Erreur lors de la génération des répartitions fiscales. svp contacter un administrateur",
                messageDuree: 5000,
                messageCouleur: "red"
            });
        }
    });

    jq
        .fail(function (xhr, ajaxOptions, thrownError) {
            erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', reponse.message);
            messageToastCompteur = 0;
            infos.ajouterMessageToast({
                message: "Erreur lors de la génération des répartitions fiscales. svp contacter un administrateur",
                messageDuree: 5000,
                messageCouleur: "red"
            });
        });


}

function serialize_data(form, data) {
    $(form).serializeArray().map(function (item) {
        if($("input[name='" + item.name + "']").hasClasses(["currency-mask", "currency-mask-total"])) {
            data[item.name] = parseFloat(item.value.replace(/\s/g, '')).toFixed(2);
        } else if($("input[name='" + item.name + "']").hasClasses(["input-percentage-input", "decimal-input"])) {
            data[item.name] = parseFloat(item.value.replace(/\s/g, ''));
        } else {
            data[item.name] = item.value;
        }
    });
}


$(document).off('click', '#afficher_modal_facturation_inspection').on('click', '#afficher_modal_facturation_inspection', function () {
    $('.facturation-inspection-form-container').html('');
    $.ajax({
        type: "GET",
        url: $(this).data('url'),
        success: function (response) {
            $('.facturation-inspection-form-container').html(response);
            $('.facturation-inspection-form-container .select2').select2();
            $('[name*="-devisFacturationXRoleEvaluation"]').select2();

            $('#ajouter-nouvelle-ligne').off('click').on('click', function (ev) {
                var count = parseInt($('#id_devis-TOTAL_FORMS').val());
                var tmplMarkup = $('#empty-form');
                var compiledTmpl = $(tmplMarkup).html().replace(/__prefix__/g, count);
                var tablebody = $('#modal_facturation_inspection').find('.row-parent');
                compiledTmpl = $(compiledTmpl).removeClass('empty-form');
                compiledTmpl = $(compiledTmpl).attr('id-model-instance', 'None');
                compiledTmpl = $(compiledTmpl).attr('id', 'regresssionsimple-');
                tablebody.append(compiledTmpl);
                $('#id_devis-TOTAL_FORMS').attr('value', count + 1);
                $('#id_devis-' + count + '-devisFacturationXRoleEvaluation').select2();
            });

            var modalTrsupr = $('#modal_facturation_inspection').find(".for-ctrl-suppression");
            modalTrsupr.find('input[type="checkbox"]').off('change').on('change', function () {
                var ctrlIcone = $(this).parent().parent().find('i');
                if ($(this).is(':checked')) {
                    $(this).closest('.row-enfant').find('.row-devis').addClass('suppression-ligne');
                    $(this).closest('.row-enfant').find('.row-devis').prop('disabled', true);
                    ctrlIcone.removeClass('fa-square-o').addClass('fa-check-square-o');
                } else {
                    $(this).closest('.row-enfant').find('.row-devis').removeClass('suppression-ligne');
                    $(this).closest('.row-enfant').find('.row-devis').prop('disabled', false);
                    ctrlIcone.removeClass('fa-check-square-o').addClass('fa-square-o');
                }
            });

            $('#btn-save-facturation-inspection').off('click').on('click', function (e) {
                e.preventDefault();
                // Récupérez l'URL de l'attribut "action" du formulaire
                var actionUrl = $('#form_facturation_inspection').attr('action');
                // Récupérez les données du formulaire
                var formData = $('#form_facturation_inspection').serializeArray();
                // Effectuez la requête AJAX en utilisant l'URL récupérée
                $.ajax({
                    type: 'POST',
                    url: actionUrl, // Utilisez l'URL récupérée
                    data: formData,
                    success: function (response) {
                        if (response.msg !== undefined) {
                            // Affichez un message de succès
                            infos.ajouterMessageToast({
                                message: 'Sauvegarde réussie',
                                messageDuree: 500,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });
                            $('#modal_facturation_inspection').modal('hide');
                            var idCycle1 = $('[name=cycle_insp]').val();
                            if (idCycle1) {
                                var idRole = $('#current-role').val();
                                var url = $('[name=url_insp]').val();
                                $('#adm-body-facturation-inspection').empty();
                                admGetFacturationInspection(url, idCycle1, idRole);
                            }
                        } else {
                            if (response.errors) {
                                // Effacez d'abord les messages d'erreur précédents
                                $('#error-messages').html('');
                                $.each(response.errors, function (index, error) {
                                    if ('__all__' in error) {
                                        var messageHTML = '<span class="help-block" name="message-erreur">' + error['__all__'][0] + '</span><br>';
                                        $('#error-messages').append(messageHTML);
                                    }
                                });
                            }
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        $('.facturation-inspection-form-container').html(jqXHR.responseText);
                    }
                });
            });

            $('#modal_facturation_inspection').modal({
                show: true,
                backdrop: 'static'
            });
        }
    });
});


/**
  Fonction d'initialisation de l'étape 1 du processus d'enquête de revenu en lot.
 * */
function initEnqueteRevenuLotEtape1() {
    $('#enquete-revenu-lot-extraction-parametres').find('select').select2();
    var dateRole = document.querySelector("#id_date_prise_effet_role");
    var dateCalendrier = document.getElementById('id_date_prise_effet_calendrier');
    initCheckboxPredominantResidentielle();
    dateRole.addEventListener('change', function () {

        dateCalendrier.disabled = this.checked;
    });
    $(document.body).on("change","#id_municipalite",function(){
        if (JSON.parse(document.getElementById('id_roles_infos').value)[this.value]) {
            document.getElementById('id_date_role').innerText = " (".concat(JSON.parse(document.getElementById('id_roles_infos').value)[this.value], '-01-01)');
        }
        else {
            document.getElementById('id_date_role').innerText = " (Rôle non défini)";
            document.getElementById('id_date_prise_effet_role').disabled = true;
            document.getElementById('id_date_prise_effet_role').checked = false;
            document.getElementById('id_date_prise_effet_calendrier').disabled = false;
        }
    });
}

function initCheckboxPredominantResidentielle(){
     var checkbox = document.querySelector("#id_usage_predominant_residentielle");
     checkbox.addEventListener('change', function () {
        var nbrUniteMinimum = document.getElementById('id_nbr_unite_minimum');
        nbrUniteMinimum.disabled = !this.checked;
        if (nbrUniteMinimum.disabled) {
            nbrUniteMinimum.value = 0;
        }
        else {
            nbrUniteMinimum.value = document.getElementById('id_default_nbr_unite_residentiel').value;
        }
    });
}

/**
  Fonction de sauvegarde de l'étape 1 du processus d'enquête de revenu en lot.
 * */
function saveEnqueteRevenuLotEtape1(callback) {
    var currentForm = $('#modal-step-contents > .active .form-horizontal');
    var params = currentForm.serialize();
    var response = {};
    var idMunicipalite = currentForm.find('#id_municipalite').val();
    var idTypeEvenement = $('#wizard').attr('id-type-evenement');

    $.ajax({
        type: "POST",
        url: '/gestion-roles/tenue-a-jour/enquete-revenu-lot/etape1/',
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            erreursAjax.effacerErreurChamps(currentForm);
             if (idMunicipalite && idTypeEvenement) {
                 validerFermetureCycle(idMunicipalite, idTypeEvenement);
             }
            if (typeof (callback) !== 'undefined') {
                response.reponse = 'ok';
                callback(response);
            }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            if (typeof (callback) !== 'undefined') {
                response.reponse = 'error';
                callback(response);
            }
            $(currentForm).empty();
            $(currentForm).html(xhr.responseText);
            document.getElementsByClassName('text-danger')[0].remove();
            $('.tooltip').remove();
            initCheckboxPredominantResidentielle();
        }
    });
}


/**
 * Fonction d'initialisation de l'étape 2 du processus d'enquête de revenu en lot.
 * */
function initEnqueteRevenuLotEtape2() {
    setTimeout(function () {
        var formEtape1 = $('#modal-step-contents > #modal-step1 .form-horizontal');
        var params = formEtape1.serialize();
        var url_etape_2 = '/gestion-roles/tenue-a-jour/enquete-revenu-lot/etape2/';
        wait.start('contenu');
        call_ajax(url_etape_2, 'GET', params, callbackSuccesEnqueteRevenueEtape2);

        // Callback lorsqu'on clique sur le bouton terminer
        $('#modal-wizard-evenement').off('finished.fu.wizard').on('finished.fu.wizard', function (evt, data) {
            wait.start();
            setTimeout(function () {
                var jqxhr = $.ajax({
                    url: url_etape_2,
                    async: false,
                    type: "POST",
                    dataType: 'html',
                    data: params
                });
                jqxhr
                    .done(function (response) {
                        if (response === 'ok') {
                            fenetreModal.fermerModal('modal-wizard-evenement');
                            refreshDatatables();
                             infos.ajouterMessageToast({
                                message: 'Sauvegarde réussie',
                                messageDuree: 500,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });
                            wait.stop();
                        } else {
                            infos.ajouterMessageToast({
                                message: "Erreur d'exécution de la commande d'enquête de revenu en lot",
                                messageCouleur: 'red'
                            });
                            wait.stop();
                        }
                    });
                jqxhr
                    .fail(function (xhr, textStatus, errorThrown) {
                        infos.ajouterMessageToast({
                            message: "Erreur d'exécution de la commande d'enquête de revenu en lot",
                            messageCouleur: 'red'
                        });
                        wait.stop();
                    });
            }, 10);
        });
    }, 10);
}

function callbackSuccesEnqueteRevenueEtape2(response) {
    var etape = $('#modal-step-contents > .active');
    etape.html(response['html']);
    etape.attr('recharger', 'oui');
    if (response['nb_enquete_revenu_a_faire'] === 0) {
        $('#btn-wizard-suivant-terminer').prop('disabled', true);
    }
    wait.stop('contenu');
}
